export const mockData = [
  
    {
      "statusCode": 200,
      "responseMessage": "Course plan details fetched",
      "responseObject": {
          "coursePlan": {
              "_id": "606e351a4b60e26a187dc1b3",
              "packageId": "606e34354b60e26a187dc1b1",
              "type": "standard",
              "startDate": "2021-04-07T18:30:00.000Z",
              "endDate": "2021-06-16T18:30:00.000Z",
              "weekFormat": "mondayToSunday",
              "status": "draft",
              "totalTests": 0,
              "testSeries": [],
              "phases": [
                  {
                      "name": "Phase first term",
                      "startDate": "2021-04-11T00:00:00.000Z",
                      "endDate": "2021-04-29T00:00:00.000Z",
                      "_id": "606e351a4b60e26a187dc846",
                      "milestoneTests": [],
                      "weeks": [
                          {
                              "weekNo": 1,
                              "startDate": "2021-04-11T00:00:00.000Z",
                              "endDate": "2021-04-11T00:00:00.000Z",
                              "_id": "606e351a4b60e26a187dc847",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Binomial Theorem",
                                              "id": "5ace20319fe7b01d5806bc43",
                                              "_id": "606e351a4b60e26a187dcdc4",
                                              "concepts": [
                                                  {
                                                      "name": "Binomial Co-efficient of a specific type of term",
                                                      "id": "5ace20399fe7b01d5806bf41",
                                                      "_id": "606e351a4b60e26a187dcdcd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e2",
                                                              "_id": "606e351a4b60e26a187dcdce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial series with k.Binomial coefficient",
                                                      "id": "5ace20399fe7b01d5806bf42",
                                                      "_id": "606e351a4b60e26a187dcdcb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e3",
                                                              "_id": "606e351a4b60e26a187dcdcc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definition, coefficient of any term",
                                                      "id": "5ace20399fe7b01d5806bf43",
                                                      "_id": "606e351a4b60e26a187dcdc9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e4",
                                                              "_id": "606e351a4b60e26a187dcdca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest co-efficient, greatest term,",
                                                      "id": "5ace20399fe7b01d5806bf44",
                                                      "_id": "606e351a4b60e26a187dcdc7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e5",
                                                              "_id": "606e351a4b60e26a187dcdc8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of co-efficient and Relationship between the Co-efficient of the expansion like (a + bx + cx2)",
                                                      "id": "5ace20399fe7b01d5806bf45",
                                                      "_id": "606e351a4b60e26a187dcdc5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e6",
                                                              "_id": "606e351a4b60e26a187dcdc6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d939",
                                                      "_id": "606e351a4b60e26a187dcdcf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Number",
                                              "id": "5ace20319fe7b01d5806bc44",
                                              "_id": "606e351a4b60e26a187dcdae",
                                              "concepts": [
                                                  {
                                                      "name": "Argument, properties of argument",
                                                      "id": "5ace20399fe7b01d5806bf46",
                                                      "_id": "606e351a4b60e26a187dcdc1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e7",
                                                              "_id": "606e351a4b60e26a187dcdc2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concept of rotation",
                                                      "id": "5ace20399fe7b01d5806bf47",
                                                      "_id": "606e351a4b60e26a187dcdbf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e8",
                                                              "_id": "606e351a4b60e26a187dcdc0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conjugate, properties of conjugate",
                                                      "id": "5ace20399fe7b01d5806bf48",
                                                      "_id": "606e351a4b60e26a187dcdbd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e9",
                                                              "_id": "606e351a4b60e26a187dcdbe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definition based problems",
                                                      "id": "5ace20399fe7b01d5806bf49",
                                                      "_id": "606e351a4b60e26a187dcdbb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ea",
                                                              "_id": "606e351a4b60e26a187dcdbc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De-Moiver's theorem, cube roots of unity, nth root of unity",
                                                      "id": "5ace20399fe7b01d5806bf4a",
                                                      "_id": "606e351a4b60e26a187dcdb9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9eb",
                                                              "_id": "606e351a4b60e26a187dcdba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ellipse, Parabola, Hyperbola",
                                                      "id": "5ace20399fe7b01d5806bf4b",
                                                      "_id": "606e351a4b60e26a187dcdb7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ec",
                                                              "_id": "606e351a4b60e26a187dcdb8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus, properties of modulus",
                                                      "id": "5ace20399fe7b01d5806bf4c",
                                                      "_id": "606e351a4b60e26a187dcdb5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ed",
                                                              "_id": "606e351a4b60e26a187dcdb6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on geometrical application of complex number-Section Formula, Straight Line, Circle",
                                                      "id": "5ace20399fe7b01d5806bf4d",
                                                      "_id": "606e351a4b60e26a187dcdb3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ee",
                                                              "_id": "606e351a4b60e26a187dcdb4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on Locus",
                                                      "id": "5ace20399fe7b01d5806bf4e",
                                                      "_id": "606e351a4b60e26a187dcdb1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ef",
                                                              "_id": "606e351a4b60e26a187dcdb2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots of complex equations",
                                                      "id": "5ace20399fe7b01d5806bf4f",
                                                      "_id": "606e351a4b60e26a187dcdaf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f0",
                                                              "_id": "606e351a4b60e26a187dcdb0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93a",
                                                      "_id": "606e351a4b60e26a187dcdc3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Logarithm",
                                              "id": "5ace20319fe7b01d5806bc45",
                                              "_id": "606e351a4b60e26a187dcda8",
                                              "concepts": [
                                                  {
                                                      "name": "Definition and properties of log",
                                                      "id": "5ace20399fe7b01d5806bf50",
                                                      "_id": "606e351a4b60e26a187dcdab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f1",
                                                              "_id": "606e351a4b60e26a187dcdac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Log inequalities, graphs",
                                                      "id": "5ace20399fe7b01d5806bf51",
                                                      "_id": "606e351a4b60e26a187dcda9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f2",
                                                              "_id": "606e351a4b60e26a187dcdaa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93b",
                                                      "_id": "606e351a4b60e26a187dcdad"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Progression & Series",
                                              "id": "5ace20319fe7b01d5806bc46",
                                              "_id": "606e351a4b60e26a187dcd9a",
                                              "concepts": [
                                                  {
                                                      "name": "AP, and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf52",
                                                      "_id": "606e351a4b60e26a187dcda5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f3",
                                                              "_id": "606e351a4b60e26a187dcda6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GP and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf53",
                                                      "_id": "606e351a4b60e26a187dcda3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f4",
                                                              "_id": "606e351a4b60e26a187dcda4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "HP and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf54",
                                                      "_id": "606e351a4b60e26a187dcda1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f5",
                                                              "_id": "606e351a4b60e26a187dcda2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of differences, Vn Method",
                                                      "id": "5ace20399fe7b01d5806bf55",
                                                      "_id": "606e351a4b60e26a187dcd9f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f6",
                                                              "_id": "606e351a4b60e26a187dcda0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on sum of first n natural numbers, their squares and their cubes, Arithmetico Geometric Progression",
                                                      "id": "5ace20399fe7b01d5806bf56",
                                                      "_id": "606e351a4b60e26a187dcd9d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f7",
                                                              "_id": "606e351a4b60e26a187dcd9e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Inequalities of AM, GM, HM, weighted AM, weighted GM, weighted HM and AM of mth power",
                                                      "id": "5ace20399fe7b01d5806bf57",
                                                      "_id": "606e351a4b60e26a187dcd9b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f8",
                                                              "_id": "606e351a4b60e26a187dcd9c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93c",
                                                      "_id": "606e351a4b60e26a187dcda7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadratic Equation and Expression",
                                              "id": "5ace20319fe7b01d5806bc47",
                                              "_id": "606e351a4b60e26a187dcd8a",
                                              "concepts": [
                                                  {
                                                      "name": "Condition for a common root of two quadratic equation and condition for both the roots common of two quadratic equation",
                                                      "id": "5ace20399fe7b01d5806bf58",
                                                      "_id": "606e351a4b60e26a187dcd97",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f9",
                                                              "_id": "606e351a4b60e26a187dcd98"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation of Quadratic Equation, sign of Quadratic Expression",
                                                      "id": "5ace20399fe7b01d5806bf59",
                                                      "_id": "606e351a4b60e26a187dcd95",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fa",
                                                              "_id": "606e351a4b60e26a187dcd96"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formula for roots, discriminant",
                                                      "id": "5ace20399fe7b01d5806bf5a",
                                                      "_id": "606e351a4b60e26a187dcd93",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fb",
                                                              "_id": "606e351a4b60e26a187dcd94"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Location of roots",
                                                      "id": "5ace20399fe7b01d5806bf5b",
                                                      "_id": "606e351a4b60e26a187dcd91",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fc",
                                                              "_id": "606e351a4b60e26a187dcd92"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "n-th degree polynomial equation and its property",
                                                      "id": "5ace20399fe7b01d5806bf5c",
                                                      "_id": "606e351a4b60e26a187dcd8f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fd",
                                                              "_id": "606e351a4b60e26a187dcd90"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic expression",
                                                      "id": "5ace20399fe7b01d5806bf5d",
                                                      "_id": "606e351a4b60e26a187dcd8d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fe",
                                                              "_id": "606e351a4b60e26a187dcd8e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder theorem",
                                                      "id": "5ace20399fe7b01d5806bf5e",
                                                      "_id": "606e351a4b60e26a187dcd8b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ff",
                                                              "_id": "606e351a4b60e26a187dcd8c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93d",
                                                      "_id": "606e351a4b60e26a187dcd99"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Derivatives",
                                              "id": "5ace20319fe7b01d5806bc48",
                                              "_id": "606e351a4b60e26a187dcd88",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93e",
                                                      "_id": "606e351a4b60e26a187dcd89"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Derivatives",
                                              "id": "5ace20319fe7b01d5806bc49",
                                              "_id": "606e351a4b60e26a187dcd72",
                                              "concepts": [
                                                  {
                                                      "name": "angle between two curves",
                                                      "id": "5ace20399fe7b01d5806bf5f",
                                                      "_id": "606e351a4b60e26a187dcd85",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da00",
                                                              "_id": "606e351a4b60e26a187dcd86"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based",
                                                      "id": "5ace20399fe7b01d5806bf60",
                                                      "_id": "606e351a4b60e26a187dcd83",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da01",
                                                              "_id": "606e351a4b60e26a187dcd84"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based - using first derivative",
                                                      "id": "5ace20399fe7b01d5806bf61",
                                                      "_id": "606e351a4b60e26a187dcd81",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da02",
                                                              "_id": "606e351a4b60e26a187dcd82"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based - using second derivative",
                                                      "id": "5ace20399fe7b01d5806bf62",
                                                      "_id": "606e351a4b60e26a187dcd7f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da03",
                                                              "_id": "606e351a4b60e26a187dcd80"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on local/global maxima/minima using first, second and higher order derivative for a differentiable function and using graph for discontinuous function",
                                                      "id": "5ace20399fe7b01d5806bf63",
                                                      "_id": "606e351a4b60e26a187dcd7d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da04",
                                                              "_id": "606e351a4b60e26a187dcd7e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Mean Value theorem",
                                                      "id": "5ace20399fe7b01d5806bf64",
                                                      "_id": "606e351a4b60e26a187dcd7b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da05",
                                                              "_id": "606e351a4b60e26a187dcd7c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on monotonocity - interval of increase and decrease using first derivative and second derivative",
                                                      "id": "5ace20399fe7b01d5806bf65",
                                                      "_id": "606e351a4b60e26a187dcd79",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da06",
                                                              "_id": "606e351a4b60e26a187dcd7a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on monotonocity and maxima/minima for functional equation",
                                                      "id": "5ace20399fe7b01d5806bf66",
                                                      "_id": "606e351a4b60e26a187dcd77",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da07",
                                                              "_id": "606e351a4b60e26a187dcd78"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on normal",
                                                      "id": "5ace20399fe7b01d5806bf67",
                                                      "_id": "606e351a4b60e26a187dcd75",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da08",
                                                              "_id": "606e351a4b60e26a187dcd76"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Tangents",
                                                      "id": "5ace20399fe7b01d5806bf68",
                                                      "_id": "606e351a4b60e26a187dcd73",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da09",
                                                              "_id": "606e351a4b60e26a187dcd74"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93f",
                                                      "_id": "606e351a4b60e26a187dcd87"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Area Enclosed by Curves",
                                              "id": "5ace20319fe7b01d5806bc4a",
                                              "_id": "606e351a4b60e26a187dcd6c",
                                              "concepts": [
                                                  {
                                                      "name": "Area bounded by f(x) and x-axis, f(y) and y-axis",
                                                      "id": "5ace20399fe7b01d5806bf69",
                                                      "_id": "606e351a4b60e26a187dcd6f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0a",
                                                              "_id": "606e351a4b60e26a187dcd70"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area bounded by f(x), g(x), x=a and x=b, curve and its asymptotes",
                                                      "id": "5ace20399fe7b01d5806bf6a",
                                                      "_id": "606e351a4b60e26a187dcd6d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0b",
                                                              "_id": "606e351a4b60e26a187dcd6e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d940",
                                                      "_id": "606e351a4b60e26a187dcd71"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Continuity & Differentiabilty",
                                              "id": "5ace20319fe7b01d5806bc4b",
                                              "_id": "606e351a4b60e26a187dcd6a",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d941",
                                                      "_id": "606e351a4b60e26a187dcd6b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Continuity & Differentiabilty",
                                              "id": "5ace20319fe7b01d5806bc4c",
                                              "_id": "606e351a4b60e26a187dcd56",
                                              "concepts": [
                                                  {
                                                      "name": "Continuity of composite function, finding unknown parameters from continuity",
                                                      "id": "5ace20399fe7b01d5806bf6b",
                                                      "_id": "606e351a4b60e26a187dcd67",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0c",
                                                              "_id": "606e351a4b60e26a187dcd68"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability based on finding unknown parameters",
                                                      "id": "5ace20399fe7b01d5806bf6c",
                                                      "_id": "606e351a4b60e26a187dcd65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0d",
                                                              "_id": "606e351a4b60e26a187dcd66"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability based on first principle, Using continuity & differentiability to determine number of real roots of a function",
                                                      "id": "5ace20399fe7b01d5806bf6d",
                                                      "_id": "606e351a4b60e26a187dcd63",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0e",
                                                              "_id": "606e351a4b60e26a187dcd64"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intermediate Value Theorem",
                                                      "id": "5ace20399fe7b01d5806bf6e",
                                                      "_id": "606e351a4b60e26a187dcd61",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0f",
                                                              "_id": "606e351a4b60e26a187dcd62"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Investigating functions using functional equation",
                                                      "id": "5ace20399fe7b01d5806bf6f",
                                                      "_id": "606e351a4b60e26a187dcd5f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da10",
                                                              "_id": "606e351a4b60e26a187dcd60"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on continuity and differentiability using graph",
                                                      "id": "5ace20399fe7b01d5806bf70",
                                                      "_id": "606e351a4b60e26a187dcd5d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da11",
                                                              "_id": "606e351a4b60e26a187dcd5e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "To check continuity of a function",
                                                      "id": "5ace20399fe7b01d5806bf71",
                                                      "_id": "606e351a4b60e26a187dcd5b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da12",
                                                              "_id": "606e351a4b60e26a187dcd5c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "To check differentiability of a function, LHD & RHD of a function, existence of derivative Problems based on piece wise defined function",
                                                      "id": "5ace20399fe7b01d5806bf72",
                                                      "_id": "606e351a4b60e26a187dcd59",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da13",
                                                              "_id": "606e351a4b60e26a187dcd5a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Type of discontinuity, to find points of discontinuity, no of points of discontinuity",
                                                      "id": "5ace20399fe7b01d5806bf73",
                                                      "_id": "606e351a4b60e26a187dcd57",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da14",
                                                              "_id": "606e351a4b60e26a187dcd58"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d942",
                                                      "_id": "606e351a4b60e26a187dcd69"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Definite Integration",
                                              "id": "5ace20319fe7b01d5806bc4d",
                                              "_id": "606e351a4b60e26a187dcd44",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Solving definite integration using graphs, piece wise continuous functions",
                                                      "id": "5ace20399fe7b01d5806bf74",
                                                      "_id": "606e351a4b60e26a187dcd53",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da15",
                                                              "_id": "606e351a4b60e26a187dcd54"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Integral of inverse of a function",
                                                      "id": "5ace20399fe7b01d5806bf75",
                                                      "_id": "606e351a4b60e26a187dcd51",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da16",
                                                              "_id": "606e351a4b60e26a187dcd52"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Integral of periodic function",
                                                      "id": "5ace20399fe7b01d5806bf76",
                                                      "_id": "606e351a4b60e26a187dcd4f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da17",
                                                              "_id": "606e351a4b60e26a187dcd50"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit as a sum",
                                                      "id": "5ace20399fe7b01d5806bf77",
                                                      "_id": "606e351a4b60e26a187dcd4d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da18",
                                                              "_id": "606e351a4b60e26a187dcd4e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton-Leibnitz rule",
                                                      "id": "5ace20399fe7b01d5806bf78",
                                                      "_id": "606e351a4b60e26a187dcd4b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da19",
                                                              "_id": "606e351a4b60e26a187dcd4c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on reduction formula",
                                                      "id": "5ace20399fe7b01d5806bf79",
                                                      "_id": "606e351a4b60e26a187dcd49",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1a",
                                                              "_id": "606e351a4b60e26a187dcd4a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on partial derivatives",
                                                      "id": "5ace203a9fe7b01d5806bf7a",
                                                      "_id": "606e351a4b60e26a187dcd47",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1b",
                                                              "_id": "606e351a4b60e26a187dcd48"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on properties",
                                                      "id": "5ace203a9fe7b01d5806bf7b",
                                                      "_id": "606e351a4b60e26a187dcd45",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1c",
                                                              "_id": "606e351a4b60e26a187dcd46"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d943",
                                                      "_id": "606e351a4b60e26a187dcd55"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Equation",
                                              "id": "5ace20319fe7b01d5806bc4e",
                                              "_id": "606e351a4b60e26a187dcd42",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d944",
                                                      "_id": "606e351a4b60e26a187dcd43"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Equation",
                                              "id": "5ace20319fe7b01d5806bc4f",
                                              "_id": "606e351a4b60e26a187dcd2e",
                                              "concepts": [
                                                  {
                                                      "name": "Apllications of differential equation- orthogonal trajectories, tangent and normal, sub-tangent and sub-normal",
                                                      "id": "5ace203a9fe7b01d5806bf7c",
                                                      "_id": "606e351a4b60e26a187dcd3f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1d",
                                                              "_id": "606e351a4b60e26a187dcd40"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application of differential equation-rate of change problem",
                                                      "id": "5ace203a9fe7b01d5806bf7d",
                                                      "_id": "606e351a4b60e26a187dcd3d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1e",
                                                              "_id": "606e351a4b60e26a187dcd3e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation of differential equation",
                                                      "id": "5ace203a9fe7b01d5806bf7e",
                                                      "_id": "606e351a4b60e26a187dcd3b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1f",
                                                              "_id": "606e351a4b60e26a187dcd3c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "geometrical apllication",
                                                      "id": "5ace203a9fe7b01d5806bf7f",
                                                      "_id": "606e351a4b60e26a187dcd39",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da20",
                                                              "_id": "606e351a4b60e26a187dcd3a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "order and degree of differential equation",
                                                      "id": "5ace203a9fe7b01d5806bf80",
                                                      "_id": "606e351a4b60e26a187dcd37",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da21",
                                                              "_id": "606e351a4b60e26a187dcd38"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reducible to variable seperable method, solution of differential equation of the homogeneous and reducible to the homogeneous form",
                                                      "id": "5ace203a9fe7b01d5806bf81",
                                                      "_id": "606e351a4b60e26a187dcd35",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da22",
                                                              "_id": "606e351a4b60e26a187dcd36"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of differential equation by variable seperable method",
                                                      "id": "5ace203a9fe7b01d5806bf82",
                                                      "_id": "606e351a4b60e26a187dcd33",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da23",
                                                              "_id": "606e351a4b60e26a187dcd34"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of general form of variable seperation",
                                                      "id": "5ace203a9fe7b01d5806bf83",
                                                      "_id": "606e351a4b60e26a187dcd31",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da24",
                                                              "_id": "606e351a4b60e26a187dcd32"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Linear differential equation, solution of bernoulis eqn, Solution of differential equation reducible to Bernoulii form",
                                                      "id": "5ace203a9fe7b01d5806bf84",
                                                      "_id": "606e351a4b60e26a187dcd2f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da25",
                                                              "_id": "606e351a4b60e26a187dcd30"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d945",
                                                      "_id": "606e351a4b60e26a187dcd41"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentiation",
                                              "id": "5ace20319fe7b01d5806bc50",
                                              "_id": "606e351a4b60e26a187dcd2c",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d946",
                                                      "_id": "606e351a4b60e26a187dcd2d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentiation",
                                              "id": "5ace20319fe7b01d5806bc51",
                                              "_id": "606e351a4b60e26a187dcd20",
                                              "concepts": [
                                                  {
                                                      "name": "chain rule",
                                                      "id": "5ace203a9fe7b01d5806bf85",
                                                      "_id": "606e351a4b60e26a187dcd29",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da26",
                                                              "_id": "606e351a4b60e26a187dcd2a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Derivative of implicit function, derivative of parametric function, derivative of one function w.r.t another function, derivative of function to power function form, derivative of infinite series type problems",
                                                      "id": "5ace203a9fe7b01d5806bf86",
                                                      "_id": "606e351a4b60e26a187dcd27",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da27",
                                                              "_id": "606e351a4b60e26a187dcd28"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation of various functions and the rules of differentiation",
                                                      "id": "5ace203a9fe7b01d5806bf87",
                                                      "_id": "606e351a4b60e26a187dcd25",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da28",
                                                              "_id": "606e351a4b60e26a187dcd26"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "first principle",
                                                      "id": "5ace203a9fe7b01d5806bf88",
                                                      "_id": "606e351a4b60e26a187dcd23",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da29",
                                                              "_id": "606e351a4b60e26a187dcd24"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "higher order derivative",
                                                      "id": "5ace203a9fe7b01d5806bf89",
                                                      "_id": "606e351a4b60e26a187dcd21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2a",
                                                              "_id": "606e351a4b60e26a187dcd22"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d947",
                                                      "_id": "606e351a4b60e26a187dcd2b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Indefinite Integration",
                                              "id": "5ace20319fe7b01d5806bc52",
                                              "_id": "606e351a4b60e26a187dcd1e",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d948",
                                                      "_id": "606e351a4b60e26a187dcd1f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Indefinite Integration",
                                              "id": "5ace20319fe7b01d5806bc53",
                                              "_id": "606e351a4b60e26a187dcd0c",
                                              "concepts": [
                                                  {
                                                      "name": "conversion of unknown form to known form",
                                                      "id": "5ace203a9fe7b01d5806bf8a",
                                                      "_id": "606e351a4b60e26a187dcd1b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2b",
                                                              "_id": "606e351a4b60e26a187dcd1c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on partial fraction",
                                                      "id": "5ace203a9fe7b01d5806bf8b",
                                                      "_id": "606e351a4b60e26a187dcd19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2c",
                                                              "_id": "606e351a4b60e26a187dcd1a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Algebraic twin form, algebraic substitution, integration using complex number",
                                                      "id": "5ace203a9fe7b01d5806bf8c",
                                                      "_id": "606e351a4b60e26a187dcd17",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2d",
                                                              "_id": "606e351a4b60e26a187dcd18"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on by parts, e to the power x (f(x) + f`(x)) dx type",
                                                      "id": "5ace203a9fe7b01d5806bf8d",
                                                      "_id": "606e351a4b60e26a187dcd15",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2e",
                                                              "_id": "606e351a4b60e26a187dcd16"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on integration of irrational function",
                                                      "id": "5ace203a9fe7b01d5806bf8e",
                                                      "_id": "606e351a4b60e26a187dcd13",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2f",
                                                              "_id": "606e351a4b60e26a187dcd14"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on integration of rational function",
                                                      "id": "5ace203a9fe7b01d5806bf8f",
                                                      "_id": "606e351a4b60e26a187dcd11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da30",
                                                              "_id": "606e351a4b60e26a187dcd12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on method of substitution",
                                                      "id": "5ace203a9fe7b01d5806bf90",
                                                      "_id": "606e351a4b60e26a187dcd0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da31",
                                                              "_id": "606e351a4b60e26a187dcd10"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic divided by quadratic, linear divided by quadratic and trigonometric substitution",
                                                      "id": "5ace203a9fe7b01d5806bf91",
                                                      "_id": "606e351a4b60e26a187dcd0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da32",
                                                              "_id": "606e351a4b60e26a187dcd0e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d949",
                                                      "_id": "606e351a4b60e26a187dcd1d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Limit of the function",
                                              "id": "5ace20319fe7b01d5806bc54",
                                              "_id": "606e351a4b60e26a187dcd0a",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94a",
                                                      "_id": "606e351a4b60e26a187dcd0b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Limit of the function",
                                              "id": "5ace20319fe7b01d5806bc55",
                                              "_id": "606e351a4b60e26a187dccec",
                                              "concepts": [
                                                  {
                                                      "name": "Application of series to find the limits of a function",
                                                      "id": "5ace203a9fe7b01d5806bf92",
                                                      "_id": "606e351a4b60e26a187dcd07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da33",
                                                              "_id": "606e351a4b60e26a187dcd08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Exponential functions",
                                                      "id": "5ace203a9fe7b01d5806bf93",
                                                      "_id": "606e351a4b60e26a187dcd05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da34",
                                                              "_id": "606e351a4b60e26a187dcd06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Logarithmic functions",
                                                      "id": "5ace203a9fe7b01d5806bf94",
                                                      "_id": "606e351a4b60e26a187dcd03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da35",
                                                              "_id": "606e351a4b60e26a187dcd04"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Trigonometrical function",
                                                      "id": "5ace203a9fe7b01d5806bf95",
                                                      "_id": "606e351a4b60e26a187dcd01",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da36",
                                                              "_id": "606e351a4b60e26a187dcd02"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Max. value and MIn. value of a function using limit",
                                                      "id": "5ace203a9fe7b01d5806bf96",
                                                      "_id": "606e351a4b60e26a187dccff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da37",
                                                              "_id": "606e351a4b60e26a187dcd00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of Direct substitution to find the limit",
                                                      "id": "5ace203a9fe7b01d5806bf97",
                                                      "_id": "606e351a4b60e26a187dccfd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da38",
                                                              "_id": "606e351a4b60e26a187dccfe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of Rationalization to find the limit",
                                                      "id": "5ace203a9fe7b01d5806bf98",
                                                      "_id": "606e351a4b60e26a187dccfb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da39",
                                                              "_id": "606e351a4b60e26a187dccfc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on 1 to power infinity form, function power function form",
                                                      "id": "5ace203a9fe7b01d5806bf99",
                                                      "_id": "606e351a4b60e26a187dccf9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3a",
                                                              "_id": "606e351a4b60e26a187dccfa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on existance of limits, LHL and RHL",
                                                      "id": "5ace203a9fe7b01d5806bf9a",
                                                      "_id": "606e351a4b60e26a187dccf7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3b",
                                                              "_id": "606e351a4b60e26a187dccf8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on L hospital rule",
                                                      "id": "5ace203a9fe7b01d5806bf9b",
                                                      "_id": "606e351a4b60e26a187dccf5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3c",
                                                              "_id": "606e351a4b60e26a187dccf6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Limit of composite functions and sandwitz theorem",
                                                      "id": "5ace203a9fe7b01d5806bf9c",
                                                      "_id": "606e351a4b60e26a187dccf3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3d",
                                                              "_id": "606e351a4b60e26a187dccf4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on limits of the form x approaches infinity",
                                                      "id": "5ace203a9fe7b01d5806bf9d",
                                                      "_id": "606e351a4b60e26a187dccf1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3e",
                                                              "_id": "606e351a4b60e26a187dccf2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Newton Lebnitz rule",
                                                      "id": "5ace203a9fe7b01d5806bf9e",
                                                      "_id": "606e351a4b60e26a187dccef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3f",
                                                              "_id": "606e351a4b60e26a187dccf0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on standard results",
                                                      "id": "5ace203a9fe7b01d5806bf9f",
                                                      "_id": "606e351a4b60e26a187dcced",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da40",
                                                              "_id": "606e351a4b60e26a187dccee"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94b",
                                                      "_id": "606e351a4b60e26a187dcd09"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Basic Calculus",
                                              "id": "5bab788738234f74bfb65ff5",
                                              "_id": "606e351a4b60e26a187dcce4",
                                              "concepts": [
                                                  {
                                                      "name": "Integration",
                                                      "id": "5bab79b238234f74bfb6600f",
                                                      "_id": "606e351a4b60e26a187dcce9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da41",
                                                              "_id": "606e351a4b60e26a187dccea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation",
                                                      "id": "5bab79c138234f74bfb66010",
                                                      "_id": "606e351a4b60e26a187dcce7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da42",
                                                              "_id": "606e351a4b60e26a187dcce8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integration",
                                                      "id": "5bab79d038234f74bfb66012",
                                                      "_id": "606e351a4b60e26a187dcce5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da43",
                                                              "_id": "606e351a4b60e26a187dcce6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94c",
                                                      "_id": "606e351a4b60e26a187dcceb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Number",
                                              "id": "5ace20319fe7b01d5806bc56",
                                              "_id": "606e351a4b60e26a187dcce0",
                                              "concepts": [
                                                  {
                                                      "name": "Intersection of a straight line and circle on Argand plane",
                                                      "id": "5ace203a9fe7b01d5806bfa0",
                                                      "_id": "606e351a4b60e26a187dcce1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da44",
                                                              "_id": "606e351a4b60e26a187dcce2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94d",
                                                      "_id": "606e351a4b60e26a187dcce3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circle",
                                              "id": "5ace20319fe7b01d5806bc57",
                                              "_id": "606e351a4b60e26a187dccde",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94e",
                                                      "_id": "606e351a4b60e26a187dccdf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circle",
                                              "id": "5ace20319fe7b01d5806bc58",
                                              "_id": "606e351a4b60e26a187dccc6",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between two circles and condition for orthogonal intersection",
                                                      "id": "5ace203a9fe7b01d5806bfa1",
                                                      "_id": "606e351a4b60e26a187dccdb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da45",
                                                              "_id": "606e351a4b60e26a187dccdc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord of contact, equation of chord in mid-point form",
                                                      "id": "5ace203a9fe7b01d5806bfa2",
                                                      "_id": "606e351a4b60e26a187dccd9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da46",
                                                              "_id": "606e351a4b60e26a187dccda"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of common tangent and their length, equation of common chord",
                                                      "id": "5ace203a9fe7b01d5806bfa3",
                                                      "_id": "606e351a4b60e26a187dccd7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da47",
                                                              "_id": "606e351a4b60e26a187dccd8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of tangent in various form",
                                                      "id": "5ace203a9fe7b01d5806bfa4",
                                                      "_id": "606e351a4b60e26a187dccd5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da48",
                                                              "_id": "606e351a4b60e26a187dccd6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Family of circles in various conditions",
                                                      "id": "5ace203a9fe7b01d5806bfa5",
                                                      "_id": "606e351a4b60e26a187dccd3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da49",
                                                              "_id": "606e351a4b60e26a187dccd4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "length of tangent",
                                                      "id": "5ace203a9fe7b01d5806bfa6",
                                                      "_id": "606e351a4b60e26a187dccd1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4a",
                                                              "_id": "606e351a4b60e26a187dccd2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Normal of the circle",
                                                      "id": "5ace203a9fe7b01d5806bfa7",
                                                      "_id": "606e351a4b60e26a187dcccf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4b",
                                                              "_id": "606e351a4b60e26a187dccd0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pair of tangents and angle between pair of tangent and director circle",
                                                      "id": "5ace203a9fe7b01d5806bfa8",
                                                      "_id": "606e351a4b60e26a187dcccd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4c",
                                                              "_id": "606e351a4b60e26a187dccce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position of point w.r.t. to circle and position of line w.r.t. circle, length of intercept made by circle on line",
                                                      "id": "5ace203a9fe7b01d5806bfa9",
                                                      "_id": "606e351a4b60e26a187dcccb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4d",
                                                              "_id": "606e351a4b60e26a187dcccc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radical axis and its property, position of two circles w.r.t. each other",
                                                      "id": "5ace203a9fe7b01d5806bfaa",
                                                      "_id": "606e351a4b60e26a187dccc9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4e",
                                                              "_id": "606e351a4b60e26a187dccca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Various forms of circle, condition for second degree equation to represents a circle",
                                                      "id": "5ace203a9fe7b01d5806bfab",
                                                      "_id": "606e351a4b60e26a187dccc7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4f",
                                                              "_id": "606e351a4b60e26a187dccc8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94f",
                                                      "_id": "606e351a4b60e26a187dccdd"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ellipse",
                                              "id": "5ace20319fe7b01d5806bc59",
                                              "_id": "606e351a4b60e26a187dccc4",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d950",
                                                      "_id": "606e351a4b60e26a187dccc5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ellipse",
                                              "id": "5ace20319fe7b01d5806bc5a",
                                              "_id": "606e351a4b60e26a187dcca6",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between the tangents",
                                                      "id": "5ace203a9fe7b01d5806bfac",
                                                      "_id": "606e351a4b60e26a187dccc1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da50",
                                                              "_id": "606e351a4b60e26a187dccc2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfad",
                                                      "_id": "606e351a4b60e26a187dccbf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da51",
                                                              "_id": "606e351a4b60e26a187dccc0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basing on director circle of ellipse",
                                                      "id": "5ace203a9fe7b01d5806bfae",
                                                      "_id": "606e351a4b60e26a187dccbd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da52",
                                                              "_id": "606e351a4b60e26a187dccbe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "chord of contact, equation of pair of tangents, director circle",
                                                      "id": "5ace203a9fe7b01d5806bfaf",
                                                      "_id": "606e351a4b60e26a187dccbb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da53",
                                                              "_id": "606e351a4b60e26a187dccbc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form,",
                                                      "id": "5ace203a9fe7b01d5806bfb0",
                                                      "_id": "606e351a4b60e26a187dccb9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da54",
                                                              "_id": "606e351a4b60e26a187dccba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord",
                                                      "id": "5ace203a9fe7b01d5806bfb1",
                                                      "_id": "606e351a4b60e26a187dccb7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da55",
                                                              "_id": "606e351a4b60e26a187dccb8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represent ellipse, standard form and general form of ellipse and to find focus, directrix, axes, latus rectum, tangent at vertex of ellipse, parametric form, focal length, auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfb2",
                                                      "_id": "606e351a4b60e26a187dccb5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da56",
                                                              "_id": "606e351a4b60e26a187dccb6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfb3",
                                                      "_id": "606e351a4b60e26a187dccb3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da57",
                                                              "_id": "606e351a4b60e26a187dccb4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of four normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfb4",
                                                      "_id": "606e351a4b60e26a187dccb1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da58",
                                                              "_id": "606e351a4b60e26a187dccb2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of chord joining two points having eccentric angle",
                                                      "id": "5ace203a9fe7b01d5806bfb5",
                                                      "_id": "606e351a4b60e26a187dccaf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da59",
                                                              "_id": "606e351a4b60e26a187dccb0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of ellipse and a circle",
                                                      "id": "5ace203a9fe7b01d5806bfb6",
                                                      "_id": "606e351a4b60e26a187dccad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5a",
                                                              "_id": "606e351a4b60e26a187dccae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "parametric co-ordinates",
                                                      "id": "5ace203a9fe7b01d5806bfb7",
                                                      "_id": "606e351a4b60e26a187dccab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5b",
                                                              "_id": "606e351a4b60e26a187dccac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "position of a pt w.r.t. ellipse",
                                                      "id": "5ace203a9fe7b01d5806bfb8",
                                                      "_id": "606e351a4b60e26a187dcca9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5c",
                                                              "_id": "606e351a4b60e26a187dccaa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in ellipse-reflection, tangent, normal",
                                                      "id": "5ace203a9fe7b01d5806bfb9",
                                                      "_id": "606e351a4b60e26a187dcca7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5d",
                                                              "_id": "606e351a4b60e26a187dcca8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d951",
                                                      "_id": "606e351a4b60e26a187dccc3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Hyperbola",
                                              "id": "5ace20319fe7b01d5806bc5b",
                                              "_id": "606e351a4b60e26a187dcca4",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d952",
                                                      "_id": "606e351a4b60e26a187dcca5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Hyperbola",
                                              "id": "5ace20319fe7b01d5806bc5c",
                                              "_id": "606e351a4b60e26a187dcc88",
                                              "concepts": [
                                                  {
                                                      "name": "Asymptotes of hyperbola and its properties",
                                                      "id": "5ace203a9fe7b01d5806bfba",
                                                      "_id": "606e351a4b60e26a187dcca1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5e",
                                                              "_id": "606e351a4b60e26a187dcca2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic properties of conjugate hyperbola of a hyperbola",
                                                      "id": "5ace203a9fe7b01d5806bfbb",
                                                      "_id": "606e351a4b60e26a187dcc9f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5f",
                                                              "_id": "606e351a4b60e26a187dcca0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord of contact, equation of pair of tangents, director circle",
                                                      "id": "5ace203a9fe7b01d5806bfbc",
                                                      "_id": "606e351a4b60e26a187dcc9d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da60",
                                                              "_id": "606e351a4b60e26a187dcc9e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                      "id": "5ace203a9fe7b01d5806bfbd",
                                                      "_id": "606e351a4b60e26a187dcc9b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da61",
                                                              "_id": "606e351a4b60e26a187dcc9c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Common tangent between hyperbola and circle",
                                                      "id": "5ace203a9fe7b01d5806bfbe",
                                                      "_id": "606e351a4b60e26a187dcc99",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da62",
                                                              "_id": "606e351a4b60e26a187dcc9a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                      "id": "5ace203a9fe7b01d5806bfbf",
                                                      "_id": "606e351a4b60e26a187dcc97",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da63",
                                                              "_id": "606e351a4b60e26a187dcc98"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represents hyperbola, standard form and general form of hyperbola, conjugate hyperbola and to find focus, directrix, axes, latus rectum, tangent at vertex of hyperbola, parametric form, focal length, auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfc0",
                                                      "_id": "606e351a4b60e26a187dcc95",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da64",
                                                              "_id": "606e351a4b60e26a187dcc96"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfc1",
                                                      "_id": "606e351a4b60e26a187dcc93",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da65",
                                                              "_id": "606e351a4b60e26a187dcc94"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of four normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfc2",
                                                      "_id": "606e351a4b60e26a187dcc91",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da66",
                                                              "_id": "606e351a4b60e26a187dcc92"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of a rectangular hyperbola with a circle",
                                                      "id": "5ace203a9fe7b01d5806bfc3",
                                                      "_id": "606e351a4b60e26a187dcc8f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da67",
                                                              "_id": "606e351a4b60e26a187dcc90"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "position of a pt w.r.t. hyperbola",
                                                      "id": "5ace203a9fe7b01d5806bfc4",
                                                      "_id": "606e351a4b60e26a187dcc8d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da68",
                                                              "_id": "606e351a4b60e26a187dcc8e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in hyperbola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                      "id": "5ace203a9fe7b01d5806bfc5",
                                                      "_id": "606e351a4b60e26a187dcc8b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da69",
                                                              "_id": "606e351a4b60e26a187dcc8c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rectangular hyperbola and its properties",
                                                      "id": "5ace203a9fe7b01d5806bfc6",
                                                      "_id": "606e351a4b60e26a187dcc89",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6a",
                                                              "_id": "606e351a4b60e26a187dcc8a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d953",
                                                      "_id": "606e351a4b60e26a187dcca3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Parabola",
                                              "id": "5ace20319fe7b01d5806bc5d",
                                              "_id": "606e351a4b60e26a187dcc86",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d954",
                                                      "_id": "606e351a4b60e26a187dcc87"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Parabola",
                                              "id": "5ace20319fe7b01d5806bc5e",
                                              "_id": "606e351a4b60e26a187dcc6e",
                                              "concepts": [
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                      "id": "5ace203a9fe7b01d5806bfc7",
                                                      "_id": "606e351a4b60e26a187dcc83",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6b",
                                                              "_id": "606e351a4b60e26a187dcc84"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                      "id": "5ace203a9fe7b01d5806bfc8",
                                                      "_id": "606e351a4b60e26a187dcc81",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6c",
                                                              "_id": "606e351a4b60e26a187dcc82"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represents conic, standard form and general form of parabola, focus, directrix, axes, latus rectum, tangent at vertex of parabola, parametric form",
                                                      "id": "5ace203a9fe7b01d5806bfc9",
                                                      "_id": "606e351a4b60e26a187dcc7f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6d",
                                                              "_id": "606e351a4b60e26a187dcc80"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for z normals",
                                                      "id": "5ace203a9fe7b01d5806bfca",
                                                      "_id": "606e351a4b60e26a187dcc7d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6e",
                                                              "_id": "606e351a4b60e26a187dcc7e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents, chord of contact",
                                                      "id": "5ace203a9fe7b01d5806bfcb",
                                                      "_id": "606e351a4b60e26a187dcc7b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6f",
                                                              "_id": "606e351a4b60e26a187dcc7c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of three normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfcc",
                                                      "_id": "606e351a4b60e26a187dcc79",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da70",
                                                              "_id": "606e351a4b60e26a187dcc7a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "eqn of normal",
                                                      "id": "5ace203a9fe7b01d5806bfcd",
                                                      "_id": "606e351a4b60e26a187dcc77",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da71",
                                                              "_id": "606e351a4b60e26a187dcc78"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of pair of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfce",
                                                      "_id": "606e351a4b60e26a187dcc75",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da72",
                                                              "_id": "606e351a4b60e26a187dcc76"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "geometrical properties of a parabola",
                                                      "id": "5ace203a9fe7b01d5806bfcf",
                                                      "_id": "606e351a4b60e26a187dcc73",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da73",
                                                              "_id": "606e351a4b60e26a187dcc74"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in parabola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                      "id": "5ace203a9fe7b01d5806bfd0",
                                                      "_id": "606e351a4b60e26a187dcc71",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da74",
                                                              "_id": "606e351a4b60e26a187dcc72"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots of cubic equations",
                                                      "id": "5ace203a9fe7b01d5806bfd1",
                                                      "_id": "606e351a4b60e26a187dcc6f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da75",
                                                              "_id": "606e351a4b60e26a187dcc70"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d955",
                                                      "_id": "606e351a4b60e26a187dcc85"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Straight Line",
                                              "id": "5ace20319fe7b01d5806bc5f",
                                              "_id": "606e351a4b60e26a187dcc6c",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d956",
                                                      "_id": "606e351a4b60e26a187dcc6d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Straight Line",
                                              "id": "5ace20319fe7b01d5806bc60",
                                              "_id": "606e351a4b60e26a187dcc52",
                                              "concepts": [
                                                  {
                                                      "name": "Angle bisectors",
                                                      "id": "5ace203a9fe7b01d5806bfd2",
                                                      "_id": "606e351a4b60e26a187dcc69",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da76",
                                                              "_id": "606e351a4b60e26a187dcc6a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of triangle, collinearity and locus",
                                                      "id": "5ace203a9fe7b01d5806bfd3",
                                                      "_id": "606e351a4b60e26a187dcc67",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da77",
                                                              "_id": "606e351a4b60e26a187dcc68"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concept of homogenization",
                                                      "id": "5ace203a9fe7b01d5806bfd4",
                                                      "_id": "606e351a4b60e26a187dcc65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da78",
                                                              "_id": "606e351a4b60e26a187dcc66"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for eqn of second degree to represent two lines, angle between two pair of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd5",
                                                      "_id": "606e351a4b60e26a187dcc63",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da79",
                                                              "_id": "606e351a4b60e26a187dcc64"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance formula, Section formula, centres related to triangle",
                                                      "id": "5ace203a9fe7b01d5806bfd6",
                                                      "_id": "606e351a4b60e26a187dcc61",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7a",
                                                              "_id": "606e351a4b60e26a187dcc62"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "eqn of pair of line joing pts of intersection of a line and a conic",
                                                      "id": "5ace203a9fe7b01d5806bfd7",
                                                      "_id": "606e351a4b60e26a187dcc5f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7b",
                                                              "_id": "606e351a4b60e26a187dcc60"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of angle bisectors of pair of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd8",
                                                      "_id": "606e351a4b60e26a187dcc5d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7c",
                                                              "_id": "606e351a4b60e26a187dcc5e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Family of straight lines/concurrency of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd9",
                                                      "_id": "606e351a4b60e26a187dcc5b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7d",
                                                              "_id": "606e351a4b60e26a187dcc5c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parametric form of line and its application",
                                                      "id": "5ace203b9fe7b01d5806bfda",
                                                      "_id": "606e351a4b60e26a187dcc59",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7e",
                                                              "_id": "606e351a4b60e26a187dcc5a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position of points w.r.t. to line, distance of a point from a line, distance between two parallel lines angle between two lines, condition of parallel/perpendicular/identical lines",
                                                      "id": "5ace203b9fe7b01d5806bfdb",
                                                      "_id": "606e351a4b60e26a187dcc57",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7f",
                                                              "_id": "606e351a4b60e26a187dcc58"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rotation and translation of axes",
                                                      "id": "5ace203b9fe7b01d5806bfdc",
                                                      "_id": "606e351a4b60e26a187dcc55",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da80",
                                                              "_id": "606e351a4b60e26a187dcc56"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Slope of a line, various forms of equation of straight line",
                                                      "id": "5ace203b9fe7b01d5806bfdd",
                                                      "_id": "606e351a4b60e26a187dcc53",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da81",
                                                              "_id": "606e351a4b60e26a187dcc54"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d957",
                                                      "_id": "606e351a4b60e26a187dcc6b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Functions",
                                              "id": "5ace20319fe7b01d5806bc61",
                                              "_id": "606e351a4b60e26a187dcc50",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d958",
                                                      "_id": "606e351a4b60e26a187dcc51"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Functions",
                                              "id": "5ace20319fe7b01d5806bc62",
                                              "_id": "606e351a4b60e26a187dcc2c",
                                              "concepts": [
                                                  {
                                                      "name": "Algebra of a function",
                                                      "id": "5ace203b9fe7b01d5806bfde",
                                                      "_id": "606e351a4b60e26a187dcc4d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da82",
                                                              "_id": "606e351a4b60e26a187dcc4e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bijective functions, inverse of a function",
                                                      "id": "5ace203b9fe7b01d5806bfdf",
                                                      "_id": "606e351a4b60e26a187dcc4b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da83",
                                                              "_id": "606e351a4b60e26a187dcc4c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "binary operation",
                                                      "id": "5ace203b9fe7b01d5806bfe0",
                                                      "_id": "606e351a4b60e26a187dcc49",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da84",
                                                              "_id": "606e351a4b60e26a187dcc4a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Composite function",
                                                      "id": "5ace203b9fe7b01d5806bfe1",
                                                      "_id": "606e351a4b60e26a187dcc47",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da85",
                                                              "_id": "606e351a4b60e26a187dcc48"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain of a function",
                                                      "id": "5ace203b9fe7b01d5806bfe2",
                                                      "_id": "606e351a4b60e26a187dcc45",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da86",
                                                              "_id": "606e351a4b60e26a187dcc46"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "even fn",
                                                      "id": "5ace203b9fe7b01d5806bfe3",
                                                      "_id": "606e351a4b60e26a187dcc43",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da87",
                                                              "_id": "606e351a4b60e26a187dcc44"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Even/odd functions",
                                                      "id": "5ace203b9fe7b01d5806bfe4",
                                                      "_id": "606e351a4b60e26a187dcc41",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da88",
                                                              "_id": "606e351a4b60e26a187dcc42"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functional equation",
                                                      "id": "5ace203b9fe7b01d5806bfe5",
                                                      "_id": "606e351a4b60e26a187dcc3f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da89",
                                                              "_id": "606e351a4b60e26a187dcc40"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GIF (Greatest integer function)",
                                                      "id": "5ace203b9fe7b01d5806bfe6",
                                                      "_id": "606e351a4b60e26a187dcc3d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8a",
                                                              "_id": "606e351a4b60e26a187dcc3e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus function",
                                                      "id": "5ace203b9fe7b01d5806bfe7",
                                                      "_id": "606e351a4b60e26a187dcc3b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8b",
                                                              "_id": "606e351a4b60e26a187dcc3c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number of elements in sets, operation on sets, venn diagram based problems, cartesian products of two sets",
                                                      "id": "5ace203b9fe7b01d5806bfe8",
                                                      "_id": "606e351a4b60e26a187dcc39",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8c",
                                                              "_id": "606e351a4b60e26a187dcc3a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number of solution type problems, Graphical solution of function",
                                                      "id": "5ace203b9fe7b01d5806bfe9",
                                                      "_id": "606e351a4b60e26a187dcc37",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8d",
                                                              "_id": "606e351a4b60e26a187dcc38"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "odd fn",
                                                      "id": "5ace203b9fe7b01d5806bfea",
                                                      "_id": "606e351a4b60e26a187dcc35",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8e",
                                                              "_id": "606e351a4b60e26a187dcc36"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Period of a function",
                                                      "id": "5ace203b9fe7b01d5806bfeb",
                                                      "_id": "606e351a4b60e26a187dcc33",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8f",
                                                              "_id": "606e351a4b60e26a187dcc34"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Range of a function",
                                                      "id": "5ace203b9fe7b01d5806bfec",
                                                      "_id": "606e351a4b60e26a187dcc31",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da90",
                                                              "_id": "606e351a4b60e26a187dcc32"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation and types of relations",
                                                      "id": "5ace203b9fe7b01d5806bfed",
                                                      "_id": "606e351a4b60e26a187dcc2f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da91",
                                                              "_id": "606e351a4b60e26a187dcc30"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types and number of functions: one-one/many-one, into/ onto",
                                                      "id": "5ace203b9fe7b01d5806bfee",
                                                      "_id": "606e351a4b60e26a187dcc2d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da92",
                                                              "_id": "606e351a4b60e26a187dcc2e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d959",
                                                      "_id": "606e351a4b60e26a187dcc4f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Inequations",
                                              "id": "5ace20319fe7b01d5806bc63",
                                              "_id": "606e351a4b60e26a187dcc28",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Inequations",
                                                      "id": "5ace203b9fe7b01d5806bfef",
                                                      "_id": "606e351a4b60e26a187dcc29",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da93",
                                                              "_id": "606e351a4b60e26a187dcc2a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95a",
                                                      "_id": "606e351a4b60e26a187dcc2b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Programming",
                                              "id": "5ace20319fe7b01d5806bc64",
                                              "_id": "606e351a4b60e26a187dcc24",
                                              "concepts": [
                                                  {
                                                      "name": "Problems based on optimization under constraints",
                                                      "id": "5ace203b9fe7b01d5806bff0",
                                                      "_id": "606e351a4b60e26a187dcc25",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da94",
                                                              "_id": "606e351a4b60e26a187dcc26"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95b",
                                                      "_id": "606e351a4b60e26a187dcc27"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Logarithmic and Exponential Series",
                                              "id": "5ace20319fe7b01d5806bc65",
                                              "_id": "606e351a4b60e26a187dcc20",
                                              "concepts": [
                                                  {
                                                      "name": "Problems related to Series and Equation",
                                                      "id": "5ace203b9fe7b01d5806bff1",
                                                      "_id": "606e351a4b60e26a187dcc21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da95",
                                                              "_id": "606e351a4b60e26a187dcc22"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95c",
                                                      "_id": "606e351a4b60e26a187dcc23"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mathematical Induction",
                                              "id": "5ace20319fe7b01d5806bc66",
                                              "_id": "606e351a4b60e26a187dcc1c",
                                              "concepts": [
                                                  {
                                                      "name": "Principle of Mathematical Induction",
                                                      "id": "5ace203b9fe7b01d5806bff2",
                                                      "_id": "606e351a4b60e26a187dcc1d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da96",
                                                              "_id": "606e351a4b60e26a187dcc1e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95d",
                                                      "_id": "606e351a4b60e26a187dcc1f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mathematical Reasoning",
                                              "id": "5ace20319fe7b01d5806bc67",
                                              "_id": "606e351a4b60e26a187dcc18",
                                              "concepts": [
                                                  {
                                                      "name": "Types of statements, Mathematical operators-And, or, NOT, If then, If and only If, Quantifiers, Tautology, Falacy",
                                                      "id": "5ace203b9fe7b01d5806bff3",
                                                      "_id": "606e351a4b60e26a187dcc19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da97",
                                                              "_id": "606e351a4b60e26a187dcc1a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95e",
                                                      "_id": "606e351a4b60e26a187dcc1b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc68",
                                              "_id": "606e351a4b60e26a187dcc14",
                                              "concepts": [
                                                  {
                                                      "name": "Angle of Elevation, Angle of Depression",
                                                      "id": "5ace203b9fe7b01d5806bff4",
                                                      "_id": "606e351a4b60e26a187dcc15",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da98",
                                                              "_id": "606e351a4b60e26a187dcc16"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95f",
                                                      "_id": "606e351a4b60e26a187dcc17"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Area related to Circle",
                                              "id": "5ace20319fe7b01d5806bc69",
                                              "_id": "606e351a4b60e26a187dcc0c",
                                              "concepts": [
                                                  {
                                                      "name": "Area enclosed by two concentric circles, Area of segment",
                                                      "id": "5ace203b9fe7b01d5806bff5",
                                                      "_id": "606e351a4b60e26a187dcc11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da99",
                                                              "_id": "606e351a4b60e26a187dcc12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of circle",
                                                      "id": "5ace203b9fe7b01d5806bff6",
                                                      "_id": "606e351a4b60e26a187dcc0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9a",
                                                              "_id": "606e351a4b60e26a187dcc10"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of sector, Semi-circle area",
                                                      "id": "5ace203b9fe7b01d5806bff7",
                                                      "_id": "606e351a4b60e26a187dcc0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9b",
                                                              "_id": "606e351a4b60e26a187dcc0e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d960",
                                                      "_id": "606e351a4b60e26a187dcc13"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Areas of Parallelogram and Triangles",
                                              "id": "5ace20319fe7b01d5806bc6a",
                                              "_id": "606e351a4b60e26a187dcc02",
                                              "concepts": [
                                                  {
                                                      "name": "Different triangles and there areas, Area of parallelogram on same base between same parallel lines are equal",
                                                      "id": "5ace203b9fe7b01d5806bff8",
                                                      "_id": "606e351a4b60e26a187dcc09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9c",
                                                              "_id": "606e351a4b60e26a187dcc0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theorems related to Parallelograms, Area, Triangles on the same base and between the same parallel lines",
                                                      "id": "5ace203b9fe7b01d5806bff9",
                                                      "_id": "606e351a4b60e26a187dcc07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9d",
                                                              "_id": "606e351a4b60e26a187dcc08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parallelograms on the Same Base and Between the Same Parallels",
                                                      "id": "5ec64785941e1306742b8440",
                                                      "_id": "606e351a4b60e26a187dcc05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9e",
                                                              "_id": "606e351a4b60e26a187dcc06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Triangles on the Same Base and Between the Same Parallels",
                                                      "id": "5ec64785941e1306742b8441",
                                                      "_id": "606e351a4b60e26a187dcc03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da9f",
                                                              "_id": "606e351a4b60e26a187dcc04"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d961",
                                                      "_id": "606e351a4b60e26a187dcc0b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Arithmetic Progressions",
                                              "id": "5ace20319fe7b01d5806bc6b",
                                              "_id": "606e351a4b60e26a187dcbfa",
                                              "concepts": [
                                                  {
                                                      "name": "Definition, nth term from start, nth term from end",
                                                      "id": "5ace203b9fe7b01d5806bffa",
                                                      "_id": "606e351a4b60e26a187dcbff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa0",
                                                              "_id": "606e351a4b60e26a187dcc00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Selection of terms in an AP, sum of first n terms of an AP",
                                                      "id": "5ace203b9fe7b01d5806bffb",
                                                      "_id": "606e351a4b60e26a187dcbfd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa1",
                                                              "_id": "606e351a4b60e26a187dcbfe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word problems",
                                                      "id": "5ace203b9fe7b01d5806bffc",
                                                      "_id": "606e351a4b60e26a187dcbfb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa2",
                                                              "_id": "606e351a4b60e26a187dcbfc"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d962",
                                                      "_id": "606e351a4b60e26a187dcc01"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circles",
                                              "id": "5ace20319fe7b01d5806bc6c",
                                              "_id": "606e351a4b60e26a187dcbe8",
                                              "concepts": [
                                                  {
                                                      "name": "Arcs and Angle subtended by them, Cyclic Quadrilateral, Cyclic Quadrilaterals Opposite Angle",
                                                      "id": "5ace203b9fe7b01d5806bffd",
                                                      "_id": "606e351a4b60e26a187dcbf7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa3",
                                                              "_id": "606e351a4b60e26a187dcbf8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definition of Circle, Major Arcs and Minor arcs, congruence of circles and arcs, some results on congurent arcs and chords, some results on equal chords",
                                                      "id": "5ace203b9fe7b01d5806bffe",
                                                      "_id": "606e351a4b60e26a187dcbf5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa4",
                                                              "_id": "606e351a4b60e26a187dcbf6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "No. of Common Tangents, Arc of Circle, Angle in Semi-Circle",
                                                      "id": "5ace203b9fe7b01d5806bfff",
                                                      "_id": "606e351a4b60e26a187dcbf3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa5",
                                                              "_id": "606e351a4b60e26a187dcbf4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cyclic Quadrilaterals",
                                                      "id": "5ec64785941e1306742b8446",
                                                      "_id": "606e351a4b60e26a187dcbf1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa6",
                                                              "_id": "606e351a4b60e26a187dcbf2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle Subtended by Arc of a Circle",
                                                      "id": "5ec64785941e1306742b8445",
                                                      "_id": "606e351a4b60e26a187dcbef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa7",
                                                              "_id": "606e351a4b60e26a187dcbf0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circles and Its Related Terms",
                                                      "id": "5ec64785941e1306742b8442",
                                                      "_id": "606e351a4b60e26a187dcbed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa8",
                                                              "_id": "606e351a4b60e26a187dcbee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chords of a Circle-I",
                                                      "id": "5ec64785941e1306742b8443",
                                                      "_id": "606e351a4b60e26a187dcbeb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daa9",
                                                              "_id": "606e351a4b60e26a187dcbec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chords of a Circle-II",
                                                      "id": "5ec64785941e1306742b8444",
                                                      "_id": "606e351a4b60e26a187dcbe9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daaa",
                                                              "_id": "606e351a4b60e26a187dcbea"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d963",
                                                      "_id": "606e351a4b60e26a187dcbf9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions - 2",
                                              "id": "5ace20319fe7b01d5806bc6d",
                                              "_id": "606e351a4b60e26a187dcbe4",
                                              "concepts": [
                                                  {
                                                      "name": "Circle construction, Circle line intersection constructions, Division of a line segment in a given ratio, Construction of tangents to a circle from a point when centre of circle is known, Construction of common tangents to two given circles, Construction ",
                                                      "id": "5ace203b9fe7b01d5806c000",
                                                      "_id": "606e351a4b60e26a187dcbe5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daab",
                                                              "_id": "606e351a4b60e26a187dcbe6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d964",
                                                      "_id": "606e351a4b60e26a187dcbe7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions-1",
                                              "id": "5ace20319fe7b01d5806bc6e",
                                              "_id": "606e351a4b60e26a187dcbe0",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of Bisector of a line segment, Construction of bisector of a given angle, Construction of some Standard angles, Construction of a triangle when its base, sum of other two sides and one base angle are given",
                                                      "id": "5ace203b9fe7b01d5806c001",
                                                      "_id": "606e351a4b60e26a187dcbe1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daac",
                                                              "_id": "606e351a4b60e26a187dcbe2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d965",
                                                      "_id": "606e351a4b60e26a187dcbe3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Co-ordinate Geometry - 2",
                                              "id": "5ace20319fe7b01d5806bc6f",
                                              "_id": "606e351a4b60e26a187dcbd8",
                                              "concepts": [
                                                  {
                                                      "name": "Cartesian system, Distance between two points, Internal and External division",
                                                      "id": "5ace203b9fe7b01d5806c002",
                                                      "_id": "606e351a4b60e26a187dcbdd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daad",
                                                              "_id": "606e351a4b60e26a187dcbde"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Centroid ,Area of a Triangle, Straight line (Locus, Slope)",
                                                      "id": "5ace203b9fe7b01d5806c003",
                                                      "_id": "606e351a4b60e26a187dcbdb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daae",
                                                              "_id": "606e351a4b60e26a187dcbdc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Forms of Straight Line- Point slope, Slope intercept, Two point, Normal form, Length of perpendicular, Angle between Two Lines",
                                                      "id": "5ace203b9fe7b01d5806c004",
                                                      "_id": "606e351a4b60e26a187dcbd9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daaf",
                                                              "_id": "606e351a4b60e26a187dcbda"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d966",
                                                      "_id": "606e351a4b60e26a187dcbdf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Co-ordinate Geometry-1",
                                              "id": "5ace20319fe7b01d5806bc70",
                                              "_id": "606e351a4b60e26a187dcbce",
                                              "concepts": [
                                                  {
                                                      "name": "Area of triangle, collinearity of points",
                                                      "id": "5ace203b9fe7b01d5806c005",
                                                      "_id": "606e351a4b60e26a187dcbd5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab0",
                                                              "_id": "606e351a4b60e26a187dcbd6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance between Two Points",
                                                      "id": "5ace203b9fe7b01d5806c006",
                                                      "_id": "606e351a4b60e26a187dcbd3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab1",
                                                              "_id": "606e351a4b60e26a187dcbd4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internal and External Division using Section Formula,",
                                                      "id": "5ace203b9fe7b01d5806c007",
                                                      "_id": "606e351a4b60e26a187dcbd1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab2",
                                                              "_id": "606e351a4b60e26a187dcbd2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid point theorem, centroid of triangle",
                                                      "id": "5ace203b9fe7b01d5806c008",
                                                      "_id": "606e351a4b60e26a187dcbcf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab3",
                                                              "_id": "606e351a4b60e26a187dcbd0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d967",
                                                      "_id": "606e351a4b60e26a187dcbd7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Heron's Formula",
                                              "id": "5ace20319fe7b01d5806bc71",
                                              "_id": "606e351a4b60e26a187dcbc6",
                                              "concepts": [
                                                  {
                                                      "name": "Heron's Formula and problems",
                                                      "id": "5ace203b9fe7b01d5806c009",
                                                      "_id": "606e351a4b60e26a187dcbcb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab4",
                                                              "_id": "606e351a4b60e26a187dcbcc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heron's Formula",
                                                      "id": "5ec64785941e1306742b844b",
                                                      "_id": "606e351a4b60e26a187dcbc9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab5",
                                                              "_id": "606e351a4b60e26a187dcbca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application of Heron's Formula",
                                                      "id": "5ec64785941e1306742b844c",
                                                      "_id": "606e351a4b60e26a187dcbc7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab6",
                                                              "_id": "606e351a4b60e26a187dcbc8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d968",
                                                      "_id": "606e351a4b60e26a187dcbcd"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equation In Two Variables-1",
                                              "id": "5ace20319fe7b01d5806bc72",
                                              "_id": "606e351a4b60e26a187dcbc2",
                                              "concepts": [
                                                  {
                                                      "name": "Linear equations in two variables, solution of Linear Equation in Two Variables, Graph of Linear Equation in Two Variables",
                                                      "id": "5ace203b9fe7b01d5806c00a",
                                                      "_id": "606e351a4b60e26a187dcbc3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab7",
                                                              "_id": "606e351a4b60e26a187dcbc4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d969",
                                                      "_id": "606e351a4b60e26a187dcbc5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equation In Two Variables-2",
                                              "id": "5ace20319fe7b01d5806bc73",
                                              "_id": "606e351a4b60e26a187dcbbc",
                                              "concepts": [
                                                  {
                                                      "name": "graphical solution of simultaneous equations in two variables, method of elimination by substitution, method of elimination by equationg coefficients\n solution of equations of form, method of elimination by comparison, method of cross multiplication",
                                                      "id": "5ace203b9fe7b01d5806c00b",
                                                      "_id": "606e351a4b60e26a187dcbbf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab8",
                                                              "_id": "606e351a4b60e26a187dcbc0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear equation in two variables, Graphs of linear equation, Simultaneous equation in two variables",
                                                      "id": "5ace203b9fe7b01d5806c00c",
                                                      "_id": "606e351a4b60e26a187dcbbd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dab9",
                                                              "_id": "606e351a4b60e26a187dcbbe"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96a",
                                                      "_id": "606e351a4b60e26a187dcbc1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Lines and Angles",
                                              "id": "5ace20319fe7b01d5806bc74",
                                              "_id": "606e351a4b60e26a187dcba6",
                                              "concepts": [
                                                  {
                                                      "name": "Angle Bisector, Vertically Opposite Angles",
                                                      "id": "5ace203b9fe7b01d5806c00d",
                                                      "_id": "606e351a4b60e26a187dcbb9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daba",
                                                              "_id": "606e351a4b60e26a187dcbba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angles, Interior angles, Exterior angle of a Triangle",
                                                      "id": "5ace203b9fe7b01d5806c00e",
                                                      "_id": "606e351a4b60e26a187dcbb7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dabb",
                                                              "_id": "606e351a4b60e26a187dcbb8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transversal & Corresponding Angle Axioms. Parallel lines and Properties",
                                                      "id": "5ace203b9fe7b01d5806c00f",
                                                      "_id": "606e351a4b60e26a187dcbb5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dabc",
                                                              "_id": "606e351a4b60e26a187dcbb6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Angles",
                                                      "id": "5ace203b9fe7b01d5806c010",
                                                      "_id": "606e351a4b60e26a187dcbb3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dabd",
                                                              "_id": "606e351a4b60e26a187dcbb4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Corresponding Angles",
                                                      "id": "5ec64785941e1306742b8431",
                                                      "_id": "606e351a4b60e26a187dcbb1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dabe",
                                                              "_id": "606e351a4b60e26a187dcbb2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Interior Angles on Same Side of Transversal",
                                                      "id": "5ec64785941e1306742b8433",
                                                      "_id": "606e351a4b60e26a187dcbaf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dabf",
                                                              "_id": "606e351a4b60e26a187dcbb0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angles and Their Types",
                                                      "id": "5ec64785941e1306742b842f",
                                                      "_id": "606e351a4b60e26a187dcbad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac0",
                                                              "_id": "606e351a4b60e26a187dcbae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alternate Interior and Exterior Angles",
                                                      "id": "5ec64785941e1306742b8432",
                                                      "_id": "606e351a4b60e26a187dcbab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac1",
                                                              "_id": "606e351a4b60e26a187dcbac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle Sum Property of a Triangle",
                                                      "id": "5ec64785941e1306742b8434",
                                                      "_id": "606e351a4b60e26a187dcba9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac2",
                                                              "_id": "606e351a4b60e26a187dcbaa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Pair of Angles",
                                                      "id": "5ec64785941e1306742b8430",
                                                      "_id": "606e351a4b60e26a187dcba7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac3",
                                                              "_id": "606e351a4b60e26a187dcba8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96b",
                                                      "_id": "606e351a4b60e26a187dcbbb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "NISL",
                                              "id": "5ace20319fe7b01d5806bc75",
                                              "_id": "606e351a4b60e26a187dcb96",
                                              "concepts": [
                                                  {
                                                      "name": "Conjugate of an Irrational Number",
                                                      "id": "5ace203b9fe7b01d5806c011",
                                                      "_id": "606e351a4b60e26a187dcba3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac4",
                                                              "_id": "606e351a4b60e26a187dcba4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Indices",
                                                      "id": "5ace203b9fe7b01d5806c012",
                                                      "_id": "606e351a4b60e26a187dcba1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac5",
                                                              "_id": "606e351a4b60e26a187dcba2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Logarithms- Definition and Properties",
                                                      "id": "5ace203b9fe7b01d5806c013",
                                                      "_id": "606e351a4b60e26a187dcb9f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac6",
                                                              "_id": "606e351a4b60e26a187dcba0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "No. of divisions of a composite number, Sum of divisions of a composite number, Decimal Representation of Rational Numbers, Results on Irrational numbers, Representation of Irrational number on number line, Representation of Real Numbers using Successive ",
                                                      "id": "5ace203b9fe7b01d5806c014",
                                                      "_id": "606e351a4b60e26a187dcb9d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac7",
                                                              "_id": "606e351a4b60e26a187dcb9e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rationalisation of the Denominator",
                                                      "id": "5ace203b9fe7b01d5806c015",
                                                      "_id": "606e351a4b60e26a187dcb9b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac8",
                                                              "_id": "606e351a4b60e26a187dcb9c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Review of Numbers, Conversion of Decimal Numbers to Rational numbers, Irrational numbers",
                                                      "id": "5ace203b9fe7b01d5806c016",
                                                      "_id": "606e351a4b60e26a187dcb99",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dac9",
                                                              "_id": "606e351a4b60e26a187dcb9a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "surds",
                                                      "id": "5ace203b9fe7b01d5806c017",
                                                      "_id": "606e351a4b60e26a187dcb97",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daca",
                                                              "_id": "606e351a4b60e26a187dcb98"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96c",
                                                      "_id": "606e351a4b60e26a187dcba5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials-1",
                                              "id": "5ace20319fe7b01d5806bc76",
                                              "_id": "606e351a4b60e26a187dcb8c",
                                              "concepts": [
                                                  {
                                                      "name": "Definition and Different Types of Polynomial, Algebraic Identities",
                                                      "id": "5ace203b9fe7b01d5806c018",
                                                      "_id": "606e351a4b60e26a187dcb93",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dacb",
                                                              "_id": "606e351a4b60e26a187dcb94"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Degree of Polynomial, Zeroes of a Polynomial",
                                                      "id": "5ace203b9fe7b01d5806c019",
                                                      "_id": "606e351a4b60e26a187dcb91",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dacc",
                                                              "_id": "606e351a4b60e26a187dcb92"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factor Theorem , Remainder Theorem",
                                                      "id": "5ace203b9fe7b01d5806c01a",
                                                      "_id": "606e351a4b60e26a187dcb8f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dacd",
                                                              "_id": "606e351a4b60e26a187dcb90"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorization of Polynomials, Axioms and Postulates, Definitions- Line,Point,Plane etc, Collinear points ,Concurrent Lines, Parallel Lines and Intersecting Lines, Line Segments",
                                                      "id": "5ace203b9fe7b01d5806c01b",
                                                      "_id": "606e351a4b60e26a187dcb8d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dace",
                                                              "_id": "606e351a4b60e26a187dcb8e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96d",
                                                      "_id": "606e351a4b60e26a187dcb95"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials-2",
                                              "id": "5ace20319fe7b01d5806bc77",
                                              "_id": "606e351a4b60e26a187dcb86",
                                              "concepts": [
                                                  {
                                                      "name": "Geometrical Meaning of the Zeroes of a Polynomials",
                                                      "id": "5ace203b9fe7b01d5806c01c",
                                                      "_id": "606e351a4b60e26a187dcb89",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dacf",
                                                              "_id": "606e351a4b60e26a187dcb8a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nature of Zeros of a Polynomial",
                                                      "id": "5ace203b9fe7b01d5806c01d",
                                                      "_id": "606e351a4b60e26a187dcb87",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad0",
                                                              "_id": "606e351a4b60e26a187dcb88"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96e",
                                                      "_id": "606e351a4b60e26a187dcb8b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability-1",
                                              "id": "5ace20319fe7b01d5806bc78",
                                              "_id": "606e351a4b60e26a187dcb7e",
                                              "concepts": [
                                                  {
                                                      "name": "Definition of Probability",
                                                      "id": "5ace203b9fe7b01d5806c01e",
                                                      "_id": "606e351a4b60e26a187dcb83",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad1",
                                                              "_id": "606e351a4b60e26a187dcb84"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on coins",
                                                      "id": "5ace203b9fe7b01d5806c01f",
                                                      "_id": "606e351a4b60e26a187dcb81",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad2",
                                                              "_id": "606e351a4b60e26a187dcb82"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on dice",
                                                      "id": "5ace203b9fe7b01d5806c020",
                                                      "_id": "606e351a4b60e26a187dcb7f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad3",
                                                              "_id": "606e351a4b60e26a187dcb80"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d96f",
                                                      "_id": "606e351a4b60e26a187dcb85"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability-2",
                                              "id": "5ace20319fe7b01d5806bc79",
                                              "_id": "606e351a4b60e26a187dcb76",
                                              "concepts": [
                                                  {
                                                      "name": "Experimental or emperical approch to probability, Definitions of trial, Event, Compound event, Occurrence of an event, Emperical Probability Definition and problems related to it",
                                                      "id": "5ace203b9fe7b01d5806c021",
                                                      "_id": "606e351a4b60e26a187dcb7b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad4",
                                                              "_id": "606e351a4b60e26a187dcb7c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Principles of Addition and Multiplication",
                                                      "id": "5ace203b9fe7b01d5806c022",
                                                      "_id": "606e351a4b60e26a187dcb79",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad5",
                                                              "_id": "606e351a4b60e26a187dcb7a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sure event, Impossible event, Complement of an event",
                                                      "id": "5ace203b9fe7b01d5806c023",
                                                      "_id": "606e351a4b60e26a187dcb77",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad6",
                                                              "_id": "606e351a4b60e26a187dcb78"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d970",
                                                      "_id": "606e351a4b60e26a187dcb7d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadratic Equations",
                                              "id": "5ace20319fe7b01d5806bc7a",
                                              "_id": "606e351a4b60e26a187dcb6c",
                                              "concepts": [
                                                  {
                                                      "name": "Discriminant based questions",
                                                      "id": "5ace203c9fe7b01d5806c024",
                                                      "_id": "606e351a4b60e26a187dcb73",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad7",
                                                              "_id": "606e351a4b60e26a187dcb74"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nature of roots",
                                                      "id": "5ace203c9fe7b01d5806c025",
                                                      "_id": "606e351a4b60e26a187dcb71",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad8",
                                                              "_id": "606e351a4b60e26a187dcb72"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic polynomials, Solution of Quadratic equations by method of factorisation, solution of quadratic equations by method of completion of squares",
                                                      "id": "5ace203c9fe7b01d5806c026",
                                                      "_id": "606e351a4b60e26a187dcb6f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dad9",
                                                              "_id": "606e351a4b60e26a187dcb70"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between roots and coeffficients of Quadratic",
                                                      "id": "5ace203c9fe7b01d5806c027",
                                                      "_id": "606e351a4b60e26a187dcb6d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dada",
                                                              "_id": "606e351a4b60e26a187dcb6e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d971",
                                                      "_id": "606e351a4b60e26a187dcb75"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadrilateral",
                                              "id": "5ace20319fe7b01d5806bc7b",
                                              "_id": "606e351a4b60e26a187dcb62",
                                              "concepts": [
                                                  {
                                                      "name": "Angle sum property of quadrilateral, Various types of quadrilateral",
                                                      "id": "5ace203c9fe7b01d5806c028",
                                                      "_id": "606e351a4b60e26a187dcb69",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dadb",
                                                              "_id": "606e351a4b60e26a187dcb6a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid - Point Theorem & it's Converse",
                                                      "id": "5ace203c9fe7b01d5806c029",
                                                      "_id": "606e351a4b60e26a187dcb67",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dadc",
                                                              "_id": "606e351a4b60e26a187dcb68"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prop. of Rectangle, Rhombus and Square",
                                                      "id": "5ace203c9fe7b01d5806c02a",
                                                      "_id": "606e351a4b60e26a187dcb65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dadd",
                                                              "_id": "606e351a4b60e26a187dcb66"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of a parallelogram, Sufficient condition for quadrilateral to be a Parallelogram",
                                                      "id": "5ace203c9fe7b01d5806c02b",
                                                      "_id": "606e351a4b60e26a187dcb63",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dade",
                                                              "_id": "606e351a4b60e26a187dcb64"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d972",
                                                      "_id": "606e351a4b60e26a187dcb6b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Real Numbers",
                                              "id": "5ace20319fe7b01d5806bc7c",
                                              "_id": "606e351a4b60e26a187dcb5c",
                                              "concepts": [
                                                  {
                                                      "name": "Euclid's Division Method, Fundamental Theorm of Arithmetic",
                                                      "id": "5ace203c9fe7b01d5806c02c",
                                                      "_id": "606e351a4b60e26a187dcb5f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dadf",
                                                              "_id": "606e351a4b60e26a187dcb60"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Results-Irrationality of sqrt of 2, 3, 5, Decimal Expansions of Rational Numbers in Terms of Terminating / Non-Terminating",
                                                      "id": "5ace203c9fe7b01d5806c02d",
                                                      "_id": "606e351a4b60e26a187dcb5d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae0",
                                                              "_id": "606e351a4b60e26a187dcb5e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d973",
                                                      "_id": "606e351a4b60e26a187dcb61"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Similar Triangles",
                                              "id": "5ace20319fe7b01d5806bc7d",
                                              "_id": "606e351a4b60e26a187dcb54",
                                              "concepts": [
                                                  {
                                                      "name": "Basic proportionality theorem and converse, AAA similarity criterion, Sss similarity criterion, SAS similarity criterion, Area of two similar triangles",
                                                      "id": "5ace203c9fe7b01d5806c02e",
                                                      "_id": "606e351a4b60e26a187dcb59",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae1",
                                                              "_id": "606e351a4b60e26a187dcb5a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of two similar triangles, Converse of Pythagoras theorem",
                                                      "id": "5ace203c9fe7b01d5806c02f",
                                                      "_id": "606e351a4b60e26a187dcb57",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae2",
                                                              "_id": "606e351a4b60e26a187dcb58"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pythagoras theorem, Vertical angle base for theorem",
                                                      "id": "5ace203c9fe7b01d5806c030",
                                                      "_id": "606e351a4b60e26a187dcb55",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae3",
                                                              "_id": "606e351a4b60e26a187dcb56"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d974",
                                                      "_id": "606e351a4b60e26a187dcb5b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics-1",
                                              "id": "5ace20319fe7b01d5806bc7e",
                                              "_id": "606e351a4b60e26a187dcb40",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of different kind of Histograms",
                                                      "id": "5ace203c9fe7b01d5806c031",
                                                      "_id": "606e351a4b60e26a187dcb51",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae4",
                                                              "_id": "606e351a4b60e26a187dcb52"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of Discrete , Grouped Frequency Distributions",
                                                      "id": "5ace203c9fe7b01d5806c032",
                                                      "_id": "606e351a4b60e26a187dcb4f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae5",
                                                              "_id": "606e351a4b60e26a187dcb50"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cumulative Frequency Distributions",
                                                      "id": "5ace203c9fe7b01d5806c033",
                                                      "_id": "606e351a4b60e26a187dcb4d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae6",
                                                              "_id": "606e351a4b60e26a187dcb4e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exclusive, Inclusive method",
                                                      "id": "5ace203c9fe7b01d5806c034",
                                                      "_id": "606e351a4b60e26a187dcb4b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae7",
                                                              "_id": "606e351a4b60e26a187dcb4c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Distributions ( Discrete and Continous )",
                                                      "id": "5ace203c9fe7b01d5806c035",
                                                      "_id": "606e351a4b60e26a187dcb49",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae8",
                                                              "_id": "606e351a4b60e26a187dcb4a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Polygon",
                                                      "id": "5ace203c9fe7b01d5806c036",
                                                      "_id": "606e351a4b60e26a187dcb47",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dae9",
                                                              "_id": "606e351a4b60e26a187dcb48"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Represantion of Statistical Data ( Bar graph, Histogram )",
                                                      "id": "5ace203c9fe7b01d5806c037",
                                                      "_id": "606e351a4b60e26a187dcb45",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daea",
                                                              "_id": "606e351a4b60e26a187dcb46"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measure of Central Tendency",
                                                      "id": "5ace203c9fe7b01d5806c038",
                                                      "_id": "606e351a4b60e26a187dcb43",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daeb",
                                                              "_id": "606e351a4b60e26a187dcb44"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Statistical Data ( Primary, Secondary )",
                                                      "id": "5ace203c9fe7b01d5806c039",
                                                      "_id": "606e351a4b60e26a187dcb41",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daec",
                                                              "_id": "606e351a4b60e26a187dcb42"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d975",
                                                      "_id": "606e351a4b60e26a187dcb53"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics-2",
                                              "id": "5ace20319fe7b01d5806bc7f",
                                              "_id": "606e351a4b60e26a187dcb38",
                                              "concepts": [
                                                  {
                                                      "name": "Empherical formula, Ogive curve, Emperical relation between mean, median, mode",
                                                      "id": "5ace203c9fe7b01d5806c03a",
                                                      "_id": "606e351a4b60e26a187dcb3d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daed",
                                                              "_id": "606e351a4b60e26a187dcb3e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Distribution",
                                                      "id": "5ace203c9fe7b01d5806c03b",
                                                      "_id": "606e351a4b60e26a187dcb3b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daee",
                                                              "_id": "606e351a4b60e26a187dcb3c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean, Median, Mode",
                                                      "id": "5ace203c9fe7b01d5806c03c",
                                                      "_id": "606e351a4b60e26a187dcb39",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daef",
                                                              "_id": "606e351a4b60e26a187dcb3a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d976",
                                                      "_id": "606e351a4b60e26a187dcb3f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Area and Volume - 1",
                                              "id": "5ace20319fe7b01d5806bc80",
                                              "_id": "606e351a4b60e26a187dcb2a",
                                              "concepts": [
                                                  {
                                                      "name": "Curved Surface Area and Total Surface Area of Hollow Cylinder,Hollow Sphere and Hollow Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c03d",
                                                      "_id": "606e351a4b60e26a187dcb35",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf0",
                                                              "_id": "606e351a4b60e26a187dcb36"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Curved Surface Area and Total Surface Area of Right Circular Cylinder,Cone,Sphere and Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c03e",
                                                      "_id": "606e351a4b60e26a187dcb33",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf1",
                                                              "_id": "606e351a4b60e26a187dcb34"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lateral Surface Area and Total Surface Area of Cuboid and Cube, Volume of a Cuboid and Cube",
                                                      "id": "5ace203c9fe7b01d5806c03f",
                                                      "_id": "606e351a4b60e26a187dcb31",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf2",
                                                              "_id": "606e351a4b60e26a187dcb32"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Cuboid and Cube",
                                                      "id": "5ace203c9fe7b01d5806c040",
                                                      "_id": "606e351a4b60e26a187dcb2f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf3",
                                                              "_id": "606e351a4b60e26a187dcb30"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Cylinder,Cone,Sphere and Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c041",
                                                      "_id": "606e351a4b60e26a187dcb2d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf4",
                                                              "_id": "606e351a4b60e26a187dcb2e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Hollow cylinder,Hollow sphere and Hollow hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c042",
                                                      "_id": "606e351a4b60e26a187dcb2b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf5",
                                                              "_id": "606e351a4b60e26a187dcb2c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d977",
                                                      "_id": "606e351a4b60e26a187dcb37"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Area and Volume - 2",
                                              "id": "5ace20319fe7b01d5806bc81",
                                              "_id": "606e351a4b60e26a187dcb16",
                                              "concepts": [
                                                  {
                                                      "name": "Combination of Solids",
                                                      "id": "5ace203c9fe7b01d5806c043",
                                                      "_id": "606e351a4b60e26a187dcb27",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf6",
                                                              "_id": "606e351a4b60e26a187dcb28"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion of a solid into another",
                                                      "id": "5ace203c9fe7b01d5806c044",
                                                      "_id": "606e351a4b60e26a187dcb25",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf7",
                                                              "_id": "606e351a4b60e26a187dcb26"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cube",
                                                      "id": "5ace203c9fe7b01d5806c045",
                                                      "_id": "606e351a4b60e26a187dcb23",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf8",
                                                              "_id": "606e351a4b60e26a187dcb24"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cuboid",
                                                      "id": "5ace203c9fe7b01d5806c046",
                                                      "_id": "606e351a4b60e26a187dcb21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daf9",
                                                              "_id": "606e351a4b60e26a187dcb22"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frustum of a Right Circular Cone",
                                                      "id": "5ace203c9fe7b01d5806c047",
                                                      "_id": "606e351a4b60e26a187dcb1f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dafa",
                                                              "_id": "606e351a4b60e26a187dcb20"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Circular Cone",
                                                      "id": "5ace203c9fe7b01d5806c048",
                                                      "_id": "606e351a4b60e26a187dcb1d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dafb",
                                                              "_id": "606e351a4b60e26a187dcb1e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Circular Cylinder",
                                                      "id": "5ace203c9fe7b01d5806c049",
                                                      "_id": "606e351a4b60e26a187dcb1b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dafc",
                                                              "_id": "606e351a4b60e26a187dcb1c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Prism & Right Prism",
                                                      "id": "5ace203c9fe7b01d5806c04a",
                                                      "_id": "606e351a4b60e26a187dcb19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dafd",
                                                              "_id": "606e351a4b60e26a187dcb1a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sphere, Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c04b",
                                                      "_id": "606e351a4b60e26a187dcb17",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673dafe",
                                                              "_id": "606e351a4b60e26a187dcb18"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d978",
                                                      "_id": "606e351a4b60e26a187dcb29"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Tangents to a Circle",
                                              "id": "5ace20319fe7b01d5806bc82",
                                              "_id": "606e351a4b60e26a187dcb0e",
                                              "concepts": [
                                                  {
                                                      "name": "Central angle and arcs, Congruence of circles and arcs, Angles subtended by arcs and chords at points on the circle",
                                                      "id": "5ace203c9fe7b01d5806c04c",
                                                      "_id": "606e351a4b60e26a187dcb13",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673daff",
                                                              "_id": "606e351a4b60e26a187dcb14"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of chords, Alternate segment, Two circles in a plane, Common tangent",
                                                      "id": "5ace203c9fe7b01d5806c04d",
                                                      "_id": "606e351a4b60e26a187dcb11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db00",
                                                              "_id": "606e351a4b60e26a187dcb12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Tangents to a circle from a point, Properties of tangents",
                                                      "id": "5ace203c9fe7b01d5806c04e",
                                                      "_id": "606e351a4b60e26a187dcb0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db01",
                                                              "_id": "606e351a4b60e26a187dcb10"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d979",
                                                      "_id": "606e351a4b60e26a187dcb15"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Triangles",
                                              "id": "5ace20319fe7b01d5806bc83",
                                              "_id": "606e351a4b60e26a187dcaf8",
                                              "concepts": [
                                                  {
                                                      "name": "Congruence of a triangles, Criterion for the Congruence of two triangles",
                                                      "id": "5ace203c9fe7b01d5806c04f",
                                                      "_id": "606e351a4b60e26a187dcb0b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db02",
                                                              "_id": "606e351a4b60e26a187dcb0c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inequality relations in a triangle, Important lines of a triangle (median, perpendicular bisector, angle bisector, altitude",
                                                      "id": "5ace203c9fe7b01d5806c050",
                                                      "_id": "606e351a4b60e26a187dcb09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db03",
                                                              "_id": "606e351a4b60e26a187dcb0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Triangles, Angle Sum Property of Triangle, Exterior Angle Theorem",
                                                      "id": "5ace203c9fe7b01d5806c051",
                                                      "_id": "606e351a4b60e26a187dcb07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db04",
                                                              "_id": "606e351a4b60e26a187dcb08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "ASA Congruence Rule",
                                                      "id": "5ec64785941e1306742b8437",
                                                      "_id": "606e351a4b60e26a187dcb05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db05",
                                                              "_id": "606e351a4b60e26a187dcb06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inequalities in a Triangle",
                                                      "id": "5ec64785941e1306742b843b",
                                                      "_id": "606e351a4b60e26a187dcb03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db06",
                                                              "_id": "606e351a4b60e26a187dcb04"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "AAS Congruence Rule",
                                                      "id": "5ec64785941e1306742b8438",
                                                      "_id": "606e351a4b60e26a187dcb01",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db07",
                                                              "_id": "606e351a4b60e26a187dcb02"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "SSS Congruence Rule",
                                                      "id": "5ec64785941e1306742b8439",
                                                      "_id": "606e351a4b60e26a187dcaff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db08",
                                                              "_id": "606e351a4b60e26a187dcb00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Congruence of Triangles",
                                                      "id": "5ec64785941e1306742b8435",
                                                      "_id": "606e351a4b60e26a187dcafd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db09",
                                                              "_id": "606e351a4b60e26a187dcafe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "RHS Congruence Rule",
                                                      "id": "5ec64785941e1306742b843a",
                                                      "_id": "606e351a4b60e26a187dcafb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0a",
                                                              "_id": "606e351a4b60e26a187dcafc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "SAS Congruence Rule",
                                                      "id": "5ec64785941e1306742b8436",
                                                      "_id": "606e351a4b60e26a187dcaf9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0b",
                                                              "_id": "606e351a4b60e26a187dcafa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97a",
                                                      "_id": "606e351a4b60e26a187dcb0d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc84",
                                              "_id": "606e351a4b60e26a187dcace",
                                              "concepts": [
                                                  {
                                                      "name": "Compound angles",
                                                      "id": "5ace203c9fe7b01d5806c052",
                                                      "_id": "606e351a4b60e26a187dcaf5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0c",
                                                              "_id": "606e351a4b60e26a187dcaf6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain & range of Trigonometric ratios",
                                                      "id": "5ace203c9fe7b01d5806c053",
                                                      "_id": "606e351a4b60e26a187dcaf3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0d",
                                                              "_id": "606e351a4b60e26a187dcaf4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental identities, Sign of Trigonometric ratios",
                                                      "id": "5ace203c9fe7b01d5806c054",
                                                      "_id": "606e351a4b60e26a187dcaf1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0e",
                                                              "_id": "606e351a4b60e26a187dcaf2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph of trignomety(periodicity) ratio",
                                                      "id": "5ace203c9fe7b01d5806c055",
                                                      "_id": "606e351a4b60e26a187dcaef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db0f",
                                                              "_id": "606e351a4b60e26a187dcaf0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest & Least values of Trigonometric Expressions",
                                                      "id": "5ace203c9fe7b01d5806c056",
                                                      "_id": "606e351a4b60e26a187dcaed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db10",
                                                              "_id": "606e351a4b60e26a187dcaee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c058",
                                                      "_id": "606e351a4b60e26a187dcaeb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db11",
                                                              "_id": "606e351a4b60e26a187dcaec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of triangle",
                                                      "id": "5ace203c9fe7b01d5806c059",
                                                      "_id": "606e351a4b60e26a187dcae9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db12",
                                                              "_id": "606e351a4b60e26a187dcaea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between different systems of Measurement of Angles",
                                                      "id": "5ace203c9fe7b01d5806c05a",
                                                      "_id": "606e351a4b60e26a187dcae7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db13",
                                                              "_id": "606e351a4b60e26a187dcae8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sub-multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c05b",
                                                      "_id": "606e351a4b60e26a187dcae5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db14",
                                                              "_id": "606e351a4b60e26a187dcae6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum and product formulae",
                                                      "id": "5ace203c9fe7b01d5806c05c",
                                                      "_id": "606e351a4b60e26a187dcae3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db15",
                                                              "_id": "606e351a4b60e26a187dcae4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation",
                                                      "id": "5ace203c9fe7b01d5806c05d",
                                                      "_id": "606e351a4b60e26a187dcae1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db16",
                                                              "_id": "606e351a4b60e26a187dcae2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation Formula - Product into Sum or Difference",
                                                      "id": "5ace203c9fe7b01d5806c05e",
                                                      "_id": "606e351a4b60e26a187dcadf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db17",
                                                              "_id": "606e351a4b60e26a187dcae0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation Formula - Sum and Difference into Poduct",
                                                      "id": "5ace203c9fe7b01d5806c05f",
                                                      "_id": "606e351a4b60e26a187dcadd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db18",
                                                              "_id": "606e351a4b60e26a187dcade"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric equations",
                                                      "id": "5ace203c9fe7b01d5806c060",
                                                      "_id": "606e351a4b60e26a187dcadb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db19",
                                                              "_id": "606e351a4b60e26a187dcadc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric inequations",
                                                      "id": "5ace203c9fe7b01d5806c061",
                                                      "_id": "606e351a4b60e26a187dcad9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1a",
                                                              "_id": "606e351a4b60e26a187dcada"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5ace203c9fe7b01d5806c063",
                                                      "_id": "606e351a4b60e26a187dcad7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1b",
                                                              "_id": "606e351a4b60e26a187dcad8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                      "id": "5ace203c9fe7b01d5806c064",
                                                      "_id": "606e351a4b60e26a187dcad5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1c",
                                                              "_id": "606e351a4b60e26a187dcad6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Complementary Angles",
                                                      "id": "5ace203c9fe7b01d5806c065",
                                                      "_id": "606e351a4b60e26a187dcad3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1d",
                                                              "_id": "606e351a4b60e26a187dcad4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of multiple angles, Trigonometric Ratios of sub-multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c066",
                                                      "_id": "606e351a4b60e26a187dcad1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1e",
                                                              "_id": "606e351a4b60e26a187dcad2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Sum & Difference of two angles",
                                                      "id": "5ace203c9fe7b01d5806c067",
                                                      "_id": "606e351a4b60e26a187dcacf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db1f",
                                                              "_id": "606e351a4b60e26a187dcad0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97b",
                                                      "_id": "606e351a4b60e26a187dcaf7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equations in Two Variables",
                                              "id": "5ec644a012a5e80679ddd546",
                                              "_id": "606e351a4b60e26a187dcac2",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Equations",
                                                      "id": "5ec64785941e1306742b8428",
                                                      "_id": "606e351a4b60e26a187dcacb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db20",
                                                              "_id": "606e351a4b60e26a187dcacc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations of Lines Parallel to the X-axis and Y-axis",
                                                      "id": "5ec64785941e1306742b842c",
                                                      "_id": "606e351a4b60e26a187dcac9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db21",
                                                              "_id": "606e351a4b60e26a187dcaca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph of Linear Equation in Two Variables",
                                                      "id": "5ec64785941e1306742b842a",
                                                      "_id": "606e351a4b60e26a187dcac7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db22",
                                                              "_id": "606e351a4b60e26a187dcac8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Life Applications ",
                                                      "id": "5ec64785941e1306742b842b",
                                                      "_id": "606e351a4b60e26a187dcac5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db23",
                                                              "_id": "606e351a4b60e26a187dcac6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of a Linear Equation",
                                                      "id": "5ec64785941e1306742b8429",
                                                      "_id": "606e351a4b60e26a187dcac3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db24",
                                                              "_id": "606e351a4b60e26a187dcac4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97c",
                                                      "_id": "606e351a4b60e26a187dcacd"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5ec644a012a5e80679ddd54b",
                                              "_id": "606e351a4b60e26a187dcab2",
                                              "concepts": [
                                                  {
                                                      "name": "Median of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b845a",
                                                      "_id": "606e351a4b60e26a187dcabf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db25",
                                                              "_id": "606e351a4b60e26a187dcac0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation of Data: Frequency Distribution Table",
                                                      "id": "5ec64785941e1306742b8455",
                                                      "_id": "606e351a4b60e26a187dcabd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db26",
                                                              "_id": "606e351a4b60e26a187dcabe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mode of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b845b",
                                                      "_id": "606e351a4b60e26a187dcabb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db27",
                                                              "_id": "606e351a4b60e26a187dcabc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Histograms",
                                                      "id": "5ec64785941e1306742b8457",
                                                      "_id": "606e351a4b60e26a187dcab9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db28",
                                                              "_id": "606e351a4b60e26a187dcaba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Polygons",
                                                      "id": "5ec64785941e1306742b8458",
                                                      "_id": "606e351a4b60e26a187dcab7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db29",
                                                              "_id": "606e351a4b60e26a187dcab8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b8459",
                                                      "_id": "606e351a4b60e26a187dcab5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2a",
                                                              "_id": "606e351a4b60e26a187dcab6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bar Graphs",
                                                      "id": "5ec64785941e1306742b8456",
                                                      "_id": "606e351a4b60e26a187dcab3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2b",
                                                              "_id": "606e351a4b60e26a187dcab4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97d",
                                                      "_id": "606e351a4b60e26a187dcac1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Number System",
                                              "id": "5ec644a012a5e80679ddd543",
                                              "_id": "606e351a4b60e26a187dcaa6",
                                              "concepts": [
                                                  {
                                                      "name": "Operations on Real Numbers",
                                                      "id": "5ec64785941e1306742b841e",
                                                      "_id": "606e351a4b60e26a187dcaaf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2c",
                                                              "_id": "606e351a4b60e26a187dcab0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Decimal Expansion of Real Numbers",
                                                      "id": "5ec64785941e1306742b841d",
                                                      "_id": "606e351a4b60e26a187dcaad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2d",
                                                              "_id": "606e351a4b60e26a187dcaae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Laws of Exponents for Real Numbers",
                                                      "id": "5ec64785941e1306742b841f",
                                                      "_id": "606e351a4b60e26a187dcaab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2e",
                                                              "_id": "606e351a4b60e26a187dcaac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Numbers",
                                                      "id": "5ec64785941e1306742b841b",
                                                      "_id": "606e351a4b60e26a187dcaa9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2f",
                                                              "_id": "606e351a4b60e26a187dcaaa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Irrational Numbers",
                                                      "id": "5ec64785941e1306742b841c",
                                                      "_id": "606e351a4b60e26a187dcaa7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db30",
                                                              "_id": "606e351a4b60e26a187dcaa8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97e",
                                                      "_id": "606e351a4b60e26a187dcab1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadrilaterals",
                                              "id": "5ec644a012a5e80679ddd548",
                                              "_id": "606e351a4b60e26a187dca9c",
                                              "concepts": [
                                                  {
                                                      "name": "Types of Quadrilaterals and Angle Sum Property",
                                                      "id": "5ec64785941e1306742b843c",
                                                      "_id": "606e351a4b60e26a187dcaa3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db31",
                                                              "_id": "606e351a4b60e26a187dcaa4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditions for a Quadrilateral to be a Parallelogram",
                                                      "id": "5ec64785941e1306742b843e",
                                                      "_id": "606e351a4b60e26a187dcaa1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db32",
                                                              "_id": "606e351a4b60e26a187dcaa2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid-Point Theorem",
                                                      "id": "5ec64785941e1306742b843f",
                                                      "_id": "606e351a4b60e26a187dca9f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db33",
                                                              "_id": "606e351a4b60e26a187dcaa0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Parallelogram",
                                                      "id": "5ec64785941e1306742b843d",
                                                      "_id": "606e351a4b60e26a187dca9d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db34",
                                                              "_id": "606e351a4b60e26a187dca9e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97f",
                                                      "_id": "606e351a4b60e26a187dcaa5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction To Euclid's Geometry",
                                              "id": "5ec644a012a5e80679ddd547",
                                              "_id": "606e351a4b60e26a187dca96",
                                              "concepts": [
                                                  {
                                                      "name": "Euclid's Definition and Axioms",
                                                      "id": "5ec64785941e1306742b842d",
                                                      "_id": "606e351a4b60e26a187dca99",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db35",
                                                              "_id": "606e351a4b60e26a187dca9a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid's Postulates",
                                                      "id": "5ec64785941e1306742b842e",
                                                      "_id": "606e351a4b60e26a187dca97",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db36",
                                                              "_id": "606e351a4b60e26a187dca98"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d980",
                                                      "_id": "606e351a4b60e26a187dca9b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ec644a012a5e80679ddd54c",
                                              "_id": "606e351a4b60e26a187dca90",
                                              "concepts": [
                                                  {
                                                      "name": "Probability-Experimental Approach",
                                                      "id": "5ec64785941e1306742b845c",
                                                      "_id": "606e351a4b60e26a187dca93",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db37",
                                                              "_id": "606e351a4b60e26a187dca94"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of an Event",
                                                      "id": "5ec64785941e1306742b845d",
                                                      "_id": "606e351a4b60e26a187dca91",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db38",
                                                              "_id": "606e351a4b60e26a187dca92"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d981",
                                                      "_id": "606e351a4b60e26a187dca95"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials",
                                              "id": "5ec644a012a5e80679ddd544",
                                              "_id": "606e351a4b60e26a187dca82",
                                              "concepts": [
                                                  {
                                                      "name": "Factorisation of Polynomials",
                                                      "id": "5ec64785941e1306742b8423",
                                                      "_id": "606e351a4b60e26a187dca8d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db39",
                                                              "_id": "606e351a4b60e26a187dca8e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities - I",
                                                      "id": "5ec64785941e1306742b8424",
                                                      "_id": "606e351a4b60e26a187dca8b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3a",
                                                              "_id": "606e351a4b60e26a187dca8c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials in One Variable",
                                                      "id": "5ec64785941e1306742b8420",
                                                      "_id": "606e351a4b60e26a187dca89",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3b",
                                                              "_id": "606e351a4b60e26a187dca8a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities - II",
                                                      "id": "5ec64785941e1306742b8425",
                                                      "_id": "606e351a4b60e26a187dca87",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3c",
                                                              "_id": "606e351a4b60e26a187dca88"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder Theorem",
                                                      "id": "5ec64785941e1306742b8422",
                                                      "_id": "606e351a4b60e26a187dca85",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3d",
                                                              "_id": "606e351a4b60e26a187dca86"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Zeros of a Polynomial",
                                                      "id": "5ec64785941e1306742b8421",
                                                      "_id": "606e351a4b60e26a187dca83",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3e",
                                                              "_id": "606e351a4b60e26a187dca84"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d982",
                                                      "_id": "606e351a4b60e26a187dca8f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions",
                                              "id": "5ec644a012a5e80679ddd549",
                                              "_id": "606e351a4b60e26a187dca78",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of a Triangle Given its Perimeter and Its Two Base Angles",
                                                      "id": "5ec64785941e1306742b844a",
                                                      "_id": "606e351a4b60e26a187dca7f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3f",
                                                              "_id": "606e351a4b60e26a187dca80"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Constructions",
                                                      "id": "5ec64785941e1306742b8447",
                                                      "_id": "606e351a4b60e26a187dca7d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db40",
                                                              "_id": "606e351a4b60e26a187dca7e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Given Its Base, a Base Angle and Sum of Other Two Sides",
                                                      "id": "5ec64785941e1306742b8448",
                                                      "_id": "606e351a4b60e26a187dca7b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db41",
                                                              "_id": "606e351a4b60e26a187dca7c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Given Its Base, a Base Angle and Difference of Other Two Sides",
                                                      "id": "5ec64785941e1306742b8449",
                                                      "_id": "606e351a4b60e26a187dca79",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db42",
                                                              "_id": "606e351a4b60e26a187dca7a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d983",
                                                      "_id": "606e351a4b60e26a187dca81"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5ec644a012a5e80679ddd545",
                                              "_id": "606e351a4b60e26a187dca72",
                                              "concepts": [
                                                  {
                                                      "name": "Plotting of Points in Cartesian Plane",
                                                      "id": "5ec64785941e1306742b8427",
                                                      "_id": "606e351a4b60e26a187dca75",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db43",
                                                              "_id": "606e351a4b60e26a187dca76"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cartesian Plane",
                                                      "id": "5ec64785941e1306742b8426",
                                                      "_id": "606e351a4b60e26a187dca73",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db44",
                                                              "_id": "606e351a4b60e26a187dca74"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d984",
                                                      "_id": "606e351a4b60e26a187dca77"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Areas and Volumes",
                                              "id": "5ec644a012a5e80679ddd54a",
                                              "_id": "606e351a4b60e26a187dca60",
                                              "concepts": [
                                                  {
                                                      "name": "Surface Area of Sphere and Hemisphere",
                                                      "id": "5ec64785941e1306742b8450",
                                                      "_id": "606e351a4b60e26a187dca6f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db45",
                                                              "_id": "606e351a4b60e26a187dca70"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Sphere and Hemisphere",
                                                      "id": "5ec64785941e1306742b8454",
                                                      "_id": "606e351a4b60e26a187dca6d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db46",
                                                              "_id": "606e351a4b60e26a187dca6e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Right Circular Cone",
                                                      "id": "5ec64785941e1306742b844f",
                                                      "_id": "606e351a4b60e26a187dca6b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db47",
                                                              "_id": "606e351a4b60e26a187dca6c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Cuboid and Cube",
                                                      "id": "5ec64785941e1306742b8451",
                                                      "_id": "606e351a4b60e26a187dca69",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db48",
                                                              "_id": "606e351a4b60e26a187dca6a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Right Circular Cylinder",
                                                      "id": "5ec64785941e1306742b8452",
                                                      "_id": "606e351a4b60e26a187dca67",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db49",
                                                              "_id": "606e351a4b60e26a187dca68"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Right Circular Cylinder",
                                                      "id": "5ec64785941e1306742b844e",
                                                      "_id": "606e351a4b60e26a187dca65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4a",
                                                              "_id": "606e351a4b60e26a187dca66"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Cuboid and Cube",
                                                      "id": "5ec64785941e1306742b844d",
                                                      "_id": "606e351a4b60e26a187dca63",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4b",
                                                              "_id": "606e351a4b60e26a187dca64"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Right Circular Cone",
                                                      "id": "5ec64785941e1306742b8453",
                                                      "_id": "606e351a4b60e26a187dca61",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4c",
                                                              "_id": "606e351a4b60e26a187dca62"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d985",
                                                      "_id": "606e351a4b60e26a187dca71"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Numbers And Sequences",
                                              "id": "5f68726f058075680d815e26",
                                              "_id": "606e351a4b60e26a187dca5e",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d986",
                                                      "_id": "606e351a4b60e26a187dca5f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f68726f058075680d815e29",
                                              "_id": "606e351a4b60e26a187dca5c",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d987",
                                                      "_id": "606e351a4b60e26a187dca5d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mensuration",
                                              "id": "5f68726f058075680d815e2b",
                                              "_id": "606e351a4b60e26a187dca5a",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d988",
                                                      "_id": "606e351a4b60e26a187dca5b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d91f",
                                              "_id": "606e351a4b60e26a187dcdd0"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Current Electricity",
                                              "id": "5ace20329fe7b01d5806bc9b",
                                              "_id": "606e351a4b60e26a187dca45",
                                              "concepts": [
                                                  {
                                                      "name": "cell and cell combination",
                                                      "id": "5ace203e9fe7b01d5806c0f3",
                                                      "_id": "606e351a4b60e26a187dca56",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd91",
                                                              "_id": "606e351a4b60e26a187dca57"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Current and voltage measuring instruments",
                                                      "id": "5ace203e9fe7b01d5806c0f4",
                                                      "_id": "606e351a4b60e26a187dca54",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd92",
                                                              "_id": "606e351a4b60e26a187dca55"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "drift velocity, electric current in conductors and current density",
                                                      "id": "5ace203e9fe7b01d5806c0f5",
                                                      "_id": "606e351a4b60e26a187dca52",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd93",
                                                              "_id": "606e351a4b60e26a187dca53"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Effective resistances in networks",
                                                      "id": "5ace203e9fe7b01d5806c0f6",
                                                      "_id": "606e351a4b60e26a187dca50",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd94",
                                                              "_id": "606e351a4b60e26a187dca51"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heating effect of current, maximum power transfer theorem",
                                                      "id": "5ace203e9fe7b01d5806c0f7",
                                                      "_id": "606e351a4b60e26a187dca4e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd95",
                                                              "_id": "606e351a4b60e26a187dca4f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kirchoff's laws and circuit problems (without capacitor)",
                                                      "id": "5ace203e9fe7b01d5806c0f8",
                                                      "_id": "606e351a4b60e26a187dca4c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd96",
                                                              "_id": "606e351a4b60e26a187dca4d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ohm's Law, Resistance and its properties",
                                                      "id": "5ace203e9fe7b01d5806c0f9",
                                                      "_id": "606e351a4b60e26a187dca4a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd97",
                                                              "_id": "606e351a4b60e26a187dca4b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "R-C circuits",
                                                      "id": "5ace203e9fe7b01d5806c0fa",
                                                      "_id": "606e351a4b60e26a187dca48",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd98",
                                                              "_id": "606e351a4b60e26a187dca49"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wheatstone bridge and its applications",
                                                      "id": "5ace203e9fe7b01d5806c0fb",
                                                      "_id": "606e351a4b60e26a187dca46",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd99",
                                                              "_id": "606e351a4b60e26a187dca47"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5b",
                                                      "_id": "606e351a4b60e26a187dca58"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electrostatistics",
                                              "id": "5ace20329fe7b01d5806bc9c",
                                              "_id": "606e351a4b60e26a187dca25",
                                              "concepts": [
                                                  {
                                                      "name": "Capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c0fc",
                                                      "_id": "606e351a4b60e26a187dca42",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9a",
                                                              "_id": "606e351a4b60e26a187dca43"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors and conductors",
                                                      "id": "5ace203e9fe7b01d5806c0fd",
                                                      "_id": "606e351a4b60e26a187dca40",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9b",
                                                              "_id": "606e351a4b60e26a187dca41"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Charge distribution and energy conservation in capacitance circuits",
                                                      "id": "5ace203e9fe7b01d5806c0fe",
                                                      "_id": "606e351a4b60e26a187dca3e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9c",
                                                              "_id": "606e351a4b60e26a187dca3f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb's law & properties of charge",
                                                      "id": "5ace203e9fe7b01d5806c0ff",
                                                      "_id": "606e351a4b60e26a187dca3c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9d",
                                                              "_id": "606e351a4b60e26a187dca3d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dielectrics and forces on dielectrics",
                                                      "id": "5ace203e9fe7b01d5806c100",
                                                      "_id": "606e351a4b60e26a187dca3a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9e",
                                                              "_id": "606e351a4b60e26a187dca3b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "effect of electric field on a dipole",
                                                      "id": "5ace203e9fe7b01d5806c101",
                                                      "_id": "606e351a4b60e26a187dca38",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9f",
                                                              "_id": "606e351a4b60e26a187dca39"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Effective capacitances in various networks (Series,Parallel..etc)",
                                                      "id": "5ace203e9fe7b01d5806c102",
                                                      "_id": "606e351a4b60e26a187dca36",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda0",
                                                              "_id": "606e351a4b60e26a187dca37"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric field lines and its representation",
                                                      "id": "5ace203e9fe7b01d5806c103",
                                                      "_id": "606e351a4b60e26a187dca34",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda1",
                                                              "_id": "606e351a4b60e26a187dca35"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric flux",
                                                      "id": "5ace203e9fe7b01d5806c104",
                                                      "_id": "606e351a4b60e26a187dca32",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda2",
                                                              "_id": "606e351a4b60e26a187dca33"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic field & potential energy, eqipotential surface",
                                                      "id": "5ace203e9fe7b01d5806c105",
                                                      "_id": "606e351a4b60e26a187dca30",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda3",
                                                              "_id": "606e351a4b60e26a187dca31"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic potential energy & self energy",
                                                      "id": "5ace203e9fe7b01d5806c106",
                                                      "_id": "606e351a4b60e26a187dca2e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda4",
                                                              "_id": "606e351a4b60e26a187dca2f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "field and potential due to a dipole",
                                                      "id": "5ace203e9fe7b01d5806c107",
                                                      "_id": "606e351a4b60e26a187dca2c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda5",
                                                              "_id": "606e351a4b60e26a187dca2d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss' Law and its application",
                                                      "id": "5ace203e9fe7b01d5806c108",
                                                      "_id": "606e351a4b60e26a187dca2a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda6",
                                                              "_id": "606e351a4b60e26a187dca2b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "properties of conductor, earthing of conductor",
                                                      "id": "5ace203e9fe7b01d5806c109",
                                                      "_id": "606e351a4b60e26a187dca28",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda7",
                                                              "_id": "606e351a4b60e26a187dca29"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem in a capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c10a",
                                                      "_id": "606e351a4b60e26a187dca26",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda8",
                                                              "_id": "606e351a4b60e26a187dca27"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5c",
                                                      "_id": "606e351a4b60e26a187dca44"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "EMI & AC",
                                              "id": "5ace20329fe7b01d5806bc9d",
                                              "_id": "606e351a4b60e26a187dca05",
                                              "concepts": [
                                                  {
                                                      "name": "Alternating current and its properties",
                                                      "id": "5ace203e9fe7b01d5806c10b",
                                                      "_id": "606e351a4b60e26a187dca22",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda9",
                                                              "_id": "606e351a4b60e26a187dca23"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Faraday's law & Lenz's Law",
                                                      "id": "5ace203e9fe7b01d5806c10c",
                                                      "_id": "606e351a4b60e26a187dca20",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddaa",
                                                              "_id": "606e351a4b60e26a187dca21"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Induced electric field",
                                                      "id": "5ace203e9fe7b01d5806c10d",
                                                      "_id": "606e351a4b60e26a187dca1e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddab",
                                                              "_id": "606e351a4b60e26a187dca1f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inductance - self and mutual",
                                                      "id": "5ace203e9fe7b01d5806c10e",
                                                      "_id": "606e351a4b60e26a187dca1c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddac",
                                                              "_id": "606e351a4b60e26a187dca1d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "inductor based circuit",
                                                      "id": "5ace203e9fe7b01d5806c10f",
                                                      "_id": "606e351a4b60e26a187dca1a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddad",
                                                              "_id": "606e351a4b60e26a187dca1b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "LCR based circuits",
                                                      "id": "5ace203e9fe7b01d5806c110",
                                                      "_id": "606e351a4b60e26a187dca18",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddae",
                                                              "_id": "606e351a4b60e26a187dca19"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "LR based circuits",
                                                      "id": "5ace203e9fe7b01d5806c111",
                                                      "_id": "606e351a4b60e26a187dca16",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddaf",
                                                              "_id": "606e351a4b60e26a187dca17"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "magnetic flux",
                                                      "id": "5ace203e9fe7b01d5806c112",
                                                      "_id": "606e351a4b60e26a187dca14",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb0",
                                                              "_id": "606e351a4b60e26a187dca15"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motional emf",
                                                      "id": "5ace203e9fe7b01d5806c113",
                                                      "_id": "606e351a4b60e26a187dca12",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb1",
                                                              "_id": "606e351a4b60e26a187dca13"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parallel circuits and Wheatstone Bridge",
                                                      "id": "5ace203e9fe7b01d5806c114",
                                                      "_id": "606e351a4b60e26a187dca10",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb2",
                                                              "_id": "606e351a4b60e26a187dca11"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power & Resonance in AC",
                                                      "id": "5ace203e9fe7b01d5806c115",
                                                      "_id": "606e351a4b60e26a187dca0e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb3",
                                                              "_id": "606e351a4b60e26a187dca0f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Study of motion of conductors in a magnetic field when currents are induced",
                                                      "id": "5ace203e9fe7b01d5806c116",
                                                      "_id": "606e351a4b60e26a187dca0c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb4",
                                                              "_id": "606e351a4b60e26a187dca0d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time varying magnetic field",
                                                      "id": "5ace203e9fe7b01d5806c117",
                                                      "_id": "606e351a4b60e26a187dca0a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb5",
                                                              "_id": "606e351a4b60e26a187dca0b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque experienced by the particle kept in magnetic field",
                                                      "id": "5ace203e9fe7b01d5806c118",
                                                      "_id": "606e351a4b60e26a187dca08",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb6",
                                                              "_id": "606e351a4b60e26a187dca09"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformer and choke coil",
                                                      "id": "5ace203e9fe7b01d5806c119",
                                                      "_id": "606e351a4b60e26a187dca06",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb7",
                                                              "_id": "606e351a4b60e26a187dca07"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5d",
                                                      "_id": "606e351a4b60e26a187dca24"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetics",
                                              "id": "5ace20329fe7b01d5806bc9e",
                                              "_id": "606e351a4b60e26a187dc9ed",
                                              "concepts": [
                                                  {
                                                      "name": "Ampere's circuital law and applications",
                                                      "id": "5ace203e9fe7b01d5806c11a",
                                                      "_id": "606e351a4b60e26a187dca02",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb8",
                                                              "_id": "606e351a4b60e26a187dca03"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot-Savart law & application",
                                                      "id": "5ace203e9fe7b01d5806c11b",
                                                      "_id": "606e351a4b60e26a187dca00",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb9",
                                                              "_id": "606e351a4b60e26a187dca01"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Earth magnetism",
                                                      "id": "5ace203e9fe7b01d5806c11c",
                                                      "_id": "606e351a4b60e26a187dc9fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddba",
                                                              "_id": "606e351a4b60e26a187dc9ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Galvanometers",
                                                      "id": "5ace203e9fe7b01d5806c11d",
                                                      "_id": "606e351a4b60e26a187dc9fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbb",
                                                              "_id": "606e351a4b60e26a187dc9fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnet and its properties",
                                                      "id": "5ace203e9fe7b01d5806c11e",
                                                      "_id": "606e351a4b60e26a187dc9fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbc",
                                                              "_id": "606e351a4b60e26a187dc9fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic force on charge particle",
                                                      "id": "5ace203e9fe7b01d5806c11f",
                                                      "_id": "606e351a4b60e26a187dc9f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbd",
                                                              "_id": "606e351a4b60e26a187dc9f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "magnetic force on current carrying wire",
                                                      "id": "5ace203e9fe7b01d5806c120",
                                                      "_id": "606e351a4b60e26a187dc9f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbe",
                                                              "_id": "606e351a4b60e26a187dc9f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic properties of material",
                                                      "id": "5ace203e9fe7b01d5806c121",
                                                      "_id": "606e351a4b60e26a187dc9f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbf",
                                                              "_id": "606e351a4b60e26a187dc9f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion of charged particles in combined field",
                                                      "id": "5ace203e9fe7b01d5806c122",
                                                      "_id": "606e351a4b60e26a187dc9f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc0",
                                                              "_id": "606e351a4b60e26a187dc9f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "potential energy of current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c123",
                                                      "_id": "606e351a4b60e26a187dc9f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc1",
                                                              "_id": "606e351a4b60e26a187dc9f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "torque on a current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c124",
                                                      "_id": "606e351a4b60e26a187dc9ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc2",
                                                              "_id": "606e351a4b60e26a187dc9ef"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5e",
                                                      "_id": "606e351a4b60e26a187dca04"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Fluids",
                                              "id": "5ace20329fe7b01d5806bc9f",
                                              "_id": "606e351a4b60e26a187dc9d3",
                                              "concepts": [
                                                  {
                                                      "name": "Barometer, manometer, U-tube",
                                                      "id": "5ace203e9fe7b01d5806c125",
                                                      "_id": "606e351a4b60e26a187dc9ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc3",
                                                              "_id": "606e351a4b60e26a187dc9eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capillary action",
                                                      "id": "5ace203e9fe7b01d5806c126",
                                                      "_id": "606e351a4b60e26a187dc9e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc4",
                                                              "_id": "606e351a4b60e26a187dc9e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Excess pressure",
                                                      "id": "5ace203e9fe7b01d5806c127",
                                                      "_id": "606e351a4b60e26a187dc9e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc5",
                                                              "_id": "606e351a4b60e26a187dc9e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Floatation",
                                                      "id": "5ace203f9fe7b01d5806c128",
                                                      "_id": "606e351a4b60e26a187dc9e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc6",
                                                              "_id": "606e351a4b60e26a187dc9e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fluid dynamics, Bernoulli's equation",
                                                      "id": "5ace203f9fe7b01d5806c129",
                                                      "_id": "606e351a4b60e26a187dc9e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc7",
                                                              "_id": "606e351a4b60e26a187dc9e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pressure and Force applied by fluid",
                                                      "id": "5ace203f9fe7b01d5806c12a",
                                                      "_id": "606e351a4b60e26a187dc9e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc8",
                                                              "_id": "606e351a4b60e26a187dc9e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Siphonic action, venturimeter, pitot tube",
                                                      "id": "5ace203f9fe7b01d5806c12b",
                                                      "_id": "606e351a4b60e26a187dc9de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc9",
                                                              "_id": "606e351a4b60e26a187dc9df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Stoke's Law",
                                                      "id": "5ace203f9fe7b01d5806c12c",
                                                      "_id": "606e351a4b60e26a187dc9dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddca",
                                                              "_id": "606e351a4b60e26a187dc9dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface tension force",
                                                      "id": "5ace203f9fe7b01d5806c12d",
                                                      "_id": "606e351a4b60e26a187dc9da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcb",
                                                              "_id": "606e351a4b60e26a187dc9db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time to drain out liquid from a container",
                                                      "id": "5ace203f9fe7b01d5806c12e",
                                                      "_id": "606e351a4b60e26a187dc9d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcc",
                                                              "_id": "606e351a4b60e26a187dc9d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velocity of efflux and thrust force",
                                                      "id": "5ace203f9fe7b01d5806c12f",
                                                      "_id": "606e351a4b60e26a187dc9d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcd",
                                                              "_id": "606e351a4b60e26a187dc9d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Viscosity",
                                                      "id": "5ace203f9fe7b01d5806c130",
                                                      "_id": "606e351a4b60e26a187dc9d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddce",
                                                              "_id": "606e351a4b60e26a187dc9d5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5f",
                                                      "_id": "606e351a4b60e26a187dc9ec"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "General Physics",
                                              "id": "5ace20329fe7b01d5806bca0",
                                              "_id": "606e351a4b60e26a187dc9c9",
                                              "concepts": [
                                                  {
                                                      "name": "dimensional analysis",
                                                      "id": "5ace203f9fe7b01d5806c131",
                                                      "_id": "606e351a4b60e26a187dc9d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcf",
                                                              "_id": "606e351a4b60e26a187dc9d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Error analysis",
                                                      "id": "5ace203f9fe7b01d5806c132",
                                                      "_id": "606e351a4b60e26a187dc9ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd0",
                                                              "_id": "606e351a4b60e26a187dc9cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Experiments",
                                                      "id": "5ace203f9fe7b01d5806c133",
                                                      "_id": "606e351a4b60e26a187dc9cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd1",
                                                              "_id": "606e351a4b60e26a187dc9cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Significant figure",
                                                      "id": "5ace203f9fe7b01d5806c134",
                                                      "_id": "606e351a4b60e26a187dc9ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd2",
                                                              "_id": "606e351a4b60e26a187dc9cb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd60",
                                                      "_id": "606e351a4b60e26a187dc9d2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vectors",
                                              "id": "5ace20329fe7b01d5806bca1",
                                              "_id": "606e351a4b60e26a187dc9c1",
                                              "concepts": [
                                                  {
                                                      "name": "Dot Product, Cross product and applications",
                                                      "id": "5ace203f9fe7b01d5806c135",
                                                      "_id": "606e351a4b60e26a187dc9c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd3",
                                                              "_id": "606e351a4b60e26a187dc9c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resolution of vectors",
                                                      "id": "5ace203f9fe7b01d5806c136",
                                                      "_id": "606e351a4b60e26a187dc9c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd4",
                                                              "_id": "606e351a4b60e26a187dc9c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vectors & parallelogram Law",
                                                      "id": "5ace203f9fe7b01d5806c137",
                                                      "_id": "606e351a4b60e26a187dc9c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd5",
                                                              "_id": "606e351a4b60e26a187dc9c3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd61",
                                                      "_id": "606e351a4b60e26a187dc9c8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Conservation Of Momentum",
                                              "id": "5ace20329fe7b01d5806bca2",
                                              "_id": "606e351a4b60e26a187dc9b1",
                                              "concepts": [
                                                  {
                                                      "name": "centre of mass",
                                                      "id": "5ace203f9fe7b01d5806c138",
                                                      "_id": "606e351a4b60e26a187dc9be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd6",
                                                              "_id": "606e351a4b60e26a187dc9bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "coefficient of restitution",
                                                      "id": "5ace203f9fe7b01d5806c139",
                                                      "_id": "606e351a4b60e26a187dc9bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd7",
                                                              "_id": "606e351a4b60e26a187dc9bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Head on collision",
                                                      "id": "5ace203f9fe7b01d5806c13a",
                                                      "_id": "606e351a4b60e26a187dc9ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd8",
                                                              "_id": "606e351a4b60e26a187dc9bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Impulse momentum theorem",
                                                      "id": "5ace203f9fe7b01d5806c13b",
                                                      "_id": "606e351a4b60e26a187dc9b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd9",
                                                              "_id": "606e351a4b60e26a187dc9b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "motion of centre of mass",
                                                      "id": "5ace203f9fe7b01d5806c13c",
                                                      "_id": "606e351a4b60e26a187dc9b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddda",
                                                              "_id": "606e351a4b60e26a187dc9b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Oblique collision",
                                                      "id": "5ace203f9fe7b01d5806c13d",
                                                      "_id": "606e351a4b60e26a187dc9b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dddb",
                                                              "_id": "606e351a4b60e26a187dc9b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "variable mass system",
                                                      "id": "5ace203f9fe7b01d5806c13e",
                                                      "_id": "606e351a4b60e26a187dc9b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dddc",
                                                              "_id": "606e351a4b60e26a187dc9b3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd62",
                                                      "_id": "606e351a4b60e26a187dc9c0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Gravitation",
                                              "id": "5ace20329fe7b01d5806bca3",
                                              "_id": "606e351a4b60e26a187dc9a5",
                                              "concepts": [
                                                  {
                                                      "name": "Escape speed, Binding energy, projection of a particle from surface of earth, Binary mass system",
                                                      "id": "5ace203f9fe7b01d5806c13f",
                                                      "_id": "606e351a4b60e26a187dc9ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dddd",
                                                              "_id": "606e351a4b60e26a187dc9af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "gravitational acceleration",
                                                      "id": "5ace203f9fe7b01d5806c140",
                                                      "_id": "606e351a4b60e26a187dc9ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddde",
                                                              "_id": "606e351a4b60e26a187dc9ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "gravitational force and field",
                                                      "id": "5ace203f9fe7b01d5806c141",
                                                      "_id": "606e351a4b60e26a187dc9aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dddf",
                                                              "_id": "606e351a4b60e26a187dc9ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "gravitational potential energy and potential, self energy",
                                                      "id": "5ace203f9fe7b01d5806c142",
                                                      "_id": "606e351a4b60e26a187dc9a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde0",
                                                              "_id": "606e351a4b60e26a187dc9a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion of planet and satellites in circular and elliptical path",
                                                      "id": "5ace203f9fe7b01d5806c143",
                                                      "_id": "606e351a4b60e26a187dc9a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde1",
                                                              "_id": "606e351a4b60e26a187dc9a7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd63",
                                                      "_id": "606e351a4b60e26a187dc9b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Kinematics",
                                              "id": "5ace20329fe7b01d5806bca4",
                                              "_id": "606e351a4b60e26a187dc98b",
                                              "concepts": [
                                                  {
                                                      "name": "1-D motion with constant acceleration",
                                                      "id": "5ace203f9fe7b01d5806c144",
                                                      "_id": "606e351a4b60e26a187dc9a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde2",
                                                              "_id": "606e351a4b60e26a187dc9a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "1-D motion with variable acceleration",
                                                      "id": "5ace203f9fe7b01d5806c145",
                                                      "_id": "606e351a4b60e26a187dc9a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde3",
                                                              "_id": "606e351a4b60e26a187dc9a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Free body diagram",
                                                      "id": "5ace203f9fe7b01d5806c146",
                                                      "_id": "606e351a4b60e26a187dc99e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde4",
                                                              "_id": "606e351a4b60e26a187dc99f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphs in kinematics",
                                                      "id": "5ace203f9fe7b01d5806c147",
                                                      "_id": "606e351a4b60e26a187dc99c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde5",
                                                              "_id": "606e351a4b60e26a187dc99d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "non uniform circular motion",
                                                      "id": "5ace203f9fe7b01d5806c148",
                                                      "_id": "606e351a4b60e26a187dc99a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde6",
                                                              "_id": "606e351a4b60e26a187dc99b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projectile Motion on horizontal plane",
                                                      "id": "5ace203f9fe7b01d5806c149",
                                                      "_id": "606e351a4b60e26a187dc998",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde7",
                                                              "_id": "606e351a4b60e26a187dc999"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "projectile motion on inclined plane",
                                                      "id": "5ace203f9fe7b01d5806c14a",
                                                      "_id": "606e351a4b60e26a187dc996",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde8",
                                                              "_id": "606e351a4b60e26a187dc997"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rain man problem",
                                                      "id": "5ace203f9fe7b01d5806c14b",
                                                      "_id": "606e351a4b60e26a187dc994",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde9",
                                                              "_id": "606e351a4b60e26a187dc995"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relative Motion",
                                                      "id": "5ace203f9fe7b01d5806c14c",
                                                      "_id": "606e351a4b60e26a187dc992",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddea",
                                                              "_id": "606e351a4b60e26a187dc993"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "river boat problem",
                                                      "id": "5ace203f9fe7b01d5806c14d",
                                                      "_id": "606e351a4b60e26a187dc990",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddeb",
                                                              "_id": "606e351a4b60e26a187dc991"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Uniform circular motion",
                                                      "id": "5ace203f9fe7b01d5806c14e",
                                                      "_id": "606e351a4b60e26a187dc98e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddec",
                                                              "_id": "606e351a4b60e26a187dc98f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velocity of approach and separation, minimum distance of approach",
                                                      "id": "5ace203f9fe7b01d5806c14f",
                                                      "_id": "606e351a4b60e26a187dc98c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dded",
                                                              "_id": "606e351a4b60e26a187dc98d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd64",
                                                      "_id": "606e351a4b60e26a187dc9a4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Laws of Motion",
                                              "id": "5ace20329fe7b01d5806bca5",
                                              "_id": "606e351a4b60e26a187dc975",
                                              "concepts": [
                                                  {
                                                      "name": "Application of Newton's second Law",
                                                      "id": "5ace203f9fe7b01d5806c150",
                                                      "_id": "606e351a4b60e26a187dc988",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddee",
                                                              "_id": "606e351a4b60e26a187dc989"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bending of track",
                                                      "id": "5ace203f9fe7b01d5806c151",
                                                      "_id": "606e351a4b60e26a187dc986",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddef",
                                                              "_id": "606e351a4b60e26a187dc987"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Constraint equations(contact constraint)",
                                                      "id": "5ace203f9fe7b01d5806c152",
                                                      "_id": "606e351a4b60e26a187dc984",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf0",
                                                              "_id": "606e351a4b60e26a187dc985"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Constraint equations(string constraint)",
                                                      "id": "5ace203f9fe7b01d5806c153",
                                                      "_id": "606e351a4b60e26a187dc982",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf1",
                                                              "_id": "606e351a4b60e26a187dc983"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dynamics of circular motion",
                                                      "id": "5ace203f9fe7b01d5806c154",
                                                      "_id": "606e351a4b60e26a187dc980",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf2",
                                                              "_id": "606e351a4b60e26a187dc981"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equilibrium of forces",
                                                      "id": "5ace203f9fe7b01d5806c155",
                                                      "_id": "606e351a4b60e26a187dc97e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf3",
                                                              "_id": "606e351a4b60e26a187dc97f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kinetic friction",
                                                      "id": "5ace203f9fe7b01d5806c156",
                                                      "_id": "606e351a4b60e26a187dc97c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf4",
                                                              "_id": "606e351a4b60e26a187dc97d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multiple block system",
                                                      "id": "5ace203f9fe7b01d5806c157",
                                                      "_id": "606e351a4b60e26a187dc97a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf5",
                                                              "_id": "606e351a4b60e26a187dc97b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton's Law and frame of reference",
                                                      "id": "5ace203f9fe7b01d5806c158",
                                                      "_id": "606e351a4b60e26a187dc978",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf6",
                                                              "_id": "606e351a4b60e26a187dc979"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Static friction",
                                                      "id": "5ace203f9fe7b01d5806c159",
                                                      "_id": "606e351a4b60e26a187dc976",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf7",
                                                              "_id": "606e351a4b60e26a187dc977"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd65",
                                                      "_id": "606e351a4b60e26a187dc98a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Rotational Motion",
                                              "id": "5ace20329fe7b01d5806bca6",
                                              "_id": "606e351a4b60e26a187dc95b",
                                              "concepts": [
                                                  {
                                                      "name": "angular momentum and conservation of angular momentum",
                                                      "id": "5ace203f9fe7b01d5806c15a",
                                                      "_id": "606e351a4b60e26a187dc972",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf8",
                                                              "_id": "606e351a4b60e26a187dc973"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Hinge reaction",
                                                      "id": "5ace203f9fe7b01d5806c15b",
                                                      "_id": "606e351a4b60e26a187dc970",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf9",
                                                              "_id": "606e351a4b60e26a187dc971"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Instantaneous axis of rotation",
                                                      "id": "5ace203f9fe7b01d5806c15c",
                                                      "_id": "606e351a4b60e26a187dc96e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfa",
                                                              "_id": "606e351a4b60e26a187dc96f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "kinetic energy of a body performing combined motion",
                                                      "id": "5ace203f9fe7b01d5806c15d",
                                                      "_id": "606e351a4b60e26a187dc96c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfb",
                                                              "_id": "606e351a4b60e26a187dc96d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment of inertia of discrete and distributed mass",
                                                      "id": "5ace203f9fe7b01d5806c15e",
                                                      "_id": "606e351a4b60e26a187dc96a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfc",
                                                              "_id": "606e351a4b60e26a187dc96b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parallel and perpendicular axis theorem",
                                                      "id": "5ace203f9fe7b01d5806c15f",
                                                      "_id": "606e351a4b60e26a187dc968",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfd",
                                                              "_id": "606e351a4b60e26a187dc969"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pure Rotation Motion",
                                                      "id": "5ace203f9fe7b01d5806c160",
                                                      "_id": "606e351a4b60e26a187dc966",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfe",
                                                              "_id": "606e351a4b60e26a187dc967"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rolling on horizontal surface",
                                                      "id": "5ace203f9fe7b01d5806c161",
                                                      "_id": "606e351a4b60e26a187dc964",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddff",
                                                              "_id": "606e351a4b60e26a187dc965"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rolling on inclined plane and toppling",
                                                      "id": "5ace203f9fe7b01d5806c162",
                                                      "_id": "606e351a4b60e26a187dc962",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de00",
                                                              "_id": "606e351a4b60e26a187dc963"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "torque",
                                                      "id": "5ace203f9fe7b01d5806c163",
                                                      "_id": "606e351a4b60e26a187dc960",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de01",
                                                              "_id": "606e351a4b60e26a187dc961"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "velocity and acceleration of a body performing combined motion",
                                                      "id": "5ace203f9fe7b01d5806c164",
                                                      "_id": "606e351a4b60e26a187dc95e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de02",
                                                              "_id": "606e351a4b60e26a187dc95f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem in rotation motion",
                                                      "id": "5ace203f9fe7b01d5806c165",
                                                      "_id": "606e351a4b60e26a187dc95c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de03",
                                                              "_id": "606e351a4b60e26a187dc95d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd66",
                                                      "_id": "606e351a4b60e26a187dc974"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work Power and Energy",
                                              "id": "5ace20329fe7b01d5806bca7",
                                              "_id": "606e351a4b60e26a187dc94b",
                                              "concepts": [
                                                  {
                                                      "name": "Conservation of mechanical energy and Conservative forces",
                                                      "id": "5ace203f9fe7b01d5806c166",
                                                      "_id": "606e351a4b60e26a187dc958",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de04",
                                                              "_id": "606e351a4b60e26a187dc959"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion in vertical circle",
                                                      "id": "5ace203f9fe7b01d5806c167",
                                                      "_id": "606e351a4b60e26a187dc956",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de05",
                                                              "_id": "606e351a4b60e26a187dc957"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential Energy",
                                                      "id": "5ace203f9fe7b01d5806c168",
                                                      "_id": "606e351a4b60e26a187dc954",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de06",
                                                              "_id": "606e351a4b60e26a187dc955"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power",
                                                      "id": "5ace203f9fe7b01d5806c169",
                                                      "_id": "606e351a4b60e26a187dc952",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de07",
                                                              "_id": "606e351a4b60e26a187dc953"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work",
                                                      "id": "5ace203f9fe7b01d5806c16a",
                                                      "_id": "606e351a4b60e26a187dc950",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de08",
                                                              "_id": "606e351a4b60e26a187dc951"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work energy theorem for a single particle system",
                                                      "id": "5ace203f9fe7b01d5806c16b",
                                                      "_id": "606e351a4b60e26a187dc94e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de09",
                                                              "_id": "606e351a4b60e26a187dc94f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem for multiple particle system",
                                                      "id": "5ace203f9fe7b01d5806c16c",
                                                      "_id": "606e351a4b60e26a187dc94c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0a",
                                                              "_id": "606e351a4b60e26a187dc94d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd67",
                                                      "_id": "606e351a4b60e26a187dc95a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Modern Physics",
                                              "id": "5ace20329fe7b01d5806bca8",
                                              "_id": "606e351a4b60e26a187dc949",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd68",
                                                      "_id": "606e351a4b60e26a187dc94a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Modern Physics",
                                              "id": "5ace20329fe7b01d5806bca9",
                                              "_id": "606e351a4b60e26a187dc931",
                                              "concepts": [
                                                  {
                                                      "name": "Bohrs model",
                                                      "id": "5ace203f9fe7b01d5806c16d",
                                                      "_id": "606e351a4b60e26a187dc946",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0b",
                                                              "_id": "606e351a4b60e26a187dc947"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conventional and non\n  conventional sources of energy",
                                                      "id": "5ace203f9fe7b01d5806c16e",
                                                      "_id": "606e351a4b60e26a187dc944",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0c",
                                                              "_id": "606e351a4b60e26a187dc945"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "dual nature of matter and de-broglie wavelength",
                                                      "id": "5ace203f9fe7b01d5806c16f",
                                                      "_id": "606e351a4b60e26a187dc942",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0d",
                                                              "_id": "606e351a4b60e26a187dc943"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Emission spectrun in Bohr's model",
                                                      "id": "5ace203f9fe7b01d5806c170",
                                                      "_id": "606e351a4b60e26a187dc940",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0e",
                                                              "_id": "606e351a4b60e26a187dc941"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "fustion and fission reaction, alpha, beta & gamma decay,",
                                                      "id": "5ace203f9fe7b01d5806c171",
                                                      "_id": "606e351a4b60e26a187dc93e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0f",
                                                              "_id": "606e351a4b60e26a187dc93f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "nuclear physics, binding energy, Q-value of reaction, threshold energy",
                                                      "id": "5ace203f9fe7b01d5806c172",
                                                      "_id": "606e351a4b60e26a187dc93c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de10",
                                                              "_id": "606e351a4b60e26a187dc93d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "photo-electric effect",
                                                      "id": "5ace203f9fe7b01d5806c173",
                                                      "_id": "606e351a4b60e26a187dc93a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de11",
                                                              "_id": "606e351a4b60e26a187dc93b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "properties of photon",
                                                      "id": "5ace203f9fe7b01d5806c174",
                                                      "_id": "606e351a4b60e26a187dc938",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de12",
                                                              "_id": "606e351a4b60e26a187dc939"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "radioactivity, parallel and series decay, radioactive equilirbium",
                                                      "id": "5ace203f9fe7b01d5806c175",
                                                      "_id": "606e351a4b60e26a187dc936",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de13",
                                                              "_id": "606e351a4b60e26a187dc937"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Renewable & non renewable source of energy",
                                                      "id": "5ace203f9fe7b01d5806c176",
                                                      "_id": "606e351a4b60e26a187dc934",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de14",
                                                              "_id": "606e351a4b60e26a187dc935"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "X rays, characteristic and continuous wavelength, mosley's law",
                                                      "id": "5ace203f9fe7b01d5806c177",
                                                      "_id": "606e351a4b60e26a187dc932",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de15",
                                                              "_id": "606e351a4b60e26a187dc933"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd69",
                                                      "_id": "606e351a4b60e26a187dc948"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5ace20329fe7b01d5806bcaa",
                                              "_id": "606e351a4b60e26a187dc90f",
                                              "concepts": [
                                                  {
                                                      "name": "basic properties of reflection and plane mirror, Object and image",
                                                      "id": "5ace203f9fe7b01d5806c178",
                                                      "_id": "606e351a4b60e26a187dc92e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de16",
                                                              "_id": "606e351a4b60e26a187dc92f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "basic properties of refraction and image formation from plane surface, variable refractive index, motion of image from plane surface",
                                                      "id": "5ace203f9fe7b01d5806c179",
                                                      "_id": "606e351a4b60e26a187dc92c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de17",
                                                              "_id": "606e351a4b60e26a187dc92d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "basic property of prism, deviation and dispersion from prism, image formation from prism, minimum deviation from prism",
                                                      "id": "5ace203f9fe7b01d5806c17a",
                                                      "_id": "606e351a4b60e26a187dc92a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de18",
                                                              "_id": "606e351a4b60e26a187dc92b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "combination of lens, silvering of lens, splitting of lens",
                                                      "id": "5ace203f9fe7b01d5806c17b",
                                                      "_id": "606e351a4b60e26a187dc928",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de19",
                                                              "_id": "606e351a4b60e26a187dc929"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "deviation from optical instruments",
                                                      "id": "5ace203f9fe7b01d5806c17c",
                                                      "_id": "606e351a4b60e26a187dc926",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1a",
                                                              "_id": "606e351a4b60e26a187dc927"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic wave",
                                                      "id": "5ace203f9fe7b01d5806c17d",
                                                      "_id": "606e351a4b60e26a187dc924",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1b",
                                                              "_id": "606e351a4b60e26a187dc925"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "huygen theory of wave fronts, YDSE",
                                                      "id": "5ace203f9fe7b01d5806c17e",
                                                      "_id": "606e351a4b60e26a187dc922",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1c",
                                                              "_id": "606e351a4b60e26a187dc923"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "interference from thin film",
                                                      "id": "5ace203f9fe7b01d5806c17f",
                                                      "_id": "606e351a4b60e26a187dc920",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1d",
                                                              "_id": "606e351a4b60e26a187dc921"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "interference in system similar to YDSE",
                                                      "id": "5ace203f9fe7b01d5806c180",
                                                      "_id": "606e351a4b60e26a187dc91e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1e",
                                                              "_id": "606e351a4b60e26a187dc91f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "microscope, telescope and eye",
                                                      "id": "5ace20409fe7b01d5806c181",
                                                      "_id": "606e351a4b60e26a187dc91c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1f",
                                                              "_id": "606e351a4b60e26a187dc91d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarization, resolving power, microscope, telescope, brewster's law, polaroids",
                                                      "id": "5ace20409fe7b01d5806c182",
                                                      "_id": "606e351a4b60e26a187dc91a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de20",
                                                              "_id": "606e351a4b60e26a187dc91b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "refraction from spherical surfaces, lens, lens formula, magnification, motion of image from lens",
                                                      "id": "5ace20409fe7b01d5806c183",
                                                      "_id": "606e351a4b60e26a187dc918",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de21",
                                                              "_id": "606e351a4b60e26a187dc919"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "shifting of fringes due to introduction of film, concept of optical path",
                                                      "id": "5ace20409fe7b01d5806c184",
                                                      "_id": "606e351a4b60e26a187dc916",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de22",
                                                              "_id": "606e351a4b60e26a187dc917"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Single slit diffraction, width of centre maximum",
                                                      "id": "5ace20409fe7b01d5806c185",
                                                      "_id": "606e351a4b60e26a187dc914",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de23",
                                                              "_id": "606e351a4b60e26a187dc915"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "spherical mirror and mirror formula, relative motion of miror and object, magnification",
                                                      "id": "5ace20409fe7b01d5806c186",
                                                      "_id": "606e351a4b60e26a187dc912",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de24",
                                                              "_id": "606e351a4b60e26a187dc913"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "total internal reflection",
                                                      "id": "5ace20409fe7b01d5806c187",
                                                      "_id": "606e351a4b60e26a187dc910",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de25",
                                                              "_id": "606e351a4b60e26a187dc911"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6a",
                                                      "_id": "606e351a4b60e26a187dc930"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electricity",
                                              "id": "5ace20329fe7b01d5806bcab",
                                              "_id": "606e351a4b60e26a187dc8f9",
                                              "concepts": [
                                                  {
                                                      "name": "Columb's Inverse Square Law",
                                                      "id": "5ace20409fe7b01d5806c188",
                                                      "_id": "606e351a4b60e26a187dc90c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de26",
                                                              "_id": "606e351a4b60e26a187dc90d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conductor, Insulator and Ammeter and Voltmeter",
                                                      "id": "5ace20409fe7b01d5806c189",
                                                      "_id": "606e351a4b60e26a187dc90a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de27",
                                                              "_id": "606e351a4b60e26a187dc90b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Power",
                                                      "id": "5ace20409fe7b01d5806c18a",
                                                      "_id": "606e351a4b60e26a187dc908",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de28",
                                                              "_id": "606e351a4b60e26a187dc909"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heating Effect of Current",
                                                      "id": "5ace20409fe7b01d5806c18b",
                                                      "_id": "606e351a4b60e26a187dc906",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de29",
                                                              "_id": "606e351a4b60e26a187dc907"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ohm's Law",
                                                      "id": "5ace20409fe7b01d5806c18c",
                                                      "_id": "606e351a4b60e26a187dc904",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2a",
                                                              "_id": "606e351a4b60e26a187dc905"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential & Potential Difference",
                                                      "id": "5ace20409fe7b01d5806c18d",
                                                      "_id": "606e351a4b60e26a187dc902",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2b",
                                                              "_id": "606e351a4b60e26a187dc903"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Charge & Electric Current",
                                                      "id": "5ace20409fe7b01d5806c18e",
                                                      "_id": "606e351a4b60e26a187dc900",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2c",
                                                              "_id": "606e351a4b60e26a187dc901"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resistance and Resistivity",
                                                      "id": "5ace20409fe7b01d5806c18f",
                                                      "_id": "606e351a4b60e26a187dc8fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2d",
                                                              "_id": "606e351a4b60e26a187dc8ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series and Parralel Combination of Resistances",
                                                      "id": "5ace20409fe7b01d5806c190",
                                                      "_id": "606e351a4b60e26a187dc8fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2e",
                                                              "_id": "606e351a4b60e26a187dc8fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wheatstone Bridge",
                                                      "id": "5ace20409fe7b01d5806c191",
                                                      "_id": "606e351a4b60e26a187dc8fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de2f",
                                                              "_id": "606e351a4b60e26a187dc8fb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6b",
                                                      "_id": "606e351a4b60e26a187dc90e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Fluid",
                                              "id": "5ace20329fe7b01d5806bcac",
                                              "_id": "606e351a4b60e26a187dc8ef",
                                              "concepts": [
                                                  {
                                                      "name": "Archimedes Principle",
                                                      "id": "5ace20409fe7b01d5806c192",
                                                      "_id": "606e351a4b60e26a187dc8f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de30",
                                                              "_id": "606e351a4b60e26a187dc8f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pressure, Atmospheric Pressure & Relative density",
                                                      "id": "5ace20409fe7b01d5806c193",
                                                      "_id": "606e351a4b60e26a187dc8f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de31",
                                                              "_id": "606e351a4b60e26a187dc8f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Upthrust/buyont force & Laws of floatation",
                                                      "id": "5ace20409fe7b01d5806c194",
                                                      "_id": "606e351a4b60e26a187dc8f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de32",
                                                              "_id": "606e351a4b60e26a187dc8f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Variation of pressure with depth & Pascal Law",
                                                      "id": "5ace20409fe7b01d5806c195",
                                                      "_id": "606e351a4b60e26a187dc8f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de33",
                                                              "_id": "606e351a4b60e26a187dc8f1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6c",
                                                      "_id": "606e351a4b60e26a187dc8f8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Gravitation",
                                              "id": "5ace20329fe7b01d5806bcad",
                                              "_id": "606e351a4b60e26a187dc8e3",
                                              "concepts": [
                                                  {
                                                      "name": "Acceleration due to gravity (g) & Variation of g and Types of Variation",
                                                      "id": "5ace20409fe7b01d5806c196",
                                                      "_id": "606e351a4b60e26a187dc8ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de34",
                                                              "_id": "606e351a4b60e26a187dc8ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Escape Velocity",
                                                      "id": "5ace20409fe7b01d5806c197",
                                                      "_id": "606e351a4b60e26a187dc8ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de35",
                                                              "_id": "606e351a4b60e26a187dc8eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Orbital velocity, Time period of a Satellite",
                                                      "id": "5ace20409fe7b01d5806c198",
                                                      "_id": "606e351a4b60e26a187dc8e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de36",
                                                              "_id": "606e351a4b60e26a187dc8e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Planetary motion, Motion of Planets & Kepler’s laws",
                                                      "id": "5ace20409fe7b01d5806c199",
                                                      "_id": "606e351a4b60e26a187dc8e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de37",
                                                              "_id": "606e351a4b60e26a187dc8e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Universal Law of Gravitation",
                                                      "id": "5ace20409fe7b01d5806c19a",
                                                      "_id": "606e351a4b60e26a187dc8e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de38",
                                                              "_id": "606e351a4b60e26a187dc8e5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6d",
                                                      "_id": "606e351a4b60e26a187dc8ee"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "HUMAN EYE",
                                              "id": "5ace20329fe7b01d5806bcae",
                                              "_id": "606e351a4b60e26a187dc8d7",
                                              "concepts": [
                                                  {
                                                      "name": "Atmospheric Refraction & Scattering of Light",
                                                      "id": "5ace20409fe7b01d5806c19b",
                                                      "_id": "606e351a4b60e26a187dc8e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de39",
                                                              "_id": "606e351a4b60e26a187dc8e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dispersion & Prism",
                                                      "id": "5ace20409fe7b01d5806c19c",
                                                      "_id": "606e351a4b60e26a187dc8de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3a",
                                                              "_id": "606e351a4b60e26a187dc8df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Human Eye & Defects of Vision",
                                                      "id": "5ace20409fe7b01d5806c19d",
                                                      "_id": "606e351a4b60e26a187dc8dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3b",
                                                              "_id": "606e351a4b60e26a187dc8dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mirror Formula & Lens Formula",
                                                      "id": "5ace20409fe7b01d5806c19e",
                                                      "_id": "606e351a4b60e26a187dc8da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3c",
                                                              "_id": "606e351a4b60e26a187dc8db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5ace20409fe7b01d5806c19f",
                                                      "_id": "606e351a4b60e26a187dc8d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3d",
                                                              "_id": "606e351a4b60e26a187dc8d9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6e",
                                                      "_id": "606e351a4b60e26a187dc8e2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Laws of Motion",
                                              "id": "5ace20329fe7b01d5806bcaf",
                                              "_id": "606e351a4b60e26a187dc8c5",
                                              "concepts": [
                                                  {
                                                      "name": "Centripetal force (Basic idea)",
                                                      "id": "5ace20409fe7b01d5806c1a0",
                                                      "_id": "606e351a4b60e26a187dc8d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3e",
                                                              "_id": "606e351a4b60e26a187dc8d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conservation of Momentum",
                                                      "id": "5ace20409fe7b01d5806c1a1",
                                                      "_id": "606e351a4b60e26a187dc8d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de3f",
                                                              "_id": "606e351a4b60e26a187dc8d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Force and its types and Inertia",
                                                      "id": "5ace20409fe7b01d5806c1a2",
                                                      "_id": "606e351a4b60e26a187dc8d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de40",
                                                              "_id": "606e351a4b60e26a187dc8d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Friction (Basic idea)",
                                                      "id": "5ace20409fe7b01d5806c1a3",
                                                      "_id": "606e351a4b60e26a187dc8ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de41",
                                                              "_id": "606e351a4b60e26a187dc8cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Impulse",
                                                      "id": "5ace20409fe7b01d5806c1a4",
                                                      "_id": "606e351a4b60e26a187dc8cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de42",
                                                              "_id": "606e351a4b60e26a187dc8cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Momentum & Newton's Second Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a5",
                                                      "_id": "606e351a4b60e26a187dc8ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de43",
                                                              "_id": "606e351a4b60e26a187dc8cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton's First Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a6",
                                                      "_id": "606e351a4b60e26a187dc8c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de44",
                                                              "_id": "606e351a4b60e26a187dc8c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton's Third Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a7",
                                                      "_id": "606e351a4b60e26a187dc8c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de45",
                                                              "_id": "606e351a4b60e26a187dc8c7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6f",
                                                      "_id": "606e351a4b60e26a187dc8d6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "LIGHT",
                                              "id": "5ace20329fe7b01d5806bcb0",
                                              "_id": "606e351a4b60e26a187dc8b3",
                                              "concepts": [
                                                  {
                                                      "name": "Combination of lens & Power of Lens",
                                                      "id": "5ace20409fe7b01d5806c1a8",
                                                      "_id": "606e351a4b60e26a187dc8c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de46",
                                                              "_id": "606e351a4b60e26a187dc8c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concave lens & Convex Lens",
                                                      "id": "5ace20409fe7b01d5806c1a9",
                                                      "_id": "606e351a4b60e26a187dc8c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de47",
                                                              "_id": "606e351a4b60e26a187dc8c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concave Mirror & Convex Mirror",
                                                      "id": "5ace20409fe7b01d5806c1aa",
                                                      "_id": "606e351a4b60e26a187dc8be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de48",
                                                              "_id": "606e351a4b60e26a187dc8bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane Mirror, Rotation of mirror & Displacing object by a distance x",
                                                      "id": "5ace20409fe7b01d5806c1ab",
                                                      "_id": "606e351a4b60e26a187dc8bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de49",
                                                              "_id": "606e351a4b60e26a187dc8bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Light & Laws of Reflection",
                                                      "id": "5ace20409fe7b01d5806c1ac",
                                                      "_id": "606e351a4b60e26a187dc8ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4a",
                                                              "_id": "606e351a4b60e26a187dc8bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real and Apparent Depth",
                                                      "id": "5ace20409fe7b01d5806c1ad",
                                                      "_id": "606e351a4b60e26a187dc8b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4b",
                                                              "_id": "606e351a4b60e26a187dc8b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refractive Index and velocity when medium changes & Snell's Law",
                                                      "id": "5ace20409fe7b01d5806c1ae",
                                                      "_id": "606e351a4b60e26a187dc8b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4c",
                                                              "_id": "606e351a4b60e26a187dc8b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Total Internal Reflection",
                                                      "id": "5ace20409fe7b01d5806c1af",
                                                      "_id": "606e351a4b60e26a187dc8b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4d",
                                                              "_id": "606e351a4b60e26a187dc8b5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd70",
                                                      "_id": "606e351a4b60e26a187dc8c4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetic Effect of Electric Current",
                                              "id": "5ace20329fe7b01d5806bcb1",
                                              "_id": "606e351a4b60e26a187dc89d",
                                              "concepts": [
                                                  {
                                                      "name": "Domestic Electric circuits, Live,Neutral and Earth wires & Safety devices in domestic circuits",
                                                      "id": "5ace20409fe7b01d5806c1b0",
                                                      "_id": "606e351a4b60e26a187dc8b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4e",
                                                              "_id": "606e351a4b60e26a187dc8b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Induction & Lenz's law",
                                                      "id": "5ace20409fe7b01d5806c1b1",
                                                      "_id": "606e351a4b60e26a187dc8ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de4f",
                                                              "_id": "606e351a4b60e26a187dc8af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fleming's Left/right hand rule & Maxwell's cork screw rule",
                                                      "id": "5ace20409fe7b01d5806c1b2",
                                                      "_id": "606e351a4b60e26a187dc8ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de50",
                                                              "_id": "606e351a4b60e26a187dc8ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Force on a charge moving in Magnetic field",
                                                      "id": "5ace20409fe7b01d5806c1b3",
                                                      "_id": "606e351a4b60e26a187dc8aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de51",
                                                              "_id": "606e351a4b60e26a187dc8ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Field",
                                                      "id": "5ace20409fe7b01d5806c1b4",
                                                      "_id": "606e351a4b60e26a187dc8a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de52",
                                                              "_id": "606e351a4b60e26a187dc8a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic field due to Current in a loop",
                                                      "id": "5ace20409fe7b01d5806c1b5",
                                                      "_id": "606e351a4b60e26a187dc8a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de53",
                                                              "_id": "606e351a4b60e26a187dc8a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic field due to Current in a straight conductor",
                                                      "id": "5ace20409fe7b01d5806c1b6",
                                                      "_id": "606e351a4b60e26a187dc8a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de54",
                                                              "_id": "606e351a4b60e26a187dc8a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Field due to Solenoid",
                                                      "id": "5ace20409fe7b01d5806c1b7",
                                                      "_id": "606e351a4b60e26a187dc8a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de55",
                                                              "_id": "606e351a4b60e26a187dc8a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motor and Generator",
                                                      "id": "5ace20409fe7b01d5806c1b8",
                                                      "_id": "606e351a4b60e26a187dc8a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de56",
                                                              "_id": "606e351a4b60e26a187dc8a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Type of Magnet, Electro magnets and its uses",
                                                      "id": "5ace20409fe7b01d5806c1b9",
                                                      "_id": "606e351a4b60e26a187dc89e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de57",
                                                              "_id": "606e351a4b60e26a187dc89f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd71",
                                                      "_id": "606e351a4b60e26a187dc8b2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Motion",
                                              "id": "5ace20329fe7b01d5806bcb2",
                                              "_id": "606e351a4b60e26a187dc88b",
                                              "concepts": [
                                                  {
                                                      "name": "Avg Speed, Avg Velocity & Constant Acceleration",
                                                      "id": "5ace20409fe7b01d5806c1ba",
                                                      "_id": "606e351a4b60e26a187dc89a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de58",
                                                              "_id": "606e351a4b60e26a187dc89b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance & Displacement",
                                                      "id": "5ace20409fe7b01d5806c1bb",
                                                      "_id": "606e351a4b60e26a187dc898",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de59",
                                                              "_id": "606e351a4b60e26a187dc899"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance time & Displacement time graph",
                                                      "id": "5ace20409fe7b01d5806c1bc",
                                                      "_id": "606e351a4b60e26a187dc896",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5a",
                                                              "_id": "606e351a4b60e26a187dc897"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations of motion",
                                                      "id": "5ace20409fe7b01d5806c1bd",
                                                      "_id": "606e351a4b60e26a187dc894",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5b",
                                                              "_id": "606e351a4b60e26a187dc895"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Free Fall under gravity",
                                                      "id": "5ace20409fe7b01d5806c1be",
                                                      "_id": "606e351a4b60e26a187dc892",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5c",
                                                              "_id": "606e351a4b60e26a187dc893"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projectile motion",
                                                      "id": "5ace20409fe7b01d5806c1bf",
                                                      "_id": "606e351a4b60e26a187dc890",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5d",
                                                              "_id": "606e351a4b60e26a187dc891"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Time & Velocity time graph",
                                                      "id": "5ace20409fe7b01d5806c1c0",
                                                      "_id": "606e351a4b60e26a187dc88e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5e",
                                                              "_id": "606e351a4b60e26a187dc88f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Uniform Circular Motion",
                                                      "id": "5ace20409fe7b01d5806c1c1",
                                                      "_id": "606e351a4b60e26a187dc88c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de5f",
                                                              "_id": "606e351a4b60e26a187dc88d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd72",
                                                      "_id": "606e351a4b60e26a187dc89c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sound",
                                              "id": "5ace20329fe7b01d5806bcb3",
                                              "_id": "606e351a4b60e26a187dc87d",
                                              "concepts": [
                                                  {
                                                      "name": "Pitch, Loudness of sound, Timber & Intensity of sound",
                                                      "id": "5ace20409fe7b01d5806c1c2",
                                                      "_id": "606e351a4b60e26a187dc888",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de60",
                                                              "_id": "606e351a4b60e26a187dc889"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reflection of sound & ECHO",
                                                      "id": "5ace20409fe7b01d5806c1c3",
                                                      "_id": "606e351a4b60e26a187dc886",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de61",
                                                              "_id": "606e351a4b60e26a187dc887"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between frequency, velocity and wave length",
                                                      "id": "5ace20409fe7b01d5806c1c4",
                                                      "_id": "606e351a4b60e26a187dc884",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de62",
                                                              "_id": "606e351a4b60e26a187dc885"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time period of simple pendulum",
                                                      "id": "5ace20409fe7b01d5806c1c5",
                                                      "_id": "606e351a4b60e26a187dc882",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de63",
                                                              "_id": "606e351a4b60e26a187dc883"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of waves , Amplitude , Time Period & Frequency",
                                                      "id": "5ace20409fe7b01d5806c1c6",
                                                      "_id": "606e351a4b60e26a187dc880",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de64",
                                                              "_id": "606e351a4b60e26a187dc881"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ultrasonic waves and its application",
                                                      "id": "5ace20409fe7b01d5806c1c7",
                                                      "_id": "606e351a4b60e26a187dc87e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de65",
                                                              "_id": "606e351a4b60e26a187dc87f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd73",
                                                      "_id": "606e351a4b60e26a187dc88a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sources of Energy",
                                              "id": "5ace20329fe7b01d5806bcb4",
                                              "_id": "606e351a4b60e26a187dc873",
                                              "concepts": [
                                                  {
                                                      "name": "Characteristics of sources of energy & Renewable and Non-Renewable Forms of Energy",
                                                      "id": "5ace20409fe7b01d5806c1c8",
                                                      "_id": "606e351a4b60e26a187dc87a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de66",
                                                              "_id": "606e351a4b60e26a187dc87b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fuels and its types & Characteristics of Fuels",
                                                      "id": "5ace20409fe7b01d5806c1c9",
                                                      "_id": "606e351a4b60e26a187dc878",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de67",
                                                              "_id": "606e351a4b60e26a187dc879"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fssion, Nuclear Fusion & Nuclear Reactor",
                                                      "id": "5ace20409fe7b01d5806c1ca",
                                                      "_id": "606e351a4b60e26a187dc876",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de68",
                                                              "_id": "606e351a4b60e26a187dc877"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Energy ( Solar, Wind, Hydro, Geo Thermal and Ocean Thermal)",
                                                      "id": "5ace20409fe7b01d5806c1cb",
                                                      "_id": "606e351a4b60e26a187dc874",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de69",
                                                              "_id": "606e351a4b60e26a187dc875"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd74",
                                                      "_id": "606e351a4b60e26a187dc87c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work, Energy & Power",
                                              "id": "5ace20329fe7b01d5806bcb5",
                                              "_id": "606e351a4b60e26a187dc865",
                                              "concepts": [
                                                  {
                                                      "name": "Conservation of energy",
                                                      "id": "5ace20419fe7b01d5806c1cc",
                                                      "_id": "606e351a4b60e26a187dc870",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6a",
                                                              "_id": "606e351a4b60e26a187dc871"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy & Different forms of energy",
                                                      "id": "5ace20419fe7b01d5806c1cd",
                                                      "_id": "606e351a4b60e26a187dc86e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6b",
                                                              "_id": "606e351a4b60e26a187dc86f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kinetic energy and Momentum",
                                                      "id": "5ace20419fe7b01d5806c1ce",
                                                      "_id": "606e351a4b60e26a187dc86c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6c",
                                                              "_id": "606e351a4b60e26a187dc86d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential energy & Kinetic energy",
                                                      "id": "5ace20419fe7b01d5806c1cf",
                                                      "_id": "606e351a4b60e26a187dc86a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6d",
                                                              "_id": "606e351a4b60e26a187dc86b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work done",
                                                      "id": "5ace20419fe7b01d5806c1d0",
                                                      "_id": "606e351a4b60e26a187dc868",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6e",
                                                              "_id": "606e351a4b60e26a187dc869"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work energy theorem",
                                                      "id": "5ace20419fe7b01d5806c1d1",
                                                      "_id": "606e351a4b60e26a187dc866",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de6f",
                                                              "_id": "606e351a4b60e26a187dc867"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd75",
                                                      "_id": "606e351a4b60e26a187dc872"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d920",
                                              "_id": "606e351a4b60e26a187dca59"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Analogy",
                                              "id": "5ace20309fe7b01d5806bc13",
                                              "_id": "606e351a4b60e26a187dc85c",
                                              "concepts": [
                                                  {
                                                      "name": "Letter Analogy",
                                                      "id": "5ace20389fe7b01d5806bef9",
                                                      "_id": "606e351a4b60e26a187dc861",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df3e",
                                                              "_id": "606e351a4b60e26a187dc862"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number Analogy",
                                                      "id": "5ace20389fe7b01d5806befa",
                                                      "_id": "606e351a4b60e26a187dc85f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df3f",
                                                              "_id": "606e351a4b60e26a187dc860"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word Analogy",
                                                      "id": "5ace20389fe7b01d5806befb",
                                                      "_id": "606e351a4b60e26a187dc85d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df40",
                                                              "_id": "606e351a4b60e26a187dc85e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df34",
                                                      "_id": "606e351a4b60e26a187dc863"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Chart Logic",
                                              "id": "5ace20309fe7b01d5806bc14",
                                              "_id": "606e351a4b60e26a187dc858",
                                              "concepts": [
                                                  {
                                                      "name": "Inserting missing character",
                                                      "id": "5ace20389fe7b01d5806befc",
                                                      "_id": "606e351a4b60e26a187dc859",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df41",
                                                              "_id": "606e351a4b60e26a187dc85a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df35",
                                                      "_id": "606e351a4b60e26a187dc85b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Classification",
                                              "id": "5ace20309fe7b01d5806bc15",
                                              "_id": "606e351a4b60e26a187dc850",
                                              "concepts": [
                                                  {
                                                      "name": "Letter Classification",
                                                      "id": "5ace20389fe7b01d5806befd",
                                                      "_id": "606e351a4b60e26a187dc855",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df42",
                                                              "_id": "606e351a4b60e26a187dc856"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number Classification",
                                                      "id": "5ace20389fe7b01d5806befe",
                                                      "_id": "606e351a4b60e26a187dc853",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df43",
                                                              "_id": "606e351a4b60e26a187dc854"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word Classification",
                                                      "id": "5ace20389fe7b01d5806beff",
                                                      "_id": "606e351a4b60e26a187dc851",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df44",
                                                              "_id": "606e351a4b60e26a187dc852"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df36",
                                                      "_id": "606e351a4b60e26a187dc857"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Figure Formation and Analogy",
                                              "id": "5ace20309fe7b01d5806bc16",
                                              "_id": "606e351a4b60e26a187dc84c",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Formation",
                                                      "id": "5ace20389fe7b01d5806bf00",
                                                      "_id": "606e351a4b60e26a187dc84d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df45",
                                                              "_id": "606e351a4b60e26a187dc84e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df37",
                                                      "_id": "606e351a4b60e26a187dc84f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Figure Matrix",
                                              "id": "5ace20309fe7b01d5806bc17",
                                              "_id": "606e351a4b60e26a187dc848",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Matrix",
                                                      "id": "5ace20389fe7b01d5806bf01",
                                                      "_id": "606e351a4b60e26a187dc849",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df46",
                                                              "_id": "606e351a4b60e26a187dc84a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df38",
                                                      "_id": "606e351a4b60e26a187dc84b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "606e351a4b60e26a187dc864"
                                          }
                                      ]
                                  }
                              ]
                          }
                      ],
                      "subjects": [
                          {
                              "name": "Mathematics",
                              "id": "5ace202e9fe7b01d5806bb8e",
                              "chapterCount": 80
                          },
                          {
                              "name": "Physics",
                              "id": "5ace202e9fe7b01d5806bb8f",
                              "chapterCount": 27
                          },
                          {
                              "name": "LOGICAL REASONING",
                              "id": "5ace202e9fe7b01d5806bb8c",
                              "chapterCount": 5
                          }
                      ],
                      "isRevision": false,
                      "description": ""
                  },
                  {
                      "name": "Phase 34*7",
                      "startDate": "2021-05-09T00:00:00.000Z",
                      "endDate": "2021-06-10T00:00:00.000Z",
                      "_id": "606e351a4b60e26a187dc1b5",
                      "milestoneTests": [],
                      "weeks": [
                          {
                              "weekNo": 2,
                              "startDate": "2021-05-09T00:00:00.000Z",
                              "endDate": "2021-05-09T00:00:00.000Z",
                              "_id": "606e351a4b60e26a187dc1b6",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Algebra",
                                              "id": "5f68726f058075680d815e27",
                                              "_id": "606e351a4b60e26a187dc843",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d989",
                                                      "_id": "606e351a4b60e26a187dc844"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics And Probability",
                                              "id": "5f68726f058075680d815e2c",
                                              "_id": "606e351a4b60e26a187dc841",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98a",
                                                      "_id": "606e351a4b60e26a187dc842"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Relations And Functions",
                                              "id": "5f68726f058075680d815e25",
                                              "_id": "606e351a4b60e26a187dc83f",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98b",
                                                      "_id": "606e351a4b60e26a187dc840"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5f68726f058075680d815e2a",
                                              "_id": "606e351a4b60e26a187dc83d",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98c",
                                                      "_id": "606e351a4b60e26a187dc83e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f68726f058075680d815e28",
                                              "_id": "606e351a4b60e26a187dc83b",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98d",
                                                      "_id": "606e351a4b60e26a187dc83c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Determinants",
                                              "id": "5ace20319fe7b01d5806bc85",
                                              "_id": "606e351a4b60e26a187dc833",
                                              "concepts": [
                                                  {
                                                      "name": "Cramer's rule for simultaneous linear equation, Solution of homogeneous linear equation (trivial and non-trivial solutions)",
                                                      "id": "5ace203c9fe7b01d5806c068",
                                                      "_id": "606e351a4b60e26a187dc838",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4d",
                                                              "_id": "606e351a4b60e26a187dc839"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Determinants and its basic question, types of determinants, Properties of determinants and multiplication of determinants",
                                                      "id": "5ace203c9fe7b01d5806c069",
                                                      "_id": "606e351a4b60e26a187dc836",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4e",
                                                              "_id": "606e351a4b60e26a187dc837"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Summation, differentation of determinant, Integration of determinant",
                                                      "id": "5ace203c9fe7b01d5806c06a",
                                                      "_id": "606e351a4b60e26a187dc834",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4f",
                                                              "_id": "606e351a4b60e26a187dc835"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98e",
                                                      "_id": "606e351a4b60e26a187dc83a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices",
                                              "id": "5ace20319fe7b01d5806bc86",
                                              "_id": "606e351a4b60e26a187dc825",
                                              "concepts": [
                                                  {
                                                      "name": "Adjoint of a matrices",
                                                      "id": "5ace203c9fe7b01d5806c06b",
                                                      "_id": "606e351a4b60e26a187dc830",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db50",
                                                              "_id": "606e351a4b60e26a187dc831"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inverse, Inverse by row, column transformation",
                                                      "id": "5ace203c9fe7b01d5806c06c",
                                                      "_id": "606e351a4b60e26a187dc82e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db51",
                                                              "_id": "606e351a4b60e26a187dc82f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Othogonal matrices, idempotent, nilpotent, involutary, Hermittian, skew-Hermittian matrices",
                                                      "id": "5ace203c9fe7b01d5806c06d",
                                                      "_id": "606e351a4b60e26a187dc82c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db52",
                                                              "_id": "606e351a4b60e26a187dc82d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of system of linear equation",
                                                      "id": "5ace203c9fe7b01d5806c06e",
                                                      "_id": "606e351a4b60e26a187dc82a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db53",
                                                              "_id": "606e351a4b60e26a187dc82b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transpose of a matrices, symmetric, skew-symmetric",
                                                      "id": "5ace203c9fe7b01d5806c06f",
                                                      "_id": "606e351a4b60e26a187dc828",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db54",
                                                              "_id": "606e351a4b60e26a187dc829"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of matrices, addition, subtraction, multiplication Minors, co-factors",
                                                      "id": "5ace203c9fe7b01d5806c070",
                                                      "_id": "606e351a4b60e26a187dc826",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db55",
                                                              "_id": "606e351a4b60e26a187dc827"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98f",
                                                      "_id": "606e351a4b60e26a187dc832"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices",
                                              "id": "5ace20319fe7b01d5806bc87",
                                              "_id": "606e351a4b60e26a187dc81d",
                                              "concepts": [
                                                  {
                                                      "name": "Conjugate of a matrix",
                                                      "id": "5ace203c9fe7b01d5806c071",
                                                      "_id": "606e351a4b60e26a187dc822",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db56",
                                                              "_id": "606e351a4b60e26a187dc823"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equality of two matrices",
                                                      "id": "5ace203c9fe7b01d5806c072",
                                                      "_id": "606e351a4b60e26a187dc820",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db57",
                                                              "_id": "606e351a4b60e26a187dc821"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Using of determinant to explain some properties of adjoint of matrix",
                                                      "id": "5ace203d9fe7b01d5806c073",
                                                      "_id": "606e351a4b60e26a187dc81e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db58",
                                                              "_id": "606e351a4b60e26a187dc81f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d990",
                                                      "_id": "606e351a4b60e26a187dc824"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Permuations & Combinations",
                                              "id": "5ace20319fe7b01d5806bc88",
                                              "_id": "606e351a4b60e26a187dc81b",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d991",
                                                      "_id": "606e351a4b60e26a187dc81c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Permuations & Combinations",
                                              "id": "5ace20319fe7b01d5806bc89",
                                              "_id": "606e351a4b60e26a187dc7fd",
                                              "concepts": [
                                                  {
                                                      "name": "Arrangement in groups",
                                                      "id": "5ace203d9fe7b01d5806c074",
                                                      "_id": "606e351a4b60e26a187dc818",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db59",
                                                              "_id": "606e351a4b60e26a187dc819"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "C (n, 1) + C (n, 2) + ……+C(n, n) =2^n - 1.",
                                                      "id": "5ace203d9fe7b01d5806c075",
                                                      "_id": "606e351a4b60e26a187dc816",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5a",
                                                              "_id": "606e351a4b60e26a187dc817"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circular permutation",
                                                      "id": "5ace203d9fe7b01d5806c076",
                                                      "_id": "606e351a4b60e26a187dc814",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5b",
                                                              "_id": "606e351a4b60e26a187dc815"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combination (with repetition, without repetition), restricted combination",
                                                      "id": "5ace203d9fe7b01d5806c077",
                                                      "_id": "606e351a4b60e26a187dc812",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5c",
                                                              "_id": "606e351a4b60e26a187dc813"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De-arrangement principle",
                                                      "id": "5ace203d9fe7b01d5806c078",
                                                      "_id": "606e351a4b60e26a187dc810",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5d",
                                                              "_id": "606e351a4b60e26a187dc811"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distribution of things into boxes",
                                                      "id": "5ace203d9fe7b01d5806c079",
                                                      "_id": "606e351a4b60e26a187dc80e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5e",
                                                              "_id": "606e351a4b60e26a187dc80f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Divison into groups and distribution among persons",
                                                      "id": "5ace203d9fe7b01d5806c07a",
                                                      "_id": "606e351a4b60e26a187dc80c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5f",
                                                              "_id": "606e351a4b60e26a187dc80d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental principle of counting (multiplication, addition rule)",
                                                      "id": "5ace203d9fe7b01d5806c07b",
                                                      "_id": "606e351a4b60e26a187dc80a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db60",
                                                              "_id": "606e351a4b60e26a187dc80b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inclusion Exclusion Principle",
                                                      "id": "5ace203d9fe7b01d5806c07c",
                                                      "_id": "606e351a4b60e26a187dc808",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db61",
                                                              "_id": "606e351a4b60e26a187dc809"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear permutation (with repetition, without repetition), restricted permutation",
                                                      "id": "5ace203d9fe7b01d5806c07d",
                                                      "_id": "606e351a4b60e26a187dc806",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db62",
                                                              "_id": "606e351a4b60e26a187dc807"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multinomial theorem",
                                                      "id": "5ace203d9fe7b01d5806c07e",
                                                      "_id": "606e351a4b60e26a187dc804",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db63",
                                                              "_id": "606e351a4b60e26a187dc805"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Selection of atleast one thing and problems related to divisors, exponent of prime 'p' in n!",
                                                      "id": "5ace203d9fe7b01d5806c07f",
                                                      "_id": "606e351a4b60e26a187dc802",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db64",
                                                              "_id": "606e351a4b60e26a187dc803"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of division of a composite number",
                                                      "id": "5ace203d9fe7b01d5806c080",
                                                      "_id": "606e351a4b60e26a187dc800",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db65",
                                                              "_id": "606e351a4b60e26a187dc801"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "total no of divisors of a number",
                                                      "id": "5ace203d9fe7b01d5806c081",
                                                      "_id": "606e351a4b60e26a187dc7fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db66",
                                                              "_id": "606e351a4b60e26a187dc7ff"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d992",
                                                      "_id": "606e351a4b60e26a187dc81a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ace20319fe7b01d5806bc8a",
                                              "_id": "606e351a4b60e26a187dc7fb",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d993",
                                                      "_id": "606e351a4b60e26a187dc7fc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ace20319fe7b01d5806bc8b",
                                              "_id": "606e351a4b60e26a187dc7d5",
                                              "concepts": [
                                                  {
                                                      "name": "Addition theorem of probability",
                                                      "id": "5ace203d9fe7b01d5806c082",
                                                      "_id": "606e351a4b60e26a187dc7f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db67",
                                                              "_id": "606e351a4b60e26a187dc7f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Addition theorem of probability",
                                                      "id": "5ace203d9fe7b01d5806c083",
                                                      "_id": "606e351a4b60e26a187dc7f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db68",
                                                              "_id": "606e351a4b60e26a187dc7f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial theorem on probability, Binomial distribution",
                                                      "id": "5ace203d9fe7b01d5806c084",
                                                      "_id": "606e351a4b60e26a187dc7f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db69",
                                                              "_id": "606e351a4b60e26a187dc7f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classical definition of probability",
                                                      "id": "5ace203d9fe7b01d5806c085",
                                                      "_id": "606e351a4b60e26a187dc7f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6a",
                                                              "_id": "606e351a4b60e26a187dc7f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exhaustive events",
                                                      "id": "5ace203d9fe7b01d5806c086",
                                                      "_id": "606e351a4b60e26a187dc7f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6b",
                                                              "_id": "606e351a4b60e26a187dc7f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multinomial theorem on probablity",
                                                      "id": "5ace203d9fe7b01d5806c087",
                                                      "_id": "606e351a4b60e26a187dc7ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6c",
                                                              "_id": "606e351a4b60e26a187dc7ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mutually exclusive events",
                                                      "id": "5ace203d9fe7b01d5806c088",
                                                      "_id": "606e351a4b60e26a187dc7ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6d",
                                                              "_id": "606e351a4b60e26a187dc7ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Bay`s theorem",
                                                      "id": "5ace203d9fe7b01d5806c089",
                                                      "_id": "606e351a4b60e26a187dc7ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6e",
                                                              "_id": "606e351a4b60e26a187dc7eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Compound probablity",
                                                      "id": "5ace203d9fe7b01d5806c08a",
                                                      "_id": "606e351a4b60e26a187dc7e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6f",
                                                              "_id": "606e351a4b60e26a187dc7e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Conditional probablity",
                                                      "id": "5ace203d9fe7b01d5806c08b",
                                                      "_id": "606e351a4b60e26a187dc7e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db70",
                                                              "_id": "606e351a4b60e26a187dc7e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on equally likely events,",
                                                      "id": "5ace203d9fe7b01d5806c08c",
                                                      "_id": "606e351a4b60e26a187dc7e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db71",
                                                              "_id": "606e351a4b60e26a187dc7e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on independent events,",
                                                      "id": "5ace203d9fe7b01d5806c08d",
                                                      "_id": "606e351a4b60e26a187dc7e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db72",
                                                              "_id": "606e351a4b60e26a187dc7e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on mixed events",
                                                      "id": "5ace203d9fe7b01d5806c08e",
                                                      "_id": "606e351a4b60e26a187dc7e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db73",
                                                              "_id": "606e351a4b60e26a187dc7e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on mutually exclusive events, exhaustive events,",
                                                      "id": "5ace203d9fe7b01d5806c08f",
                                                      "_id": "606e351a4b60e26a187dc7de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db74",
                                                              "_id": "606e351a4b60e26a187dc7df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on repeated trials",
                                                      "id": "5ace203d9fe7b01d5806c090",
                                                      "_id": "606e351a4b60e26a187dc7dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db75",
                                                              "_id": "606e351a4b60e26a187dc7dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Total probability theorem",
                                                      "id": "5ace203d9fe7b01d5806c091",
                                                      "_id": "606e351a4b60e26a187dc7da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db76",
                                                              "_id": "606e351a4b60e26a187dc7db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on sample space, classsical definition of probability, complementary events",
                                                      "id": "5ace203d9fe7b01d5806c092",
                                                      "_id": "606e351a4b60e26a187dc7d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db77",
                                                              "_id": "606e351a4b60e26a187dc7d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random variable",
                                                      "id": "5ace203d9fe7b01d5806c093",
                                                      "_id": "606e351a4b60e26a187dc7d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db78",
                                                              "_id": "606e351a4b60e26a187dc7d7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d994",
                                                      "_id": "606e351a4b60e26a187dc7fa"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5ace20319fe7b01d5806bc8c",
                                              "_id": "606e351a4b60e26a187dc7cf",
                                              "concepts": [
                                                  {
                                                      "name": "Calculation of mean, median, mode of grouped and ungrouped data",
                                                      "id": "5ace203d9fe7b01d5806c094",
                                                      "_id": "606e351a4b60e26a187dc7d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db79",
                                                              "_id": "606e351a4b60e26a187dc7d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Calculation of standard deviation, variance and mean deviation for grouped and ungrouped data",
                                                      "id": "5ace203d9fe7b01d5806c095",
                                                      "_id": "606e351a4b60e26a187dc7d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7a",
                                                              "_id": "606e351a4b60e26a187dc7d1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d995",
                                                      "_id": "606e351a4b60e26a187dc7d4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Heights & Distances",
                                              "id": "5ace20319fe7b01d5806bc8d",
                                              "_id": "606e351a4b60e26a187dc7c7",
                                              "concepts": [
                                                  {
                                                      "name": "Problems based on angle of elevation, angle of depression",
                                                      "id": "5ace203d9fe7b01d5806c096",
                                                      "_id": "606e351a4b60e26a187dc7cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7b",
                                                              "_id": "606e351a4b60e26a187dc7cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems related to 2-Dimensional",
                                                      "id": "5ace203d9fe7b01d5806c097",
                                                      "_id": "606e351a4b60e26a187dc7ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7c",
                                                              "_id": "606e351a4b60e26a187dc7cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems related to 3-Dimensional",
                                                      "id": "5ace203d9fe7b01d5806c098",
                                                      "_id": "606e351a4b60e26a187dc7c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7d",
                                                              "_id": "606e351a4b60e26a187dc7c9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d996",
                                                      "_id": "606e351a4b60e26a187dc7ce"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc8e",
                                              "_id": "606e351a4b60e26a187dc7bf",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Maximum and minimum values",
                                                      "id": "5ace203d9fe7b01d5806c099",
                                                      "_id": "606e351a4b60e26a187dc7c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7e",
                                                              "_id": "606e351a4b60e26a187dc7c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on -Definition of inverse functions, Domain and Range, Graphs of inverse functions, properties of inverse functions",
                                                      "id": "5ace203d9fe7b01d5806c09a",
                                                      "_id": "606e351a4b60e26a187dc7c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7f",
                                                              "_id": "606e351a4b60e26a187dc7c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of series, Solution of Inverse trigonometric Equations",
                                                      "id": "5ace203d9fe7b01d5806c09b",
                                                      "_id": "606e351a4b60e26a187dc7c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db80",
                                                              "_id": "606e351a4b60e26a187dc7c1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d997",
                                                      "_id": "606e351a4b60e26a187dc7c6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometry /Inverse Circular Function",
                                              "id": "5ace20319fe7b01d5806bc8f",
                                              "_id": "606e351a4b60e26a187dc7b3",
                                              "concepts": [
                                                  {
                                                      "name": "Conversion of one ICF to other",
                                                      "id": "5ace203d9fe7b01d5806c09c",
                                                      "_id": "606e351a4b60e26a187dc7bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db81",
                                                              "_id": "606e351a4b60e26a187dc7bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inverse circular Function - domain & range",
                                                      "id": "5ace203d9fe7b01d5806c09d",
                                                      "_id": "606e351a4b60e26a187dc7ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db82",
                                                              "_id": "606e351a4b60e26a187dc7bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "problems based on inverse trigonometric function of trigonometric functions",
                                                      "id": "5ace203d9fe7b01d5806c09e",
                                                      "_id": "606e351a4b60e26a187dc7b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db83",
                                                              "_id": "606e351a4b60e26a187dc7b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "problems based on trigonometric functions of inverse trigonometric function",
                                                      "id": "5ace203d9fe7b01d5806c09f",
                                                      "_id": "606e351a4b60e26a187dc7b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db84",
                                                              "_id": "606e351a4b60e26a187dc7b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "sum & Difference of Two or more ICFs",
                                                      "id": "5ace203d9fe7b01d5806c0a0",
                                                      "_id": "606e351a4b60e26a187dc7b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db85",
                                                              "_id": "606e351a4b60e26a187dc7b5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d998",
                                                      "_id": "606e351a4b60e26a187dc7be"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Solution of Triangle",
                                              "id": "5ace20319fe7b01d5806bc90",
                                              "_id": "606e351a4b60e26a187dc7b1",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d999",
                                                      "_id": "606e351a4b60e26a187dc7b2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Solution of Triangle",
                                              "id": "5ace20319fe7b01d5806bc91",
                                              "_id": "606e351a4b60e26a187dc797",
                                              "concepts": [
                                                  {
                                                      "name": "Circles circumscribing or inscribing a regular Polygon",
                                                      "id": "5ace203d9fe7b01d5806c0a1",
                                                      "_id": "606e351a4b60e26a187dc7ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db86",
                                                              "_id": "606e351a4b60e26a187dc7af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circles Connected with a Triangle - Circumcircle, Incircle, Escribed Circles",
                                                      "id": "5ace203d9fe7b01d5806c0a2",
                                                      "_id": "606e351a4b60e26a187dc7ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db87",
                                                              "_id": "606e351a4b60e26a187dc7ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "cyclic quadrilaterals",
                                                      "id": "5ace203d9fe7b01d5806c0a3",
                                                      "_id": "606e351a4b60e26a187dc7aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db88",
                                                              "_id": "606e351a4b60e26a187dc7ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance of Circumcentre, incentre, orthocentre, centroid and ex-centre from the sides and vertices of the triangle, Distance between circumcentre and orthocentre, circmucentre and incentre, circum centre and excentre, Apolloneus theorem, length of median",
                                                      "id": "5ace203d9fe7b01d5806c0a4",
                                                      "_id": "606e351a4b60e26a187dc7a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db89",
                                                              "_id": "606e351a4b60e26a187dc7a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Half angle formula",
                                                      "id": "5ace203d9fe7b01d5806c0a5",
                                                      "_id": "606e351a4b60e26a187dc7a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8a",
                                                              "_id": "606e351a4b60e26a187dc7a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Heron's formula, Area of triangle",
                                                      "id": "5ace203d9fe7b01d5806c0a6",
                                                      "_id": "606e351a4b60e26a187dc7a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8b",
                                                              "_id": "606e351a4b60e26a187dc7a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on m-n theorem",
                                                      "id": "5ace203d9fe7b01d5806c0a7",
                                                      "_id": "606e351a4b60e26a187dc7a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8c",
                                                              "_id": "606e351a4b60e26a187dc7a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projection formula, Napier's Analogy",
                                                      "id": "5ace203d9fe7b01d5806c0a8",
                                                      "_id": "606e351a4b60e26a187dc7a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8d",
                                                              "_id": "606e351a4b60e26a187dc7a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sine Rule, Cosine Rule",
                                                      "id": "5ace203d9fe7b01d5806c0a9",
                                                      "_id": "606e351a4b60e26a187dc79e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8e",
                                                              "_id": "606e351a4b60e26a187dc79f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of Triangle - Two angles and included side are given",
                                                      "id": "5ace203d9fe7b01d5806c0aa",
                                                      "_id": "606e351a4b60e26a187dc79c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8f",
                                                              "_id": "606e351a4b60e26a187dc79d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of Triangle - Two sides and included angle are given",
                                                      "id": "5ace203d9fe7b01d5806c0ab",
                                                      "_id": "606e351a4b60e26a187dc79a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db90",
                                                              "_id": "606e351a4b60e26a187dc79b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Triangle including ambiguous cases",
                                                      "id": "5ace203d9fe7b01d5806c0ac",
                                                      "_id": "606e351a4b60e26a187dc798",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db91",
                                                              "_id": "606e351a4b60e26a187dc799"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99a",
                                                      "_id": "606e351a4b60e26a187dc7b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometric Equations",
                                              "id": "5ace20319fe7b01d5806bc92",
                                              "_id": "606e351a4b60e26a187dc795",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99b",
                                                      "_id": "606e351a4b60e26a187dc796"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometric Equations",
                                              "id": "5ace20329fe7b01d5806bc93",
                                              "_id": "606e351a4b60e26a187dc783",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Problems based on extreme values",
                                                      "id": "5ace203d9fe7b01d5806c0ad",
                                                      "_id": "606e351a4b60e26a187dc792",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db92",
                                                              "_id": "606e351a4b60e26a187dc793"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Simultaneous trigonometric equation - in one variable",
                                                      "id": "5ace203d9fe7b01d5806c0ae",
                                                      "_id": "606e351a4b60e26a187dc790",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db93",
                                                              "_id": "606e351a4b60e26a187dc791"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Simultaneous trigonometric equation - in two variable",
                                                      "id": "5ace203d9fe7b01d5806c0af",
                                                      "_id": "606e351a4b60e26a187dc78e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db94",
                                                              "_id": "606e351a4b60e26a187dc78f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - based on extreme values of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0b0",
                                                      "_id": "606e351a4b60e26a187dc78c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db95",
                                                              "_id": "606e351a4b60e26a187dc78d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - General Solution",
                                                      "id": "5ace203d9fe7b01d5806c0b1",
                                                      "_id": "606e351a4b60e26a187dc78a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db96",
                                                              "_id": "606e351a4b60e26a187dc78b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - in a given Interval",
                                                      "id": "5ace203d9fe7b01d5806c0b2",
                                                      "_id": "606e351a4b60e26a187dc788",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db97",
                                                              "_id": "606e351a4b60e26a187dc789"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - Priciple values",
                                                      "id": "5ace203d9fe7b01d5806c0b3",
                                                      "_id": "606e351a4b60e26a187dc786",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db98",
                                                              "_id": "606e351a4b60e26a187dc787"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Inequation",
                                                      "id": "5ace203d9fe7b01d5806c0b4",
                                                      "_id": "606e351a4b60e26a187dc784",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db99",
                                                              "_id": "606e351a4b60e26a187dc785"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99c",
                                                      "_id": "606e351a4b60e26a187dc794"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5ace20329fe7b01d5806bc94",
                                              "_id": "606e351a4b60e26a187dc77d",
                                              "concepts": [
                                                  {
                                                      "name": "Heights and distances",
                                                      "id": "5ace203d9fe7b01d5806c0b7",
                                                      "_id": "606e351a4b60e26a187dc780",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9a",
                                                              "_id": "606e351a4b60e26a187dc781"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c0",
                                                      "_id": "606e351a4b60e26a187dc77e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9b",
                                                              "_id": "606e351a4b60e26a187dc77f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99d",
                                                      "_id": "606e351a4b60e26a187dc782"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry Ratios & Identities",
                                              "id": "5ace20329fe7b01d5806bc95",
                                              "_id": "606e351a4b60e26a187dc77b",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99e",
                                                      "_id": "606e351a4b60e26a187dc77c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry Ratios & Identities",
                                              "id": "5ace20329fe7b01d5806bc96",
                                              "_id": "606e351a4b60e26a187dc763",
                                              "concepts": [
                                                  {
                                                      "name": "Conditional identities, trigonometric inequalities, trigonometrical graphs",
                                                      "id": "5ace203d9fe7b01d5806c0c1",
                                                      "_id": "606e351a4b60e26a187dc778",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9c",
                                                              "_id": "606e351a4b60e26a187dc779"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain & range of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c2",
                                                      "_id": "606e351a4b60e26a187dc776",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9d",
                                                              "_id": "606e351a4b60e26a187dc777"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Identities, compound angles, multiple angles, sub-multiple angles and transformations",
                                                      "id": "5ace203d9fe7b01d5806c0c3",
                                                      "_id": "606e351a4b60e26a187dc774",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9e",
                                                              "_id": "606e351a4b60e26a187dc775"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Maximum and minimum value of trigonometric function",
                                                      "id": "5ace203d9fe7b01d5806c0c4",
                                                      "_id": "606e351a4b60e26a187dc772",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9f",
                                                              "_id": "606e351a4b60e26a187dc773"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "polygons",
                                                      "id": "5ace203d9fe7b01d5806c0c5",
                                                      "_id": "606e351a4b60e26a187dc770",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba0",
                                                              "_id": "606e351a4b60e26a187dc771"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Principle, particular and general solution of trigonometrical equation, Conversion to lower degree, Conversion into quadratic form, change of variable",
                                                      "id": "5ace203d9fe7b01d5806c0c6",
                                                      "_id": "606e351a4b60e26a187dc76e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba1",
                                                              "_id": "606e351a4b60e26a187dc76f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of cosine, where angles are in G.P.",
                                                      "id": "5ace203d9fe7b01d5806c0c7",
                                                      "_id": "606e351a4b60e26a187dc76c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba2",
                                                              "_id": "606e351a4b60e26a187dc76d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sign of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c8",
                                                      "_id": "606e351a4b60e26a187dc76a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba3",
                                                              "_id": "606e351a4b60e26a187dc76b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Summation of sine/cosine series",
                                                      "id": "5ace203d9fe7b01d5806c0c9",
                                                      "_id": "606e351a4b60e26a187dc768",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba4",
                                                              "_id": "606e351a4b60e26a187dc769"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                      "id": "5ace203d9fe7b01d5806c0ca",
                                                      "_id": "606e351a4b60e26a187dc766",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba5",
                                                              "_id": "606e351a4b60e26a187dc767"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric ratios of sum & difference of two angles",
                                                      "id": "5ace203e9fe7b01d5806c0cb",
                                                      "_id": "606e351a4b60e26a187dc764",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba6",
                                                              "_id": "606e351a4b60e26a187dc765"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99f",
                                                      "_id": "606e351a4b60e26a187dc77a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "3-Dimensional Geometry",
                                              "id": "5ace20329fe7b01d5806bc97",
                                              "_id": "606e351a4b60e26a187dc761",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a0",
                                                      "_id": "606e351a4b60e26a187dc762"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "3-Dimensional Geometry",
                                              "id": "5ace20329fe7b01d5806bc98",
                                              "_id": "606e351a4b60e26a187dc741",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between a line and a plane, Planes bisecting the angles between two planes, Bisector of acute / obtuse angle, Distance of a point from a plane, Distance between two parallel planes",
                                                      "id": "5ace203e9fe7b01d5806c0cc",
                                                      "_id": "606e351a4b60e26a187dc75e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba7",
                                                              "_id": "606e351a4b60e26a187dc75f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle between two vectors, Projection of the join of two points",
                                                      "id": "5ace203e9fe7b01d5806c0cd",
                                                      "_id": "606e351a4b60e26a187dc75c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba8",
                                                              "_id": "606e351a4b60e26a187dc75d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency ( C. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0ce",
                                                      "_id": "606e351a4b60e26a187dc75a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba9",
                                                              "_id": "606e351a4b60e26a187dc75b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0cf",
                                                      "_id": "606e351a4b60e26a187dc758",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbaa",
                                                              "_id": "606e351a4b60e26a187dc759"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Direction cosines, Direction ratios",
                                                      "id": "5ace203e9fe7b01d5806c0d0",
                                                      "_id": "606e351a4b60e26a187dc756",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbab",
                                                              "_id": "606e351a4b60e26a187dc757"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance formula, Section formula, Centriod of a triangle, Centriod of a tetrahedron,",
                                                      "id": "5ace203e9fe7b01d5806c0d1",
                                                      "_id": "606e351a4b60e26a187dc754",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbac",
                                                              "_id": "606e351a4b60e26a187dc755"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d2",
                                                      "_id": "606e351a4b60e26a187dc752",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbad",
                                                              "_id": "606e351a4b60e26a187dc753"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere (C. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d3",
                                                      "_id": "606e351a4b60e26a187dc750",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbae",
                                                              "_id": "606e351a4b60e26a187dc751"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere the extremities of diameter being",
                                                      "id": "5ace203e9fe7b01d5806c0d4",
                                                      "_id": "606e351a4b60e26a187dc74e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbaf",
                                                              "_id": "606e351a4b60e26a187dc74f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere the extremities of diameter being given ( c. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d5",
                                                      "_id": "606e351a4b60e26a187dc74c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb0",
                                                              "_id": "606e351a4b60e26a187dc74d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere through four points ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d6",
                                                      "_id": "606e351a4b60e26a187dc74a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb1",
                                                              "_id": "606e351a4b60e26a187dc74b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane passing through three points, Plane passing through two points and parallel to a vector, Plane passing through two points and parallel to two vectors, Plane parallel to a given plane, Angle between two planes",
                                                      "id": "5ace203e9fe7b01d5806c0d7",
                                                      "_id": "606e351a4b60e26a187dc748",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb2",
                                                              "_id": "606e351a4b60e26a187dc749"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane-General equation of plane, Plane in normal form, Transformation of general form of normal form, Plane passing through a point and perpendicular to a vector, Equation of a plane in intercept form",
                                                      "id": "5ace203e9fe7b01d5806c0d8",
                                                      "_id": "606e351a4b60e26a187dc746",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb3",
                                                              "_id": "606e351a4b60e26a187dc747"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Planes passing through the intersection of two planes, Two sides of a plane, Condition for a line to lie in a plane, Condition for two lines to be intersecting coplaner and the plane containing them, Area of Figures (Traingle etc.) in 3-Dimensional space",
                                                      "id": "5ace203e9fe7b01d5806c0d9",
                                                      "_id": "606e351a4b60e26a187dc744",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb4",
                                                              "_id": "606e351a4b60e26a187dc745"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Straight Line-through a point and parallel to a vector, Line passing through two points, Angle between two lines, Perpendicular from a point to a line, Shortest distance between two lines",
                                                      "id": "5ace203e9fe7b01d5806c0da",
                                                      "_id": "606e351a4b60e26a187dc742",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb5",
                                                              "_id": "606e351a4b60e26a187dc743"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a1",
                                                      "_id": "606e351a4b60e26a187dc760"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector",
                                              "id": "5ace20329fe7b01d5806bc99",
                                              "_id": "606e351a4b60e26a187dc73f",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a2",
                                                      "_id": "606e351a4b60e26a187dc740"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector",
                                              "id": "5ace20329fe7b01d5806bc9a",
                                              "_id": "606e351a4b60e26a187dc70d",
                                              "concepts": [
                                                  {
                                                      "name": "Component of a vector",
                                                      "id": "5ace203e9fe7b01d5806c0db",
                                                      "_id": "606e351a4b60e26a187dc73c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb6",
                                                              "_id": "606e351a4b60e26a187dc73d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Component of a vector",
                                                      "id": "5ace203e9fe7b01d5806c0dc",
                                                      "_id": "606e351a4b60e26a187dc73a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb7",
                                                              "_id": "606e351a4b60e26a187dc73b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cross product of two vectors and its application",
                                                      "id": "5ace203e9fe7b01d5806c0dd",
                                                      "_id": "606e351a4b60e26a187dc738",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb8",
                                                              "_id": "606e351a4b60e26a187dc739"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dot product of two vectors and its application",
                                                      "id": "5ace203e9fe7b01d5806c0de",
                                                      "_id": "606e351a4b60e26a187dc736",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb9",
                                                              "_id": "606e351a4b60e26a187dc737"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical application of vectors-plane, parallel planes, angle between planes, length of perpendicular from a point on the plane, point of intersection of a straight line and a plane, angle between two planes",
                                                      "id": "5ace203e9fe7b01d5806c0df",
                                                      "_id": "606e351a4b60e26a187dc734",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbba",
                                                              "_id": "606e351a4b60e26a187dc735"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical application of vectors-straight line, angle between straight line, point of intersection of straight line, distance between two straight lines, distance of a point from a straight line, angle bisector",
                                                      "id": "5ace203e9fe7b01d5806c0e0",
                                                      "_id": "606e351a4b60e26a187dc732",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbb",
                                                              "_id": "606e351a4b60e26a187dc733"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical interpretation",
                                                      "id": "5ace203e9fe7b01d5806c0e1",
                                                      "_id": "606e351a4b60e26a187dc730",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbc",
                                                              "_id": "606e351a4b60e26a187dc731"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical interpretation of cross product",
                                                      "id": "5ace203e9fe7b01d5806c0e2",
                                                      "_id": "606e351a4b60e26a187dc72e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbd",
                                                              "_id": "606e351a4b60e26a187dc72f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Image of a plane in a plane, image of a line in a plane, image of a point in a plane, image of a point in a line",
                                                      "id": "5ace203e9fe7b01d5806c0e3",
                                                      "_id": "606e351a4b60e26a187dc72c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbe",
                                                              "_id": "606e351a4b60e26a187dc72d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear combination",
                                                      "id": "5ace203e9fe7b01d5806c0e4",
                                                      "_id": "606e351a4b60e26a187dc72a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbf",
                                                              "_id": "606e351a4b60e26a187dc72b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear combination, Linearly dependent or independent",
                                                      "id": "5ace203e9fe7b01d5806c0e5",
                                                      "_id": "606e351a4b60e26a187dc728",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc0",
                                                              "_id": "606e351a4b60e26a187dc729"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear dependent or independent",
                                                      "id": "5ace203e9fe7b01d5806c0e6",
                                                      "_id": "606e351a4b60e26a187dc726",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc1",
                                                              "_id": "606e351a4b60e26a187dc727"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment of a force",
                                                      "id": "5ace203e9fe7b01d5806c0e7",
                                                      "_id": "606e351a4b60e26a187dc724",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc2",
                                                              "_id": "606e351a4b60e26a187dc725"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on collinearity of three points, two vectors, four points, three vectors",
                                                      "id": "5ace203e9fe7b01d5806c0e8",
                                                      "_id": "606e351a4b60e26a187dc722",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc3",
                                                              "_id": "606e351a4b60e26a187dc723"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on magnitude of vectors, Types of vectors, Addition and subtraction of vectors, Position vectors, Section formula (internal/external),",
                                                      "id": "5ace203e9fe7b01d5806c0e9",
                                                      "_id": "606e351a4b60e26a187dc720",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc4",
                                                              "_id": "606e351a4b60e26a187dc721"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of four vector",
                                                      "id": "5ace203e9fe7b01d5806c0ea",
                                                      "_id": "606e351a4b60e26a187dc71e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc5",
                                                              "_id": "606e351a4b60e26a187dc71f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of two vectors",
                                                      "id": "5ace203e9fe7b01d5806c0eb",
                                                      "_id": "606e351a4b60e26a187dc71c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc6",
                                                              "_id": "606e351a4b60e26a187dc71d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reciprocal system of vectors and solution of vector equation",
                                                      "id": "5ace203e9fe7b01d5806c0ec",
                                                      "_id": "606e351a4b60e26a187dc71a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc7",
                                                              "_id": "606e351a4b60e26a187dc71b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar product",
                                                      "id": "5ace203e9fe7b01d5806c0ed",
                                                      "_id": "606e351a4b60e26a187dc718",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc8",
                                                              "_id": "606e351a4b60e26a187dc719"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar triple product",
                                                      "id": "5ace203e9fe7b01d5806c0ee",
                                                      "_id": "606e351a4b60e26a187dc716",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc9",
                                                              "_id": "606e351a4b60e26a187dc717"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Triple product",
                                                      "id": "5ace203e9fe7b01d5806c0ef",
                                                      "_id": "606e351a4b60e26a187dc714",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbca",
                                                              "_id": "606e351a4b60e26a187dc715"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector product",
                                                      "id": "5ace203e9fe7b01d5806c0f0",
                                                      "_id": "606e351a4b60e26a187dc712",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcb",
                                                              "_id": "606e351a4b60e26a187dc713"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector triple product",
                                                      "id": "5ace203e9fe7b01d5806c0f1",
                                                      "_id": "606e351a4b60e26a187dc710",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcc",
                                                              "_id": "606e351a4b60e26a187dc711"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work done",
                                                      "id": "5ace203e9fe7b01d5806c0f2",
                                                      "_id": "606e351a4b60e26a187dc70e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcd",
                                                              "_id": "606e351a4b60e26a187dc70f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a3",
                                                      "_id": "606e351a4b60e26a187dc73e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Real Number",
                                              "id": "5ec36b98f05a6036ccbb380c",
                                              "_id": "606e351a4b60e26a187dc703",
                                              "concepts": [
                                                  {
                                                      "name": "Fundamental Theorem of Arithmetic",
                                                      "id": "5ec36bfce56f4536c61841ec",
                                                      "_id": "606e351a4b60e26a187dc70a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbce",
                                                              "_id": "606e351a4b60e26a187dc70b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid's Division Lemma",
                                                      "id": "5ec36bfce56f4536c61841eb",
                                                      "_id": "606e351a4b60e26a187dc708",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcf",
                                                              "_id": "606e351a4b60e26a187dc709"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Decimal Expansion of Rational Numbers",
                                                      "id": "5ec36bfce56f4536c61841ee",
                                                      "_id": "606e351a4b60e26a187dc706",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd0",
                                                              "_id": "606e351a4b60e26a187dc707"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Review of Irrational Numbers",
                                                      "id": "5ec36bfce56f4536c61841ed",
                                                      "_id": "606e351a4b60e26a187dc704",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd1",
                                                              "_id": "606e351a4b60e26a187dc705"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a4",
                                                      "_id": "606e351a4b60e26a187dc70c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Triangles",
                                              "id": "5ec36b98f05a6036ccbb3811",
                                              "_id": "606e351a4b60e26a187dc6f3",
                                              "concepts": [
                                                  {
                                                      "name": "SSS Criterion of Similarity of Two Triangles",
                                                      "id": "5ec37036f05a6036ccbb387d",
                                                      "_id": "606e351a4b60e26a187dc700",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd2",
                                                              "_id": "606e351a4b60e26a187dc701"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "SAS Criterion of Similarity of Two Triangles",
                                                      "id": "5ec37036f05a6036ccbb387e",
                                                      "_id": "606e351a4b60e26a187dc6fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd3",
                                                              "_id": "606e351a4b60e26a187dc6ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pythagoras Theorem and Its Converse",
                                                      "id": "5ec37036f05a6036ccbb3880",
                                                      "_id": "606e351a4b60e26a187dc6fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd4",
                                                              "_id": "606e351a4b60e26a187dc6fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Similarity of Triangles",
                                                      "id": "5ec37036f05a6036ccbb387b",
                                                      "_id": "606e351a4b60e26a187dc6fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd5",
                                                              "_id": "606e351a4b60e26a187dc6fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "AAA Criterion of Similarity of Two Triangles",
                                                      "id": "5ec37036f05a6036ccbb387c",
                                                      "_id": "606e351a4b60e26a187dc6f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd6",
                                                              "_id": "606e351a4b60e26a187dc6f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Areas of Similar Triangles",
                                                      "id": "5ec37036f05a6036ccbb387f",
                                                      "_id": "606e351a4b60e26a187dc6f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd7",
                                                              "_id": "606e351a4b60e26a187dc6f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Similar Figures",
                                                      "id": "5ec37036f05a6036ccbb387a",
                                                      "_id": "606e351a4b60e26a187dc6f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd8",
                                                              "_id": "606e351a4b60e26a187dc6f5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a5",
                                                      "_id": "606e351a4b60e26a187dc702"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions",
                                              "id": "5ec36b98f05a6036ccbb3816",
                                              "_id": "606e351a4b60e26a187dc6eb",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of Tangents to a Circle",
                                                      "id": "5ec377853d2b7e3af65ff176",
                                                      "_id": "606e351a4b60e26a187dc6f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd9",
                                                              "_id": "606e351a4b60e26a187dc6f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Division of a Line Segment",
                                                      "id": "5ec377853d2b7e3af65ff174",
                                                      "_id": "606e351a4b60e26a187dc6ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbda",
                                                              "_id": "606e351a4b60e26a187dc6ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Similar to a Given Triangle as per Given Scale Factor",
                                                      "id": "5ec377853d2b7e3af65ff175",
                                                      "_id": "606e351a4b60e26a187dc6ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdb",
                                                              "_id": "606e351a4b60e26a187dc6ed"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a6",
                                                      "_id": "606e351a4b60e26a187dc6f2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials",
                                              "id": "5ec36b98f05a6036ccbb380d",
                                              "_id": "606e351a4b60e26a187dc6e1",
                                              "concepts": [
                                                  {
                                                      "name": "Division Algorithm of Polynomials",
                                                      "id": "5ec36c363d2b7e3af65fefb3",
                                                      "_id": "606e351a4b60e26a187dc6e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdc",
                                                              "_id": "606e351a4b60e26a187dc6e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relationship between Zeroes and Coefficient of a Quadratic Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb1",
                                                      "_id": "606e351a4b60e26a187dc6e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdd",
                                                              "_id": "606e351a4b60e26a187dc6e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relationship between Zeroes and Coefficient of a Cubic Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb2",
                                                      "_id": "606e351a4b60e26a187dc6e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbde",
                                                              "_id": "606e351a4b60e26a187dc6e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Zeros of a Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb0",
                                                      "_id": "606e351a4b60e26a187dc6e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdf",
                                                              "_id": "606e351a4b60e26a187dc6e3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a7",
                                                      "_id": "606e351a4b60e26a187dc6ea"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5ec36b98f05a6036ccbb3812",
                                              "_id": "606e351a4b60e26a187dc6d9",
                                              "concepts": [
                                                  {
                                                      "name": "Area of a Triangle",
                                                      "id": "5ec370763d2b7e3af65ff041",
                                                      "_id": "606e351a4b60e26a187dc6de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe0",
                                                              "_id": "606e351a4b60e26a187dc6df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance Formula",
                                                      "id": "5ec370763d2b7e3af65ff03f",
                                                      "_id": "606e351a4b60e26a187dc6dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe1",
                                                              "_id": "606e351a4b60e26a187dc6dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Section Formula",
                                                      "id": "5ec370763d2b7e3af65ff040",
                                                      "_id": "606e351a4b60e26a187dc6da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe2",
                                                              "_id": "606e351a4b60e26a187dc6db"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a8",
                                                      "_id": "606e351a4b60e26a187dc6e0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Areas Related to Circles",
                                              "id": "5ec36b98f05a6036ccbb3817",
                                              "_id": "606e351a4b60e26a187dc6cf",
                                              "concepts": [
                                                  {
                                                      "name": "Perimeter and Area of a Circle",
                                                      "id": "5ec377d2e56f4536c61843cd",
                                                      "_id": "606e351a4b60e26a187dc6d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe3",
                                                              "_id": "606e351a4b60e26a187dc6d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of Segment of a Circle",
                                                      "id": "5ec377d2e56f4536c61843cf",
                                                      "_id": "606e351a4b60e26a187dc6d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe4",
                                                              "_id": "606e351a4b60e26a187dc6d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of Sector of a Circle",
                                                      "id": "5ec377d2e56f4536c61843ce",
                                                      "_id": "606e351a4b60e26a187dc6d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe5",
                                                              "_id": "606e351a4b60e26a187dc6d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Areas of Combinations of Plane Figures",
                                                      "id": "5ec377d2e56f4536c61843d0",
                                                      "_id": "606e351a4b60e26a187dc6d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe6",
                                                              "_id": "606e351a4b60e26a187dc6d1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a9",
                                                      "_id": "606e351a4b60e26a187dc6d8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Pair of Linear Equations in Two Variables",
                                              "id": "5ec36b98f05a6036ccbb380e",
                                              "_id": "606e351a4b60e26a187dc6bf",
                                              "concepts": [
                                                  {
                                                      "name": "Pair of Linear Equations in Two Variables",
                                                      "id": "5ec36c873d2b7e3af65fefba",
                                                      "_id": "606e351a4b60e26a187dc6cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe7",
                                                              "_id": "606e351a4b60e26a187dc6cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cross Multiplication Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbe",
                                                      "_id": "606e351a4b60e26a187dc6ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe8",
                                                              "_id": "606e351a4b60e26a187dc6cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditions for Solvability",
                                                      "id": "5ec36c873d2b7e3af65fefbf",
                                                      "_id": "606e351a4b60e26a187dc6c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe9",
                                                              "_id": "606e351a4b60e26a187dc6c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Elimination Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbd",
                                                      "_id": "606e351a4b60e26a187dc6c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbea",
                                                              "_id": "606e351a4b60e26a187dc6c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Method of Solution of a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbb",
                                                      "_id": "606e351a4b60e26a187dc6c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbeb",
                                                              "_id": "606e351a4b60e26a187dc6c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations Reducible to a Pair of Linear Equations in Two Variables",
                                                      "id": "5ec36c873d2b7e3af65fefc0",
                                                      "_id": "606e351a4b60e26a187dc6c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbec",
                                                              "_id": "606e351a4b60e26a187dc6c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Substitution Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbc",
                                                      "_id": "606e351a4b60e26a187dc6c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbed",
                                                              "_id": "606e351a4b60e26a187dc6c1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9aa",
                                                      "_id": "606e351a4b60e26a187dc6ce"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction to Trigonometry",
                                              "id": "5ec36b98f05a6036ccbb3813",
                                              "_id": "606e351a4b60e26a187dc6b5",
                                              "concepts": [
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5ec370e6e56f4536c618425a",
                                                      "_id": "606e351a4b60e26a187dc6bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbee",
                                                              "_id": "606e351a4b60e26a187dc6bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Complementary Angles",
                                                      "id": "5ec370e6e56f4536c6184259",
                                                      "_id": "606e351a4b60e26a187dc6ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbef",
                                                              "_id": "606e351a4b60e26a187dc6bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios",
                                                      "id": "5ec370e6e56f4536c6184257",
                                                      "_id": "606e351a4b60e26a187dc6b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf0",
                                                              "_id": "606e351a4b60e26a187dc6b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Some Specific Angles",
                                                      "id": "5ec370e6e56f4536c6184258",
                                                      "_id": "606e351a4b60e26a187dc6b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf1",
                                                              "_id": "606e351a4b60e26a187dc6b7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ab",
                                                      "_id": "606e351a4b60e26a187dc6be"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Areas and Volumes",
                                              "id": "5ec36b98f05a6036ccbb3818",
                                              "_id": "606e351a4b60e26a187dc6ab",
                                              "concepts": [
                                                  {
                                                      "name": "Frustum of a Cone",
                                                      "id": "5ec3783d497e903afb98dc9f",
                                                      "_id": "606e351a4b60e26a187dc6b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf2",
                                                              "_id": "606e351a4b60e26a187dc6b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Combination of Solids",
                                                      "id": "5ec3783d497e903afb98dc9d",
                                                      "_id": "606e351a4b60e26a187dc6b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf3",
                                                              "_id": "606e351a4b60e26a187dc6b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of a Combination of Solids",
                                                      "id": "5ec3783d497e903afb98dc9c",
                                                      "_id": "606e351a4b60e26a187dc6ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf4",
                                                              "_id": "606e351a4b60e26a187dc6af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion of Solid from One Shape to Another",
                                                      "id": "5ec3783d497e903afb98dc9e",
                                                      "_id": "606e351a4b60e26a187dc6ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf5",
                                                              "_id": "606e351a4b60e26a187dc6ad"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ac",
                                                      "_id": "606e351a4b60e26a187dc6b4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadratic Equations",
                                              "id": "5ec36b98f05a6036ccbb380f",
                                              "_id": "606e351a4b60e26a187dc69f",
                                              "concepts": [
                                                  {
                                                      "name": "Nature of Roots",
                                                      "id": "5ec36cc5497e903afb98db67",
                                                      "_id": "606e351a4b60e26a187dc6a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf6",
                                                              "_id": "606e351a4b60e26a187dc6a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of a Quadratic Equation by Factorisation",
                                                      "id": "5ec36cc5497e903afb98db64",
                                                      "_id": "606e351a4b60e26a187dc6a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf7",
                                                              "_id": "606e351a4b60e26a187dc6a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic Equations",
                                                      "id": "5ec36cc5497e903afb98db63",
                                                      "_id": "606e351a4b60e26a187dc6a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf8",
                                                              "_id": "606e351a4b60e26a187dc6a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of a Quadratic Equation Using Quadratic Formula",
                                                      "id": "5ec36cc5497e903afb98db66",
                                                      "_id": "606e351a4b60e26a187dc6a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf9",
                                                              "_id": "606e351a4b60e26a187dc6a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of a Quadratic Equation by Completing the Square",
                                                      "id": "5ec36cc5497e903afb98db65",
                                                      "_id": "606e351a4b60e26a187dc6a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfa",
                                                              "_id": "606e351a4b60e26a187dc6a1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ad",
                                                      "_id": "606e351a4b60e26a187dc6aa"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Some Applications of Trigonometry",
                                              "id": "5ec36b98f05a6036ccbb3814",
                                              "_id": "606e351a4b60e26a187dc69b",
                                              "concepts": [
                                                  {
                                                      "name": "Heights and Distances",
                                                      "id": "5ec376b9f05a6036ccbb38cf",
                                                      "_id": "606e351a4b60e26a187dc69c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfb",
                                                              "_id": "606e351a4b60e26a187dc69d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ae",
                                                      "_id": "606e351a4b60e26a187dc69e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5ec36b98f05a6036ccbb3819",
                                              "_id": "606e351a4b60e26a187dc68d",
                                              "concepts": [
                                                  {
                                                      "name": "Mode of Grouped Data",
                                                      "id": "5ec37898e56f4536c6184408",
                                                      "_id": "606e351a4b60e26a187dc698",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfc",
                                                              "_id": "606e351a4b60e26a187dc699"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Direct Method",
                                                      "id": "5ec37898e56f4536c6184405",
                                                      "_id": "606e351a4b60e26a187dc696",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfd",
                                                              "_id": "606e351a4b60e26a187dc697"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Assumed Mean Method",
                                                      "id": "5ec37898e56f4536c6184406",
                                                      "_id": "606e351a4b60e26a187dc694",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfe",
                                                              "_id": "606e351a4b60e26a187dc695"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Step Deviation Method",
                                                      "id": "5ec37898e56f4536c6184407",
                                                      "_id": "606e351a4b60e26a187dc692",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbff",
                                                              "_id": "606e351a4b60e26a187dc693"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Median of Grouped Data",
                                                      "id": "5ec37898e56f4536c6184409",
                                                      "_id": "606e351a4b60e26a187dc690",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc00",
                                                              "_id": "606e351a4b60e26a187dc691"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Representation of Cumulative Frequency Distribution",
                                                      "id": "5ec37898e56f4536c618440a",
                                                      "_id": "606e351a4b60e26a187dc68e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc01",
                                                              "_id": "606e351a4b60e26a187dc68f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9af",
                                                      "_id": "606e351a4b60e26a187dc69a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ec36b98f05a6036ccbb381a",
                                              "_id": "606e351a4b60e26a187dc685",
                                              "concepts": [
                                                  {
                                                      "name": "Sure and Impossible Events",
                                                      "id": "5ec378d0e56f4536c618441d",
                                                      "_id": "606e351a4b60e26a187dc68a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc02",
                                                              "_id": "606e351a4b60e26a187dc68b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of an Event",
                                                      "id": "5ec378d0e56f4536c618441b",
                                                      "_id": "606e351a4b60e26a187dc688",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc03",
                                                              "_id": "606e351a4b60e26a187dc689"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of Complement of an Event",
                                                      "id": "5ec378d0e56f4536c618441c",
                                                      "_id": "606e351a4b60e26a187dc686",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc04",
                                                              "_id": "606e351a4b60e26a187dc687"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b0",
                                                      "_id": "606e351a4b60e26a187dc68c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Arithmetic Progressions",
                                              "id": "5ec36b98f05a6036ccbb3810",
                                              "_id": "606e351a4b60e26a187dc67b",
                                              "concepts": [
                                                  {
                                                      "name": "Applications of Sum of Terms of an Arithmetic Progression",
                                                      "id": "5ec36d08f05a6036ccbb3861",
                                                      "_id": "606e351a4b60e26a187dc682",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc05",
                                                              "_id": "606e351a4b60e26a187dc683"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of First n Terms of an Arithmetic Progression",
                                                      "id": "5ec36d08f05a6036ccbb3860",
                                                      "_id": "606e351a4b60e26a187dc680",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc06",
                                                              "_id": "606e351a4b60e26a187dc681"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "nth Term of an Arithmetic Progression",
                                                      "id": "5ec36d08f05a6036ccbb385f",
                                                      "_id": "606e351a4b60e26a187dc67e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc07",
                                                              "_id": "606e351a4b60e26a187dc67f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arithmetic Progressions",
                                                      "id": "5ec36d08f05a6036ccbb385e",
                                                      "_id": "606e351a4b60e26a187dc67c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc08",
                                                              "_id": "606e351a4b60e26a187dc67d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b1",
                                                      "_id": "606e351a4b60e26a187dc684"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circles",
                                              "id": "5ec36b98f05a6036ccbb3815",
                                              "_id": "606e351a4b60e26a187dc675",
                                              "concepts": [
                                                  {
                                                      "name": "Relationship Between Radius and Tangent to a Circle",
                                                      "id": "5ec3775be56f4536c61843bb",
                                                      "_id": "606e351a4b60e26a187dc678",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc09",
                                                              "_id": "606e351a4b60e26a187dc679"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lengths of Tangents Drawn From an External Point to a Circle",
                                                      "id": "5ec3775be56f4536c61843bc",
                                                      "_id": "606e351a4b60e26a187dc676",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0a",
                                                              "_id": "606e351a4b60e26a187dc677"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b2",
                                                      "_id": "606e351a4b60e26a187dc67a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f687f33058075680d816492",
                                              "_id": "606e351a4b60e26a187dc667",
                                              "concepts": [
                                                  {
                                                      "name": "Concurrency Theorems",
                                                      "id": "5f688427ca5ac358f1705c72",
                                                      "_id": "606e351a4b60e26a187dc672",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0b",
                                                              "_id": "606e351a4b60e26a187dc673"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thales Theorem And Angle Bisector Theorem",
                                                      "id": "5f688427ca5ac358f1705c6f",
                                                      "_id": "606e351a4b60e26a187dc670",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0c",
                                                              "_id": "606e351a4b60e26a187dc671"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pythagoras Theorem",
                                                      "id": "5f688427ca5ac358f1705c70",
                                                      "_id": "606e351a4b60e26a187dc66e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0d",
                                                              "_id": "606e351a4b60e26a187dc66f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c6d",
                                                      "_id": "606e351a4b60e26a187dc66c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0e",
                                                              "_id": "606e351a4b60e26a187dc66d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circles And Tangents",
                                                      "id": "5f688427ca5ac358f1705c71",
                                                      "_id": "606e351a4b60e26a187dc66a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0f",
                                                              "_id": "606e351a4b60e26a187dc66b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Similarity",
                                                      "id": "5f688427ca5ac358f1705c6e",
                                                      "_id": "606e351a4b60e26a187dc668",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc10",
                                                              "_id": "606e351a4b60e26a187dc669"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b3",
                                                      "_id": "606e351a4b60e26a187dc674"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f687f33058075680d816493",
                                              "_id": "606e351a4b60e26a187dc659",
                                              "concepts": [
                                                  {
                                                      "name": "Inclination Of A Line",
                                                      "id": "5f688427ca5ac358f1705c76",
                                                      "_id": "606e351a4b60e26a187dc664",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc11",
                                                              "_id": "606e351a4b60e26a187dc665"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area Of A Quadrilateral",
                                                      "id": "5f688427ca5ac358f1705c75",
                                                      "_id": "606e351a4b60e26a187dc662",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc12",
                                                              "_id": "606e351a4b60e26a187dc663"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c73",
                                                      "_id": "606e351a4b60e26a187dc660",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc13",
                                                              "_id": "606e351a4b60e26a187dc661"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "General Form Of A Straight Line",
                                                      "id": "5f688427ca5ac358f1705c78",
                                                      "_id": "606e351a4b60e26a187dc65e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc14",
                                                              "_id": "606e351a4b60e26a187dc65f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area Of A Triangle",
                                                      "id": "5f688427ca5ac358f1705c74",
                                                      "_id": "606e351a4b60e26a187dc65c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc15",
                                                              "_id": "606e351a4b60e26a187dc65d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Straight Line",
                                                      "id": "5f688427ca5ac358f1705c77",
                                                      "_id": "606e351a4b60e26a187dc65a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc16",
                                                              "_id": "606e351a4b60e26a187dc65b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b4",
                                                      "_id": "606e351a4b60e26a187dc666"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Numbers And Sequences",
                                              "id": "5f687f33058075680d816490",
                                              "_id": "606e351a4b60e26a187dc641",
                                              "concepts": [
                                                  {
                                                      "name": "Special Series",
                                                      "id": "5f688427ca5ac358f1705c63",
                                                      "_id": "606e351a4b60e26a187dc656",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc17",
                                                              "_id": "606e351a4b60e26a187dc657"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum To N Terms Of A Geometric Progression",
                                                      "id": "5f688427ca5ac358f1705c62",
                                                      "_id": "606e351a4b60e26a187dc654",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc18",
                                                              "_id": "606e351a4b60e26a187dc655"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arithmetic Progression",
                                                      "id": "5f688427ca5ac358f1705c5f",
                                                      "_id": "606e351a4b60e26a187dc652",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc19",
                                                              "_id": "606e351a4b60e26a187dc653"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid’s Division Algorithm",
                                                      "id": "5f688427ca5ac358f1705c5b",
                                                      "_id": "606e351a4b60e26a187dc650",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1a",
                                                              "_id": "606e351a4b60e26a187dc651"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorem Of Arithmetic",
                                                      "id": "5f688427ca5ac358f1705c5c",
                                                      "_id": "606e351a4b60e26a187dc64e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1b",
                                                              "_id": "606e351a4b60e26a187dc64f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c59",
                                                      "_id": "606e351a4b60e26a187dc64c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1c",
                                                              "_id": "606e351a4b60e26a187dc64d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modular Arithmetic",
                                                      "id": "5f688427ca5ac358f1705c5d",
                                                      "_id": "606e351a4b60e26a187dc64a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1d",
                                                              "_id": "606e351a4b60e26a187dc64b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometric Progression",
                                                      "id": "5f688427ca5ac358f1705c61",
                                                      "_id": "606e351a4b60e26a187dc648",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1e",
                                                              "_id": "606e351a4b60e26a187dc649"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sequences",
                                                      "id": "5f688427ca5ac358f1705c5e",
                                                      "_id": "606e351a4b60e26a187dc646",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1f",
                                                              "_id": "606e351a4b60e26a187dc647"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid’s Division Lemma",
                                                      "id": "5f688427ca5ac358f1705c5a",
                                                      "_id": "606e351a4b60e26a187dc644",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc20",
                                                              "_id": "606e351a4b60e26a187dc645"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series",
                                                      "id": "5f688427ca5ac358f1705c60",
                                                      "_id": "606e351a4b60e26a187dc642",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc21",
                                                              "_id": "606e351a4b60e26a187dc643"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b5",
                                                      "_id": "606e351a4b60e26a187dc658"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mensuration",
                                              "id": "5f687f33058075680d816495",
                                              "_id": "606e351a4b60e26a187dc635",
                                              "concepts": [
                                                  {
                                                      "name": "Volume And Surface Area Of Combined Solids",
                                                      "id": "5f688427ca5ac358f1705c7f",
                                                      "_id": "606e351a4b60e26a187dc63e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc22",
                                                              "_id": "606e351a4b60e26a187dc63f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area",
                                                      "id": "5f688427ca5ac358f1705c7d",
                                                      "_id": "606e351a4b60e26a187dc63c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc23",
                                                              "_id": "606e351a4b60e26a187dc63d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion Of Solids From One Shape To Another With No Change In Volume",
                                                      "id": "5f688427ca5ac358f1705c80",
                                                      "_id": "606e351a4b60e26a187dc63a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc24",
                                                              "_id": "606e351a4b60e26a187dc63b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume",
                                                      "id": "5f688427ca5ac358f1705c7e",
                                                      "_id": "606e351a4b60e26a187dc638",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc25",
                                                              "_id": "606e351a4b60e26a187dc639"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c7c",
                                                      "_id": "606e351a4b60e26a187dc636",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc26",
                                                              "_id": "606e351a4b60e26a187dc637"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b6",
                                                      "_id": "606e351a4b60e26a187dc640"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Algebra",
                                              "id": "5f687f33058075680d816491",
                                              "_id": "606e351a4b60e26a187dc621",
                                              "concepts": [
                                                  {
                                                      "name": "Simultaneous Linear Equations In Three Variables",
                                                      "id": "5f688427ca5ac358f1705c65",
                                                      "_id": "606e351a4b60e26a187dc632",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc27",
                                                              "_id": "606e351a4b60e26a187dc633"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Square Root Of Polynomials",
                                                      "id": "5f688427ca5ac358f1705c68",
                                                      "_id": "606e351a4b60e26a187dc630",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc28",
                                                              "_id": "606e351a4b60e26a187dc631"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c64",
                                                      "_id": "606e351a4b60e26a187dc62e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc29",
                                                              "_id": "606e351a4b60e26a187dc62f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matrices",
                                                      "id": "5f688427ca5ac358f1705c6c",
                                                      "_id": "606e351a4b60e26a187dc62c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2a",
                                                              "_id": "606e351a4b60e26a187dc62d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic Graphs",
                                                      "id": "5f688427ca5ac358f1705c6b",
                                                      "_id": "606e351a4b60e26a187dc62a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2b",
                                                              "_id": "606e351a4b60e26a187dc62b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph Of Variations",
                                                      "id": "5f688427ca5ac358f1705c6a",
                                                      "_id": "606e351a4b60e26a187dc628",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2c",
                                                              "_id": "606e351a4b60e26a187dc629"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic Equations",
                                                      "id": "5f688427ca5ac358f1705c69",
                                                      "_id": "606e351a4b60e26a187dc626",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2d",
                                                              "_id": "606e351a4b60e26a187dc627"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Expressions",
                                                      "id": "5f688427ca5ac358f1705c67",
                                                      "_id": "606e351a4b60e26a187dc624",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2e",
                                                              "_id": "606e351a4b60e26a187dc625"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GCD And LCM Of Polynomials",
                                                      "id": "5f688427ca5ac358f1705c66",
                                                      "_id": "606e351a4b60e26a187dc622",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2f",
                                                              "_id": "606e351a4b60e26a187dc623"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b7",
                                                      "_id": "606e351a4b60e26a187dc634"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics And Probability",
                                              "id": "5f687f33058075680d816496",
                                              "_id": "606e351a4b60e26a187dc613",
                                              "concepts": [
                                                  {
                                                      "name": "Measures Of Dispersion",
                                                      "id": "5f688427ca5ac358f1705c82",
                                                      "_id": "606e351a4b60e26a187dc61e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc30",
                                                              "_id": "606e351a4b60e26a187dc61f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability",
                                                      "id": "5f688427ca5ac358f1705c84",
                                                      "_id": "606e351a4b60e26a187dc61c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc31",
                                                              "_id": "606e351a4b60e26a187dc61d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebra Of Events",
                                                      "id": "5f688427ca5ac358f1705c85",
                                                      "_id": "606e351a4b60e26a187dc61a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc32",
                                                              "_id": "606e351a4b60e26a187dc61b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coefficient Of Variation",
                                                      "id": "5f688427ca5ac358f1705c83",
                                                      "_id": "606e351a4b60e26a187dc618",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc33",
                                                              "_id": "606e351a4b60e26a187dc619"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c81",
                                                      "_id": "606e351a4b60e26a187dc616",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc34",
                                                              "_id": "606e351a4b60e26a187dc617"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Addition Theorem Of Probability",
                                                      "id": "5f688427ca5ac358f1705c86",
                                                      "_id": "606e351a4b60e26a187dc614",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc35",
                                                              "_id": "606e351a4b60e26a187dc615"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b8",
                                                      "_id": "606e351a4b60e26a187dc620"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5f687f33058075680d816494",
                                              "_id": "606e351a4b60e26a187dc60b",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c79",
                                                      "_id": "606e351a4b60e26a187dc610",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc36",
                                                              "_id": "606e351a4b60e26a187dc611"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heights And Distances",
                                                      "id": "5f688427ca5ac358f1705c7b",
                                                      "_id": "606e351a4b60e26a187dc60e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc37",
                                                              "_id": "606e351a4b60e26a187dc60f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5f688427ca5ac358f1705c7a",
                                                      "_id": "606e351a4b60e26a187dc60c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc38",
                                                              "_id": "606e351a4b60e26a187dc60d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b9",
                                                      "_id": "606e351a4b60e26a187dc612"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Relations And Functions",
                                              "id": "5f687f33058075680d81648f",
                                              "_id": "606e351a4b60e26a187dc5f5",
                                              "concepts": [
                                                  {
                                                      "name": "Cartesian Product",
                                                      "id": "5f688427ca5ac358f1705c51",
                                                      "_id": "606e351a4b60e26a187dc608",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc39",
                                                              "_id": "606e351a4b60e26a187dc609"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Functions",
                                                      "id": "5f688427ca5ac358f1705c55",
                                                      "_id": "606e351a4b60e26a187dc606",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3a",
                                                              "_id": "606e351a4b60e26a187dc607"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of Functions",
                                                      "id": "5f688427ca5ac358f1705c54",
                                                      "_id": "606e351a4b60e26a187dc604",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3b",
                                                              "_id": "606e351a4b60e26a187dc605"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relations",
                                                      "id": "5f688427ca5ac358f1705c52",
                                                      "_id": "606e351a4b60e26a187dc602",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3c",
                                                              "_id": "606e351a4b60e26a187dc603"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Special Cases Of Functions",
                                                      "id": "5f688427ca5ac358f1705c56",
                                                      "_id": "606e351a4b60e26a187dc600",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3d",
                                                              "_id": "606e351a4b60e26a187dc601"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c4f",
                                                      "_id": "606e351a4b60e26a187dc5fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3e",
                                                              "_id": "606e351a4b60e26a187dc5ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ordered Pair",
                                                      "id": "5f688427ca5ac358f1705c50",
                                                      "_id": "606e351a4b60e26a187dc5fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3f",
                                                              "_id": "606e351a4b60e26a187dc5fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Identifying The Graphs Of Linear, Quadratic, Cubic And Reciprocal Functions",
                                                      "id": "5f688427ca5ac358f1705c58",
                                                      "_id": "606e351a4b60e26a187dc5fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc40",
                                                              "_id": "606e351a4b60e26a187dc5fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Composition Of Functions",
                                                      "id": "5f688427ca5ac358f1705c57",
                                                      "_id": "606e351a4b60e26a187dc5f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc41",
                                                              "_id": "606e351a4b60e26a187dc5f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions",
                                                      "id": "5f688427ca5ac358f1705c53",
                                                      "_id": "606e351a4b60e26a187dc5f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc42",
                                                              "_id": "606e351a4b60e26a187dc5f7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ba",
                                                      "_id": "606e351a4b60e26a187dc60a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5f64aec082532750fe359c21",
                                              "_id": "606e351a4b60e26a187dc5eb",
                                              "concepts": [
                                                  {
                                                      "name": "Trigonometric Ratios For Complementary Angles",
                                                      "id": "5f65877582532750fe35d007",
                                                      "_id": "606e351a4b60e26a187dc5f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc43",
                                                              "_id": "606e351a4b60e26a187dc5f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios Of Some Special Angles",
                                                      "id": "5f65877582532750fe35d006",
                                                      "_id": "606e351a4b60e26a187dc5f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc44",
                                                              "_id": "606e351a4b60e26a187dc5f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d005",
                                                      "_id": "606e351a4b60e26a187dc5ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc45",
                                                              "_id": "606e351a4b60e26a187dc5ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method Of Using Trigonometric Table",
                                                      "id": "5f65877582532750fe35d008",
                                                      "_id": "606e351a4b60e26a187dc5ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc46",
                                                              "_id": "606e351a4b60e26a187dc5ed"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bb",
                                                      "_id": "606e351a4b60e26a187dc5f4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Set Language",
                                              "id": "5f64aec082532750fe359c1c",
                                              "_id": "606e351a4b60e26a187dc5d9",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f657fbf03e86d7fe78b3e5e",
                                                      "_id": "606e351a4b60e26a187dc5e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc47",
                                                              "_id": "606e351a4b60e26a187dc5e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application On Cardinality Of Sets:",
                                                      "id": "5f657fbf03e86d7fe78b3e65",
                                                      "_id": "606e351a4b60e26a187dc5e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc48",
                                                              "_id": "606e351a4b60e26a187dc5e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of A Set",
                                                      "id": "5f657fbf03e86d7fe78b3e60",
                                                      "_id": "606e351a4b60e26a187dc5e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc49",
                                                              "_id": "606e351a4b60e26a187dc5e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Set Operations",
                                                      "id": "5f657fbf03e86d7fe78b3e63",
                                                      "_id": "606e351a4b60e26a187dc5e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4a",
                                                              "_id": "606e351a4b60e26a187dc5e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Sets",
                                                      "id": "5f657fbf03e86d7fe78b3e61",
                                                      "_id": "606e351a4b60e26a187dc5e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4b",
                                                              "_id": "606e351a4b60e26a187dc5e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Set",
                                                      "id": "5f657fbf03e86d7fe78b3e5f",
                                                      "_id": "606e351a4b60e26a187dc5de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4c",
                                                              "_id": "606e351a4b60e26a187dc5df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’s Laws",
                                                      "id": "5f657fbf03e86d7fe78b3e64",
                                                      "_id": "606e351a4b60e26a187dc5dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4d",
                                                              "_id": "606e351a4b60e26a187dc5dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Set Operations",
                                                      "id": "5f657fbf03e86d7fe78b3e62",
                                                      "_id": "606e351a4b60e26a187dc5da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4e",
                                                              "_id": "606e351a4b60e26a187dc5db"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bc",
                                                      "_id": "606e351a4b60e26a187dc5ea"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Algebra",
                                              "id": "5f64aec082532750fe359c1e",
                                              "_id": "606e351a4b60e26a187dc5c7",
                                              "concepts": [
                                                  {
                                                      "name": "Division of Polynomials",
                                                      "id": "5f65877582532750fe35cff4",
                                                      "_id": "606e351a4b60e26a187dc5d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4f",
                                                              "_id": "606e351a4b60e26a187dc5d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials",
                                                      "id": "5f65877582532750fe35cff0",
                                                      "_id": "606e351a4b60e26a187dc5d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc50",
                                                              "_id": "606e351a4b60e26a187dc5d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35cfef",
                                                      "_id": "606e351a4b60e26a187dc5d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc51",
                                                              "_id": "606e351a4b60e26a187dc5d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorisation",
                                                      "id": "5f65877582532750fe35cff3",
                                                      "_id": "606e351a4b60e26a187dc5d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc52",
                                                              "_id": "606e351a4b60e26a187dc5d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Equation In Two Variables",
                                                      "id": "5f65877582532750fe35cff6",
                                                      "_id": "606e351a4b60e26a187dc5ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc53",
                                                              "_id": "606e351a4b60e26a187dc5cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest Common Divisor (Gcd)",
                                                      "id": "5f65877582532750fe35cff5",
                                                      "_id": "606e351a4b60e26a187dc5cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc54",
                                                              "_id": "606e351a4b60e26a187dc5cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities",
                                                      "id": "5f65877582532750fe35cff2",
                                                      "_id": "606e351a4b60e26a187dc5ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc55",
                                                              "_id": "606e351a4b60e26a187dc5cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder Theorem",
                                                      "id": "5f65877582532750fe35cff1",
                                                      "_id": "606e351a4b60e26a187dc5c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc56",
                                                              "_id": "606e351a4b60e26a187dc5c9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bd",
                                                      "_id": "606e351a4b60e26a187dc5d8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5f64aec082532750fe359c23",
                                              "_id": "606e351a4b60e26a187dc5b9",
                                              "concepts": [
                                                  {
                                                      "name": "Median",
                                                      "id": "5f65877582532750fe35d012",
                                                      "_id": "606e351a4b60e26a187dc5c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc57",
                                                              "_id": "606e351a4b60e26a187dc5c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d00e",
                                                      "_id": "606e351a4b60e26a187dc5c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc58",
                                                              "_id": "606e351a4b60e26a187dc5c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Collection Of Data",
                                                      "id": "5f65877582532750fe35d00f",
                                                      "_id": "606e351a4b60e26a187dc5c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc59",
                                                              "_id": "606e351a4b60e26a187dc5c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mode",
                                                      "id": "5f65877582532750fe35d013",
                                                      "_id": "606e351a4b60e26a187dc5be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5a",
                                                              "_id": "606e351a4b60e26a187dc5bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measures Of Central Tendency",
                                                      "id": "5f65877582532750fe35d010",
                                                      "_id": "606e351a4b60e26a187dc5bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5b",
                                                              "_id": "606e351a4b60e26a187dc5bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arithmetic Mean",
                                                      "id": "5f65877582532750fe35d011",
                                                      "_id": "606e351a4b60e26a187dc5ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5c",
                                                              "_id": "606e351a4b60e26a187dc5bb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9be",
                                                      "_id": "606e351a4b60e26a187dc5c6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5f64aec082532750fe359c24",
                                              "_id": "606e351a4b60e26a187dc5ad",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d014",
                                                      "_id": "606e351a4b60e26a187dc5b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5d",
                                                              "_id": "606e351a4b60e26a187dc5b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Ideas",
                                                      "id": "5f65877582532750fe35d015",
                                                      "_id": "606e351a4b60e26a187dc5b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5e",
                                                              "_id": "606e351a4b60e26a187dc5b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classical Approach",
                                                      "id": "5f65877582532750fe35d016",
                                                      "_id": "606e351a4b60e26a187dc5b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5f",
                                                              "_id": "606e351a4b60e26a187dc5b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Empirical Approach",
                                                      "id": "5f65877582532750fe35d017",
                                                      "_id": "606e351a4b60e26a187dc5b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc60",
                                                              "_id": "606e351a4b60e26a187dc5b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Events",
                                                      "id": "5f65877582532750fe35d018",
                                                      "_id": "606e351a4b60e26a187dc5ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc61",
                                                              "_id": "606e351a4b60e26a187dc5af"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bf",
                                                      "_id": "606e351a4b60e26a187dc5b8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f64aec082532750fe359c1f",
                                              "_id": "606e351a4b60e26a187dc59d",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35cff7",
                                                      "_id": "606e351a4b60e26a187dc5aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc62",
                                                              "_id": "606e351a4b60e26a187dc5ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cyclic Quadrilaterals",
                                                      "id": "5f65877582532750fe35cffc",
                                                      "_id": "606e351a4b60e26a187dc5a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc63",
                                                              "_id": "606e351a4b60e26a187dc5a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parts Of A Circle",
                                                      "id": "5f65877582532750fe35cffa",
                                                      "_id": "606e351a4b60e26a187dc5a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc64",
                                                              "_id": "606e351a4b60e26a187dc5a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Chords Of A Circle",
                                                      "id": "5f65877582532750fe35cffb",
                                                      "_id": "606e351a4b60e26a187dc5a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc65",
                                                              "_id": "606e351a4b60e26a187dc5a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadrilaterals",
                                                      "id": "5f65877582532750fe35cff9",
                                                      "_id": "606e351a4b60e26a187dc5a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc66",
                                                              "_id": "606e351a4b60e26a187dc5a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Angles",
                                                      "id": "5f65877582532750fe35cff8",
                                                      "_id": "606e351a4b60e26a187dc5a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc67",
                                                              "_id": "606e351a4b60e26a187dc5a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Practical Geometry",
                                                      "id": "5f65877582532750fe35cffd",
                                                      "_id": "606e351a4b60e26a187dc59e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc68",
                                                              "_id": "606e351a4b60e26a187dc59f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c0",
                                                      "_id": "606e351a4b60e26a187dc5ac"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f64aec082532750fe359c20",
                                              "_id": "606e351a4b60e26a187dc58d",
                                              "concepts": [
                                                  {
                                                      "name": "The Coordinates Of The Centroid",
                                                      "id": "5f65877582532750fe35d004",
                                                      "_id": "606e351a4b60e26a187dc59a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc69",
                                                              "_id": "606e351a4b60e26a187dc59b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance Between Any Two Points",
                                                      "id": "5f65877582532750fe35d000",
                                                      "_id": "606e351a4b60e26a187dc598",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6a",
                                                              "_id": "606e351a4b60e26a187dc599"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Section Formula",
                                                      "id": "5f65877582532750fe35d003",
                                                      "_id": "606e351a4b60e26a187dc596",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6b",
                                                              "_id": "606e351a4b60e26a187dc597"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Devising A Coordinate System",
                                                      "id": "5f65877582532750fe35cfff",
                                                      "_id": "606e351a4b60e26a187dc594",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6c",
                                                              "_id": "606e351a4b60e26a187dc595"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Points Of Trisection Of A Line Segment",
                                                      "id": "5f65877582532750fe35d002",
                                                      "_id": "606e351a4b60e26a187dc592",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6d",
                                                              "_id": "606e351a4b60e26a187dc593"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Mid-Point Of A Line Segment",
                                                      "id": "5f65877582532750fe35d001",
                                                      "_id": "606e351a4b60e26a187dc590",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6e",
                                                              "_id": "606e351a4b60e26a187dc591"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mapping The Plane",
                                                      "id": "5f65877582532750fe35cffe",
                                                      "_id": "606e351a4b60e26a187dc58e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6f",
                                                              "_id": "606e351a4b60e26a187dc58f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c1",
                                                      "_id": "606e351a4b60e26a187dc59c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mensuration",
                                              "id": "5f64aec082532750fe359c22",
                                              "_id": "606e351a4b60e26a187dc581",
                                              "concepts": [
                                                  {
                                                      "name": "Surface Area Of Cuboid And Cube",
                                                      "id": "5f65877582532750fe35d00c",
                                                      "_id": "606e351a4b60e26a187dc58a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc70",
                                                              "_id": "606e351a4b60e26a187dc58b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d009",
                                                      "_id": "606e351a4b60e26a187dc588",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc71",
                                                              "_id": "606e351a4b60e26a187dc589"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of Cuboid And Cube",
                                                      "id": "5f65877582532750fe35d00d",
                                                      "_id": "606e351a4b60e26a187dc586",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc72",
                                                              "_id": "606e351a4b60e26a187dc587"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heron’s Formula",
                                                      "id": "5f65877582532750fe35d00a",
                                                      "_id": "606e351a4b60e26a187dc584",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc73",
                                                              "_id": "606e351a4b60e26a187dc585"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Heron’s Formula In Finding Areas Of Quadrilaterals",
                                                      "id": "5f65877582532750fe35d00b",
                                                      "_id": "606e351a4b60e26a187dc582",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc74",
                                                              "_id": "606e351a4b60e26a187dc583"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c2",
                                                      "_id": "606e351a4b60e26a187dc58c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Real Numbers",
                                              "id": "5f64aec082532750fe359c1d",
                                              "_id": "606e351a4b60e26a187dc56f",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35cfe7",
                                                      "_id": "606e351a4b60e26a187dc57e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc75",
                                                              "_id": "606e351a4b60e26a187dc57f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Irrational Numbers",
                                                      "id": "5f65877582532750fe35cfe9",
                                                      "_id": "606e351a4b60e26a187dc57c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc76",
                                                              "_id": "606e351a4b60e26a187dc57d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rationalisation Of Surds",
                                                      "id": "5f65877582532750fe35cfed",
                                                      "_id": "606e351a4b60e26a187dc57a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc77",
                                                              "_id": "606e351a4b60e26a187dc57b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Numbers",
                                                      "id": "5f65877582532750fe35cfea",
                                                      "_id": "606e351a4b60e26a187dc578",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc78",
                                                              "_id": "606e351a4b60e26a187dc579"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scientific Notation",
                                                      "id": "5f65877582532750fe35cfee",
                                                      "_id": "606e351a4b60e26a187dc576",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc79",
                                                              "_id": "606e351a4b60e26a187dc577"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surds",
                                                      "id": "5f65877582532750fe35cfec",
                                                      "_id": "606e351a4b60e26a187dc574",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7a",
                                                              "_id": "606e351a4b60e26a187dc575"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radical Notation",
                                                      "id": "5f65877582532750fe35cfeb",
                                                      "_id": "606e351a4b60e26a187dc572",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7b",
                                                              "_id": "606e351a4b60e26a187dc573"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Numbers",
                                                      "id": "5f65877582532750fe35cfe8",
                                                      "_id": "606e351a4b60e26a187dc570",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7c",
                                                              "_id": "606e351a4b60e26a187dc571"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c3",
                                                      "_id": "606e351a4b60e26a187dc580"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Two Dimensional Analytical Geometry-Ii",
                                              "id": "5f6831c6f100a06808b0d4ef",
                                              "_id": "606e351a4b60e26a187dc55f",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68335c058075680d813619",
                                                      "_id": "606e351a4b60e26a187dc56c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7d",
                                                              "_id": "606e351a4b60e26a187dc56d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Tangents And Normals To Conics",
                                                      "id": "5f68335c058075680d81361e",
                                                      "_id": "606e351a4b60e26a187dc56a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7e",
                                                              "_id": "606e351a4b60e26a187dc56b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circle",
                                                      "id": "5f68335c058075680d81361a",
                                                      "_id": "606e351a4b60e26a187dc568",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7f",
                                                              "_id": "606e351a4b60e26a187dc569"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conic Sections",
                                                      "id": "5f68335c058075680d81361c",
                                                      "_id": "606e351a4b60e26a187dc566",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc80",
                                                              "_id": "606e351a4b60e26a187dc567"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Life Applications Of Conics",
                                                      "id": "5f68335c058075680d81361f",
                                                      "_id": "606e351a4b60e26a187dc564",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc81",
                                                              "_id": "606e351a4b60e26a187dc565"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conics",
                                                      "id": "5f68335c058075680d81361b",
                                                      "_id": "606e351a4b60e26a187dc562",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc82",
                                                              "_id": "606e351a4b60e26a187dc563"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parametric Form Of Conics",
                                                      "id": "5f68335c058075680d81361d",
                                                      "_id": "606e351a4b60e26a187dc560",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc83",
                                                              "_id": "606e351a4b60e26a187dc561"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c4",
                                                      "_id": "606e351a4b60e26a187dc56e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ordinary Differential Equations",
                                              "id": "5f6831c6f100a06808b0d4f4",
                                              "_id": "606e351a4b60e26a187dc54d",
                                              "concepts": [
                                                  {
                                                      "name": "Solution Of First Order And First Degree Differential Equations",
                                                      "id": "5f6834dc058075680d81371c",
                                                      "_id": "606e351a4b60e26a187dc55c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc84",
                                                              "_id": "606e351a4b60e26a187dc55d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6834dc058075680d813717",
                                                      "_id": "606e351a4b60e26a187dc55a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc85",
                                                              "_id": "606e351a4b60e26a187dc55b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differential Equation, Order, And Degree",
                                                      "id": "5f6834dc058075680d813718",
                                                      "_id": "606e351a4b60e26a187dc558",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc86",
                                                              "_id": "606e351a4b60e26a187dc559"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation Of Differential Equations",
                                                      "id": "5f6834dc058075680d81371a",
                                                      "_id": "606e351a4b60e26a187dc556",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc87",
                                                              "_id": "606e351a4b60e26a187dc557"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of Ordinary Differential Equations",
                                                      "id": "5f6834dc058075680d81371b",
                                                      "_id": "606e351a4b60e26a187dc554",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc88",
                                                              "_id": "606e351a4b60e26a187dc555"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Order Ordinary Differential Equations",
                                                      "id": "5f6834dc058075680d81371e",
                                                      "_id": "606e351a4b60e26a187dc552",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc89",
                                                              "_id": "606e351a4b60e26a187dc553"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First Order Linear Differential Equations",
                                                      "id": "5f6834dc058075680d81371d",
                                                      "_id": "606e351a4b60e26a187dc550",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8a",
                                                              "_id": "606e351a4b60e26a187dc551"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification Of Differential Equations",
                                                      "id": "5f6834dc058075680d813719",
                                                      "_id": "606e351a4b60e26a187dc54e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8b",
                                                              "_id": "606e351a4b60e26a187dc54f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c5",
                                                      "_id": "606e351a4b60e26a187dc55e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Numbers",
                                              "id": "5f6831c6f100a06808b0d4ec",
                                              "_id": "606e351a4b60e26a187dc53b",
                                              "concepts": [
                                                  {
                                                      "name": "Geometry And Locus Of Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027f1",
                                                      "_id": "606e351a4b60e26a187dc54a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8c",
                                                              "_id": "606e351a4b60e26a187dc54b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conjugate Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027ef",
                                                      "_id": "606e351a4b60e26a187dc548",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8d",
                                                              "_id": "606e351a4b60e26a187dc549"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Algebraic Properties Of Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ee",
                                                      "_id": "606e351a4b60e26a187dc546",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8e",
                                                              "_id": "606e351a4b60e26a187dc547"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ed",
                                                      "_id": "606e351a4b60e26a187dc544",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8f",
                                                              "_id": "606e351a4b60e26a187dc545"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction To Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ec",
                                                      "_id": "606e351a4b60e26a187dc542",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc90",
                                                              "_id": "606e351a4b60e26a187dc543"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Moivre’S Theorem And Its Applications",
                                                      "id": "5f683275ca5ac358f17027f3",
                                                      "_id": "606e351a4b60e26a187dc540",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc91",
                                                              "_id": "606e351a4b60e26a187dc541"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027f0",
                                                      "_id": "606e351a4b60e26a187dc53e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc92",
                                                              "_id": "606e351a4b60e26a187dc53f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polar And Euler Form Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027f2",
                                                      "_id": "606e351a4b60e26a187dc53c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc93",
                                                              "_id": "606e351a4b60e26a187dc53d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c6",
                                                      "_id": "606e351a4b60e26a187dc54c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Differential Calculus",
                                              "id": "5f6831c6f100a06808b0d4f1",
                                              "_id": "606e351a4b60e26a187dc525",
                                              "concepts": [
                                                  {
                                                      "name": "Indeterminate Forms",
                                                      "id": "5f683405ca5ac358f17028c0",
                                                      "_id": "606e351a4b60e26a187dc538",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc94",
                                                              "_id": "606e351a4b60e26a187dc539"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Second Derivative",
                                                      "id": "5f683405ca5ac358f17028c2",
                                                      "_id": "606e351a4b60e26a187dc536",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc95",
                                                              "_id": "606e351a4b60e26a187dc537"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Derivative",
                                                      "id": "5f683405ca5ac358f17028c1",
                                                      "_id": "606e351a4b60e26a187dc534",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc96",
                                                              "_id": "606e351a4b60e26a187dc535"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sketching Of Curves",
                                                      "id": "5f683405ca5ac358f17028c5",
                                                      "_id": "606e351a4b60e26a187dc532",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc97",
                                                              "_id": "606e351a4b60e26a187dc533"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683405ca5ac358f17028bc",
                                                      "_id": "606e351a4b60e26a187dc530",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc98",
                                                              "_id": "606e351a4b60e26a187dc531"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meaning Of Derivatives",
                                                      "id": "5f683405ca5ac358f17028bd",
                                                      "_id": "606e351a4b60e26a187dc52e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc99",
                                                              "_id": "606e351a4b60e26a187dc52f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean Value Theorem",
                                                      "id": "5f683405ca5ac358f17028be",
                                                      "_id": "606e351a4b60e26a187dc52c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9a",
                                                              "_id": "606e351a4b60e26a187dc52d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Symmetry And Asymptotes",
                                                      "id": "5f683405ca5ac358f17028c4",
                                                      "_id": "606e351a4b60e26a187dc52a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9b",
                                                              "_id": "606e351a4b60e26a187dc52b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series Expansions",
                                                      "id": "5f683405ca5ac358f17028bf",
                                                      "_id": "606e351a4b60e26a187dc528",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9c",
                                                              "_id": "606e351a4b60e26a187dc529"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications In Optimization",
                                                      "id": "5f683405ca5ac358f17028c3",
                                                      "_id": "606e351a4b60e26a187dc526",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9d",
                                                              "_id": "606e351a4b60e26a187dc527"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c7",
                                                      "_id": "606e351a4b60e26a187dc53a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Discrete Mathematics",
                                              "id": "5f6831c6f100a06808b0d4f6",
                                              "_id": "606e351a4b60e26a187dc51d",
                                              "concepts": [
                                                  {
                                                      "name": "Binary Operations",
                                                      "id": "5f68352571814158f68cc7e1",
                                                      "_id": "606e351a4b60e26a187dc522",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9e",
                                                              "_id": "606e351a4b60e26a187dc523"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68352571814158f68cc7e0",
                                                      "_id": "606e351a4b60e26a187dc520",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9f",
                                                              "_id": "606e351a4b60e26a187dc521"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Logic",
                                                      "id": "5f68352571814158f68cc7e2",
                                                      "_id": "606e351a4b60e26a187dc51e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca0",
                                                              "_id": "606e351a4b60e26a187dc51f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c8",
                                                      "_id": "606e351a4b60e26a187dc524"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Vector Algebra",
                                              "id": "5f6831c6f100a06808b0d4f0",
                                              "_id": "606e351a4b60e26a187dc507",
                                              "concepts": [
                                                  {
                                                      "name": "Jacobi’S Identity And Lagrange’S Identity",
                                                      "id": "5f6833c2058075680d81364f",
                                                      "_id": "606e351a4b60e26a187dc51a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca1",
                                                              "_id": "606e351a4b60e26a187dc51b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meeting Point Of A Line And A Plane",
                                                      "id": "5f6833c2058075680d813653",
                                                      "_id": "606e351a4b60e26a187dc518",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca2",
                                                              "_id": "606e351a4b60e26a187dc519"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar Product And Vector Product",
                                                      "id": "5f6833c2058075680d81364c",
                                                      "_id": "606e351a4b60e26a187dc516",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca3",
                                                              "_id": "606e351a4b60e26a187dc517"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometric Introduction To Vectors",
                                                      "id": "5f6833c2058075680d81364b",
                                                      "_id": "606e351a4b60e26a187dc514",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca4",
                                                              "_id": "606e351a4b60e26a187dc515"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Image Of A Point In A Plane",
                                                      "id": "5f6833c2058075680d813652",
                                                      "_id": "606e351a4b60e26a187dc512",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca5",
                                                              "_id": "606e351a4b60e26a187dc513"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar Triple Product",
                                                      "id": "5f6833c2058075680d81364d",
                                                      "_id": "606e351a4b60e26a187dc510",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca6",
                                                              "_id": "606e351a4b60e26a187dc511"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different Forms Of Equation Of A Plane",
                                                      "id": "5f6833c2058075680d813651",
                                                      "_id": "606e351a4b60e26a187dc50e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca7",
                                                              "_id": "606e351a4b60e26a187dc50f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector Triple Product",
                                                      "id": "5f6833c2058075680d81364e",
                                                      "_id": "606e351a4b60e26a187dc50c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca8",
                                                              "_id": "606e351a4b60e26a187dc50d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6833c2058075680d81364a",
                                                      "_id": "606e351a4b60e26a187dc50a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca9",
                                                              "_id": "606e351a4b60e26a187dc50b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different Forms Of Equation Of A Straight Line",
                                                      "id": "5f6833c2058075680d813650",
                                                      "_id": "606e351a4b60e26a187dc508",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcaa",
                                                              "_id": "606e351a4b60e26a187dc509"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c9",
                                                      "_id": "606e351a4b60e26a187dc51c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Matrices And Determinants",
                                              "id": "5f6831c6f100a06808b0d4eb",
                                              "_id": "606e351a4b60e26a187dc4fb",
                                              "concepts": [
                                                  {
                                                      "name": "Inverse Of A Non-Singular Square Matrix",
                                                      "id": "5f683235f100a06808b0d503",
                                                      "_id": "606e351a4b60e26a187dc504",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcab",
                                                              "_id": "606e351a4b60e26a187dc505"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Elementary Transformations Of A Matrix",
                                                      "id": "5f683235f100a06808b0d504",
                                                      "_id": "606e351a4b60e26a187dc502",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcac",
                                                              "_id": "606e351a4b60e26a187dc503"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Matrices: Consistency Of System Of Linear Equations By Rank Method",
                                                      "id": "5f683235f100a06808b0d506",
                                                      "_id": "606e351a4b60e26a187dc500",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcad",
                                                              "_id": "606e351a4b60e26a187dc501"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683235f100a06808b0d502",
                                                      "_id": "606e351a4b60e26a187dc4fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcae",
                                                              "_id": "606e351a4b60e26a187dc4ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Matrices: Solving System Of Linear Equations",
                                                      "id": "5f683235f100a06808b0d505",
                                                      "_id": "606e351a4b60e26a187dc4fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcaf",
                                                              "_id": "606e351a4b60e26a187dc4fd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ca",
                                                      "_id": "606e351a4b60e26a187dc506"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability Distributions",
                                              "id": "5f6831c6f100a06808b0d4f5",
                                              "_id": "606e351a4b60e26a187dc4ed",
                                              "concepts": [
                                                  {
                                                      "name": "Continuous Distributions",
                                                      "id": "5f683505058075680d813749",
                                                      "_id": "606e351a4b60e26a187dc4f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb0",
                                                              "_id": "606e351a4b60e26a187dc4f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Expectation",
                                                      "id": "5f683505058075680d81374a",
                                                      "_id": "606e351a4b60e26a187dc4f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb1",
                                                              "_id": "606e351a4b60e26a187dc4f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Random Variable",
                                                      "id": "5f683505058075680d813748",
                                                      "_id": "606e351a4b60e26a187dc4f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb2",
                                                              "_id": "606e351a4b60e26a187dc4f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683505058075680d813746",
                                                      "_id": "606e351a4b60e26a187dc4f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb3",
                                                              "_id": "606e351a4b60e26a187dc4f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random Variable",
                                                      "id": "5f683505058075680d813747",
                                                      "_id": "606e351a4b60e26a187dc4f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb4",
                                                              "_id": "606e351a4b60e26a187dc4f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                      "id": "5f683505058075680d81374b",
                                                      "_id": "606e351a4b60e26a187dc4ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb5",
                                                              "_id": "606e351a4b60e26a187dc4ef"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cb",
                                                      "_id": "606e351a4b60e26a187dc4fa"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometric Functions",
                                              "id": "5f6831c6f100a06808b0d4ee",
                                              "_id": "606e351a4b60e26a187dc4d7",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68332aca5ac358f170285a",
                                                      "_id": "606e351a4b60e26a187dc4ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb6",
                                                              "_id": "606e351a4b60e26a187dc4eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Inverse Trigonometric Functions",
                                                      "id": "5f68332aca5ac358f1702863",
                                                      "_id": "606e351a4b60e26a187dc4e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb7",
                                                              "_id": "606e351a4b60e26a187dc4e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sine Function And Inverse Sine Function",
                                                      "id": "5f68332aca5ac358f170285c",
                                                      "_id": "606e351a4b60e26a187dc4e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb8",
                                                              "_id": "606e351a4b60e26a187dc4e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Tangent Function And The Inverse Tangent Function",
                                                      "id": "5f68332aca5ac358f170285e",
                                                      "_id": "606e351a4b60e26a187dc4e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb9",
                                                              "_id": "606e351a4b60e26a187dc4e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cosecant Function And The Inverse Cosecant Function",
                                                      "id": "5f68332aca5ac358f170285f",
                                                      "_id": "606e351a4b60e26a187dc4e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcba",
                                                              "_id": "606e351a4b60e26a187dc4e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Principal Value Of Inverse Trigonometric Functions",
                                                      "id": "5f68332aca5ac358f1702862",
                                                      "_id": "606e351a4b60e26a187dc4e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbb",
                                                              "_id": "606e351a4b60e26a187dc4e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cotangent Function And The Inverse Cotangent Function",
                                                      "id": "5f68332aca5ac358f1702861",
                                                      "_id": "606e351a4b60e26a187dc4de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbc",
                                                              "_id": "606e351a4b60e26a187dc4df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Secant Function And Inverse Secant Function",
                                                      "id": "5f68332aca5ac358f1702860",
                                                      "_id": "606e351a4b60e26a187dc4dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbd",
                                                              "_id": "606e351a4b60e26a187dc4dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cosine Function And Inverse Cosine Function",
                                                      "id": "5f68332aca5ac358f170285d",
                                                      "_id": "606e351a4b60e26a187dc4da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbe",
                                                              "_id": "606e351a4b60e26a187dc4db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Some Fundamental Concepts",
                                                      "id": "5f68332aca5ac358f170285b",
                                                      "_id": "606e351a4b60e26a187dc4d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbf",
                                                              "_id": "606e351a4b60e26a187dc4d9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cc",
                                                      "_id": "606e351a4b60e26a187dc4ec"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Integration",
                                              "id": "5f6831c6f100a06808b0d4f3",
                                              "_id": "606e351a4b60e26a187dc4c3",
                                              "concepts": [
                                                  {
                                                      "name": "Gamma Integral",
                                                      "id": "5f683497ca5ac358f170293f",
                                                      "_id": "606e351a4b60e26a187dc4d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc0",
                                                              "_id": "606e351a4b60e26a187dc4d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                      "id": "5f683497ca5ac358f170293b",
                                                      "_id": "606e351a4b60e26a187dc4d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc1",
                                                              "_id": "606e351a4b60e26a187dc4d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683497ca5ac358f1702939",
                                                      "_id": "606e351a4b60e26a187dc4d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc2",
                                                              "_id": "606e351a4b60e26a187dc4d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Evaluation Of Bounded Plane Area By Integration",
                                                      "id": "5f683497ca5ac358f1702940",
                                                      "_id": "606e351a4b60e26a187dc4ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc3",
                                                              "_id": "606e351a4b60e26a187dc4cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reduction Formulae",
                                                      "id": "5f683497ca5ac358f170293e",
                                                      "_id": "606e351a4b60e26a187dc4cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc4",
                                                              "_id": "606e351a4b60e26a187dc4cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                      "id": "5f683497ca5ac358f1702941",
                                                      "_id": "606e351a4b60e26a187dc4ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc5",
                                                              "_id": "606e351a4b60e26a187dc4cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Improper Integrals",
                                                      "id": "5f683497ca5ac358f170293d",
                                                      "_id": "606e351a4b60e26a187dc4c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc6",
                                                              "_id": "606e351a4b60e26a187dc4c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bernoulli’S Formula",
                                                      "id": "5f683497ca5ac358f170293c",
                                                      "_id": "606e351a4b60e26a187dc4c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc7",
                                                              "_id": "606e351a4b60e26a187dc4c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integral As The Limit Of A Sum",
                                                      "id": "5f683497ca5ac358f170293a",
                                                      "_id": "606e351a4b60e26a187dc4c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc8",
                                                              "_id": "606e351a4b60e26a187dc4c5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cd",
                                                      "_id": "606e351a4b60e26a187dc4d6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentials And Partial Derivatives",
                                              "id": "5f6831c6f100a06808b0d4f2",
                                              "_id": "606e351a4b60e26a187dc4b5",
                                              "concepts": [
                                                  {
                                                      "name": "Partial Derivatives",
                                                      "id": "5f68345471814158f68cc765",
                                                      "_id": "606e351a4b60e26a187dc4c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc9",
                                                              "_id": "606e351a4b60e26a187dc4c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differentials",
                                                      "id": "5f68345471814158f68cc762",
                                                      "_id": "606e351a4b60e26a187dc4be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcca",
                                                              "_id": "606e351a4b60e26a187dc4bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions Of Several Variables",
                                                      "id": "5f68345471814158f68cc763",
                                                      "_id": "606e351a4b60e26a187dc4bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccb",
                                                              "_id": "606e351a4b60e26a187dc4bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68345471814158f68cc761",
                                                      "_id": "606e351a4b60e26a187dc4ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccc",
                                                              "_id": "606e351a4b60e26a187dc4bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                      "id": "5f68345471814158f68cc764",
                                                      "_id": "606e351a4b60e26a187dc4b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccd",
                                                              "_id": "606e351a4b60e26a187dc4b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differential Of A",
                                                      "id": "5f68345471814158f68cc766",
                                                      "_id": "606e351a4b60e26a187dc4b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcce",
                                                              "_id": "606e351a4b60e26a187dc4b7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ce",
                                                      "_id": "606e351a4b60e26a187dc4c2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Theory Of Equations",
                                              "id": "5f6831c6f100a06808b0d4ed",
                                              "_id": "606e351a4b60e26a187dc4a1",
                                              "concepts": [
                                                  {
                                                      "name": "Basics Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53b",
                                                      "_id": "606e351a4b60e26a187dc4b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccf",
                                                              "_id": "606e351a4b60e26a187dc4b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vieta’S Formulae And Formation Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53c",
                                                      "_id": "606e351a4b60e26a187dc4b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd0",
                                                              "_id": "606e351a4b60e26a187dc4b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots Of Higher Degree Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53f",
                                                      "_id": "606e351a4b60e26a187dc4ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd1",
                                                              "_id": "606e351a4b60e26a187dc4af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nature Of Roots And Nature Of Coefficients Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53d",
                                                      "_id": "606e351a4b60e26a187dc4ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd2",
                                                              "_id": "606e351a4b60e26a187dc4ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications To Geometrical Problems",
                                                      "id": "5f6832c3f100a06808b0d53e",
                                                      "_id": "606e351a4b60e26a187dc4aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd3",
                                                              "_id": "606e351a4b60e26a187dc4ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomial Equations With No Additional Information",
                                                      "id": "5f6832c3f100a06808b0d541",
                                                      "_id": "606e351a4b60e26a187dc4a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd4",
                                                              "_id": "606e351a4b60e26a187dc4a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Descartes Rule",
                                                      "id": "5f6832c3f100a06808b0d542",
                                                      "_id": "606e351a4b60e26a187dc4a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd5",
                                                              "_id": "606e351a4b60e26a187dc4a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials With Additional Information",
                                                      "id": "5f6832c3f100a06808b0d540",
                                                      "_id": "606e351a4b60e26a187dc4a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd6",
                                                              "_id": "606e351a4b60e26a187dc4a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6832c3f100a06808b0d53a",
                                                      "_id": "606e351a4b60e26a187dc4a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd7",
                                                              "_id": "606e351a4b60e26a187dc4a3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cf",
                                                      "_id": "606e351a4b60e26a187dc4b4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Calculus - Differentiability And Methods Of Differentiation",
                                              "id": "5f68661f71814158f68ce591",
                                              "_id": "606e351a4b60e26a187dc497",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159ff",
                                                      "_id": "606e351a4b60e26a187dc49e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd8",
                                                              "_id": "606e351a4b60e26a187dc49f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Concept Of Derivative",
                                                      "id": "5f686a41058075680d815a00",
                                                      "_id": "606e351a4b60e26a187dc49c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd9",
                                                              "_id": "606e351a4b60e26a187dc49d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability And Continuity",
                                                      "id": "5f686a41058075680d815a01",
                                                      "_id": "606e351a4b60e26a187dc49a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcda",
                                                              "_id": "606e351a4b60e26a187dc49b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation Rules",
                                                      "id": "5f686a41058075680d815a02",
                                                      "_id": "606e351a4b60e26a187dc498",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdb",
                                                              "_id": "606e351a4b60e26a187dc499"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d0",
                                                      "_id": "606e351a4b60e26a187dc4a0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector Algebra",
                                              "id": "5f68661f71814158f68ce58f",
                                              "_id": "606e351a4b60e26a187dc485",
                                              "concepts": [
                                                  {
                                                      "name": "Algebra Of Vectors",
                                                      "id": "5f686a41058075680d8159f7",
                                                      "_id": "606e351a4b60e26a187dc494",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdc",
                                                              "_id": "606e351a4b60e26a187dc495"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resolution Of Vectors",
                                                      "id": "5f686a41058075680d8159f9",
                                                      "_id": "606e351a4b60e26a187dc492",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdd",
                                                              "_id": "606e351a4b60e26a187dc493"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Direction Cosines And Directon Ratios",
                                                      "id": "5f686a41058075680d8159fa",
                                                      "_id": "606e351a4b60e26a187dc490",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcde",
                                                              "_id": "606e351a4b60e26a187dc491"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalars And Vectors",
                                                      "id": "5f686a41058075680d8159f5",
                                                      "_id": "606e351a4b60e26a187dc48e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdf",
                                                              "_id": "606e351a4b60e26a187dc48f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position Vectors",
                                                      "id": "5f686a41058075680d8159f8",
                                                      "_id": "606e351a4b60e26a187dc48c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce0",
                                                              "_id": "606e351a4b60e26a187dc48d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product Of Vectors",
                                                      "id": "5f686a41058075680d8159fb",
                                                      "_id": "606e351a4b60e26a187dc48a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce1",
                                                              "_id": "606e351a4b60e26a187dc48b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of A Vector And Types Of Vectors",
                                                      "id": "5f686a41058075680d8159f6",
                                                      "_id": "606e351a4b60e26a187dc488",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce2",
                                                              "_id": "606e351a4b60e26a187dc489"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159f4",
                                                      "_id": "606e351a4b60e26a187dc486",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce3",
                                                              "_id": "606e351a4b60e26a187dc487"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d1",
                                                      "_id": "606e351a4b60e26a187dc496"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Calculus - Limits And Continuity",
                                              "id": "5f68661f71814158f68ce590",
                                              "_id": "606e351a4b60e26a187dc47d",
                                              "concepts": [
                                                  {
                                                      "name": "Limits",
                                                      "id": "5f686a41058075680d8159fd",
                                                      "_id": "606e351a4b60e26a187dc482",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce4",
                                                              "_id": "606e351a4b60e26a187dc483"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuity",
                                                      "id": "5f686a41058075680d8159fe",
                                                      "_id": "606e351a4b60e26a187dc480",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce5",
                                                              "_id": "606e351a4b60e26a187dc481"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159fc",
                                                      "_id": "606e351a4b60e26a187dc47e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce6",
                                                              "_id": "606e351a4b60e26a187dc47f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d2",
                                                      "_id": "606e351a4b60e26a187dc484"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Integral Calculus",
                                              "id": "5f68661f71814158f68ce592",
                                              "_id": "606e351a4b60e26a187dc46d",
                                              "concepts": [
                                                  {
                                                      "name": "Integrals Of The Form F(Ax + B)",
                                                      "id": "5f686a41058075680d815a06",
                                                      "_id": "606e351a4b60e26a187dc47a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce7",
                                                              "_id": "606e351a4b60e26a187dc47b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Rules Of Integration",
                                                      "id": "5f686a41058075680d815a05",
                                                      "_id": "606e351a4b60e26a187dc478",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce8",
                                                              "_id": "606e351a4b60e26a187dc479"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Integrals",
                                                      "id": "5f686a41058075680d815a07",
                                                      "_id": "606e351a4b60e26a187dc476",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce9",
                                                              "_id": "606e351a4b60e26a187dc477"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Applications",
                                                      "id": "5f686a41058075680d815a08",
                                                      "_id": "606e351a4b60e26a187dc474",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcea",
                                                              "_id": "606e351a4b60e26a187dc475"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Methods Of Integration",
                                                      "id": "5f686a41058075680d815a09",
                                                      "_id": "606e351a4b60e26a187dc472",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dceb",
                                                              "_id": "606e351a4b60e26a187dc473"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d815a03",
                                                      "_id": "606e351a4b60e26a187dc470",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcec",
                                                              "_id": "606e351a4b60e26a187dc471"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton-Leibnitz Integral",
                                                      "id": "5f686a41058075680d815a04",
                                                      "_id": "606e351a4b60e26a187dc46e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dced",
                                                              "_id": "606e351a4b60e26a187dc46f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d3",
                                                      "_id": "606e351a4b60e26a187dc47c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction To Probability Theory",
                                              "id": "5f68661f71814158f68ce593",
                                              "_id": "606e351a4b60e26a187dc45b",
                                              "concepts": [
                                                  {
                                                      "name": "Probability",
                                                      "id": "5f686a41058075680d815a0d",
                                                      "_id": "606e351a4b60e26a187dc46a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcee",
                                                              "_id": "606e351a4b60e26a187dc46b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Total Probability Of An Event",
                                                      "id": "5f686a41058075680d815a10",
                                                      "_id": "606e351a4b60e26a187dc468",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcef",
                                                              "_id": "606e351a4b60e26a187dc469"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Some Basic Theorems On Probability",
                                                      "id": "5f686a41058075680d815a0e",
                                                      "_id": "606e351a4b60e26a187dc466",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf0",
                                                              "_id": "606e351a4b60e26a187dc467"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d815a0a",
                                                      "_id": "606e351a4b60e26a187dc464",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf1",
                                                              "_id": "606e351a4b60e26a187dc465"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Finite Sample Space",
                                                      "id": "5f686a41058075680d815a0c",
                                                      "_id": "606e351a4b60e26a187dc462",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf2",
                                                              "_id": "606e351a4b60e26a187dc463"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Definitions",
                                                      "id": "5f686a41058075680d815a0b",
                                                      "_id": "606e351a4b60e26a187dc460",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf3",
                                                              "_id": "606e351a4b60e26a187dc461"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditional Probability",
                                                      "id": "5f686a41058075680d815a0f",
                                                      "_id": "606e351a4b60e26a187dc45e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf4",
                                                              "_id": "606e351a4b60e26a187dc45f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bayes’ Theorem",
                                                      "id": "5f686a41058075680d815a11",
                                                      "_id": "606e351a4b60e26a187dc45c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf5",
                                                              "_id": "606e351a4b60e26a187dc45d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d4",
                                                      "_id": "606e351a4b60e26a187dc46c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices And Determinants",
                                              "id": "5f68661f71814158f68ce58e",
                                              "_id": "606e351a4b60e26a187dc453",
                                              "concepts": [
                                                  {
                                                      "name": "Determinants",
                                                      "id": "5f686a41058075680d8159f3",
                                                      "_id": "606e351a4b60e26a187dc458",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf6",
                                                              "_id": "606e351a4b60e26a187dc459"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matrices",
                                                      "id": "5f686a41058075680d8159f2",
                                                      "_id": "606e351a4b60e26a187dc456",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf7",
                                                              "_id": "606e351a4b60e26a187dc457"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159f1",
                                                      "_id": "606e351a4b60e26a187dc454",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf8",
                                                              "_id": "606e351a4b60e26a187dc455"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d5",
                                                      "_id": "606e351a4b60e26a187dc45a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Binomial Th Eorem, Sequences And Series",
                                              "id": "5f68661f71814158f68ce58c",
                                              "_id": "606e351a4b60e26a187dc445",
                                              "concepts": [
                                                  {
                                                      "name": "Finite Series",
                                                      "id": "5f686a41058075680d8159ea",
                                                      "_id": "606e351a4b60e26a187dc450",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf9",
                                                              "_id": "606e351a4b60e26a187dc451"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial Theorem",
                                                      "id": "5f686a41058075680d8159e7",
                                                      "_id": "606e351a4b60e26a187dc44e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfa",
                                                              "_id": "606e351a4b60e26a187dc44f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159e6",
                                                      "_id": "606e351a4b60e26a187dc44c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfb",
                                                              "_id": "606e351a4b60e26a187dc44d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Particular Cases Of Binomial Theorem",
                                                      "id": "5f686a41058075680d8159e8",
                                                      "_id": "606e351a4b60e26a187dc44a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfc",
                                                              "_id": "606e351a4b60e26a187dc44b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Finite Sequences",
                                                      "id": "5f686a41058075680d8159e9",
                                                      "_id": "606e351a4b60e26a187dc448",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfd",
                                                              "_id": "606e351a4b60e26a187dc449"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Infinite Sequences And Series",
                                                      "id": "5f686a41058075680d8159eb",
                                                      "_id": "606e351a4b60e26a187dc446",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfe",
                                                              "_id": "606e351a4b60e26a187dc447"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d6",
                                                      "_id": "606e351a4b60e26a187dc452"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5f68661f71814158f68ce58a",
                                              "_id": "606e351a4b60e26a187dc431",
                                              "concepts": [
                                                  {
                                                      "name": "Application To Triangle",
                                                      "id": "5f686a41058075680d8159de",
                                                      "_id": "606e351a4b60e26a187dc442",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcff",
                                                              "_id": "606e351a4b60e26a187dc443"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Functions And Their Properties",
                                                      "id": "5f686a41058075680d8159da",
                                                      "_id": "606e351a4b60e26a187dc440",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd00",
                                                              "_id": "606e351a4b60e26a187dc441"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radian Measure",
                                                      "id": "5f686a41058075680d8159d9",
                                                      "_id": "606e351a4b60e26a187dc43e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd01",
                                                              "_id": "606e351a4b60e26a187dc43f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "A Recall Of Basic Results",
                                                      "id": "5f686a41058075680d8159d8",
                                                      "_id": "606e351a4b60e26a187dc43c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd02",
                                                              "_id": "606e351a4b60e26a187dc43d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inverse Trigonometric Functions",
                                                      "id": "5f686a41058075680d8159df",
                                                      "_id": "606e351a4b60e26a187dc43a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd03",
                                                              "_id": "606e351a4b60e26a187dc43b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159d7",
                                                      "_id": "606e351a4b60e26a187dc438",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd04",
                                                              "_id": "606e351a4b60e26a187dc439"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5f686a41058075680d8159db",
                                                      "_id": "606e351a4b60e26a187dc436",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd05",
                                                              "_id": "606e351a4b60e26a187dc437"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Equations",
                                                      "id": "5f686a41058075680d8159dc",
                                                      "_id": "606e351a4b60e26a187dc434",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd06",
                                                              "_id": "606e351a4b60e26a187dc435"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Triangle",
                                                      "id": "5f686a41058075680d8159dd",
                                                      "_id": "606e351a4b60e26a187dc432",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd07",
                                                              "_id": "606e351a4b60e26a187dc433"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d7",
                                                      "_id": "606e351a4b60e26a187dc444"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Combinatorics And Mathematical Induction",
                                              "id": "5f68661f71814158f68ce58b",
                                              "_id": "606e351a4b60e26a187dc423",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159e0",
                                                      "_id": "606e351a4b60e26a187dc42e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd08",
                                                              "_id": "606e351a4b60e26a187dc42f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Permutations",
                                                      "id": "5f686a41058075680d8159e3",
                                                      "_id": "606e351a4b60e26a187dc42c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd09",
                                                              "_id": "606e351a4b60e26a187dc42d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combinations",
                                                      "id": "5f686a41058075680d8159e4",
                                                      "_id": "606e351a4b60e26a187dc42a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0a",
                                                              "_id": "606e351a4b60e26a187dc42b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorials",
                                                      "id": "5f686a41058075680d8159e2",
                                                      "_id": "606e351a4b60e26a187dc428",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0b",
                                                              "_id": "606e351a4b60e26a187dc429"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Induction",
                                                      "id": "5f686a41058075680d8159e5",
                                                      "_id": "606e351a4b60e26a187dc426",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0c",
                                                              "_id": "606e351a4b60e26a187dc427"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Principles Of Counting",
                                                      "id": "5f686a41058075680d8159e1",
                                                      "_id": "606e351a4b60e26a187dc424",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0d",
                                                              "_id": "606e351a4b60e26a187dc425"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d8",
                                                      "_id": "606e351a4b60e26a187dc430"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sets, Relations And Functions",
                                              "id": "5f68661f71814158f68ce588",
                                              "_id": "606e351a4b60e26a187dc413",
                                              "concepts": [
                                                  {
                                                      "name": "Sets",
                                                      "id": "5f686a41058075680d8159c7",
                                                      "_id": "606e351a4b60e26a187dc420",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0e",
                                                              "_id": "606e351a4b60e26a187dc421"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relations",
                                                      "id": "5f686a41058075680d8159ca",
                                                      "_id": "606e351a4b60e26a187dc41e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0f",
                                                              "_id": "606e351a4b60e26a187dc41f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions",
                                                      "id": "5f686a41058075680d8159cb",
                                                      "_id": "606e351a4b60e26a187dc41c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd10",
                                                              "_id": "606e351a4b60e26a187dc41d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphing Functions Using Transformations",
                                                      "id": "5f686a41058075680d8159cc",
                                                      "_id": "606e351a4b60e26a187dc41a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd11",
                                                              "_id": "606e351a4b60e26a187dc41b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cartesian Product",
                                                      "id": "5f686a41058075680d8159c8",
                                                      "_id": "606e351a4b60e26a187dc418",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd12",
                                                              "_id": "606e351a4b60e26a187dc419"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159c6",
                                                      "_id": "606e351a4b60e26a187dc416",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd13",
                                                              "_id": "606e351a4b60e26a187dc417"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Constants And Variables, Intervals And Neighbourhoods",
                                                      "id": "5f686a41058075680d8159c9",
                                                      "_id": "606e351a4b60e26a187dc414",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd14",
                                                              "_id": "606e351a4b60e26a187dc415"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d9",
                                                      "_id": "606e351a4b60e26a187dc422"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Two Dimensional Analytical Geometry",
                                              "id": "5f68661f71814158f68ce58d",
                                              "_id": "606e351a4b60e26a187dc407",
                                              "concepts": [
                                                  {
                                                      "name": "Straight Lines",
                                                      "id": "5f686a41058075680d8159ee",
                                                      "_id": "606e351a4b60e26a187dc410",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd15",
                                                              "_id": "606e351a4b60e26a187dc411"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159ec",
                                                      "_id": "606e351a4b60e26a187dc40e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd16",
                                                              "_id": "606e351a4b60e26a187dc40f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pair Of Straight Lines",
                                                      "id": "5f686a41058075680d8159f0",
                                                      "_id": "606e351a4b60e26a187dc40c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd17",
                                                              "_id": "606e351a4b60e26a187dc40d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Locus Of A Point",
                                                      "id": "5f686a41058075680d8159ed",
                                                      "_id": "606e351a4b60e26a187dc40a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd18",
                                                              "_id": "606e351a4b60e26a187dc40b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle Between Two Straight Lines",
                                                      "id": "5f686a41058075680d8159ef",
                                                      "_id": "606e351a4b60e26a187dc408",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd19",
                                                              "_id": "606e351a4b60e26a187dc409"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9da",
                                                      "_id": "606e351a4b60e26a187dc412"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Basic Algebra",
                                              "id": "5f68661f71814158f68ce589",
                                              "_id": "606e351a4b60e26a187dc3f1",
                                              "concepts": [
                                                  {
                                                      "name": "Quadratic Functions",
                                                      "id": "5f686a41058075680d8159d1",
                                                      "_id": "606e351a4b60e26a187dc404",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1a",
                                                              "_id": "606e351a4b60e26a187dc405"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomial Functions",
                                                      "id": "5f686a41058075680d8159d2",
                                                      "_id": "606e351a4b60e26a187dc402",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1b",
                                                              "_id": "606e351a4b60e26a187dc403"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Functions",
                                                      "id": "5f686a41058075680d8159d3",
                                                      "_id": "606e351a4b60e26a187dc400",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1c",
                                                              "_id": "606e351a4b60e26a187dc401"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Number System",
                                                      "id": "5f686a41058075680d8159ce",
                                                      "_id": "606e351a4b60e26a187dc3fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1d",
                                                              "_id": "606e351a4b60e26a187dc3ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159cd",
                                                      "_id": "606e351a4b60e26a187dc3fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1e",
                                                              "_id": "606e351a4b60e26a187dc3fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exponents And Radicals",
                                                      "id": "5f686a41058075680d8159d4",
                                                      "_id": "606e351a4b60e26a187dc3fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1f",
                                                              "_id": "606e351a4b60e26a187dc3fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Algebra In Real Life",
                                                      "id": "5f686a41058075680d8159d6",
                                                      "_id": "606e351a4b60e26a187dc3f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd20",
                                                              "_id": "606e351a4b60e26a187dc3f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Logarithm",
                                                      "id": "5f686a41058075680d8159d5",
                                                      "_id": "606e351a4b60e26a187dc3f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd21",
                                                              "_id": "606e351a4b60e26a187dc3f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Absolute Value",
                                                      "id": "5f686a41058075680d8159cf",
                                                      "_id": "606e351a4b60e26a187dc3f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd22",
                                                              "_id": "606e351a4b60e26a187dc3f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Inequalities",
                                                      "id": "5f686a41058075680d8159d0",
                                                      "_id": "606e351a4b60e26a187dc3f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd23",
                                                              "_id": "606e351a4b60e26a187dc3f3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9db",
                                                      "_id": "606e351a4b60e26a187dc406"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Integration",
                                              "id": "5f71d512ce003c1296026cd3",
                                              "_id": "606e351a4b60e26a187dc3dd",
                                              "concepts": [
                                                  {
                                                      "name": "Evaluation Of Bounded Plane Area By Integration",
                                                      "id": "5f71d7c47ac53612907090e4",
                                                      "_id": "606e351a4b60e26a187dc3ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd24",
                                                              "_id": "606e351a4b60e26a187dc3ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                      "id": "5f71d7c47ac53612907090e5",
                                                      "_id": "606e351a4b60e26a187dc3ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd25",
                                                              "_id": "606e351a4b60e26a187dc3ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090dd",
                                                      "_id": "606e351a4b60e26a187dc3ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd26",
                                                              "_id": "606e351a4b60e26a187dc3eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integral As The Limit Of A Sum",
                                                      "id": "5f71d7c47ac53612907090de",
                                                      "_id": "606e351a4b60e26a187dc3e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd27",
                                                              "_id": "606e351a4b60e26a187dc3e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bernoulli’S Formula",
                                                      "id": "5f71d7c47ac53612907090e0",
                                                      "_id": "606e351a4b60e26a187dc3e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd28",
                                                              "_id": "606e351a4b60e26a187dc3e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reduction Formulae",
                                                      "id": "5f71d7c47ac53612907090e2",
                                                      "_id": "606e351a4b60e26a187dc3e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd29",
                                                              "_id": "606e351a4b60e26a187dc3e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gamma Integral",
                                                      "id": "5f71d7c47ac53612907090e3",
                                                      "_id": "606e351a4b60e26a187dc3e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2a",
                                                              "_id": "606e351a4b60e26a187dc3e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                      "id": "5f71d7c47ac53612907090df",
                                                      "_id": "606e351a4b60e26a187dc3e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2b",
                                                              "_id": "606e351a4b60e26a187dc3e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Improper Integrals",
                                                      "id": "5f71d7c47ac53612907090e1",
                                                      "_id": "606e351a4b60e26a187dc3de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2c",
                                                              "_id": "606e351a4b60e26a187dc3df"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9dc",
                                                      "_id": "606e351a4b60e26a187dc3f0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Differential Calculus",
                                              "id": "5f71d512ce003c1296026cd1",
                                              "_id": "606e351a4b60e26a187dc3c7",
                                              "concepts": [
                                                  {
                                                      "name": "Applications In Optimization",
                                                      "id": "5f71d7c47ac53612907090d4",
                                                      "_id": "606e351a4b60e26a187dc3da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2d",
                                                              "_id": "606e351a4b60e26a187dc3db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090cd",
                                                      "_id": "606e351a4b60e26a187dc3d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2e",
                                                              "_id": "606e351a4b60e26a187dc3d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Symmetry And Asymptotes",
                                                      "id": "5f71d7c47ac53612907090d5",
                                                      "_id": "606e351a4b60e26a187dc3d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2f",
                                                              "_id": "606e351a4b60e26a187dc3d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meaning Of Derivatives",
                                                      "id": "5f71d7c47ac53612907090ce",
                                                      "_id": "606e351a4b60e26a187dc3d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd30",
                                                              "_id": "606e351a4b60e26a187dc3d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean Value Theorem",
                                                      "id": "5f71d7c47ac53612907090cf",
                                                      "_id": "606e351a4b60e26a187dc3d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd31",
                                                              "_id": "606e351a4b60e26a187dc3d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series Expansions",
                                                      "id": "5f71d7c47ac53612907090d0",
                                                      "_id": "606e351a4b60e26a187dc3d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd32",
                                                              "_id": "606e351a4b60e26a187dc3d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Second Derivative",
                                                      "id": "5f71d7c47ac53612907090d3",
                                                      "_id": "606e351a4b60e26a187dc3ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd33",
                                                              "_id": "606e351a4b60e26a187dc3cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sketching Of Curves",
                                                      "id": "5f71d7c47ac53612907090d6",
                                                      "_id": "606e351a4b60e26a187dc3cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd34",
                                                              "_id": "606e351a4b60e26a187dc3cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Indeterminate Forms",
                                                      "id": "5f71d7c47ac53612907090d1",
                                                      "_id": "606e351a4b60e26a187dc3ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd35",
                                                              "_id": "606e351a4b60e26a187dc3cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Derivative",
                                                      "id": "5f71d7c47ac53612907090d2",
                                                      "_id": "606e351a4b60e26a187dc3c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd36",
                                                              "_id": "606e351a4b60e26a187dc3c9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9dd",
                                                      "_id": "606e351a4b60e26a187dc3dc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Discrete Mathematics",
                                              "id": "5f71d512ce003c1296026cd6",
                                              "_id": "606e351a4b60e26a187dc3bf",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090f4",
                                                      "_id": "606e351a4b60e26a187dc3c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd37",
                                                              "_id": "606e351a4b60e26a187dc3c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Logic",
                                                      "id": "5f71d7c47ac53612907090f6",
                                                      "_id": "606e351a4b60e26a187dc3c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd38",
                                                              "_id": "606e351a4b60e26a187dc3c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binary Operations",
                                                      "id": "5f71d7c47ac53612907090f5",
                                                      "_id": "606e351a4b60e26a187dc3c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd39",
                                                              "_id": "606e351a4b60e26a187dc3c1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9de",
                                                      "_id": "606e351a4b60e26a187dc3c6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability Distributions",
                                              "id": "5f71d512ce003c1296026cd5",
                                              "_id": "606e351a4b60e26a187dc3b1",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Random Variable",
                                                      "id": "5f71d7c47ac53612907090f0",
                                                      "_id": "606e351a4b60e26a187dc3bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3a",
                                                              "_id": "606e351a4b60e26a187dc3bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random Variable",
                                                      "id": "5f71d7c47ac53612907090ef",
                                                      "_id": "606e351a4b60e26a187dc3ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3b",
                                                              "_id": "606e351a4b60e26a187dc3bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                      "id": "5f71d7c47ac53612907090f3",
                                                      "_id": "606e351a4b60e26a187dc3b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3c",
                                                              "_id": "606e351a4b60e26a187dc3b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090ee",
                                                      "_id": "606e351a4b60e26a187dc3b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3d",
                                                              "_id": "606e351a4b60e26a187dc3b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Expectation",
                                                      "id": "5f71d7c47ac53612907090f2",
                                                      "_id": "606e351a4b60e26a187dc3b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3e",
                                                              "_id": "606e351a4b60e26a187dc3b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuous Distributions",
                                                      "id": "5f71d7c47ac53612907090f1",
                                                      "_id": "606e351a4b60e26a187dc3b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3f",
                                                              "_id": "606e351a4b60e26a187dc3b3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9df",
                                                      "_id": "606e351a4b60e26a187dc3be"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentials And Partial Derivatives",
                                              "id": "5f71d512ce003c1296026cd2",
                                              "_id": "606e351a4b60e26a187dc3a3",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Approximation And Differential Of A",
                                                      "id": "5f71d7c47ac53612907090dc",
                                                      "_id": "606e351a4b60e26a187dc3ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd40",
                                                              "_id": "606e351a4b60e26a187dc3af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                      "id": "5f71d7c47ac53612907090da",
                                                      "_id": "606e351a4b60e26a187dc3ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd41",
                                                              "_id": "606e351a4b60e26a187dc3ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Partial Derivatives",
                                                      "id": "5f71d7c47ac53612907090db",
                                                      "_id": "606e351a4b60e26a187dc3aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd42",
                                                              "_id": "606e351a4b60e26a187dc3ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions Of Several Variables",
                                                      "id": "5f71d7c47ac53612907090d9",
                                                      "_id": "606e351a4b60e26a187dc3a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd43",
                                                              "_id": "606e351a4b60e26a187dc3a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differentials",
                                                      "id": "5f71d7c47ac53612907090d8",
                                                      "_id": "606e351a4b60e26a187dc3a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd44",
                                                              "_id": "606e351a4b60e26a187dc3a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090d7",
                                                      "_id": "606e351a4b60e26a187dc3a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd45",
                                                              "_id": "606e351a4b60e26a187dc3a5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9e0",
                                                      "_id": "606e351a4b60e26a187dc3b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ordinary Differential Equations",
                                              "id": "5f71d512ce003c1296026cd4",
                                              "_id": "606e351a4b60e26a187dc391",
                                              "concepts": [
                                                  {
                                                      "name": "Classification Of Differential Equations",
                                                      "id": "5f71d7c47ac53612907090e8",
                                                      "_id": "606e351a4b60e26a187dc3a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd46",
                                                              "_id": "606e351a4b60e26a187dc3a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of First Order And First Degree Differential Equations",
                                                      "id": "5f71d7c47ac53612907090eb",
                                                      "_id": "606e351a4b60e26a187dc39e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd47",
                                                              "_id": "606e351a4b60e26a187dc39f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differential Equation, Order, And Degree",
                                                      "id": "5f71d7c47ac53612907090e7",
                                                      "_id": "606e351a4b60e26a187dc39c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd48",
                                                              "_id": "606e351a4b60e26a187dc39d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090e6",
                                                      "_id": "606e351a4b60e26a187dc39a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd49",
                                                              "_id": "606e351a4b60e26a187dc39b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation Of Differential Equations",
                                                      "id": "5f71d7c47ac53612907090e9",
                                                      "_id": "606e351a4b60e26a187dc398",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4a",
                                                              "_id": "606e351a4b60e26a187dc399"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Order Ordinary Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ed",
                                                      "_id": "606e351a4b60e26a187dc396",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4b",
                                                              "_id": "606e351a4b60e26a187dc397"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of Ordinary Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ea",
                                                      "_id": "606e351a4b60e26a187dc394",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4c",
                                                              "_id": "606e351a4b60e26a187dc395"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First Order Linear Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ec",
                                                      "_id": "606e351a4b60e26a187dc392",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4d",
                                                              "_id": "606e351a4b60e26a187dc393"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9e1",
                                                      "_id": "606e351a4b60e26a187dc3a2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d91f",
                                              "_id": "606e351a4b60e26a187dc845"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Laws Of Motion",
                                              "id": "5f6860f5058075680d81545a",
                                              "_id": "606e351a4b60e26a187dc380",
                                              "concepts": [
                                                  {
                                                      "name": "Dynamics Of Circular Motion",
                                                      "id": "5f6862f9f100a06808b0f5ba",
                                                      "_id": "606e351a4b60e26a187dc38d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de70",
                                                              "_id": "606e351a4b60e26a187dc38e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lami’S Theorem",
                                                      "id": "5f6862f9f100a06808b0f5b7",
                                                      "_id": "606e351a4b60e26a187dc38b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de71",
                                                              "_id": "606e351a4b60e26a187dc38c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5b4",
                                                      "_id": "606e351a4b60e26a187dc389",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de72",
                                                              "_id": "606e351a4b60e26a187dc38a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Friction",
                                                      "id": "5f6862f9f100a06808b0f5b9",
                                                      "_id": "606e351a4b60e26a187dc387",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de73",
                                                              "_id": "606e351a4b60e26a187dc388"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton’S Laws",
                                                      "id": "5f6862f9f100a06808b0f5b5",
                                                      "_id": "606e351a4b60e26a187dc385",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de74",
                                                              "_id": "606e351a4b60e26a187dc386"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Newton’S Laws",
                                                      "id": "5f6862f9f100a06808b0f5b6",
                                                      "_id": "606e351a4b60e26a187dc383",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de75",
                                                              "_id": "606e351a4b60e26a187dc384"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Law Of Conservation Of Total Linear Momentum",
                                                      "id": "5f6862f9f100a06808b0f5b8",
                                                      "_id": "606e351a4b60e26a187dc381",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de76",
                                                              "_id": "606e351a4b60e26a187dc382"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd76",
                                                      "_id": "606e351a4b60e26a187dc38f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Motion Of System Of Particles And Rigid Bodies",
                                              "id": "5f6860f5058075680d81545c",
                                              "_id": "606e351a4b60e26a187dc370",
                                              "concepts": [
                                                  {
                                                      "name": "Equilibrium Of Rigid Bodies",
                                                      "id": "5f6862f9f100a06808b0f5c3",
                                                      "_id": "606e351a4b60e26a187dc37d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de77",
                                                              "_id": "606e351a4b60e26a187dc37e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque And Angular Momentum",
                                                      "id": "5f6862f9f100a06808b0f5c2",
                                                      "_id": "606e351a4b60e26a187dc37b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de78",
                                                              "_id": "606e351a4b60e26a187dc37c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Centre Of Mass",
                                                      "id": "5f6862f9f100a06808b0f5c1",
                                                      "_id": "606e351a4b60e26a187dc379",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de79",
                                                              "_id": "606e351a4b60e26a187dc37a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5c0",
                                                      "_id": "606e351a4b60e26a187dc377",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7a",
                                                              "_id": "606e351a4b60e26a187dc378"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment Of Inertia",
                                                      "id": "5f6862f9f100a06808b0f5c4",
                                                      "_id": "606e351a4b60e26a187dc375",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7b",
                                                              "_id": "606e351a4b60e26a187dc376"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rolling Motion",
                                                      "id": "5f6862f9f100a06808b0f5c6",
                                                      "_id": "606e351a4b60e26a187dc373",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7c",
                                                              "_id": "606e351a4b60e26a187dc374"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rotational Dynamics",
                                                      "id": "5f6862f9f100a06808b0f5c5",
                                                      "_id": "606e351a4b60e26a187dc371",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7d",
                                                              "_id": "606e351a4b60e26a187dc372"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd77",
                                                      "_id": "606e351a4b60e26a187dc37f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Nature Of Physical World And Measurement",
                                              "id": "5f6860f5058075680d815458",
                                              "_id": "606e351a4b60e26a187dc35e",
                                              "concepts": [
                                                  {
                                                      "name": "Theory Of Errors",
                                                      "id": "5f6862f9f100a06808b0f5a6",
                                                      "_id": "606e351a4b60e26a187dc36d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7e",
                                                              "_id": "606e351a4b60e26a187dc36e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Physics - Introduction",
                                                      "id": "5f6862f9f100a06808b0f5a2",
                                                      "_id": "606e351a4b60e26a187dc36b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7f",
                                                              "_id": "606e351a4b60e26a187dc36c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Physics In Relation To Technology And Society",
                                                      "id": "5f6862f9f100a06808b0f5a3",
                                                      "_id": "606e351a4b60e26a187dc369",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de80",
                                                              "_id": "606e351a4b60e26a187dc36a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dimensional Analysis",
                                                      "id": "5f6862f9f100a06808b0f5a8",
                                                      "_id": "606e351a4b60e26a187dc367",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de81",
                                                              "_id": "606e351a4b60e26a187dc368"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Significant Figures",
                                                      "id": "5f6862f9f100a06808b0f5a7",
                                                      "_id": "606e351a4b60e26a187dc365",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de82",
                                                              "_id": "606e351a4b60e26a187dc366"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Science—Introduction",
                                                      "id": "5f6862f9f100a06808b0f5a1",
                                                      "_id": "606e351a4b60e26a187dc363",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de83",
                                                              "_id": "606e351a4b60e26a187dc364"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measurement Of Basic Quantities",
                                                      "id": "5f6862f9f100a06808b0f5a5",
                                                      "_id": "606e351a4b60e26a187dc361",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de84",
                                                              "_id": "606e351a4b60e26a187dc362"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measurement",
                                                      "id": "5f6862f9f100a06808b0f5a4",
                                                      "_id": "606e351a4b60e26a187dc35f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de85",
                                                              "_id": "606e351a4b60e26a187dc360"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd78",
                                                      "_id": "606e351a4b60e26a187dc36f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work, Energy And Power",
                                              "id": "5f6860f5058075680d81545b",
                                              "_id": "606e351a4b60e26a187dc352",
                                              "concepts": [
                                                  {
                                                      "name": "Energy",
                                                      "id": "5f6862f9f100a06808b0f5bd",
                                                      "_id": "606e351a4b60e26a187dc35b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de86",
                                                              "_id": "606e351a4b60e26a187dc35c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5bb",
                                                      "_id": "606e351a4b60e26a187dc359",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de87",
                                                              "_id": "606e351a4b60e26a187dc35a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work",
                                                      "id": "5f6862f9f100a06808b0f5bc",
                                                      "_id": "606e351a4b60e26a187dc357",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de88",
                                                              "_id": "606e351a4b60e26a187dc358"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Collisions",
                                                      "id": "5f6862f9f100a06808b0f5bf",
                                                      "_id": "606e351a4b60e26a187dc355",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de89",
                                                              "_id": "606e351a4b60e26a187dc356"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power",
                                                      "id": "5f6862f9f100a06808b0f5be",
                                                      "_id": "606e351a4b60e26a187dc353",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8a",
                                                              "_id": "606e351a4b60e26a187dc354"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd79",
                                                      "_id": "606e351a4b60e26a187dc35d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Kinematics",
                                              "id": "5f6860f5058075680d815459",
                                              "_id": "606e351a4b60e26a187dc33a",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5a9",
                                                      "_id": "606e351a4b60e26a187dc34f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8b",
                                                              "_id": "606e351a4b60e26a187dc350"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Components Of A Vector",
                                                      "id": "5f6862f9f100a06808b0f5ac",
                                                      "_id": "606e351a4b60e26a187dc34d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8c",
                                                              "_id": "606e351a4b60e26a187dc34e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Integral Calculus",
                                                      "id": "5f6862f9f100a06808b0f5b1",
                                                      "_id": "606e351a4b60e26a187dc34b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8d",
                                                              "_id": "606e351a4b60e26a187dc34c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Elementary Concepts Of Vector Algebra",
                                                      "id": "5f6862f9f100a06808b0f5ab",
                                                      "_id": "606e351a4b60e26a187dc349",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8e",
                                                              "_id": "606e351a4b60e26a187dc34a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multiplication Of Vector By A Scalar",
                                                      "id": "5f6862f9f100a06808b0f5ad",
                                                      "_id": "606e351a4b60e26a187dc347",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8f",
                                                              "_id": "606e351a4b60e26a187dc348"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position Vector",
                                                      "id": "5f6862f9f100a06808b0f5ae",
                                                      "_id": "606e351a4b60e26a187dc345",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de90",
                                                              "_id": "606e351a4b60e26a187dc346"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance And Displacement",
                                                      "id": "5f6862f9f100a06808b0f5af",
                                                      "_id": "606e351a4b60e26a187dc343",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de91",
                                                              "_id": "606e351a4b60e26a187dc344"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differential Calculus",
                                                      "id": "5f6862f9f100a06808b0f5b0",
                                                      "_id": "606e351a4b60e26a187dc341",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de92",
                                                              "_id": "606e351a4b60e26a187dc342"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion Along One Dimension",
                                                      "id": "5f6862f9f100a06808b0f5b2",
                                                      "_id": "606e351a4b60e26a187dc33f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de93",
                                                              "_id": "606e351a4b60e26a187dc340"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concept Of Rest And Motion",
                                                      "id": "5f6862f9f100a06808b0f5aa",
                                                      "_id": "606e351a4b60e26a187dc33d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de94",
                                                              "_id": "606e351a4b60e26a187dc33e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projectile Motion",
                                                      "id": "5f6862f9f100a06808b0f5b3",
                                                      "_id": "606e351a4b60e26a187dc33b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de95",
                                                              "_id": "606e351a4b60e26a187dc33c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7a",
                                                      "_id": "606e351a4b60e26a187dc351"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Principle of communication",
                                              "id": "5ace20329fe7b01d5806bcb6",
                                              "_id": "606e351a4b60e26a187dc336",
                                              "concepts": [
                                                  {
                                                      "name": "Basic of electronic communication",
                                                      "id": "5ace20419fe7b01d5806c1d2",
                                                      "_id": "606e351a4b60e26a187dc337",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de96",
                                                              "_id": "606e351a4b60e26a187dc338"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7b",
                                                      "_id": "606e351a4b60e26a187dc339"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semi conductors",
                                              "id": "5ace20329fe7b01d5806bcb7",
                                              "_id": "606e351a4b60e26a187dc330",
                                              "concepts": [
                                                  {
                                                      "name": "basic of semiconductors, semiconductors diode, junction transistor",
                                                      "id": "5ace20419fe7b01d5806c1d3",
                                                      "_id": "606e351a4b60e26a187dc333",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de97",
                                                              "_id": "606e351a4b60e26a187dc334"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "digital electronics and logic gates",
                                                      "id": "5ace20419fe7b01d5806c1d4",
                                                      "_id": "606e351a4b60e26a187dc331",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de98",
                                                              "_id": "606e351a4b60e26a187dc332"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7c",
                                                      "_id": "606e351a4b60e26a187dc335"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Heat and Thermodynamics",
                                              "id": "5ace20329fe7b01d5806bcb8",
                                              "_id": "606e351a4b60e26a187dc31e",
                                              "concepts": [
                                                  {
                                                      "name": "calorimetary",
                                                      "id": "5ace20419fe7b01d5806c1d5",
                                                      "_id": "606e351a4b60e26a187dc32d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de99",
                                                              "_id": "606e351a4b60e26a187dc32e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First law of Thermodynamics & process",
                                                      "id": "5ace20419fe7b01d5806c1d6",
                                                      "_id": "606e351a4b60e26a187dc32b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9a",
                                                              "_id": "606e351a4b60e26a187dc32c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "graphs, efficiency and engines",
                                                      "id": "5ace20419fe7b01d5806c1d7",
                                                      "_id": "606e351a4b60e26a187dc329",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9b",
                                                              "_id": "606e351a4b60e26a187dc32a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heat transfer conduction",
                                                      "id": "5ace20419fe7b01d5806c1d8",
                                                      "_id": "606e351a4b60e26a187dc327",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9c",
                                                              "_id": "606e351a4b60e26a187dc328"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heat transfer radiation and convection",
                                                      "id": "5ace20419fe7b01d5806c1d9",
                                                      "_id": "606e351a4b60e26a187dc325",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9d",
                                                              "_id": "606e351a4b60e26a187dc326"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ideal gas equation, Average,RMS, Most probable velocities, Molar specific heat capacities",
                                                      "id": "5ace20419fe7b01d5806c1da",
                                                      "_id": "606e351a4b60e26a187dc323",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9e",
                                                              "_id": "606e351a4b60e26a187dc324"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kinetic theory of gases and degree of freedom",
                                                      "id": "5ace20419fe7b01d5806c1db",
                                                      "_id": "606e351a4b60e26a187dc321",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9f",
                                                              "_id": "606e351a4b60e26a187dc322"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thermometry, thermal expansion of solid, liquid",
                                                      "id": "5ace20419fe7b01d5806c1dc",
                                                      "_id": "606e351a4b60e26a187dc31f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea0",
                                                              "_id": "606e351a4b60e26a187dc320"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7d",
                                                      "_id": "606e351a4b60e26a187dc32f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Simple Harmonic Motion",
                                              "id": "5ace20329fe7b01d5806bcb9",
                                              "_id": "606e351a4b60e26a187dc310",
                                              "concepts": [
                                                  {
                                                      "name": "Damped harmonic motion, forced oscillation, superposition principle, reduced mass concept",
                                                      "id": "5ace20419fe7b01d5806c1dd",
                                                      "_id": "606e351a4b60e26a187dc31b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea1",
                                                              "_id": "606e351a4b60e26a187dc31c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy in SHM",
                                                      "id": "5ace20419fe7b01d5806c1de",
                                                      "_id": "606e351a4b60e26a187dc319",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea2",
                                                              "_id": "606e351a4b60e26a187dc31a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of SHM, Relation between SHM and uniform circular motion, Phase constant, phase",
                                                      "id": "5ace20419fe7b01d5806c1df",
                                                      "_id": "606e351a4b60e26a187dc317",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea3",
                                                              "_id": "606e351a4b60e26a187dc318"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency of a system performing SHM",
                                                      "id": "5ace20419fe7b01d5806c1e0",
                                                      "_id": "606e351a4b60e26a187dc315",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea4",
                                                              "_id": "606e351a4b60e26a187dc316"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulii of elasticity, Elastic potential energy, graph between stress & strain",
                                                      "id": "5ace20419fe7b01d5806c1e1",
                                                      "_id": "606e351a4b60e26a187dc313",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea5",
                                                              "_id": "606e351a4b60e26a187dc314"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple and rigid pendulum",
                                                      "id": "5ace20419fe7b01d5806c1e2",
                                                      "_id": "606e351a4b60e26a187dc311",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea6",
                                                              "_id": "606e351a4b60e26a187dc312"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7e",
                                                      "_id": "606e351a4b60e26a187dc31d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Waves and Sound",
                                              "id": "5ace20329fe7b01d5806bcba",
                                              "_id": "606e351a4b60e26a187dc300",
                                              "concepts": [
                                                  {
                                                      "name": "Beats and doppler effect, transmission and reflection of wave",
                                                      "id": "5ace20419fe7b01d5806c1e3",
                                                      "_id": "606e351a4b60e26a187dc30d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea7",
                                                              "_id": "606e351a4b60e26a187dc30e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy transfer in waves & intensity",
                                                      "id": "5ace20419fe7b01d5806c1e4",
                                                      "_id": "606e351a4b60e26a187dc30b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea8",
                                                              "_id": "606e351a4b60e26a187dc30c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "standing wave in organ pipe and in rod",
                                                      "id": "5ace20419fe7b01d5806c1e5",
                                                      "_id": "606e351a4b60e26a187dc309",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea9",
                                                              "_id": "606e351a4b60e26a187dc30a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Superposition of waves - Interference, standing wave in string, energy in standing wave",
                                                      "id": "5ace20419fe7b01d5806c1e6",
                                                      "_id": "606e351a4b60e26a187dc307",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deaa",
                                                              "_id": "606e351a4b60e26a187dc308"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transverse and longitudinal waves, Equation of waves",
                                                      "id": "5ace20419fe7b01d5806c1e7",
                                                      "_id": "606e351a4b60e26a187dc305",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deab",
                                                              "_id": "606e351a4b60e26a187dc306"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velcoity & Acceleration of particles of medium during wave propagation",
                                                      "id": "5ace20419fe7b01d5806c1e8",
                                                      "_id": "606e351a4b60e26a187dc303",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deac",
                                                              "_id": "606e351a4b60e26a187dc304"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "velocity of longitudinal and transverse waves",
                                                      "id": "5ace20419fe7b01d5806c1e9",
                                                      "_id": "606e351a4b60e26a187dc301",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dead",
                                                              "_id": "606e351a4b60e26a187dc302"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7f",
                                                      "_id": "606e351a4b60e26a187dc30f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electromagnetic Induction And Alternating Current",
                                              "id": "5f6991e8058075680d81d37f",
                                              "_id": "606e351a4b60e26a187dc2ec",
                                              "concepts": [
                                                  {
                                                      "name": "Methods Of Producing Induced Emf",
                                                      "id": "5f69941cca5ac358f170d8ee",
                                                      "_id": "606e351a4b60e26a187dc2fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deae",
                                                              "_id": "606e351a4b60e26a187dc2fe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alternating Current",
                                                      "id": "5f69941cca5ac358f170d8f1",
                                                      "_id": "606e351a4b60e26a187dc2fb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deaf",
                                                              "_id": "606e351a4b60e26a187dc2fc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Induction",
                                                      "id": "5f69941cca5ac358f170d8eb",
                                                      "_id": "606e351a4b60e26a187dc2f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb0",
                                                              "_id": "606e351a4b60e26a187dc2fa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power In Ac Circuits",
                                                      "id": "5f69941cca5ac358f170d8f2",
                                                      "_id": "606e351a4b60e26a187dc2f7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb1",
                                                              "_id": "606e351a4b60e26a187dc2f8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Oscillation In Lc Circuits",
                                                      "id": "5f69941cca5ac358f170d8f3",
                                                      "_id": "606e351a4b60e26a187dc2f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb2",
                                                              "_id": "606e351a4b60e26a187dc2f6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Analogies Between Lc Oscillations And Simple Harmonic Oscillations",
                                                      "id": "5f69941cca5ac358f170d8ec",
                                                      "_id": "606e351a4b60e26a187dc2f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb3",
                                                              "_id": "606e351a4b60e26a187dc2f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Self–Induction",
                                                      "id": "5f69941cca5ac358f170d8ed",
                                                      "_id": "606e351a4b60e26a187dc2f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb4",
                                                              "_id": "606e351a4b60e26a187dc2f2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ac Generator",
                                                      "id": "5f69941cca5ac358f170d8ef",
                                                      "_id": "606e351a4b60e26a187dc2ef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb5",
                                                              "_id": "606e351a4b60e26a187dc2f0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformer",
                                                      "id": "5f69941cca5ac358f170d8f0",
                                                      "_id": "606e351a4b60e26a187dc2ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb6",
                                                              "_id": "606e351a4b60e26a187dc2ee"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd80",
                                                      "_id": "606e351a4b60e26a187dc2ff"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electromagnetic Waves",
                                              "id": "5f6991e8058075680d81d380",
                                              "_id": "606e351a4b60e26a187dc2e4",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Spectrumemission And Absorption Spectrumfraunhofer Lines",
                                                      "id": "5f699431058075680d81d4bd",
                                                      "_id": "606e351a4b60e26a187dc2e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb7",
                                                              "_id": "606e351a4b60e26a187dc2ea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Waves",
                                                      "id": "5f699431058075680d81d4bc",
                                                      "_id": "606e351a4b60e26a187dc2e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb8",
                                                              "_id": "606e351a4b60e26a187dc2e8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699431058075680d81d4bb",
                                                      "_id": "606e351a4b60e26a187dc2e5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb9",
                                                              "_id": "606e351a4b60e26a187dc2e6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd81",
                                                      "_id": "606e351a4b60e26a187dc2eb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Communication Systems",
                                              "id": "5f6991e8058075680d81d385",
                                              "_id": "606e351a4b60e26a187dc2ca",
                                              "concepts": [
                                                  {
                                                      "name": "Modulation",
                                                      "id": "5f699522058075680d81d51a",
                                                      "_id": "606e351a4b60e26a187dc2e1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deba",
                                                              "_id": "606e351a4b60e26a187dc2e2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Satellite Communication",
                                                      "id": "5f699522058075680d81d51e",
                                                      "_id": "606e351a4b60e26a187dc2df",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debb",
                                                              "_id": "606e351a4b60e26a187dc2e0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Propagation Of Electromagnetic Waves",
                                                      "id": "5f699522058075680d81d51d",
                                                      "_id": "606e351a4b60e26a187dc2dd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debc",
                                                              "_id": "606e351a4b60e26a187dc2de"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radar And Applications",
                                                      "id": "5f699522058075680d81d520",
                                                      "_id": "606e351a4b60e26a187dc2db",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debd",
                                                              "_id": "606e351a4b60e26a187dc2dc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Elements Of An Electronic Communication System",
                                                      "id": "5f699522058075680d81d51b",
                                                      "_id": "606e351a4b60e26a187dc2d9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debe",
                                                              "_id": "606e351a4b60e26a187dc2da"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internet",
                                                      "id": "5f699522058075680d81d522",
                                                      "_id": "606e351a4b60e26a187dc2d7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debf",
                                                              "_id": "606e351a4b60e26a187dc2d8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699522058075680d81d519",
                                                      "_id": "606e351a4b60e26a187dc2d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec0",
                                                              "_id": "606e351a4b60e26a187dc2d6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Antenna Size",
                                                      "id": "5f699522058075680d81d51c",
                                                      "_id": "606e351a4b60e26a187dc2d3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec1",
                                                              "_id": "606e351a4b60e26a187dc2d4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Global Positioning System",
                                                      "id": "5f699522058075680d81d523",
                                                      "_id": "606e351a4b60e26a187dc2d1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec2",
                                                              "_id": "606e351a4b60e26a187dc2d2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fibre Optic Communication",
                                                      "id": "5f699522058075680d81d51f",
                                                      "_id": "606e351a4b60e26a187dc2cf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec3",
                                                              "_id": "606e351a4b60e26a187dc2d0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mobile Communication",
                                                      "id": "5f699522058075680d81d521",
                                                      "_id": "606e351a4b60e26a187dc2cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec4",
                                                              "_id": "606e351a4b60e26a187dc2ce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                      "id": "5f699522058075680d81d524",
                                                      "_id": "606e351a4b60e26a187dc2cb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec5",
                                                              "_id": "606e351a4b60e26a187dc2cc"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd82",
                                                      "_id": "606e351a4b60e26a187dc2e3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Recent Developments In Physics",
                                              "id": "5f6991e8058075680d81d386",
                                              "_id": "606e351a4b60e26a187dc2c2",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699536f100a06808b181df",
                                                      "_id": "606e351a4b60e26a187dc2c7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec6",
                                                              "_id": "606e351a4b60e26a187dc2c8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nanoscience And Nanotechnology",
                                                      "id": "5f699536f100a06808b181e0",
                                                      "_id": "606e351a4b60e26a187dc2c5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec7",
                                                              "_id": "606e351a4b60e26a187dc2c6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Robotics",
                                                      "id": "5f699536f100a06808b181e1",
                                                      "_id": "606e351a4b60e26a187dc2c3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec8",
                                                              "_id": "606e351a4b60e26a187dc2c4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd83",
                                                      "_id": "606e351a4b60e26a187dc2c9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5f6991e8058075680d81d381",
                                              "_id": "606e351a4b60e26a187dc2a6",
                                              "concepts": [
                                                  {
                                                      "name": "Refraction",
                                                      "id": "5f699472ca5ac358f170d92d",
                                                      "_id": "606e351a4b60e26a187dc2bf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec9",
                                                              "_id": "606e351a4b60e26a187dc2c0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thin Lens",
                                                      "id": "5f699472ca5ac358f170d92f",
                                                      "_id": "606e351a4b60e26a187dc2bd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deca",
                                                              "_id": "606e351a4b60e26a187dc2be"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refraction At Single Spherical Surface",
                                                      "id": "5f699472ca5ac358f170d92e",
                                                      "_id": "606e351a4b60e26a187dc2bb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decb",
                                                              "_id": "606e351a4b60e26a187dc2bc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diffraction",
                                                      "id": "5f699472ca5ac358f170d934",
                                                      "_id": "606e351a4b60e26a187dc2b9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decc",
                                                              "_id": "606e351a4b60e26a187dc2ba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wave Nature Of Light",
                                                      "id": "5f699472ca5ac358f170d932",
                                                      "_id": "606e351a4b60e26a187dc2b7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decd",
                                                              "_id": "606e351a4b60e26a187dc2b8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Interference",
                                                      "id": "5f699472ca5ac358f170d933",
                                                      "_id": "606e351a4b60e26a187dc2b5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dece",
                                                              "_id": "606e351a4b60e26a187dc2b6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories On Light",
                                                      "id": "5f699472ca5ac358f170d931",
                                                      "_id": "606e351a4b60e26a187dc2b3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decf",
                                                              "_id": "606e351a4b60e26a187dc2b4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Spherical Mirrors",
                                                      "id": "5f699472ca5ac358f170d92b",
                                                      "_id": "606e351a4b60e26a187dc2b1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded0",
                                                              "_id": "606e351a4b60e26a187dc2b2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5f699472ca5ac358f170d936",
                                                      "_id": "606e351a4b60e26a187dc2af",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded1",
                                                              "_id": "606e351a4b60e26a187dc2b0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prism",
                                                      "id": "5f699472ca5ac358f170d930",
                                                      "_id": "606e351a4b60e26a187dc2ad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded2",
                                                              "_id": "606e351a4b60e26a187dc2ae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699472ca5ac358f170d92a",
                                                      "_id": "606e351a4b60e26a187dc2ab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded3",
                                                              "_id": "606e351a4b60e26a187dc2ac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Of Light",
                                                      "id": "5f699472ca5ac358f170d92c",
                                                      "_id": "606e351a4b60e26a187dc2a9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded4",
                                                              "_id": "606e351a4b60e26a187dc2aa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarisation",
                                                      "id": "5f699472ca5ac358f170d935",
                                                      "_id": "606e351a4b60e26a187dc2a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded5",
                                                              "_id": "606e351a4b60e26a187dc2a8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd84",
                                                      "_id": "606e351a4b60e26a187dc2c1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electrostatics",
                                              "id": "5f6991e8058075680d81d37c",
                                              "_id": "606e351a4b60e26a187dc292",
                                              "concepts": [
                                                  {
                                                      "name": "Electrostatics Of Conductors And Dielectrics",
                                                      "id": "5f69922571814158f68d60ef",
                                                      "_id": "606e351a4b60e26a187dc2a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded6",
                                                              "_id": "606e351a4b60e26a187dc2a4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distribution Of Charges In A Conductor And Action At Points",
                                                      "id": "5f69922571814158f68d60f1",
                                                      "_id": "606e351a4b60e26a187dc2a1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded7",
                                                              "_id": "606e351a4b60e26a187dc2a2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Dipole And Its Properties",
                                                      "id": "5f69922571814158f68d60ec",
                                                      "_id": "606e351a4b60e26a187dc29f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded8",
                                                              "_id": "606e351a4b60e26a187dc2a0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Field And Electric Field Lines",
                                                      "id": "5f69922571814158f68d60eb",
                                                      "_id": "606e351a4b60e26a187dc29d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded9",
                                                              "_id": "606e351a4b60e26a187dc29e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb’s Law",
                                                      "id": "5f69922571814158f68d60ea",
                                                      "_id": "606e351a4b60e26a187dc29b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deda",
                                                              "_id": "606e351a4b60e26a187dc29c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic Potential And Potential Energy",
                                                      "id": "5f69922571814158f68d60ed",
                                                      "_id": "606e351a4b60e26a187dc299",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedb",
                                                              "_id": "606e351a4b60e26a187dc29a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f69922571814158f68d60e9",
                                                      "_id": "606e351a4b60e26a187dc297",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedc",
                                                              "_id": "606e351a4b60e26a187dc298"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors And Capacitance",
                                                      "id": "5f69922571814158f68d60f0",
                                                      "_id": "606e351a4b60e26a187dc295",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedd",
                                                              "_id": "606e351a4b60e26a187dc296"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss Law And Its Applications",
                                                      "id": "5f69922571814158f68d60ee",
                                                      "_id": "606e351a4b60e26a187dc293",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dede",
                                                              "_id": "606e351a4b60e26a187dc294"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd85",
                                                      "_id": "606e351a4b60e26a187dc2a5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Dual Nature Of Radiation And Matter",
                                              "id": "5f6991e8058075680d81d382",
                                              "_id": "606e351a4b60e26a187dc288",
                                              "concepts": [
                                                  {
                                                      "name": "Photo Electric Effect",
                                                      "id": "5f69948d71814158f68d6237",
                                                      "_id": "606e351a4b60e26a187dc28f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedf",
                                                              "_id": "606e351a4b60e26a187dc290"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f69948d71814158f68d6236",
                                                      "_id": "606e351a4b60e26a187dc28d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee0",
                                                              "_id": "606e351a4b60e26a187dc28e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matter Waves",
                                                      "id": "5f69948d71814158f68d6238",
                                                      "_id": "606e351a4b60e26a187dc28b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee1",
                                                              "_id": "606e351a4b60e26a187dc28c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "X – Rays",
                                                      "id": "5f69948d71814158f68d6239",
                                                      "_id": "606e351a4b60e26a187dc289",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee2",
                                                              "_id": "606e351a4b60e26a187dc28a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd86",
                                                      "_id": "606e351a4b60e26a187dc291"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetism And Magnetic Effects Of Electric Current",
                                              "id": "5f6991e8058075680d81d37e",
                                              "_id": "606e351a4b60e26a187dc270",
                                              "concepts": [
                                                  {
                                                      "name": "Torque Acting On A Bar Magnet In Uniform Magnetic Field",
                                                      "id": "5f6993e8ca5ac358f170d8d8",
                                                      "_id": "606e351a4b60e26a187dc285",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee3",
                                                              "_id": "606e351a4b60e26a187dc286"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Properties",
                                                      "id": "5f6993e8ca5ac358f170d8d9",
                                                      "_id": "606e351a4b60e26a187dc283",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee4",
                                                              "_id": "606e351a4b60e26a187dc284"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction To Magnetism",
                                                      "id": "5f6993e8ca5ac358f170d8d6",
                                                      "_id": "606e351a4b60e26a187dc281",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee5",
                                                              "_id": "606e351a4b60e26a187dc282"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Hysteresis",
                                                      "id": "5f6993e8ca5ac358f170d8db",
                                                      "_id": "606e351a4b60e26a187dc27f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee6",
                                                              "_id": "606e351a4b60e26a187dc280"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Effects Of Current",
                                                      "id": "5f6993e8ca5ac358f170d8dc",
                                                      "_id": "606e351a4b60e26a187dc27d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee7",
                                                              "_id": "606e351a4b60e26a187dc27e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lorentz Force",
                                                      "id": "5f6993e8ca5ac358f170d8df",
                                                      "_id": "606e351a4b60e26a187dc27b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee8",
                                                              "_id": "606e351a4b60e26a187dc27c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification Of Magnetic Materials",
                                                      "id": "5f6993e8ca5ac358f170d8da",
                                                      "_id": "606e351a4b60e26a187dc279",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee9",
                                                              "_id": "606e351a4b60e26a187dc27a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot - Savart Law",
                                                      "id": "5f6993e8ca5ac358f170d8dd",
                                                      "_id": "606e351a4b60e26a187dc277",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deea",
                                                              "_id": "606e351a4b60e26a187dc278"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ampère’s Circuital Law",
                                                      "id": "5f6993e8ca5ac358f170d8de",
                                                      "_id": "606e351a4b60e26a187dc275",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deeb",
                                                              "_id": "606e351a4b60e26a187dc276"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb’s Inverse Square Law Of Magnetism",
                                                      "id": "5f6993e8ca5ac358f170d8d7",
                                                      "_id": "606e351a4b60e26a187dc273",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deec",
                                                              "_id": "606e351a4b60e26a187dc274"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque On A Current Loop",
                                                      "id": "5f6993e8ca5ac358f170d8e0",
                                                      "_id": "606e351a4b60e26a187dc271",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deed",
                                                              "_id": "606e351a4b60e26a187dc272"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd87",
                                                      "_id": "606e351a4b60e26a187dc287"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Current Electricity",
                                              "id": "5f6991e8058075680d81d37d",
                                              "_id": "606e351a4b60e26a187dc260",
                                              "concepts": [
                                                  {
                                                      "name": "Electric Current",
                                                      "id": "5f69925aca5ac358f170d804",
                                                      "_id": "606e351a4b60e26a187dc26d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deee",
                                                              "_id": "606e351a4b60e26a187dc26e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heating Effect Of Electric Current",
                                                      "id": "5f69925aca5ac358f170d809",
                                                      "_id": "606e351a4b60e26a187dc26b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deef",
                                                              "_id": "606e351a4b60e26a187dc26c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ohm’s Law",
                                                      "id": "5f69925aca5ac358f170d805",
                                                      "_id": "606e351a4b60e26a187dc269",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def0",
                                                              "_id": "606e351a4b60e26a187dc26a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Cells And Batteries",
                                                      "id": "5f69925aca5ac358f170d807",
                                                      "_id": "606e351a4b60e26a187dc267",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def1",
                                                              "_id": "606e351a4b60e26a187dc268"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thermoelectric Effect",
                                                      "id": "5f69925aca5ac358f170d80a",
                                                      "_id": "606e351a4b60e26a187dc265",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def2",
                                                              "_id": "606e351a4b60e26a187dc266"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kirchhoff’s Rules",
                                                      "id": "5f69925aca5ac358f170d808",
                                                      "_id": "606e351a4b60e26a187dc263",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def3",
                                                              "_id": "606e351a4b60e26a187dc264"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy And Power In Electrical Circuits",
                                                      "id": "5f69925aca5ac358f170d806",
                                                      "_id": "606e351a4b60e26a187dc261",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def4",
                                                              "_id": "606e351a4b60e26a187dc262"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd88",
                                                      "_id": "606e351a4b60e26a187dc26f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Atomic And Nuclear Physics",
                                              "id": "5f6991e8058075680d81d383",
                                              "_id": "606e351a4b60e26a187dc24e",
                                              "concepts": [
                                                  {
                                                      "name": "Nuclei",
                                                      "id": "5f6994b7ca5ac358f170d965",
                                                      "_id": "606e351a4b60e26a187dc25d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def5",
                                                              "_id": "606e351a4b60e26a187dc25e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Discharge Through Gases",
                                                      "id": "5f6994b7ca5ac358f170d963",
                                                      "_id": "606e351a4b60e26a187dc25b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def6",
                                                              "_id": "606e351a4b60e26a187dc25c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fusion",
                                                      "id": "5f6994b7ca5ac358f170d969",
                                                      "_id": "606e351a4b60e26a187dc259",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def7",
                                                              "_id": "606e351a4b60e26a187dc25a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Force",
                                                      "id": "5f6994b7ca5ac358f170d966",
                                                      "_id": "606e351a4b60e26a187dc257",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def8",
                                                              "_id": "606e351a4b60e26a187dc258"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radioactivity",
                                                      "id": "5f6994b7ca5ac358f170d967",
                                                      "_id": "606e351a4b60e26a187dc255",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def9",
                                                              "_id": "606e351a4b60e26a187dc256"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fission",
                                                      "id": "5f6994b7ca5ac358f170d968",
                                                      "_id": "606e351a4b60e26a187dc253",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defa",
                                                              "_id": "606e351a4b60e26a187dc254"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atom Models",
                                                      "id": "5f6994b7ca5ac358f170d964",
                                                      "_id": "606e351a4b60e26a187dc251",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defb",
                                                              "_id": "606e351a4b60e26a187dc252"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6994b7ca5ac358f170d962",
                                                      "_id": "606e351a4b60e26a187dc24f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defc",
                                                              "_id": "606e351a4b60e26a187dc250"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd89",
                                                      "_id": "606e351a4b60e26a187dc25f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semiconductor Electronics",
                                              "id": "5f6991e8058075680d81d384",
                                              "_id": "606e351a4b60e26a187dc23e",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Semiconductrors",
                                                      "id": "5f6994deca5ac358f170d985",
                                                      "_id": "606e351a4b60e26a187dc24b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defd",
                                                              "_id": "606e351a4b60e26a187dc24c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diodes",
                                                      "id": "5f6994deca5ac358f170d986",
                                                      "_id": "606e351a4b60e26a187dc249",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defe",
                                                              "_id": "606e351a4b60e26a187dc24a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Bipolar Junction Transistor [Bjt]",
                                                      "id": "5f6994deca5ac358f170d987",
                                                      "_id": "606e351a4b60e26a187dc247",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deff",
                                                              "_id": "606e351a4b60e26a187dc248"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Digital Electronics",
                                                      "id": "5f6994deca5ac358f170d988",
                                                      "_id": "606e351a4b60e26a187dc245",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df00",
                                                              "_id": "606e351a4b60e26a187dc246"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’s Theorem",
                                                      "id": "5f6994deca5ac358f170d98a",
                                                      "_id": "606e351a4b60e26a187dc243",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df01",
                                                              "_id": "606e351a4b60e26a187dc244"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6994deca5ac358f170d984",
                                                      "_id": "606e351a4b60e26a187dc241",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df02",
                                                              "_id": "606e351a4b60e26a187dc242"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Boolean Algebra",
                                                      "id": "5f6994deca5ac358f170d989",
                                                      "_id": "606e351a4b60e26a187dc23f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df03",
                                                              "_id": "606e351a4b60e26a187dc240"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8a",
                                                      "_id": "606e351a4b60e26a187dc24d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Communication Systems",
                                              "id": "5f71cc80414f235e9782af05",
                                              "_id": "606e351a4b60e26a187dc224",
                                              "concepts": [
                                                  {
                                                      "name": "Fibre Optic Communication",
                                                      "id": "5f71ce207ac5361290708c0c",
                                                      "_id": "606e351a4b60e26a187dc23b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df04",
                                                              "_id": "606e351a4b60e26a187dc23c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Global Positioning System",
                                                      "id": "5f71ce207ac5361290708c10",
                                                      "_id": "606e351a4b60e26a187dc239",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df05",
                                                              "_id": "606e351a4b60e26a187dc23a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internet",
                                                      "id": "5f71ce207ac5361290708c0f",
                                                      "_id": "606e351a4b60e26a187dc237",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df06",
                                                              "_id": "606e351a4b60e26a187dc238"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Antenna Size",
                                                      "id": "5f71ce207ac5361290708c09",
                                                      "_id": "606e351a4b60e26a187dc235",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df07",
                                                              "_id": "606e351a4b60e26a187dc236"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708c06",
                                                      "_id": "606e351a4b60e26a187dc233",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df08",
                                                              "_id": "606e351a4b60e26a187dc234"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                      "id": "5f71ce207ac5361290708c11",
                                                      "_id": "606e351a4b60e26a187dc231",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df09",
                                                              "_id": "606e351a4b60e26a187dc232"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radar And Applications",
                                                      "id": "5f71ce207ac5361290708c0d",
                                                      "_id": "606e351a4b60e26a187dc22f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0a",
                                                              "_id": "606e351a4b60e26a187dc230"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Propagation Of Electromagnetic Waves",
                                                      "id": "5f71ce207ac5361290708c0a",
                                                      "_id": "606e351a4b60e26a187dc22d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0b",
                                                              "_id": "606e351a4b60e26a187dc22e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Elements Of An Electronic Communication System",
                                                      "id": "5f71ce207ac5361290708c08",
                                                      "_id": "606e351a4b60e26a187dc22b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0c",
                                                              "_id": "606e351a4b60e26a187dc22c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Satellite Communication",
                                                      "id": "5f71ce207ac5361290708c0b",
                                                      "_id": "606e351a4b60e26a187dc229",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0d",
                                                              "_id": "606e351a4b60e26a187dc22a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mobile Communication",
                                                      "id": "5f71ce207ac5361290708c0e",
                                                      "_id": "606e351a4b60e26a187dc227",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0e",
                                                              "_id": "606e351a4b60e26a187dc228"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulation",
                                                      "id": "5f71ce207ac5361290708c07",
                                                      "_id": "606e351a4b60e26a187dc225",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0f",
                                                              "_id": "606e351a4b60e26a187dc226"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8b",
                                                      "_id": "606e351a4b60e26a187dc23d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Recent Developments In Physics",
                                              "id": "5f71cc80414f235e9782af06",
                                              "_id": "606e351a4b60e26a187dc21c",
                                              "concepts": [
                                                  {
                                                      "name": "Nanoscience And Nanotechnology",
                                                      "id": "5f71ce207ac5361290708c13",
                                                      "_id": "606e351a4b60e26a187dc221",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df10",
                                                              "_id": "606e351a4b60e26a187dc222"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708c12",
                                                      "_id": "606e351a4b60e26a187dc21f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df11",
                                                              "_id": "606e351a4b60e26a187dc220"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Robotics",
                                                      "id": "5f71ce207ac5361290708c14",
                                                      "_id": "606e351a4b60e26a187dc21d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df12",
                                                              "_id": "606e351a4b60e26a187dc21e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8c",
                                                      "_id": "606e351a4b60e26a187dc223"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5f71cc80414f235e9782af01",
                                              "_id": "606e351a4b60e26a187dc200",
                                              "concepts": [
                                                  {
                                                      "name": "Refraction",
                                                      "id": "5f71ce207ac5361290708be9",
                                                      "_id": "606e351a4b60e26a187dc219",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df13",
                                                              "_id": "606e351a4b60e26a187dc21a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refraction At Single Spherical Surface",
                                                      "id": "5f71ce207ac5361290708bea",
                                                      "_id": "606e351a4b60e26a187dc217",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df14",
                                                              "_id": "606e351a4b60e26a187dc218"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wave Nature Of Light",
                                                      "id": "5f71ce207ac5361290708bee",
                                                      "_id": "606e351a4b60e26a187dc215",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df15",
                                                              "_id": "606e351a4b60e26a187dc216"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708be6",
                                                      "_id": "606e351a4b60e26a187dc213",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df16",
                                                              "_id": "606e351a4b60e26a187dc214"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories On Light",
                                                      "id": "5f71ce207ac5361290708bed",
                                                      "_id": "606e351a4b60e26a187dc211",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df17",
                                                              "_id": "606e351a4b60e26a187dc212"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarisation",
                                                      "id": "5f71ce207ac5361290708bf1",
                                                      "_id": "606e351a4b60e26a187dc20f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df18",
                                                              "_id": "606e351a4b60e26a187dc210"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diffraction",
                                                      "id": "5f71ce207ac5361290708bf0",
                                                      "_id": "606e351a4b60e26a187dc20d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df19",
                                                              "_id": "606e351a4b60e26a187dc20e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prism",
                                                      "id": "5f71ce207ac5361290708bec",
                                                      "_id": "606e351a4b60e26a187dc20b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1a",
                                                              "_id": "606e351a4b60e26a187dc20c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5f71ce207ac5361290708bf2",
                                                      "_id": "606e351a4b60e26a187dc209",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1b",
                                                              "_id": "606e351a4b60e26a187dc20a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Of Light",
                                                      "id": "5f71ce207ac5361290708be8",
                                                      "_id": "606e351a4b60e26a187dc207",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1c",
                                                              "_id": "606e351a4b60e26a187dc208"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Spherical Mirrors",
                                                      "id": "5f71ce207ac5361290708be7",
                                                      "_id": "606e351a4b60e26a187dc205",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1d",
                                                              "_id": "606e351a4b60e26a187dc206"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thin Lens",
                                                      "id": "5f71ce207ac5361290708beb",
                                                      "_id": "606e351a4b60e26a187dc203",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1e",
                                                              "_id": "606e351a4b60e26a187dc204"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Interference",
                                                      "id": "5f71ce207ac5361290708bef",
                                                      "_id": "606e351a4b60e26a187dc201",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1f",
                                                              "_id": "606e351a4b60e26a187dc202"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8d",
                                                      "_id": "606e351a4b60e26a187dc21b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semiconductor Electronics",
                                              "id": "5f71cc80414f235e9782af04",
                                              "_id": "606e351a4b60e26a187dc1f0",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bff",
                                                      "_id": "606e351a4b60e26a187dc1fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df20",
                                                              "_id": "606e351a4b60e26a187dc1fe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Bipolar Junction Transistor [Bjt]",
                                                      "id": "5f71ce207ac5361290708c02",
                                                      "_id": "606e351a4b60e26a187dc1fb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df21",
                                                              "_id": "606e351a4b60e26a187dc1fc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Digital Electronics",
                                                      "id": "5f71ce207ac5361290708c03",
                                                      "_id": "606e351a4b60e26a187dc1f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df22",
                                                              "_id": "606e351a4b60e26a187dc1fa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’S Theorem",
                                                      "id": "5f71ce207ac5361290708c05",
                                                      "_id": "606e351a4b60e26a187dc1f7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df23",
                                                              "_id": "606e351a4b60e26a187dc1f8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diodes",
                                                      "id": "5f71ce207ac5361290708c01",
                                                      "_id": "606e351a4b60e26a187dc1f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df24",
                                                              "_id": "606e351a4b60e26a187dc1f6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Semiconductrors",
                                                      "id": "5f71ce207ac5361290708c00",
                                                      "_id": "606e351a4b60e26a187dc1f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df25",
                                                              "_id": "606e351a4b60e26a187dc1f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Boolean Algebra",
                                                      "id": "5f71ce207ac5361290708c04",
                                                      "_id": "606e351a4b60e26a187dc1f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df26",
                                                              "_id": "606e351a4b60e26a187dc1f2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8e",
                                                      "_id": "606e351a4b60e26a187dc1ff"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Dual Nature Of Radiation And Matter",
                                              "id": "5f71cc80414f235e9782af02",
                                              "_id": "606e351a4b60e26a187dc1e6",
                                              "concepts": [
                                                  {
                                                      "name": "X – Rays",
                                                      "id": "5f71ce207ac5361290708bf6",
                                                      "_id": "606e351a4b60e26a187dc1ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df27",
                                                              "_id": "606e351a4b60e26a187dc1ee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Photo Electric Effect",
                                                      "id": "5f71ce207ac5361290708bf4",
                                                      "_id": "606e351a4b60e26a187dc1eb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df28",
                                                              "_id": "606e351a4b60e26a187dc1ec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bf3",
                                                      "_id": "606e351a4b60e26a187dc1e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df29",
                                                              "_id": "606e351a4b60e26a187dc1ea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matter Waves",
                                                      "id": "5f71ce207ac5361290708bf5",
                                                      "_id": "606e351a4b60e26a187dc1e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2a",
                                                              "_id": "606e351a4b60e26a187dc1e8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8f",
                                                      "_id": "606e351a4b60e26a187dc1ef"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Atomic And Nuclear Physics",
                                              "id": "5f71cc80414f235e9782af03",
                                              "_id": "606e351a4b60e26a187dc1d4",
                                              "concepts": [
                                                  {
                                                      "name": "Radioactivity",
                                                      "id": "5f71ce207ac5361290708bfc",
                                                      "_id": "606e351a4b60e26a187dc1e3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2b",
                                                              "_id": "606e351a4b60e26a187dc1e4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclei",
                                                      "id": "5f71ce207ac5361290708bfa",
                                                      "_id": "606e351a4b60e26a187dc1e1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2c",
                                                              "_id": "606e351a4b60e26a187dc1e2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bf7",
                                                      "_id": "606e351a4b60e26a187dc1df",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2d",
                                                              "_id": "606e351a4b60e26a187dc1e0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Discharge Through Gases",
                                                      "id": "5f71ce207ac5361290708bf8",
                                                      "_id": "606e351a4b60e26a187dc1dd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2e",
                                                              "_id": "606e351a4b60e26a187dc1de"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fusion",
                                                      "id": "5f71ce207ac5361290708bfe",
                                                      "_id": "606e351a4b60e26a187dc1db",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2f",
                                                              "_id": "606e351a4b60e26a187dc1dc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atom Models",
                                                      "id": "5f71ce207ac5361290708bf9",
                                                      "_id": "606e351a4b60e26a187dc1d9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df30",
                                                              "_id": "606e351a4b60e26a187dc1da"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Force",
                                                      "id": "5f71ce207ac5361290708bfb",
                                                      "_id": "606e351a4b60e26a187dc1d7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df31",
                                                              "_id": "606e351a4b60e26a187dc1d8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fission",
                                                      "id": "5f71ce207ac5361290708bfd",
                                                      "_id": "606e351a4b60e26a187dc1d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df32",
                                                              "_id": "606e351a4b60e26a187dc1d6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd90",
                                                      "_id": "606e351a4b60e26a187dc1e5"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d920",
                                              "_id": "606e351a4b60e26a187dc390"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Logical Deduction",
                                              "id": "5ace20309fe7b01d5806bc18",
                                              "_id": "606e351a4b60e26a187dc1cf",
                                              "concepts": [
                                                  {
                                                      "name": "Syllogism",
                                                      "id": "5ace20389fe7b01d5806bf02",
                                                      "_id": "606e351a4b60e26a187dc1d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df47",
                                                              "_id": "606e351a4b60e26a187dc1d1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df39",
                                                      "_id": "606e351a4b60e26a187dc1d2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Paper Cutting",
                                              "id": "5ace20309fe7b01d5806bc19",
                                              "_id": "606e351a4b60e26a187dc1c9",
                                              "concepts": [
                                                  {
                                                      "name": "Folding and Unfolding",
                                                      "id": "5ace20389fe7b01d5806bf03",
                                                      "_id": "606e351a4b60e26a187dc1cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df48",
                                                              "_id": "606e351a4b60e26a187dc1cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Paper Cutting and Dot Situation",
                                                      "id": "5ace20389fe7b01d5806bf04",
                                                      "_id": "606e351a4b60e26a187dc1ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df49",
                                                              "_id": "606e351a4b60e26a187dc1cb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3a",
                                                      "_id": "606e351a4b60e26a187dc1ce"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Pattern Perception",
                                              "id": "5ace20309fe7b01d5806bc1a",
                                              "_id": "606e351a4b60e26a187dc1c5",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Completion",
                                                      "id": "5ace20389fe7b01d5806bf05",
                                                      "_id": "606e351a4b60e26a187dc1c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4a",
                                                              "_id": "606e351a4b60e26a187dc1c7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3b",
                                                      "_id": "606e351a4b60e26a187dc1c8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Rule Direction",
                                              "id": "5ace20309fe7b01d5806bc1b",
                                              "_id": "606e351a4b60e26a187dc1c1",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Series",
                                                      "id": "5ace20389fe7b01d5806bf06",
                                                      "_id": "606e351a4b60e26a187dc1c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4b",
                                                              "_id": "606e351a4b60e26a187dc1c3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3c",
                                                      "_id": "606e351a4b60e26a187dc1c4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Series Completion",
                                              "id": "5ace20309fe7b01d5806bc1c",
                                              "_id": "606e351a4b60e26a187dc1b7",
                                              "concepts": [
                                                  {
                                                      "name": "Alphabet Series",
                                                      "id": "5ace20389fe7b01d5806bf07",
                                                      "_id": "606e351a4b60e26a187dc1be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4c",
                                                              "_id": "606e351a4b60e26a187dc1bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alphanumeric Series",
                                                      "id": "5ace20389fe7b01d5806bf08",
                                                      "_id": "606e351a4b60e26a187dc1bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4d",
                                                              "_id": "606e351a4b60e26a187dc1bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuous Pattern Series",
                                                      "id": "5ace20389fe7b01d5806bf09",
                                                      "_id": "606e351a4b60e26a187dc1ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4e",
                                                              "_id": "606e351a4b60e26a187dc1bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "NUMBER SERIES",
                                                      "id": "5ace20389fe7b01d5806bf0a",
                                                      "_id": "606e351a4b60e26a187dc1b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4f",
                                                              "_id": "606e351a4b60e26a187dc1b9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3d",
                                                      "_id": "606e351a4b60e26a187dc1c0"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "606e351a4b60e26a187dc1d3"
                                          }
                                      ]
                                  }
                              ]
                          }
                      ],
                      "subjects": [
                          {
                              "name": "Mathematics",
                              "id": "5ace202e9fe7b01d5806bb8e",
                              "chapterCount": 89
                          },
                          {
                              "name": "Physics",
                              "id": "5ace202e9fe7b01d5806bb8f",
                              "chapterCount": 27
                          },
                          {
                              "name": "LOGICAL REASONING",
                              "id": "5ace202e9fe7b01d5806bb8c",
                              "chapterCount": 5
                          }
                      ],
                      "isRevision": false,
                      "description": ""
                  }
              ],
              "subjects": [
                  {
                      "id": "5ace202e9fe7b01d5806bb8e",
                      "name": "Mathematics",
                      "chapterCount": 169
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8f",
                      "name": "Physics",
                      "chapterCount": 54
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8c",
                      "name": "LOGICAL REASONING",
                      "chapterCount": 10
                  }
              ],
              "totalPhases": 2
          }
      }
  },
  
    {
      "statusCode": 200,
      "responseMessage": "Course plan details fetched",
      "responseObject": {
          "coursePlan": {
              "_id": "6077c4eebc5f4d4df9ef1b43",
              "packageId": "607551a83a5af95b0ff8b5a3",
              "type": "combo",
              "startDate": "2021-04-26T12:27:45.779Z",
              "endDate": "2021-07-26T12:27:45.779Z",
              "weekFormat": "weekly",
              "status": "draft",
              "totalTests": 0,
              "testSeries": [],
              "phases": [
                  {
                      "name": "Phase 1",
                      "startDate": "2021-04-26T00:00:00.000Z",
                      "endDate": "2021-05-31T00:00:00.000Z",
                      "_id": "6077c4efbc5f4d4df9ef234c",
                      "milestoneTests": [],
                      "weeks": [
                          {
                              "weekNo": 1,
                              "startDate": "2021-04-26T00:00:00.000Z",
                              "endDate": "2021-05-02T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef291d",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "The fundamental unit of life",
                                              "id": "5ace202f9fe7b01d5806bbc3",
                                              "_id": "6077c4efbc5f4d4df9ef2aa4",
                                              "concepts": [
                                                  {
                                                      "name": "Discovery & Microscopy",
                                                      "id": "5ace20339fe7b01d5806bd5a",
                                                      "_id": "6077c4efbc5f4d4df9ef2ab9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c829d",
                                                              "_id": "6077c4efbc5f4d4df9ef2aba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Totipotency, Size,Number and shape of cell",
                                                      "id": "5ace20339fe7b01d5806bd5d",
                                                      "_id": "6077c4efbc5f4d4df9ef2ab7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c829e",
                                                              "_id": "6077c4efbc5f4d4df9ef2ab8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Characteristics of Prokaryotic cell",
                                                      "id": "5ace20339fe7b01d5806bd57",
                                                      "_id": "6077c4efbc5f4d4df9ef2ab5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c829f",
                                                              "_id": "6077c4efbc5f4d4df9ef2ab6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Characteristics of Eukaryotic cell",
                                                      "id": "5ace20339fe7b01d5806bd56",
                                                      "_id": "6077c4efbc5f4d4df9ef2ab3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a0",
                                                              "_id": "6077c4efbc5f4d4df9ef2ab4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Difference between Prokaryotic and Eukaryotic cell",
                                                      "id": "5ace20339fe7b01d5806bd59",
                                                      "_id": "6077c4efbc5f4d4df9ef2ab1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a1",
                                                              "_id": "6077c4efbc5f4d4df9ef2ab2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Difference between plant cell and animal cell",
                                                      "id": "5ace20339fe7b01d5806bd58",
                                                      "_id": "6077c4efbc5f4d4df9ef2aaf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a2",
                                                              "_id": "6077c4efbc5f4d4df9ef2ab0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cell wall",
                                                      "id": "5ace20339fe7b01d5806bd55",
                                                      "_id": "6077c4efbc5f4d4df9ef2aad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a3",
                                                              "_id": "6077c4efbc5f4d4df9ef2aae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cell Membrane",
                                                      "id": "5ace20339fe7b01d5806bd54",
                                                      "_id": "6077c4efbc5f4d4df9ef2aab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a4",
                                                              "_id": "6077c4efbc5f4d4df9ef2aac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nucleus",
                                                      "id": "5ace20339fe7b01d5806bd5c",
                                                      "_id": "6077c4efbc5f4d4df9ef2aa9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a5",
                                                              "_id": "6077c4efbc5f4d4df9ef2aaa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Non-membranous organelles, single & double membraned organelles",
                                                      "id": "5ace20339fe7b01d5806bd5b",
                                                      "_id": "6077c4efbc5f4d4df9ef2aa7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a6",
                                                              "_id": "6077c4efbc5f4d4df9ef2aa8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cell cycle",
                                                      "id": "5ace20339fe7b01d5806bd53",
                                                      "_id": "6077c4efbc5f4d4df9ef2aa5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a7",
                                                              "_id": "6077c4efbc5f4d4df9ef2aa6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8207",
                                                      "_id": "6077c4efbc5f4d4df9ef2abb"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef2abc"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Matter in our Surroundings",
                                              "id": "5ace202f9fe7b01d5806bbcc",
                                              "_id": "6077c4efbc5f4d4df9ef2a97",
                                              "concepts": [
                                                  {
                                                      "name": "Particulate Nature Of Matter(Physical states of matter)",
                                                      "id": "5ace20349fe7b01d5806bda3",
                                                      "_id": "6077c4efbc5f4d4df9ef2aa0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831b",
                                                              "_id": "6077c4efbc5f4d4df9ef2aa1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diffusion,Brownian movement",
                                                      "id": "5ace20349fe7b01d5806bda0",
                                                      "_id": "6077c4efbc5f4d4df9ef2a9e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831c",
                                                              "_id": "6077c4efbc5f4d4df9ef2a9f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Change of state of matter",
                                                      "id": "5ace20349fe7b01d5806bd9f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a9c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831d",
                                                              "_id": "6077c4efbc5f4d4df9ef2a9d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Latent heat and specific heat",
                                                      "id": "5ace20349fe7b01d5806bda2",
                                                      "_id": "6077c4efbc5f4d4df9ef2a9a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831e",
                                                              "_id": "6077c4efbc5f4d4df9ef2a9b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Evaporation And Factors affecting evapouration",
                                                      "id": "5ace20349fe7b01d5806bda1",
                                                      "_id": "6077c4efbc5f4d4df9ef2a98",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831f",
                                                              "_id": "6077c4efbc5f4d4df9ef2a99"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8212",
                                                      "_id": "6077c4efbc5f4d4df9ef2aa2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef2aa3"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "NISL",
                                              "id": "5ace20319fe7b01d5806bc75",
                                              "_id": "6077c4efbc5f4d4df9ef2a86",
                                              "concepts": [
                                                  {
                                                      "name": "Review of Numbers, Conversion of Decimal Numbers to Rational numbers, Irrational numbers",
                                                      "id": "5ace203b9fe7b01d5806c016",
                                                      "_id": "6077c4efbc5f4d4df9ef2a93",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8362",
                                                              "_id": "6077c4efbc5f4d4df9ef2a94"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "surds",
                                                      "id": "5ace203b9fe7b01d5806c017",
                                                      "_id": "6077c4efbc5f4d4df9ef2a91",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8363",
                                                              "_id": "6077c4efbc5f4d4df9ef2a92"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conjugate of an Irrational Number",
                                                      "id": "5ace203b9fe7b01d5806c011",
                                                      "_id": "6077c4efbc5f4d4df9ef2a8f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8364",
                                                              "_id": "6077c4efbc5f4d4df9ef2a90"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rationalisation of the Denominator",
                                                      "id": "5ace203b9fe7b01d5806c015",
                                                      "_id": "6077c4efbc5f4d4df9ef2a8d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8365",
                                                              "_id": "6077c4efbc5f4d4df9ef2a8e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Logarithms- Definition and Properties",
                                                      "id": "5ace203b9fe7b01d5806c013",
                                                      "_id": "6077c4efbc5f4d4df9ef2a8b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8366",
                                                              "_id": "6077c4efbc5f4d4df9ef2a8c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "No. of divisions of a composite number, Sum of divisions of a composite number, Decimal Representation of Rational Numbers, Results on Irrational numbers, Representation of Irrational number on number line, Representation of Real Numbers using Successive Magnification",
                                                      "id": "5ace203b9fe7b01d5806c014",
                                                      "_id": "6077c4efbc5f4d4df9ef2a89",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8367",
                                                              "_id": "6077c4efbc5f4d4df9ef2a8a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Indices",
                                                      "id": "5ace203b9fe7b01d5806c012",
                                                      "_id": "6077c4efbc5f4d4df9ef2a87",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8368",
                                                              "_id": "6077c4efbc5f4d4df9ef2a88"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a95"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Binomial Theorem",
                                              "id": "5ace20319fe7b01d5806bc43",
                                              "_id": "6077c4efbc5f4d4df9ef2a7a",
                                              "concepts": [
                                                  {
                                                      "name": "Binomial Co-efficient of a specific type of term",
                                                      "id": "5ace20399fe7b01d5806bf41",
                                                      "_id": "6077c4efbc5f4d4df9ef2a83",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e2",
                                                              "_id": "6077c4efbc5f4d4df9ef2a84"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial series with k.Binomial coefficient",
                                                      "id": "5ace20399fe7b01d5806bf42",
                                                      "_id": "6077c4efbc5f4d4df9ef2a81",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e3",
                                                              "_id": "6077c4efbc5f4d4df9ef2a82"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definition, coefficient of any term",
                                                      "id": "5ace20399fe7b01d5806bf43",
                                                      "_id": "6077c4efbc5f4d4df9ef2a7f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e4",
                                                              "_id": "6077c4efbc5f4d4df9ef2a80"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest co-efficient, greatest term,",
                                                      "id": "5ace20399fe7b01d5806bf44",
                                                      "_id": "6077c4efbc5f4d4df9ef2a7d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e5",
                                                              "_id": "6077c4efbc5f4d4df9ef2a7e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of co-efficient and Relationship between the Co-efficient of the expansion like (a + bx + cx2)",
                                                      "id": "5ace20399fe7b01d5806bf45",
                                                      "_id": "6077c4efbc5f4d4df9ef2a7b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e6",
                                                              "_id": "6077c4efbc5f4d4df9ef2a7c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d939",
                                                      "_id": "6077c4efbc5f4d4df9ef2a85"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials-1",
                                              "id": "5ace20319fe7b01d5806bc76",
                                              "_id": "6077c4efbc5f4d4df9ef2a70",
                                              "concepts": [
                                                  {
                                                      "name": "Definition and Different Types of Polynomial, Algebraic Identities",
                                                      "id": "5ace203b9fe7b01d5806c018",
                                                      "_id": "6077c4efbc5f4d4df9ef2a77",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8369",
                                                              "_id": "6077c4efbc5f4d4df9ef2a78"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Degree of Polynomial, Zeroes of a Polynomial",
                                                      "id": "5ace203b9fe7b01d5806c019",
                                                      "_id": "6077c4efbc5f4d4df9ef2a75",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836a",
                                                              "_id": "6077c4efbc5f4d4df9ef2a76"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factor Theorem , Remainder Theorem",
                                                      "id": "5ace203b9fe7b01d5806c01a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a73",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836b",
                                                              "_id": "6077c4efbc5f4d4df9ef2a74"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorization of Polynomials, Axioms and Postulates, Definitions- Line,Point,Plane etc, Collinear points ,Concurrent Lines, Parallel Lines and Intersecting Lines, Line Segments",
                                                      "id": "5ace203b9fe7b01d5806c01b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a71",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836c",
                                                              "_id": "6077c4efbc5f4d4df9ef2a72"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821c",
                                                      "_id": "6077c4efbc5f4d4df9ef2a79"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Number",
                                              "id": "5ace20319fe7b01d5806bc44",
                                              "_id": "6077c4efbc5f4d4df9ef2a5a",
                                              "concepts": [
                                                  {
                                                      "name": "Argument, properties of argument",
                                                      "id": "5ace20399fe7b01d5806bf46",
                                                      "_id": "6077c4efbc5f4d4df9ef2a6d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e7",
                                                              "_id": "6077c4efbc5f4d4df9ef2a6e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concept of rotation",
                                                      "id": "5ace20399fe7b01d5806bf47",
                                                      "_id": "6077c4efbc5f4d4df9ef2a6b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e8",
                                                              "_id": "6077c4efbc5f4d4df9ef2a6c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conjugate, properties of conjugate",
                                                      "id": "5ace20399fe7b01d5806bf48",
                                                      "_id": "6077c4efbc5f4d4df9ef2a69",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9e9",
                                                              "_id": "6077c4efbc5f4d4df9ef2a6a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definition based problems",
                                                      "id": "5ace20399fe7b01d5806bf49",
                                                      "_id": "6077c4efbc5f4d4df9ef2a67",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ea",
                                                              "_id": "6077c4efbc5f4d4df9ef2a68"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De-Moiver's theorem, cube roots of unity, nth root of unity",
                                                      "id": "5ace20399fe7b01d5806bf4a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9eb",
                                                              "_id": "6077c4efbc5f4d4df9ef2a66"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ellipse, Parabola, Hyperbola",
                                                      "id": "5ace20399fe7b01d5806bf4b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a63",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ec",
                                                              "_id": "6077c4efbc5f4d4df9ef2a64"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus, properties of modulus",
                                                      "id": "5ace20399fe7b01d5806bf4c",
                                                      "_id": "6077c4efbc5f4d4df9ef2a61",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ed",
                                                              "_id": "6077c4efbc5f4d4df9ef2a62"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on geometrical application of complex number-Section Formula, Straight Line, Circle",
                                                      "id": "5ace20399fe7b01d5806bf4d",
                                                      "_id": "6077c4efbc5f4d4df9ef2a5f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ee",
                                                              "_id": "6077c4efbc5f4d4df9ef2a60"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on Locus",
                                                      "id": "5ace20399fe7b01d5806bf4e",
                                                      "_id": "6077c4efbc5f4d4df9ef2a5d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ef",
                                                              "_id": "6077c4efbc5f4d4df9ef2a5e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots of complex equations",
                                                      "id": "5ace20399fe7b01d5806bf4f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a5b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f0",
                                                              "_id": "6077c4efbc5f4d4df9ef2a5c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a6f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Lines and Angles",
                                              "id": "5ace20319fe7b01d5806bc74",
                                              "_id": "6077c4efbc5f4d4df9ef2a50",
                                              "concepts": [
                                                  {
                                                      "name": "Angles, Interior angles, Exterior angle of a Triangle",
                                                      "id": "5ace203b9fe7b01d5806c00e",
                                                      "_id": "6077c4efbc5f4d4df9ef2a57",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836d",
                                                              "_id": "6077c4efbc5f4d4df9ef2a58"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Angles",
                                                      "id": "5ace203b9fe7b01d5806c010",
                                                      "_id": "6077c4efbc5f4d4df9ef2a55",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836e",
                                                              "_id": "6077c4efbc5f4d4df9ef2a56"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle Bisector, Vertically Opposite Angles",
                                                      "id": "5ace203b9fe7b01d5806c00d",
                                                      "_id": "6077c4efbc5f4d4df9ef2a53",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c836f",
                                                              "_id": "6077c4efbc5f4d4df9ef2a54"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transversal & Corresponding Angle Axioms. Parallel lines and Properties",
                                                      "id": "5ace203b9fe7b01d5806c00f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a51",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8370",
                                                              "_id": "6077c4efbc5f4d4df9ef2a52"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821d",
                                                      "_id": "6077c4efbc5f4d4df9ef2a59"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Logarithm",
                                              "id": "5ace20319fe7b01d5806bc45",
                                              "_id": "6077c4efbc5f4d4df9ef2a4a",
                                              "concepts": [
                                                  {
                                                      "name": "Definition and properties of log",
                                                      "id": "5ace20399fe7b01d5806bf50",
                                                      "_id": "6077c4efbc5f4d4df9ef2a4d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f1",
                                                              "_id": "6077c4efbc5f4d4df9ef2a4e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Log inequalities, graphs",
                                                      "id": "5ace20399fe7b01d5806bf51",
                                                      "_id": "6077c4efbc5f4d4df9ef2a4b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f2",
                                                              "_id": "6077c4efbc5f4d4df9ef2a4c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a4f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equation In Two Variables-1",
                                              "id": "5ace20319fe7b01d5806bc72",
                                              "_id": "6077c4efbc5f4d4df9ef2a46",
                                              "concepts": [
                                                  {
                                                      "name": "Linear equations in two variables, solution of Linear Equation in Two Variables, Graph of Linear Equation in Two Variables",
                                                      "id": "5ace203b9fe7b01d5806c00a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a47",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8371",
                                                              "_id": "6077c4efbc5f4d4df9ef2a48"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821e",
                                                      "_id": "6077c4efbc5f4d4df9ef2a49"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Progression & Series",
                                              "id": "5ace20319fe7b01d5806bc46",
                                              "_id": "6077c4efbc5f4d4df9ef2a38",
                                              "concepts": [
                                                  {
                                                      "name": "AP, and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf52",
                                                      "_id": "6077c4efbc5f4d4df9ef2a43",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f3",
                                                              "_id": "6077c4efbc5f4d4df9ef2a44"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GP and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf53",
                                                      "_id": "6077c4efbc5f4d4df9ef2a41",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f4",
                                                              "_id": "6077c4efbc5f4d4df9ef2a42"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "HP and its mean and number of means inserted between two numbers",
                                                      "id": "5ace20399fe7b01d5806bf54",
                                                      "_id": "6077c4efbc5f4d4df9ef2a3f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f5",
                                                              "_id": "6077c4efbc5f4d4df9ef2a40"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of differences, Vn Method",
                                                      "id": "5ace20399fe7b01d5806bf55",
                                                      "_id": "6077c4efbc5f4d4df9ef2a3d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f6",
                                                              "_id": "6077c4efbc5f4d4df9ef2a3e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on sum of first n natural numbers, their squares and their cubes, Arithmetico Geometric Progression",
                                                      "id": "5ace20399fe7b01d5806bf56",
                                                      "_id": "6077c4efbc5f4d4df9ef2a3b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f7",
                                                              "_id": "6077c4efbc5f4d4df9ef2a3c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Inequalities of AM, GM, HM, weighted AM, weighted GM, weighted HM and AM of mth power",
                                                      "id": "5ace20399fe7b01d5806bf57",
                                                      "_id": "6077c4efbc5f4d4df9ef2a39",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f8",
                                                              "_id": "6077c4efbc5f4d4df9ef2a3a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93c",
                                                      "_id": "6077c4efbc5f4d4df9ef2a45"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Triangles",
                                              "id": "5ace20319fe7b01d5806bc83",
                                              "_id": "6077c4efbc5f4d4df9ef2a30",
                                              "concepts": [
                                                  {
                                                      "name": "Types of Triangles, Angle Sum Property of Triangle, Exterior Angle Theorem",
                                                      "id": "5ace203c9fe7b01d5806c051",
                                                      "_id": "6077c4efbc5f4d4df9ef2a35",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8372",
                                                              "_id": "6077c4efbc5f4d4df9ef2a36"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Congruence of a triangles, Criterion for the Congruence of two triangles",
                                                      "id": "5ace203c9fe7b01d5806c04f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a33",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8373",
                                                              "_id": "6077c4efbc5f4d4df9ef2a34"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inequality relations in a triangle, Important lines of a triangle (median, perpendicular bisector, angle bisector, altitude",
                                                      "id": "5ace203c9fe7b01d5806c050",
                                                      "_id": "6077c4efbc5f4d4df9ef2a31",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8374",
                                                              "_id": "6077c4efbc5f4d4df9ef2a32"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a37"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadratic Equation and Expression",
                                              "id": "5ace20319fe7b01d5806bc47",
                                              "_id": "6077c4efbc5f4d4df9ef2a20",
                                              "concepts": [
                                                  {
                                                      "name": "Condition for a common root of two quadratic equation and condition for both the roots common of two quadratic equation",
                                                      "id": "5ace20399fe7b01d5806bf58",
                                                      "_id": "6077c4efbc5f4d4df9ef2a2d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9f9",
                                                              "_id": "6077c4efbc5f4d4df9ef2a2e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation of Quadratic Equation, sign of Quadratic Expression",
                                                      "id": "5ace20399fe7b01d5806bf59",
                                                      "_id": "6077c4efbc5f4d4df9ef2a2b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fa",
                                                              "_id": "6077c4efbc5f4d4df9ef2a2c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formula for roots, discriminant",
                                                      "id": "5ace20399fe7b01d5806bf5a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a29",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fb",
                                                              "_id": "6077c4efbc5f4d4df9ef2a2a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Location of roots",
                                                      "id": "5ace20399fe7b01d5806bf5b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a27",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fc",
                                                              "_id": "6077c4efbc5f4d4df9ef2a28"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "n-th degree polynomial equation and its property",
                                                      "id": "5ace20399fe7b01d5806bf5c",
                                                      "_id": "6077c4efbc5f4d4df9ef2a25",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fd",
                                                              "_id": "6077c4efbc5f4d4df9ef2a26"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic expression",
                                                      "id": "5ace20399fe7b01d5806bf5d",
                                                      "_id": "6077c4efbc5f4d4df9ef2a23",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9fe",
                                                              "_id": "6077c4efbc5f4d4df9ef2a24"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder theorem",
                                                      "id": "5ace20399fe7b01d5806bf5e",
                                                      "_id": "6077c4efbc5f4d4df9ef2a21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673d9ff",
                                                              "_id": "6077c4efbc5f4d4df9ef2a22"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93d",
                                                      "_id": "6077c4efbc5f4d4df9ef2a2f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadrilateral",
                                              "id": "5ace20319fe7b01d5806bc7b",
                                              "_id": "6077c4efbc5f4d4df9ef2a16",
                                              "concepts": [
                                                  {
                                                      "name": "Angle sum property of quadrilateral, Various types of quadrilateral",
                                                      "id": "5ace203c9fe7b01d5806c028",
                                                      "_id": "6077c4efbc5f4d4df9ef2a1d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8375",
                                                              "_id": "6077c4efbc5f4d4df9ef2a1e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of a parallelogram, Sufficient condition for quadrilateral to be a Parallelogram",
                                                      "id": "5ace203c9fe7b01d5806c02b",
                                                      "_id": "6077c4efbc5f4d4df9ef2a1b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8376",
                                                              "_id": "6077c4efbc5f4d4df9ef2a1c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prop. of Rectangle, Rhombus and Square",
                                                      "id": "5ace203c9fe7b01d5806c02a",
                                                      "_id": "6077c4efbc5f4d4df9ef2a19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8377",
                                                              "_id": "6077c4efbc5f4d4df9ef2a1a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid - Point Theorem & it's Converse",
                                                      "id": "5ace203c9fe7b01d5806c029",
                                                      "_id": "6077c4efbc5f4d4df9ef2a17",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8378",
                                                              "_id": "6077c4efbc5f4d4df9ef2a18"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8220",
                                                      "_id": "6077c4efbc5f4d4df9ef2a1f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Derivatives",
                                              "id": "5ace20319fe7b01d5806bc48",
                                              "_id": "6077c4efbc5f4d4df9ef2a14",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93e",
                                                      "_id": "6077c4efbc5f4d4df9ef2a15"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Areas of Parallelogram and Triangles",
                                              "id": "5ace20319fe7b01d5806bc6a",
                                              "_id": "6077c4efbc5f4d4df9ef2a0e",
                                              "concepts": [
                                                  {
                                                      "name": "Theorems related to Parallelograms, Area, Triangles on the same base and between the same parallel lines",
                                                      "id": "5ace203b9fe7b01d5806bff9",
                                                      "_id": "6077c4efbc5f4d4df9ef2a11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8379",
                                                              "_id": "6077c4efbc5f4d4df9ef2a12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different triangles and there areas, Area of parallelogram on same base between same parallel lines are equal",
                                                      "id": "5ace203b9fe7b01d5806bff8",
                                                      "_id": "6077c4efbc5f4d4df9ef2a0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837a",
                                                              "_id": "6077c4efbc5f4d4df9ef2a10"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8221",
                                                      "_id": "6077c4efbc5f4d4df9ef2a13"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Derivatives",
                                              "id": "5ace20319fe7b01d5806bc49",
                                              "_id": "6077c4efbc5f4d4df9ef29f8",
                                              "concepts": [
                                                  {
                                                      "name": "angle between two curves",
                                                      "id": "5ace20399fe7b01d5806bf5f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a0b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da00",
                                                              "_id": "6077c4efbc5f4d4df9ef2a0c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based",
                                                      "id": "5ace20399fe7b01d5806bf60",
                                                      "_id": "6077c4efbc5f4d4df9ef2a09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da01",
                                                              "_id": "6077c4efbc5f4d4df9ef2a0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based - using first derivative",
                                                      "id": "5ace20399fe7b01d5806bf61",
                                                      "_id": "6077c4efbc5f4d4df9ef2a07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da02",
                                                              "_id": "6077c4efbc5f4d4df9ef2a08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "monotonocity based problems - inequality based - using second derivative",
                                                      "id": "5ace20399fe7b01d5806bf62",
                                                      "_id": "6077c4efbc5f4d4df9ef2a05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da03",
                                                              "_id": "6077c4efbc5f4d4df9ef2a06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on local/global maxima/minima using first, second and higher order derivative for a differentiable function and using graph for discontinuous function",
                                                      "id": "5ace20399fe7b01d5806bf63",
                                                      "_id": "6077c4efbc5f4d4df9ef2a03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da04",
                                                              "_id": "6077c4efbc5f4d4df9ef2a04"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Mean Value theorem",
                                                      "id": "5ace20399fe7b01d5806bf64",
                                                      "_id": "6077c4efbc5f4d4df9ef2a01",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da05",
                                                              "_id": "6077c4efbc5f4d4df9ef2a02"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on monotonocity - interval of increase and decrease using first derivative and second derivative",
                                                      "id": "5ace20399fe7b01d5806bf65",
                                                      "_id": "6077c4efbc5f4d4df9ef29ff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da06",
                                                              "_id": "6077c4efbc5f4d4df9ef2a00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on monotonocity and maxima/minima for functional equation",
                                                      "id": "5ace20399fe7b01d5806bf66",
                                                      "_id": "6077c4efbc5f4d4df9ef29fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da07",
                                                              "_id": "6077c4efbc5f4d4df9ef29fe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on normal",
                                                      "id": "5ace20399fe7b01d5806bf67",
                                                      "_id": "6077c4efbc5f4d4df9ef29fb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da08",
                                                              "_id": "6077c4efbc5f4d4df9ef29fc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Tangents",
                                                      "id": "5ace20399fe7b01d5806bf68",
                                                      "_id": "6077c4efbc5f4d4df9ef29f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da09",
                                                              "_id": "6077c4efbc5f4d4df9ef29fa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d93f",
                                                      "_id": "6077c4efbc5f4d4df9ef2a0d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circles",
                                              "id": "5ace20319fe7b01d5806bc6c",
                                              "_id": "6077c4efbc5f4d4df9ef29f0",
                                              "concepts": [
                                                  {
                                                      "name": "Definition of Circle, Major Arcs and Minor arcs, congruence of circles and arcs, some results on congurent arcs and chords, some results on equal chords",
                                                      "id": "5ace203b9fe7b01d5806bffe",
                                                      "_id": "6077c4efbc5f4d4df9ef29f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837b",
                                                              "_id": "6077c4efbc5f4d4df9ef29f6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arcs and Angle subtended by them, Cyclic Quadrilateral, Cyclic Quadrilaterals Opposite Angle",
                                                      "id": "5ace203b9fe7b01d5806bffd",
                                                      "_id": "6077c4efbc5f4d4df9ef29f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837c",
                                                              "_id": "6077c4efbc5f4d4df9ef29f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "No. of Common Tangents, Arc of Circle, Angle in Semi-Circle",
                                                      "id": "5ace203b9fe7b01d5806bfff",
                                                      "_id": "6077c4efbc5f4d4df9ef29f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837d",
                                                              "_id": "6077c4efbc5f4d4df9ef29f2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8222",
                                                      "_id": "6077c4efbc5f4d4df9ef29f7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Area Enclosed by Curves",
                                              "id": "5ace20319fe7b01d5806bc4a",
                                              "_id": "6077c4efbc5f4d4df9ef29ea",
                                              "concepts": [
                                                  {
                                                      "name": "Area bounded by f(x) and x-axis, f(y) and y-axis",
                                                      "id": "5ace20399fe7b01d5806bf69",
                                                      "_id": "6077c4efbc5f4d4df9ef29ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0a",
                                                              "_id": "6077c4efbc5f4d4df9ef29ee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area bounded by f(x), g(x), x=a and x=b, curve and its asymptotes",
                                                      "id": "5ace20399fe7b01d5806bf6a",
                                                      "_id": "6077c4efbc5f4d4df9ef29eb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0b",
                                                              "_id": "6077c4efbc5f4d4df9ef29ec"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d940",
                                                      "_id": "6077c4efbc5f4d4df9ef29ef"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions-1",
                                              "id": "5ace20319fe7b01d5806bc6e",
                                              "_id": "6077c4efbc5f4d4df9ef29e6",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of Bisector of a line segment, Construction of bisector of a given angle, Construction of some Standard angles, Construction of a triangle when its base, sum of other two sides and one base angle are given",
                                                      "id": "5ace203b9fe7b01d5806c001",
                                                      "_id": "6077c4efbc5f4d4df9ef29e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837e",
                                                              "_id": "6077c4efbc5f4d4df9ef29e8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8223",
                                                      "_id": "6077c4efbc5f4d4df9ef29e9"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef2a96"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Motion",
                                              "id": "5ace20329fe7b01d5806bcb2",
                                              "_id": "6077c4efbc5f4d4df9ef29d3",
                                              "concepts": [
                                                  {
                                                      "name": "Distance & Displacement",
                                                      "id": "5ace20409fe7b01d5806c1bb",
                                                      "_id": "6077c4efbc5f4d4df9ef29e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d6",
                                                              "_id": "6077c4efbc5f4d4df9ef29e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Avg Speed, Avg Velocity & Constant Acceleration",
                                                      "id": "5ace20409fe7b01d5806c1ba",
                                                      "_id": "6077c4efbc5f4d4df9ef29e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d7",
                                                              "_id": "6077c4efbc5f4d4df9ef29e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations of motion",
                                                      "id": "5ace20409fe7b01d5806c1bd",
                                                      "_id": "6077c4efbc5f4d4df9ef29de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d8",
                                                              "_id": "6077c4efbc5f4d4df9ef29df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Free Fall under gravity",
                                                      "id": "5ace20409fe7b01d5806c1be",
                                                      "_id": "6077c4efbc5f4d4df9ef29dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d9",
                                                              "_id": "6077c4efbc5f4d4df9ef29dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance time & Displacement time graph",
                                                      "id": "5ace20409fe7b01d5806c1bc",
                                                      "_id": "6077c4efbc5f4d4df9ef29da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83da",
                                                              "_id": "6077c4efbc5f4d4df9ef29db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Time & Velocity time graph",
                                                      "id": "5ace20409fe7b01d5806c1c0",
                                                      "_id": "6077c4efbc5f4d4df9ef29d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83db",
                                                              "_id": "6077c4efbc5f4d4df9ef29d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Uniform Circular Motion",
                                                      "id": "5ace20409fe7b01d5806c1c1",
                                                      "_id": "6077c4efbc5f4d4df9ef29d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83dc",
                                                              "_id": "6077c4efbc5f4d4df9ef29d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projectile motion",
                                                      "id": "5ace20409fe7b01d5806c1bf",
                                                      "_id": "6077c4efbc5f4d4df9ef29d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83dd",
                                                              "_id": "6077c4efbc5f4d4df9ef29d5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8238",
                                                      "_id": "6077c4efbc5f4d4df9ef29e4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electric Charges and Fields",
                                              "id": "5ace20329fe7b01d5806bc9c",
                                              "_id": "6077c4efbc5f4d4df9ef29b9",
                                              "concepts": [
                                                  {
                                                      "name": "Coulomb's law & properties of charge",
                                                      "id": "5ace203e9fe7b01d5806c0ff",
                                                      "_id": "6077c4efbc5f4d4df9ef29d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df17f",
                                                              "_id": "6077c4efbc5f4d4df9ef29d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dielectrics and forces on dielectrics",
                                                      "id": "5ace203e9fe7b01d5806c100",
                                                      "_id": "6077c4efbc5f4d4df9ef29ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df180",
                                                              "_id": "6077c4efbc5f4d4df9ef29cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "effect of electric field on a dipole",
                                                      "id": "5ace203e9fe7b01d5806c101",
                                                      "_id": "6077c4efbc5f4d4df9ef29cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df181",
                                                              "_id": "6077c4efbc5f4d4df9ef29cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric field lines and its representation",
                                                      "id": "5ace203e9fe7b01d5806c103",
                                                      "_id": "6077c4efbc5f4d4df9ef29ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df182",
                                                              "_id": "6077c4efbc5f4d4df9ef29cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric flux",
                                                      "id": "5ace203e9fe7b01d5806c104",
                                                      "_id": "6077c4efbc5f4d4df9ef29c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df183",
                                                              "_id": "6077c4efbc5f4d4df9ef29c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss' Law and its application",
                                                      "id": "5ace203e9fe7b01d5806c108",
                                                      "_id": "6077c4efbc5f4d4df9ef29c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df184",
                                                              "_id": "6077c4efbc5f4d4df9ef29c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "properties of conductor, earthing of conductor",
                                                      "id": "5ace203e9fe7b01d5806c109",
                                                      "_id": "6077c4efbc5f4d4df9ef29c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df185",
                                                              "_id": "6077c4efbc5f4d4df9ef29c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Charges and Charging by induction",
                                                      "id": "5eeb62320a45db222dd12d09",
                                                      "_id": "6077c4efbc5f4d4df9ef29c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df186",
                                                              "_id": "6077c4efbc5f4d4df9ef29c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric field and Electric flux",
                                                      "id": "5eeb62320a45db222dd12d0b",
                                                      "_id": "6077c4efbc5f4d4df9ef29c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df187",
                                                              "_id": "6077c4efbc5f4d4df9ef29c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss Law and Its Applications",
                                                      "id": "5eeb62320a45db222dd12d0d",
                                                      "_id": "6077c4efbc5f4d4df9ef29be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df188",
                                                              "_id": "6077c4efbc5f4d4df9ef29bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric dipole",
                                                      "id": "5eeb62320a45db222dd12d0c",
                                                      "_id": "6077c4efbc5f4d4df9ef29bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df189",
                                                              "_id": "6077c4efbc5f4d4df9ef29bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb's law",
                                                      "id": "5eeb62320a45db222dd12d0a",
                                                      "_id": "6077c4efbc5f4d4df9ef29ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b1bf414a7d53ce5df18a",
                                                              "_id": "6077c4efbc5f4d4df9ef29bb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76b0f0f29da5758fc4bdbc",
                                                      "_id": "6077c4efbc5f4d4df9ef29d2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Current Electricity",
                                              "id": "5ace20329fe7b01d5806bc9b",
                                              "_id": "6077c4efbc5f4d4df9ef29a5",
                                              "concepts": [
                                                  {
                                                      "name": "cell and cell combination",
                                                      "id": "5ace203e9fe7b01d5806c0f3",
                                                      "_id": "6077c4efbc5f4d4df9ef29b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd91",
                                                              "_id": "6077c4efbc5f4d4df9ef29b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Current and voltage measuring instruments",
                                                      "id": "5ace203e9fe7b01d5806c0f4",
                                                      "_id": "6077c4efbc5f4d4df9ef29b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd92",
                                                              "_id": "6077c4efbc5f4d4df9ef29b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "drift velocity, electric current in conductors and current density",
                                                      "id": "5ace203e9fe7b01d5806c0f5",
                                                      "_id": "6077c4efbc5f4d4df9ef29b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd93",
                                                              "_id": "6077c4efbc5f4d4df9ef29b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Effective resistances in networks",
                                                      "id": "5ace203e9fe7b01d5806c0f6",
                                                      "_id": "6077c4efbc5f4d4df9ef29b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd94",
                                                              "_id": "6077c4efbc5f4d4df9ef29b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heating effect of current, maximum power transfer theorem",
                                                      "id": "5ace203e9fe7b01d5806c0f7",
                                                      "_id": "6077c4efbc5f4d4df9ef29ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd95",
                                                              "_id": "6077c4efbc5f4d4df9ef29af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kirchoff's laws and circuit problems (without capacitor)",
                                                      "id": "5ace203e9fe7b01d5806c0f8",
                                                      "_id": "6077c4efbc5f4d4df9ef29ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd96",
                                                              "_id": "6077c4efbc5f4d4df9ef29ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ohm's Law, Resistance and its properties",
                                                      "id": "5ace203e9fe7b01d5806c0f9",
                                                      "_id": "6077c4efbc5f4d4df9ef29aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd97",
                                                              "_id": "6077c4efbc5f4d4df9ef29ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "R-C circuits",
                                                      "id": "5ace203e9fe7b01d5806c0fa",
                                                      "_id": "6077c4efbc5f4d4df9ef29a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd98",
                                                              "_id": "6077c4efbc5f4d4df9ef29a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wheatstone bridge and its applications",
                                                      "id": "5ace203e9fe7b01d5806c0fb",
                                                      "_id": "6077c4efbc5f4d4df9ef29a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd99",
                                                              "_id": "6077c4efbc5f4d4df9ef29a7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5b",
                                                      "_id": "6077c4efbc5f4d4df9ef29b8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electrostatic Potential and Capacitance",
                                              "id": "5ace20329fe7b01d5806bc9c",
                                              "_id": "6077c4efbc5f4d4df9ef2983",
                                              "concepts": [
                                                  {
                                                      "name": "Capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c0fc",
                                                      "_id": "6077c4efbc5f4d4df9ef29a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae62",
                                                              "_id": "6077c4efbc5f4d4df9ef29a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors and conductors",
                                                      "id": "5ace203e9fe7b01d5806c0fd",
                                                      "_id": "6077c4efbc5f4d4df9ef29a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae63",
                                                              "_id": "6077c4efbc5f4d4df9ef29a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Charge distribution and energy conservation in capacitance circuits",
                                                      "id": "5ace203e9fe7b01d5806c0fe",
                                                      "_id": "6077c4efbc5f4d4df9ef299e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae64",
                                                              "_id": "6077c4efbc5f4d4df9ef299f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Effective capacitances in various networks (Series,Parallel..etc)",
                                                      "id": "5ace203e9fe7b01d5806c102",
                                                      "_id": "6077c4efbc5f4d4df9ef299c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae65",
                                                              "_id": "6077c4efbc5f4d4df9ef299d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic field & potential energy, eqipotential surface",
                                                      "id": "5ace203e9fe7b01d5806c105",
                                                      "_id": "6077c4efbc5f4d4df9ef299a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae66",
                                                              "_id": "6077c4efbc5f4d4df9ef299b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic potential energy & self energy",
                                                      "id": "5ace203e9fe7b01d5806c106",
                                                      "_id": "6077c4efbc5f4d4df9ef2998",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae67",
                                                              "_id": "6077c4efbc5f4d4df9ef2999"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "field and potential due to a dipole",
                                                      "id": "5ace203e9fe7b01d5806c107",
                                                      "_id": "6077c4efbc5f4d4df9ef2996",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae68",
                                                              "_id": "6077c4efbc5f4d4df9ef2997"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem in a capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c10a",
                                                      "_id": "6077c4efbc5f4d4df9ef2994",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae69",
                                                              "_id": "6077c4efbc5f4d4df9ef2995"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combination of capacitors",
                                                      "id": "5eeb62320a45db222dd12d14",
                                                      "_id": "6077c4efbc5f4d4df9ef2992",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6a",
                                                              "_id": "6077c4efbc5f4d4df9ef2993"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatics of Conductors, Dielectrics and Polarisation",
                                                      "id": "5eeb62320a45db222dd12d12",
                                                      "_id": "6077c4efbc5f4d4df9ef2990",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6b",
                                                              "_id": "6077c4efbc5f4d4df9ef2991"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors and Capacitance",
                                                      "id": "5eeb62320a45db222dd12d13",
                                                      "_id": "6077c4efbc5f4d4df9ef298e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6c",
                                                              "_id": "6077c4efbc5f4d4df9ef298f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential due to an electric dipole and a system of charges",
                                                      "id": "5eeb62320a45db222dd12d0f",
                                                      "_id": "6077c4efbc5f4d4df9ef298c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6d",
                                                              "_id": "6077c4efbc5f4d4df9ef298d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equipotential surfaces and Potential Energy due to a system of charges",
                                                      "id": "5eeb62320a45db222dd12d10",
                                                      "_id": "6077c4efbc5f4d4df9ef298a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6e",
                                                              "_id": "6077c4efbc5f4d4df9ef298b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy stored in a Capacitor and Van de Graff generator",
                                                      "id": "5eeb62320a45db222dd12d15",
                                                      "_id": "6077c4efbc5f4d4df9ef2988",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae6f",
                                                              "_id": "6077c4efbc5f4d4df9ef2989"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic potential",
                                                      "id": "5eeb62320a45db222dd12d0e",
                                                      "_id": "6077c4efbc5f4d4df9ef2986",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae70",
                                                              "_id": "6077c4efbc5f4d4df9ef2987"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential energy in an external field",
                                                      "id": "5eeb62320a45db222dd12d11",
                                                      "_id": "6077c4efbc5f4d4df9ef2984",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f76b2b0a44fda53d315ae71",
                                                              "_id": "6077c4efbc5f4d4df9ef2985"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76b1e1f29da5758fc4bde0",
                                                      "_id": "6077c4efbc5f4d4df9ef29a4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Laws of Motion",
                                              "id": "5ace20329fe7b01d5806bcaf",
                                              "_id": "6077c4efbc5f4d4df9ef2971",
                                              "concepts": [
                                                  {
                                                      "name": "Force and its types and Inertia",
                                                      "id": "5ace20409fe7b01d5806c1a2",
                                                      "_id": "6077c4efbc5f4d4df9ef2980",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83de",
                                                              "_id": "6077c4efbc5f4d4df9ef2981"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton's First Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a6",
                                                      "_id": "6077c4efbc5f4d4df9ef297e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83df",
                                                              "_id": "6077c4efbc5f4d4df9ef297f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Momentum & Newton's Second Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a5",
                                                      "_id": "6077c4efbc5f4d4df9ef297c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e0",
                                                              "_id": "6077c4efbc5f4d4df9ef297d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton's Third Law of Motion",
                                                      "id": "5ace20409fe7b01d5806c1a7",
                                                      "_id": "6077c4efbc5f4d4df9ef297a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e1",
                                                              "_id": "6077c4efbc5f4d4df9ef297b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Impulse",
                                                      "id": "5ace20409fe7b01d5806c1a4",
                                                      "_id": "6077c4efbc5f4d4df9ef2978",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e2",
                                                              "_id": "6077c4efbc5f4d4df9ef2979"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conservation of Momentum",
                                                      "id": "5ace20409fe7b01d5806c1a1",
                                                      "_id": "6077c4efbc5f4d4df9ef2976",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e3",
                                                              "_id": "6077c4efbc5f4d4df9ef2977"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Friction (Basic idea)",
                                                      "id": "5ace20409fe7b01d5806c1a3",
                                                      "_id": "6077c4efbc5f4d4df9ef2974",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e4",
                                                              "_id": "6077c4efbc5f4d4df9ef2975"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Centripetal force (Basic idea)",
                                                      "id": "5ace20409fe7b01d5806c1a0",
                                                      "_id": "6077c4efbc5f4d4df9ef2972",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e5",
                                                              "_id": "6077c4efbc5f4d4df9ef2973"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8239",
                                                      "_id": "6077c4efbc5f4d4df9ef2982"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electrostatistics",
                                              "id": "5ace20329fe7b01d5806bc9c",
                                              "_id": "6077c4efbc5f4d4df9ef2951",
                                              "concepts": [
                                                  {
                                                      "name": "Capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c0fc",
                                                      "_id": "6077c4efbc5f4d4df9ef296e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9a",
                                                              "_id": "6077c4efbc5f4d4df9ef296f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors and conductors",
                                                      "id": "5ace203e9fe7b01d5806c0fd",
                                                      "_id": "6077c4efbc5f4d4df9ef296c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9b",
                                                              "_id": "6077c4efbc5f4d4df9ef296d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Charge distribution and energy conservation in capacitance circuits",
                                                      "id": "5ace203e9fe7b01d5806c0fe",
                                                      "_id": "6077c4efbc5f4d4df9ef296a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9c",
                                                              "_id": "6077c4efbc5f4d4df9ef296b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb's law & properties of charge",
                                                      "id": "5ace203e9fe7b01d5806c0ff",
                                                      "_id": "6077c4efbc5f4d4df9ef2968",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9d",
                                                              "_id": "6077c4efbc5f4d4df9ef2969"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dielectrics and forces on dielectrics",
                                                      "id": "5ace203e9fe7b01d5806c100",
                                                      "_id": "6077c4efbc5f4d4df9ef2966",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9e",
                                                              "_id": "6077c4efbc5f4d4df9ef2967"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "effect of electric field on a dipole",
                                                      "id": "5ace203e9fe7b01d5806c101",
                                                      "_id": "6077c4efbc5f4d4df9ef2964",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd9f",
                                                              "_id": "6077c4efbc5f4d4df9ef2965"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Effective capacitances in various networks (Series,Parallel..etc)",
                                                      "id": "5ace203e9fe7b01d5806c102",
                                                      "_id": "6077c4efbc5f4d4df9ef2962",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda0",
                                                              "_id": "6077c4efbc5f4d4df9ef2963"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric field lines and its representation",
                                                      "id": "5ace203e9fe7b01d5806c103",
                                                      "_id": "6077c4efbc5f4d4df9ef2960",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda1",
                                                              "_id": "6077c4efbc5f4d4df9ef2961"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric flux",
                                                      "id": "5ace203e9fe7b01d5806c104",
                                                      "_id": "6077c4efbc5f4d4df9ef295e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda2",
                                                              "_id": "6077c4efbc5f4d4df9ef295f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic field & potential energy, eqipotential surface",
                                                      "id": "5ace203e9fe7b01d5806c105",
                                                      "_id": "6077c4efbc5f4d4df9ef295c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda3",
                                                              "_id": "6077c4efbc5f4d4df9ef295d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic potential energy & self energy",
                                                      "id": "5ace203e9fe7b01d5806c106",
                                                      "_id": "6077c4efbc5f4d4df9ef295a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda4",
                                                              "_id": "6077c4efbc5f4d4df9ef295b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "field and potential due to a dipole",
                                                      "id": "5ace203e9fe7b01d5806c107",
                                                      "_id": "6077c4efbc5f4d4df9ef2958",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda5",
                                                              "_id": "6077c4efbc5f4d4df9ef2959"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss' Law and its application",
                                                      "id": "5ace203e9fe7b01d5806c108",
                                                      "_id": "6077c4efbc5f4d4df9ef2956",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda6",
                                                              "_id": "6077c4efbc5f4d4df9ef2957"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "properties of conductor, earthing of conductor",
                                                      "id": "5ace203e9fe7b01d5806c109",
                                                      "_id": "6077c4efbc5f4d4df9ef2954",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda7",
                                                              "_id": "6077c4efbc5f4d4df9ef2955"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem in a capacitor circuit",
                                                      "id": "5ace203e9fe7b01d5806c10a",
                                                      "_id": "6077c4efbc5f4d4df9ef2952",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda8",
                                                              "_id": "6077c4efbc5f4d4df9ef2953"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5c",
                                                      "_id": "6077c4efbc5f4d4df9ef2970"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef29e5"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Series Completion",
                                              "id": "5ace20319fe7b01d5806bc3b",
                                              "_id": "6077c4efbc5f4d4df9ef294a",
                                              "concepts": [
                                                  {
                                                      "name": "Number Series",
                                                      "id": "5ace20399fe7b01d5806bf37",
                                                      "_id": "6077c4efbc5f4d4df9ef294d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8420",
                                                              "_id": "6077c4efbc5f4d4df9ef294e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alphabet Series",
                                                      "id": "5ace20399fe7b01d5806bf36",
                                                      "_id": "6077c4efbc5f4d4df9ef294b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8421",
                                                              "_id": "6077c4efbc5f4d4df9ef294c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8243",
                                                      "_id": "6077c4efbc5f4d4df9ef294f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inserting Missing Character",
                                              "id": "5ace20319fe7b01d5806bc2f",
                                              "_id": "6077c4efbc5f4d4df9ef2946",
                                              "concepts": [
                                                  {
                                                      "name": "Inserting missing character",
                                                      "id": "5ace20389fe7b01d5806bf1f",
                                                      "_id": "6077c4efbc5f4d4df9ef2947",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8422",
                                                              "_id": "6077c4efbc5f4d4df9ef2948"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8244",
                                                      "_id": "6077c4efbc5f4d4df9ef2949"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Blood Relations",
                                              "id": "5ace20309fe7b01d5806bc21",
                                              "_id": "6077c4efbc5f4d4df9ef2942",
                                              "concepts": [
                                                  {
                                                      "name": "Blood Relations",
                                                      "id": "5ace20389fe7b01d5806bf0f",
                                                      "_id": "6077c4efbc5f4d4df9ef2943",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8423",
                                                              "_id": "6077c4efbc5f4d4df9ef2944"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8245",
                                                      "_id": "6077c4efbc5f4d4df9ef2945"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef2950"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "India - Size and Location",
                                              "id": "5ace20329fe7b01d5806bcc8",
                                              "_id": "6077c4efbc5f4d4df9ef293d",
                                              "concepts": [
                                                  {
                                                      "name": "India - Size and Location",
                                                      "id": "5ace20419fe7b01d5806c1fc",
                                                      "_id": "6077c4efbc5f4d4df9ef293e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8455",
                                                              "_id": "6077c4efbc5f4d4df9ef293f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8268",
                                                      "_id": "6077c4efbc5f4d4df9ef2940"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Drainage",
                                              "id": "5ace20329fe7b01d5806bcc6",
                                              "_id": "6077c4efbc5f4d4df9ef2937",
                                              "concepts": [
                                                  {
                                                      "name": "Perennial & Seasonal Rivers.",
                                                      "id": "5ace20419fe7b01d5806c1f9",
                                                      "_id": "6077c4efbc5f4d4df9ef293a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8456",
                                                              "_id": "6077c4efbc5f4d4df9ef293b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different river systems.",
                                                      "id": "5ace20419fe7b01d5806c1f8",
                                                      "_id": "6077c4efbc5f4d4df9ef2938",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8457",
                                                              "_id": "6077c4efbc5f4d4df9ef2939"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8269",
                                                      "_id": "6077c4efbc5f4d4df9ef293c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Physical Features of India",
                                              "id": "5ace20329fe7b01d5806bccd",
                                              "_id": "6077c4efbc5f4d4df9ef2931",
                                              "concepts": [
                                                  {
                                                      "name": "Plate Tectonic movements & the formation of Himalaya",
                                                      "id": "5ace20419fe7b01d5806c203",
                                                      "_id": "6077c4efbc5f4d4df9ef2934",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8458",
                                                              "_id": "6077c4efbc5f4d4df9ef2935"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different landforms",
                                                      "id": "5ace20419fe7b01d5806c202",
                                                      "_id": "6077c4efbc5f4d4df9ef2932",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8459",
                                                              "_id": "6077c4efbc5f4d4df9ef2933"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826a",
                                                      "_id": "6077c4efbc5f4d4df9ef2936"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Climate",
                                              "id": "5ace20329fe7b01d5806bcc5",
                                              "_id": "6077c4efbc5f4d4df9ef292b",
                                              "concepts": [
                                                  {
                                                      "name": "Components of weather & climate",
                                                      "id": "5ace20419fe7b01d5806c1f6",
                                                      "_id": "6077c4efbc5f4d4df9ef292e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845a",
                                                              "_id": "6077c4efbc5f4d4df9ef292f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factors, affecting climate i.e., India",
                                                      "id": "5ace20419fe7b01d5806c1f7",
                                                      "_id": "6077c4efbc5f4d4df9ef292c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845b",
                                                              "_id": "6077c4efbc5f4d4df9ef292d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826b",
                                                      "_id": "6077c4efbc5f4d4df9ef2930"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Natural Vegetation and Wildlife",
                                              "id": "5ace20329fe7b01d5806bccc",
                                              "_id": "6077c4efbc5f4d4df9ef2927",
                                              "concepts": [
                                                  {
                                                      "name": "Natural Vegetation & Wildlife",
                                                      "id": "5ace20419fe7b01d5806c201",
                                                      "_id": "6077c4efbc5f4d4df9ef2928",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845c",
                                                              "_id": "6077c4efbc5f4d4df9ef2929"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826c",
                                                      "_id": "6077c4efbc5f4d4df9ef292a"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef2941"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Analogy",
                                              "id": "5ace20309fe7b01d5806bc13",
                                              "_id": "6077c4efbc5f4d4df9ef291e",
                                              "concepts": [
                                                  {
                                                      "name": "Letter Analogy",
                                                      "id": "5ace20389fe7b01d5806bef9",
                                                      "_id": "6077c4efbc5f4d4df9ef2923",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df3e",
                                                              "_id": "6077c4efbc5f4d4df9ef2924"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number Analogy",
                                                      "id": "5ace20389fe7b01d5806befa",
                                                      "_id": "6077c4efbc5f4d4df9ef2921",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df3f",
                                                              "_id": "6077c4efbc5f4d4df9ef2922"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word Analogy",
                                                      "id": "5ace20389fe7b01d5806befb",
                                                      "_id": "6077c4efbc5f4d4df9ef291f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df40",
                                                              "_id": "6077c4efbc5f4d4df9ef2920"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df34",
                                                      "_id": "6077c4efbc5f4d4df9ef2925"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef2926"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 2,
                              "startDate": "2021-05-03T00:00:00.000Z",
                              "endDate": "2021-05-09T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef27a1",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Tissues",
                                              "id": "5ace202f9fe7b01d5806bbc4",
                                              "_id": "6077c4efbc5f4d4df9ef290c",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction Classification of plant tissues",
                                                      "id": "5ace20339fe7b01d5806bd61",
                                                      "_id": "6077c4efbc5f4d4df9ef2919",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a8",
                                                              "_id": "6077c4efbc5f4d4df9ef291a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple & Complex permanent tissues",
                                                      "id": "5ace20339fe7b01d5806bd64",
                                                      "_id": "6077c4efbc5f4d4df9ef2917",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82a9",
                                                              "_id": "6077c4efbc5f4d4df9ef2918"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meristematic tissues & Protective tissue",
                                                      "id": "5ace20339fe7b01d5806bd62",
                                                      "_id": "6077c4efbc5f4d4df9ef2915",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82aa",
                                                              "_id": "6077c4efbc5f4d4df9ef2916"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification of animal tissues",
                                                      "id": "5ace20339fe7b01d5806bd5e",
                                                      "_id": "6077c4efbc5f4d4df9ef2913",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ab",
                                                              "_id": "6077c4efbc5f4d4df9ef2914"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Epithelial tissues",
                                                      "id": "5ace20339fe7b01d5806bd60",
                                                      "_id": "6077c4efbc5f4d4df9ef2911",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ac",
                                                              "_id": "6077c4efbc5f4d4df9ef2912"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Connective tissues",
                                                      "id": "5ace20339fe7b01d5806bd5f",
                                                      "_id": "6077c4efbc5f4d4df9ef290f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ad",
                                                              "_id": "6077c4efbc5f4d4df9ef2910"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Muscular & Nervous tissues",
                                                      "id": "5ace20339fe7b01d5806bd63",
                                                      "_id": "6077c4efbc5f4d4df9ef290d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ae",
                                                              "_id": "6077c4efbc5f4d4df9ef290e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8208",
                                                      "_id": "6077c4efbc5f4d4df9ef291b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef291c"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Is matter around as pure?",
                                              "id": "5ace202f9fe7b01d5806bbcb",
                                              "_id": "6077c4efbc5f4d4df9ef28fb",
                                              "concepts": [
                                                  {
                                                      "name": "Elements(metals,non-metals and metalloids)",
                                                      "id": "5ace20349fe7b01d5806bd9a",
                                                      "_id": "6077c4efbc5f4d4df9ef2908",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8320",
                                                              "_id": "6077c4efbc5f4d4df9ef2909"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Compounds",
                                                      "id": "5ace20349fe7b01d5806bd98",
                                                      "_id": "6077c4efbc5f4d4df9ef2906",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8321",
                                                              "_id": "6077c4efbc5f4d4df9ef2907"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Homogenous mixtures",
                                                      "id": "5ace20349fe7b01d5806bd9c",
                                                      "_id": "6077c4efbc5f4d4df9ef2904",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8322",
                                                              "_id": "6077c4efbc5f4d4df9ef2905"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heterogenous mixtures(Colloids and Suspensions)",
                                                      "id": "5ace20349fe7b01d5806bd9b",
                                                      "_id": "6077c4efbc5f4d4df9ef2902",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8323",
                                                              "_id": "6077c4efbc5f4d4df9ef2903"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concentration terms",
                                                      "id": "5ace20349fe7b01d5806bd99",
                                                      "_id": "6077c4efbc5f4d4df9ef2900",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8324",
                                                              "_id": "6077c4efbc5f4d4df9ef2901"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Separation of mixtures",
                                                      "id": "5ace20349fe7b01d5806bd9e",
                                                      "_id": "6077c4efbc5f4d4df9ef28fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8325",
                                                              "_id": "6077c4efbc5f4d4df9ef28ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Physical and Chemical changes",
                                                      "id": "5ace20349fe7b01d5806bd9d",
                                                      "_id": "6077c4efbc5f4d4df9ef28fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8326",
                                                              "_id": "6077c4efbc5f4d4df9ef28fd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8213",
                                                      "_id": "6077c4efbc5f4d4df9ef290a"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef290b"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Continuity & Differentiabilty",
                                              "id": "5ace20319fe7b01d5806bc4b",
                                              "_id": "6077c4efbc5f4d4df9ef28f8",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d941",
                                                      "_id": "6077c4efbc5f4d4df9ef28f9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Heron's Formula",
                                              "id": "5ace20319fe7b01d5806bc71",
                                              "_id": "6077c4efbc5f4d4df9ef28f4",
                                              "concepts": [
                                                  {
                                                      "name": "Heron's Formula and problems",
                                                      "id": "5ace203b9fe7b01d5806c009",
                                                      "_id": "6077c4efbc5f4d4df9ef28f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c837f",
                                                              "_id": "6077c4efbc5f4d4df9ef28f6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8224",
                                                      "_id": "6077c4efbc5f4d4df9ef28f7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Continuity & Differentiabilty",
                                              "id": "5ace20319fe7b01d5806bc4c",
                                              "_id": "6077c4efbc5f4d4df9ef28e0",
                                              "concepts": [
                                                  {
                                                      "name": "Continuity of composite function, finding unknown parameters from continuity",
                                                      "id": "5ace20399fe7b01d5806bf6b",
                                                      "_id": "6077c4efbc5f4d4df9ef28f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0c",
                                                              "_id": "6077c4efbc5f4d4df9ef28f2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability based on finding unknown parameters",
                                                      "id": "5ace20399fe7b01d5806bf6c",
                                                      "_id": "6077c4efbc5f4d4df9ef28ef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0d",
                                                              "_id": "6077c4efbc5f4d4df9ef28f0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability based on first principle, Using continuity & differentiability to determine number of real roots of a function",
                                                      "id": "5ace20399fe7b01d5806bf6d",
                                                      "_id": "6077c4efbc5f4d4df9ef28ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0e",
                                                              "_id": "6077c4efbc5f4d4df9ef28ee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intermediate Value Theorem",
                                                      "id": "5ace20399fe7b01d5806bf6e",
                                                      "_id": "6077c4efbc5f4d4df9ef28eb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da0f",
                                                              "_id": "6077c4efbc5f4d4df9ef28ec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Investigating functions using functional equation",
                                                      "id": "5ace20399fe7b01d5806bf6f",
                                                      "_id": "6077c4efbc5f4d4df9ef28e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da10",
                                                              "_id": "6077c4efbc5f4d4df9ef28ea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on continuity and differentiability using graph",
                                                      "id": "5ace20399fe7b01d5806bf70",
                                                      "_id": "6077c4efbc5f4d4df9ef28e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da11",
                                                              "_id": "6077c4efbc5f4d4df9ef28e8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "To check continuity of a function",
                                                      "id": "5ace20399fe7b01d5806bf71",
                                                      "_id": "6077c4efbc5f4d4df9ef28e5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da12",
                                                              "_id": "6077c4efbc5f4d4df9ef28e6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "To check differentiability of a function, LHD & RHD of a function, existence of derivative Problems based on piece wise defined function",
                                                      "id": "5ace20399fe7b01d5806bf72",
                                                      "_id": "6077c4efbc5f4d4df9ef28e3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da13",
                                                              "_id": "6077c4efbc5f4d4df9ef28e4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Type of discontinuity, to find points of discontinuity, no of points of discontinuity",
                                                      "id": "5ace20399fe7b01d5806bf73",
                                                      "_id": "6077c4efbc5f4d4df9ef28e1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da14",
                                                              "_id": "6077c4efbc5f4d4df9ef28e2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d942",
                                                      "_id": "6077c4efbc5f4d4df9ef28f3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Area and Volume - 1",
                                              "id": "5ace20319fe7b01d5806bc80",
                                              "_id": "6077c4efbc5f4d4df9ef28d2",
                                              "concepts": [
                                                  {
                                                      "name": "Lateral Surface Area and Total Surface Area of Cuboid and Cube, Volume of a Cuboid and Cube",
                                                      "id": "5ace203c9fe7b01d5806c03f",
                                                      "_id": "6077c4efbc5f4d4df9ef28dd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8380",
                                                              "_id": "6077c4efbc5f4d4df9ef28de"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Cuboid and Cube",
                                                      "id": "5ace203c9fe7b01d5806c040",
                                                      "_id": "6077c4efbc5f4d4df9ef28db",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8381",
                                                              "_id": "6077c4efbc5f4d4df9ef28dc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Curved Surface Area and Total Surface Area of Right Circular Cylinder,Cone,Sphere and Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c03e",
                                                      "_id": "6077c4efbc5f4d4df9ef28d9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8382",
                                                              "_id": "6077c4efbc5f4d4df9ef28da"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Curved Surface Area and Total Surface Area of Hollow Cylinder,Hollow Sphere and Hollow Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c03d",
                                                      "_id": "6077c4efbc5f4d4df9ef28d7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8383",
                                                              "_id": "6077c4efbc5f4d4df9ef28d8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Cylinder,Cone,Sphere and Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c041",
                                                      "_id": "6077c4efbc5f4d4df9ef28d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8384",
                                                              "_id": "6077c4efbc5f4d4df9ef28d6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Hollow cylinder,Hollow sphere and Hollow hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c042",
                                                      "_id": "6077c4efbc5f4d4df9ef28d3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8385",
                                                              "_id": "6077c4efbc5f4d4df9ef28d4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8225",
                                                      "_id": "6077c4efbc5f4d4df9ef28df"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Definite Integration",
                                              "id": "5ace20319fe7b01d5806bc4d",
                                              "_id": "6077c4efbc5f4d4df9ef28c0",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Solving definite integration using graphs, piece wise continuous functions",
                                                      "id": "5ace20399fe7b01d5806bf74",
                                                      "_id": "6077c4efbc5f4d4df9ef28cf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da15",
                                                              "_id": "6077c4efbc5f4d4df9ef28d0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Integral of inverse of a function",
                                                      "id": "5ace20399fe7b01d5806bf75",
                                                      "_id": "6077c4efbc5f4d4df9ef28cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da16",
                                                              "_id": "6077c4efbc5f4d4df9ef28ce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Integral of periodic function",
                                                      "id": "5ace20399fe7b01d5806bf76",
                                                      "_id": "6077c4efbc5f4d4df9ef28cb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da17",
                                                              "_id": "6077c4efbc5f4d4df9ef28cc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit as a sum",
                                                      "id": "5ace20399fe7b01d5806bf77",
                                                      "_id": "6077c4efbc5f4d4df9ef28c9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da18",
                                                              "_id": "6077c4efbc5f4d4df9ef28ca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton-Leibnitz rule",
                                                      "id": "5ace20399fe7b01d5806bf78",
                                                      "_id": "6077c4efbc5f4d4df9ef28c7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da19",
                                                              "_id": "6077c4efbc5f4d4df9ef28c8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on reduction formula",
                                                      "id": "5ace20399fe7b01d5806bf79",
                                                      "_id": "6077c4efbc5f4d4df9ef28c5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1a",
                                                              "_id": "6077c4efbc5f4d4df9ef28c6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on partial derivatives",
                                                      "id": "5ace203a9fe7b01d5806bf7a",
                                                      "_id": "6077c4efbc5f4d4df9ef28c3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1b",
                                                              "_id": "6077c4efbc5f4d4df9ef28c4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on properties",
                                                      "id": "5ace203a9fe7b01d5806bf7b",
                                                      "_id": "6077c4efbc5f4d4df9ef28c1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1c",
                                                              "_id": "6077c4efbc5f4d4df9ef28c2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d943",
                                                      "_id": "6077c4efbc5f4d4df9ef28d1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics-1",
                                              "id": "5ace20319fe7b01d5806bc7e",
                                              "_id": "6077c4efbc5f4d4df9ef28ac",
                                              "concepts": [
                                                  {
                                                      "name": "Statistical Data ( Primary, Secondary )",
                                                      "id": "5ace203c9fe7b01d5806c039",
                                                      "_id": "6077c4efbc5f4d4df9ef28bd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8386",
                                                              "_id": "6077c4efbc5f4d4df9ef28be"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Distributions ( Discrete and Continous )",
                                                      "id": "5ace203c9fe7b01d5806c035",
                                                      "_id": "6077c4efbc5f4d4df9ef28bb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8387",
                                                              "_id": "6077c4efbc5f4d4df9ef28bc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exclusive, Inclusive method",
                                                      "id": "5ace203c9fe7b01d5806c034",
                                                      "_id": "6077c4efbc5f4d4df9ef28b9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8388",
                                                              "_id": "6077c4efbc5f4d4df9ef28ba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of Discrete , Grouped Frequency Distributions",
                                                      "id": "5ace203c9fe7b01d5806c032",
                                                      "_id": "6077c4efbc5f4d4df9ef28b7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8389",
                                                              "_id": "6077c4efbc5f4d4df9ef28b8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cumulative Frequency Distributions",
                                                      "id": "5ace203c9fe7b01d5806c033",
                                                      "_id": "6077c4efbc5f4d4df9ef28b5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838a",
                                                              "_id": "6077c4efbc5f4d4df9ef28b6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Represantion of Statistical Data ( Bar graph, Histogram )",
                                                      "id": "5ace203c9fe7b01d5806c037",
                                                      "_id": "6077c4efbc5f4d4df9ef28b3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838b",
                                                              "_id": "6077c4efbc5f4d4df9ef28b4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of different kind of Histograms",
                                                      "id": "5ace203c9fe7b01d5806c031",
                                                      "_id": "6077c4efbc5f4d4df9ef28b1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838c",
                                                              "_id": "6077c4efbc5f4d4df9ef28b2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Polygon",
                                                      "id": "5ace203c9fe7b01d5806c036",
                                                      "_id": "6077c4efbc5f4d4df9ef28af",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838d",
                                                              "_id": "6077c4efbc5f4d4df9ef28b0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measure of Central Tendency",
                                                      "id": "5ace203c9fe7b01d5806c038",
                                                      "_id": "6077c4efbc5f4d4df9ef28ad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838e",
                                                              "_id": "6077c4efbc5f4d4df9ef28ae"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8226",
                                                      "_id": "6077c4efbc5f4d4df9ef28bf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Equation",
                                              "id": "5ace20319fe7b01d5806bc4e",
                                              "_id": "6077c4efbc5f4d4df9ef28aa",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d944",
                                                      "_id": "6077c4efbc5f4d4df9ef28ab"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Co-ordinate Geometry-1",
                                              "id": "5ace20319fe7b01d5806bc70",
                                              "_id": "6077c4efbc5f4d4df9ef28a0",
                                              "concepts": [
                                                  {
                                                      "name": "Distance between Two Points",
                                                      "id": "5ace203b9fe7b01d5806c006",
                                                      "_id": "6077c4efbc5f4d4df9ef28a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c838f",
                                                              "_id": "6077c4efbc5f4d4df9ef28a8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internal and External Division using Section Formula,",
                                                      "id": "5ace203b9fe7b01d5806c007",
                                                      "_id": "6077c4efbc5f4d4df9ef28a5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8390",
                                                              "_id": "6077c4efbc5f4d4df9ef28a6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid point theorem, centroid of triangle",
                                                      "id": "5ace203b9fe7b01d5806c008",
                                                      "_id": "6077c4efbc5f4d4df9ef28a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8391",
                                                              "_id": "6077c4efbc5f4d4df9ef28a4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of triangle, collinearity of points",
                                                      "id": "5ace203b9fe7b01d5806c005",
                                                      "_id": "6077c4efbc5f4d4df9ef28a1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8392",
                                                              "_id": "6077c4efbc5f4d4df9ef28a2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8227",
                                                      "_id": "6077c4efbc5f4d4df9ef28a9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Equation",
                                              "id": "5ace20319fe7b01d5806bc4f",
                                              "_id": "6077c4efbc5f4d4df9ef288c",
                                              "concepts": [
                                                  {
                                                      "name": "Apllications of differential equation- orthogonal trajectories, tangent and normal, sub-tangent and sub-normal",
                                                      "id": "5ace203a9fe7b01d5806bf7c",
                                                      "_id": "6077c4efbc5f4d4df9ef289d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1d",
                                                              "_id": "6077c4efbc5f4d4df9ef289e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application of differential equation-rate of change problem",
                                                      "id": "5ace203a9fe7b01d5806bf7d",
                                                      "_id": "6077c4efbc5f4d4df9ef289b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1e",
                                                              "_id": "6077c4efbc5f4d4df9ef289c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation of differential equation",
                                                      "id": "5ace203a9fe7b01d5806bf7e",
                                                      "_id": "6077c4efbc5f4d4df9ef2899",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da1f",
                                                              "_id": "6077c4efbc5f4d4df9ef289a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "geometrical apllication",
                                                      "id": "5ace203a9fe7b01d5806bf7f",
                                                      "_id": "6077c4efbc5f4d4df9ef2897",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da20",
                                                              "_id": "6077c4efbc5f4d4df9ef2898"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "order and degree of differential equation",
                                                      "id": "5ace203a9fe7b01d5806bf80",
                                                      "_id": "6077c4efbc5f4d4df9ef2895",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da21",
                                                              "_id": "6077c4efbc5f4d4df9ef2896"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reducible to variable seperable method, solution of differential equation of the homogeneous and reducible to the homogeneous form",
                                                      "id": "5ace203a9fe7b01d5806bf81",
                                                      "_id": "6077c4efbc5f4d4df9ef2893",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da22",
                                                              "_id": "6077c4efbc5f4d4df9ef2894"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of differential equation by variable seperable method",
                                                      "id": "5ace203a9fe7b01d5806bf82",
                                                      "_id": "6077c4efbc5f4d4df9ef2891",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da23",
                                                              "_id": "6077c4efbc5f4d4df9ef2892"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of general form of variable seperation",
                                                      "id": "5ace203a9fe7b01d5806bf83",
                                                      "_id": "6077c4efbc5f4d4df9ef288f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da24",
                                                              "_id": "6077c4efbc5f4d4df9ef2890"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Linear differential equation, solution of bernoulis eqn, Solution of differential equation reducible to Bernoulii form",
                                                      "id": "5ace203a9fe7b01d5806bf84",
                                                      "_id": "6077c4efbc5f4d4df9ef288d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da25",
                                                              "_id": "6077c4efbc5f4d4df9ef288e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d945",
                                                      "_id": "6077c4efbc5f4d4df9ef289f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability-1",
                                              "id": "5ace20319fe7b01d5806bc78",
                                              "_id": "6077c4efbc5f4d4df9ef2884",
                                              "concepts": [
                                                  {
                                                      "name": "Definition of Probability",
                                                      "id": "5ace203b9fe7b01d5806c01e",
                                                      "_id": "6077c4efbc5f4d4df9ef2889",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8393",
                                                              "_id": "6077c4efbc5f4d4df9ef288a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on coins",
                                                      "id": "5ace203b9fe7b01d5806c01f",
                                                      "_id": "6077c4efbc5f4d4df9ef2887",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8394",
                                                              "_id": "6077c4efbc5f4d4df9ef2888"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on dice",
                                                      "id": "5ace203b9fe7b01d5806c020",
                                                      "_id": "6077c4efbc5f4d4df9ef2885",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8395",
                                                              "_id": "6077c4efbc5f4d4df9ef2886"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8228",
                                                      "_id": "6077c4efbc5f4d4df9ef288b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentiation",
                                              "id": "5ace20319fe7b01d5806bc50",
                                              "_id": "6077c4efbc5f4d4df9ef2882",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d946",
                                                      "_id": "6077c4efbc5f4d4df9ef2883"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Co-ordinate Geometry - 2",
                                              "id": "5ace20319fe7b01d5806bc6f",
                                              "_id": "6077c4efbc5f4d4df9ef287a",
                                              "concepts": [
                                                  {
                                                      "name": "Cartesian system, Distance between two points, Internal and External division",
                                                      "id": "5ace203b9fe7b01d5806c002",
                                                      "_id": "6077c4efbc5f4d4df9ef287f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8396",
                                                              "_id": "6077c4efbc5f4d4df9ef2880"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Centroid ,Area of a Triangle, Straight line (Locus, Slope)",
                                                      "id": "5ace203b9fe7b01d5806c003",
                                                      "_id": "6077c4efbc5f4d4df9ef287d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8397",
                                                              "_id": "6077c4efbc5f4d4df9ef287e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Forms of Straight Line- Point slope, Slope intercept, Two point, Normal form, Length of perpendicular, Angle between Two Lines",
                                                      "id": "5ace203b9fe7b01d5806c004",
                                                      "_id": "6077c4efbc5f4d4df9ef287b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8398",
                                                              "_id": "6077c4efbc5f4d4df9ef287c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8229",
                                                      "_id": "6077c4efbc5f4d4df9ef2881"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentiation",
                                              "id": "5ace20319fe7b01d5806bc51",
                                              "_id": "6077c4efbc5f4d4df9ef286e",
                                              "concepts": [
                                                  {
                                                      "name": "chain rule",
                                                      "id": "5ace203a9fe7b01d5806bf85",
                                                      "_id": "6077c4efbc5f4d4df9ef2877",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da26",
                                                              "_id": "6077c4efbc5f4d4df9ef2878"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Derivative of implicit function, derivative of parametric function, derivative of one function w.r.t another function, derivative of function to power function form, derivative of infinite series type problems",
                                                      "id": "5ace203a9fe7b01d5806bf86",
                                                      "_id": "6077c4efbc5f4d4df9ef2875",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da27",
                                                              "_id": "6077c4efbc5f4d4df9ef2876"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation of various functions and the rules of differentiation",
                                                      "id": "5ace203a9fe7b01d5806bf87",
                                                      "_id": "6077c4efbc5f4d4df9ef2873",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da28",
                                                              "_id": "6077c4efbc5f4d4df9ef2874"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "first principle",
                                                      "id": "5ace203a9fe7b01d5806bf88",
                                                      "_id": "6077c4efbc5f4d4df9ef2871",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da29",
                                                              "_id": "6077c4efbc5f4d4df9ef2872"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "higher order derivative",
                                                      "id": "5ace203a9fe7b01d5806bf89",
                                                      "_id": "6077c4efbc5f4d4df9ef286f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2a",
                                                              "_id": "6077c4efbc5f4d4df9ef2870"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d947",
                                                      "_id": "6077c4efbc5f4d4df9ef2879"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability-2",
                                              "id": "5ace20319fe7b01d5806bc79",
                                              "_id": "6077c4efbc5f4d4df9ef2866",
                                              "concepts": [
                                                  {
                                                      "name": "Experimental or emperical approch to probability, Definitions of trial, Event, Compound event, Occurrence of an event, Emperical Probability Definition and problems related to it",
                                                      "id": "5ace203b9fe7b01d5806c021",
                                                      "_id": "6077c4efbc5f4d4df9ef286b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8399",
                                                              "_id": "6077c4efbc5f4d4df9ef286c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Principles of Addition and Multiplication",
                                                      "id": "5ace203b9fe7b01d5806c022",
                                                      "_id": "6077c4efbc5f4d4df9ef2869",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839a",
                                                              "_id": "6077c4efbc5f4d4df9ef286a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sure event, Impossible event, Complement of an event",
                                                      "id": "5ace203b9fe7b01d5806c023",
                                                      "_id": "6077c4efbc5f4d4df9ef2867",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839b",
                                                              "_id": "6077c4efbc5f4d4df9ef2868"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822a",
                                                      "_id": "6077c4efbc5f4d4df9ef286d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Indefinite Integration",
                                              "id": "5ace20319fe7b01d5806bc52",
                                              "_id": "6077c4efbc5f4d4df9ef2864",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d948",
                                                      "_id": "6077c4efbc5f4d4df9ef2865"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equation In Two Variables-2",
                                              "id": "5ace20319fe7b01d5806bc73",
                                              "_id": "6077c4efbc5f4d4df9ef285e",
                                              "concepts": [
                                                  {
                                                      "name": "Linear equation in two variables, Graphs of linear equation, Simultaneous equation in two variables",
                                                      "id": "5ace203b9fe7b01d5806c00c",
                                                      "_id": "6077c4efbc5f4d4df9ef2861",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839c",
                                                              "_id": "6077c4efbc5f4d4df9ef2862"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "graphical solution of simultaneous equations in two variables, method of elimination by substitution, method of elimination by equationg coefficients\nsolution of equations of form, method of elimination by comparison, method of cross multiplication",
                                                      "id": "5ace203b9fe7b01d5806c00b",
                                                      "_id": "6077c4efbc5f4d4df9ef285f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839d",
                                                              "_id": "6077c4efbc5f4d4df9ef2860"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822b",
                                                      "_id": "6077c4efbc5f4d4df9ef2863"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Indefinite Integration",
                                              "id": "5ace20319fe7b01d5806bc53",
                                              "_id": "6077c4efbc5f4d4df9ef284c",
                                              "concepts": [
                                                  {
                                                      "name": "conversion of unknown form to known form",
                                                      "id": "5ace203a9fe7b01d5806bf8a",
                                                      "_id": "6077c4efbc5f4d4df9ef285b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2b",
                                                              "_id": "6077c4efbc5f4d4df9ef285c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on partial fraction",
                                                      "id": "5ace203a9fe7b01d5806bf8b",
                                                      "_id": "6077c4efbc5f4d4df9ef2859",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2c",
                                                              "_id": "6077c4efbc5f4d4df9ef285a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Algebraic twin form, algebraic substitution, integration using complex number",
                                                      "id": "5ace203a9fe7b01d5806bf8c",
                                                      "_id": "6077c4efbc5f4d4df9ef2857",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2d",
                                                              "_id": "6077c4efbc5f4d4df9ef2858"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on by parts, e to the power x (f(x) + f`(x)) dx type",
                                                      "id": "5ace203a9fe7b01d5806bf8d",
                                                      "_id": "6077c4efbc5f4d4df9ef2855",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2e",
                                                              "_id": "6077c4efbc5f4d4df9ef2856"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on integration of irrational function",
                                                      "id": "5ace203a9fe7b01d5806bf8e",
                                                      "_id": "6077c4efbc5f4d4df9ef2853",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da2f",
                                                              "_id": "6077c4efbc5f4d4df9ef2854"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on integration of rational function",
                                                      "id": "5ace203a9fe7b01d5806bf8f",
                                                      "_id": "6077c4efbc5f4d4df9ef2851",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da30",
                                                              "_id": "6077c4efbc5f4d4df9ef2852"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on method of substitution",
                                                      "id": "5ace203a9fe7b01d5806bf90",
                                                      "_id": "6077c4efbc5f4d4df9ef284f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da31",
                                                              "_id": "6077c4efbc5f4d4df9ef2850"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic divided by quadratic, linear divided by quadratic and trigonometric substitution",
                                                      "id": "5ace203a9fe7b01d5806bf91",
                                                      "_id": "6077c4efbc5f4d4df9ef284d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da32",
                                                              "_id": "6077c4efbc5f4d4df9ef284e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d949",
                                                      "_id": "6077c4efbc5f4d4df9ef285d"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef28fa"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Moving Charges and Magnetism",
                                              "id": "5ace20329fe7b01d5806bc9e",
                                              "_id": "6077c4efbc5f4d4df9ef282d",
                                              "concepts": [
                                                  {
                                                      "name": "Ampere's circuital law and applications",
                                                      "id": "5ace203e9fe7b01d5806c11a",
                                                      "_id": "6077c4efbc5f4d4df9ef2848",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e24c",
                                                              "_id": "6077c4efbc5f4d4df9ef2849"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot-Savart law & application",
                                                      "id": "5ace203e9fe7b01d5806c11b",
                                                      "_id": "6077c4efbc5f4d4df9ef2846",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e24d",
                                                              "_id": "6077c4efbc5f4d4df9ef2847"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Galvanometers",
                                                      "id": "5ace203e9fe7b01d5806c11d",
                                                      "_id": "6077c4efbc5f4d4df9ef2844",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e24e",
                                                              "_id": "6077c4efbc5f4d4df9ef2845"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic force on charge particle",
                                                      "id": "5ace203e9fe7b01d5806c11f",
                                                      "_id": "6077c4efbc5f4d4df9ef2842",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e24f",
                                                              "_id": "6077c4efbc5f4d4df9ef2843"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "magnetic force on current carrying wire",
                                                      "id": "5ace203e9fe7b01d5806c120",
                                                      "_id": "6077c4efbc5f4d4df9ef2840",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e250",
                                                              "_id": "6077c4efbc5f4d4df9ef2841"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion of charged particles in combined field",
                                                      "id": "5ace203e9fe7b01d5806c122",
                                                      "_id": "6077c4efbc5f4d4df9ef283e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e251",
                                                              "_id": "6077c4efbc5f4d4df9ef283f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "potential energy of current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c123",
                                                      "_id": "6077c4efbc5f4d4df9ef283c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e252",
                                                              "_id": "6077c4efbc5f4d4df9ef283d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "torque on a current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c124",
                                                      "_id": "6077c4efbc5f4d4df9ef283a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e253",
                                                              "_id": "6077c4efbc5f4d4df9ef283b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Force ",
                                                      "id": "5eeb62320a45db222dd12d1d",
                                                      "_id": "6077c4efbc5f4d4df9ef2838",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e254",
                                                              "_id": "6077c4efbc5f4d4df9ef2839"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moving coil galvanometer",
                                                      "id": "5eeb62320a45db222dd12d22",
                                                      "_id": "6077c4efbc5f4d4df9ef2836",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e255",
                                                              "_id": "6077c4efbc5f4d4df9ef2837"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ampere's Circuital Law and Force between two parallel currents",
                                                      "id": "5eeb62320a45db222dd12d20",
                                                      "_id": "6077c4efbc5f4d4df9ef2834",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e256",
                                                              "_id": "6077c4efbc5f4d4df9ef2835"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque on Current Loop and Magnetic Dipole",
                                                      "id": "5eeb62320a45db222dd12d21",
                                                      "_id": "6077c4efbc5f4d4df9ef2832",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e257",
                                                              "_id": "6077c4efbc5f4d4df9ef2833"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion in a magnetic field and in combined electrical and magnetic fields",
                                                      "id": "5eeb62320a45db222dd12d1e",
                                                      "_id": "6077c4efbc5f4d4df9ef2830",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e258",
                                                              "_id": "6077c4efbc5f4d4df9ef2831"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot-Savart Law",
                                                      "id": "5eeb62320a45db222dd12d1f",
                                                      "_id": "6077c4efbc5f4d4df9ef282e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f5f402c863d076508897df5",
                                                              "syllabusId": "5f7c38eba44fda53d316e259",
                                                              "_id": "6077c4efbc5f4d4df9ef282f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f7c3321f29da5758fc5ff96",
                                                      "_id": "6077c4efbc5f4d4df9ef284a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Gravitation",
                                              "id": "5ace20329fe7b01d5806bcad",
                                              "_id": "6077c4efbc5f4d4df9ef2821",
                                              "concepts": [
                                                  {
                                                      "name": "Universal Law of Gravitation",
                                                      "id": "5ace20409fe7b01d5806c19a",
                                                      "_id": "6077c4efbc5f4d4df9ef282a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e6",
                                                              "_id": "6077c4efbc5f4d4df9ef282b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Planetary motion, Motion of Planets & Kepler’s laws",
                                                      "id": "5ace20409fe7b01d5806c199",
                                                      "_id": "6077c4efbc5f4d4df9ef2828",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e7",
                                                              "_id": "6077c4efbc5f4d4df9ef2829"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Orbital velocity, Time period of a Satellite",
                                                      "id": "5ace20409fe7b01d5806c198",
                                                      "_id": "6077c4efbc5f4d4df9ef2826",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e8",
                                                              "_id": "6077c4efbc5f4d4df9ef2827"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Escape Velocity",
                                                      "id": "5ace20409fe7b01d5806c197",
                                                      "_id": "6077c4efbc5f4d4df9ef2824",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83e9",
                                                              "_id": "6077c4efbc5f4d4df9ef2825"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Acceleration due to gravity (g) & Variation of g and Types of Variation",
                                                      "id": "5ace20409fe7b01d5806c196",
                                                      "_id": "6077c4efbc5f4d4df9ef2822",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ea",
                                                              "_id": "6077c4efbc5f4d4df9ef2823"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823a",
                                                      "_id": "6077c4efbc5f4d4df9ef282c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "EMI & AC",
                                              "id": "5ace20329fe7b01d5806bc9d",
                                              "_id": "6077c4efbc5f4d4df9ef2801",
                                              "concepts": [
                                                  {
                                                      "name": "Alternating current and its properties",
                                                      "id": "5ace203e9fe7b01d5806c10b",
                                                      "_id": "6077c4efbc5f4d4df9ef281e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dda9",
                                                              "_id": "6077c4efbc5f4d4df9ef281f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Faraday's law & Lenz's Law",
                                                      "id": "5ace203e9fe7b01d5806c10c",
                                                      "_id": "6077c4efbc5f4d4df9ef281c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddaa",
                                                              "_id": "6077c4efbc5f4d4df9ef281d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Induced electric field",
                                                      "id": "5ace203e9fe7b01d5806c10d",
                                                      "_id": "6077c4efbc5f4d4df9ef281a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddab",
                                                              "_id": "6077c4efbc5f4d4df9ef281b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inductance - self and mutual",
                                                      "id": "5ace203e9fe7b01d5806c10e",
                                                      "_id": "6077c4efbc5f4d4df9ef2818",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddac",
                                                              "_id": "6077c4efbc5f4d4df9ef2819"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "inductor based circuit",
                                                      "id": "5ace203e9fe7b01d5806c10f",
                                                      "_id": "6077c4efbc5f4d4df9ef2816",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddad",
                                                              "_id": "6077c4efbc5f4d4df9ef2817"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "LCR based circuits",
                                                      "id": "5ace203e9fe7b01d5806c110",
                                                      "_id": "6077c4efbc5f4d4df9ef2814",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddae",
                                                              "_id": "6077c4efbc5f4d4df9ef2815"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "LR based circuits",
                                                      "id": "5ace203e9fe7b01d5806c111",
                                                      "_id": "6077c4efbc5f4d4df9ef2812",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddaf",
                                                              "_id": "6077c4efbc5f4d4df9ef2813"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "magnetic flux",
                                                      "id": "5ace203e9fe7b01d5806c112",
                                                      "_id": "6077c4efbc5f4d4df9ef2810",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb0",
                                                              "_id": "6077c4efbc5f4d4df9ef2811"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motional emf",
                                                      "id": "5ace203e9fe7b01d5806c113",
                                                      "_id": "6077c4efbc5f4d4df9ef280e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb1",
                                                              "_id": "6077c4efbc5f4d4df9ef280f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parallel circuits and Wheatstone Bridge",
                                                      "id": "5ace203e9fe7b01d5806c114",
                                                      "_id": "6077c4efbc5f4d4df9ef280c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb2",
                                                              "_id": "6077c4efbc5f4d4df9ef280d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power & Resonance in AC",
                                                      "id": "5ace203e9fe7b01d5806c115",
                                                      "_id": "6077c4efbc5f4d4df9ef280a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb3",
                                                              "_id": "6077c4efbc5f4d4df9ef280b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Study of motion of conductors in a magnetic field when currents are induced",
                                                      "id": "5ace203e9fe7b01d5806c116",
                                                      "_id": "6077c4efbc5f4d4df9ef2808",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb4",
                                                              "_id": "6077c4efbc5f4d4df9ef2809"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time varying magnetic field",
                                                      "id": "5ace203e9fe7b01d5806c117",
                                                      "_id": "6077c4efbc5f4d4df9ef2806",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb5",
                                                              "_id": "6077c4efbc5f4d4df9ef2807"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque experienced by the particle kept in magnetic field",
                                                      "id": "5ace203e9fe7b01d5806c118",
                                                      "_id": "6077c4efbc5f4d4df9ef2804",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb6",
                                                              "_id": "6077c4efbc5f4d4df9ef2805"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformer and choke coil",
                                                      "id": "5ace203e9fe7b01d5806c119",
                                                      "_id": "6077c4efbc5f4d4df9ef2802",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb7",
                                                              "_id": "6077c4efbc5f4d4df9ef2803"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5d",
                                                      "_id": "6077c4efbc5f4d4df9ef2820"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Fluid",
                                              "id": "5ace20329fe7b01d5806bcac",
                                              "_id": "6077c4efbc5f4d4df9ef27f7",
                                              "concepts": [
                                                  {
                                                      "name": "Pressure, Atmospheric Pressure & Relative density",
                                                      "id": "5ace20409fe7b01d5806c193",
                                                      "_id": "6077c4efbc5f4d4df9ef27fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83eb",
                                                              "_id": "6077c4efbc5f4d4df9ef27ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Variation of pressure with depth & Pascal Law",
                                                      "id": "5ace20409fe7b01d5806c195",
                                                      "_id": "6077c4efbc5f4d4df9ef27fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ec",
                                                              "_id": "6077c4efbc5f4d4df9ef27fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Upthrust/buyont force & Laws of floatation",
                                                      "id": "5ace20409fe7b01d5806c194",
                                                      "_id": "6077c4efbc5f4d4df9ef27fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ed",
                                                              "_id": "6077c4efbc5f4d4df9ef27fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Archimedes Principle",
                                                      "id": "5ace20409fe7b01d5806c192",
                                                      "_id": "6077c4efbc5f4d4df9ef27f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ee",
                                                              "_id": "6077c4efbc5f4d4df9ef27f9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823b",
                                                      "_id": "6077c4efbc5f4d4df9ef2800"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetics",
                                              "id": "5ace20329fe7b01d5806bc9e",
                                              "_id": "6077c4efbc5f4d4df9ef27df",
                                              "concepts": [
                                                  {
                                                      "name": "Ampere's circuital law and applications",
                                                      "id": "5ace203e9fe7b01d5806c11a",
                                                      "_id": "6077c4efbc5f4d4df9ef27f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb8",
                                                              "_id": "6077c4efbc5f4d4df9ef27f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot-Savart law & application",
                                                      "id": "5ace203e9fe7b01d5806c11b",
                                                      "_id": "6077c4efbc5f4d4df9ef27f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddb9",
                                                              "_id": "6077c4efbc5f4d4df9ef27f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Earth magnetism",
                                                      "id": "5ace203e9fe7b01d5806c11c",
                                                      "_id": "6077c4efbc5f4d4df9ef27f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddba",
                                                              "_id": "6077c4efbc5f4d4df9ef27f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Galvanometers",
                                                      "id": "5ace203e9fe7b01d5806c11d",
                                                      "_id": "6077c4efbc5f4d4df9ef27ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbb",
                                                              "_id": "6077c4efbc5f4d4df9ef27ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnet and its properties",
                                                      "id": "5ace203e9fe7b01d5806c11e",
                                                      "_id": "6077c4efbc5f4d4df9ef27ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbc",
                                                              "_id": "6077c4efbc5f4d4df9ef27ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic force on charge particle",
                                                      "id": "5ace203e9fe7b01d5806c11f",
                                                      "_id": "6077c4efbc5f4d4df9ef27ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbd",
                                                              "_id": "6077c4efbc5f4d4df9ef27eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "magnetic force on current carrying wire",
                                                      "id": "5ace203e9fe7b01d5806c120",
                                                      "_id": "6077c4efbc5f4d4df9ef27e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbe",
                                                              "_id": "6077c4efbc5f4d4df9ef27e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic properties of material",
                                                      "id": "5ace203e9fe7b01d5806c121",
                                                      "_id": "6077c4efbc5f4d4df9ef27e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddbf",
                                                              "_id": "6077c4efbc5f4d4df9ef27e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion of charged particles in combined field",
                                                      "id": "5ace203e9fe7b01d5806c122",
                                                      "_id": "6077c4efbc5f4d4df9ef27e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc0",
                                                              "_id": "6077c4efbc5f4d4df9ef27e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "potential energy of current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c123",
                                                      "_id": "6077c4efbc5f4d4df9ef27e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc1",
                                                              "_id": "6077c4efbc5f4d4df9ef27e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "torque on a current carrying loop",
                                                      "id": "5ace203e9fe7b01d5806c124",
                                                      "_id": "6077c4efbc5f4d4df9ef27e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc2",
                                                              "_id": "6077c4efbc5f4d4df9ef27e1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5e",
                                                      "_id": "6077c4efbc5f4d4df9ef27f6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work, Energy & Power",
                                              "id": "5ace20329fe7b01d5806bcb5",
                                              "_id": "6077c4efbc5f4d4df9ef27d1",
                                              "concepts": [
                                                  {
                                                      "name": "Work done",
                                                      "id": "5ace20419fe7b01d5806c1d0",
                                                      "_id": "6077c4efbc5f4d4df9ef27dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ef",
                                                              "_id": "6077c4efbc5f4d4df9ef27dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy & Different forms of energy",
                                                      "id": "5ace20419fe7b01d5806c1cd",
                                                      "_id": "6077c4efbc5f4d4df9ef27da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f0",
                                                              "_id": "6077c4efbc5f4d4df9ef27db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential energy & Kinetic energy",
                                                      "id": "5ace20419fe7b01d5806c1cf",
                                                      "_id": "6077c4efbc5f4d4df9ef27d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f1",
                                                              "_id": "6077c4efbc5f4d4df9ef27d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kinetic energy and Momentum",
                                                      "id": "5ace20419fe7b01d5806c1ce",
                                                      "_id": "6077c4efbc5f4d4df9ef27d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f2",
                                                              "_id": "6077c4efbc5f4d4df9ef27d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work energy theorem",
                                                      "id": "5ace20419fe7b01d5806c1d1",
                                                      "_id": "6077c4efbc5f4d4df9ef27d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f3",
                                                              "_id": "6077c4efbc5f4d4df9ef27d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conservation of energy",
                                                      "id": "5ace20419fe7b01d5806c1cc",
                                                      "_id": "6077c4efbc5f4d4df9ef27d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f4",
                                                              "_id": "6077c4efbc5f4d4df9ef27d3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823c",
                                                      "_id": "6077c4efbc5f4d4df9ef27de"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef284b"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Coding Decoding",
                                              "id": "5ace20309fe7b01d5806bc24",
                                              "_id": "6077c4efbc5f4d4df9ef27cc",
                                              "concepts": [
                                                  {
                                                      "name": "Coding Decoding",
                                                      "id": "5ace20389fe7b01d5806bf12",
                                                      "_id": "6077c4efbc5f4d4df9ef27cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8424",
                                                              "_id": "6077c4efbc5f4d4df9ef27ce"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8246",
                                                      "_id": "6077c4efbc5f4d4df9ef27cf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Alphabet Test",
                                              "id": "5ace20309fe7b01d5806bc1d",
                                              "_id": "6077c4efbc5f4d4df9ef27c8",
                                              "concepts": [
                                                  {
                                                      "name": "Alphabet Test",
                                                      "id": "5ace20389fe7b01d5806bf0b",
                                                      "_id": "6077c4efbc5f4d4df9ef27c9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8425",
                                                              "_id": "6077c4efbc5f4d4df9ef27ca"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8247",
                                                      "_id": "6077c4efbc5f4d4df9ef27cb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Direction Sense Test",
                                              "id": "5ace20309fe7b01d5806bc28",
                                              "_id": "6077c4efbc5f4d4df9ef27c4",
                                              "concepts": [
                                                  {
                                                      "name": "Direction Sense Test",
                                                      "id": "5ace20389fe7b01d5806bf18",
                                                      "_id": "6077c4efbc5f4d4df9ef27c5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8426",
                                                              "_id": "6077c4efbc5f4d4df9ef27c6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8248",
                                                      "_id": "6077c4efbc5f4d4df9ef27c7"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef27d0"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Population",
                                              "id": "5ace20329fe7b01d5806bcce",
                                              "_id": "6077c4efbc5f4d4df9ef27bd",
                                              "concepts": [
                                                  {
                                                      "name": "Factors of populatin growth.",
                                                      "id": "5ace20419fe7b01d5806c205",
                                                      "_id": "6077c4efbc5f4d4df9ef27c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845d",
                                                              "_id": "6077c4efbc5f4d4df9ef27c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different categories of population.",
                                                      "id": "5ace20419fe7b01d5806c204",
                                                      "_id": "6077c4efbc5f4d4df9ef27be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845e",
                                                              "_id": "6077c4efbc5f4d4df9ef27bf"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826d",
                                                      "_id": "6077c4efbc5f4d4df9ef27c2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Resources and Development",
                                              "id": "5ace20329fe7b01d5806bccf",
                                              "_id": "6077c4efbc5f4d4df9ef27b7",
                                              "concepts": [
                                                  {
                                                      "name": "Different types of resources.",
                                                      "id": "5ace20419fe7b01d5806c206",
                                                      "_id": "6077c4efbc5f4d4df9ef27ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c845f",
                                                              "_id": "6077c4efbc5f4d4df9ef27bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Steps of resource conservation.",
                                                      "id": "5ace20419fe7b01d5806c207",
                                                      "_id": "6077c4efbc5f4d4df9ef27b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8460",
                                                              "_id": "6077c4efbc5f4d4df9ef27b9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826e",
                                                      "_id": "6077c4efbc5f4d4df9ef27bc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Forest and Wildlife Resources",
                                              "id": "5ace20329fe7b01d5806bcc7",
                                              "_id": "6077c4efbc5f4d4df9ef27b1",
                                              "concepts": [
                                                  {
                                                      "name": "Contribution of forests.",
                                                      "id": "5ace20419fe7b01d5806c1fb",
                                                      "_id": "6077c4efbc5f4d4df9ef27b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8461",
                                                              "_id": "6077c4efbc5f4d4df9ef27b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Causes of deforestation & the steps of the forests conservation",
                                                      "id": "5ace20419fe7b01d5806c1fa",
                                                      "_id": "6077c4efbc5f4d4df9ef27b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8462",
                                                              "_id": "6077c4efbc5f4d4df9ef27b3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c826f",
                                                      "_id": "6077c4efbc5f4d4df9ef27b6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Water Resources",
                                              "id": "5ace20329fe7b01d5806bcd0",
                                              "_id": "6077c4efbc5f4d4df9ef27ad",
                                              "concepts": [
                                                  {
                                                      "name": "Water, scarecity & conservation",
                                                      "id": "5ace20419fe7b01d5806c208",
                                                      "_id": "6077c4efbc5f4d4df9ef27ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8463",
                                                              "_id": "6077c4efbc5f4d4df9ef27af"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8270",
                                                      "_id": "6077c4efbc5f4d4df9ef27b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Agriculture",
                                              "id": "5ace20329fe7b01d5806bcc4",
                                              "_id": "6077c4efbc5f4d4df9ef27a7",
                                              "concepts": [
                                                  {
                                                      "name": "Types of agriculture.",
                                                      "id": "5ace20419fe7b01d5806c1f5",
                                                      "_id": "6077c4efbc5f4d4df9ef27aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8464",
                                                              "_id": "6077c4efbc5f4d4df9ef27ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different types of crops.",
                                                      "id": "5ace20419fe7b01d5806c1f4",
                                                      "_id": "6077c4efbc5f4d4df9ef27a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8465",
                                                              "_id": "6077c4efbc5f4d4df9ef27a9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8271",
                                                      "_id": "6077c4efbc5f4d4df9ef27ac"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef27c3"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Chart Logic",
                                              "id": "5ace20309fe7b01d5806bc14",
                                              "_id": "6077c4efbc5f4d4df9ef27a2",
                                              "concepts": [
                                                  {
                                                      "name": "Inserting missing character",
                                                      "id": "5ace20389fe7b01d5806befc",
                                                      "_id": "6077c4efbc5f4d4df9ef27a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df41",
                                                              "_id": "6077c4efbc5f4d4df9ef27a4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df35",
                                                      "_id": "6077c4efbc5f4d4df9ef27a5"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef27a6"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 3,
                              "startDate": "2021-05-10T00:00:00.000Z",
                              "endDate": "2021-05-16T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef2603",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Diversity in living organism",
                                              "id": "5ace202f9fe7b01d5806bbbc",
                                              "_id": "6077c4efbc5f4d4df9ef2764",
                                              "concepts": [
                                                  {
                                                      "name": "Taxonomy",
                                                      "id": "5ace20339fe7b01d5806bd17",
                                                      "_id": "6077c4efbc5f4d4df9ef279d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82af",
                                                              "_id": "6077c4efbc5f4d4df9ef279e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial nomenclature",
                                                      "id": "5ace20339fe7b01d5806bd03",
                                                      "_id": "6077c4efbc5f4d4df9ef279b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b0",
                                                              "_id": "6077c4efbc5f4d4df9ef279c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of classification",
                                                      "id": "5ace20339fe7b01d5806bd19",
                                                      "_id": "6077c4efbc5f4d4df9ef2799",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b1",
                                                              "_id": "6077c4efbc5f4d4df9ef279a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kingdom Monera",
                                                      "id": "5ace20339fe7b01d5806bd0c",
                                                      "_id": "6077c4efbc5f4d4df9ef2797",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b2",
                                                              "_id": "6077c4efbc5f4d4df9ef2798"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kingdom Protista",
                                                      "id": "5ace20339fe7b01d5806bd0e",
                                                      "_id": "6077c4efbc5f4d4df9ef2795",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b3",
                                                              "_id": "6077c4efbc5f4d4df9ef2796"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kingdom Fungi",
                                                      "id": "5ace20339fe7b01d5806bd0b",
                                                      "_id": "6077c4efbc5f4d4df9ef2793",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b4",
                                                              "_id": "6077c4efbc5f4d4df9ef2794"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kingdom Plantae",
                                                      "id": "5ace20339fe7b01d5806bd0d",
                                                      "_id": "6077c4efbc5f4d4df9ef2791",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b5",
                                                              "_id": "6077c4efbc5f4d4df9ef2792"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thallophyta",
                                                      "id": "5ace20339fe7b01d5806bd18",
                                                      "_id": "6077c4efbc5f4d4df9ef278f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b6",
                                                              "_id": "6077c4efbc5f4d4df9ef2790"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bryophyta",
                                                      "id": "5ace20339fe7b01d5806bd04",
                                                      "_id": "6077c4efbc5f4d4df9ef278d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b7",
                                                              "_id": "6077c4efbc5f4d4df9ef278e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pteridophyta",
                                                      "id": "5ace20339fe7b01d5806bd15",
                                                      "_id": "6077c4efbc5f4d4df9ef278b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b8",
                                                              "_id": "6077c4efbc5f4d4df9ef278c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gymnosperm",
                                                      "id": "5ace20339fe7b01d5806bd08",
                                                      "_id": "6077c4efbc5f4d4df9ef2789",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82b9",
                                                              "_id": "6077c4efbc5f4d4df9ef278a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angiosperm",
                                                      "id": "5ace20329fe7b01d5806bcfe",
                                                      "_id": "6077c4efbc5f4d4df9ef2787",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ba",
                                                              "_id": "6077c4efbc5f4d4df9ef2788"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kingdom Animalia",
                                                      "id": "5ace20339fe7b01d5806bd0a",
                                                      "_id": "6077c4efbc5f4d4df9ef2785",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82bb",
                                                              "_id": "6077c4efbc5f4d4df9ef2786"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Porifera",
                                                      "id": "5ace20339fe7b01d5806bd13",
                                                      "_id": "6077c4efbc5f4d4df9ef2783",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82bc",
                                                              "_id": "6077c4efbc5f4d4df9ef2784"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coelenterata or Cnidaria",
                                                      "id": "5ace20339fe7b01d5806bd06",
                                                      "_id": "6077c4efbc5f4d4df9ef2781",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82bd",
                                                              "_id": "6077c4efbc5f4d4df9ef2782"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Platyhelminthes",
                                                      "id": "5ace20339fe7b01d5806bd12",
                                                      "_id": "6077c4efbc5f4d4df9ef277f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82be",
                                                              "_id": "6077c4efbc5f4d4df9ef2780"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Aschelminthes",
                                                      "id": "5ace20339fe7b01d5806bd01",
                                                      "_id": "6077c4efbc5f4d4df9ef277d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82bf",
                                                              "_id": "6077c4efbc5f4d4df9ef277e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Annelida",
                                                      "id": "5ace20329fe7b01d5806bcff",
                                                      "_id": "6077c4efbc5f4d4df9ef277b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c0",
                                                              "_id": "6077c4efbc5f4d4df9ef277c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arthropoda",
                                                      "id": "5ace20329fe7b01d5806bd00",
                                                      "_id": "6077c4efbc5f4d4df9ef2779",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c1",
                                                              "_id": "6077c4efbc5f4d4df9ef277a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mollusca",
                                                      "id": "5ace20339fe7b01d5806bd10",
                                                      "_id": "6077c4efbc5f4d4df9ef2777",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c2",
                                                              "_id": "6077c4efbc5f4d4df9ef2778"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Echinodermata",
                                                      "id": "5ace20339fe7b01d5806bd07",
                                                      "_id": "6077c4efbc5f4d4df9ef2775",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c3",
                                                              "_id": "6077c4efbc5f4d4df9ef2776"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Hemichordata",
                                                      "id": "5ace20339fe7b01d5806bd09",
                                                      "_id": "6077c4efbc5f4d4df9ef2773",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c4",
                                                              "_id": "6077c4efbc5f4d4df9ef2774"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Protochordata",
                                                      "id": "5ace20339fe7b01d5806bd14",
                                                      "_id": "6077c4efbc5f4d4df9ef2771",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c5",
                                                              "_id": "6077c4efbc5f4d4df9ef2772"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chordata",
                                                      "id": "5ace20339fe7b01d5806bd05",
                                                      "_id": "6077c4efbc5f4d4df9ef276f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c6",
                                                              "_id": "6077c4efbc5f4d4df9ef2770"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pisces",
                                                      "id": "5ace20339fe7b01d5806bd11",
                                                      "_id": "6077c4efbc5f4d4df9ef276d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c7",
                                                              "_id": "6077c4efbc5f4d4df9ef276e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Amphibians",
                                                      "id": "5ace20329fe7b01d5806bcfd",
                                                      "_id": "6077c4efbc5f4d4df9ef276b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c8",
                                                              "_id": "6077c4efbc5f4d4df9ef276c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Aves",
                                                      "id": "5ace20339fe7b01d5806bd02",
                                                      "_id": "6077c4efbc5f4d4df9ef2769",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82c9",
                                                              "_id": "6077c4efbc5f4d4df9ef276a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reptilia",
                                                      "id": "5ace20339fe7b01d5806bd16",
                                                      "_id": "6077c4efbc5f4d4df9ef2767",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ca",
                                                              "_id": "6077c4efbc5f4d4df9ef2768"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mammalia",
                                                      "id": "5ace20339fe7b01d5806bd0f",
                                                      "_id": "6077c4efbc5f4d4df9ef2765",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82cb",
                                                              "_id": "6077c4efbc5f4d4df9ef2766"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8209",
                                                      "_id": "6077c4efbc5f4d4df9ef279f"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef27a0"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Atoms,Molecules & Mole Concept",
                                              "id": "5ace202f9fe7b01d5806bbc8",
                                              "_id": "6077c4efbc5f4d4df9ef274b",
                                              "concepts": [
                                                  {
                                                      "name": "Laws of Chemical Combination",
                                                      "id": "5ace20349fe7b01d5806bd83",
                                                      "_id": "6077c4efbc5f4d4df9ef2760",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8327",
                                                              "_id": "6077c4efbc5f4d4df9ef2761"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Important Terminology",
                                                      "id": "5ace20349fe7b01d5806bd81",
                                                      "_id": "6077c4efbc5f4d4df9ef275e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8328",
                                                              "_id": "6077c4efbc5f4d4df9ef275f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chemical Formula and Valency",
                                                      "id": "5ace20349fe7b01d5806bd7f",
                                                      "_id": "6077c4efbc5f4d4df9ef275c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8329",
                                                              "_id": "6077c4efbc5f4d4df9ef275d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mole Concept",
                                                      "id": "5ace20349fe7b01d5806bd86",
                                                      "_id": "6077c4efbc5f4d4df9ef275a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832a",
                                                              "_id": "6077c4efbc5f4d4df9ef275b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Percentage Composition",
                                                      "id": "5ace20349fe7b01d5806bd88",
                                                      "_id": "6077c4efbc5f4d4df9ef2758",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832b",
                                                              "_id": "6077c4efbc5f4d4df9ef2759"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Empirical and Molecular Formula",
                                                      "id": "5ace20349fe7b01d5806bd80",
                                                      "_id": "6077c4efbc5f4d4df9ef2756",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832c",
                                                              "_id": "6077c4efbc5f4d4df9ef2757"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Molarity",
                                                      "id": "5ace20349fe7b01d5806bd85",
                                                      "_id": "6077c4efbc5f4d4df9ef2754",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832d",
                                                              "_id": "6077c4efbc5f4d4df9ef2755"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Molality",
                                                      "id": "5ace20349fe7b01d5806bd84",
                                                      "_id": "6077c4efbc5f4d4df9ef2752",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832e",
                                                              "_id": "6077c4efbc5f4d4df9ef2753"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mole Fraction",
                                                      "id": "5ace20349fe7b01d5806bd87",
                                                      "_id": "6077c4efbc5f4d4df9ef2750",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c832f",
                                                              "_id": "6077c4efbc5f4d4df9ef2751"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Avogadro Hypothesis",
                                                      "id": "5ace20349fe7b01d5806bd7e",
                                                      "_id": "6077c4efbc5f4d4df9ef274e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8330",
                                                              "_id": "6077c4efbc5f4d4df9ef274f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Isotopes,Isotones and Isobars",
                                                      "id": "5ace20349fe7b01d5806bd82",
                                                      "_id": "6077c4efbc5f4d4df9ef274c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8331",
                                                              "_id": "6077c4efbc5f4d4df9ef274d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8214",
                                                      "_id": "6077c4efbc5f4d4df9ef2762"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef2763"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Quadratic Equations",
                                              "id": "5ace20319fe7b01d5806bc7a",
                                              "_id": "6077c4efbc5f4d4df9ef2740",
                                              "concepts": [
                                                  {
                                                      "name": "Quadratic polynomials, Solution of Quadratic equations by method of factorisation, solution of quadratic equations by method of completion of squares",
                                                      "id": "5ace203c9fe7b01d5806c026",
                                                      "_id": "6077c4efbc5f4d4df9ef2747",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839e",
                                                              "_id": "6077c4efbc5f4d4df9ef2748"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between roots and coeffficients of Quadratic",
                                                      "id": "5ace203c9fe7b01d5806c027",
                                                      "_id": "6077c4efbc5f4d4df9ef2745",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c839f",
                                                              "_id": "6077c4efbc5f4d4df9ef2746"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Discriminant based questions",
                                                      "id": "5ace203c9fe7b01d5806c024",
                                                      "_id": "6077c4efbc5f4d4df9ef2743",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a0",
                                                              "_id": "6077c4efbc5f4d4df9ef2744"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nature of roots",
                                                      "id": "5ace203c9fe7b01d5806c025",
                                                      "_id": "6077c4efbc5f4d4df9ef2741",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a1",
                                                              "_id": "6077c4efbc5f4d4df9ef2742"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822c",
                                                      "_id": "6077c4efbc5f4d4df9ef2749"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Limit of the function",
                                              "id": "5ace20319fe7b01d5806bc54",
                                              "_id": "6077c4efbc5f4d4df9ef273e",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94a",
                                                      "_id": "6077c4efbc5f4d4df9ef273f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Arithmetic Progressions",
                                              "id": "5ace20319fe7b01d5806bc6b",
                                              "_id": "6077c4efbc5f4d4df9ef2736",
                                              "concepts": [
                                                  {
                                                      "name": "Definition, nth term from start, nth term from end",
                                                      "id": "5ace203b9fe7b01d5806bffa",
                                                      "_id": "6077c4efbc5f4d4df9ef273b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a2",
                                                              "_id": "6077c4efbc5f4d4df9ef273c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Selection of terms in an AP, sum of first n terms of an AP",
                                                      "id": "5ace203b9fe7b01d5806bffb",
                                                      "_id": "6077c4efbc5f4d4df9ef2739",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a3",
                                                              "_id": "6077c4efbc5f4d4df9ef273a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word problems",
                                                      "id": "5ace203b9fe7b01d5806bffc",
                                                      "_id": "6077c4efbc5f4d4df9ef2737",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a4",
                                                              "_id": "6077c4efbc5f4d4df9ef2738"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822d",
                                                      "_id": "6077c4efbc5f4d4df9ef273d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Limit of the function",
                                              "id": "5ace20319fe7b01d5806bc55",
                                              "_id": "6077c4efbc5f4d4df9ef2718",
                                              "concepts": [
                                                  {
                                                      "name": "Application of series to find the limits of a function",
                                                      "id": "5ace203a9fe7b01d5806bf92",
                                                      "_id": "6077c4efbc5f4d4df9ef2733",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da33",
                                                              "_id": "6077c4efbc5f4d4df9ef2734"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Exponential functions",
                                                      "id": "5ace203a9fe7b01d5806bf93",
                                                      "_id": "6077c4efbc5f4d4df9ef2731",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da34",
                                                              "_id": "6077c4efbc5f4d4df9ef2732"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Logarithmic functions",
                                                      "id": "5ace203a9fe7b01d5806bf94",
                                                      "_id": "6077c4efbc5f4d4df9ef272f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da35",
                                                              "_id": "6077c4efbc5f4d4df9ef2730"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limits of Trigonometrical function",
                                                      "id": "5ace203a9fe7b01d5806bf95",
                                                      "_id": "6077c4efbc5f4d4df9ef272d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da36",
                                                              "_id": "6077c4efbc5f4d4df9ef272e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Max. value and MIn. value of a function using limit",
                                                      "id": "5ace203a9fe7b01d5806bf96",
                                                      "_id": "6077c4efbc5f4d4df9ef272b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da37",
                                                              "_id": "6077c4efbc5f4d4df9ef272c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of Direct substitution to find the limit",
                                                      "id": "5ace203a9fe7b01d5806bf97",
                                                      "_id": "6077c4efbc5f4d4df9ef2729",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da38",
                                                              "_id": "6077c4efbc5f4d4df9ef272a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Method of Rationalization to find the limit",
                                                      "id": "5ace203a9fe7b01d5806bf98",
                                                      "_id": "6077c4efbc5f4d4df9ef2727",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da39",
                                                              "_id": "6077c4efbc5f4d4df9ef2728"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on 1 to power infinity form, function power function form",
                                                      "id": "5ace203a9fe7b01d5806bf99",
                                                      "_id": "6077c4efbc5f4d4df9ef2725",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3a",
                                                              "_id": "6077c4efbc5f4d4df9ef2726"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on existance of limits, LHL and RHL",
                                                      "id": "5ace203a9fe7b01d5806bf9a",
                                                      "_id": "6077c4efbc5f4d4df9ef2723",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3b",
                                                              "_id": "6077c4efbc5f4d4df9ef2724"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on L hospital rule",
                                                      "id": "5ace203a9fe7b01d5806bf9b",
                                                      "_id": "6077c4efbc5f4d4df9ef2721",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3c",
                                                              "_id": "6077c4efbc5f4d4df9ef2722"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Limit of composite functions and sandwitz theorem",
                                                      "id": "5ace203a9fe7b01d5806bf9c",
                                                      "_id": "6077c4efbc5f4d4df9ef271f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3d",
                                                              "_id": "6077c4efbc5f4d4df9ef2720"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on limits of the form x approaches infinity",
                                                      "id": "5ace203a9fe7b01d5806bf9d",
                                                      "_id": "6077c4efbc5f4d4df9ef271d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3e",
                                                              "_id": "6077c4efbc5f4d4df9ef271e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on Newton Lebnitz rule",
                                                      "id": "5ace203a9fe7b01d5806bf9e",
                                                      "_id": "6077c4efbc5f4d4df9ef271b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da3f",
                                                              "_id": "6077c4efbc5f4d4df9ef271c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on standard results",
                                                      "id": "5ace203a9fe7b01d5806bf9f",
                                                      "_id": "6077c4efbc5f4d4df9ef2719",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da40",
                                                              "_id": "6077c4efbc5f4d4df9ef271a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94b",
                                                      "_id": "6077c4efbc5f4d4df9ef2735"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Similar Triangles",
                                              "id": "5ace20319fe7b01d5806bc7d",
                                              "_id": "6077c4efbc5f4d4df9ef2710",
                                              "concepts": [
                                                  {
                                                      "name": "Basic proportionality theorem and converse, AAA similarity criterion, Sss similarity criterion, SAS similarity criterion, Area of two similar triangles",
                                                      "id": "5ace203c9fe7b01d5806c02e",
                                                      "_id": "6077c4efbc5f4d4df9ef2715",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a5",
                                                              "_id": "6077c4efbc5f4d4df9ef2716"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pythagoras theorem, Vertical angle base for theorem",
                                                      "id": "5ace203c9fe7b01d5806c030",
                                                      "_id": "6077c4efbc5f4d4df9ef2713",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a6",
                                                              "_id": "6077c4efbc5f4d4df9ef2714"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of two similar triangles, Converse of Pythagoras theorem",
                                                      "id": "5ace203c9fe7b01d5806c02f",
                                                      "_id": "6077c4efbc5f4d4df9ef2711",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a7",
                                                              "_id": "6077c4efbc5f4d4df9ef2712"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822e",
                                                      "_id": "6077c4efbc5f4d4df9ef2717"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Basic Calculus",
                                              "id": "5bab788738234f74bfb65ff5",
                                              "_id": "6077c4efbc5f4d4df9ef2708",
                                              "concepts": [
                                                  {
                                                      "name": "Integration",
                                                      "id": "5bab79b238234f74bfb6600f",
                                                      "_id": "6077c4efbc5f4d4df9ef270d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da41",
                                                              "_id": "6077c4efbc5f4d4df9ef270e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation",
                                                      "id": "5bab79c138234f74bfb66010",
                                                      "_id": "6077c4efbc5f4d4df9ef270b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da42",
                                                              "_id": "6077c4efbc5f4d4df9ef270c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integration",
                                                      "id": "5bab79d038234f74bfb66012",
                                                      "_id": "6077c4efbc5f4d4df9ef2709",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da43",
                                                              "_id": "6077c4efbc5f4d4df9ef270a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94c",
                                                      "_id": "6077c4efbc5f4d4df9ef270f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Tangents to a Circle",
                                              "id": "5ace20319fe7b01d5806bc82",
                                              "_id": "6077c4efbc5f4d4df9ef2700",
                                              "concepts": [
                                                  {
                                                      "name": "Tangents to a circle from a point, Properties of tangents",
                                                      "id": "5ace203c9fe7b01d5806c04e",
                                                      "_id": "6077c4efbc5f4d4df9ef2705",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a8",
                                                              "_id": "6077c4efbc5f4d4df9ef2706"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of chords, Alternate segment, Two circles in a plane, Common tangent",
                                                      "id": "5ace203c9fe7b01d5806c04d",
                                                      "_id": "6077c4efbc5f4d4df9ef2703",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83a9",
                                                              "_id": "6077c4efbc5f4d4df9ef2704"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Central angle and arcs, Congruence of circles and arcs, Angles subtended by arcs and chords at points on the circle",
                                                      "id": "5ace203c9fe7b01d5806c04c",
                                                      "_id": "6077c4efbc5f4d4df9ef2701",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83aa",
                                                              "_id": "6077c4efbc5f4d4df9ef2702"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c822f",
                                                      "_id": "6077c4efbc5f4d4df9ef2707"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Number",
                                              "id": "5ace20319fe7b01d5806bc56",
                                              "_id": "6077c4efbc5f4d4df9ef26fc",
                                              "concepts": [
                                                  {
                                                      "name": "Intersection of a straight line and circle on Argand plane",
                                                      "id": "5ace203a9fe7b01d5806bfa0",
                                                      "_id": "6077c4efbc5f4d4df9ef26fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da44",
                                                              "_id": "6077c4efbc5f4d4df9ef26fe"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94d",
                                                      "_id": "6077c4efbc5f4d4df9ef26ff"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions - 2",
                                              "id": "5ace20319fe7b01d5806bc6d",
                                              "_id": "6077c4efbc5f4d4df9ef26f8",
                                              "concepts": [
                                                  {
                                                      "name": "Circle construction, Circle line intersection constructions, Division of a line segment in a given ratio, Construction of tangents to a circle from a point when centre of circle is known, Construction of common tangents to two given circles, Construction of Circumcircle and incircle of a triangle",
                                                      "id": "5ace203b9fe7b01d5806c000",
                                                      "_id": "6077c4efbc5f4d4df9ef26f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ab",
                                                              "_id": "6077c4efbc5f4d4df9ef26fa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8230",
                                                      "_id": "6077c4efbc5f4d4df9ef26fb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circle",
                                              "id": "5ace20319fe7b01d5806bc57",
                                              "_id": "6077c4efbc5f4d4df9ef26f6",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94e",
                                                      "_id": "6077c4efbc5f4d4df9ef26f7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Area and Volume - 2",
                                              "id": "5ace20319fe7b01d5806bc81",
                                              "_id": "6077c4efbc5f4d4df9ef26e2",
                                              "concepts": [
                                                  {
                                                      "name": "Cuboid",
                                                      "id": "5ace203c9fe7b01d5806c046",
                                                      "_id": "6077c4efbc5f4d4df9ef26f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ac",
                                                              "_id": "6077c4efbc5f4d4df9ef26f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cube",
                                                      "id": "5ace203c9fe7b01d5806c045",
                                                      "_id": "6077c4efbc5f4d4df9ef26f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ad",
                                                              "_id": "6077c4efbc5f4d4df9ef26f2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Prism & Right Prism",
                                                      "id": "5ace203c9fe7b01d5806c04a",
                                                      "_id": "6077c4efbc5f4d4df9ef26ef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ae",
                                                              "_id": "6077c4efbc5f4d4df9ef26f0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Circular Cylinder",
                                                      "id": "5ace203c9fe7b01d5806c049",
                                                      "_id": "6077c4efbc5f4d4df9ef26ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83af",
                                                              "_id": "6077c4efbc5f4d4df9ef26ee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Right Circular Cone",
                                                      "id": "5ace203c9fe7b01d5806c048",
                                                      "_id": "6077c4efbc5f4d4df9ef26eb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b0",
                                                              "_id": "6077c4efbc5f4d4df9ef26ec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sphere, Hemisphere",
                                                      "id": "5ace203c9fe7b01d5806c04b",
                                                      "_id": "6077c4efbc5f4d4df9ef26e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b1",
                                                              "_id": "6077c4efbc5f4d4df9ef26ea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion of a solid into another",
                                                      "id": "5ace203c9fe7b01d5806c044",
                                                      "_id": "6077c4efbc5f4d4df9ef26e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b2",
                                                              "_id": "6077c4efbc5f4d4df9ef26e8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combination of Solids",
                                                      "id": "5ace203c9fe7b01d5806c043",
                                                      "_id": "6077c4efbc5f4d4df9ef26e5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b3",
                                                              "_id": "6077c4efbc5f4d4df9ef26e6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frustum of a Right Circular Cone",
                                                      "id": "5ace203c9fe7b01d5806c047",
                                                      "_id": "6077c4efbc5f4d4df9ef26e3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b4",
                                                              "_id": "6077c4efbc5f4d4df9ef26e4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8231",
                                                      "_id": "6077c4efbc5f4d4df9ef26f5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Circle",
                                              "id": "5ace20319fe7b01d5806bc58",
                                              "_id": "6077c4efbc5f4d4df9ef26ca",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between two circles and condition for orthogonal intersection",
                                                      "id": "5ace203a9fe7b01d5806bfa1",
                                                      "_id": "6077c4efbc5f4d4df9ef26df",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da45",
                                                              "_id": "6077c4efbc5f4d4df9ef26e0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord of contact, equation of chord in mid-point form",
                                                      "id": "5ace203a9fe7b01d5806bfa2",
                                                      "_id": "6077c4efbc5f4d4df9ef26dd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da46",
                                                              "_id": "6077c4efbc5f4d4df9ef26de"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of common tangent and their length, equation of common chord",
                                                      "id": "5ace203a9fe7b01d5806bfa3",
                                                      "_id": "6077c4efbc5f4d4df9ef26db",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da47",
                                                              "_id": "6077c4efbc5f4d4df9ef26dc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of tangent in various form",
                                                      "id": "5ace203a9fe7b01d5806bfa4",
                                                      "_id": "6077c4efbc5f4d4df9ef26d9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da48",
                                                              "_id": "6077c4efbc5f4d4df9ef26da"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Family of circles in various conditions",
                                                      "id": "5ace203a9fe7b01d5806bfa5",
                                                      "_id": "6077c4efbc5f4d4df9ef26d7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da49",
                                                              "_id": "6077c4efbc5f4d4df9ef26d8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "length of tangent",
                                                      "id": "5ace203a9fe7b01d5806bfa6",
                                                      "_id": "6077c4efbc5f4d4df9ef26d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4a",
                                                              "_id": "6077c4efbc5f4d4df9ef26d6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Normal of the circle",
                                                      "id": "5ace203a9fe7b01d5806bfa7",
                                                      "_id": "6077c4efbc5f4d4df9ef26d3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4b",
                                                              "_id": "6077c4efbc5f4d4df9ef26d4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pair of tangents and angle between pair of tangent and director circle",
                                                      "id": "5ace203a9fe7b01d5806bfa8",
                                                      "_id": "6077c4efbc5f4d4df9ef26d1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4c",
                                                              "_id": "6077c4efbc5f4d4df9ef26d2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position of point w.r.t. to circle and position of line w.r.t. circle, length of intercept made by circle on line",
                                                      "id": "5ace203a9fe7b01d5806bfa9",
                                                      "_id": "6077c4efbc5f4d4df9ef26cf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4d",
                                                              "_id": "6077c4efbc5f4d4df9ef26d0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radical axis and its property, position of two circles w.r.t. each other",
                                                      "id": "5ace203a9fe7b01d5806bfaa",
                                                      "_id": "6077c4efbc5f4d4df9ef26cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4e",
                                                              "_id": "6077c4efbc5f4d4df9ef26ce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Various forms of circle, condition for second degree equation to represents a circle",
                                                      "id": "5ace203a9fe7b01d5806bfab",
                                                      "_id": "6077c4efbc5f4d4df9ef26cb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da4f",
                                                              "_id": "6077c4efbc5f4d4df9ef26cc"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d94f",
                                                      "_id": "6077c4efbc5f4d4df9ef26e1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc84",
                                              "_id": "6077c4efbc5f4d4df9ef269c",
                                              "concepts": [
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5ace203c9fe7b01d5806c063",
                                                      "_id": "6077c4efbc5f4d4df9ef26c7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b5",
                                                              "_id": "6077c4efbc5f4d4df9ef26c8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Complementary Angles",
                                                      "id": "5ace203c9fe7b01d5806c065",
                                                      "_id": "6077c4efbc5f4d4df9ef26c5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b6",
                                                              "_id": "6077c4efbc5f4d4df9ef26c6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between different systems of Measurement of Angles",
                                                      "id": "5ace203c9fe7b01d5806c05a",
                                                      "_id": "6077c4efbc5f4d4df9ef26c3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b7",
                                                              "_id": "6077c4efbc5f4d4df9ef26c4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental identities, Sign of Trigonometric ratios",
                                                      "id": "5ace203c9fe7b01d5806c054",
                                                      "_id": "6077c4efbc5f4d4df9ef26c1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b8",
                                                              "_id": "6077c4efbc5f4d4df9ef26c2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain & range of Trigonometric ratios",
                                                      "id": "5ace203c9fe7b01d5806c053",
                                                      "_id": "6077c4efbc5f4d4df9ef26bf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83b9",
                                                              "_id": "6077c4efbc5f4d4df9ef26c0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                      "id": "5ace203c9fe7b01d5806c064",
                                                      "_id": "6077c4efbc5f4d4df9ef26bd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ba",
                                                              "_id": "6077c4efbc5f4d4df9ef26be"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Sum & Difference of two angles",
                                                      "id": "5ace203c9fe7b01d5806c067",
                                                      "_id": "6077c4efbc5f4d4df9ef26bb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83bb",
                                                              "_id": "6077c4efbc5f4d4df9ef26bc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation Formula - Product into Sum or Difference",
                                                      "id": "5ace203c9fe7b01d5806c05e",
                                                      "_id": "6077c4efbc5f4d4df9ef26b9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83bc",
                                                              "_id": "6077c4efbc5f4d4df9ef26ba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation Formula - Sum and Difference into Poduct",
                                                      "id": "5ace203c9fe7b01d5806c05f",
                                                      "_id": "6077c4efbc5f4d4df9ef26b7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83bd",
                                                              "_id": "6077c4efbc5f4d4df9ef26b8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of multiple angles, Trigonometric Ratios of sub-multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c066",
                                                      "_id": "6077c4efbc5f4d4df9ef26b5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83be",
                                                              "_id": "6077c4efbc5f4d4df9ef26b6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest & Least values of Trigonometric Expressions",
                                                      "id": "5ace203c9fe7b01d5806c056",
                                                      "_id": "6077c4efbc5f4d4df9ef26b3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83bf",
                                                              "_id": "6077c4efbc5f4d4df9ef26b4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Compound angles",
                                                      "id": "5ace203c9fe7b01d5806c052",
                                                      "_id": "6077c4efbc5f4d4df9ef26b1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c0",
                                                              "_id": "6077c4efbc5f4d4df9ef26b2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c058",
                                                      "_id": "6077c4efbc5f4d4df9ef26af",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c1",
                                                              "_id": "6077c4efbc5f4d4df9ef26b0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sub-multiple angles",
                                                      "id": "5ace203c9fe7b01d5806c05b",
                                                      "_id": "6077c4efbc5f4d4df9ef26ad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c2",
                                                              "_id": "6077c4efbc5f4d4df9ef26ae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformation",
                                                      "id": "5ace203c9fe7b01d5806c05d",
                                                      "_id": "6077c4efbc5f4d4df9ef26ab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c3",
                                                              "_id": "6077c4efbc5f4d4df9ef26ac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph of trignomety(periodicity) ratio",
                                                      "id": "5ace203c9fe7b01d5806c055",
                                                      "_id": "6077c4efbc5f4d4df9ef26a9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c4",
                                                              "_id": "6077c4efbc5f4d4df9ef26aa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric equations",
                                                      "id": "5ace203c9fe7b01d5806c060",
                                                      "_id": "6077c4efbc5f4d4df9ef26a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c5",
                                                              "_id": "6077c4efbc5f4d4df9ef26a8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric inequations",
                                                      "id": "5ace203c9fe7b01d5806c061",
                                                      "_id": "6077c4efbc5f4d4df9ef26a5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c6",
                                                              "_id": "6077c4efbc5f4d4df9ef26a6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of triangle",
                                                      "id": "5ace203c9fe7b01d5806c059",
                                                      "_id": "6077c4efbc5f4d4df9ef26a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c7",
                                                              "_id": "6077c4efbc5f4d4df9ef26a4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trignometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c0",
                                                      "_id": "6077c4efbc5f4d4df9ef26a1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c8",
                                                              "_id": "6077c4efbc5f4d4df9ef26a2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heights and distances",
                                                      "id": "5ace203d9fe7b01d5806c0b7",
                                                      "_id": "6077c4efbc5f4d4df9ef269f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83c9",
                                                              "_id": "6077c4efbc5f4d4df9ef26a0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum and product formulae",
                                                      "id": "5ace203c9fe7b01d5806c05c",
                                                      "_id": "6077c4efbc5f4d4df9ef269d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ca",
                                                              "_id": "6077c4efbc5f4d4df9ef269e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8232",
                                                      "_id": "6077c4efbc5f4d4df9ef26c9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ellipse",
                                              "id": "5ace20319fe7b01d5806bc59",
                                              "_id": "6077c4efbc5f4d4df9ef269a",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d950",
                                                      "_id": "6077c4efbc5f4d4df9ef269b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Application of Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc68",
                                              "_id": "6077c4efbc5f4d4df9ef2696",
                                              "concepts": [
                                                  {
                                                      "name": "Angle of Elevation, Angle of Depression",
                                                      "id": "5ace203b9fe7b01d5806bff4",
                                                      "_id": "6077c4efbc5f4d4df9ef2697",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83cb",
                                                              "_id": "6077c4efbc5f4d4df9ef2698"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8233",
                                                      "_id": "6077c4efbc5f4d4df9ef2699"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ellipse",
                                              "id": "5ace20319fe7b01d5806bc5a",
                                              "_id": "6077c4efbc5f4d4df9ef2678",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between the tangents",
                                                      "id": "5ace203a9fe7b01d5806bfac",
                                                      "_id": "6077c4efbc5f4d4df9ef2693",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da50",
                                                              "_id": "6077c4efbc5f4d4df9ef2694"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfad",
                                                      "_id": "6077c4efbc5f4d4df9ef2691",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da51",
                                                              "_id": "6077c4efbc5f4d4df9ef2692"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basing on director circle of ellipse",
                                                      "id": "5ace203a9fe7b01d5806bfae",
                                                      "_id": "6077c4efbc5f4d4df9ef268f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da52",
                                                              "_id": "6077c4efbc5f4d4df9ef2690"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "chord of contact, equation of pair of tangents, director circle",
                                                      "id": "5ace203a9fe7b01d5806bfaf",
                                                      "_id": "6077c4efbc5f4d4df9ef268d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da53",
                                                              "_id": "6077c4efbc5f4d4df9ef268e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form,",
                                                      "id": "5ace203a9fe7b01d5806bfb0",
                                                      "_id": "6077c4efbc5f4d4df9ef268b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da54",
                                                              "_id": "6077c4efbc5f4d4df9ef268c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord",
                                                      "id": "5ace203a9fe7b01d5806bfb1",
                                                      "_id": "6077c4efbc5f4d4df9ef2689",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da55",
                                                              "_id": "6077c4efbc5f4d4df9ef268a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represent ellipse, standard form and general form of ellipse and to find focus, directrix, axes, latus rectum, tangent at vertex of ellipse, parametric form, focal length, auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfb2",
                                                      "_id": "6077c4efbc5f4d4df9ef2687",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da56",
                                                              "_id": "6077c4efbc5f4d4df9ef2688"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfb3",
                                                      "_id": "6077c4efbc5f4d4df9ef2685",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da57",
                                                              "_id": "6077c4efbc5f4d4df9ef2686"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of four normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfb4",
                                                      "_id": "6077c4efbc5f4d4df9ef2683",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da58",
                                                              "_id": "6077c4efbc5f4d4df9ef2684"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of chord joining two points having eccentric angle",
                                                      "id": "5ace203a9fe7b01d5806bfb5",
                                                      "_id": "6077c4efbc5f4d4df9ef2681",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da59",
                                                              "_id": "6077c4efbc5f4d4df9ef2682"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of ellipse and a circle",
                                                      "id": "5ace203a9fe7b01d5806bfb6",
                                                      "_id": "6077c4efbc5f4d4df9ef267f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5a",
                                                              "_id": "6077c4efbc5f4d4df9ef2680"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "parametric co-ordinates",
                                                      "id": "5ace203a9fe7b01d5806bfb7",
                                                      "_id": "6077c4efbc5f4d4df9ef267d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5b",
                                                              "_id": "6077c4efbc5f4d4df9ef267e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "position of a pt w.r.t. ellipse",
                                                      "id": "5ace203a9fe7b01d5806bfb8",
                                                      "_id": "6077c4efbc5f4d4df9ef267b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5c",
                                                              "_id": "6077c4efbc5f4d4df9ef267c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in ellipse-reflection, tangent, normal",
                                                      "id": "5ace203a9fe7b01d5806bfb9",
                                                      "_id": "6077c4efbc5f4d4df9ef2679",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5d",
                                                              "_id": "6077c4efbc5f4d4df9ef267a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d951",
                                                      "_id": "6077c4efbc5f4d4df9ef2695"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics-2",
                                              "id": "5ace20319fe7b01d5806bc7f",
                                              "_id": "6077c4efbc5f4d4df9ef2670",
                                              "concepts": [
                                                  {
                                                      "name": "Frequency Distribution",
                                                      "id": "5ace203c9fe7b01d5806c03b",
                                                      "_id": "6077c4efbc5f4d4df9ef2675",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83cc",
                                                              "_id": "6077c4efbc5f4d4df9ef2676"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean, Median, Mode",
                                                      "id": "5ace203c9fe7b01d5806c03c",
                                                      "_id": "6077c4efbc5f4d4df9ef2673",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83cd",
                                                              "_id": "6077c4efbc5f4d4df9ef2674"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Empherical formula, Ogive curve, Emperical relation between mean, median, mode",
                                                      "id": "5ace203c9fe7b01d5806c03a",
                                                      "_id": "6077c4efbc5f4d4df9ef2671",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ce",
                                                              "_id": "6077c4efbc5f4d4df9ef2672"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8234",
                                                      "_id": "6077c4efbc5f4d4df9ef2677"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef274a"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Fluids",
                                              "id": "5ace20329fe7b01d5806bc9f",
                                              "_id": "6077c4efbc5f4d4df9ef2655",
                                              "concepts": [
                                                  {
                                                      "name": "Barometer, manometer, U-tube",
                                                      "id": "5ace203e9fe7b01d5806c125",
                                                      "_id": "6077c4efbc5f4d4df9ef266c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc3",
                                                              "_id": "6077c4efbc5f4d4df9ef266d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capillary action",
                                                      "id": "5ace203e9fe7b01d5806c126",
                                                      "_id": "6077c4efbc5f4d4df9ef266a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc4",
                                                              "_id": "6077c4efbc5f4d4df9ef266b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Excess pressure",
                                                      "id": "5ace203e9fe7b01d5806c127",
                                                      "_id": "6077c4efbc5f4d4df9ef2668",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc5",
                                                              "_id": "6077c4efbc5f4d4df9ef2669"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Floatation",
                                                      "id": "5ace203f9fe7b01d5806c128",
                                                      "_id": "6077c4efbc5f4d4df9ef2666",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc6",
                                                              "_id": "6077c4efbc5f4d4df9ef2667"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fluid dynamics, Bernoulli's equation",
                                                      "id": "5ace203f9fe7b01d5806c129",
                                                      "_id": "6077c4efbc5f4d4df9ef2664",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc7",
                                                              "_id": "6077c4efbc5f4d4df9ef2665"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pressure and Force applied by fluid",
                                                      "id": "5ace203f9fe7b01d5806c12a",
                                                      "_id": "6077c4efbc5f4d4df9ef2662",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc8",
                                                              "_id": "6077c4efbc5f4d4df9ef2663"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Siphonic action, venturimeter, pitot tube",
                                                      "id": "5ace203f9fe7b01d5806c12b",
                                                      "_id": "6077c4efbc5f4d4df9ef2660",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddc9",
                                                              "_id": "6077c4efbc5f4d4df9ef2661"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Stoke's Law",
                                                      "id": "5ace203f9fe7b01d5806c12c",
                                                      "_id": "6077c4efbc5f4d4df9ef265e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddca",
                                                              "_id": "6077c4efbc5f4d4df9ef265f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface tension force",
                                                      "id": "5ace203f9fe7b01d5806c12d",
                                                      "_id": "6077c4efbc5f4d4df9ef265c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcb",
                                                              "_id": "6077c4efbc5f4d4df9ef265d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time to drain out liquid from a container",
                                                      "id": "5ace203f9fe7b01d5806c12e",
                                                      "_id": "6077c4efbc5f4d4df9ef265a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcc",
                                                              "_id": "6077c4efbc5f4d4df9ef265b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velocity of efflux and thrust force",
                                                      "id": "5ace203f9fe7b01d5806c12f",
                                                      "_id": "6077c4efbc5f4d4df9ef2658",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcd",
                                                              "_id": "6077c4efbc5f4d4df9ef2659"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Viscosity",
                                                      "id": "5ace203f9fe7b01d5806c130",
                                                      "_id": "6077c4efbc5f4d4df9ef2656",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddce",
                                                              "_id": "6077c4efbc5f4d4df9ef2657"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd5f",
                                                      "_id": "6077c4efbc5f4d4df9ef266e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ray Optics and Optical Instruments",
                                              "id": "5eeb5f6cbb67ca2232c1e0b0",
                                              "_id": "6077c4efbc5f4d4df9ef2653",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae64",
                                                      "_id": "6077c4efbc5f4d4df9ef2654"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sound",
                                              "id": "5ace20329fe7b01d5806bcb3",
                                              "_id": "6077c4efbc5f4d4df9ef2645",
                                              "concepts": [
                                                  {
                                                      "name": "Types of waves , Amplitude , Time Period & Frequency",
                                                      "id": "5ace20409fe7b01d5806c1c6",
                                                      "_id": "6077c4efbc5f4d4df9ef2650",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f5",
                                                              "_id": "6077c4efbc5f4d4df9ef2651"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reflection of sound & ECHO",
                                                      "id": "5ace20409fe7b01d5806c1c3",
                                                      "_id": "6077c4efbc5f4d4df9ef264e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f6",
                                                              "_id": "6077c4efbc5f4d4df9ef264f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation between frequency, velocity and wave length",
                                                      "id": "5ace20409fe7b01d5806c1c4",
                                                      "_id": "6077c4efbc5f4d4df9ef264c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f7",
                                                              "_id": "6077c4efbc5f4d4df9ef264d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pitch, Loudness of sound, Timber & Intensity of sound",
                                                      "id": "5ace20409fe7b01d5806c1c2",
                                                      "_id": "6077c4efbc5f4d4df9ef264a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f8",
                                                              "_id": "6077c4efbc5f4d4df9ef264b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ultrasonic waves and its application",
                                                      "id": "5ace20409fe7b01d5806c1c7",
                                                      "_id": "6077c4efbc5f4d4df9ef2648",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83f9",
                                                              "_id": "6077c4efbc5f4d4df9ef2649"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time period of simple pendulum",
                                                      "id": "5ace20409fe7b01d5806c1c5",
                                                      "_id": "6077c4efbc5f4d4df9ef2646",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83fa",
                                                              "_id": "6077c4efbc5f4d4df9ef2647"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823d",
                                                      "_id": "6077c4efbc5f4d4df9ef2652"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semiconductor Electronics: Materials, Devices, and Simple Circuits",
                                              "id": "5eeb5f6cbb67ca2232c1e0b5",
                                              "_id": "6077c4efbc5f4d4df9ef2643",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae65",
                                                      "_id": "6077c4efbc5f4d4df9ef2644"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "General Physics",
                                              "id": "5ace20329fe7b01d5806bca0",
                                              "_id": "6077c4efbc5f4d4df9ef2639",
                                              "concepts": [
                                                  {
                                                      "name": "dimensional analysis",
                                                      "id": "5ace203f9fe7b01d5806c131",
                                                      "_id": "6077c4efbc5f4d4df9ef2640",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddcf",
                                                              "_id": "6077c4efbc5f4d4df9ef2641"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Error analysis",
                                                      "id": "5ace203f9fe7b01d5806c132",
                                                      "_id": "6077c4efbc5f4d4df9ef263e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd0",
                                                              "_id": "6077c4efbc5f4d4df9ef263f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Experiments",
                                                      "id": "5ace203f9fe7b01d5806c133",
                                                      "_id": "6077c4efbc5f4d4df9ef263c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd1",
                                                              "_id": "6077c4efbc5f4d4df9ef263d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Significant figure",
                                                      "id": "5ace203f9fe7b01d5806c134",
                                                      "_id": "6077c4efbc5f4d4df9ef263a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd2",
                                                              "_id": "6077c4efbc5f4d4df9ef263b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd60",
                                                      "_id": "6077c4efbc5f4d4df9ef2642"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electromagnetic Induction",
                                              "id": "5eeb5f6cbb67ca2232c1e0ad",
                                              "_id": "6077c4efbc5f4d4df9ef2637",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae67",
                                                      "_id": "6077c4efbc5f4d4df9ef2638"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef266f"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Number System",
                                              "id": "5ace20319fe7b01d5806bc33",
                                              "_id": "6077c4efbc5f4d4df9ef2630",
                                              "concepts": [
                                                  {
                                                      "name": "Remainder theorem",
                                                      "id": "5ace20399fe7b01d5806bf25",
                                                      "_id": "6077c4efbc5f4d4df9ef2633",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8427",
                                                              "_id": "6077c4efbc5f4d4df9ef2634"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basics of number system",
                                                      "id": "5ace20399fe7b01d5806bf24",
                                                      "_id": "6077c4efbc5f4d4df9ef2631",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8428",
                                                              "_id": "6077c4efbc5f4d4df9ef2632"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8249",
                                                      "_id": "6077c4efbc5f4d4df9ef2635"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Machine Input",
                                              "id": "5ace20319fe7b01d5806bc31",
                                              "_id": "6077c4efbc5f4d4df9ef262c",
                                              "concepts": [
                                                  {
                                                      "name": "Sequential output tracing",
                                                      "id": "5ace20389fe7b01d5806bf21",
                                                      "_id": "6077c4efbc5f4d4df9ef262d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8429",
                                                              "_id": "6077c4efbc5f4d4df9ef262e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824a",
                                                      "_id": "6077c4efbc5f4d4df9ef262f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Logical Venn Diagram",
                                              "id": "5ace20319fe7b01d5806bc30",
                                              "_id": "6077c4efbc5f4d4df9ef2628",
                                              "concepts": [
                                                  {
                                                      "name": "Venn Diagrams",
                                                      "id": "5ace20389fe7b01d5806bf20",
                                                      "_id": "6077c4efbc5f4d4df9ef2629",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842a",
                                                              "_id": "6077c4efbc5f4d4df9ef262a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824b",
                                                      "_id": "6077c4efbc5f4d4df9ef262b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef2636"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Minerals and Energy Resources",
                                              "id": "5ace20329fe7b01d5806bccb",
                                              "_id": "6077c4efbc5f4d4df9ef2621",
                                              "concepts": [
                                                  {
                                                      "name": "Occurrence of minerals.",
                                                      "id": "5ace20419fe7b01d5806c1ff",
                                                      "_id": "6077c4efbc5f4d4df9ef2624",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8466",
                                                              "_id": "6077c4efbc5f4d4df9ef2625"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Uses and conservation of mineral & energy resources",
                                                      "id": "5ace20419fe7b01d5806c200",
                                                      "_id": "6077c4efbc5f4d4df9ef2622",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8467",
                                                              "_id": "6077c4efbc5f4d4df9ef2623"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8272",
                                                      "_id": "6077c4efbc5f4d4df9ef2626"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Manufacturing Industries",
                                              "id": "5ace20329fe7b01d5806bcca",
                                              "_id": "6077c4efbc5f4d4df9ef261d",
                                              "concepts": [
                                                  {
                                                      "name": "Industries, location and their importance",
                                                      "id": "5ace20419fe7b01d5806c1fe",
                                                      "_id": "6077c4efbc5f4d4df9ef261e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8468",
                                                              "_id": "6077c4efbc5f4d4df9ef261f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8273",
                                                      "_id": "6077c4efbc5f4d4df9ef2620"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Life Lines of National Economy",
                                              "id": "5ace20329fe7b01d5806bcc9",
                                              "_id": "6077c4efbc5f4d4df9ef2619",
                                              "concepts": [
                                                  {
                                                      "name": "Importance of the transportation and communication in economy",
                                                      "id": "5ace20419fe7b01d5806c1fd",
                                                      "_id": "6077c4efbc5f4d4df9ef261a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8469",
                                                              "_id": "6077c4efbc5f4d4df9ef261b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8274",
                                                      "_id": "6077c4efbc5f4d4df9ef261c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "The French Revolution",
                                              "id": "5ace20329fe7b01d5806bcdc",
                                              "_id": "6077c4efbc5f4d4df9ef2613",
                                              "concepts": [
                                                  {
                                                      "name": "Causes of the French Revolution",
                                                      "id": "5ace20429fe7b01d5806c221",
                                                      "_id": "6077c4efbc5f4d4df9ef2616",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846a",
                                                              "_id": "6077c4efbc5f4d4df9ef2617"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Contribution of different sections in the FR",
                                                      "id": "5ace20429fe7b01d5806c222",
                                                      "_id": "6077c4efbc5f4d4df9ef2614",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846b",
                                                              "_id": "6077c4efbc5f4d4df9ef2615"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8275",
                                                      "_id": "6077c4efbc5f4d4df9ef2618"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Socialism in Europe and the Russian Revolution",
                                              "id": "5ace20329fe7b01d5806bcda",
                                              "_id": "6077c4efbc5f4d4df9ef260d",
                                              "concepts": [
                                                  {
                                                      "name": "Rise of socialism",
                                                      "id": "5ace20429fe7b01d5806c21e",
                                                      "_id": "6077c4efbc5f4d4df9ef2610",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846c",
                                                              "_id": "6077c4efbc5f4d4df9ef2611"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Causes of the RR and its impact",
                                                      "id": "5ace20429fe7b01d5806c21d",
                                                      "_id": "6077c4efbc5f4d4df9ef260e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846d",
                                                              "_id": "6077c4efbc5f4d4df9ef260f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8276",
                                                      "_id": "6077c4efbc5f4d4df9ef2612"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef2627"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Classification",
                                              "id": "5ace20309fe7b01d5806bc15",
                                              "_id": "6077c4efbc5f4d4df9ef2604",
                                              "concepts": [
                                                  {
                                                      "name": "Letter Classification",
                                                      "id": "5ace20389fe7b01d5806befd",
                                                      "_id": "6077c4efbc5f4d4df9ef2609",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df42",
                                                              "_id": "6077c4efbc5f4d4df9ef260a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number Classification",
                                                      "id": "5ace20389fe7b01d5806befe",
                                                      "_id": "6077c4efbc5f4d4df9ef2607",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df43",
                                                              "_id": "6077c4efbc5f4d4df9ef2608"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Word Classification",
                                                      "id": "5ace20389fe7b01d5806beff",
                                                      "_id": "6077c4efbc5f4d4df9ef2605",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df44",
                                                              "_id": "6077c4efbc5f4d4df9ef2606"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df36",
                                                      "_id": "6077c4efbc5f4d4df9ef260b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef260c"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 4,
                              "startDate": "2021-05-17T00:00:00.000Z",
                              "endDate": "2021-05-23T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef24b7",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Why do we fall ill",
                                              "id": "5ace202f9fe7b01d5806bbc5",
                                              "_id": "6077c4efbc5f4d4df9ef25f0",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction to disease, types, cause",
                                                      "id": "5ace20339fe7b01d5806bd67",
                                                      "_id": "6077c4efbc5f4d4df9ef25ff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82cc",
                                                              "_id": "6077c4efbc5f4d4df9ef2600"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Immunization",
                                                      "id": "5ace20339fe7b01d5806bd66",
                                                      "_id": "6077c4efbc5f4d4df9ef25fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82cd",
                                                              "_id": "6077c4efbc5f4d4df9ef25fe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bacterial diseases",
                                                      "id": "5ace20339fe7b01d5806bd65",
                                                      "_id": "6077c4efbc5f4d4df9ef25fb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ce",
                                                              "_id": "6077c4efbc5f4d4df9ef25fc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Viral diseases",
                                                      "id": "5ace20339fe7b01d5806bd6b",
                                                      "_id": "6077c4efbc5f4d4df9ef25f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82cf",
                                                              "_id": "6077c4efbc5f4d4df9ef25fa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Protozoan disease",
                                                      "id": "5ace20339fe7b01d5806bd6a",
                                                      "_id": "6077c4efbc5f4d4df9ef25f7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d0",
                                                              "_id": "6077c4efbc5f4d4df9ef25f8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mineral deficiency disorder",
                                                      "id": "5ace20339fe7b01d5806bd68",
                                                      "_id": "6077c4efbc5f4d4df9ef25f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d1",
                                                              "_id": "6077c4efbc5f4d4df9ef25f6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Protein deficiency disorder",
                                                      "id": "5ace20339fe7b01d5806bd69",
                                                      "_id": "6077c4efbc5f4d4df9ef25f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d2",
                                                              "_id": "6077c4efbc5f4d4df9ef25f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vitamin deficiency disorder",
                                                      "id": "5ace20339fe7b01d5806bd6c",
                                                      "_id": "6077c4efbc5f4d4df9ef25f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d3",
                                                              "_id": "6077c4efbc5f4d4df9ef25f2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820a",
                                                      "_id": "6077c4efbc5f4d4df9ef2601"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef2602"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Atomic structure",
                                              "id": "5ace202f9fe7b01d5806bbc7",
                                              "_id": "6077c4efbc5f4d4df9ef25db",
                                              "concepts": [
                                                  {
                                                      "name": "Discovery of Fundamental Particles",
                                                      "id": "5ace20349fe7b01d5806bd77",
                                                      "_id": "6077c4efbc5f4d4df9ef25ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8332",
                                                              "_id": "6077c4efbc5f4d4df9ef25ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atomic Models (Thomson & Rutherford Atomic Models)",
                                                      "id": "5ace20349fe7b01d5806bd75",
                                                      "_id": "6077c4efbc5f4d4df9ef25ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8333",
                                                              "_id": "6077c4efbc5f4d4df9ef25eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bohrs Theory",
                                                      "id": "5ace20349fe7b01d5806bd76",
                                                      "_id": "6077c4efbc5f4d4df9ef25e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8334",
                                                              "_id": "6077c4efbc5f4d4df9ef25e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electronic distribution in terms of shells and subshells",
                                                      "id": "5ace20349fe7b01d5806bd79",
                                                      "_id": "6077c4efbc5f4d4df9ef25e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8335",
                                                              "_id": "6077c4efbc5f4d4df9ef25e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Isotopes, Isotones and Isobars",
                                                      "id": "5ace20349fe7b01d5806bd7b",
                                                      "_id": "6077c4efbc5f4d4df9ef25e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8336",
                                                              "_id": "6077c4efbc5f4d4df9ef25e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Iso-electronic species",
                                                      "id": "5ace20349fe7b01d5806bd7a",
                                                      "_id": "6077c4efbc5f4d4df9ef25e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8337",
                                                              "_id": "6077c4efbc5f4d4df9ef25e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Radiation",
                                                      "id": "5ace20349fe7b01d5806bd78",
                                                      "_id": "6077c4efbc5f4d4df9ef25e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8338",
                                                              "_id": "6077c4efbc5f4d4df9ef25e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radioactivity",
                                                      "id": "5ace20349fe7b01d5806bd7d",
                                                      "_id": "6077c4efbc5f4d4df9ef25de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8339",
                                                              "_id": "6077c4efbc5f4d4df9ef25df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plancks Quantum Theory and Quantum Numbers",
                                                      "id": "5ace20349fe7b01d5806bd7c",
                                                      "_id": "6077c4efbc5f4d4df9ef25dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833a",
                                                              "_id": "6077c4efbc5f4d4df9ef25dd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8215",
                                                      "_id": "6077c4efbc5f4d4df9ef25ee"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef25ef"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Hyperbola",
                                              "id": "5ace20319fe7b01d5806bc5b",
                                              "_id": "6077c4efbc5f4d4df9ef25d8",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d952",
                                                      "_id": "6077c4efbc5f4d4df9ef25d9"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Area related to Circle",
                                              "id": "5ace20319fe7b01d5806bc69",
                                              "_id": "6077c4efbc5f4d4df9ef25d0",
                                              "concepts": [
                                                  {
                                                      "name": "Area of circle",
                                                      "id": "5ace203b9fe7b01d5806bff6",
                                                      "_id": "6077c4efbc5f4d4df9ef25d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83cf",
                                                              "_id": "6077c4efbc5f4d4df9ef25d6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of sector, Semi-circle area",
                                                      "id": "5ace203b9fe7b01d5806bff7",
                                                      "_id": "6077c4efbc5f4d4df9ef25d3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d0",
                                                              "_id": "6077c4efbc5f4d4df9ef25d4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area enclosed by two concentric circles, Area of segment",
                                                      "id": "5ace203b9fe7b01d5806bff5",
                                                      "_id": "6077c4efbc5f4d4df9ef25d1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d1",
                                                              "_id": "6077c4efbc5f4d4df9ef25d2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8235",
                                                      "_id": "6077c4efbc5f4d4df9ef25d7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Hyperbola",
                                              "id": "5ace20319fe7b01d5806bc5c",
                                              "_id": "6077c4efbc5f4d4df9ef25b4",
                                              "concepts": [
                                                  {
                                                      "name": "Asymptotes of hyperbola and its properties",
                                                      "id": "5ace203a9fe7b01d5806bfba",
                                                      "_id": "6077c4efbc5f4d4df9ef25cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5e",
                                                              "_id": "6077c4efbc5f4d4df9ef25ce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic properties of conjugate hyperbola of a hyperbola",
                                                      "id": "5ace203a9fe7b01d5806bfbb",
                                                      "_id": "6077c4efbc5f4d4df9ef25cb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da5f",
                                                              "_id": "6077c4efbc5f4d4df9ef25cc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord of contact, equation of pair of tangents, director circle",
                                                      "id": "5ace203a9fe7b01d5806bfbc",
                                                      "_id": "6077c4efbc5f4d4df9ef25c9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da60",
                                                              "_id": "6077c4efbc5f4d4df9ef25ca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                      "id": "5ace203a9fe7b01d5806bfbd",
                                                      "_id": "6077c4efbc5f4d4df9ef25c7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da61",
                                                              "_id": "6077c4efbc5f4d4df9ef25c8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Common tangent between hyperbola and circle",
                                                      "id": "5ace203a9fe7b01d5806bfbe",
                                                      "_id": "6077c4efbc5f4d4df9ef25c5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da62",
                                                              "_id": "6077c4efbc5f4d4df9ef25c6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                      "id": "5ace203a9fe7b01d5806bfbf",
                                                      "_id": "6077c4efbc5f4d4df9ef25c3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da63",
                                                              "_id": "6077c4efbc5f4d4df9ef25c4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represents hyperbola, standard form and general form of hyperbola, conjugate hyperbola and to find focus, directrix, axes, latus rectum, tangent at vertex of hyperbola, parametric form, focal length, auxiliary circle",
                                                      "id": "5ace203a9fe7b01d5806bfc0",
                                                      "_id": "6077c4efbc5f4d4df9ef25c1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da64",
                                                              "_id": "6077c4efbc5f4d4df9ef25c2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfc1",
                                                      "_id": "6077c4efbc5f4d4df9ef25bf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da65",
                                                              "_id": "6077c4efbc5f4d4df9ef25c0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of four normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfc2",
                                                      "_id": "6077c4efbc5f4d4df9ef25bd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da66",
                                                              "_id": "6077c4efbc5f4d4df9ef25be"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Intersection of a rectangular hyperbola with a circle",
                                                      "id": "5ace203a9fe7b01d5806bfc3",
                                                      "_id": "6077c4efbc5f4d4df9ef25bb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da67",
                                                              "_id": "6077c4efbc5f4d4df9ef25bc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "position of a pt w.r.t. hyperbola",
                                                      "id": "5ace203a9fe7b01d5806bfc4",
                                                      "_id": "6077c4efbc5f4d4df9ef25b9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da68",
                                                              "_id": "6077c4efbc5f4d4df9ef25ba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in hyperbola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                      "id": "5ace203a9fe7b01d5806bfc5",
                                                      "_id": "6077c4efbc5f4d4df9ef25b7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da69",
                                                              "_id": "6077c4efbc5f4d4df9ef25b8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rectangular hyperbola and its properties",
                                                      "id": "5ace203a9fe7b01d5806bfc6",
                                                      "_id": "6077c4efbc5f4d4df9ef25b5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6a",
                                                              "_id": "6077c4efbc5f4d4df9ef25b6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d953",
                                                      "_id": "6077c4efbc5f4d4df9ef25cf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Real Numbers",
                                              "id": "5ace20319fe7b01d5806bc7c",
                                              "_id": "6077c4efbc5f4d4df9ef25ae",
                                              "concepts": [
                                                  {
                                                      "name": "Euclid's Division Method, Fundamental Theorm of Arithmetic",
                                                      "id": "5ace203c9fe7b01d5806c02c",
                                                      "_id": "6077c4efbc5f4d4df9ef25b1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d2",
                                                              "_id": "6077c4efbc5f4d4df9ef25b2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Results-Irrationality of sqrt of 2, 3, 5, Decimal Expansions of Rational Numbers in Terms of Terminating / Non-Terminating",
                                                      "id": "5ace203c9fe7b01d5806c02d",
                                                      "_id": "6077c4efbc5f4d4df9ef25af",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d3",
                                                              "_id": "6077c4efbc5f4d4df9ef25b0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8236",
                                                      "_id": "6077c4efbc5f4d4df9ef25b3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Parabola",
                                              "id": "5ace20319fe7b01d5806bc5d",
                                              "_id": "6077c4efbc5f4d4df9ef25ac",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d954",
                                                      "_id": "6077c4efbc5f4d4df9ef25ad"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials-2",
                                              "id": "5ace20319fe7b01d5806bc77",
                                              "_id": "6077c4efbc5f4d4df9ef25a6",
                                              "concepts": [
                                                  {
                                                      "name": "Nature of Zeros of a Polynomial",
                                                      "id": "5ace203b9fe7b01d5806c01d",
                                                      "_id": "6077c4efbc5f4d4df9ef25a9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d4",
                                                              "_id": "6077c4efbc5f4d4df9ef25aa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical Meaning of the Zeroes of a Polynomials",
                                                      "id": "5ace203b9fe7b01d5806c01c",
                                                      "_id": "6077c4efbc5f4d4df9ef25a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83d5",
                                                              "_id": "6077c4efbc5f4d4df9ef25a8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8237",
                                                      "_id": "6077c4efbc5f4d4df9ef25ab"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Parabola",
                                              "id": "5ace20319fe7b01d5806bc5e",
                                              "_id": "6077c4efbc5f4d4df9ef258e",
                                              "concepts": [
                                                  {
                                                      "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                      "id": "5ace203a9fe7b01d5806bfc7",
                                                      "_id": "6077c4efbc5f4d4df9ef25a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6b",
                                                              "_id": "6077c4efbc5f4d4df9ef25a4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                      "id": "5ace203a9fe7b01d5806bfc8",
                                                      "_id": "6077c4efbc5f4d4df9ef25a1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6c",
                                                              "_id": "6077c4efbc5f4d4df9ef25a2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for second degree to represents conic, standard form and general form of parabola, focus, directrix, axes, latus rectum, tangent at vertex of parabola, parametric form",
                                                      "id": "5ace203a9fe7b01d5806bfc9",
                                                      "_id": "6077c4efbc5f4d4df9ef259f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6d",
                                                              "_id": "6077c4efbc5f4d4df9ef25a0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for z normals",
                                                      "id": "5ace203a9fe7b01d5806bfca",
                                                      "_id": "6077c4efbc5f4d4df9ef259d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6e",
                                                              "_id": "6077c4efbc5f4d4df9ef259e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents, chord of contact",
                                                      "id": "5ace203a9fe7b01d5806bfcb",
                                                      "_id": "6077c4efbc5f4d4df9ef259b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da6f",
                                                              "_id": "6077c4efbc5f4d4df9ef259c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Co-normal points, condition of three normals passing through a point",
                                                      "id": "5ace203a9fe7b01d5806bfcc",
                                                      "_id": "6077c4efbc5f4d4df9ef2599",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da70",
                                                              "_id": "6077c4efbc5f4d4df9ef259a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "eqn of normal",
                                                      "id": "5ace203a9fe7b01d5806bfcd",
                                                      "_id": "6077c4efbc5f4d4df9ef2597",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da71",
                                                              "_id": "6077c4efbc5f4d4df9ef2598"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of pair of tangents",
                                                      "id": "5ace203a9fe7b01d5806bfce",
                                                      "_id": "6077c4efbc5f4d4df9ef2595",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da72",
                                                              "_id": "6077c4efbc5f4d4df9ef2596"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "geometrical properties of a parabola",
                                                      "id": "5ace203a9fe7b01d5806bfcf",
                                                      "_id": "6077c4efbc5f4d4df9ef2593",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da73",
                                                              "_id": "6077c4efbc5f4d4df9ef2594"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties in parabola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                      "id": "5ace203a9fe7b01d5806bfd0",
                                                      "_id": "6077c4efbc5f4d4df9ef2591",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da74",
                                                              "_id": "6077c4efbc5f4d4df9ef2592"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots of cubic equations",
                                                      "id": "5ace203a9fe7b01d5806bfd1",
                                                      "_id": "6077c4efbc5f4d4df9ef258f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da75",
                                                              "_id": "6077c4efbc5f4d4df9ef2590"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d955",
                                                      "_id": "6077c4efbc5f4d4df9ef25a5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Straight Line",
                                              "id": "5ace20319fe7b01d5806bc5f",
                                              "_id": "6077c4efbc5f4d4df9ef258c",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d956",
                                                      "_id": "6077c4efbc5f4d4df9ef258d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Straight Line",
                                              "id": "5ace20319fe7b01d5806bc60",
                                              "_id": "6077c4efbc5f4d4df9ef2572",
                                              "concepts": [
                                                  {
                                                      "name": "Angle bisectors",
                                                      "id": "5ace203a9fe7b01d5806bfd2",
                                                      "_id": "6077c4efbc5f4d4df9ef2589",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da76",
                                                              "_id": "6077c4efbc5f4d4df9ef258a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of triangle, collinearity and locus",
                                                      "id": "5ace203a9fe7b01d5806bfd3",
                                                      "_id": "6077c4efbc5f4d4df9ef2587",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da77",
                                                              "_id": "6077c4efbc5f4d4df9ef2588"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concept of homogenization",
                                                      "id": "5ace203a9fe7b01d5806bfd4",
                                                      "_id": "6077c4efbc5f4d4df9ef2585",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da78",
                                                              "_id": "6077c4efbc5f4d4df9ef2586"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition for eqn of second degree to represent two lines, angle between two pair of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd5",
                                                      "_id": "6077c4efbc5f4d4df9ef2583",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da79",
                                                              "_id": "6077c4efbc5f4d4df9ef2584"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance formula, Section formula, centres related to triangle",
                                                      "id": "5ace203a9fe7b01d5806bfd6",
                                                      "_id": "6077c4efbc5f4d4df9ef2581",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7a",
                                                              "_id": "6077c4efbc5f4d4df9ef2582"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "eqn of pair of line joing pts of intersection of a line and a conic",
                                                      "id": "5ace203a9fe7b01d5806bfd7",
                                                      "_id": "6077c4efbc5f4d4df9ef257f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7b",
                                                              "_id": "6077c4efbc5f4d4df9ef2580"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of angle bisectors of pair of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd8",
                                                      "_id": "6077c4efbc5f4d4df9ef257d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7c",
                                                              "_id": "6077c4efbc5f4d4df9ef257e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Family of straight lines/concurrency of straight lines",
                                                      "id": "5ace203a9fe7b01d5806bfd9",
                                                      "_id": "6077c4efbc5f4d4df9ef257b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7d",
                                                              "_id": "6077c4efbc5f4d4df9ef257c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parametric form of line and its application",
                                                      "id": "5ace203b9fe7b01d5806bfda",
                                                      "_id": "6077c4efbc5f4d4df9ef2579",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7e",
                                                              "_id": "6077c4efbc5f4d4df9ef257a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position of points w.r.t. to line, distance of a point from a line, distance between two parallel lines angle between two lines, condition of parallel/perpendicular/identical lines",
                                                      "id": "5ace203b9fe7b01d5806bfdb",
                                                      "_id": "6077c4efbc5f4d4df9ef2577",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da7f",
                                                              "_id": "6077c4efbc5f4d4df9ef2578"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rotation and translation of axes",
                                                      "id": "5ace203b9fe7b01d5806bfdc",
                                                      "_id": "6077c4efbc5f4d4df9ef2575",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da80",
                                                              "_id": "6077c4efbc5f4d4df9ef2576"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Slope of a line, various forms of equation of straight line",
                                                      "id": "5ace203b9fe7b01d5806bfdd",
                                                      "_id": "6077c4efbc5f4d4df9ef2573",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da81",
                                                              "_id": "6077c4efbc5f4d4df9ef2574"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d957",
                                                      "_id": "6077c4efbc5f4d4df9ef258b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Functions",
                                              "id": "5ace20319fe7b01d5806bc61",
                                              "_id": "6077c4efbc5f4d4df9ef2570",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d958",
                                                      "_id": "6077c4efbc5f4d4df9ef2571"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Functions",
                                              "id": "5ace20319fe7b01d5806bc62",
                                              "_id": "6077c4efbc5f4d4df9ef254c",
                                              "concepts": [
                                                  {
                                                      "name": "Algebra of a function",
                                                      "id": "5ace203b9fe7b01d5806bfde",
                                                      "_id": "6077c4efbc5f4d4df9ef256d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da82",
                                                              "_id": "6077c4efbc5f4d4df9ef256e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bijective functions, inverse of a function",
                                                      "id": "5ace203b9fe7b01d5806bfdf",
                                                      "_id": "6077c4efbc5f4d4df9ef256b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da83",
                                                              "_id": "6077c4efbc5f4d4df9ef256c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "binary operation",
                                                      "id": "5ace203b9fe7b01d5806bfe0",
                                                      "_id": "6077c4efbc5f4d4df9ef2569",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da84",
                                                              "_id": "6077c4efbc5f4d4df9ef256a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Composite function",
                                                      "id": "5ace203b9fe7b01d5806bfe1",
                                                      "_id": "6077c4efbc5f4d4df9ef2567",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da85",
                                                              "_id": "6077c4efbc5f4d4df9ef2568"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain of a function",
                                                      "id": "5ace203b9fe7b01d5806bfe2",
                                                      "_id": "6077c4efbc5f4d4df9ef2565",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da86",
                                                              "_id": "6077c4efbc5f4d4df9ef2566"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "even fn",
                                                      "id": "5ace203b9fe7b01d5806bfe3",
                                                      "_id": "6077c4efbc5f4d4df9ef2563",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da87",
                                                              "_id": "6077c4efbc5f4d4df9ef2564"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Even/odd functions",
                                                      "id": "5ace203b9fe7b01d5806bfe4",
                                                      "_id": "6077c4efbc5f4d4df9ef2561",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da88",
                                                              "_id": "6077c4efbc5f4d4df9ef2562"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functional equation",
                                                      "id": "5ace203b9fe7b01d5806bfe5",
                                                      "_id": "6077c4efbc5f4d4df9ef255f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da89",
                                                              "_id": "6077c4efbc5f4d4df9ef2560"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GIF (Greatest integer function)",
                                                      "id": "5ace203b9fe7b01d5806bfe6",
                                                      "_id": "6077c4efbc5f4d4df9ef255d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8a",
                                                              "_id": "6077c4efbc5f4d4df9ef255e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus function",
                                                      "id": "5ace203b9fe7b01d5806bfe7",
                                                      "_id": "6077c4efbc5f4d4df9ef255b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8b",
                                                              "_id": "6077c4efbc5f4d4df9ef255c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number of elements in sets, operation on sets, venn diagram based problems, cartesian products of two sets",
                                                      "id": "5ace203b9fe7b01d5806bfe8",
                                                      "_id": "6077c4efbc5f4d4df9ef2559",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8c",
                                                              "_id": "6077c4efbc5f4d4df9ef255a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Number of solution type problems, Graphical solution of function",
                                                      "id": "5ace203b9fe7b01d5806bfe9",
                                                      "_id": "6077c4efbc5f4d4df9ef2557",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8d",
                                                              "_id": "6077c4efbc5f4d4df9ef2558"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "odd fn",
                                                      "id": "5ace203b9fe7b01d5806bfea",
                                                      "_id": "6077c4efbc5f4d4df9ef2555",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8e",
                                                              "_id": "6077c4efbc5f4d4df9ef2556"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Period of a function",
                                                      "id": "5ace203b9fe7b01d5806bfeb",
                                                      "_id": "6077c4efbc5f4d4df9ef2553",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da8f",
                                                              "_id": "6077c4efbc5f4d4df9ef2554"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Range of a function",
                                                      "id": "5ace203b9fe7b01d5806bfec",
                                                      "_id": "6077c4efbc5f4d4df9ef2551",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da90",
                                                              "_id": "6077c4efbc5f4d4df9ef2552"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relation and types of relations",
                                                      "id": "5ace203b9fe7b01d5806bfed",
                                                      "_id": "6077c4efbc5f4d4df9ef254f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da91",
                                                              "_id": "6077c4efbc5f4d4df9ef2550"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types and number of functions: one-one/many-one, into/ onto",
                                                      "id": "5ace203b9fe7b01d5806bfee",
                                                      "_id": "6077c4efbc5f4d4df9ef254d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da92",
                                                              "_id": "6077c4efbc5f4d4df9ef254e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d959",
                                                      "_id": "6077c4efbc5f4d4df9ef256f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Inequations",
                                              "id": "5ace20319fe7b01d5806bc63",
                                              "_id": "6077c4efbc5f4d4df9ef2548",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Inequations",
                                                      "id": "5ace203b9fe7b01d5806bfef",
                                                      "_id": "6077c4efbc5f4d4df9ef2549",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da93",
                                                              "_id": "6077c4efbc5f4d4df9ef254a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95a",
                                                      "_id": "6077c4efbc5f4d4df9ef254b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Programming",
                                              "id": "5ace20319fe7b01d5806bc64",
                                              "_id": "6077c4efbc5f4d4df9ef2544",
                                              "concepts": [
                                                  {
                                                      "name": "Problems based on optimization under constraints",
                                                      "id": "5ace203b9fe7b01d5806bff0",
                                                      "_id": "6077c4efbc5f4d4df9ef2545",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da94",
                                                              "_id": "6077c4efbc5f4d4df9ef2546"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95b",
                                                      "_id": "6077c4efbc5f4d4df9ef2547"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Logarithmic and Exponential Series",
                                              "id": "5ace20319fe7b01d5806bc65",
                                              "_id": "6077c4efbc5f4d4df9ef2540",
                                              "concepts": [
                                                  {
                                                      "name": "Problems related to Series and Equation",
                                                      "id": "5ace203b9fe7b01d5806bff1",
                                                      "_id": "6077c4efbc5f4d4df9ef2541",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da95",
                                                              "_id": "6077c4efbc5f4d4df9ef2542"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95c",
                                                      "_id": "6077c4efbc5f4d4df9ef2543"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mathematical Induction",
                                              "id": "5ace20319fe7b01d5806bc66",
                                              "_id": "6077c4efbc5f4d4df9ef253c",
                                              "concepts": [
                                                  {
                                                      "name": "Principle of Mathematical Induction",
                                                      "id": "5ace203b9fe7b01d5806bff2",
                                                      "_id": "6077c4efbc5f4d4df9ef253d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da96",
                                                              "_id": "6077c4efbc5f4d4df9ef253e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95d",
                                                      "_id": "6077c4efbc5f4d4df9ef253f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mathematical Reasoning",
                                              "id": "5ace20319fe7b01d5806bc67",
                                              "_id": "6077c4efbc5f4d4df9ef2538",
                                              "concepts": [
                                                  {
                                                      "name": "Types of statements, Mathematical operators-And, or, NOT, If then, If and only If, Quantifiers, Tautology, Falacy",
                                                      "id": "5ace203b9fe7b01d5806bff3",
                                                      "_id": "6077c4efbc5f4d4df9ef2539",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673da97",
                                                              "_id": "6077c4efbc5f4d4df9ef253a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5722b35a0a066673d95e",
                                                      "_id": "6077c4efbc5f4d4df9ef253b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Linear Equations in Two Variables",
                                              "id": "5ec644a012a5e80679ddd546",
                                              "_id": "6077c4efbc5f4d4df9ef252c",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Equations",
                                                      "id": "5ec64785941e1306742b8428",
                                                      "_id": "6077c4efbc5f4d4df9ef2535",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db20",
                                                              "_id": "6077c4efbc5f4d4df9ef2536"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations of Lines Parallel to the X-axis and Y-axis",
                                                      "id": "5ec64785941e1306742b842c",
                                                      "_id": "6077c4efbc5f4d4df9ef2533",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db21",
                                                              "_id": "6077c4efbc5f4d4df9ef2534"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph of Linear Equation in Two Variables",
                                                      "id": "5ec64785941e1306742b842a",
                                                      "_id": "6077c4efbc5f4d4df9ef2531",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db22",
                                                              "_id": "6077c4efbc5f4d4df9ef2532"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Life Applications ",
                                                      "id": "5ec64785941e1306742b842b",
                                                      "_id": "6077c4efbc5f4d4df9ef252f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db23",
                                                              "_id": "6077c4efbc5f4d4df9ef2530"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of a Linear Equation",
                                                      "id": "5ec64785941e1306742b8429",
                                                      "_id": "6077c4efbc5f4d4df9ef252d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5723b35a0a066673db24",
                                                              "_id": "6077c4efbc5f4d4df9ef252e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97c",
                                                      "_id": "6077c4efbc5f4d4df9ef2537"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef25da"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Electricity",
                                              "id": "5ace20329fe7b01d5806bcab",
                                              "_id": "6077c4efbc5f4d4df9ef2515",
                                              "concepts": [
                                                  {
                                                      "name": "Potential & Potential Difference",
                                                      "id": "5ace20409fe7b01d5806c18d",
                                                      "_id": "6077c4efbc5f4d4df9ef2528",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83fb",
                                                              "_id": "6077c4efbc5f4d4df9ef2529"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Charge & Electric Current",
                                                      "id": "5ace20409fe7b01d5806c18e",
                                                      "_id": "6077c4efbc5f4d4df9ef2526",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83fc",
                                                              "_id": "6077c4efbc5f4d4df9ef2527"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ohm's Law",
                                                      "id": "5ace20409fe7b01d5806c18c",
                                                      "_id": "6077c4efbc5f4d4df9ef2524",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83fd",
                                                              "_id": "6077c4efbc5f4d4df9ef2525"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conductor, Insulator and Ammeter and Voltmeter",
                                                      "id": "5ace20409fe7b01d5806c189",
                                                      "_id": "6077c4efbc5f4d4df9ef2522",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83fe",
                                                              "_id": "6077c4efbc5f4d4df9ef2523"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resistance and Resistivity",
                                                      "id": "5ace20409fe7b01d5806c18f",
                                                      "_id": "6077c4efbc5f4d4df9ef2520",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c83ff",
                                                              "_id": "6077c4efbc5f4d4df9ef2521"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series and Parralel Combination of Resistances",
                                                      "id": "5ace20409fe7b01d5806c190",
                                                      "_id": "6077c4efbc5f4d4df9ef251e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8400",
                                                              "_id": "6077c4efbc5f4d4df9ef251f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heating Effect of Current",
                                                      "id": "5ace20409fe7b01d5806c18b",
                                                      "_id": "6077c4efbc5f4d4df9ef251c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8401",
                                                              "_id": "6077c4efbc5f4d4df9ef251d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Power",
                                                      "id": "5ace20409fe7b01d5806c18a",
                                                      "_id": "6077c4efbc5f4d4df9ef251a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8402",
                                                              "_id": "6077c4efbc5f4d4df9ef251b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Columb's Inverse Square Law",
                                                      "id": "5ace20409fe7b01d5806c188",
                                                      "_id": "6077c4efbc5f4d4df9ef2518",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8403",
                                                              "_id": "6077c4efbc5f4d4df9ef2519"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wheatstone Bridge",
                                                      "id": "5ace20409fe7b01d5806c191",
                                                      "_id": "6077c4efbc5f4d4df9ef2516",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8404",
                                                              "_id": "6077c4efbc5f4d4df9ef2517"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823e",
                                                      "_id": "6077c4efbc5f4d4df9ef252a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Wave Optics",
                                              "id": "5eeb5f6cbb67ca2232c1e0b1",
                                              "_id": "6077c4efbc5f4d4df9ef2513",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae69",
                                                      "_id": "6077c4efbc5f4d4df9ef2514"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vectors",
                                              "id": "5ace20329fe7b01d5806bca1",
                                              "_id": "6077c4efbc5f4d4df9ef250b",
                                              "concepts": [
                                                  {
                                                      "name": "Dot Product, Cross product and applications",
                                                      "id": "5ace203f9fe7b01d5806c135",
                                                      "_id": "6077c4efbc5f4d4df9ef2510",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd3",
                                                              "_id": "6077c4efbc5f4d4df9ef2511"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resolution of vectors",
                                                      "id": "5ace203f9fe7b01d5806c136",
                                                      "_id": "6077c4efbc5f4d4df9ef250e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd4",
                                                              "_id": "6077c4efbc5f4d4df9ef250f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vectors & parallelogram Law",
                                                      "id": "5ace203f9fe7b01d5806c137",
                                                      "_id": "6077c4efbc5f4d4df9ef250c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd5",
                                                              "_id": "6077c4efbc5f4d4df9ef250d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd61",
                                                      "_id": "6077c4efbc5f4d4df9ef2512"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetism and Matter",
                                              "id": "5eeb5f6cbb67ca2232c1e0ac",
                                              "_id": "6077c4efbc5f4d4df9ef2509",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae6a",
                                                      "_id": "6077c4efbc5f4d4df9ef250a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetic Effect of Electric Current",
                                              "id": "5ace20329fe7b01d5806bcb1",
                                              "_id": "6077c4efbc5f4d4df9ef24f3",
                                              "concepts": [
                                                  {
                                                      "name": "Magnetic Field",
                                                      "id": "5ace20409fe7b01d5806c1b4",
                                                      "_id": "6077c4efbc5f4d4df9ef2506",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8405",
                                                              "_id": "6077c4efbc5f4d4df9ef2507"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic field due to Current in a straight conductor",
                                                      "id": "5ace20409fe7b01d5806c1b6",
                                                      "_id": "6077c4efbc5f4d4df9ef2504",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8406",
                                                              "_id": "6077c4efbc5f4d4df9ef2505"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic field due to Current in a loop",
                                                      "id": "5ace20409fe7b01d5806c1b5",
                                                      "_id": "6077c4efbc5f4d4df9ef2502",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8407",
                                                              "_id": "6077c4efbc5f4d4df9ef2503"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Field due to Solenoid",
                                                      "id": "5ace20409fe7b01d5806c1b7",
                                                      "_id": "6077c4efbc5f4d4df9ef2500",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8408",
                                                              "_id": "6077c4efbc5f4d4df9ef2501"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Type of Magnet, Electro magnets and its uses",
                                                      "id": "5ace20409fe7b01d5806c1b9",
                                                      "_id": "6077c4efbc5f4d4df9ef24fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8409",
                                                              "_id": "6077c4efbc5f4d4df9ef24ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fleming's Left/right hand rule & Maxwell's cork screw rule",
                                                      "id": "5ace20409fe7b01d5806c1b2",
                                                      "_id": "6077c4efbc5f4d4df9ef24fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840a",
                                                              "_id": "6077c4efbc5f4d4df9ef24fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Force on a charge moving in Magnetic field",
                                                      "id": "5ace20409fe7b01d5806c1b3",
                                                      "_id": "6077c4efbc5f4d4df9ef24fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840b",
                                                              "_id": "6077c4efbc5f4d4df9ef24fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Induction & Lenz's law",
                                                      "id": "5ace20409fe7b01d5806c1b1",
                                                      "_id": "6077c4efbc5f4d4df9ef24f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840c",
                                                              "_id": "6077c4efbc5f4d4df9ef24f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motor and Generator",
                                                      "id": "5ace20409fe7b01d5806c1b8",
                                                      "_id": "6077c4efbc5f4d4df9ef24f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840d",
                                                              "_id": "6077c4efbc5f4d4df9ef24f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domestic Electric circuits, Live,Neutral and Earth wires & Safety devices in domestic circuits",
                                                      "id": "5ace20409fe7b01d5806c1b0",
                                                      "_id": "6077c4efbc5f4d4df9ef24f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840e",
                                                              "_id": "6077c4efbc5f4d4df9ef24f5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c823f",
                                                      "_id": "6077c4efbc5f4d4df9ef2508"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Dual Nature of Radiation and Matter",
                                              "id": "5eeb5f6cbb67ca2232c1e0b2",
                                              "_id": "6077c4efbc5f4d4df9ef24f1",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae6b",
                                                      "_id": "6077c4efbc5f4d4df9ef24f2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef252b"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Syllogism",
                                              "id": "5ace20319fe7b01d5806bc40",
                                              "_id": "6077c4efbc5f4d4df9ef24ec",
                                              "concepts": [
                                                  {
                                                      "name": "Syllogism",
                                                      "id": "5ace20399fe7b01d5806bf3d",
                                                      "_id": "6077c4efbc5f4d4df9ef24ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842b",
                                                              "_id": "6077c4efbc5f4d4df9ef24ee"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824c",
                                                      "_id": "6077c4efbc5f4d4df9ef24ef"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Arrangements",
                                              "id": "5ace20309fe7b01d5806bc20",
                                              "_id": "6077c4efbc5f4d4df9ef24e8",
                                              "concepts": [
                                                  {
                                                      "name": "Arrangements",
                                                      "id": "5ace20389fe7b01d5806bf0e",
                                                      "_id": "6077c4efbc5f4d4df9ef24e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842c",
                                                              "_id": "6077c4efbc5f4d4df9ef24ea"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824d",
                                                      "_id": "6077c4efbc5f4d4df9ef24eb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ranking Test & Time Sequence Test",
                                              "id": "5ace20319fe7b01d5806bc39",
                                              "_id": "6077c4efbc5f4d4df9ef24e0",
                                              "concepts": [
                                                  {
                                                      "name": "Ranking Test",
                                                      "id": "5ace20399fe7b01d5806bf32",
                                                      "_id": "6077c4efbc5f4d4df9ef24e5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842d",
                                                              "_id": "6077c4efbc5f4d4df9ef24e6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time Sequence Test",
                                                      "id": "5ace20399fe7b01d5806bf33",
                                                      "_id": "6077c4efbc5f4d4df9ef24e3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842e",
                                                              "_id": "6077c4efbc5f4d4df9ef24e4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Calendar",
                                                      "id": "5ace20399fe7b01d5806bf31",
                                                      "_id": "6077c4efbc5f4d4df9ef24e1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c842f",
                                                              "_id": "6077c4efbc5f4d4df9ef24e2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824e",
                                                      "_id": "6077c4efbc5f4d4df9ef24e7"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef24f0"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Nazism and the Rise of Hitler",
                                              "id": "5ace20329fe7b01d5806bcd5",
                                              "_id": "6077c4efbc5f4d4df9ef24d9",
                                              "concepts": [
                                                  {
                                                      "name": "First World War and Weimar Republic.",
                                                      "id": "5ace20419fe7b01d5806c210",
                                                      "_id": "6077c4efbc5f4d4df9ef24dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846e",
                                                              "_id": "6077c4efbc5f4d4df9ef24dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rise of Hitler & the idea of Nazism",
                                                      "id": "5ace20419fe7b01d5806c211",
                                                      "_id": "6077c4efbc5f4d4df9ef24da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c846f",
                                                              "_id": "6077c4efbc5f4d4df9ef24db"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8277",
                                                      "_id": "6077c4efbc5f4d4df9ef24de"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Forest Society and Colonialism",
                                              "id": "5ace20329fe7b01d5806bcd2",
                                              "_id": "6077c4efbc5f4d4df9ef24d3",
                                              "concepts": [
                                                  {
                                                      "name": "Causes of deforestration.",
                                                      "id": "5ace20419fe7b01d5806c20b",
                                                      "_id": "6077c4efbc5f4d4df9ef24d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8470",
                                                              "_id": "6077c4efbc5f4d4df9ef24d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Forests rule under British government'",
                                                      "id": "5ace20419fe7b01d5806c20c",
                                                      "_id": "6077c4efbc5f4d4df9ef24d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8471",
                                                              "_id": "6077c4efbc5f4d4df9ef24d5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8278",
                                                      "_id": "6077c4efbc5f4d4df9ef24d8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Pastaralists in the Modern World",
                                              "id": "5ace20329fe7b01d5806bcd7",
                                              "_id": "6077c4efbc5f4d4df9ef24cb",
                                              "concepts": [
                                                  {
                                                      "name": "Pastoralists of India.",
                                                      "id": "5ace20429fe7b01d5806c216",
                                                      "_id": "6077c4efbc5f4d4df9ef24d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8472",
                                                              "_id": "6077c4efbc5f4d4df9ef24d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different rules, affecting pastoralists movement",
                                                      "id": "5ace20419fe7b01d5806c214",
                                                      "_id": "6077c4efbc5f4d4df9ef24ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8473",
                                                              "_id": "6077c4efbc5f4d4df9ef24cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pastoralist in Africa",
                                                      "id": "5ace20429fe7b01d5806c215",
                                                      "_id": "6077c4efbc5f4d4df9ef24cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8474",
                                                              "_id": "6077c4efbc5f4d4df9ef24cd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8279",
                                                      "_id": "6077c4efbc5f4d4df9ef24d2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Peasants and Farmers",
                                              "id": "5ace20329fe7b01d5806bcd8",
                                              "_id": "6077c4efbc5f4d4df9ef24c3",
                                              "concepts": [
                                                  {
                                                      "name": "Life of the peasant in Britain after enclosurement",
                                                      "id": "5ace20429fe7b01d5806c218",
                                                      "_id": "6077c4efbc5f4d4df9ef24c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8475",
                                                              "_id": "6077c4efbc5f4d4df9ef24c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Whites settlers of USA & causes of Dust Bowl",
                                                      "id": "5ace20429fe7b01d5806c219",
                                                      "_id": "6077c4efbc5f4d4df9ef24c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8476",
                                                              "_id": "6077c4efbc5f4d4df9ef24c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cultivation of opium in Bengal under British rule",
                                                      "id": "5ace20429fe7b01d5806c217",
                                                      "_id": "6077c4efbc5f4d4df9ef24c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8477",
                                                              "_id": "6077c4efbc5f4d4df9ef24c5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827a",
                                                      "_id": "6077c4efbc5f4d4df9ef24ca"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "History and Sport: The Story of Cricket",
                                              "id": "5ace20329fe7b01d5806bcd3",
                                              "_id": "6077c4efbc5f4d4df9ef24bd",
                                              "concepts": [
                                                  {
                                                      "name": "Rise and growth of cricket.",
                                                      "id": "5ace20419fe7b01d5806c20e",
                                                      "_id": "6077c4efbc5f4d4df9ef24c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8478",
                                                              "_id": "6077c4efbc5f4d4df9ef24c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cricket as the symbol of nationalism",
                                                      "id": "5ace20419fe7b01d5806c20d",
                                                      "_id": "6077c4efbc5f4d4df9ef24be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8479",
                                                              "_id": "6077c4efbc5f4d4df9ef24bf"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827b",
                                                      "_id": "6077c4efbc5f4d4df9ef24c2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef24df"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Figure Formation and Analogy",
                                              "id": "5ace20309fe7b01d5806bc16",
                                              "_id": "6077c4efbc5f4d4df9ef24b8",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Formation",
                                                      "id": "5ace20389fe7b01d5806bf00",
                                                      "_id": "6077c4efbc5f4d4df9ef24b9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df45",
                                                              "_id": "6077c4efbc5f4d4df9ef24ba"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df37",
                                                      "_id": "6077c4efbc5f4d4df9ef24bb"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef24bc"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 5,
                              "startDate": "2021-05-24T00:00:00.000Z",
                              "endDate": "2021-05-30T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef234d",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Natural Resources",
                                              "id": "5ace202f9fe7b01d5806bbc2",
                                              "_id": "6077c4efbc5f4d4df9ef24a4",
                                              "concepts": [
                                                  {
                                                      "name": "Types of resources, Energy & Newly formed Resources",
                                                      "id": "5ace20339fe7b01d5806bd51",
                                                      "_id": "6077c4efbc5f4d4df9ef24b3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d4",
                                                              "_id": "6077c4efbc5f4d4df9ef24b4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Air",
                                                      "id": "5ace20339fe7b01d5806bd4b",
                                                      "_id": "6077c4efbc5f4d4df9ef24b1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d5",
                                                              "_id": "6077c4efbc5f4d4df9ef24b2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Water & Forest",
                                                      "id": "5ace20339fe7b01d5806bd52",
                                                      "_id": "6077c4efbc5f4d4df9ef24af",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d6",
                                                              "_id": "6077c4efbc5f4d4df9ef24b0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Soil",
                                                      "id": "5ace20339fe7b01d5806bd50",
                                                      "_id": "6077c4efbc5f4d4df9ef24ad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d7",
                                                              "_id": "6077c4efbc5f4d4df9ef24ae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biomass energy & Coal, Petroleum, Fossil Fuels",
                                                      "id": "5ace20339fe7b01d5806bd4d",
                                                      "_id": "6077c4efbc5f4d4df9ef24ab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d8",
                                                              "_id": "6077c4efbc5f4d4df9ef24ac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pollution",
                                                      "id": "5ace20339fe7b01d5806bd4f",
                                                      "_id": "6077c4efbc5f4d4df9ef24a9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82d9",
                                                              "_id": "6077c4efbc5f4d4df9ef24aa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conservative measures",
                                                      "id": "5ace20339fe7b01d5806bd4e",
                                                      "_id": "6077c4efbc5f4d4df9ef24a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82da",
                                                              "_id": "6077c4efbc5f4d4df9ef24a8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biogeochemical Cycles",
                                                      "id": "5ace20339fe7b01d5806bd4c",
                                                      "_id": "6077c4efbc5f4d4df9ef24a5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82db",
                                                              "_id": "6077c4efbc5f4d4df9ef24a6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820b",
                                                      "_id": "6077c4efbc5f4d4df9ef24b5"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef24b6"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Chemical Reactions",
                                              "id": "5ace202f9fe7b01d5806bbca",
                                              "_id": "6077c4efbc5f4d4df9ef2491",
                                              "concepts": [
                                                  {
                                                      "name": "Combination Reaction",
                                                      "id": "5ace20349fe7b01d5806bd91",
                                                      "_id": "6077c4efbc5f4d4df9ef24a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833b",
                                                              "_id": "6077c4efbc5f4d4df9ef24a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Decomposition Reaction",
                                                      "id": "5ace20349fe7b01d5806bd92",
                                                      "_id": "6077c4efbc5f4d4df9ef249e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833c",
                                                              "_id": "6077c4efbc5f4d4df9ef249f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Displacement Reaction- Single Displacement Reaction",
                                                      "id": "5ace20349fe7b01d5806bd94",
                                                      "_id": "6077c4efbc5f4d4df9ef249c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833d",
                                                              "_id": "6077c4efbc5f4d4df9ef249d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Displacement Reaction- Double Displacement Reaction",
                                                      "id": "5ace20349fe7b01d5806bd93",
                                                      "_id": "6077c4efbc5f4d4df9ef249a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833e",
                                                              "_id": "6077c4efbc5f4d4df9ef249b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reactivity Series",
                                                      "id": "5ace20349fe7b01d5806bd95",
                                                      "_id": "6077c4efbc5f4d4df9ef2498",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c833f",
                                                              "_id": "6077c4efbc5f4d4df9ef2499"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rusting of Iron and Rancidity",
                                                      "id": "5ace20349fe7b01d5806bd97",
                                                      "_id": "6077c4efbc5f4d4df9ef2496",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8340",
                                                              "_id": "6077c4efbc5f4d4df9ef2497"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Redox Reaction",
                                                      "id": "5ace20349fe7b01d5806bd96",
                                                      "_id": "6077c4efbc5f4d4df9ef2494",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8341",
                                                              "_id": "6077c4efbc5f4d4df9ef2495"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Balancing of Equations",
                                                      "id": "5ace20349fe7b01d5806bd90",
                                                      "_id": "6077c4efbc5f4d4df9ef2492",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8342",
                                                              "_id": "6077c4efbc5f4d4df9ef2493"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8216",
                                                      "_id": "6077c4efbc5f4d4df9ef24a2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef24a3"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Statistics",
                                              "id": "5ec644a012a5e80679ddd54b",
                                              "_id": "6077c4efbc5f4d4df9ef2480",
                                              "concepts": [
                                                  {
                                                      "name": "Median of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b845a",
                                                      "_id": "6077c4efbc5f4d4df9ef248d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db25",
                                                              "_id": "6077c4efbc5f4d4df9ef248e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation of Data: Frequency Distribution Table",
                                                      "id": "5ec64785941e1306742b8455",
                                                      "_id": "6077c4efbc5f4d4df9ef248b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db26",
                                                              "_id": "6077c4efbc5f4d4df9ef248c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mode of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b845b",
                                                      "_id": "6077c4efbc5f4d4df9ef2489",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db27",
                                                              "_id": "6077c4efbc5f4d4df9ef248a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Histograms",
                                                      "id": "5ec64785941e1306742b8457",
                                                      "_id": "6077c4efbc5f4d4df9ef2487",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db28",
                                                              "_id": "6077c4efbc5f4d4df9ef2488"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency Polygons",
                                                      "id": "5ec64785941e1306742b8458",
                                                      "_id": "6077c4efbc5f4d4df9ef2485",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db29",
                                                              "_id": "6077c4efbc5f4d4df9ef2486"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Ungrouped Data",
                                                      "id": "5ec64785941e1306742b8459",
                                                      "_id": "6077c4efbc5f4d4df9ef2483",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2a",
                                                              "_id": "6077c4efbc5f4d4df9ef2484"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bar Graphs",
                                                      "id": "5ec64785941e1306742b8456",
                                                      "_id": "6077c4efbc5f4d4df9ef2481",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2b",
                                                              "_id": "6077c4efbc5f4d4df9ef2482"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97d",
                                                      "_id": "6077c4efbc5f4d4df9ef248f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Number System",
                                              "id": "5ec644a012a5e80679ddd543",
                                              "_id": "6077c4efbc5f4d4df9ef2474",
                                              "concepts": [
                                                  {
                                                      "name": "Operations on Real Numbers",
                                                      "id": "5ec64785941e1306742b841e",
                                                      "_id": "6077c4efbc5f4d4df9ef247d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2c",
                                                              "_id": "6077c4efbc5f4d4df9ef247e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Decimal Expansion of Real Numbers",
                                                      "id": "5ec64785941e1306742b841d",
                                                      "_id": "6077c4efbc5f4d4df9ef247b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2d",
                                                              "_id": "6077c4efbc5f4d4df9ef247c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Laws of Exponents for Real Numbers",
                                                      "id": "5ec64785941e1306742b841f",
                                                      "_id": "6077c4efbc5f4d4df9ef2479",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2e",
                                                              "_id": "6077c4efbc5f4d4df9ef247a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Numbers",
                                                      "id": "5ec64785941e1306742b841b",
                                                      "_id": "6077c4efbc5f4d4df9ef2477",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db2f",
                                                              "_id": "6077c4efbc5f4d4df9ef2478"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Irrational Numbers",
                                                      "id": "5ec64785941e1306742b841c",
                                                      "_id": "6077c4efbc5f4d4df9ef2475",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db30",
                                                              "_id": "6077c4efbc5f4d4df9ef2476"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97e",
                                                      "_id": "6077c4efbc5f4d4df9ef247f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Quadrilaterals",
                                              "id": "5ec644a012a5e80679ddd548",
                                              "_id": "6077c4efbc5f4d4df9ef246a",
                                              "concepts": [
                                                  {
                                                      "name": "Types of Quadrilaterals and Angle Sum Property",
                                                      "id": "5ec64785941e1306742b843c",
                                                      "_id": "6077c4efbc5f4d4df9ef2471",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db31",
                                                              "_id": "6077c4efbc5f4d4df9ef2472"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditions for a Quadrilateral to be a Parallelogram",
                                                      "id": "5ec64785941e1306742b843e",
                                                      "_id": "6077c4efbc5f4d4df9ef246f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db32",
                                                              "_id": "6077c4efbc5f4d4df9ef2470"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mid-Point Theorem",
                                                      "id": "5ec64785941e1306742b843f",
                                                      "_id": "6077c4efbc5f4d4df9ef246d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db33",
                                                              "_id": "6077c4efbc5f4d4df9ef246e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Parallelogram",
                                                      "id": "5ec64785941e1306742b843d",
                                                      "_id": "6077c4efbc5f4d4df9ef246b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db34",
                                                              "_id": "6077c4efbc5f4d4df9ef246c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d97f",
                                                      "_id": "6077c4efbc5f4d4df9ef2473"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction To Euclid's Geometry",
                                              "id": "5ec644a012a5e80679ddd547",
                                              "_id": "6077c4efbc5f4d4df9ef2464",
                                              "concepts": [
                                                  {
                                                      "name": "Euclid's Definition and Axioms",
                                                      "id": "5ec64785941e1306742b842d",
                                                      "_id": "6077c4efbc5f4d4df9ef2467",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db35",
                                                              "_id": "6077c4efbc5f4d4df9ef2468"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid's Postulates",
                                                      "id": "5ec64785941e1306742b842e",
                                                      "_id": "6077c4efbc5f4d4df9ef2465",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db36",
                                                              "_id": "6077c4efbc5f4d4df9ef2466"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d980",
                                                      "_id": "6077c4efbc5f4d4df9ef2469"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ec644a012a5e80679ddd54c",
                                              "_id": "6077c4efbc5f4d4df9ef245e",
                                              "concepts": [
                                                  {
                                                      "name": "Probability-Experimental Approach",
                                                      "id": "5ec64785941e1306742b845c",
                                                      "_id": "6077c4efbc5f4d4df9ef2461",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db37",
                                                              "_id": "6077c4efbc5f4d4df9ef2462"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of an Event",
                                                      "id": "5ec64785941e1306742b845d",
                                                      "_id": "6077c4efbc5f4d4df9ef245f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db38",
                                                              "_id": "6077c4efbc5f4d4df9ef2460"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d981",
                                                      "_id": "6077c4efbc5f4d4df9ef2463"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials",
                                              "id": "5ec644a012a5e80679ddd544",
                                              "_id": "6077c4efbc5f4d4df9ef2450",
                                              "concepts": [
                                                  {
                                                      "name": "Factorisation of Polynomials",
                                                      "id": "5ec64785941e1306742b8423",
                                                      "_id": "6077c4efbc5f4d4df9ef245b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db39",
                                                              "_id": "6077c4efbc5f4d4df9ef245c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities - I",
                                                      "id": "5ec64785941e1306742b8424",
                                                      "_id": "6077c4efbc5f4d4df9ef2459",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3a",
                                                              "_id": "6077c4efbc5f4d4df9ef245a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials in One Variable",
                                                      "id": "5ec64785941e1306742b8420",
                                                      "_id": "6077c4efbc5f4d4df9ef2457",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3b",
                                                              "_id": "6077c4efbc5f4d4df9ef2458"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities - II",
                                                      "id": "5ec64785941e1306742b8425",
                                                      "_id": "6077c4efbc5f4d4df9ef2455",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3c",
                                                              "_id": "6077c4efbc5f4d4df9ef2456"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder Theorem",
                                                      "id": "5ec64785941e1306742b8422",
                                                      "_id": "6077c4efbc5f4d4df9ef2453",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3d",
                                                              "_id": "6077c4efbc5f4d4df9ef2454"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Zeros of a Polynomial",
                                                      "id": "5ec64785941e1306742b8421",
                                                      "_id": "6077c4efbc5f4d4df9ef2451",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3e",
                                                              "_id": "6077c4efbc5f4d4df9ef2452"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d982",
                                                      "_id": "6077c4efbc5f4d4df9ef245d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions",
                                              "id": "5ec644a012a5e80679ddd549",
                                              "_id": "6077c4efbc5f4d4df9ef2446",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of a Triangle Given its Perimeter and Its Two Base Angles",
                                                      "id": "5ec64785941e1306742b844a",
                                                      "_id": "6077c4efbc5f4d4df9ef244d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db3f",
                                                              "_id": "6077c4efbc5f4d4df9ef244e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Constructions",
                                                      "id": "5ec64785941e1306742b8447",
                                                      "_id": "6077c4efbc5f4d4df9ef244b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db40",
                                                              "_id": "6077c4efbc5f4d4df9ef244c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Given Its Base, a Base Angle and Sum of Other Two Sides",
                                                      "id": "5ec64785941e1306742b8448",
                                                      "_id": "6077c4efbc5f4d4df9ef2449",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db41",
                                                              "_id": "6077c4efbc5f4d4df9ef244a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Given Its Base, a Base Angle and Difference of Other Two Sides",
                                                      "id": "5ec64785941e1306742b8449",
                                                      "_id": "6077c4efbc5f4d4df9ef2447",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db42",
                                                              "_id": "6077c4efbc5f4d4df9ef2448"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d983",
                                                      "_id": "6077c4efbc5f4d4df9ef244f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5ec644a012a5e80679ddd545",
                                              "_id": "6077c4efbc5f4d4df9ef2440",
                                              "concepts": [
                                                  {
                                                      "name": "Plotting of Points in Cartesian Plane",
                                                      "id": "5ec64785941e1306742b8427",
                                                      "_id": "6077c4efbc5f4d4df9ef2443",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db43",
                                                              "_id": "6077c4efbc5f4d4df9ef2444"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cartesian Plane",
                                                      "id": "5ec64785941e1306742b8426",
                                                      "_id": "6077c4efbc5f4d4df9ef2441",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db44",
                                                              "_id": "6077c4efbc5f4d4df9ef2442"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d984",
                                                      "_id": "6077c4efbc5f4d4df9ef2445"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Areas and Volumes",
                                              "id": "5ec644a012a5e80679ddd54a",
                                              "_id": "6077c4efbc5f4d4df9ef242e",
                                              "concepts": [
                                                  {
                                                      "name": "Surface Area of Sphere and Hemisphere",
                                                      "id": "5ec64785941e1306742b8450",
                                                      "_id": "6077c4efbc5f4d4df9ef243d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db45",
                                                              "_id": "6077c4efbc5f4d4df9ef243e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Sphere and Hemisphere",
                                                      "id": "5ec64785941e1306742b8454",
                                                      "_id": "6077c4efbc5f4d4df9ef243b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db46",
                                                              "_id": "6077c4efbc5f4d4df9ef243c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Right Circular Cone",
                                                      "id": "5ec64785941e1306742b844f",
                                                      "_id": "6077c4efbc5f4d4df9ef2439",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db47",
                                                              "_id": "6077c4efbc5f4d4df9ef243a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Cuboid and Cube",
                                                      "id": "5ec64785941e1306742b8451",
                                                      "_id": "6077c4efbc5f4d4df9ef2437",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db48",
                                                              "_id": "6077c4efbc5f4d4df9ef2438"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Right Circular Cylinder",
                                                      "id": "5ec64785941e1306742b8452",
                                                      "_id": "6077c4efbc5f4d4df9ef2435",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db49",
                                                              "_id": "6077c4efbc5f4d4df9ef2436"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Right Circular Cylinder",
                                                      "id": "5ec64785941e1306742b844e",
                                                      "_id": "6077c4efbc5f4d4df9ef2433",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4a",
                                                              "_id": "6077c4efbc5f4d4df9ef2434"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of Cuboid and Cube",
                                                      "id": "5ec64785941e1306742b844d",
                                                      "_id": "6077c4efbc5f4d4df9ef2431",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4b",
                                                              "_id": "6077c4efbc5f4d4df9ef2432"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of Right Circular Cone",
                                                      "id": "5ec64785941e1306742b8453",
                                                      "_id": "6077c4efbc5f4d4df9ef242f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4c",
                                                              "_id": "6077c4efbc5f4d4df9ef2430"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d985",
                                                      "_id": "6077c4efbc5f4d4df9ef243f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Numbers And Sequences",
                                              "id": "5f68726f058075680d815e26",
                                              "_id": "6077c4efbc5f4d4df9ef242c",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d986",
                                                      "_id": "6077c4efbc5f4d4df9ef242d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f68726f058075680d815e29",
                                              "_id": "6077c4efbc5f4d4df9ef242a",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d987",
                                                      "_id": "6077c4efbc5f4d4df9ef242b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Mensuration",
                                              "id": "5f68726f058075680d815e2b",
                                              "_id": "6077c4efbc5f4d4df9ef2428",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d988",
                                                      "_id": "6077c4efbc5f4d4df9ef2429"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Algebra",
                                              "id": "5f68726f058075680d815e27",
                                              "_id": "6077c4efbc5f4d4df9ef2426",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d989",
                                                      "_id": "6077c4efbc5f4d4df9ef2427"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics And Probability",
                                              "id": "5f68726f058075680d815e2c",
                                              "_id": "6077c4efbc5f4d4df9ef2424",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98a",
                                                      "_id": "6077c4efbc5f4d4df9ef2425"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Relations And Functions",
                                              "id": "5f68726f058075680d815e25",
                                              "_id": "6077c4efbc5f4d4df9ef2422",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98b",
                                                      "_id": "6077c4efbc5f4d4df9ef2423"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f68726f058075680d815e28",
                                              "_id": "6077c4efbc5f4d4df9ef2420",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98d",
                                                      "_id": "6077c4efbc5f4d4df9ef2421"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Determinants",
                                              "id": "5ace20319fe7b01d5806bc85",
                                              "_id": "6077c4efbc5f4d4df9ef2418",
                                              "concepts": [
                                                  {
                                                      "name": "Cramer's rule for simultaneous linear equation, Solution of homogeneous linear equation (trivial and non-trivial solutions)",
                                                      "id": "5ace203c9fe7b01d5806c068",
                                                      "_id": "6077c4efbc5f4d4df9ef241d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4d",
                                                              "_id": "6077c4efbc5f4d4df9ef241e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Determinants and its basic question, types of determinants, Properties of determinants and multiplication of determinants",
                                                      "id": "5ace203c9fe7b01d5806c069",
                                                      "_id": "6077c4efbc5f4d4df9ef241b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4e",
                                                              "_id": "6077c4efbc5f4d4df9ef241c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Summation, differentation of determinant, Integration of determinant",
                                                      "id": "5ace203c9fe7b01d5806c06a",
                                                      "_id": "6077c4efbc5f4d4df9ef2419",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db4f",
                                                              "_id": "6077c4efbc5f4d4df9ef241a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98e",
                                                      "_id": "6077c4efbc5f4d4df9ef241f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices",
                                              "id": "5ace20319fe7b01d5806bc86",
                                              "_id": "6077c4efbc5f4d4df9ef240a",
                                              "concepts": [
                                                  {
                                                      "name": "Adjoint of a matrices",
                                                      "id": "5ace203c9fe7b01d5806c06b",
                                                      "_id": "6077c4efbc5f4d4df9ef2415",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db50",
                                                              "_id": "6077c4efbc5f4d4df9ef2416"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inverse, Inverse by row, column transformation",
                                                      "id": "5ace203c9fe7b01d5806c06c",
                                                      "_id": "6077c4efbc5f4d4df9ef2413",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db51",
                                                              "_id": "6077c4efbc5f4d4df9ef2414"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Othogonal matrices, idempotent, nilpotent, involutary, Hermittian, skew-Hermittian matrices",
                                                      "id": "5ace203c9fe7b01d5806c06d",
                                                      "_id": "6077c4efbc5f4d4df9ef2411",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db52",
                                                              "_id": "6077c4efbc5f4d4df9ef2412"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of system of linear equation",
                                                      "id": "5ace203c9fe7b01d5806c06e",
                                                      "_id": "6077c4efbc5f4d4df9ef240f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db53",
                                                              "_id": "6077c4efbc5f4d4df9ef2410"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transpose of a matrices, symmetric, skew-symmetric",
                                                      "id": "5ace203c9fe7b01d5806c06f",
                                                      "_id": "6077c4efbc5f4d4df9ef240d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db54",
                                                              "_id": "6077c4efbc5f4d4df9ef240e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of matrices, addition, subtraction, multiplication Minors, co-factors",
                                                      "id": "5ace203c9fe7b01d5806c070",
                                                      "_id": "6077c4efbc5f4d4df9ef240b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db55",
                                                              "_id": "6077c4efbc5f4d4df9ef240c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d98f",
                                                      "_id": "6077c4efbc5f4d4df9ef2417"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices",
                                              "id": "5ace20319fe7b01d5806bc87",
                                              "_id": "6077c4efbc5f4d4df9ef2402",
                                              "concepts": [
                                                  {
                                                      "name": "Conjugate of a matrix",
                                                      "id": "5ace203c9fe7b01d5806c071",
                                                      "_id": "6077c4efbc5f4d4df9ef2407",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db56",
                                                              "_id": "6077c4efbc5f4d4df9ef2408"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equality of two matrices",
                                                      "id": "5ace203c9fe7b01d5806c072",
                                                      "_id": "6077c4efbc5f4d4df9ef2405",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db57",
                                                              "_id": "6077c4efbc5f4d4df9ef2406"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Using of determinant to explain some properties of adjoint of matrix",
                                                      "id": "5ace203d9fe7b01d5806c073",
                                                      "_id": "6077c4efbc5f4d4df9ef2403",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db58",
                                                              "_id": "6077c4efbc5f4d4df9ef2404"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d990",
                                                      "_id": "6077c4efbc5f4d4df9ef2409"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Permuations & Combinations",
                                              "id": "5ace20319fe7b01d5806bc88",
                                              "_id": "6077c4efbc5f4d4df9ef2400",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d991",
                                                      "_id": "6077c4efbc5f4d4df9ef2401"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Permuations & Combinations",
                                              "id": "5ace20319fe7b01d5806bc89",
                                              "_id": "6077c4efbc5f4d4df9ef23e2",
                                              "concepts": [
                                                  {
                                                      "name": "Arrangement in groups",
                                                      "id": "5ace203d9fe7b01d5806c074",
                                                      "_id": "6077c4efbc5f4d4df9ef23fd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db59",
                                                              "_id": "6077c4efbc5f4d4df9ef23fe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "C (n, 1) + C (n, 2) + ……+C(n, n) =2^n - 1.",
                                                      "id": "5ace203d9fe7b01d5806c075",
                                                      "_id": "6077c4efbc5f4d4df9ef23fb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5a",
                                                              "_id": "6077c4efbc5f4d4df9ef23fc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circular permutation",
                                                      "id": "5ace203d9fe7b01d5806c076",
                                                      "_id": "6077c4efbc5f4d4df9ef23f9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5b",
                                                              "_id": "6077c4efbc5f4d4df9ef23fa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combination (with repetition, without repetition), restricted combination",
                                                      "id": "5ace203d9fe7b01d5806c077",
                                                      "_id": "6077c4efbc5f4d4df9ef23f7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5c",
                                                              "_id": "6077c4efbc5f4d4df9ef23f8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De-arrangement principle",
                                                      "id": "5ace203d9fe7b01d5806c078",
                                                      "_id": "6077c4efbc5f4d4df9ef23f5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5d",
                                                              "_id": "6077c4efbc5f4d4df9ef23f6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distribution of things into boxes",
                                                      "id": "5ace203d9fe7b01d5806c079",
                                                      "_id": "6077c4efbc5f4d4df9ef23f3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5e",
                                                              "_id": "6077c4efbc5f4d4df9ef23f4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Divison into groups and distribution among persons",
                                                      "id": "5ace203d9fe7b01d5806c07a",
                                                      "_id": "6077c4efbc5f4d4df9ef23f1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db5f",
                                                              "_id": "6077c4efbc5f4d4df9ef23f2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental principle of counting (multiplication, addition rule)",
                                                      "id": "5ace203d9fe7b01d5806c07b",
                                                      "_id": "6077c4efbc5f4d4df9ef23ef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db60",
                                                              "_id": "6077c4efbc5f4d4df9ef23f0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inclusion Exclusion Principle",
                                                      "id": "5ace203d9fe7b01d5806c07c",
                                                      "_id": "6077c4efbc5f4d4df9ef23ed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db61",
                                                              "_id": "6077c4efbc5f4d4df9ef23ee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear permutation (with repetition, without repetition), restricted permutation",
                                                      "id": "5ace203d9fe7b01d5806c07d",
                                                      "_id": "6077c4efbc5f4d4df9ef23eb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db62",
                                                              "_id": "6077c4efbc5f4d4df9ef23ec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multinomial theorem",
                                                      "id": "5ace203d9fe7b01d5806c07e",
                                                      "_id": "6077c4efbc5f4d4df9ef23e9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db63",
                                                              "_id": "6077c4efbc5f4d4df9ef23ea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Selection of atleast one thing and problems related to divisors, exponent of prime 'p' in n!",
                                                      "id": "5ace203d9fe7b01d5806c07f",
                                                      "_id": "6077c4efbc5f4d4df9ef23e7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db64",
                                                              "_id": "6077c4efbc5f4d4df9ef23e8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of division of a composite number",
                                                      "id": "5ace203d9fe7b01d5806c080",
                                                      "_id": "6077c4efbc5f4d4df9ef23e5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db65",
                                                              "_id": "6077c4efbc5f4d4df9ef23e6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "total no of divisors of a number",
                                                      "id": "5ace203d9fe7b01d5806c081",
                                                      "_id": "6077c4efbc5f4d4df9ef23e3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db66",
                                                              "_id": "6077c4efbc5f4d4df9ef23e4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d992",
                                                      "_id": "6077c4efbc5f4d4df9ef23ff"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef2490"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Conservation Of Momentum",
                                              "id": "5ace20329fe7b01d5806bca2",
                                              "_id": "6077c4efbc5f4d4df9ef23d1",
                                              "concepts": [
                                                  {
                                                      "name": "centre of mass",
                                                      "id": "5ace203f9fe7b01d5806c138",
                                                      "_id": "6077c4efbc5f4d4df9ef23de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd6",
                                                              "_id": "6077c4efbc5f4d4df9ef23df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "coefficient of restitution",
                                                      "id": "5ace203f9fe7b01d5806c139",
                                                      "_id": "6077c4efbc5f4d4df9ef23dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd7",
                                                              "_id": "6077c4efbc5f4d4df9ef23dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Head on collision",
                                                      "id": "5ace203f9fe7b01d5806c13a",
                                                      "_id": "6077c4efbc5f4d4df9ef23da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd8",
                                                              "_id": "6077c4efbc5f4d4df9ef23db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Impulse momentum theorem",
                                                      "id": "5ace203f9fe7b01d5806c13b",
                                                      "_id": "6077c4efbc5f4d4df9ef23d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddd9",
                                                              "_id": "6077c4efbc5f4d4df9ef23d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "motion of centre of mass",
                                                      "id": "5ace203f9fe7b01d5806c13c",
                                                      "_id": "6077c4efbc5f4d4df9ef23d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673ddda",
                                                              "_id": "6077c4efbc5f4d4df9ef23d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Oblique collision",
                                                      "id": "5ace203f9fe7b01d5806c13d",
                                                      "_id": "6077c4efbc5f4d4df9ef23d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dddb",
                                                              "_id": "6077c4efbc5f4d4df9ef23d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "variable mass system",
                                                      "id": "5ace203f9fe7b01d5806c13e",
                                                      "_id": "6077c4efbc5f4d4df9ef23d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dddc",
                                                              "_id": "6077c4efbc5f4d4df9ef23d3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd62",
                                                      "_id": "6077c4efbc5f4d4df9ef23e0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Alternating Current",
                                              "id": "5eeb5f6cbb67ca2232c1e0ae",
                                              "_id": "6077c4efbc5f4d4df9ef23cf",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae6c",
                                                      "_id": "6077c4efbc5f4d4df9ef23d0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sources of Energy",
                                              "id": "5ace20329fe7b01d5806bcb4",
                                              "_id": "6077c4efbc5f4d4df9ef23c5",
                                              "concepts": [
                                                  {
                                                      "name": "Characteristics of sources of energy & Renewable and Non-Renewable Forms of Energy",
                                                      "id": "5ace20409fe7b01d5806c1c8",
                                                      "_id": "6077c4efbc5f4d4df9ef23cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c840f",
                                                              "_id": "6077c4efbc5f4d4df9ef23cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Energy ( Solar, Wind, Hydro, Geo Thermal and Ocean Thermal)",
                                                      "id": "5ace20409fe7b01d5806c1cb",
                                                      "_id": "6077c4efbc5f4d4df9ef23ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8410",
                                                              "_id": "6077c4efbc5f4d4df9ef23cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fuels and its types & Characteristics of Fuels",
                                                      "id": "5ace20409fe7b01d5806c1c9",
                                                      "_id": "6077c4efbc5f4d4df9ef23c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8411",
                                                              "_id": "6077c4efbc5f4d4df9ef23c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fssion, Nuclear Fusion & Nuclear Reactor",
                                                      "id": "5ace20409fe7b01d5806c1ca",
                                                      "_id": "6077c4efbc5f4d4df9ef23c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8412",
                                                              "_id": "6077c4efbc5f4d4df9ef23c7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8240",
                                                      "_id": "6077c4efbc5f4d4df9ef23ce"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Atoms",
                                              "id": "5eeb5f6cbb67ca2232c1e0b3",
                                              "_id": "6077c4efbc5f4d4df9ef23c3",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae6d",
                                                      "_id": "6077c4efbc5f4d4df9ef23c4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "LIGHT",
                                              "id": "5ace20329fe7b01d5806bcb0",
                                              "_id": "6077c4efbc5f4d4df9ef23b1",
                                              "concepts": [
                                                  {
                                                      "name": "Properties of Light & Laws of Reflection",
                                                      "id": "5ace20409fe7b01d5806c1ac",
                                                      "_id": "6077c4efbc5f4d4df9ef23c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8413",
                                                              "_id": "6077c4efbc5f4d4df9ef23c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane Mirror, Rotation of mirror & Displacing object by a distance x",
                                                      "id": "5ace20409fe7b01d5806c1ab",
                                                      "_id": "6077c4efbc5f4d4df9ef23be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8414",
                                                              "_id": "6077c4efbc5f4d4df9ef23bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concave Mirror & Convex Mirror",
                                                      "id": "5ace20409fe7b01d5806c1aa",
                                                      "_id": "6077c4efbc5f4d4df9ef23bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8415",
                                                              "_id": "6077c4efbc5f4d4df9ef23bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refractive Index and velocity when medium changes & Snell's Law",
                                                      "id": "5ace20409fe7b01d5806c1ae",
                                                      "_id": "6077c4efbc5f4d4df9ef23ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8416",
                                                              "_id": "6077c4efbc5f4d4df9ef23bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Concave lens & Convex Lens",
                                                      "id": "5ace20409fe7b01d5806c1a9",
                                                      "_id": "6077c4efbc5f4d4df9ef23b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8417",
                                                              "_id": "6077c4efbc5f4d4df9ef23b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combination of lens & Power of Lens",
                                                      "id": "5ace20409fe7b01d5806c1a8",
                                                      "_id": "6077c4efbc5f4d4df9ef23b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8418",
                                                              "_id": "6077c4efbc5f4d4df9ef23b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real and Apparent Depth",
                                                      "id": "5ace20409fe7b01d5806c1ad",
                                                      "_id": "6077c4efbc5f4d4df9ef23b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8419",
                                                              "_id": "6077c4efbc5f4d4df9ef23b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Total Internal Reflection",
                                                      "id": "5ace20409fe7b01d5806c1af",
                                                      "_id": "6077c4efbc5f4d4df9ef23b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841a",
                                                              "_id": "6077c4efbc5f4d4df9ef23b3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8241",
                                                      "_id": "6077c4efbc5f4d4df9ef23c2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Kinematics",
                                              "id": "5ace20329fe7b01d5806bca4",
                                              "_id": "6077c4efbc5f4d4df9ef2397",
                                              "concepts": [
                                                  {
                                                      "name": "1-D motion with constant acceleration",
                                                      "id": "5ace203f9fe7b01d5806c144",
                                                      "_id": "6077c4efbc5f4d4df9ef23ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde2",
                                                              "_id": "6077c4efbc5f4d4df9ef23af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "1-D motion with variable acceleration",
                                                      "id": "5ace203f9fe7b01d5806c145",
                                                      "_id": "6077c4efbc5f4d4df9ef23ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde3",
                                                              "_id": "6077c4efbc5f4d4df9ef23ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Free body diagram",
                                                      "id": "5ace203f9fe7b01d5806c146",
                                                      "_id": "6077c4efbc5f4d4df9ef23aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde4",
                                                              "_id": "6077c4efbc5f4d4df9ef23ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphs in kinematics",
                                                      "id": "5ace203f9fe7b01d5806c147",
                                                      "_id": "6077c4efbc5f4d4df9ef23a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde5",
                                                              "_id": "6077c4efbc5f4d4df9ef23a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "non uniform circular motion",
                                                      "id": "5ace203f9fe7b01d5806c148",
                                                      "_id": "6077c4efbc5f4d4df9ef23a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde6",
                                                              "_id": "6077c4efbc5f4d4df9ef23a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projectile Motion on horizontal plane",
                                                      "id": "5ace203f9fe7b01d5806c149",
                                                      "_id": "6077c4efbc5f4d4df9ef23a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde7",
                                                              "_id": "6077c4efbc5f4d4df9ef23a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "projectile motion on inclined plane",
                                                      "id": "5ace203f9fe7b01d5806c14a",
                                                      "_id": "6077c4efbc5f4d4df9ef23a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde8",
                                                              "_id": "6077c4efbc5f4d4df9ef23a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rain man problem",
                                                      "id": "5ace203f9fe7b01d5806c14b",
                                                      "_id": "6077c4efbc5f4d4df9ef23a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dde9",
                                                              "_id": "6077c4efbc5f4d4df9ef23a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relative Motion",
                                                      "id": "5ace203f9fe7b01d5806c14c",
                                                      "_id": "6077c4efbc5f4d4df9ef239e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddea",
                                                              "_id": "6077c4efbc5f4d4df9ef239f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "river boat problem",
                                                      "id": "5ace203f9fe7b01d5806c14d",
                                                      "_id": "6077c4efbc5f4d4df9ef239c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddeb",
                                                              "_id": "6077c4efbc5f4d4df9ef239d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Uniform circular motion",
                                                      "id": "5ace203f9fe7b01d5806c14e",
                                                      "_id": "6077c4efbc5f4d4df9ef239a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddec",
                                                              "_id": "6077c4efbc5f4d4df9ef239b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velocity of approach and separation, minimum distance of approach",
                                                      "id": "5ace203f9fe7b01d5806c14f",
                                                      "_id": "6077c4efbc5f4d4df9ef2398",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dded",
                                                              "_id": "6077c4efbc5f4d4df9ef2399"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd64",
                                                      "_id": "6077c4efbc5f4d4df9ef23b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Nuclei",
                                              "id": "5eeb5f6cbb67ca2232c1e0b4",
                                              "_id": "6077c4efbc5f4d4df9ef2395",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f5f402c863d076508897df5",
                                                      "syllabusId": "5f76a73af29da5758fc4ae70",
                                                      "_id": "6077c4efbc5f4d4df9ef2396"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef23e1"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Data Sufficiency",
                                              "id": "5ace20309fe7b01d5806bc27",
                                              "_id": "6077c4efbc5f4d4df9ef2390",
                                              "concepts": [
                                                  {
                                                      "name": "Data Sufficiency",
                                                      "id": "5ace20389fe7b01d5806bf17",
                                                      "_id": "6077c4efbc5f4d4df9ef2391",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8430",
                                                              "_id": "6077c4efbc5f4d4df9ef2392"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c824f",
                                                      "_id": "6077c4efbc5f4d4df9ef2393"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Word Problems",
                                              "id": "5ace20319fe7b01d5806bc42",
                                              "_id": "6077c4efbc5f4d4df9ef238c",
                                              "concepts": [
                                                  {
                                                      "name": "Logical Sequence of Words",
                                                      "id": "5ace20399fe7b01d5806bf40",
                                                      "_id": "6077c4efbc5f4d4df9ef238d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8431",
                                                              "_id": "6077c4efbc5f4d4df9ef238e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8250",
                                                      "_id": "6077c4efbc5f4d4df9ef238f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ratio & Proportion",
                                              "id": "5ace20319fe7b01d5806bc3a",
                                              "_id": "6077c4efbc5f4d4df9ef2386",
                                              "concepts": [
                                                  {
                                                      "name": "Ratio & Proportion, Variation",
                                                      "id": "5ace20399fe7b01d5806bf35",
                                                      "_id": "6077c4efbc5f4d4df9ef2389",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8432",
                                                              "_id": "6077c4efbc5f4d4df9ef238a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Partnership",
                                                      "id": "5ace20399fe7b01d5806bf34",
                                                      "_id": "6077c4efbc5f4d4df9ef2387",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8433",
                                                              "_id": "6077c4efbc5f4d4df9ef2388"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8251",
                                                      "_id": "6077c4efbc5f4d4df9ef238b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Percentage",
                                              "id": "5ace20319fe7b01d5806bc35",
                                              "_id": "6077c4efbc5f4d4df9ef2382",
                                              "concepts": [
                                                  {
                                                      "name": "Percentages",
                                                      "id": "5ace20399fe7b01d5806bf27",
                                                      "_id": "6077c4efbc5f4d4df9ef2383",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8434",
                                                              "_id": "6077c4efbc5f4d4df9ef2384"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8252",
                                                      "_id": "6077c4efbc5f4d4df9ef2385"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Profit, Loss & Discount",
                                              "id": "5ace20319fe7b01d5806bc37",
                                              "_id": "6077c4efbc5f4d4df9ef237a",
                                              "concepts": [
                                                  {
                                                      "name": "Profit",
                                                      "id": "5ace20399fe7b01d5806bf2b",
                                                      "_id": "6077c4efbc5f4d4df9ef237f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8435",
                                                              "_id": "6077c4efbc5f4d4df9ef2380"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Loss",
                                                      "id": "5ace20399fe7b01d5806bf2a",
                                                      "_id": "6077c4efbc5f4d4df9ef237d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8436",
                                                              "_id": "6077c4efbc5f4d4df9ef237e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Discount",
                                                      "id": "5ace20399fe7b01d5806bf29",
                                                      "_id": "6077c4efbc5f4d4df9ef237b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8437",
                                                              "_id": "6077c4efbc5f4d4df9ef237c"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8253",
                                                      "_id": "6077c4efbc5f4d4df9ef2381"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef2394"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Clothig - A Social History",
                                              "id": "5ace20329fe7b01d5806bcd1",
                                              "_id": "6077c4efbc5f4d4df9ef2373",
                                              "concepts": [
                                                  {
                                                      "name": "Clothing pattern of France, USA after sumptuary laws",
                                                      "id": "5ace20419fe7b01d5806c209",
                                                      "_id": "6077c4efbc5f4d4df9ef2376",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847a",
                                                              "_id": "6077c4efbc5f4d4df9ef2377"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dress styles in India",
                                                      "id": "5ace20419fe7b01d5806c20a",
                                                      "_id": "6077c4efbc5f4d4df9ef2374",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847b",
                                                              "_id": "6077c4efbc5f4d4df9ef2375"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827c",
                                                      "_id": "6077c4efbc5f4d4df9ef2378"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "The Age of Industrialisation",
                                              "id": "5ace20329fe7b01d5806bcdb",
                                              "_id": "6077c4efbc5f4d4df9ef236d",
                                              "concepts": [
                                                  {
                                                      "name": "Industrialisation in Britain",
                                                      "id": "5ace20429fe7b01d5806c21f",
                                                      "_id": "6077c4efbc5f4d4df9ef2370",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847c",
                                                              "_id": "6077c4efbc5f4d4df9ef2371"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Process of industralisation in India",
                                                      "id": "5ace20429fe7b01d5806c220",
                                                      "_id": "6077c4efbc5f4d4df9ef236e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847d",
                                                              "_id": "6077c4efbc5f4d4df9ef236f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827d",
                                                      "_id": "6077c4efbc5f4d4df9ef2372"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "The Making of Global World",
                                              "id": "5ace20329fe7b01d5806bcdd",
                                              "_id": "6077c4efbc5f4d4df9ef2367",
                                              "concepts": [
                                                  {
                                                      "name": "Factors of globalisation in ancient period",
                                                      "id": "5ace20429fe7b01d5806c223",
                                                      "_id": "6077c4efbc5f4d4df9ef236a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847e",
                                                              "_id": "6077c4efbc5f4d4df9ef236b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Making of the modern world a global one",
                                                      "id": "5ace20429fe7b01d5806c224",
                                                      "_id": "6077c4efbc5f4d4df9ef2368",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c847f",
                                                              "_id": "6077c4efbc5f4d4df9ef2369"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827e",
                                                      "_id": "6077c4efbc5f4d4df9ef236c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Print Culture and the Modern World",
                                              "id": "5ace20329fe7b01d5806bcd9",
                                              "_id": "6077c4efbc5f4d4df9ef235f",
                                              "concepts": [
                                                  {
                                                      "name": "beginning of print in Asia",
                                                      "id": "5ace20429fe7b01d5806c21a",
                                                      "_id": "6077c4efbc5f4d4df9ef2364",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8480",
                                                              "_id": "6077c4efbc5f4d4df9ef2365"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Spread of print culture in Europe",
                                                      "id": "5ace20429fe7b01d5806c21c",
                                                      "_id": "6077c4efbc5f4d4df9ef2362",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8481",
                                                              "_id": "6077c4efbc5f4d4df9ef2363"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Print revolution in India",
                                                      "id": "5ace20429fe7b01d5806c21b",
                                                      "_id": "6077c4efbc5f4d4df9ef2360",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8482",
                                                              "_id": "6077c4efbc5f4d4df9ef2361"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c827f",
                                                      "_id": "6077c4efbc5f4d4df9ef2366"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Novels, Society and History",
                                              "id": "5ace20329fe7b01d5806bcd6",
                                              "_id": "6077c4efbc5f4d4df9ef2359",
                                              "concepts": [
                                                  {
                                                      "name": "Beginning of Novels in Europe",
                                                      "id": "5ace20419fe7b01d5806c212",
                                                      "_id": "6077c4efbc5f4d4df9ef235c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8483",
                                                              "_id": "6077c4efbc5f4d4df9ef235d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "History of writing of novels in India",
                                                      "id": "5ace20419fe7b01d5806c213",
                                                      "_id": "6077c4efbc5f4d4df9ef235a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8484",
                                                              "_id": "6077c4efbc5f4d4df9ef235b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8280",
                                                      "_id": "6077c4efbc5f4d4df9ef235e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work, Life and Leisure",
                                              "id": "5ace20329fe7b01d5806bce0",
                                              "_id": "6077c4efbc5f4d4df9ef2353",
                                              "concepts": [
                                                  {
                                                      "name": "Process of urbanisation and its impact in England",
                                                      "id": "5ace20429fe7b01d5806c229",
                                                      "_id": "6077c4efbc5f4d4df9ef2356",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8485",
                                                              "_id": "6077c4efbc5f4d4df9ef2357"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Urbanisation in Bombay and its impacts",
                                                      "id": "5ace20429fe7b01d5806c22a",
                                                      "_id": "6077c4efbc5f4d4df9ef2354",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8486",
                                                              "_id": "6077c4efbc5f4d4df9ef2355"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8281",
                                                      "_id": "6077c4efbc5f4d4df9ef2358"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef2379"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Figure Matrix",
                                              "id": "5ace20309fe7b01d5806bc17",
                                              "_id": "6077c4efbc5f4d4df9ef234e",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Matrix",
                                                      "id": "5ace20389fe7b01d5806bf01",
                                                      "_id": "6077c4efbc5f4d4df9ef234f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df46",
                                                              "_id": "6077c4efbc5f4d4df9ef2350"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df38",
                                                      "_id": "6077c4efbc5f4d4df9ef2351"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef2352"
                                          }
                                      ]
                                  }
                              ]
                          }
                      ],
                      "subjects": [
                          {
                              "name": "Biology",
                              "id": "5ace202e9fe7b01d5806bb89",
                              "chapterCount": 5
                          },
                          {
                              "name": "Chemistry",
                              "id": "5ace202e9fe7b01d5806bb8a",
                              "chapterCount": 5
                          },
                          {
                              "name": "Mathematics",
                              "id": "5ace202e9fe7b01d5806bb8e",
                              "chapterCount": 89
                          },
                          {
                              "name": "Physics",
                              "id": "5ace202e9fe7b01d5806bb8f",
                              "chapterCount": 31
                          },
                          {
                              "name": "MAT",
                              "id": "5ace202e9fe7b01d5806bb8d",
                              "chapterCount": 17
                          },
                          {
                              "name": "Social Science",
                              "id": "5ace202e9fe7b01d5806bb90",
                              "chapterCount": 26
                          },
                          {
                              "name": "LOGICAL REASONING",
                              "id": "5ace202e9fe7b01d5806bb8c",
                              "chapterCount": 5
                          }
                      ],
                      "isRevision": false,
                      "description": ""
                  },
                  {
                      "name": "phase 2",
                      "startDate": "2021-06-03T00:00:00.000Z",
                      "endDate": "2021-07-21T00:00:00.000Z",
                      "_id": "6077c4eebc5f4d4df9ef1b45",
                      "milestoneTests": [],
                      "weeks": [
                          {
                              "weekNo": 6,
                              "startDate": "2021-06-03T00:00:00.000Z",
                              "endDate": "2021-06-09T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef2252",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Improvement in Food Resources",
                                              "id": "5ace202f9fe7b01d5806bbbf",
                                              "_id": "6077c4efbc5f4d4df9ef233b",
                                              "concepts": [
                                                  {
                                                      "name": "Crop variety improvement & hybrid vigour",
                                                      "id": "5ace20339fe7b01d5806bd2a",
                                                      "_id": "6077c4efbc5f4d4df9ef2348",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82dc",
                                                              "_id": "6077c4efbc5f4d4df9ef2349"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nutrients",
                                                      "id": "5ace20339fe7b01d5806bd2e",
                                                      "_id": "6077c4efbc5f4d4df9ef2346",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82dd",
                                                              "_id": "6077c4efbc5f4d4df9ef2347"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fertilizers & Manures",
                                                      "id": "5ace20339fe7b01d5806bd2c",
                                                      "_id": "6077c4efbc5f4d4df9ef2344",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82de",
                                                              "_id": "6077c4efbc5f4d4df9ef2345"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Irrigation methods",
                                                      "id": "5ace20339fe7b01d5806bd2d",
                                                      "_id": "6077c4efbc5f4d4df9ef2342",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82df",
                                                              "_id": "6077c4efbc5f4d4df9ef2343"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cropping pattern",
                                                      "id": "5ace20339fe7b01d5806bd2b",
                                                      "_id": "6077c4efbc5f4d4df9ef2340",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e0",
                                                              "_id": "6077c4efbc5f4d4df9ef2341"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Crop protection management",
                                                      "id": "5ace20339fe7b01d5806bd29",
                                                      "_id": "6077c4efbc5f4d4df9ef233e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e1",
                                                              "_id": "6077c4efbc5f4d4df9ef233f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Animal husbandry",
                                                      "id": "5ace20339fe7b01d5806bd28",
                                                      "_id": "6077c4efbc5f4d4df9ef233c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e2",
                                                              "_id": "6077c4efbc5f4d4df9ef233d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820c",
                                                      "_id": "6077c4efbc5f4d4df9ef234a"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef234b"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Acid Base And Salts",
                                              "id": "5ace202f9fe7b01d5806bbc6",
                                              "_id": "6077c4efbc5f4d4df9ef2328",
                                              "concepts": [
                                                  {
                                                      "name": "Definition of Acid And Base",
                                                      "id": "5ace20339fe7b01d5806bd6d",
                                                      "_id": "6077c4efbc5f4d4df9ef2337",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8343",
                                                              "_id": "6077c4efbc5f4d4df9ef2338"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reaction Of Acid With Metals, Oxygen, Water and Salts",
                                                      "id": "5ace20339fe7b01d5806bd70",
                                                      "_id": "6077c4efbc5f4d4df9ef2335",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8344",
                                                              "_id": "6077c4efbc5f4d4df9ef2336"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reactions Of Bases",
                                                      "id": "5ace20339fe7b01d5806bd71",
                                                      "_id": "6077c4efbc5f4d4df9ef2333",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8345",
                                                              "_id": "6077c4efbc5f4d4df9ef2334"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories of acids & bases - Arrhenius concept",
                                                      "id": "5ace20339fe7b01d5806bd72",
                                                      "_id": "6077c4efbc5f4d4df9ef2331",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8346",
                                                              "_id": "6077c4efbc5f4d4df9ef2332"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories of acids & bases - Bronsted Lowry concept",
                                                      "id": "5ace20339fe7b01d5806bd73",
                                                      "_id": "6077c4efbc5f4d4df9ef232f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8347",
                                                              "_id": "6077c4efbc5f4d4df9ef2330"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories of acids & bases - Lewis concept",
                                                      "id": "5ace20349fe7b01d5806bd74",
                                                      "_id": "6077c4efbc5f4d4df9ef232d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8348",
                                                              "_id": "6077c4efbc5f4d4df9ef232e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "pH Scale",
                                                      "id": "5ace20339fe7b01d5806bd6f",
                                                      "_id": "6077c4efbc5f4d4df9ef232b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8349",
                                                              "_id": "6077c4efbc5f4d4df9ef232c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different types of Salts",
                                                      "id": "5ace20339fe7b01d5806bd6e",
                                                      "_id": "6077c4efbc5f4d4df9ef2329",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834a",
                                                              "_id": "6077c4efbc5f4d4df9ef232a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8217",
                                                      "_id": "6077c4efbc5f4d4df9ef2339"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef233a"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Probability",
                                              "id": "5ace20319fe7b01d5806bc8a",
                                              "_id": "6077c4efbc5f4d4df9ef2325",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d993",
                                                      "_id": "6077c4efbc5f4d4df9ef2326"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ace20319fe7b01d5806bc8b",
                                              "_id": "6077c4efbc5f4d4df9ef22ff",
                                              "concepts": [
                                                  {
                                                      "name": "Addition theorem of probability",
                                                      "id": "5ace203d9fe7b01d5806c082",
                                                      "_id": "6077c4efbc5f4d4df9ef2322",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db67",
                                                              "_id": "6077c4efbc5f4d4df9ef2323"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Addition theorem of probability",
                                                      "id": "5ace203d9fe7b01d5806c083",
                                                      "_id": "6077c4efbc5f4d4df9ef2320",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db68",
                                                              "_id": "6077c4efbc5f4d4df9ef2321"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial theorem on probability, Binomial distribution",
                                                      "id": "5ace203d9fe7b01d5806c084",
                                                      "_id": "6077c4efbc5f4d4df9ef231e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db69",
                                                              "_id": "6077c4efbc5f4d4df9ef231f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classical definition of probability",
                                                      "id": "5ace203d9fe7b01d5806c085",
                                                      "_id": "6077c4efbc5f4d4df9ef231c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6a",
                                                              "_id": "6077c4efbc5f4d4df9ef231d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exhaustive events",
                                                      "id": "5ace203d9fe7b01d5806c086",
                                                      "_id": "6077c4efbc5f4d4df9ef231a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6b",
                                                              "_id": "6077c4efbc5f4d4df9ef231b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Multinomial theorem on probablity",
                                                      "id": "5ace203d9fe7b01d5806c087",
                                                      "_id": "6077c4efbc5f4d4df9ef2318",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6c",
                                                              "_id": "6077c4efbc5f4d4df9ef2319"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mutually exclusive events",
                                                      "id": "5ace203d9fe7b01d5806c088",
                                                      "_id": "6077c4efbc5f4d4df9ef2316",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6d",
                                                              "_id": "6077c4efbc5f4d4df9ef2317"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Bay`s theorem",
                                                      "id": "5ace203d9fe7b01d5806c089",
                                                      "_id": "6077c4efbc5f4d4df9ef2314",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6e",
                                                              "_id": "6077c4efbc5f4d4df9ef2315"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Compound probablity",
                                                      "id": "5ace203d9fe7b01d5806c08a",
                                                      "_id": "6077c4efbc5f4d4df9ef2312",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db6f",
                                                              "_id": "6077c4efbc5f4d4df9ef2313"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Conditional probablity",
                                                      "id": "5ace203d9fe7b01d5806c08b",
                                                      "_id": "6077c4efbc5f4d4df9ef2310",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db70",
                                                              "_id": "6077c4efbc5f4d4df9ef2311"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on equally likely events,",
                                                      "id": "5ace203d9fe7b01d5806c08c",
                                                      "_id": "6077c4efbc5f4d4df9ef230e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db71",
                                                              "_id": "6077c4efbc5f4d4df9ef230f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on independent events,",
                                                      "id": "5ace203d9fe7b01d5806c08d",
                                                      "_id": "6077c4efbc5f4d4df9ef230c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db72",
                                                              "_id": "6077c4efbc5f4d4df9ef230d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on mixed events",
                                                      "id": "5ace203d9fe7b01d5806c08e",
                                                      "_id": "6077c4efbc5f4d4df9ef230a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db73",
                                                              "_id": "6077c4efbc5f4d4df9ef230b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on mutually exclusive events, exhaustive events,",
                                                      "id": "5ace203d9fe7b01d5806c08f",
                                                      "_id": "6077c4efbc5f4d4df9ef2308",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db74",
                                                              "_id": "6077c4efbc5f4d4df9ef2309"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on repeated trials",
                                                      "id": "5ace203d9fe7b01d5806c090",
                                                      "_id": "6077c4efbc5f4d4df9ef2306",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db75",
                                                              "_id": "6077c4efbc5f4d4df9ef2307"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Total probability theorem",
                                                      "id": "5ace203d9fe7b01d5806c091",
                                                      "_id": "6077c4efbc5f4d4df9ef2304",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db76",
                                                              "_id": "6077c4efbc5f4d4df9ef2305"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on sample space, classsical definition of probability, complementary events",
                                                      "id": "5ace203d9fe7b01d5806c092",
                                                      "_id": "6077c4efbc5f4d4df9ef2302",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db77",
                                                              "_id": "6077c4efbc5f4d4df9ef2303"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random variable",
                                                      "id": "5ace203d9fe7b01d5806c093",
                                                      "_id": "6077c4efbc5f4d4df9ef2300",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db78",
                                                              "_id": "6077c4efbc5f4d4df9ef2301"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d994",
                                                      "_id": "6077c4efbc5f4d4df9ef2324"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5ace20319fe7b01d5806bc8c",
                                              "_id": "6077c4efbc5f4d4df9ef22f9",
                                              "concepts": [
                                                  {
                                                      "name": "Calculation of mean, median, mode of grouped and ungrouped data",
                                                      "id": "5ace203d9fe7b01d5806c094",
                                                      "_id": "6077c4efbc5f4d4df9ef22fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db79",
                                                              "_id": "6077c4efbc5f4d4df9ef22fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Calculation of standard deviation, variance and mean deviation for grouped and ungrouped data",
                                                      "id": "5ace203d9fe7b01d5806c095",
                                                      "_id": "6077c4efbc5f4d4df9ef22fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7a",
                                                              "_id": "6077c4efbc5f4d4df9ef22fb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d995",
                                                      "_id": "6077c4efbc5f4d4df9ef22fe"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Heights & Distances",
                                              "id": "5ace20319fe7b01d5806bc8d",
                                              "_id": "6077c4efbc5f4d4df9ef22f1",
                                              "concepts": [
                                                  {
                                                      "name": "Problems based on angle of elevation, angle of depression",
                                                      "id": "5ace203d9fe7b01d5806c096",
                                                      "_id": "6077c4efbc5f4d4df9ef22f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7b",
                                                              "_id": "6077c4efbc5f4d4df9ef22f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems related to 2-Dimensional",
                                                      "id": "5ace203d9fe7b01d5806c097",
                                                      "_id": "6077c4efbc5f4d4df9ef22f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7c",
                                                              "_id": "6077c4efbc5f4d4df9ef22f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems related to 3-Dimensional",
                                                      "id": "5ace203d9fe7b01d5806c098",
                                                      "_id": "6077c4efbc5f4d4df9ef22f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7d",
                                                              "_id": "6077c4efbc5f4d4df9ef22f3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d996",
                                                      "_id": "6077c4efbc5f4d4df9ef22f8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometry",
                                              "id": "5ace20319fe7b01d5806bc8e",
                                              "_id": "6077c4efbc5f4d4df9ef22e9",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Maximum and minimum values",
                                                      "id": "5ace203d9fe7b01d5806c099",
                                                      "_id": "6077c4efbc5f4d4df9ef22ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7e",
                                                              "_id": "6077c4efbc5f4d4df9ef22ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on -Definition of inverse functions, Domain and Range, Graphs of inverse functions, properties of inverse functions",
                                                      "id": "5ace203d9fe7b01d5806c09a",
                                                      "_id": "6077c4efbc5f4d4df9ef22ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db7f",
                                                              "_id": "6077c4efbc5f4d4df9ef22ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum of series, Solution of Inverse trigonometric Equations",
                                                      "id": "5ace203d9fe7b01d5806c09b",
                                                      "_id": "6077c4efbc5f4d4df9ef22ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db80",
                                                              "_id": "6077c4efbc5f4d4df9ef22eb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d997",
                                                      "_id": "6077c4efbc5f4d4df9ef22f0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometry /Inverse Circular Function",
                                              "id": "5ace20319fe7b01d5806bc8f",
                                              "_id": "6077c4efbc5f4d4df9ef22dd",
                                              "concepts": [
                                                  {
                                                      "name": "Conversion of one ICF to other",
                                                      "id": "5ace203d9fe7b01d5806c09c",
                                                      "_id": "6077c4efbc5f4d4df9ef22e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db81",
                                                              "_id": "6077c4efbc5f4d4df9ef22e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Inverse circular Function - domain & range",
                                                      "id": "5ace203d9fe7b01d5806c09d",
                                                      "_id": "6077c4efbc5f4d4df9ef22e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db82",
                                                              "_id": "6077c4efbc5f4d4df9ef22e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "problems based on inverse trigonometric function of trigonometric functions",
                                                      "id": "5ace203d9fe7b01d5806c09e",
                                                      "_id": "6077c4efbc5f4d4df9ef22e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db83",
                                                              "_id": "6077c4efbc5f4d4df9ef22e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "problems based on trigonometric functions of inverse trigonometric function",
                                                      "id": "5ace203d9fe7b01d5806c09f",
                                                      "_id": "6077c4efbc5f4d4df9ef22e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db84",
                                                              "_id": "6077c4efbc5f4d4df9ef22e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "sum & Difference of Two or more ICFs",
                                                      "id": "5ace203d9fe7b01d5806c0a0",
                                                      "_id": "6077c4efbc5f4d4df9ef22de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db85",
                                                              "_id": "6077c4efbc5f4d4df9ef22df"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d998",
                                                      "_id": "6077c4efbc5f4d4df9ef22e8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Solution of Triangle",
                                              "id": "5ace20319fe7b01d5806bc90",
                                              "_id": "6077c4efbc5f4d4df9ef22db",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d999",
                                                      "_id": "6077c4efbc5f4d4df9ef22dc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Solution of Triangle",
                                              "id": "5ace20319fe7b01d5806bc91",
                                              "_id": "6077c4efbc5f4d4df9ef22c1",
                                              "concepts": [
                                                  {
                                                      "name": "Circles circumscribing or inscribing a regular Polygon",
                                                      "id": "5ace203d9fe7b01d5806c0a1",
                                                      "_id": "6077c4efbc5f4d4df9ef22d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db86",
                                                              "_id": "6077c4efbc5f4d4df9ef22d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circles Connected with a Triangle - Circumcircle, Incircle, Escribed Circles",
                                                      "id": "5ace203d9fe7b01d5806c0a2",
                                                      "_id": "6077c4efbc5f4d4df9ef22d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db87",
                                                              "_id": "6077c4efbc5f4d4df9ef22d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "cyclic quadrilaterals",
                                                      "id": "5ace203d9fe7b01d5806c0a3",
                                                      "_id": "6077c4efbc5f4d4df9ef22d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db88",
                                                              "_id": "6077c4efbc5f4d4df9ef22d5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance of Circumcentre, incentre, orthocentre, centroid and ex-centre from the sides and vertices of the triangle, Distance between circumcentre and orthocentre, circmucentre and incentre, circum centre and excentre, Apolloneus theorem, length of median",
                                                      "id": "5ace203d9fe7b01d5806c0a4",
                                                      "_id": "6077c4efbc5f4d4df9ef22d2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db89",
                                                              "_id": "6077c4efbc5f4d4df9ef22d3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Half angle formula",
                                                      "id": "5ace203d9fe7b01d5806c0a5",
                                                      "_id": "6077c4efbc5f4d4df9ef22d0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8a",
                                                              "_id": "6077c4efbc5f4d4df9ef22d1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on Heron's formula, Area of triangle",
                                                      "id": "5ace203d9fe7b01d5806c0a6",
                                                      "_id": "6077c4efbc5f4d4df9ef22ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8b",
                                                              "_id": "6077c4efbc5f4d4df9ef22cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problem based on m-n theorem",
                                                      "id": "5ace203d9fe7b01d5806c0a7",
                                                      "_id": "6077c4efbc5f4d4df9ef22cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8c",
                                                              "_id": "6077c4efbc5f4d4df9ef22cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Projection formula, Napier's Analogy",
                                                      "id": "5ace203d9fe7b01d5806c0a8",
                                                      "_id": "6077c4efbc5f4d4df9ef22ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8d",
                                                              "_id": "6077c4efbc5f4d4df9ef22cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sine Rule, Cosine Rule",
                                                      "id": "5ace203d9fe7b01d5806c0a9",
                                                      "_id": "6077c4efbc5f4d4df9ef22c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8e",
                                                              "_id": "6077c4efbc5f4d4df9ef22c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of Triangle - Two angles and included side are given",
                                                      "id": "5ace203d9fe7b01d5806c0aa",
                                                      "_id": "6077c4efbc5f4d4df9ef22c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db8f",
                                                              "_id": "6077c4efbc5f4d4df9ef22c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "solution of Triangle - Two sides and included angle are given",
                                                      "id": "5ace203d9fe7b01d5806c0ab",
                                                      "_id": "6077c4efbc5f4d4df9ef22c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db90",
                                                              "_id": "6077c4efbc5f4d4df9ef22c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Triangle including ambiguous cases",
                                                      "id": "5ace203d9fe7b01d5806c0ac",
                                                      "_id": "6077c4efbc5f4d4df9ef22c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db91",
                                                              "_id": "6077c4efbc5f4d4df9ef22c3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99a",
                                                      "_id": "6077c4efbc5f4d4df9ef22da"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometric Equations",
                                              "id": "5ace20319fe7b01d5806bc92",
                                              "_id": "6077c4efbc5f4d4df9ef22bf",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99b",
                                                      "_id": "6077c4efbc5f4d4df9ef22c0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometric Equations",
                                              "id": "5ace20329fe7b01d5806bc93",
                                              "_id": "6077c4efbc5f4d4df9ef22ad",
                                              "concepts": [
                                                  {
                                                      "name": "Inequalities, Problems based on extreme values",
                                                      "id": "5ace203d9fe7b01d5806c0ad",
                                                      "_id": "6077c4efbc5f4d4df9ef22bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db92",
                                                              "_id": "6077c4efbc5f4d4df9ef22bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Simultaneous trigonometric equation - in one variable",
                                                      "id": "5ace203d9fe7b01d5806c0ae",
                                                      "_id": "6077c4efbc5f4d4df9ef22ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db93",
                                                              "_id": "6077c4efbc5f4d4df9ef22bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Simultaneous trigonometric equation - in two variable",
                                                      "id": "5ace203d9fe7b01d5806c0af",
                                                      "_id": "6077c4efbc5f4d4df9ef22b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db94",
                                                              "_id": "6077c4efbc5f4d4df9ef22b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - based on extreme values of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0b0",
                                                      "_id": "6077c4efbc5f4d4df9ef22b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db95",
                                                              "_id": "6077c4efbc5f4d4df9ef22b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - General Solution",
                                                      "id": "5ace203d9fe7b01d5806c0b1",
                                                      "_id": "6077c4efbc5f4d4df9ef22b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db96",
                                                              "_id": "6077c4efbc5f4d4df9ef22b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - in a given Interval",
                                                      "id": "5ace203d9fe7b01d5806c0b2",
                                                      "_id": "6077c4efbc5f4d4df9ef22b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db97",
                                                              "_id": "6077c4efbc5f4d4df9ef22b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution of Trigonometric Equations - Priciple values",
                                                      "id": "5ace203d9fe7b01d5806c0b3",
                                                      "_id": "6077c4efbc5f4d4df9ef22b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db98",
                                                              "_id": "6077c4efbc5f4d4df9ef22b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Inequation",
                                                      "id": "5ace203d9fe7b01d5806c0b4",
                                                      "_id": "6077c4efbc5f4d4df9ef22ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db99",
                                                              "_id": "6077c4efbc5f4d4df9ef22af"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99c",
                                                      "_id": "6077c4efbc5f4d4df9ef22be"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef2327"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "HUMAN EYE",
                                              "id": "5ace20329fe7b01d5806bcae",
                                              "_id": "6077c4efbc5f4d4df9ef22a0",
                                              "concepts": [
                                                  {
                                                      "name": "Human Eye & Defects of Vision",
                                                      "id": "5ace20409fe7b01d5806c19d",
                                                      "_id": "6077c4efbc5f4d4df9ef22a9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841b",
                                                              "_id": "6077c4efbc5f4d4df9ef22aa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dispersion & Prism",
                                                      "id": "5ace20409fe7b01d5806c19c",
                                                      "_id": "6077c4efbc5f4d4df9ef22a7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841c",
                                                              "_id": "6077c4efbc5f4d4df9ef22a8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atmospheric Refraction & Scattering of Light",
                                                      "id": "5ace20409fe7b01d5806c19b",
                                                      "_id": "6077c4efbc5f4d4df9ef22a5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841d",
                                                              "_id": "6077c4efbc5f4d4df9ef22a6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mirror Formula & Lens Formula",
                                                      "id": "5ace20409fe7b01d5806c19e",
                                                      "_id": "6077c4efbc5f4d4df9ef22a3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841e",
                                                              "_id": "6077c4efbc5f4d4df9ef22a4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5ace20409fe7b01d5806c19f",
                                                      "_id": "6077c4efbc5f4d4df9ef22a1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c841f",
                                                              "_id": "6077c4efbc5f4d4df9ef22a2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8242",
                                                      "_id": "6077c4efbc5f4d4df9ef22ab"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Rotational Motion",
                                              "id": "5ace20329fe7b01d5806bca6",
                                              "_id": "6077c4efbc5f4d4df9ef2286",
                                              "concepts": [
                                                  {
                                                      "name": "angular momentum and conservation of angular momentum",
                                                      "id": "5ace203f9fe7b01d5806c15a",
                                                      "_id": "6077c4efbc5f4d4df9ef229d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf8",
                                                              "_id": "6077c4efbc5f4d4df9ef229e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Hinge reaction",
                                                      "id": "5ace203f9fe7b01d5806c15b",
                                                      "_id": "6077c4efbc5f4d4df9ef229b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddf9",
                                                              "_id": "6077c4efbc5f4d4df9ef229c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Instantaneous axis of rotation",
                                                      "id": "5ace203f9fe7b01d5806c15c",
                                                      "_id": "6077c4efbc5f4d4df9ef2299",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfa",
                                                              "_id": "6077c4efbc5f4d4df9ef229a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "kinetic energy of a body performing combined motion",
                                                      "id": "5ace203f9fe7b01d5806c15d",
                                                      "_id": "6077c4efbc5f4d4df9ef2297",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfb",
                                                              "_id": "6077c4efbc5f4d4df9ef2298"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment of inertia of discrete and distributed mass",
                                                      "id": "5ace203f9fe7b01d5806c15e",
                                                      "_id": "6077c4efbc5f4d4df9ef2295",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfc",
                                                              "_id": "6077c4efbc5f4d4df9ef2296"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parallel and perpendicular axis theorem",
                                                      "id": "5ace203f9fe7b01d5806c15f",
                                                      "_id": "6077c4efbc5f4d4df9ef2293",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfd",
                                                              "_id": "6077c4efbc5f4d4df9ef2294"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pure Rotation Motion",
                                                      "id": "5ace203f9fe7b01d5806c160",
                                                      "_id": "6077c4efbc5f4d4df9ef2291",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddfe",
                                                              "_id": "6077c4efbc5f4d4df9ef2292"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rolling on horizontal surface",
                                                      "id": "5ace203f9fe7b01d5806c161",
                                                      "_id": "6077c4efbc5f4d4df9ef228f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ddff",
                                                              "_id": "6077c4efbc5f4d4df9ef2290"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "rolling on inclined plane and toppling",
                                                      "id": "5ace203f9fe7b01d5806c162",
                                                      "_id": "6077c4efbc5f4d4df9ef228d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de00",
                                                              "_id": "6077c4efbc5f4d4df9ef228e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "torque",
                                                      "id": "5ace203f9fe7b01d5806c163",
                                                      "_id": "6077c4efbc5f4d4df9ef228b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de01",
                                                              "_id": "6077c4efbc5f4d4df9ef228c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "velocity and acceleration of a body performing combined motion",
                                                      "id": "5ace203f9fe7b01d5806c164",
                                                      "_id": "6077c4efbc5f4d4df9ef2289",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de02",
                                                              "_id": "6077c4efbc5f4d4df9ef228a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem in rotation motion",
                                                      "id": "5ace203f9fe7b01d5806c165",
                                                      "_id": "6077c4efbc5f4d4df9ef2287",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de03",
                                                              "_id": "6077c4efbc5f4d4df9ef2288"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd66",
                                                      "_id": "6077c4efbc5f4d4df9ef229f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work Power and Energy",
                                              "id": "5ace20329fe7b01d5806bca7",
                                              "_id": "6077c4efbc5f4d4df9ef2276",
                                              "concepts": [
                                                  {
                                                      "name": "Conservation of mechanical energy and Conservative forces",
                                                      "id": "5ace203f9fe7b01d5806c166",
                                                      "_id": "6077c4efbc5f4d4df9ef2283",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de04",
                                                              "_id": "6077c4efbc5f4d4df9ef2284"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Motion in vertical circle",
                                                      "id": "5ace203f9fe7b01d5806c167",
                                                      "_id": "6077c4efbc5f4d4df9ef2281",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de05",
                                                              "_id": "6077c4efbc5f4d4df9ef2282"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Potential Energy",
                                                      "id": "5ace203f9fe7b01d5806c168",
                                                      "_id": "6077c4efbc5f4d4df9ef227f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de06",
                                                              "_id": "6077c4efbc5f4d4df9ef2280"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power",
                                                      "id": "5ace203f9fe7b01d5806c169",
                                                      "_id": "6077c4efbc5f4d4df9ef227d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de07",
                                                              "_id": "6077c4efbc5f4d4df9ef227e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work",
                                                      "id": "5ace203f9fe7b01d5806c16a",
                                                      "_id": "6077c4efbc5f4d4df9ef227b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de08",
                                                              "_id": "6077c4efbc5f4d4df9ef227c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work energy theorem for a single particle system",
                                                      "id": "5ace203f9fe7b01d5806c16b",
                                                      "_id": "6077c4efbc5f4d4df9ef2279",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de09",
                                                              "_id": "6077c4efbc5f4d4df9ef227a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "work energy theorem for multiple particle system",
                                                      "id": "5ace203f9fe7b01d5806c16c",
                                                      "_id": "6077c4efbc5f4d4df9ef2277",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0a",
                                                              "_id": "6077c4efbc5f4d4df9ef2278"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd67",
                                                      "_id": "6077c4efbc5f4d4df9ef2285"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Modern Physics",
                                              "id": "5ace20329fe7b01d5806bca8",
                                              "_id": "6077c4efbc5f4d4df9ef2274",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd68",
                                                      "_id": "6077c4efbc5f4d4df9ef2275"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef22ac"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Mixtures, Alligations & Averages",
                                              "id": "5ace20319fe7b01d5806bc32",
                                              "_id": "6077c4efbc5f4d4df9ef226d",
                                              "concepts": [
                                                  {
                                                      "name": "Alligations & Mixtures",
                                                      "id": "5ace20389fe7b01d5806bf22",
                                                      "_id": "6077c4efbc5f4d4df9ef2270",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8438",
                                                              "_id": "6077c4efbc5f4d4df9ef2271"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Averages",
                                                      "id": "5ace20399fe7b01d5806bf23",
                                                      "_id": "6077c4efbc5f4d4df9ef226e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8439",
                                                              "_id": "6077c4efbc5f4d4df9ef226f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8254",
                                                      "_id": "6077c4efbc5f4d4df9ef2272"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Clocks",
                                              "id": "5ace20309fe7b01d5806bc23",
                                              "_id": "6077c4efbc5f4d4df9ef2269",
                                              "concepts": [
                                                  {
                                                      "name": "Clocks",
                                                      "id": "5ace20389fe7b01d5806bf11",
                                                      "_id": "6077c4efbc5f4d4df9ef226a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843a",
                                                              "_id": "6077c4efbc5f4d4df9ef226b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8255",
                                                      "_id": "6077c4efbc5f4d4df9ef226c"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef2273"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "The Rise of Nationalism in Europe",
                                              "id": "5ace20329fe7b01d5806bcdf",
                                              "_id": "6077c4efbc5f4d4df9ef2262",
                                              "concepts": [
                                                  {
                                                      "name": "French Revolution and its impact",
                                                      "id": "5ace20429fe7b01d5806c227",
                                                      "_id": "6077c4efbc5f4d4df9ef2265",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8487",
                                                              "_id": "6077c4efbc5f4d4df9ef2266"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Unification of Germany, Italy and UK",
                                                      "id": "5ace20429fe7b01d5806c228",
                                                      "_id": "6077c4efbc5f4d4df9ef2263",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8488",
                                                              "_id": "6077c4efbc5f4d4df9ef2264"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8282",
                                                      "_id": "6077c4efbc5f4d4df9ef2267"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "The Naitonal Movement in Indo-China",
                                              "id": "5ace20329fe7b01d5806bcde",
                                              "_id": "6077c4efbc5f4d4df9ef225c",
                                              "concepts": [
                                                  {
                                                      "name": "Occupation of Vietnam by French",
                                                      "id": "5ace20429fe7b01d5806c225",
                                                      "_id": "6077c4efbc5f4d4df9ef225f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8489",
                                                              "_id": "6077c4efbc5f4d4df9ef2260"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vietnamese war with France and USA",
                                                      "id": "5ace20429fe7b01d5806c226",
                                                      "_id": "6077c4efbc5f4d4df9ef225d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848a",
                                                              "_id": "6077c4efbc5f4d4df9ef225e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8283",
                                                      "_id": "6077c4efbc5f4d4df9ef2261"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Nationalism in India",
                                              "id": "5ace20329fe7b01d5806bcd4",
                                              "_id": "6077c4efbc5f4d4df9ef2258",
                                              "concepts": [
                                                  {
                                                      "name": "Indian nationalism under congress before Gandhi\nIndian nationalism under congress with Gandhi",
                                                      "id": "5ace20419fe7b01d5806c20f",
                                                      "_id": "6077c4efbc5f4d4df9ef2259",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848b",
                                                              "_id": "6077c4efbc5f4d4df9ef225a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8284",
                                                      "_id": "6077c4efbc5f4d4df9ef225b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef2268"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Logical Deduction",
                                              "id": "5ace20309fe7b01d5806bc18",
                                              "_id": "6077c4efbc5f4d4df9ef2253",
                                              "concepts": [
                                                  {
                                                      "name": "Syllogism",
                                                      "id": "5ace20389fe7b01d5806bf02",
                                                      "_id": "6077c4efbc5f4d4df9ef2254",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df47",
                                                              "_id": "6077c4efbc5f4d4df9ef2255"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df39",
                                                      "_id": "6077c4efbc5f4d4df9ef2256"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef2257"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 7,
                              "startDate": "2021-06-10T00:00:00.000Z",
                              "endDate": "2021-06-16T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef2100",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Life Processes",
                                              "id": "5ace202f9fe7b01d5806bbc0",
                                              "_id": "6077c4efbc5f4d4df9ef2221",
                                              "concepts": [
                                                  {
                                                      "name": "Nutrition, Types of nutrition, Nutrients and balanced diet",
                                                      "id": "5ace20339fe7b01d5806bd3d",
                                                      "_id": "6077c4efbc5f4d4df9ef224e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e3",
                                                              "_id": "6077c4efbc5f4d4df9ef224f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plant nutrition",
                                                      "id": "5ace20339fe7b01d5806bd3e",
                                                      "_id": "6077c4efbc5f4d4df9ef224c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e4",
                                                              "_id": "6077c4efbc5f4d4df9ef224d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lignt reaction & Dark reaction",
                                                      "id": "5ace20339fe7b01d5806bd3b",
                                                      "_id": "6077c4efbc5f4d4df9ef224a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e5",
                                                              "_id": "6077c4efbc5f4d4df9ef224b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Steps of holozoic nutrition, Digestion in Amoeba",
                                                      "id": "5ace20339fe7b01d5806bd41",
                                                      "_id": "6077c4efbc5f4d4df9ef2248",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e6",
                                                              "_id": "6077c4efbc5f4d4df9ef2249"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Digestion in Human",
                                                      "id": "5ace20339fe7b01d5806bd34",
                                                      "_id": "6077c4efbc5f4d4df9ef2246",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e7",
                                                              "_id": "6077c4efbc5f4d4df9ef2247"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diseases related to digestion",
                                                      "id": "5ace20339fe7b01d5806bd35",
                                                      "_id": "6077c4efbc5f4d4df9ef2244",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e8",
                                                              "_id": "6077c4efbc5f4d4df9ef2245"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Respiration in plants",
                                                      "id": "5ace20339fe7b01d5806bd40",
                                                      "_id": "6077c4efbc5f4d4df9ef2242",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82e9",
                                                              "_id": "6077c4efbc5f4d4df9ef2243"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Respiration in Amoeba",
                                                      "id": "5ace20339fe7b01d5806bd3f",
                                                      "_id": "6077c4efbc5f4d4df9ef2240",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ea",
                                                              "_id": "6077c4efbc5f4d4df9ef2241"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Structure of lungs & Breathing process",
                                                      "id": "5ace20339fe7b01d5806bd44",
                                                      "_id": "6077c4efbc5f4d4df9ef223e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82eb",
                                                              "_id": "6077c4efbc5f4d4df9ef223f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Aerobic respiration",
                                                      "id": "5ace20339fe7b01d5806bd2f",
                                                      "_id": "6077c4efbc5f4d4df9ef223c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ec",
                                                              "_id": "6077c4efbc5f4d4df9ef223d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Anaerobic respiration",
                                                      "id": "5ace20339fe7b01d5806bd30",
                                                      "_id": "6077c4efbc5f4d4df9ef223a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ed",
                                                              "_id": "6077c4efbc5f4d4df9ef223b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diseases related to respiration",
                                                      "id": "5ace20339fe7b01d5806bd38",
                                                      "_id": "6077c4efbc5f4d4df9ef2238",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ee",
                                                              "_id": "6077c4efbc5f4d4df9ef2239"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transportation in plants",
                                                      "id": "5ace20339fe7b01d5806bd45",
                                                      "_id": "6077c4efbc5f4d4df9ef2236",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82ef",
                                                              "_id": "6077c4efbc5f4d4df9ef2237"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Blood and its components & Blood vessels",
                                                      "id": "5ace20339fe7b01d5806bd31",
                                                      "_id": "6077c4efbc5f4d4df9ef2234",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f0",
                                                              "_id": "6077c4efbc5f4d4df9ef2235"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Structure of heart",
                                                      "id": "5ace20339fe7b01d5806bd42",
                                                      "_id": "6077c4efbc5f4d4df9ef2232",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f1",
                                                              "_id": "6077c4efbc5f4d4df9ef2233"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circulation in Human",
                                                      "id": "5ace20339fe7b01d5806bd33",
                                                      "_id": "6077c4efbc5f4d4df9ef2230",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f2",
                                                              "_id": "6077c4efbc5f4d4df9ef2231"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Blood groups",
                                                      "id": "5ace20339fe7b01d5806bd32",
                                                      "_id": "6077c4efbc5f4d4df9ef222e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f3",
                                                              "_id": "6077c4efbc5f4d4df9ef222f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lymphatic system",
                                                      "id": "5ace20339fe7b01d5806bd3c",
                                                      "_id": "6077c4efbc5f4d4df9ef222c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f4",
                                                              "_id": "6077c4efbc5f4d4df9ef222d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diseases related to heart and lymph",
                                                      "id": "5ace20339fe7b01d5806bd37",
                                                      "_id": "6077c4efbc5f4d4df9ef222a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f5",
                                                              "_id": "6077c4efbc5f4d4df9ef222b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Excretion and its products",
                                                      "id": "5ace20339fe7b01d5806bd39",
                                                      "_id": "6077c4efbc5f4d4df9ef2228",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f6",
                                                              "_id": "6077c4efbc5f4d4df9ef2229"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Structure of kidney & Nephron & Formation of urine",
                                                      "id": "5ace20339fe7b01d5806bd43",
                                                      "_id": "6077c4efbc5f4d4df9ef2226",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f7",
                                                              "_id": "6077c4efbc5f4d4df9ef2227"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Excretion in Plants",
                                                      "id": "5ace20339fe7b01d5806bd3a",
                                                      "_id": "6077c4efbc5f4d4df9ef2224",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f8",
                                                              "_id": "6077c4efbc5f4d4df9ef2225"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diseases related to Excretion",
                                                      "id": "5ace20339fe7b01d5806bd36",
                                                      "_id": "6077c4efbc5f4d4df9ef2222",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d78e316d24ffb2c82f9",
                                                              "_id": "6077c4efbc5f4d4df9ef2223"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820d",
                                                      "_id": "6077c4efbc5f4d4df9ef2250"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef2251"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Metals and Non Metals",
                                              "id": "5ace202f9fe7b01d5806bbcd",
                                              "_id": "6077c4efbc5f4d4df9ef2210",
                                              "concepts": [
                                                  {
                                                      "name": "Properties of Metals",
                                                      "id": "5ace20349fe7b01d5806bda8",
                                                      "_id": "6077c4efbc5f4d4df9ef221d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834b",
                                                              "_id": "6077c4efbc5f4d4df9ef221e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties of Non- Metals",
                                                      "id": "5ace20349fe7b01d5806bda9",
                                                      "_id": "6077c4efbc5f4d4df9ef221b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834c",
                                                              "_id": "6077c4efbc5f4d4df9ef221c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Compounds of Metals and Non-Metals",
                                                      "id": "5ace20349fe7b01d5806bda4",
                                                      "_id": "6077c4efbc5f4d4df9ef2219",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834d",
                                                              "_id": "6077c4efbc5f4d4df9ef221a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Metallurgy - An Introduction to Methods of Extraction",
                                                      "id": "5ace20349fe7b01d5806bda7",
                                                      "_id": "6077c4efbc5f4d4df9ef2217",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834e",
                                                              "_id": "6077c4efbc5f4d4df9ef2218"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Enrichment of Ores",
                                                      "id": "5ace20349fe7b01d5806bda6",
                                                      "_id": "6077c4efbc5f4d4df9ef2215",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c834f",
                                                              "_id": "6077c4efbc5f4d4df9ef2216"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reduction and Refining",
                                                      "id": "5ace20349fe7b01d5806bdaa",
                                                      "_id": "6077c4efbc5f4d4df9ef2213",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8350",
                                                              "_id": "6077c4efbc5f4d4df9ef2214"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Corrosion & Alloys",
                                                      "id": "5ace20349fe7b01d5806bda5",
                                                      "_id": "6077c4efbc5f4d4df9ef2211",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8351",
                                                              "_id": "6077c4efbc5f4d4df9ef2212"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8218",
                                                      "_id": "6077c4efbc5f4d4df9ef221f"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef2220"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Trigonometry Ratios & Identities",
                                              "id": "5ace20329fe7b01d5806bc95",
                                              "_id": "6077c4efbc5f4d4df9ef220d",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99e",
                                                      "_id": "6077c4efbc5f4d4df9ef220e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Trigonometry Ratios & Identities",
                                              "id": "5ace20329fe7b01d5806bc96",
                                              "_id": "6077c4efbc5f4d4df9ef21f5",
                                              "concepts": [
                                                  {
                                                      "name": "Conditional identities, trigonometric inequalities, trigonometrical graphs",
                                                      "id": "5ace203d9fe7b01d5806c0c1",
                                                      "_id": "6077c4efbc5f4d4df9ef220a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9c",
                                                              "_id": "6077c4efbc5f4d4df9ef220b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Domain & range of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c2",
                                                      "_id": "6077c4efbc5f4d4df9ef2208",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9d",
                                                              "_id": "6077c4efbc5f4d4df9ef2209"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Identities, compound angles, multiple angles, sub-multiple angles and transformations",
                                                      "id": "5ace203d9fe7b01d5806c0c3",
                                                      "_id": "6077c4efbc5f4d4df9ef2206",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9e",
                                                              "_id": "6077c4efbc5f4d4df9ef2207"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Maximum and minimum value of trigonometric function",
                                                      "id": "5ace203d9fe7b01d5806c0c4",
                                                      "_id": "6077c4efbc5f4d4df9ef2204",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673db9f",
                                                              "_id": "6077c4efbc5f4d4df9ef2205"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "polygons",
                                                      "id": "5ace203d9fe7b01d5806c0c5",
                                                      "_id": "6077c4efbc5f4d4df9ef2202",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba0",
                                                              "_id": "6077c4efbc5f4d4df9ef2203"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Principle, particular and general solution of trigonometrical equation, Conversion to lower degree, Conversion into quadratic form, change of variable",
                                                      "id": "5ace203d9fe7b01d5806c0c6",
                                                      "_id": "6077c4efbc5f4d4df9ef2200",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba1",
                                                              "_id": "6077c4efbc5f4d4df9ef2201"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of cosine, where angles are in G.P.",
                                                      "id": "5ace203d9fe7b01d5806c0c7",
                                                      "_id": "6077c4efbc5f4d4df9ef21fe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba2",
                                                              "_id": "6077c4efbc5f4d4df9ef21ff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sign of Trigonometric ratios",
                                                      "id": "5ace203d9fe7b01d5806c0c8",
                                                      "_id": "6077c4efbc5f4d4df9ef21fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba3",
                                                              "_id": "6077c4efbc5f4d4df9ef21fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Summation of sine/cosine series",
                                                      "id": "5ace203d9fe7b01d5806c0c9",
                                                      "_id": "6077c4efbc5f4d4df9ef21fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba4",
                                                              "_id": "6077c4efbc5f4d4df9ef21fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                      "id": "5ace203d9fe7b01d5806c0ca",
                                                      "_id": "6077c4efbc5f4d4df9ef21f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba5",
                                                              "_id": "6077c4efbc5f4d4df9ef21f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric ratios of sum & difference of two angles",
                                                      "id": "5ace203e9fe7b01d5806c0cb",
                                                      "_id": "6077c4efbc5f4d4df9ef21f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba6",
                                                              "_id": "6077c4efbc5f4d4df9ef21f7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d99f",
                                                      "_id": "6077c4efbc5f4d4df9ef220c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "3-Dimensional Geometry",
                                              "id": "5ace20329fe7b01d5806bc97",
                                              "_id": "6077c4efbc5f4d4df9ef21f3",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a0",
                                                      "_id": "6077c4efbc5f4d4df9ef21f4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "3-Dimensional Geometry",
                                              "id": "5ace20329fe7b01d5806bc98",
                                              "_id": "6077c4efbc5f4d4df9ef21d3",
                                              "concepts": [
                                                  {
                                                      "name": "Angle between a line and a plane, Planes bisecting the angles between two planes, Bisector of acute / obtuse angle, Distance of a point from a plane, Distance between two parallel planes",
                                                      "id": "5ace203e9fe7b01d5806c0cc",
                                                      "_id": "6077c4efbc5f4d4df9ef21f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba7",
                                                              "_id": "6077c4efbc5f4d4df9ef21f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle between two vectors, Projection of the join of two points",
                                                      "id": "5ace203e9fe7b01d5806c0cd",
                                                      "_id": "6077c4efbc5f4d4df9ef21ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba8",
                                                              "_id": "6077c4efbc5f4d4df9ef21ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency ( C. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0ce",
                                                      "_id": "6077c4efbc5f4d4df9ef21ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dba9",
                                                              "_id": "6077c4efbc5f4d4df9ef21ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Condition of tangency ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0cf",
                                                      "_id": "6077c4efbc5f4d4df9ef21ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbaa",
                                                              "_id": "6077c4efbc5f4d4df9ef21eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Direction cosines, Direction ratios",
                                                      "id": "5ace203e9fe7b01d5806c0d0",
                                                      "_id": "6077c4efbc5f4d4df9ef21e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbab",
                                                              "_id": "6077c4efbc5f4d4df9ef21e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance formula, Section formula, Centriod of a triangle, Centriod of a tetrahedron,",
                                                      "id": "5ace203e9fe7b01d5806c0d1",
                                                      "_id": "6077c4efbc5f4d4df9ef21e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbac",
                                                              "_id": "6077c4efbc5f4d4df9ef21e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d2",
                                                      "_id": "6077c4efbc5f4d4df9ef21e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbad",
                                                              "_id": "6077c4efbc5f4d4df9ef21e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere (C. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d3",
                                                      "_id": "6077c4efbc5f4d4df9ef21e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbae",
                                                              "_id": "6077c4efbc5f4d4df9ef21e3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere the extremities of diameter being",
                                                      "id": "5ace203e9fe7b01d5806c0d4",
                                                      "_id": "6077c4efbc5f4d4df9ef21e0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbaf",
                                                              "_id": "6077c4efbc5f4d4df9ef21e1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere the extremities of diameter being given ( c. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d5",
                                                      "_id": "6077c4efbc5f4d4df9ef21de",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb0",
                                                              "_id": "6077c4efbc5f4d4df9ef21df"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of a sphere through four points ( v. F. )",
                                                      "id": "5ace203e9fe7b01d5806c0d6",
                                                      "_id": "6077c4efbc5f4d4df9ef21dc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb1",
                                                              "_id": "6077c4efbc5f4d4df9ef21dd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane passing through three points, Plane passing through two points and parallel to a vector, Plane passing through two points and parallel to two vectors, Plane parallel to a given plane, Angle between two planes",
                                                      "id": "5ace203e9fe7b01d5806c0d7",
                                                      "_id": "6077c4efbc5f4d4df9ef21da",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb2",
                                                              "_id": "6077c4efbc5f4d4df9ef21db"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plane-General equation of plane, Plane in normal form, Transformation of general form of normal form, Plane passing through a point and perpendicular to a vector, Equation of a plane in intercept form",
                                                      "id": "5ace203e9fe7b01d5806c0d8",
                                                      "_id": "6077c4efbc5f4d4df9ef21d8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb3",
                                                              "_id": "6077c4efbc5f4d4df9ef21d9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Planes passing through the intersection of two planes, Two sides of a plane, Condition for a line to lie in a plane, Condition for two lines to be intersecting coplaner and the plane containing them, Area of Figures (Traingle etc.) in 3-Dimensional space",
                                                      "id": "5ace203e9fe7b01d5806c0d9",
                                                      "_id": "6077c4efbc5f4d4df9ef21d6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb4",
                                                              "_id": "6077c4efbc5f4d4df9ef21d7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Straight Line-through a point and parallel to a vector, Line passing through two points, Angle between two lines, Perpendicular from a point to a line, Shortest distance between two lines",
                                                      "id": "5ace203e9fe7b01d5806c0da",
                                                      "_id": "6077c4efbc5f4d4df9ef21d4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb5",
                                                              "_id": "6077c4efbc5f4d4df9ef21d5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a1",
                                                      "_id": "6077c4efbc5f4d4df9ef21f2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector",
                                              "id": "5ace20329fe7b01d5806bc99",
                                              "_id": "6077c4efbc5f4d4df9ef21d1",
                                              "concepts": [],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a2",
                                                      "_id": "6077c4efbc5f4d4df9ef21d2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector",
                                              "id": "5ace20329fe7b01d5806bc9a",
                                              "_id": "6077c4efbc5f4d4df9ef219f",
                                              "concepts": [
                                                  {
                                                      "name": "Component of a vector",
                                                      "id": "5ace203e9fe7b01d5806c0db",
                                                      "_id": "6077c4efbc5f4d4df9ef21ce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb6",
                                                              "_id": "6077c4efbc5f4d4df9ef21cf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Component of a vector",
                                                      "id": "5ace203e9fe7b01d5806c0dc",
                                                      "_id": "6077c4efbc5f4d4df9ef21cc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb7",
                                                              "_id": "6077c4efbc5f4d4df9ef21cd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cross product of two vectors and its application",
                                                      "id": "5ace203e9fe7b01d5806c0dd",
                                                      "_id": "6077c4efbc5f4d4df9ef21ca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb8",
                                                              "_id": "6077c4efbc5f4d4df9ef21cb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dot product of two vectors and its application",
                                                      "id": "5ace203e9fe7b01d5806c0de",
                                                      "_id": "6077c4efbc5f4d4df9ef21c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbb9",
                                                              "_id": "6077c4efbc5f4d4df9ef21c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical application of vectors-plane, parallel planes, angle between planes, length of perpendicular from a point on the plane, point of intersection of a straight line and a plane, angle between two planes",
                                                      "id": "5ace203e9fe7b01d5806c0df",
                                                      "_id": "6077c4efbc5f4d4df9ef21c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbba",
                                                              "_id": "6077c4efbc5f4d4df9ef21c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical application of vectors-straight line, angle between straight line, point of intersection of straight line, distance between two straight lines, distance of a point from a straight line, angle bisector",
                                                      "id": "5ace203e9fe7b01d5806c0e0",
                                                      "_id": "6077c4efbc5f4d4df9ef21c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbb",
                                                              "_id": "6077c4efbc5f4d4df9ef21c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical interpretation",
                                                      "id": "5ace203e9fe7b01d5806c0e1",
                                                      "_id": "6077c4efbc5f4d4df9ef21c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbc",
                                                              "_id": "6077c4efbc5f4d4df9ef21c3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometrical interpretation of cross product",
                                                      "id": "5ace203e9fe7b01d5806c0e2",
                                                      "_id": "6077c4efbc5f4d4df9ef21c0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbd",
                                                              "_id": "6077c4efbc5f4d4df9ef21c1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Image of a plane in a plane, image of a line in a plane, image of a point in a plane, image of a point in a line",
                                                      "id": "5ace203e9fe7b01d5806c0e3",
                                                      "_id": "6077c4efbc5f4d4df9ef21be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbe",
                                                              "_id": "6077c4efbc5f4d4df9ef21bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear combination",
                                                      "id": "5ace203e9fe7b01d5806c0e4",
                                                      "_id": "6077c4efbc5f4d4df9ef21bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbbf",
                                                              "_id": "6077c4efbc5f4d4df9ef21bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear combination, Linearly dependent or independent",
                                                      "id": "5ace203e9fe7b01d5806c0e5",
                                                      "_id": "6077c4efbc5f4d4df9ef21ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc0",
                                                              "_id": "6077c4efbc5f4d4df9ef21bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear dependent or independent",
                                                      "id": "5ace203e9fe7b01d5806c0e6",
                                                      "_id": "6077c4efbc5f4d4df9ef21b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc1",
                                                              "_id": "6077c4efbc5f4d4df9ef21b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment of a force",
                                                      "id": "5ace203e9fe7b01d5806c0e7",
                                                      "_id": "6077c4efbc5f4d4df9ef21b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc2",
                                                              "_id": "6077c4efbc5f4d4df9ef21b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on collinearity of three points, two vectors, four points, three vectors",
                                                      "id": "5ace203e9fe7b01d5806c0e8",
                                                      "_id": "6077c4efbc5f4d4df9ef21b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc3",
                                                              "_id": "6077c4efbc5f4d4df9ef21b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems based on magnitude of vectors, Types of vectors, Addition and subtraction of vectors, Position vectors, Section formula (internal/external),",
                                                      "id": "5ace203e9fe7b01d5806c0e9",
                                                      "_id": "6077c4efbc5f4d4df9ef21b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc4",
                                                              "_id": "6077c4efbc5f4d4df9ef21b3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of four vector",
                                                      "id": "5ace203e9fe7b01d5806c0ea",
                                                      "_id": "6077c4efbc5f4d4df9ef21b0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc5",
                                                              "_id": "6077c4efbc5f4d4df9ef21b1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product of two vectors",
                                                      "id": "5ace203e9fe7b01d5806c0eb",
                                                      "_id": "6077c4efbc5f4d4df9ef21ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc6",
                                                              "_id": "6077c4efbc5f4d4df9ef21af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reciprocal system of vectors and solution of vector equation",
                                                      "id": "5ace203e9fe7b01d5806c0ec",
                                                      "_id": "6077c4efbc5f4d4df9ef21ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc7",
                                                              "_id": "6077c4efbc5f4d4df9ef21ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar product",
                                                      "id": "5ace203e9fe7b01d5806c0ed",
                                                      "_id": "6077c4efbc5f4d4df9ef21aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc8",
                                                              "_id": "6077c4efbc5f4d4df9ef21ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar triple product",
                                                      "id": "5ace203e9fe7b01d5806c0ee",
                                                      "_id": "6077c4efbc5f4d4df9ef21a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbc9",
                                                              "_id": "6077c4efbc5f4d4df9ef21a9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Triple product",
                                                      "id": "5ace203e9fe7b01d5806c0ef",
                                                      "_id": "6077c4efbc5f4d4df9ef21a6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbca",
                                                              "_id": "6077c4efbc5f4d4df9ef21a7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector product",
                                                      "id": "5ace203e9fe7b01d5806c0f0",
                                                      "_id": "6077c4efbc5f4d4df9ef21a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcb",
                                                              "_id": "6077c4efbc5f4d4df9ef21a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector triple product",
                                                      "id": "5ace203e9fe7b01d5806c0f1",
                                                      "_id": "6077c4efbc5f4d4df9ef21a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcc",
                                                              "_id": "6077c4efbc5f4d4df9ef21a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work done",
                                                      "id": "5ace203e9fe7b01d5806c0f2",
                                                      "_id": "6077c4efbc5f4d4df9ef21a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcd",
                                                              "_id": "6077c4efbc5f4d4df9ef21a1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a3",
                                                      "_id": "6077c4efbc5f4d4df9ef21d0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Real Number",
                                              "id": "5ec36b98f05a6036ccbb380c",
                                              "_id": "6077c4efbc5f4d4df9ef2195",
                                              "concepts": [
                                                  {
                                                      "name": "Fundamental Theorem of Arithmetic",
                                                      "id": "5ec36bfce56f4536c61841ec",
                                                      "_id": "6077c4efbc5f4d4df9ef219c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbce",
                                                              "_id": "6077c4efbc5f4d4df9ef219d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid's Division Lemma",
                                                      "id": "5ec36bfce56f4536c61841eb",
                                                      "_id": "6077c4efbc5f4d4df9ef219a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbcf",
                                                              "_id": "6077c4efbc5f4d4df9ef219b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Decimal Expansion of Rational Numbers",
                                                      "id": "5ec36bfce56f4536c61841ee",
                                                      "_id": "6077c4efbc5f4d4df9ef2198",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd0",
                                                              "_id": "6077c4efbc5f4d4df9ef2199"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Review of Irrational Numbers",
                                                      "id": "5ec36bfce56f4536c61841ed",
                                                      "_id": "6077c4efbc5f4d4df9ef2196",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd1",
                                                              "_id": "6077c4efbc5f4d4df9ef2197"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a4",
                                                      "_id": "6077c4efbc5f4d4df9ef219e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constructions",
                                              "id": "5ec36b98f05a6036ccbb3816",
                                              "_id": "6077c4efbc5f4d4df9ef218d",
                                              "concepts": [
                                                  {
                                                      "name": "Construction of Tangents to a Circle",
                                                      "id": "5ec377853d2b7e3af65ff176",
                                                      "_id": "6077c4efbc5f4d4df9ef2192",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbd9",
                                                              "_id": "6077c4efbc5f4d4df9ef2193"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Division of a Line Segment",
                                                      "id": "5ec377853d2b7e3af65ff174",
                                                      "_id": "6077c4efbc5f4d4df9ef2190",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbda",
                                                              "_id": "6077c4efbc5f4d4df9ef2191"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Construction of a Triangle Similar to a Given Triangle as per Given Scale Factor",
                                                      "id": "5ec377853d2b7e3af65ff175",
                                                      "_id": "6077c4efbc5f4d4df9ef218e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdb",
                                                              "_id": "6077c4efbc5f4d4df9ef218f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a6",
                                                      "_id": "6077c4efbc5f4d4df9ef2194"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Polynomials",
                                              "id": "5ec36b98f05a6036ccbb380d",
                                              "_id": "6077c4efbc5f4d4df9ef2183",
                                              "concepts": [
                                                  {
                                                      "name": "Division Algorithm of Polynomials",
                                                      "id": "5ec36c363d2b7e3af65fefb3",
                                                      "_id": "6077c4efbc5f4d4df9ef218a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdc",
                                                              "_id": "6077c4efbc5f4d4df9ef218b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relationship between Zeroes and Coefficient of a Quadratic Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb1",
                                                      "_id": "6077c4efbc5f4d4df9ef2188",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdd",
                                                              "_id": "6077c4efbc5f4d4df9ef2189"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relationship between Zeroes and Coefficient of a Cubic Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb2",
                                                      "_id": "6077c4efbc5f4d4df9ef2186",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbde",
                                                              "_id": "6077c4efbc5f4d4df9ef2187"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Zeros of a Polynomial",
                                                      "id": "5ec36c363d2b7e3af65fefb0",
                                                      "_id": "6077c4efbc5f4d4df9ef2184",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbdf",
                                                              "_id": "6077c4efbc5f4d4df9ef2185"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a7",
                                                      "_id": "6077c4efbc5f4d4df9ef218c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5ec36b98f05a6036ccbb3812",
                                              "_id": "6077c4efbc5f4d4df9ef217b",
                                              "concepts": [
                                                  {
                                                      "name": "Area of a Triangle",
                                                      "id": "5ec370763d2b7e3af65ff041",
                                                      "_id": "6077c4efbc5f4d4df9ef2180",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe0",
                                                              "_id": "6077c4efbc5f4d4df9ef2181"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance Formula",
                                                      "id": "5ec370763d2b7e3af65ff03f",
                                                      "_id": "6077c4efbc5f4d4df9ef217e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe1",
                                                              "_id": "6077c4efbc5f4d4df9ef217f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Section Formula",
                                                      "id": "5ec370763d2b7e3af65ff040",
                                                      "_id": "6077c4efbc5f4d4df9ef217c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe2",
                                                              "_id": "6077c4efbc5f4d4df9ef217d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a8",
                                                      "_id": "6077c4efbc5f4d4df9ef2182"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef220f"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Modern Physics",
                                              "id": "5ace20329fe7b01d5806bca9",
                                              "_id": "6077c4efbc5f4d4df9ef2162",
                                              "concepts": [
                                                  {
                                                      "name": "Bohrs model",
                                                      "id": "5ace203f9fe7b01d5806c16d",
                                                      "_id": "6077c4efbc5f4d4df9ef2177",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0b",
                                                              "_id": "6077c4efbc5f4d4df9ef2178"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conventional and non\n  conventional sources of energy",
                                                      "id": "5ace203f9fe7b01d5806c16e",
                                                      "_id": "6077c4efbc5f4d4df9ef2175",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0c",
                                                              "_id": "6077c4efbc5f4d4df9ef2176"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "dual nature of matter and de-broglie wavelength",
                                                      "id": "5ace203f9fe7b01d5806c16f",
                                                      "_id": "6077c4efbc5f4d4df9ef2173",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0d",
                                                              "_id": "6077c4efbc5f4d4df9ef2174"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Emission spectrun in Bohr's model",
                                                      "id": "5ace203f9fe7b01d5806c170",
                                                      "_id": "6077c4efbc5f4d4df9ef2171",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0e",
                                                              "_id": "6077c4efbc5f4d4df9ef2172"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "fustion and fission reaction, alpha, beta & gamma decay,",
                                                      "id": "5ace203f9fe7b01d5806c171",
                                                      "_id": "6077c4efbc5f4d4df9ef216f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de0f",
                                                              "_id": "6077c4efbc5f4d4df9ef2170"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "nuclear physics, binding energy, Q-value of reaction, threshold energy",
                                                      "id": "5ace203f9fe7b01d5806c172",
                                                      "_id": "6077c4efbc5f4d4df9ef216d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de10",
                                                              "_id": "6077c4efbc5f4d4df9ef216e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "photo-electric effect",
                                                      "id": "5ace203f9fe7b01d5806c173",
                                                      "_id": "6077c4efbc5f4d4df9ef216b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de11",
                                                              "_id": "6077c4efbc5f4d4df9ef216c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "properties of photon",
                                                      "id": "5ace203f9fe7b01d5806c174",
                                                      "_id": "6077c4efbc5f4d4df9ef2169",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de12",
                                                              "_id": "6077c4efbc5f4d4df9ef216a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "radioactivity, parallel and series decay, radioactive equilirbium",
                                                      "id": "5ace203f9fe7b01d5806c175",
                                                      "_id": "6077c4efbc5f4d4df9ef2167",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de13",
                                                              "_id": "6077c4efbc5f4d4df9ef2168"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Renewable & non renewable source of energy",
                                                      "id": "5ace203f9fe7b01d5806c176",
                                                      "_id": "6077c4efbc5f4d4df9ef2165",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de14",
                                                              "_id": "6077c4efbc5f4d4df9ef2166"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "X rays, characteristic and continuous wavelength, mosley's law",
                                                      "id": "5ace203f9fe7b01d5806c177",
                                                      "_id": "6077c4efbc5f4d4df9ef2163",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de15",
                                                              "_id": "6077c4efbc5f4d4df9ef2164"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd69",
                                                      "_id": "6077c4efbc5f4d4df9ef2179"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5ace20329fe7b01d5806bcaa",
                                              "_id": "6077c4efbc5f4d4df9ef2140",
                                              "concepts": [
                                                  {
                                                      "name": "basic properties of reflection and plane mirror, Object and image",
                                                      "id": "5ace203f9fe7b01d5806c178",
                                                      "_id": "6077c4efbc5f4d4df9ef215f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de16",
                                                              "_id": "6077c4efbc5f4d4df9ef2160"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "basic properties of refraction and image formation from plane surface, variable refractive index, motion of image from plane surface",
                                                      "id": "5ace203f9fe7b01d5806c179",
                                                      "_id": "6077c4efbc5f4d4df9ef215d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de17",
                                                              "_id": "6077c4efbc5f4d4df9ef215e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "basic property of prism, deviation and dispersion from prism, image formation from prism, minimum deviation from prism",
                                                      "id": "5ace203f9fe7b01d5806c17a",
                                                      "_id": "6077c4efbc5f4d4df9ef215b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de18",
                                                              "_id": "6077c4efbc5f4d4df9ef215c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "combination of lens, silvering of lens, splitting of lens",
                                                      "id": "5ace203f9fe7b01d5806c17b",
                                                      "_id": "6077c4efbc5f4d4df9ef2159",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de19",
                                                              "_id": "6077c4efbc5f4d4df9ef215a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "deviation from optical instruments",
                                                      "id": "5ace203f9fe7b01d5806c17c",
                                                      "_id": "6077c4efbc5f4d4df9ef2157",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1a",
                                                              "_id": "6077c4efbc5f4d4df9ef2158"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic wave",
                                                      "id": "5ace203f9fe7b01d5806c17d",
                                                      "_id": "6077c4efbc5f4d4df9ef2155",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1b",
                                                              "_id": "6077c4efbc5f4d4df9ef2156"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "huygen theory of wave fronts, YDSE",
                                                      "id": "5ace203f9fe7b01d5806c17e",
                                                      "_id": "6077c4efbc5f4d4df9ef2153",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1c",
                                                              "_id": "6077c4efbc5f4d4df9ef2154"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "interference from thin film",
                                                      "id": "5ace203f9fe7b01d5806c17f",
                                                      "_id": "6077c4efbc5f4d4df9ef2151",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1d",
                                                              "_id": "6077c4efbc5f4d4df9ef2152"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "interference in system similar to YDSE",
                                                      "id": "5ace203f9fe7b01d5806c180",
                                                      "_id": "6077c4efbc5f4d4df9ef214f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1e",
                                                              "_id": "6077c4efbc5f4d4df9ef2150"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "microscope, telescope and eye",
                                                      "id": "5ace20409fe7b01d5806c181",
                                                      "_id": "6077c4efbc5f4d4df9ef214d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de1f",
                                                              "_id": "6077c4efbc5f4d4df9ef214e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarization, resolving power, microscope, telescope, brewster's law, polaroids",
                                                      "id": "5ace20409fe7b01d5806c182",
                                                      "_id": "6077c4efbc5f4d4df9ef214b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de20",
                                                              "_id": "6077c4efbc5f4d4df9ef214c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "refraction from spherical surfaces, lens, lens formula, magnification, motion of image from lens",
                                                      "id": "5ace20409fe7b01d5806c183",
                                                      "_id": "6077c4efbc5f4d4df9ef2149",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de21",
                                                              "_id": "6077c4efbc5f4d4df9ef214a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "shifting of fringes due to introduction of film, concept of optical path",
                                                      "id": "5ace20409fe7b01d5806c184",
                                                      "_id": "6077c4efbc5f4d4df9ef2147",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de22",
                                                              "_id": "6077c4efbc5f4d4df9ef2148"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Single slit diffraction, width of centre maximum",
                                                      "id": "5ace20409fe7b01d5806c185",
                                                      "_id": "6077c4efbc5f4d4df9ef2145",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de23",
                                                              "_id": "6077c4efbc5f4d4df9ef2146"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "spherical mirror and mirror formula, relative motion of miror and object, magnification",
                                                      "id": "5ace20409fe7b01d5806c186",
                                                      "_id": "6077c4efbc5f4d4df9ef2143",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de24",
                                                              "_id": "6077c4efbc5f4d4df9ef2144"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "total internal reflection",
                                                      "id": "5ace20409fe7b01d5806c187",
                                                      "_id": "6077c4efbc5f4d4df9ef2141",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de25",
                                                              "_id": "6077c4efbc5f4d4df9ef2142"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd6a",
                                                      "_id": "6077c4efbc5f4d4df9ef2161"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Laws Of Motion",
                                              "id": "5f6860f5058075680d81545a",
                                              "_id": "6077c4efbc5f4d4df9ef2130",
                                              "concepts": [
                                                  {
                                                      "name": "Dynamics Of Circular Motion",
                                                      "id": "5f6862f9f100a06808b0f5ba",
                                                      "_id": "6077c4efbc5f4d4df9ef213d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de70",
                                                              "_id": "6077c4efbc5f4d4df9ef213e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lami’S Theorem",
                                                      "id": "5f6862f9f100a06808b0f5b7",
                                                      "_id": "6077c4efbc5f4d4df9ef213b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de71",
                                                              "_id": "6077c4efbc5f4d4df9ef213c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5b4",
                                                      "_id": "6077c4efbc5f4d4df9ef2139",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de72",
                                                              "_id": "6077c4efbc5f4d4df9ef213a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Friction",
                                                      "id": "5f6862f9f100a06808b0f5b9",
                                                      "_id": "6077c4efbc5f4d4df9ef2137",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de73",
                                                              "_id": "6077c4efbc5f4d4df9ef2138"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton’S Laws",
                                                      "id": "5f6862f9f100a06808b0f5b5",
                                                      "_id": "6077c4efbc5f4d4df9ef2135",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de74",
                                                              "_id": "6077c4efbc5f4d4df9ef2136"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Newton’S Laws",
                                                      "id": "5f6862f9f100a06808b0f5b6",
                                                      "_id": "6077c4efbc5f4d4df9ef2133",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de75",
                                                              "_id": "6077c4efbc5f4d4df9ef2134"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Law Of Conservation Of Total Linear Momentum",
                                                      "id": "5f6862f9f100a06808b0f5b8",
                                                      "_id": "6077c4efbc5f4d4df9ef2131",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de76",
                                                              "_id": "6077c4efbc5f4d4df9ef2132"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd76",
                                                      "_id": "6077c4efbc5f4d4df9ef213f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Motion Of System Of Particles And Rigid Bodies",
                                              "id": "5f6860f5058075680d81545c",
                                              "_id": "6077c4efbc5f4d4df9ef2120",
                                              "concepts": [
                                                  {
                                                      "name": "Equilibrium Of Rigid Bodies",
                                                      "id": "5f6862f9f100a06808b0f5c3",
                                                      "_id": "6077c4efbc5f4d4df9ef212d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de77",
                                                              "_id": "6077c4efbc5f4d4df9ef212e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque And Angular Momentum",
                                                      "id": "5f6862f9f100a06808b0f5c2",
                                                      "_id": "6077c4efbc5f4d4df9ef212b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de78",
                                                              "_id": "6077c4efbc5f4d4df9ef212c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Centre Of Mass",
                                                      "id": "5f6862f9f100a06808b0f5c1",
                                                      "_id": "6077c4efbc5f4d4df9ef2129",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de79",
                                                              "_id": "6077c4efbc5f4d4df9ef212a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5c0",
                                                      "_id": "6077c4efbc5f4d4df9ef2127",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7a",
                                                              "_id": "6077c4efbc5f4d4df9ef2128"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Moment Of Inertia",
                                                      "id": "5f6862f9f100a06808b0f5c4",
                                                      "_id": "6077c4efbc5f4d4df9ef2125",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7b",
                                                              "_id": "6077c4efbc5f4d4df9ef2126"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rolling Motion",
                                                      "id": "5f6862f9f100a06808b0f5c6",
                                                      "_id": "6077c4efbc5f4d4df9ef2123",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7c",
                                                              "_id": "6077c4efbc5f4d4df9ef2124"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rotational Dynamics",
                                                      "id": "5f6862f9f100a06808b0f5c5",
                                                      "_id": "6077c4efbc5f4d4df9ef2121",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7d",
                                                              "_id": "6077c4efbc5f4d4df9ef2122"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd77",
                                                      "_id": "6077c4efbc5f4d4df9ef212f"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef217a"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Cubes & Dice",
                                              "id": "5ace20309fe7b01d5806bc25",
                                              "_id": "6077c4efbc5f4d4df9ef2119",
                                              "concepts": [
                                                  {
                                                      "name": "Cubes",
                                                      "id": "5ace20389fe7b01d5806bf13",
                                                      "_id": "6077c4efbc5f4d4df9ef211c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843b",
                                                              "_id": "6077c4efbc5f4d4df9ef211d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dice",
                                                      "id": "5ace20389fe7b01d5806bf14",
                                                      "_id": "6077c4efbc5f4d4df9ef211a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843c",
                                                              "_id": "6077c4efbc5f4d4df9ef211b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8256",
                                                      "_id": "6077c4efbc5f4d4df9ef211e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Figure series",
                                              "id": "5ace20319fe7b01d5806bc2c",
                                              "_id": "6077c4efbc5f4d4df9ef2115",
                                              "concepts": [
                                                  {
                                                      "name": "Figure series",
                                                      "id": "5ace20389fe7b01d5806bf1c",
                                                      "_id": "6077c4efbc5f4d4df9ef2116",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843d",
                                                              "_id": "6077c4efbc5f4d4df9ef2117"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8257",
                                                      "_id": "6077c4efbc5f4d4df9ef2118"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef211f"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Democracy in the Contemporary World",
                                              "id": "5ace20329fe7b01d5806bce4",
                                              "_id": "6077c4efbc5f4d4df9ef2110",
                                              "concepts": [
                                                  {
                                                      "name": "Expansion of democracy in the world",
                                                      "id": "5ace20429fe7b01d5806c22f",
                                                      "_id": "6077c4efbc5f4d4df9ef2111",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848c",
                                                              "_id": "6077c4efbc5f4d4df9ef2112"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8285",
                                                      "_id": "6077c4efbc5f4d4df9ef2113"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "What is Democracy ? Why Democracy?",
                                              "id": "5ace20329fe7b01d5806bced",
                                              "_id": "6077c4efbc5f4d4df9ef210c",
                                              "concepts": [
                                                  {
                                                      "name": "Merits & demarits of democracy",
                                                      "id": "5ace20429fe7b01d5806c23c",
                                                      "_id": "6077c4efbc5f4d4df9ef210d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848d",
                                                              "_id": "6077c4efbc5f4d4df9ef210e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8286",
                                                      "_id": "6077c4efbc5f4d4df9ef210f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Constitutional Design",
                                              "id": "5ace20329fe7b01d5806bce2",
                                              "_id": "6077c4efbc5f4d4df9ef2108",
                                              "concepts": [
                                                  {
                                                      "name": "African nation congress and its role in the equality for Blacks.\nFormation of CA and constitution in India",
                                                      "id": "5ace20429fe7b01d5806c22c",
                                                      "_id": "6077c4efbc5f4d4df9ef2109",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848e",
                                                              "_id": "6077c4efbc5f4d4df9ef210a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8287",
                                                      "_id": "6077c4efbc5f4d4df9ef210b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef2114"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Paper Cutting",
                                              "id": "5ace20309fe7b01d5806bc19",
                                              "_id": "6077c4efbc5f4d4df9ef2101",
                                              "concepts": [
                                                  {
                                                      "name": "Folding and Unfolding",
                                                      "id": "5ace20389fe7b01d5806bf03",
                                                      "_id": "6077c4efbc5f4d4df9ef2104",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df48",
                                                              "_id": "6077c4efbc5f4d4df9ef2105"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Paper Cutting and Dot Situation",
                                                      "id": "5ace20389fe7b01d5806bf04",
                                                      "_id": "6077c4efbc5f4d4df9ef2102",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df49",
                                                              "_id": "6077c4efbc5f4d4df9ef2103"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3a",
                                                      "_id": "6077c4efbc5f4d4df9ef2106"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef2107"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 8,
                              "startDate": "2021-06-17T00:00:00.000Z",
                              "endDate": "2021-06-23T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef200a",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Control & Co-ordination & Reproduction",
                                              "id": "5ace202f9fe7b01d5806bbbb",
                                              "_id": "6077c4efbc5f4d4df9ef20e1",
                                              "concepts": [
                                                  {
                                                      "name": "Plant movements",
                                                      "id": "5ace20329fe7b01d5806bcf8",
                                                      "_id": "6077c4efbc5f4d4df9ef20fc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82fa",
                                                              "_id": "6077c4efbc5f4d4df9ef20fd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Plant hormones",
                                                      "id": "5ace20329fe7b01d5806bcf7",
                                                      "_id": "6077c4efbc5f4d4df9ef20fa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82fb",
                                                              "_id": "6077c4efbc5f4d4df9ef20fb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Structure and function of Human brain",
                                                      "id": "5ace20329fe7b01d5806bcfa",
                                                      "_id": "6077c4efbc5f4d4df9ef20f8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82fc",
                                                              "_id": "6077c4efbc5f4d4df9ef20f9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Structure and function of Spinal cord",
                                                      "id": "5ace20329fe7b01d5806bcfb",
                                                      "_id": "6077c4efbc5f4d4df9ef20f6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82fd",
                                                              "_id": "6077c4efbc5f4d4df9ef20f7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Autonomic nervous system",
                                                      "id": "5ace20329fe7b01d5806bcef",
                                                      "_id": "6077c4efbc5f4d4df9ef20f4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82fe",
                                                              "_id": "6077c4efbc5f4d4df9ef20f5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "peripheral nervous system",
                                                      "id": "5ace20329fe7b01d5806bcf6",
                                                      "_id": "6077c4efbc5f4d4df9ef20f2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c82ff",
                                                              "_id": "6077c4efbc5f4d4df9ef20f3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Endocrine glands",
                                                      "id": "5ace20329fe7b01d5806bcf0",
                                                      "_id": "6077c4efbc5f4d4df9ef20f0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8300",
                                                              "_id": "6077c4efbc5f4d4df9ef20f1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vegetative reproduction, Budding, Fission, Spore formation",
                                                      "id": "5ace20329fe7b01d5806bcfc",
                                                      "_id": "6077c4efbc5f4d4df9ef20ee",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8301",
                                                              "_id": "6077c4efbc5f4d4df9ef20ef"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parts of a flower, Pollination",
                                                      "id": "5ace20329fe7b01d5806bcf5",
                                                      "_id": "6077c4efbc5f4d4df9ef20ec",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8302",
                                                              "_id": "6077c4efbc5f4d4df9ef20ed"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fertilization in angiospermic plants",
                                                      "id": "5ace20329fe7b01d5806bcf1",
                                                      "_id": "6077c4efbc5f4d4df9ef20ea",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8303",
                                                              "_id": "6077c4efbc5f4d4df9ef20eb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Human male reproductive system",
                                                      "id": "5ace20329fe7b01d5806bcf4",
                                                      "_id": "6077c4efbc5f4d4df9ef20e8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8304",
                                                              "_id": "6077c4efbc5f4d4df9ef20e9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Human female reproductive system",
                                                      "id": "5ace20329fe7b01d5806bcf3",
                                                      "_id": "6077c4efbc5f4d4df9ef20e6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8305",
                                                              "_id": "6077c4efbc5f4d4df9ef20e7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Puberty , Menstrual cycle",
                                                      "id": "5ace20329fe7b01d5806bcf9",
                                                      "_id": "6077c4efbc5f4d4df9ef20e4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8306",
                                                              "_id": "6077c4efbc5f4d4df9ef20e5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fertilization in human, Birth control measures",
                                                      "id": "5ace20329fe7b01d5806bcf2",
                                                      "_id": "6077c4efbc5f4d4df9ef20e2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8307",
                                                              "_id": "6077c4efbc5f4d4df9ef20e3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820e",
                                                      "_id": "6077c4efbc5f4d4df9ef20fe"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef20ff"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Periodic classification of elements",
                                              "id": "5ace202f9fe7b01d5806bbce",
                                              "_id": "6077c4efbc5f4d4df9ef20cc",
                                              "concepts": [
                                                  {
                                                      "name": "Classification of Elements",
                                                      "id": "5ace20349fe7b01d5806bdac",
                                                      "_id": "6077c4efbc5f4d4df9ef20dd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8352",
                                                              "_id": "6077c4efbc5f4d4df9ef20de"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dobereneirs triads and Newlands Law",
                                                      "id": "5ace20349fe7b01d5806bdad",
                                                      "_id": "6077c4efbc5f4d4df9ef20db",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8353",
                                                              "_id": "6077c4efbc5f4d4df9ef20dc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mendeleevs Periodic Table",
                                                      "id": "5ace20349fe7b01d5806bdb0",
                                                      "_id": "6077c4efbc5f4d4df9ef20d9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8354",
                                                              "_id": "6077c4efbc5f4d4df9ef20da"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Periodic Properties",
                                                      "id": "5ace20349fe7b01d5806bdb3",
                                                      "_id": "6077c4efbc5f4d4df9ef20d7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8355",
                                                              "_id": "6077c4efbc5f4d4df9ef20d8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atomic Size",
                                                      "id": "5ace20349fe7b01d5806bdab",
                                                      "_id": "6077c4efbc5f4d4df9ef20d5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8356",
                                                              "_id": "6077c4efbc5f4d4df9ef20d6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ionisation Energy and Electron Affinity",
                                                      "id": "5ace20349fe7b01d5806bdaf",
                                                      "_id": "6077c4efbc5f4d4df9ef20d3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8357",
                                                              "_id": "6077c4efbc5f4d4df9ef20d4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electronegativity",
                                                      "id": "5ace20349fe7b01d5806bdae",
                                                      "_id": "6077c4efbc5f4d4df9ef20d1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8358",
                                                              "_id": "6077c4efbc5f4d4df9ef20d2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Metallic & Non Metallic character",
                                                      "id": "5ace20349fe7b01d5806bdb1",
                                                      "_id": "6077c4efbc5f4d4df9ef20cf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8359",
                                                              "_id": "6077c4efbc5f4d4df9ef20d0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Oxide Nature",
                                                      "id": "5ace20349fe7b01d5806bdb2",
                                                      "_id": "6077c4efbc5f4d4df9ef20cd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835a",
                                                              "_id": "6077c4efbc5f4d4df9ef20ce"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8219",
                                                      "_id": "6077c4efbc5f4d4df9ef20df"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef20e0"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Areas Related to Circles",
                                              "id": "5ec36b98f05a6036ccbb3817",
                                              "_id": "6077c4efbc5f4d4df9ef20c1",
                                              "concepts": [
                                                  {
                                                      "name": "Perimeter and Area of a Circle",
                                                      "id": "5ec377d2e56f4536c61843cd",
                                                      "_id": "6077c4efbc5f4d4df9ef20c8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe3",
                                                              "_id": "6077c4efbc5f4d4df9ef20c9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of Segment of a Circle",
                                                      "id": "5ec377d2e56f4536c61843cf",
                                                      "_id": "6077c4efbc5f4d4df9ef20c6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe4",
                                                              "_id": "6077c4efbc5f4d4df9ef20c7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area of Sector of a Circle",
                                                      "id": "5ec377d2e56f4536c61843ce",
                                                      "_id": "6077c4efbc5f4d4df9ef20c4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe5",
                                                              "_id": "6077c4efbc5f4d4df9ef20c5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Areas of Combinations of Plane Figures",
                                                      "id": "5ec377d2e56f4536c61843d0",
                                                      "_id": "6077c4efbc5f4d4df9ef20c2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe6",
                                                              "_id": "6077c4efbc5f4d4df9ef20c3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9a9",
                                                      "_id": "6077c4efbc5f4d4df9ef20ca"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Pair of Linear Equations in Two Variables",
                                              "id": "5ec36b98f05a6036ccbb380e",
                                              "_id": "6077c4efbc5f4d4df9ef20b1",
                                              "concepts": [
                                                  {
                                                      "name": "Pair of Linear Equations in Two Variables",
                                                      "id": "5ec36c873d2b7e3af65fefba",
                                                      "_id": "6077c4efbc5f4d4df9ef20be",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe7",
                                                              "_id": "6077c4efbc5f4d4df9ef20bf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cross Multiplication Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbe",
                                                      "_id": "6077c4efbc5f4d4df9ef20bc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe8",
                                                              "_id": "6077c4efbc5f4d4df9ef20bd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditions for Solvability",
                                                      "id": "5ec36c873d2b7e3af65fefbf",
                                                      "_id": "6077c4efbc5f4d4df9ef20ba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbe9",
                                                              "_id": "6077c4efbc5f4d4df9ef20bb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Elimination Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbd",
                                                      "_id": "6077c4efbc5f4d4df9ef20b8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbea",
                                                              "_id": "6077c4efbc5f4d4df9ef20b9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Method of Solution of a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbb",
                                                      "_id": "6077c4efbc5f4d4df9ef20b6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbeb",
                                                              "_id": "6077c4efbc5f4d4df9ef20b7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equations Reducible to a Pair of Linear Equations in Two Variables",
                                                      "id": "5ec36c873d2b7e3af65fefc0",
                                                      "_id": "6077c4efbc5f4d4df9ef20b4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbec",
                                                              "_id": "6077c4efbc5f4d4df9ef20b5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Substitution Method of Solving a Pair of Linear Equations",
                                                      "id": "5ec36c873d2b7e3af65fefbc",
                                                      "_id": "6077c4efbc5f4d4df9ef20b2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbed",
                                                              "_id": "6077c4efbc5f4d4df9ef20b3"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9aa",
                                                      "_id": "6077c4efbc5f4d4df9ef20c0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction to Trigonometry",
                                              "id": "5ec36b98f05a6036ccbb3813",
                                              "_id": "6077c4efbc5f4d4df9ef20a7",
                                              "concepts": [
                                                  {
                                                      "name": "Trigonometric Identities",
                                                      "id": "5ec370e6e56f4536c618425a",
                                                      "_id": "6077c4efbc5f4d4df9ef20ae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbee",
                                                              "_id": "6077c4efbc5f4d4df9ef20af"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Complementary Angles",
                                                      "id": "5ec370e6e56f4536c6184259",
                                                      "_id": "6077c4efbc5f4d4df9ef20ac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbef",
                                                              "_id": "6077c4efbc5f4d4df9ef20ad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios",
                                                      "id": "5ec370e6e56f4536c6184257",
                                                      "_id": "6077c4efbc5f4d4df9ef20aa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf0",
                                                              "_id": "6077c4efbc5f4d4df9ef20ab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Trigonometric Ratios of Some Specific Angles",
                                                      "id": "5ec370e6e56f4536c6184258",
                                                      "_id": "6077c4efbc5f4d4df9ef20a8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf1",
                                                              "_id": "6077c4efbc5f4d4df9ef20a9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ab",
                                                      "_id": "6077c4efbc5f4d4df9ef20b0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Surface Areas and Volumes",
                                              "id": "5ec36b98f05a6036ccbb3818",
                                              "_id": "6077c4efbc5f4d4df9ef209d",
                                              "concepts": [
                                                  {
                                                      "name": "Frustum of a Cone",
                                                      "id": "5ec3783d497e903afb98dc9f",
                                                      "_id": "6077c4efbc5f4d4df9ef20a4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf2",
                                                              "_id": "6077c4efbc5f4d4df9ef20a5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume of a Combination of Solids",
                                                      "id": "5ec3783d497e903afb98dc9d",
                                                      "_id": "6077c4efbc5f4d4df9ef20a2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf3",
                                                              "_id": "6077c4efbc5f4d4df9ef20a3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area of a Combination of Solids",
                                                      "id": "5ec3783d497e903afb98dc9c",
                                                      "_id": "6077c4efbc5f4d4df9ef20a0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf4",
                                                              "_id": "6077c4efbc5f4d4df9ef20a1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion of Solid from One Shape to Another",
                                                      "id": "5ec3783d497e903afb98dc9e",
                                                      "_id": "6077c4efbc5f4d4df9ef209e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbf5",
                                                              "_id": "6077c4efbc5f4d4df9ef209f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ac",
                                                      "_id": "6077c4efbc5f4d4df9ef20a6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Some Applications of Trigonometry",
                                              "id": "5ec36b98f05a6036ccbb3814",
                                              "_id": "6077c4efbc5f4d4df9ef2099",
                                              "concepts": [
                                                  {
                                                      "name": "Heights and Distances",
                                                      "id": "5ec376b9f05a6036ccbb38cf",
                                                      "_id": "6077c4efbc5f4d4df9ef209a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfb",
                                                              "_id": "6077c4efbc5f4d4df9ef209b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ae",
                                                      "_id": "6077c4efbc5f4d4df9ef209c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5ec36b98f05a6036ccbb3819",
                                              "_id": "6077c4efbc5f4d4df9ef208b",
                                              "concepts": [
                                                  {
                                                      "name": "Mode of Grouped Data",
                                                      "id": "5ec37898e56f4536c6184408",
                                                      "_id": "6077c4efbc5f4d4df9ef2096",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfc",
                                                              "_id": "6077c4efbc5f4d4df9ef2097"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Direct Method",
                                                      "id": "5ec37898e56f4536c6184405",
                                                      "_id": "6077c4efbc5f4d4df9ef2094",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfd",
                                                              "_id": "6077c4efbc5f4d4df9ef2095"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Assumed Mean Method",
                                                      "id": "5ec37898e56f4536c6184406",
                                                      "_id": "6077c4efbc5f4d4df9ef2092",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbfe",
                                                              "_id": "6077c4efbc5f4d4df9ef2093"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean of Grouped Data Using Step Deviation Method",
                                                      "id": "5ec37898e56f4536c6184407",
                                                      "_id": "6077c4efbc5f4d4df9ef2090",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dbff",
                                                              "_id": "6077c4efbc5f4d4df9ef2091"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Median of Grouped Data",
                                                      "id": "5ec37898e56f4536c6184409",
                                                      "_id": "6077c4efbc5f4d4df9ef208e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc00",
                                                              "_id": "6077c4efbc5f4d4df9ef208f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphical Representation of Cumulative Frequency Distribution",
                                                      "id": "5ec37898e56f4536c618440a",
                                                      "_id": "6077c4efbc5f4d4df9ef208c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc01",
                                                              "_id": "6077c4efbc5f4d4df9ef208d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9af",
                                                      "_id": "6077c4efbc5f4d4df9ef2098"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ec36b98f05a6036ccbb381a",
                                              "_id": "6077c4efbc5f4d4df9ef2083",
                                              "concepts": [
                                                  {
                                                      "name": "Sure and Impossible Events",
                                                      "id": "5ec378d0e56f4536c618441d",
                                                      "_id": "6077c4efbc5f4d4df9ef2088",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc02",
                                                              "_id": "6077c4efbc5f4d4df9ef2089"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of an Event",
                                                      "id": "5ec378d0e56f4536c618441b",
                                                      "_id": "6077c4efbc5f4d4df9ef2086",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc03",
                                                              "_id": "6077c4efbc5f4d4df9ef2087"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability of Complement of an Event",
                                                      "id": "5ec378d0e56f4536c618441c",
                                                      "_id": "6077c4efbc5f4d4df9ef2084",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc04",
                                                              "_id": "6077c4efbc5f4d4df9ef2085"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b0",
                                                      "_id": "6077c4efbc5f4d4df9ef208a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f687f33058075680d816492",
                                              "_id": "6077c4efbc5f4d4df9ef2075",
                                              "concepts": [
                                                  {
                                                      "name": "Concurrency Theorems",
                                                      "id": "5f688427ca5ac358f1705c72",
                                                      "_id": "6077c4efbc5f4d4df9ef2080",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0b",
                                                              "_id": "6077c4efbc5f4d4df9ef2081"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thales Theorem And Angle Bisector Theorem",
                                                      "id": "5f688427ca5ac358f1705c6f",
                                                      "_id": "6077c4efbc5f4d4df9ef207e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0c",
                                                              "_id": "6077c4efbc5f4d4df9ef207f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pythagoras Theorem",
                                                      "id": "5f688427ca5ac358f1705c70",
                                                      "_id": "6077c4efbc5f4d4df9ef207c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0d",
                                                              "_id": "6077c4efbc5f4d4df9ef207d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c6d",
                                                      "_id": "6077c4efbc5f4d4df9ef207a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0e",
                                                              "_id": "6077c4efbc5f4d4df9ef207b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circles And Tangents",
                                                      "id": "5f688427ca5ac358f1705c71",
                                                      "_id": "6077c4efbc5f4d4df9ef2078",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc0f",
                                                              "_id": "6077c4efbc5f4d4df9ef2079"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Similarity",
                                                      "id": "5f688427ca5ac358f1705c6e",
                                                      "_id": "6077c4efbc5f4d4df9ef2076",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc10",
                                                              "_id": "6077c4efbc5f4d4df9ef2077"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b3",
                                                      "_id": "6077c4efbc5f4d4df9ef2082"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f687f33058075680d816493",
                                              "_id": "6077c4efbc5f4d4df9ef2067",
                                              "concepts": [
                                                  {
                                                      "name": "Inclination Of A Line",
                                                      "id": "5f688427ca5ac358f1705c76",
                                                      "_id": "6077c4efbc5f4d4df9ef2072",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc11",
                                                              "_id": "6077c4efbc5f4d4df9ef2073"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area Of A Quadrilateral",
                                                      "id": "5f688427ca5ac358f1705c75",
                                                      "_id": "6077c4efbc5f4d4df9ef2070",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc12",
                                                              "_id": "6077c4efbc5f4d4df9ef2071"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c73",
                                                      "_id": "6077c4efbc5f4d4df9ef206e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc13",
                                                              "_id": "6077c4efbc5f4d4df9ef206f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "General Form Of A Straight Line",
                                                      "id": "5f688427ca5ac358f1705c78",
                                                      "_id": "6077c4efbc5f4d4df9ef206c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc14",
                                                              "_id": "6077c4efbc5f4d4df9ef206d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Area Of A Triangle",
                                                      "id": "5f688427ca5ac358f1705c74",
                                                      "_id": "6077c4efbc5f4d4df9ef206a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc15",
                                                              "_id": "6077c4efbc5f4d4df9ef206b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Straight Line",
                                                      "id": "5f688427ca5ac358f1705c77",
                                                      "_id": "6077c4efbc5f4d4df9ef2068",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc16",
                                                              "_id": "6077c4efbc5f4d4df9ef2069"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b4",
                                                      "_id": "6077c4efbc5f4d4df9ef2074"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Numbers And Sequences",
                                              "id": "5f687f33058075680d816490",
                                              "_id": "6077c4efbc5f4d4df9ef204f",
                                              "concepts": [
                                                  {
                                                      "name": "Special Series",
                                                      "id": "5f688427ca5ac358f1705c63",
                                                      "_id": "6077c4efbc5f4d4df9ef2064",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc17",
                                                              "_id": "6077c4efbc5f4d4df9ef2065"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sum To N Terms Of A Geometric Progression",
                                                      "id": "5f688427ca5ac358f1705c62",
                                                      "_id": "6077c4efbc5f4d4df9ef2062",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc18",
                                                              "_id": "6077c4efbc5f4d4df9ef2063"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arithmetic Progression",
                                                      "id": "5f688427ca5ac358f1705c5f",
                                                      "_id": "6077c4efbc5f4d4df9ef2060",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc19",
                                                              "_id": "6077c4efbc5f4d4df9ef2061"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid’s Division Algorithm",
                                                      "id": "5f688427ca5ac358f1705c5b",
                                                      "_id": "6077c4efbc5f4d4df9ef205e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1a",
                                                              "_id": "6077c4efbc5f4d4df9ef205f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorem Of Arithmetic",
                                                      "id": "5f688427ca5ac358f1705c5c",
                                                      "_id": "6077c4efbc5f4d4df9ef205c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1b",
                                                              "_id": "6077c4efbc5f4d4df9ef205d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c59",
                                                      "_id": "6077c4efbc5f4d4df9ef205a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1c",
                                                              "_id": "6077c4efbc5f4d4df9ef205b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modular Arithmetic",
                                                      "id": "5f688427ca5ac358f1705c5d",
                                                      "_id": "6077c4efbc5f4d4df9ef2058",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1d",
                                                              "_id": "6077c4efbc5f4d4df9ef2059"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometric Progression",
                                                      "id": "5f688427ca5ac358f1705c61",
                                                      "_id": "6077c4efbc5f4d4df9ef2056",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1e",
                                                              "_id": "6077c4efbc5f4d4df9ef2057"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sequences",
                                                      "id": "5f688427ca5ac358f1705c5e",
                                                      "_id": "6077c4efbc5f4d4df9ef2054",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc1f",
                                                              "_id": "6077c4efbc5f4d4df9ef2055"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Euclid’s Division Lemma",
                                                      "id": "5f688427ca5ac358f1705c5a",
                                                      "_id": "6077c4efbc5f4d4df9ef2052",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc20",
                                                              "_id": "6077c4efbc5f4d4df9ef2053"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series",
                                                      "id": "5f688427ca5ac358f1705c60",
                                                      "_id": "6077c4efbc5f4d4df9ef2050",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc21",
                                                              "_id": "6077c4efbc5f4d4df9ef2051"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b5",
                                                      "_id": "6077c4efbc5f4d4df9ef2066"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef20cb"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Nature Of Physical World And Measurement",
                                              "id": "5f6860f5058075680d815458",
                                              "_id": "6077c4efbc5f4d4df9ef203c",
                                              "concepts": [
                                                  {
                                                      "name": "Theory Of Errors",
                                                      "id": "5f6862f9f100a06808b0f5a6",
                                                      "_id": "6077c4efbc5f4d4df9ef204b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7e",
                                                              "_id": "6077c4efbc5f4d4df9ef204c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Physics - Introduction",
                                                      "id": "5f6862f9f100a06808b0f5a2",
                                                      "_id": "6077c4efbc5f4d4df9ef2049",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de7f",
                                                              "_id": "6077c4efbc5f4d4df9ef204a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Physics In Relation To Technology And Society",
                                                      "id": "5f6862f9f100a06808b0f5a3",
                                                      "_id": "6077c4efbc5f4d4df9ef2047",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de80",
                                                              "_id": "6077c4efbc5f4d4df9ef2048"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Dimensional Analysis",
                                                      "id": "5f6862f9f100a06808b0f5a8",
                                                      "_id": "6077c4efbc5f4d4df9ef2045",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de81",
                                                              "_id": "6077c4efbc5f4d4df9ef2046"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Significant Figures",
                                                      "id": "5f6862f9f100a06808b0f5a7",
                                                      "_id": "6077c4efbc5f4d4df9ef2043",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de82",
                                                              "_id": "6077c4efbc5f4d4df9ef2044"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Science—Introduction",
                                                      "id": "5f6862f9f100a06808b0f5a1",
                                                      "_id": "6077c4efbc5f4d4df9ef2041",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de83",
                                                              "_id": "6077c4efbc5f4d4df9ef2042"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measurement Of Basic Quantities",
                                                      "id": "5f6862f9f100a06808b0f5a5",
                                                      "_id": "6077c4efbc5f4d4df9ef203f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de84",
                                                              "_id": "6077c4efbc5f4d4df9ef2040"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measurement",
                                                      "id": "5f6862f9f100a06808b0f5a4",
                                                      "_id": "6077c4efbc5f4d4df9ef203d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de85",
                                                              "_id": "6077c4efbc5f4d4df9ef203e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd78",
                                                      "_id": "6077c4efbc5f4d4df9ef204d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Work, Energy And Power",
                                              "id": "5f6860f5058075680d81545b",
                                              "_id": "6077c4efbc5f4d4df9ef2030",
                                              "concepts": [
                                                  {
                                                      "name": "Energy",
                                                      "id": "5f6862f9f100a06808b0f5bd",
                                                      "_id": "6077c4efbc5f4d4df9ef2039",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de86",
                                                              "_id": "6077c4efbc5f4d4df9ef203a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6862f9f100a06808b0f5bb",
                                                      "_id": "6077c4efbc5f4d4df9ef2037",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de87",
                                                              "_id": "6077c4efbc5f4d4df9ef2038"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Work",
                                                      "id": "5f6862f9f100a06808b0f5bc",
                                                      "_id": "6077c4efbc5f4d4df9ef2035",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de88",
                                                              "_id": "6077c4efbc5f4d4df9ef2036"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Collisions",
                                                      "id": "5f6862f9f100a06808b0f5bf",
                                                      "_id": "6077c4efbc5f4d4df9ef2033",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de89",
                                                              "_id": "6077c4efbc5f4d4df9ef2034"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power",
                                                      "id": "5f6862f9f100a06808b0f5be",
                                                      "_id": "6077c4efbc5f4d4df9ef2031",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de8a",
                                                              "_id": "6077c4efbc5f4d4df9ef2032"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd79",
                                                      "_id": "6077c4efbc5f4d4df9ef203b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Principle of communication",
                                              "id": "5ace20329fe7b01d5806bcb6",
                                              "_id": "6077c4efbc5f4d4df9ef202c",
                                              "concepts": [
                                                  {
                                                      "name": "Basic of electronic communication",
                                                      "id": "5ace20419fe7b01d5806c1d2",
                                                      "_id": "6077c4efbc5f4d4df9ef202d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de96",
                                                              "_id": "6077c4efbc5f4d4df9ef202e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7b",
                                                      "_id": "6077c4efbc5f4d4df9ef202f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semi conductors",
                                              "id": "5ace20329fe7b01d5806bcb7",
                                              "_id": "6077c4efbc5f4d4df9ef2026",
                                              "concepts": [
                                                  {
                                                      "name": "basic of semiconductors, semiconductors diode, junction transistor",
                                                      "id": "5ace20419fe7b01d5806c1d3",
                                                      "_id": "6077c4efbc5f4d4df9ef2029",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de97",
                                                              "_id": "6077c4efbc5f4d4df9ef202a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "digital electronics and logic gates",
                                                      "id": "5ace20419fe7b01d5806c1d4",
                                                      "_id": "6077c4efbc5f4d4df9ef2027",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de98",
                                                              "_id": "6077c4efbc5f4d4df9ef2028"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7c",
                                                      "_id": "6077c4efbc5f4d4df9ef202b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef204e"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Figure analogy",
                                              "id": "5ace20309fe7b01d5806bc2a",
                                              "_id": "6077c4efbc5f4d4df9ef2021",
                                              "concepts": [
                                                  {
                                                      "name": "Figure analogy",
                                                      "id": "5ace20389fe7b01d5806bf1a",
                                                      "_id": "6077c4efbc5f4d4df9ef2022",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843e",
                                                              "_id": "6077c4efbc5f4d4df9ef2023"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8258",
                                                      "_id": "6077c4efbc5f4d4df9ef2024"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Figure classification & Figure counting",
                                              "id": "5ace20319fe7b01d5806bc2b",
                                              "_id": "6077c4efbc5f4d4df9ef201d",
                                              "concepts": [
                                                  {
                                                      "name": "Figure classification & Figure counting",
                                                      "id": "5ace20389fe7b01d5806bf1b",
                                                      "_id": "6077c4efbc5f4d4df9ef201e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c843f",
                                                              "_id": "6077c4efbc5f4d4df9ef201f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8259",
                                                      "_id": "6077c4efbc5f4d4df9ef2020"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef2025"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Electoral Politics",
                                              "id": "5ace20329fe7b01d5806bce6",
                                              "_id": "6077c4efbc5f4d4df9ef2018",
                                              "concepts": [
                                                  {
                                                      "name": "Needs of election & steps involved in it.",
                                                      "id": "5ace20429fe7b01d5806c231",
                                                      "_id": "6077c4efbc5f4d4df9ef2019",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c848f",
                                                              "_id": "6077c4efbc5f4d4df9ef201a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8288",
                                                      "_id": "6077c4efbc5f4d4df9ef201b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Working of Institutions",
                                              "id": "5ace20329fe7b01d5806bcee",
                                              "_id": "6077c4efbc5f4d4df9ef2014",
                                              "concepts": [
                                                  {
                                                      "name": "Functions of legislature, \nexecutive and judiciary",
                                                      "id": "5ace20429fe7b01d5806c23d",
                                                      "_id": "6077c4efbc5f4d4df9ef2015",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8490",
                                                              "_id": "6077c4efbc5f4d4df9ef2016"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8289",
                                                      "_id": "6077c4efbc5f4d4df9ef2017"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Democratic Rights",
                                              "id": "5ace20329fe7b01d5806bce5",
                                              "_id": "6077c4efbc5f4d4df9ef2010",
                                              "concepts": [
                                                  {
                                                      "name": "The fundamental rights & the writs.",
                                                      "id": "5ace20429fe7b01d5806c230",
                                                      "_id": "6077c4efbc5f4d4df9ef2011",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8491",
                                                              "_id": "6077c4efbc5f4d4df9ef2012"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828a",
                                                      "_id": "6077c4efbc5f4d4df9ef2013"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef201c"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Pattern Perception",
                                              "id": "5ace20309fe7b01d5806bc1a",
                                              "_id": "6077c4efbc5f4d4df9ef200b",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Completion",
                                                      "id": "5ace20389fe7b01d5806bf05",
                                                      "_id": "6077c4efbc5f4d4df9ef200c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4a",
                                                              "_id": "6077c4efbc5f4d4df9ef200d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3b",
                                                      "_id": "6077c4efbc5f4d4df9ef200e"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef200f"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 9,
                              "startDate": "2021-06-24T00:00:00.000Z",
                              "endDate": "2021-06-30T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef1ee2",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Heredity & Evolution",
                                              "id": "5ace202f9fe7b01d5806bbbe",
                                              "_id": "6077c4efbc5f4d4df9ef1ffb",
                                              "concepts": [
                                                  {
                                                      "name": "Mendel's laws of genetics, Mendelian ratios",
                                                      "id": "5ace20339fe7b01d5806bd24",
                                                      "_id": "6077c4efbc5f4d4df9ef2006",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8308",
                                                              "_id": "6077c4efbc5f4d4df9ef2007"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Experiments to show DNA as genetic material, Structure of DNA, Types of chromosomes",
                                                      "id": "5ace20339fe7b01d5806bd23",
                                                      "_id": "6077c4efbc5f4d4df9ef2004",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8309",
                                                              "_id": "6077c4efbc5f4d4df9ef2005"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sex determination in Human and Genetic Disorders",
                                                      "id": "5ace20339fe7b01d5806bd25",
                                                      "_id": "6077c4efbc5f4d4df9ef2002",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830a",
                                                              "_id": "6077c4efbc5f4d4df9ef2003"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories of Origin of Life",
                                                      "id": "5ace20339fe7b01d5806bd27",
                                                      "_id": "6077c4efbc5f4d4df9ef2000",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830b",
                                                              "_id": "6077c4efbc5f4d4df9ef2001"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories of Evolution",
                                                      "id": "5ace20339fe7b01d5806bd26",
                                                      "_id": "6077c4efbc5f4d4df9ef1ffe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830c",
                                                              "_id": "6077c4efbc5f4d4df9ef1fff"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Evidences of Evolution",
                                                      "id": "5ace20339fe7b01d5806bd22",
                                                      "_id": "6077c4efbc5f4d4df9ef1ffc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830d",
                                                              "_id": "6077c4efbc5f4d4df9ef1ffd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c820f",
                                                      "_id": "6077c4efbc5f4d4df9ef2008"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef2009"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [
                                          {
                                              "name": "Carbon Compounds",
                                              "id": "5ace202f9fe7b01d5806bbc9",
                                              "_id": "6077c4efbc5f4d4df9ef1fea",
                                              "concepts": [
                                                  {
                                                      "name": "IUPAC Nomenclature",
                                                      "id": "5ace20349fe7b01d5806bd8b",
                                                      "_id": "6077c4efbc5f4d4df9ef1ff7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835b",
                                                              "_id": "6077c4efbc5f4d4df9ef1ff8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Versatile Nature Of Carbon, Some Compounds Of Carbon",
                                                      "id": "5ace20349fe7b01d5806bd8f",
                                                      "_id": "6077c4efbc5f4d4df9ef1ff5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835c",
                                                              "_id": "6077c4efbc5f4d4df9ef1ff6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Isomerism",
                                                      "id": "5ace20349fe7b01d5806bd8a",
                                                      "_id": "6077c4efbc5f4d4df9ef1ff3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835d",
                                                              "_id": "6077c4efbc5f4d4df9ef1ff4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types of Organic Reactions",
                                                      "id": "5ace20349fe7b01d5806bd8e",
                                                      "_id": "6077c4efbc5f4d4df9ef1ff1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835e",
                                                              "_id": "6077c4efbc5f4d4df9ef1ff2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polymers",
                                                      "id": "5ace20349fe7b01d5806bd8c",
                                                      "_id": "6077c4efbc5f4d4df9ef1fef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c835f",
                                                              "_id": "6077c4efbc5f4d4df9ef1ff0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Soaps & Detergents",
                                                      "id": "5ace20349fe7b01d5806bd8d",
                                                      "_id": "6077c4efbc5f4d4df9ef1fed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8360",
                                                              "_id": "6077c4efbc5f4d4df9ef1fee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Allotropes of Carbon",
                                                      "id": "5ace20349fe7b01d5806bd89",
                                                      "_id": "6077c4efbc5f4d4df9ef1feb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8361",
                                                              "_id": "6077c4efbc5f4d4df9ef1fec"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c821a",
                                                      "_id": "6077c4efbc5f4d4df9ef1ff9"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef1ffa"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Mensuration",
                                              "id": "5f687f33058075680d816495",
                                              "_id": "6077c4efbc5f4d4df9ef1fdd",
                                              "concepts": [
                                                  {
                                                      "name": "Volume And Surface Area Of Combined Solids",
                                                      "id": "5f688427ca5ac358f1705c7f",
                                                      "_id": "6077c4efbc5f4d4df9ef1fe6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc22",
                                                              "_id": "6077c4efbc5f4d4df9ef1fe7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Surface Area",
                                                      "id": "5f688427ca5ac358f1705c7d",
                                                      "_id": "6077c4efbc5f4d4df9ef1fe4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc23",
                                                              "_id": "6077c4efbc5f4d4df9ef1fe5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conversion Of Solids From One Shape To Another With No Change In Volume",
                                                      "id": "5f688427ca5ac358f1705c80",
                                                      "_id": "6077c4efbc5f4d4df9ef1fe2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc24",
                                                              "_id": "6077c4efbc5f4d4df9ef1fe3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume",
                                                      "id": "5f688427ca5ac358f1705c7e",
                                                      "_id": "6077c4efbc5f4d4df9ef1fe0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc25",
                                                              "_id": "6077c4efbc5f4d4df9ef1fe1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c7c",
                                                      "_id": "6077c4efbc5f4d4df9ef1fde",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc26",
                                                              "_id": "6077c4efbc5f4d4df9ef1fdf"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b6",
                                                      "_id": "6077c4efbc5f4d4df9ef1fe8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Algebra",
                                              "id": "5f687f33058075680d816491",
                                              "_id": "6077c4efbc5f4d4df9ef1fc9",
                                              "concepts": [
                                                  {
                                                      "name": "Simultaneous Linear Equations In Three Variables",
                                                      "id": "5f688427ca5ac358f1705c65",
                                                      "_id": "6077c4efbc5f4d4df9ef1fda",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc27",
                                                              "_id": "6077c4efbc5f4d4df9ef1fdb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Square Root Of Polynomials",
                                                      "id": "5f688427ca5ac358f1705c68",
                                                      "_id": "6077c4efbc5f4d4df9ef1fd8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc28",
                                                              "_id": "6077c4efbc5f4d4df9ef1fd9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c64",
                                                      "_id": "6077c4efbc5f4d4df9ef1fd6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc29",
                                                              "_id": "6077c4efbc5f4d4df9ef1fd7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matrices",
                                                      "id": "5f688427ca5ac358f1705c6c",
                                                      "_id": "6077c4efbc5f4d4df9ef1fd4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2a",
                                                              "_id": "6077c4efbc5f4d4df9ef1fd5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic Graphs",
                                                      "id": "5f688427ca5ac358f1705c6b",
                                                      "_id": "6077c4efbc5f4d4df9ef1fd2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2b",
                                                              "_id": "6077c4efbc5f4d4df9ef1fd3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graph Of Variations",
                                                      "id": "5f688427ca5ac358f1705c6a",
                                                      "_id": "6077c4efbc5f4d4df9ef1fd0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2c",
                                                              "_id": "6077c4efbc5f4d4df9ef1fd1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadratic Equations",
                                                      "id": "5f688427ca5ac358f1705c69",
                                                      "_id": "6077c4efbc5f4d4df9ef1fce",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2d",
                                                              "_id": "6077c4efbc5f4d4df9ef1fcf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Expressions",
                                                      "id": "5f688427ca5ac358f1705c67",
                                                      "_id": "6077c4efbc5f4d4df9ef1fcc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2e",
                                                              "_id": "6077c4efbc5f4d4df9ef1fcd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "GCD And LCM Of Polynomials",
                                                      "id": "5f688427ca5ac358f1705c66",
                                                      "_id": "6077c4efbc5f4d4df9ef1fca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc2f",
                                                              "_id": "6077c4efbc5f4d4df9ef1fcb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b7",
                                                      "_id": "6077c4efbc5f4d4df9ef1fdc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics And Probability",
                                              "id": "5f687f33058075680d816496",
                                              "_id": "6077c4efbc5f4d4df9ef1fbb",
                                              "concepts": [
                                                  {
                                                      "name": "Measures Of Dispersion",
                                                      "id": "5f688427ca5ac358f1705c82",
                                                      "_id": "6077c4efbc5f4d4df9ef1fc6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc30",
                                                              "_id": "6077c4efbc5f4d4df9ef1fc7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Probability",
                                                      "id": "5f688427ca5ac358f1705c84",
                                                      "_id": "6077c4efbc5f4d4df9ef1fc4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc31",
                                                              "_id": "6077c4efbc5f4d4df9ef1fc5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebra Of Events",
                                                      "id": "5f688427ca5ac358f1705c85",
                                                      "_id": "6077c4efbc5f4d4df9ef1fc2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc32",
                                                              "_id": "6077c4efbc5f4d4df9ef1fc3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coefficient Of Variation",
                                                      "id": "5f688427ca5ac358f1705c83",
                                                      "_id": "6077c4efbc5f4d4df9ef1fc0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc33",
                                                              "_id": "6077c4efbc5f4d4df9ef1fc1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c81",
                                                      "_id": "6077c4efbc5f4d4df9ef1fbe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc34",
                                                              "_id": "6077c4efbc5f4d4df9ef1fbf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Addition Theorem Of Probability",
                                                      "id": "5f688427ca5ac358f1705c86",
                                                      "_id": "6077c4efbc5f4d4df9ef1fbc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc35",
                                                              "_id": "6077c4efbc5f4d4df9ef1fbd"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9b8",
                                                      "_id": "6077c4efbc5f4d4df9ef1fc8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Relations And Functions",
                                              "id": "5f687f33058075680d81648f",
                                              "_id": "6077c4efbc5f4d4df9ef1fa5",
                                              "concepts": [
                                                  {
                                                      "name": "Cartesian Product",
                                                      "id": "5f688427ca5ac358f1705c51",
                                                      "_id": "6077c4efbc5f4d4df9ef1fb8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc39",
                                                              "_id": "6077c4efbc5f4d4df9ef1fb9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Functions",
                                                      "id": "5f688427ca5ac358f1705c55",
                                                      "_id": "6077c4efbc5f4d4df9ef1fb6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3a",
                                                              "_id": "6077c4efbc5f4d4df9ef1fb7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of Functions",
                                                      "id": "5f688427ca5ac358f1705c54",
                                                      "_id": "6077c4efbc5f4d4df9ef1fb4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3b",
                                                              "_id": "6077c4efbc5f4d4df9ef1fb5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relations",
                                                      "id": "5f688427ca5ac358f1705c52",
                                                      "_id": "6077c4efbc5f4d4df9ef1fb2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3c",
                                                              "_id": "6077c4efbc5f4d4df9ef1fb3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Special Cases Of Functions",
                                                      "id": "5f688427ca5ac358f1705c56",
                                                      "_id": "6077c4efbc5f4d4df9ef1fb0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3d",
                                                              "_id": "6077c4efbc5f4d4df9ef1fb1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f688427ca5ac358f1705c4f",
                                                      "_id": "6077c4efbc5f4d4df9ef1fae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3e",
                                                              "_id": "6077c4efbc5f4d4df9ef1faf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ordered Pair",
                                                      "id": "5f688427ca5ac358f1705c50",
                                                      "_id": "6077c4efbc5f4d4df9ef1fac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc3f",
                                                              "_id": "6077c4efbc5f4d4df9ef1fad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Identifying The Graphs Of Linear, Quadratic, Cubic And Reciprocal Functions",
                                                      "id": "5f688427ca5ac358f1705c58",
                                                      "_id": "6077c4efbc5f4d4df9ef1faa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc40",
                                                              "_id": "6077c4efbc5f4d4df9ef1fab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Composition Of Functions",
                                                      "id": "5f688427ca5ac358f1705c57",
                                                      "_id": "6077c4efbc5f4d4df9ef1fa8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc41",
                                                              "_id": "6077c4efbc5f4d4df9ef1fa9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions",
                                                      "id": "5f688427ca5ac358f1705c53",
                                                      "_id": "6077c4efbc5f4d4df9ef1fa6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc42",
                                                              "_id": "6077c4efbc5f4d4df9ef1fa7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ba",
                                                      "_id": "6077c4efbc5f4d4df9ef1fba"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Set Language",
                                              "id": "5f64aec082532750fe359c1c",
                                              "_id": "6077c4efbc5f4d4df9ef1f93",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f657fbf03e86d7fe78b3e5e",
                                                      "_id": "6077c4efbc5f4d4df9ef1fa2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc47",
                                                              "_id": "6077c4efbc5f4d4df9ef1fa3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application On Cardinality Of Sets:",
                                                      "id": "5f657fbf03e86d7fe78b3e65",
                                                      "_id": "6077c4efbc5f4d4df9ef1fa0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc48",
                                                              "_id": "6077c4efbc5f4d4df9ef1fa1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of A Set",
                                                      "id": "5f657fbf03e86d7fe78b3e60",
                                                      "_id": "6077c4efbc5f4d4df9ef1f9e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc49",
                                                              "_id": "6077c4efbc5f4d4df9ef1f9f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Set Operations",
                                                      "id": "5f657fbf03e86d7fe78b3e63",
                                                      "_id": "6077c4efbc5f4d4df9ef1f9c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4a",
                                                              "_id": "6077c4efbc5f4d4df9ef1f9d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Sets",
                                                      "id": "5f657fbf03e86d7fe78b3e61",
                                                      "_id": "6077c4efbc5f4d4df9ef1f9a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4b",
                                                              "_id": "6077c4efbc5f4d4df9ef1f9b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Set",
                                                      "id": "5f657fbf03e86d7fe78b3e5f",
                                                      "_id": "6077c4efbc5f4d4df9ef1f98",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4c",
                                                              "_id": "6077c4efbc5f4d4df9ef1f99"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’s Laws",
                                                      "id": "5f657fbf03e86d7fe78b3e64",
                                                      "_id": "6077c4efbc5f4d4df9ef1f96",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4d",
                                                              "_id": "6077c4efbc5f4d4df9ef1f97"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Set Operations",
                                                      "id": "5f657fbf03e86d7fe78b3e62",
                                                      "_id": "6077c4efbc5f4d4df9ef1f94",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4e",
                                                              "_id": "6077c4efbc5f4d4df9ef1f95"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bc",
                                                      "_id": "6077c4efbc5f4d4df9ef1fa4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Algebra",
                                              "id": "5f64aec082532750fe359c1e",
                                              "_id": "6077c4efbc5f4d4df9ef1f81",
                                              "concepts": [
                                                  {
                                                      "name": "Division of Polynomials",
                                                      "id": "5f65877582532750fe35cff4",
                                                      "_id": "6077c4efbc5f4d4df9ef1f90",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc4f",
                                                              "_id": "6077c4efbc5f4d4df9ef1f91"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials",
                                                      "id": "5f65877582532750fe35cff0",
                                                      "_id": "6077c4efbc5f4d4df9ef1f8e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc50",
                                                              "_id": "6077c4efbc5f4d4df9ef1f8f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35cfef",
                                                      "_id": "6077c4efbc5f4d4df9ef1f8c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc51",
                                                              "_id": "6077c4efbc5f4d4df9ef1f8d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorisation",
                                                      "id": "5f65877582532750fe35cff3",
                                                      "_id": "6077c4efbc5f4d4df9ef1f8a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc52",
                                                              "_id": "6077c4efbc5f4d4df9ef1f8b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Equation In Two Variables",
                                                      "id": "5f65877582532750fe35cff6",
                                                      "_id": "6077c4efbc5f4d4df9ef1f88",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc53",
                                                              "_id": "6077c4efbc5f4d4df9ef1f89"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Greatest Common Divisor (Gcd)",
                                                      "id": "5f65877582532750fe35cff5",
                                                      "_id": "6077c4efbc5f4d4df9ef1f86",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc54",
                                                              "_id": "6077c4efbc5f4d4df9ef1f87"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Algebraic Identities",
                                                      "id": "5f65877582532750fe35cff2",
                                                      "_id": "6077c4efbc5f4d4df9ef1f84",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc55",
                                                              "_id": "6077c4efbc5f4d4df9ef1f85"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Remainder Theorem",
                                                      "id": "5f65877582532750fe35cff1",
                                                      "_id": "6077c4efbc5f4d4df9ef1f82",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc56",
                                                              "_id": "6077c4efbc5f4d4df9ef1f83"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bd",
                                                      "_id": "6077c4efbc5f4d4df9ef1f92"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statistics",
                                              "id": "5f64aec082532750fe359c23",
                                              "_id": "6077c4efbc5f4d4df9ef1f73",
                                              "concepts": [
                                                  {
                                                      "name": "Median",
                                                      "id": "5f65877582532750fe35d012",
                                                      "_id": "6077c4efbc5f4d4df9ef1f7e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc57",
                                                              "_id": "6077c4efbc5f4d4df9ef1f7f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d00e",
                                                      "_id": "6077c4efbc5f4d4df9ef1f7c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc58",
                                                              "_id": "6077c4efbc5f4d4df9ef1f7d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Collection Of Data",
                                                      "id": "5f65877582532750fe35d00f",
                                                      "_id": "6077c4efbc5f4d4df9ef1f7a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc59",
                                                              "_id": "6077c4efbc5f4d4df9ef1f7b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mode",
                                                      "id": "5f65877582532750fe35d013",
                                                      "_id": "6077c4efbc5f4d4df9ef1f78",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5a",
                                                              "_id": "6077c4efbc5f4d4df9ef1f79"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Measures Of Central Tendency",
                                                      "id": "5f65877582532750fe35d010",
                                                      "_id": "6077c4efbc5f4d4df9ef1f76",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5b",
                                                              "_id": "6077c4efbc5f4d4df9ef1f77"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Arithmetic Mean",
                                                      "id": "5f65877582532750fe35d011",
                                                      "_id": "6077c4efbc5f4d4df9ef1f74",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5c",
                                                              "_id": "6077c4efbc5f4d4df9ef1f75"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9be",
                                                      "_id": "6077c4efbc5f4d4df9ef1f80"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5f64aec082532750fe359c24",
                                              "_id": "6077c4efbc5f4d4df9ef1f67",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d014",
                                                      "_id": "6077c4efbc5f4d4df9ef1f70",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5d",
                                                              "_id": "6077c4efbc5f4d4df9ef1f71"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Ideas",
                                                      "id": "5f65877582532750fe35d015",
                                                      "_id": "6077c4efbc5f4d4df9ef1f6e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5e",
                                                              "_id": "6077c4efbc5f4d4df9ef1f6f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classical Approach",
                                                      "id": "5f65877582532750fe35d016",
                                                      "_id": "6077c4efbc5f4d4df9ef1f6c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc5f",
                                                              "_id": "6077c4efbc5f4d4df9ef1f6d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Empirical Approach",
                                                      "id": "5f65877582532750fe35d017",
                                                      "_id": "6077c4efbc5f4d4df9ef1f6a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc60",
                                                              "_id": "6077c4efbc5f4d4df9ef1f6b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Events",
                                                      "id": "5f65877582532750fe35d018",
                                                      "_id": "6077c4efbc5f4d4df9ef1f68",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc61",
                                                              "_id": "6077c4efbc5f4d4df9ef1f69"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9bf",
                                                      "_id": "6077c4efbc5f4d4df9ef1f72"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Geometry",
                                              "id": "5f64aec082532750fe359c1f",
                                              "_id": "6077c4efbc5f4d4df9ef1f57",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35cff7",
                                                      "_id": "6077c4efbc5f4d4df9ef1f64",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc62",
                                                              "_id": "6077c4efbc5f4d4df9ef1f65"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cyclic Quadrilaterals",
                                                      "id": "5f65877582532750fe35cffc",
                                                      "_id": "6077c4efbc5f4d4df9ef1f62",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc63",
                                                              "_id": "6077c4efbc5f4d4df9ef1f63"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parts Of A Circle",
                                                      "id": "5f65877582532750fe35cffa",
                                                      "_id": "6077c4efbc5f4d4df9ef1f60",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc64",
                                                              "_id": "6077c4efbc5f4d4df9ef1f61"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Chords Of A Circle",
                                                      "id": "5f65877582532750fe35cffb",
                                                      "_id": "6077c4efbc5f4d4df9ef1f5e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc65",
                                                              "_id": "6077c4efbc5f4d4df9ef1f5f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Quadrilaterals",
                                                      "id": "5f65877582532750fe35cff9",
                                                      "_id": "6077c4efbc5f4d4df9ef1f5c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc66",
                                                              "_id": "6077c4efbc5f4d4df9ef1f5d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Angles",
                                                      "id": "5f65877582532750fe35cff8",
                                                      "_id": "6077c4efbc5f4d4df9ef1f5a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc67",
                                                              "_id": "6077c4efbc5f4d4df9ef1f5b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Practical Geometry",
                                                      "id": "5f65877582532750fe35cffd",
                                                      "_id": "6077c4efbc5f4d4df9ef1f58",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc68",
                                                              "_id": "6077c4efbc5f4d4df9ef1f59"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c0",
                                                      "_id": "6077c4efbc5f4d4df9ef1f66"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Coordinate Geometry",
                                              "id": "5f64aec082532750fe359c20",
                                              "_id": "6077c4efbc5f4d4df9ef1f47",
                                              "concepts": [
                                                  {
                                                      "name": "The Coordinates Of The Centroid",
                                                      "id": "5f65877582532750fe35d004",
                                                      "_id": "6077c4efbc5f4d4df9ef1f54",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc69",
                                                              "_id": "6077c4efbc5f4d4df9ef1f55"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distance Between Any Two Points",
                                                      "id": "5f65877582532750fe35d000",
                                                      "_id": "6077c4efbc5f4d4df9ef1f52",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6a",
                                                              "_id": "6077c4efbc5f4d4df9ef1f53"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Section Formula",
                                                      "id": "5f65877582532750fe35d003",
                                                      "_id": "6077c4efbc5f4d4df9ef1f50",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6b",
                                                              "_id": "6077c4efbc5f4d4df9ef1f51"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Devising A Coordinate System",
                                                      "id": "5f65877582532750fe35cfff",
                                                      "_id": "6077c4efbc5f4d4df9ef1f4e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6c",
                                                              "_id": "6077c4efbc5f4d4df9ef1f4f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Points Of Trisection Of A Line Segment",
                                                      "id": "5f65877582532750fe35d002",
                                                      "_id": "6077c4efbc5f4d4df9ef1f4c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6d",
                                                              "_id": "6077c4efbc5f4d4df9ef1f4d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Mid-Point Of A Line Segment",
                                                      "id": "5f65877582532750fe35d001",
                                                      "_id": "6077c4efbc5f4d4df9ef1f4a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6e",
                                                              "_id": "6077c4efbc5f4d4df9ef1f4b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mapping The Plane",
                                                      "id": "5f65877582532750fe35cffe",
                                                      "_id": "6077c4efbc5f4d4df9ef1f48",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc6f",
                                                              "_id": "6077c4efbc5f4d4df9ef1f49"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c1",
                                                      "_id": "6077c4efbc5f4d4df9ef1f56"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef1fe9"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Heat and Thermodynamics",
                                              "id": "5ace20329fe7b01d5806bcb8",
                                              "_id": "6077c4efbc5f4d4df9ef1f34",
                                              "concepts": [
                                                  {
                                                      "name": "calorimetary",
                                                      "id": "5ace20419fe7b01d5806c1d5",
                                                      "_id": "6077c4efbc5f4d4df9ef1f43",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de99",
                                                              "_id": "6077c4efbc5f4d4df9ef1f44"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First law of Thermodynamics & process",
                                                      "id": "5ace20419fe7b01d5806c1d6",
                                                      "_id": "6077c4efbc5f4d4df9ef1f41",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9a",
                                                              "_id": "6077c4efbc5f4d4df9ef1f42"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "graphs, efficiency and engines",
                                                      "id": "5ace20419fe7b01d5806c1d7",
                                                      "_id": "6077c4efbc5f4d4df9ef1f3f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9b",
                                                              "_id": "6077c4efbc5f4d4df9ef1f40"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heat transfer conduction",
                                                      "id": "5ace20419fe7b01d5806c1d8",
                                                      "_id": "6077c4efbc5f4d4df9ef1f3d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9c",
                                                              "_id": "6077c4efbc5f4d4df9ef1f3e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heat transfer radiation and convection",
                                                      "id": "5ace20419fe7b01d5806c1d9",
                                                      "_id": "6077c4efbc5f4d4df9ef1f3b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9d",
                                                              "_id": "6077c4efbc5f4d4df9ef1f3c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ideal gas equation, Average,RMS, Most probable velocities, Molar specific heat capacities",
                                                      "id": "5ace20419fe7b01d5806c1da",
                                                      "_id": "6077c4efbc5f4d4df9ef1f39",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9e",
                                                              "_id": "6077c4efbc5f4d4df9ef1f3a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Kinetic theory of gases and degree of freedom",
                                                      "id": "5ace20419fe7b01d5806c1db",
                                                      "_id": "6077c4efbc5f4d4df9ef1f37",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673de9f",
                                                              "_id": "6077c4efbc5f4d4df9ef1f38"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thermometry, thermal expansion of solid, liquid",
                                                      "id": "5ace20419fe7b01d5806c1dc",
                                                      "_id": "6077c4efbc5f4d4df9ef1f35",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea0",
                                                              "_id": "6077c4efbc5f4d4df9ef1f36"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7d",
                                                      "_id": "6077c4efbc5f4d4df9ef1f45"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Simple Harmonic Motion",
                                              "id": "5ace20329fe7b01d5806bcb9",
                                              "_id": "6077c4efbc5f4d4df9ef1f26",
                                              "concepts": [
                                                  {
                                                      "name": "Damped harmonic motion, forced oscillation, superposition principle, reduced mass concept",
                                                      "id": "5ace20419fe7b01d5806c1dd",
                                                      "_id": "6077c4efbc5f4d4df9ef1f31",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea1",
                                                              "_id": "6077c4efbc5f4d4df9ef1f32"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy in SHM",
                                                      "id": "5ace20419fe7b01d5806c1de",
                                                      "_id": "6077c4efbc5f4d4df9ef1f2f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea2",
                                                              "_id": "6077c4efbc5f4d4df9ef1f30"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Equation of SHM, Relation between SHM and uniform circular motion, Phase constant, phase",
                                                      "id": "5ace20419fe7b01d5806c1df",
                                                      "_id": "6077c4efbc5f4d4df9ef1f2d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea3",
                                                              "_id": "6077c4efbc5f4d4df9ef1f2e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Frequency of a system performing SHM",
                                                      "id": "5ace20419fe7b01d5806c1e0",
                                                      "_id": "6077c4efbc5f4d4df9ef1f2b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea4",
                                                              "_id": "6077c4efbc5f4d4df9ef1f2c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulii of elasticity, Elastic potential energy, graph between stress & strain",
                                                      "id": "5ace20419fe7b01d5806c1e1",
                                                      "_id": "6077c4efbc5f4d4df9ef1f29",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea5",
                                                              "_id": "6077c4efbc5f4d4df9ef1f2a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple and rigid pendulum",
                                                      "id": "5ace20419fe7b01d5806c1e2",
                                                      "_id": "6077c4efbc5f4d4df9ef1f27",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea6",
                                                              "_id": "6077c4efbc5f4d4df9ef1f28"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7e",
                                                      "_id": "6077c4efbc5f4d4df9ef1f33"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Waves and Sound",
                                              "id": "5ace20329fe7b01d5806bcba",
                                              "_id": "6077c4efbc5f4d4df9ef1f16",
                                              "concepts": [
                                                  {
                                                      "name": "Beats and doppler effect, transmission and reflection of wave",
                                                      "id": "5ace20419fe7b01d5806c1e3",
                                                      "_id": "6077c4efbc5f4d4df9ef1f23",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea7",
                                                              "_id": "6077c4efbc5f4d4df9ef1f24"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy transfer in waves & intensity",
                                                      "id": "5ace20419fe7b01d5806c1e4",
                                                      "_id": "6077c4efbc5f4d4df9ef1f21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea8",
                                                              "_id": "6077c4efbc5f4d4df9ef1f22"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "standing wave in organ pipe and in rod",
                                                      "id": "5ace20419fe7b01d5806c1e5",
                                                      "_id": "6077c4efbc5f4d4df9ef1f1f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dea9",
                                                              "_id": "6077c4efbc5f4d4df9ef1f20"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Superposition of waves - Interference, standing wave in string, energy in standing wave",
                                                      "id": "5ace20419fe7b01d5806c1e6",
                                                      "_id": "6077c4efbc5f4d4df9ef1f1d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deaa",
                                                              "_id": "6077c4efbc5f4d4df9ef1f1e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transverse and longitudinal waves, Equation of waves",
                                                      "id": "5ace20419fe7b01d5806c1e7",
                                                      "_id": "6077c4efbc5f4d4df9ef1f1b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deab",
                                                              "_id": "6077c4efbc5f4d4df9ef1f1c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Velcoity & Acceleration of particles of medium during wave propagation",
                                                      "id": "5ace20419fe7b01d5806c1e8",
                                                      "_id": "6077c4efbc5f4d4df9ef1f19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deac",
                                                              "_id": "6077c4efbc5f4d4df9ef1f1a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "velocity of longitudinal and transverse waves",
                                                      "id": "5ace20419fe7b01d5806c1e9",
                                                      "_id": "6077c4efbc5f4d4df9ef1f17",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dead",
                                                              "_id": "6077c4efbc5f4d4df9ef1f18"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd7f",
                                                      "_id": "6077c4efbc5f4d4df9ef1f25"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Electromagnetic Induction And Alternating Current",
                                              "id": "5f6991e8058075680d81d37f",
                                              "_id": "6077c4efbc5f4d4df9ef1f02",
                                              "concepts": [
                                                  {
                                                      "name": "Methods Of Producing Induced Emf",
                                                      "id": "5f69941cca5ac358f170d8ee",
                                                      "_id": "6077c4efbc5f4d4df9ef1f13",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deae",
                                                              "_id": "6077c4efbc5f4d4df9ef1f14"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alternating Current",
                                                      "id": "5f69941cca5ac358f170d8f1",
                                                      "_id": "6077c4efbc5f4d4df9ef1f11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deaf",
                                                              "_id": "6077c4efbc5f4d4df9ef1f12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Induction",
                                                      "id": "5f69941cca5ac358f170d8eb",
                                                      "_id": "6077c4efbc5f4d4df9ef1f0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb0",
                                                              "_id": "6077c4efbc5f4d4df9ef1f10"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Power In Ac Circuits",
                                                      "id": "5f69941cca5ac358f170d8f2",
                                                      "_id": "6077c4efbc5f4d4df9ef1f0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb1",
                                                              "_id": "6077c4efbc5f4d4df9ef1f0e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Oscillation In Lc Circuits",
                                                      "id": "5f69941cca5ac358f170d8f3",
                                                      "_id": "6077c4efbc5f4d4df9ef1f0b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb2",
                                                              "_id": "6077c4efbc5f4d4df9ef1f0c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Analogies Between Lc Oscillations And Simple Harmonic Oscillations",
                                                      "id": "5f69941cca5ac358f170d8ec",
                                                      "_id": "6077c4efbc5f4d4df9ef1f09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb3",
                                                              "_id": "6077c4efbc5f4d4df9ef1f0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Self–Induction",
                                                      "id": "5f69941cca5ac358f170d8ed",
                                                      "_id": "6077c4efbc5f4d4df9ef1f07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb4",
                                                              "_id": "6077c4efbc5f4d4df9ef1f08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ac Generator",
                                                      "id": "5f69941cca5ac358f170d8ef",
                                                      "_id": "6077c4efbc5f4d4df9ef1f05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb5",
                                                              "_id": "6077c4efbc5f4d4df9ef1f06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Transformer",
                                                      "id": "5f69941cca5ac358f170d8f0",
                                                      "_id": "6077c4efbc5f4d4df9ef1f03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb6",
                                                              "_id": "6077c4efbc5f4d4df9ef1f04"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd80",
                                                      "_id": "6077c4efbc5f4d4df9ef1f15"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef1f46"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Embedded figures, Completion of incomplete pattern",
                                              "id": "5ace20309fe7b01d5806bc29",
                                              "_id": "6077c4efbc5f4d4df9ef1efd",
                                              "concepts": [
                                                  {
                                                      "name": "Embedded figures, Completion of incomplete pattern",
                                                      "id": "5ace20389fe7b01d5806bf19",
                                                      "_id": "6077c4efbc5f4d4df9ef1efe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8440",
                                                              "_id": "6077c4efbc5f4d4df9ef1eff"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825a",
                                                      "_id": "6077c4efbc5f4d4df9ef1f00"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Images",
                                              "id": "5ace20319fe7b01d5806bc2d",
                                              "_id": "6077c4efbc5f4d4df9ef1ef9",
                                              "concepts": [
                                                  {
                                                      "name": "Images",
                                                      "id": "5ace20389fe7b01d5806bf1d",
                                                      "_id": "6077c4efbc5f4d4df9ef1efa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8441",
                                                              "_id": "6077c4efbc5f4d4df9ef1efb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825b",
                                                      "_id": "6077c4efbc5f4d4df9ef1efc"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef1f01"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Power Sharing",
                                              "id": "5ace20329fe7b01d5806bcec",
                                              "_id": "6077c4efbc5f4d4df9ef1ef4",
                                              "concepts": [
                                                  {
                                                      "name": "Needs of power sharing and its different forms",
                                                      "id": "5ace20429fe7b01d5806c23b",
                                                      "_id": "6077c4efbc5f4d4df9ef1ef5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8492",
                                                              "_id": "6077c4efbc5f4d4df9ef1ef6"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828b",
                                                      "_id": "6077c4efbc5f4d4df9ef1ef7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Federalism",
                                              "id": "5ace20329fe7b01d5806bce7",
                                              "_id": "6077c4efbc5f4d4df9ef1eee",
                                              "concepts": [
                                                  {
                                                      "name": "Division of power between centre & state",
                                                      "id": "5ace20429fe7b01d5806c232",
                                                      "_id": "6077c4efbc5f4d4df9ef1ef1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8493",
                                                              "_id": "6077c4efbc5f4d4df9ef1ef2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Featrus of federalism",
                                                      "id": "5ace20429fe7b01d5806c233",
                                                      "_id": "6077c4efbc5f4d4df9ef1eef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8494",
                                                              "_id": "6077c4efbc5f4d4df9ef1ef0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828c",
                                                      "_id": "6077c4efbc5f4d4df9ef1ef3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Democracy and Diversity",
                                              "id": "5ace20329fe7b01d5806bce3",
                                              "_id": "6077c4efbc5f4d4df9ef1ee8",
                                              "concepts": [
                                                  {
                                                      "name": "Features of democracy.",
                                                      "id": "5ace20429fe7b01d5806c22d",
                                                      "_id": "6077c4efbc5f4d4df9ef1eeb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8495",
                                                              "_id": "6077c4efbc5f4d4df9ef1eec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The way democracy accomodates differences",
                                                      "id": "5ace20429fe7b01d5806c22e",
                                                      "_id": "6077c4efbc5f4d4df9ef1ee9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8496",
                                                              "_id": "6077c4efbc5f4d4df9ef1eea"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828d",
                                                      "_id": "6077c4efbc5f4d4df9ef1eed"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef1ef8"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Rule Direction",
                                              "id": "5ace20309fe7b01d5806bc1b",
                                              "_id": "6077c4efbc5f4d4df9ef1ee3",
                                              "concepts": [
                                                  {
                                                      "name": "Figure Series",
                                                      "id": "5ace20389fe7b01d5806bf06",
                                                      "_id": "6077c4efbc5f4d4df9ef1ee4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4b",
                                                              "_id": "6077c4efbc5f4d4df9ef1ee5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3c",
                                                      "_id": "6077c4efbc5f4d4df9ef1ee6"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef1ee7"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 10,
                              "startDate": "2021-07-01T00:00:00.000Z",
                              "endDate": "2021-07-07T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef1dbe",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Management of natural resources",
                                              "id": "5ace202f9fe7b01d5806bbc1",
                                              "_id": "6077c4efbc5f4d4df9ef1ed5",
                                              "concepts": [
                                                  {
                                                      "name": "Types of resources",
                                                      "id": "5ace20339fe7b01d5806bd4a",
                                                      "_id": "6077c4efbc5f4d4df9ef1ede",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830e",
                                                              "_id": "6077c4efbc5f4d4df9ef1edf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Narmada Bachao Andolan, Ganga Action Plan, Water harvesting system",
                                                      "id": "5ace20339fe7b01d5806bd49",
                                                      "_id": "6077c4efbc5f4d4df9ef1edc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c830f",
                                                              "_id": "6077c4efbc5f4d4df9ef1edd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Chipko movement, Stake holders of forest, Problems through dam constructions",
                                                      "id": "5ace20339fe7b01d5806bd46",
                                                      "_id": "6077c4efbc5f4d4df9ef1eda",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8310",
                                                              "_id": "6077c4efbc5f4d4df9ef1edb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fossil Fuels",
                                                      "id": "5ace20339fe7b01d5806bd48",
                                                      "_id": "6077c4efbc5f4d4df9ef1ed8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8311",
                                                              "_id": "6077c4efbc5f4d4df9ef1ed9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conservation Methods",
                                                      "id": "5ace20339fe7b01d5806bd47",
                                                      "_id": "6077c4efbc5f4d4df9ef1ed6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8312",
                                                              "_id": "6077c4efbc5f4d4df9ef1ed7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8210",
                                                      "_id": "6077c4efbc5f4d4df9ef1ee0"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef1ee1"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef1ed4"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Mensuration",
                                              "id": "5f64aec082532750fe359c22",
                                              "_id": "6077c4efbc5f4d4df9ef1ec7",
                                              "concepts": [
                                                  {
                                                      "name": "Surface Area Of Cuboid And Cube",
                                                      "id": "5f65877582532750fe35d00c",
                                                      "_id": "6077c4efbc5f4d4df9ef1ed0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc70",
                                                              "_id": "6077c4efbc5f4d4df9ef1ed1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f65877582532750fe35d009",
                                                      "_id": "6077c4efbc5f4d4df9ef1ece",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc71",
                                                              "_id": "6077c4efbc5f4d4df9ef1ecf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of Cuboid And Cube",
                                                      "id": "5f65877582532750fe35d00d",
                                                      "_id": "6077c4efbc5f4d4df9ef1ecc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc72",
                                                              "_id": "6077c4efbc5f4d4df9ef1ecd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Heron’s Formula",
                                                      "id": "5f65877582532750fe35d00a",
                                                      "_id": "6077c4efbc5f4d4df9ef1eca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc73",
                                                              "_id": "6077c4efbc5f4d4df9ef1ecb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Heron’s Formula In Finding Areas Of Quadrilaterals",
                                                      "id": "5f65877582532750fe35d00b",
                                                      "_id": "6077c4efbc5f4d4df9ef1ec8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc74",
                                                              "_id": "6077c4efbc5f4d4df9ef1ec9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c2",
                                                      "_id": "6077c4efbc5f4d4df9ef1ed2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Two Dimensional Analytical Geometry-Ii",
                                              "id": "5f6831c6f100a06808b0d4ef",
                                              "_id": "6077c4efbc5f4d4df9ef1eb7",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68335c058075680d813619",
                                                      "_id": "6077c4efbc5f4d4df9ef1ec4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7d",
                                                              "_id": "6077c4efbc5f4d4df9ef1ec5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Tangents And Normals To Conics",
                                                      "id": "5f68335c058075680d81361e",
                                                      "_id": "6077c4efbc5f4d4df9ef1ec2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7e",
                                                              "_id": "6077c4efbc5f4d4df9ef1ec3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Circle",
                                                      "id": "5f68335c058075680d81361a",
                                                      "_id": "6077c4efbc5f4d4df9ef1ec0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc7f",
                                                              "_id": "6077c4efbc5f4d4df9ef1ec1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conic Sections",
                                                      "id": "5f68335c058075680d81361c",
                                                      "_id": "6077c4efbc5f4d4df9ef1ebe",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc80",
                                                              "_id": "6077c4efbc5f4d4df9ef1ebf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Life Applications Of Conics",
                                                      "id": "5f68335c058075680d81361f",
                                                      "_id": "6077c4efbc5f4d4df9ef1ebc",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc81",
                                                              "_id": "6077c4efbc5f4d4df9ef1ebd"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conics",
                                                      "id": "5f68335c058075680d81361b",
                                                      "_id": "6077c4efbc5f4d4df9ef1eba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc82",
                                                              "_id": "6077c4efbc5f4d4df9ef1ebb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Parametric Form Of Conics",
                                                      "id": "5f68335c058075680d81361d",
                                                      "_id": "6077c4efbc5f4d4df9ef1eb8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc83",
                                                              "_id": "6077c4efbc5f4d4df9ef1eb9"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c4",
                                                      "_id": "6077c4efbc5f4d4df9ef1ec6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ordinary Differential Equations",
                                              "id": "5f6831c6f100a06808b0d4f4",
                                              "_id": "6077c4efbc5f4d4df9ef1ea5",
                                              "concepts": [
                                                  {
                                                      "name": "Solution Of First Order And First Degree Differential Equations",
                                                      "id": "5f6834dc058075680d81371c",
                                                      "_id": "6077c4efbc5f4d4df9ef1eb4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc84",
                                                              "_id": "6077c4efbc5f4d4df9ef1eb5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6834dc058075680d813717",
                                                      "_id": "6077c4efbc5f4d4df9ef1eb2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc85",
                                                              "_id": "6077c4efbc5f4d4df9ef1eb3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differential Equation, Order, And Degree",
                                                      "id": "5f6834dc058075680d813718",
                                                      "_id": "6077c4efbc5f4d4df9ef1eb0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc86",
                                                              "_id": "6077c4efbc5f4d4df9ef1eb1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation Of Differential Equations",
                                                      "id": "5f6834dc058075680d81371a",
                                                      "_id": "6077c4efbc5f4d4df9ef1eae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc87",
                                                              "_id": "6077c4efbc5f4d4df9ef1eaf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of Ordinary Differential Equations",
                                                      "id": "5f6834dc058075680d81371b",
                                                      "_id": "6077c4efbc5f4d4df9ef1eac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc88",
                                                              "_id": "6077c4efbc5f4d4df9ef1ead"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Order Ordinary Differential Equations",
                                                      "id": "5f6834dc058075680d81371e",
                                                      "_id": "6077c4efbc5f4d4df9ef1eaa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc89",
                                                              "_id": "6077c4efbc5f4d4df9ef1eab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First Order Linear Differential Equations",
                                                      "id": "5f6834dc058075680d81371d",
                                                      "_id": "6077c4efbc5f4d4df9ef1ea8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8a",
                                                              "_id": "6077c4efbc5f4d4df9ef1ea9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification Of Differential Equations",
                                                      "id": "5f6834dc058075680d813719",
                                                      "_id": "6077c4efbc5f4d4df9ef1ea6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8b",
                                                              "_id": "6077c4efbc5f4d4df9ef1ea7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c5",
                                                      "_id": "6077c4efbc5f4d4df9ef1eb6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Complex Numbers",
                                              "id": "5f6831c6f100a06808b0d4ec",
                                              "_id": "6077c4efbc5f4d4df9ef1e93",
                                              "concepts": [
                                                  {
                                                      "name": "Geometry And Locus Of Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027f1",
                                                      "_id": "6077c4efbc5f4d4df9ef1ea2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8c",
                                                              "_id": "6077c4efbc5f4d4df9ef1ea3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conjugate Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027ef",
                                                      "_id": "6077c4efbc5f4d4df9ef1ea0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8d",
                                                              "_id": "6077c4efbc5f4d4df9ef1ea1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Algebraic Properties Of Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ee",
                                                      "_id": "6077c4efbc5f4d4df9ef1e9e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8e",
                                                              "_id": "6077c4efbc5f4d4df9ef1e9f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ed",
                                                      "_id": "6077c4efbc5f4d4df9ef1e9c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc8f",
                                                              "_id": "6077c4efbc5f4d4df9ef1e9d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction To Complex Numbers",
                                                      "id": "5f683275ca5ac358f17027ec",
                                                      "_id": "6077c4efbc5f4d4df9ef1e9a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc90",
                                                              "_id": "6077c4efbc5f4d4df9ef1e9b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Moivre’S Theorem And Its Applications",
                                                      "id": "5f683275ca5ac358f17027f3",
                                                      "_id": "6077c4efbc5f4d4df9ef1e98",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc91",
                                                              "_id": "6077c4efbc5f4d4df9ef1e99"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulus Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027f0",
                                                      "_id": "6077c4efbc5f4d4df9ef1e96",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc92",
                                                              "_id": "6077c4efbc5f4d4df9ef1e97"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polar And Euler Form Of A Complex Number",
                                                      "id": "5f683275ca5ac358f17027f2",
                                                      "_id": "6077c4efbc5f4d4df9ef1e94",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc93",
                                                              "_id": "6077c4efbc5f4d4df9ef1e95"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c6",
                                                      "_id": "6077c4efbc5f4d4df9ef1ea4"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Differential Calculus",
                                              "id": "5f6831c6f100a06808b0d4f1",
                                              "_id": "6077c4efbc5f4d4df9ef1e7d",
                                              "concepts": [
                                                  {
                                                      "name": "Indeterminate Forms",
                                                      "id": "5f683405ca5ac358f17028c0",
                                                      "_id": "6077c4efbc5f4d4df9ef1e90",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc94",
                                                              "_id": "6077c4efbc5f4d4df9ef1e91"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Second Derivative",
                                                      "id": "5f683405ca5ac358f17028c2",
                                                      "_id": "6077c4efbc5f4d4df9ef1e8e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc95",
                                                              "_id": "6077c4efbc5f4d4df9ef1e8f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Derivative",
                                                      "id": "5f683405ca5ac358f17028c1",
                                                      "_id": "6077c4efbc5f4d4df9ef1e8c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc96",
                                                              "_id": "6077c4efbc5f4d4df9ef1e8d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sketching Of Curves",
                                                      "id": "5f683405ca5ac358f17028c5",
                                                      "_id": "6077c4efbc5f4d4df9ef1e8a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc97",
                                                              "_id": "6077c4efbc5f4d4df9ef1e8b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683405ca5ac358f17028bc",
                                                      "_id": "6077c4efbc5f4d4df9ef1e88",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc98",
                                                              "_id": "6077c4efbc5f4d4df9ef1e89"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meaning Of Derivatives",
                                                      "id": "5f683405ca5ac358f17028bd",
                                                      "_id": "6077c4efbc5f4d4df9ef1e86",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc99",
                                                              "_id": "6077c4efbc5f4d4df9ef1e87"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean Value Theorem",
                                                      "id": "5f683405ca5ac358f17028be",
                                                      "_id": "6077c4efbc5f4d4df9ef1e84",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9a",
                                                              "_id": "6077c4efbc5f4d4df9ef1e85"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Symmetry And Asymptotes",
                                                      "id": "5f683405ca5ac358f17028c4",
                                                      "_id": "6077c4efbc5f4d4df9ef1e82",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9b",
                                                              "_id": "6077c4efbc5f4d4df9ef1e83"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series Expansions",
                                                      "id": "5f683405ca5ac358f17028bf",
                                                      "_id": "6077c4efbc5f4d4df9ef1e80",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9c",
                                                              "_id": "6077c4efbc5f4d4df9ef1e81"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications In Optimization",
                                                      "id": "5f683405ca5ac358f17028c3",
                                                      "_id": "6077c4efbc5f4d4df9ef1e7e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9d",
                                                              "_id": "6077c4efbc5f4d4df9ef1e7f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c7",
                                                      "_id": "6077c4efbc5f4d4df9ef1e92"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Discrete Mathematics",
                                              "id": "5f6831c6f100a06808b0d4f6",
                                              "_id": "6077c4efbc5f4d4df9ef1e75",
                                              "concepts": [
                                                  {
                                                      "name": "Binary Operations",
                                                      "id": "5f68352571814158f68cc7e1",
                                                      "_id": "6077c4efbc5f4d4df9ef1e7a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9e",
                                                              "_id": "6077c4efbc5f4d4df9ef1e7b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68352571814158f68cc7e0",
                                                      "_id": "6077c4efbc5f4d4df9ef1e78",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dc9f",
                                                              "_id": "6077c4efbc5f4d4df9ef1e79"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Logic",
                                                      "id": "5f68352571814158f68cc7e2",
                                                      "_id": "6077c4efbc5f4d4df9ef1e76",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca0",
                                                              "_id": "6077c4efbc5f4d4df9ef1e77"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c8",
                                                      "_id": "6077c4efbc5f4d4df9ef1e7c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Vector Algebra",
                                              "id": "5f6831c6f100a06808b0d4f0",
                                              "_id": "6077c4efbc5f4d4df9ef1e5f",
                                              "concepts": [
                                                  {
                                                      "name": "Jacobi’S Identity And Lagrange’S Identity",
                                                      "id": "5f6833c2058075680d81364f",
                                                      "_id": "6077c4efbc5f4d4df9ef1e72",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca1",
                                                              "_id": "6077c4efbc5f4d4df9ef1e73"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meeting Point Of A Line And A Plane",
                                                      "id": "5f6833c2058075680d813653",
                                                      "_id": "6077c4efbc5f4d4df9ef1e70",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca2",
                                                              "_id": "6077c4efbc5f4d4df9ef1e71"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar Product And Vector Product",
                                                      "id": "5f6833c2058075680d81364c",
                                                      "_id": "6077c4efbc5f4d4df9ef1e6e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca3",
                                                              "_id": "6077c4efbc5f4d4df9ef1e6f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Geometric Introduction To Vectors",
                                                      "id": "5f6833c2058075680d81364b",
                                                      "_id": "6077c4efbc5f4d4df9ef1e6c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca4",
                                                              "_id": "6077c4efbc5f4d4df9ef1e6d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Image Of A Point In A Plane",
                                                      "id": "5f6833c2058075680d813652",
                                                      "_id": "6077c4efbc5f4d4df9ef1e6a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca5",
                                                              "_id": "6077c4efbc5f4d4df9ef1e6b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalar Triple Product",
                                                      "id": "5f6833c2058075680d81364d",
                                                      "_id": "6077c4efbc5f4d4df9ef1e68",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca6",
                                                              "_id": "6077c4efbc5f4d4df9ef1e69"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different Forms Of Equation Of A Plane",
                                                      "id": "5f6833c2058075680d813651",
                                                      "_id": "6077c4efbc5f4d4df9ef1e66",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca7",
                                                              "_id": "6077c4efbc5f4d4df9ef1e67"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vector Triple Product",
                                                      "id": "5f6833c2058075680d81364e",
                                                      "_id": "6077c4efbc5f4d4df9ef1e64",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca8",
                                                              "_id": "6077c4efbc5f4d4df9ef1e65"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6833c2058075680d81364a",
                                                      "_id": "6077c4efbc5f4d4df9ef1e62",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dca9",
                                                              "_id": "6077c4efbc5f4d4df9ef1e63"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Different Forms Of Equation Of A Straight Line",
                                                      "id": "5f6833c2058075680d813650",
                                                      "_id": "6077c4efbc5f4d4df9ef1e60",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcaa",
                                                              "_id": "6077c4efbc5f4d4df9ef1e61"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9c9",
                                                      "_id": "6077c4efbc5f4d4df9ef1e74"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Matrices And Determinants",
                                              "id": "5f6831c6f100a06808b0d4eb",
                                              "_id": "6077c4efbc5f4d4df9ef1e53",
                                              "concepts": [
                                                  {
                                                      "name": "Inverse Of A Non-Singular Square Matrix",
                                                      "id": "5f683235f100a06808b0d503",
                                                      "_id": "6077c4efbc5f4d4df9ef1e5c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcab",
                                                              "_id": "6077c4efbc5f4d4df9ef1e5d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Elementary Transformations Of A Matrix",
                                                      "id": "5f683235f100a06808b0d504",
                                                      "_id": "6077c4efbc5f4d4df9ef1e5a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcac",
                                                              "_id": "6077c4efbc5f4d4df9ef1e5b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Matrices: Consistency Of System Of Linear Equations By Rank Method",
                                                      "id": "5f683235f100a06808b0d506",
                                                      "_id": "6077c4efbc5f4d4df9ef1e58",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcad",
                                                              "_id": "6077c4efbc5f4d4df9ef1e59"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683235f100a06808b0d502",
                                                      "_id": "6077c4efbc5f4d4df9ef1e56",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcae",
                                                              "_id": "6077c4efbc5f4d4df9ef1e57"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Matrices: Solving System Of Linear Equations",
                                                      "id": "5f683235f100a06808b0d505",
                                                      "_id": "6077c4efbc5f4d4df9ef1e54",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcaf",
                                                              "_id": "6077c4efbc5f4d4df9ef1e55"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ca",
                                                      "_id": "6077c4efbc5f4d4df9ef1e5e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability Distributions",
                                              "id": "5f6831c6f100a06808b0d4f5",
                                              "_id": "6077c4efbc5f4d4df9ef1e45",
                                              "concepts": [
                                                  {
                                                      "name": "Continuous Distributions",
                                                      "id": "5f683505058075680d813749",
                                                      "_id": "6077c4efbc5f4d4df9ef1e50",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb0",
                                                              "_id": "6077c4efbc5f4d4df9ef1e51"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Expectation",
                                                      "id": "5f683505058075680d81374a",
                                                      "_id": "6077c4efbc5f4d4df9ef1e4e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb1",
                                                              "_id": "6077c4efbc5f4d4df9ef1e4f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Random Variable",
                                                      "id": "5f683505058075680d813748",
                                                      "_id": "6077c4efbc5f4d4df9ef1e4c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb2",
                                                              "_id": "6077c4efbc5f4d4df9ef1e4d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683505058075680d813746",
                                                      "_id": "6077c4efbc5f4d4df9ef1e4a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb3",
                                                              "_id": "6077c4efbc5f4d4df9ef1e4b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random Variable",
                                                      "id": "5f683505058075680d813747",
                                                      "_id": "6077c4efbc5f4d4df9ef1e48",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb4",
                                                              "_id": "6077c4efbc5f4d4df9ef1e49"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                      "id": "5f683505058075680d81374b",
                                                      "_id": "6077c4efbc5f4d4df9ef1e46",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb5",
                                                              "_id": "6077c4efbc5f4d4df9ef1e47"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cb",
                                                      "_id": "6077c4efbc5f4d4df9ef1e52"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inverse Trigonometric Functions",
                                              "id": "5f6831c6f100a06808b0d4ee",
                                              "_id": "6077c4efbc5f4d4df9ef1e2f",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68332aca5ac358f170285a",
                                                      "_id": "6077c4efbc5f4d4df9ef1e42",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb6",
                                                              "_id": "6077c4efbc5f4d4df9ef1e43"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Inverse Trigonometric Functions",
                                                      "id": "5f68332aca5ac358f1702863",
                                                      "_id": "6077c4efbc5f4d4df9ef1e40",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb7",
                                                              "_id": "6077c4efbc5f4d4df9ef1e41"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sine Function And Inverse Sine Function",
                                                      "id": "5f68332aca5ac358f170285c",
                                                      "_id": "6077c4efbc5f4d4df9ef1e3e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb8",
                                                              "_id": "6077c4efbc5f4d4df9ef1e3f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Tangent Function And The Inverse Tangent Function",
                                                      "id": "5f68332aca5ac358f170285e",
                                                      "_id": "6077c4efbc5f4d4df9ef1e3c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcb9",
                                                              "_id": "6077c4efbc5f4d4df9ef1e3d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cosecant Function And The Inverse Cosecant Function",
                                                      "id": "5f68332aca5ac358f170285f",
                                                      "_id": "6077c4efbc5f4d4df9ef1e3a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcba",
                                                              "_id": "6077c4efbc5f4d4df9ef1e3b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Principal Value Of Inverse Trigonometric Functions",
                                                      "id": "5f68332aca5ac358f1702862",
                                                      "_id": "6077c4efbc5f4d4df9ef1e38",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbb",
                                                              "_id": "6077c4efbc5f4d4df9ef1e39"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cotangent Function And The Inverse Cotangent Function",
                                                      "id": "5f68332aca5ac358f1702861",
                                                      "_id": "6077c4efbc5f4d4df9ef1e36",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbc",
                                                              "_id": "6077c4efbc5f4d4df9ef1e37"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Secant Function And Inverse Secant Function",
                                                      "id": "5f68332aca5ac358f1702860",
                                                      "_id": "6077c4efbc5f4d4df9ef1e34",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbd",
                                                              "_id": "6077c4efbc5f4d4df9ef1e35"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Cosine Function And Inverse Cosine Function",
                                                      "id": "5f68332aca5ac358f170285d",
                                                      "_id": "6077c4efbc5f4d4df9ef1e32",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbe",
                                                              "_id": "6077c4efbc5f4d4df9ef1e33"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Some Fundamental Concepts",
                                                      "id": "5f68332aca5ac358f170285b",
                                                      "_id": "6077c4efbc5f4d4df9ef1e30",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcbf",
                                                              "_id": "6077c4efbc5f4d4df9ef1e31"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cc",
                                                      "_id": "6077c4efbc5f4d4df9ef1e44"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef1ed3"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Electromagnetic Waves",
                                              "id": "5f6991e8058075680d81d380",
                                              "_id": "6077c4efbc5f4d4df9ef1e26",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Spectrumemission And Absorption Spectrumfraunhofer Lines",
                                                      "id": "5f699431058075680d81d4bd",
                                                      "_id": "6077c4efbc5f4d4df9ef1e2b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb7",
                                                              "_id": "6077c4efbc5f4d4df9ef1e2c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electromagnetic Waves",
                                                      "id": "5f699431058075680d81d4bc",
                                                      "_id": "6077c4efbc5f4d4df9ef1e29",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb8",
                                                              "_id": "6077c4efbc5f4d4df9ef1e2a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699431058075680d81d4bb",
                                                      "_id": "6077c4efbc5f4d4df9ef1e27",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deb9",
                                                              "_id": "6077c4efbc5f4d4df9ef1e28"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd81",
                                                      "_id": "6077c4efbc5f4d4df9ef1e2d"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Communication Systems",
                                              "id": "5f6991e8058075680d81d385",
                                              "_id": "6077c4efbc5f4d4df9ef1e0c",
                                              "concepts": [
                                                  {
                                                      "name": "Modulation",
                                                      "id": "5f699522058075680d81d51a",
                                                      "_id": "6077c4efbc5f4d4df9ef1e23",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deba",
                                                              "_id": "6077c4efbc5f4d4df9ef1e24"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Satellite Communication",
                                                      "id": "5f699522058075680d81d51e",
                                                      "_id": "6077c4efbc5f4d4df9ef1e21",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debb",
                                                              "_id": "6077c4efbc5f4d4df9ef1e22"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Propagation Of Electromagnetic Waves",
                                                      "id": "5f699522058075680d81d51d",
                                                      "_id": "6077c4efbc5f4d4df9ef1e1f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debc",
                                                              "_id": "6077c4efbc5f4d4df9ef1e20"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radar And Applications",
                                                      "id": "5f699522058075680d81d520",
                                                      "_id": "6077c4efbc5f4d4df9ef1e1d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debd",
                                                              "_id": "6077c4efbc5f4d4df9ef1e1e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Elements Of An Electronic Communication System",
                                                      "id": "5f699522058075680d81d51b",
                                                      "_id": "6077c4efbc5f4d4df9ef1e1b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debe",
                                                              "_id": "6077c4efbc5f4d4df9ef1e1c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internet",
                                                      "id": "5f699522058075680d81d522",
                                                      "_id": "6077c4efbc5f4d4df9ef1e19",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673debf",
                                                              "_id": "6077c4efbc5f4d4df9ef1e1a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699522058075680d81d519",
                                                      "_id": "6077c4efbc5f4d4df9ef1e17",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec0",
                                                              "_id": "6077c4efbc5f4d4df9ef1e18"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Antenna Size",
                                                      "id": "5f699522058075680d81d51c",
                                                      "_id": "6077c4efbc5f4d4df9ef1e15",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec1",
                                                              "_id": "6077c4efbc5f4d4df9ef1e16"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Global Positioning System",
                                                      "id": "5f699522058075680d81d523",
                                                      "_id": "6077c4efbc5f4d4df9ef1e13",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec2",
                                                              "_id": "6077c4efbc5f4d4df9ef1e14"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fibre Optic Communication",
                                                      "id": "5f699522058075680d81d51f",
                                                      "_id": "6077c4efbc5f4d4df9ef1e11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec3",
                                                              "_id": "6077c4efbc5f4d4df9ef1e12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mobile Communication",
                                                      "id": "5f699522058075680d81d521",
                                                      "_id": "6077c4efbc5f4d4df9ef1e0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec4",
                                                              "_id": "6077c4efbc5f4d4df9ef1e10"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                      "id": "5f699522058075680d81d524",
                                                      "_id": "6077c4efbc5f4d4df9ef1e0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec5",
                                                              "_id": "6077c4efbc5f4d4df9ef1e0e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd82",
                                                      "_id": "6077c4efbc5f4d4df9ef1e25"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Recent Developments In Physics",
                                              "id": "5f6991e8058075680d81d386",
                                              "_id": "6077c4efbc5f4d4df9ef1e04",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699536f100a06808b181df",
                                                      "_id": "6077c4efbc5f4d4df9ef1e09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec6",
                                                              "_id": "6077c4efbc5f4d4df9ef1e0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nanoscience And Nanotechnology",
                                                      "id": "5f699536f100a06808b181e0",
                                                      "_id": "6077c4efbc5f4d4df9ef1e07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec7",
                                                              "_id": "6077c4efbc5f4d4df9ef1e08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Robotics",
                                                      "id": "5f699536f100a06808b181e1",
                                                      "_id": "6077c4efbc5f4d4df9ef1e05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec8",
                                                              "_id": "6077c4efbc5f4d4df9ef1e06"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd83",
                                                      "_id": "6077c4efbc5f4d4df9ef1e0b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5f6991e8058075680d81d381",
                                              "_id": "6077c4efbc5f4d4df9ef1de8",
                                              "concepts": [
                                                  {
                                                      "name": "Refraction",
                                                      "id": "5f699472ca5ac358f170d92d",
                                                      "_id": "6077c4efbc5f4d4df9ef1e01",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dec9",
                                                              "_id": "6077c4efbc5f4d4df9ef1e02"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thin Lens",
                                                      "id": "5f699472ca5ac358f170d92f",
                                                      "_id": "6077c4efbc5f4d4df9ef1dff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deca",
                                                              "_id": "6077c4efbc5f4d4df9ef1e00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refraction At Single Spherical Surface",
                                                      "id": "5f699472ca5ac358f170d92e",
                                                      "_id": "6077c4efbc5f4d4df9ef1dfd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decb",
                                                              "_id": "6077c4efbc5f4d4df9ef1dfe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diffraction",
                                                      "id": "5f699472ca5ac358f170d934",
                                                      "_id": "6077c4efbc5f4d4df9ef1dfb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decc",
                                                              "_id": "6077c4efbc5f4d4df9ef1dfc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wave Nature Of Light",
                                                      "id": "5f699472ca5ac358f170d932",
                                                      "_id": "6077c4efbc5f4d4df9ef1df9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decd",
                                                              "_id": "6077c4efbc5f4d4df9ef1dfa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Interference",
                                                      "id": "5f699472ca5ac358f170d933",
                                                      "_id": "6077c4efbc5f4d4df9ef1df7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dece",
                                                              "_id": "6077c4efbc5f4d4df9ef1df8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories On Light",
                                                      "id": "5f699472ca5ac358f170d931",
                                                      "_id": "6077c4efbc5f4d4df9ef1df5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673decf",
                                                              "_id": "6077c4efbc5f4d4df9ef1df6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Spherical Mirrors",
                                                      "id": "5f699472ca5ac358f170d92b",
                                                      "_id": "6077c4efbc5f4d4df9ef1df3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded0",
                                                              "_id": "6077c4efbc5f4d4df9ef1df4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5f699472ca5ac358f170d936",
                                                      "_id": "6077c4efbc5f4d4df9ef1df1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded1",
                                                              "_id": "6077c4efbc5f4d4df9ef1df2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prism",
                                                      "id": "5f699472ca5ac358f170d930",
                                                      "_id": "6077c4efbc5f4d4df9ef1def",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded2",
                                                              "_id": "6077c4efbc5f4d4df9ef1df0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f699472ca5ac358f170d92a",
                                                      "_id": "6077c4efbc5f4d4df9ef1ded",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded3",
                                                              "_id": "6077c4efbc5f4d4df9ef1dee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Of Light",
                                                      "id": "5f699472ca5ac358f170d92c",
                                                      "_id": "6077c4efbc5f4d4df9ef1deb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded4",
                                                              "_id": "6077c4efbc5f4d4df9ef1dec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarisation",
                                                      "id": "5f699472ca5ac358f170d935",
                                                      "_id": "6077c4efbc5f4d4df9ef1de9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded5",
                                                              "_id": "6077c4efbc5f4d4df9ef1dea"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd84",
                                                      "_id": "6077c4efbc5f4d4df9ef1e03"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef1e2e"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Paper cutting folding & unfolding, Dot situation",
                                              "id": "5ace20319fe7b01d5806bc34",
                                              "_id": "6077c4efbc5f4d4df9ef1de3",
                                              "concepts": [
                                                  {
                                                      "name": "Paper cutting folding & unfolding, Dot situation",
                                                      "id": "5ace20399fe7b01d5806bf26",
                                                      "_id": "6077c4efbc5f4d4df9ef1de4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8442",
                                                              "_id": "6077c4efbc5f4d4df9ef1de5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825c",
                                                      "_id": "6077c4efbc5f4d4df9ef1de6"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Time & Work",
                                              "id": "5ace20319fe7b01d5806bc41",
                                              "_id": "6077c4efbc5f4d4df9ef1ddd",
                                              "concepts": [
                                                  {
                                                      "name": "Chain Rule, Pipes & cisterns",
                                                      "id": "5ace20399fe7b01d5806bf3e",
                                                      "_id": "6077c4efbc5f4d4df9ef1de0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8443",
                                                              "_id": "6077c4efbc5f4d4df9ef1de1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Time & Work problems",
                                                      "id": "5ace20399fe7b01d5806bf3f",
                                                      "_id": "6077c4efbc5f4d4df9ef1dde",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8444",
                                                              "_id": "6077c4efbc5f4d4df9ef1ddf"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825d",
                                                      "_id": "6077c4efbc5f4d4df9ef1de2"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef1de7"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Gender, Religion and Caste",
                                              "id": "5ace20329fe7b01d5806bce8",
                                              "_id": "6077c4efbc5f4d4df9ef1dd6",
                                              "concepts": [
                                                  {
                                                      "name": "Diversity of gender & castecism in India",
                                                      "id": "5ace20429fe7b01d5806c234",
                                                      "_id": "6077c4efbc5f4d4df9ef1dd9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8497",
                                                              "_id": "6077c4efbc5f4d4df9ef1dda"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "India, a secular country",
                                                      "id": "5ace20429fe7b01d5806c235",
                                                      "_id": "6077c4efbc5f4d4df9ef1dd7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8498",
                                                              "_id": "6077c4efbc5f4d4df9ef1dd8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828e",
                                                      "_id": "6077c4efbc5f4d4df9ef1ddb"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Popular Struggles and Movements",
                                              "id": "5ace20329fe7b01d5806bceb",
                                              "_id": "6077c4efbc5f4d4df9ef1dd0",
                                              "concepts": [
                                                  {
                                                      "name": "Successful struggle and mass participation.",
                                                      "id": "5ace20429fe7b01d5806c23a",
                                                      "_id": "6077c4efbc5f4d4df9ef1dd3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8499",
                                                              "_id": "6077c4efbc5f4d4df9ef1dd4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Role of pressure groups.",
                                                      "id": "5ace20429fe7b01d5806c239",
                                                      "_id": "6077c4efbc5f4d4df9ef1dd1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849a",
                                                              "_id": "6077c4efbc5f4d4df9ef1dd2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c828f",
                                                      "_id": "6077c4efbc5f4d4df9ef1dd5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Political Parties",
                                              "id": "5ace20329fe7b01d5806bcea",
                                              "_id": "6077c4efbc5f4d4df9ef1dca",
                                              "concepts": [
                                                  {
                                                      "name": "Political parties and their needs",
                                                      "id": "5ace20429fe7b01d5806c238",
                                                      "_id": "6077c4efbc5f4d4df9ef1dcd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849b",
                                                              "_id": "6077c4efbc5f4d4df9ef1dce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions and challenges of the political parties",
                                                      "id": "5ace20429fe7b01d5806c237",
                                                      "_id": "6077c4efbc5f4d4df9ef1dcb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849c",
                                                              "_id": "6077c4efbc5f4d4df9ef1dcc"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8290",
                                                      "_id": "6077c4efbc5f4d4df9ef1dcf"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef1ddc"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [
                                          {
                                              "name": "Series Completion",
                                              "id": "5ace20309fe7b01d5806bc1c",
                                              "_id": "6077c4efbc5f4d4df9ef1dbf",
                                              "concepts": [
                                                  {
                                                      "name": "Alphabet Series",
                                                      "id": "5ace20389fe7b01d5806bf07",
                                                      "_id": "6077c4efbc5f4d4df9ef1dc6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4c",
                                                              "_id": "6077c4efbc5f4d4df9ef1dc7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Alphanumeric Series",
                                                      "id": "5ace20389fe7b01d5806bf08",
                                                      "_id": "6077c4efbc5f4d4df9ef1dc4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4d",
                                                              "_id": "6077c4efbc5f4d4df9ef1dc5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuous Pattern Series",
                                                      "id": "5ace20389fe7b01d5806bf09",
                                                      "_id": "6077c4efbc5f4d4df9ef1dc2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4e",
                                                              "_id": "6077c4efbc5f4d4df9ef1dc3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "NUMBER SERIES",
                                                      "id": "5ace20389fe7b01d5806bf0a",
                                                      "_id": "6077c4efbc5f4d4df9ef1dc0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df4f",
                                                              "_id": "6077c4efbc5f4d4df9ef1dc1"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5725b35a0a066673df3d",
                                                      "_id": "6077c4efbc5f4d4df9ef1dc8"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef1dc9"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 11,
                              "startDate": "2021-07-08T00:00:00.000Z",
                              "endDate": "2021-07-14T00:00:00.000Z",
                              "_id": "6077c4efbc5f4d4df9ef1cb4",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [
                                          {
                                              "name": "Environmental Problem",
                                              "id": "5ace202f9fe7b01d5806bbbd",
                                              "_id": "6077c4efbc5f4d4df9ef1dab",
                                              "concepts": [
                                                  {
                                                      "name": "Definition/Introduction, Food chain/Food web",
                                                      "id": "5ace20339fe7b01d5806bd1b",
                                                      "_id": "6077c4efbc5f4d4df9ef1dba",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8313",
                                                              "_id": "6077c4efbc5f4d4df9ef1dbb"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ecological Pyramids",
                                                      "id": "5ace20339fe7b01d5806bd1d",
                                                      "_id": "6077c4efbc5f4d4df9ef1db8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8314",
                                                              "_id": "6077c4efbc5f4d4df9ef1db9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Energy Flow",
                                                      "id": "5ace20339fe7b01d5806bd1e",
                                                      "_id": "6077c4efbc5f4d4df9ef1db6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8315",
                                                              "_id": "6077c4efbc5f4d4df9ef1db7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ecological Balance",
                                                      "id": "5ace20339fe7b01d5806bd1c",
                                                      "_id": "6077c4efbc5f4d4df9ef1db4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8316",
                                                              "_id": "6077c4efbc5f4d4df9ef1db5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Water Pollution",
                                                      "id": "5ace20339fe7b01d5806bd21",
                                                      "_id": "6077c4efbc5f4d4df9ef1db2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8317",
                                                              "_id": "6077c4efbc5f4d4df9ef1db3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Air Pollution",
                                                      "id": "5ace20339fe7b01d5806bd1a",
                                                      "_id": "6077c4efbc5f4d4df9ef1db0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8318",
                                                              "_id": "6077c4efbc5f4d4df9ef1db1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Land Pollution",
                                                      "id": "5ace20339fe7b01d5806bd1f",
                                                      "_id": "6077c4efbc5f4d4df9ef1dae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8319",
                                                              "_id": "6077c4efbc5f4d4df9ef1daf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Preventive Measures",
                                                      "id": "5ace20339fe7b01d5806bd20",
                                                      "_id": "6077c4efbc5f4d4df9ef1dac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c831a",
                                                              "_id": "6077c4efbc5f4d4df9ef1dad"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8211",
                                                      "_id": "6077c4efbc5f4d4df9ef1dbc"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef1dbd"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef1daa"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Applications Of Integration",
                                              "id": "5f6831c6f100a06808b0d4f3",
                                              "_id": "6077c4efbc5f4d4df9ef1d95",
                                              "concepts": [
                                                  {
                                                      "name": "Gamma Integral",
                                                      "id": "5f683497ca5ac358f170293f",
                                                      "_id": "6077c4efbc5f4d4df9ef1da6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc0",
                                                              "_id": "6077c4efbc5f4d4df9ef1da7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                      "id": "5f683497ca5ac358f170293b",
                                                      "_id": "6077c4efbc5f4d4df9ef1da4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc1",
                                                              "_id": "6077c4efbc5f4d4df9ef1da5"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f683497ca5ac358f1702939",
                                                      "_id": "6077c4efbc5f4d4df9ef1da2",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc2",
                                                              "_id": "6077c4efbc5f4d4df9ef1da3"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Evaluation Of Bounded Plane Area By Integration",
                                                      "id": "5f683497ca5ac358f1702940",
                                                      "_id": "6077c4efbc5f4d4df9ef1da0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc3",
                                                              "_id": "6077c4efbc5f4d4df9ef1da1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reduction Formulae",
                                                      "id": "5f683497ca5ac358f170293e",
                                                      "_id": "6077c4efbc5f4d4df9ef1d9e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc4",
                                                              "_id": "6077c4efbc5f4d4df9ef1d9f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                      "id": "5f683497ca5ac358f1702941",
                                                      "_id": "6077c4efbc5f4d4df9ef1d9c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc5",
                                                              "_id": "6077c4efbc5f4d4df9ef1d9d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Improper Integrals",
                                                      "id": "5f683497ca5ac358f170293d",
                                                      "_id": "6077c4efbc5f4d4df9ef1d9a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc6",
                                                              "_id": "6077c4efbc5f4d4df9ef1d9b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bernoulli’S Formula",
                                                      "id": "5f683497ca5ac358f170293c",
                                                      "_id": "6077c4efbc5f4d4df9ef1d98",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc7",
                                                              "_id": "6077c4efbc5f4d4df9ef1d99"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integral As The Limit Of A Sum",
                                                      "id": "5f683497ca5ac358f170293a",
                                                      "_id": "6077c4efbc5f4d4df9ef1d96",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc8",
                                                              "_id": "6077c4efbc5f4d4df9ef1d97"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cd",
                                                      "_id": "6077c4efbc5f4d4df9ef1da8"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentials And Partial Derivatives",
                                              "id": "5f6831c6f100a06808b0d4f2",
                                              "_id": "6077c4efbc5f4d4df9ef1d87",
                                              "concepts": [
                                                  {
                                                      "name": "Partial Derivatives",
                                                      "id": "5f68345471814158f68cc765",
                                                      "_id": "6077c4efbc5f4d4df9ef1d92",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcc9",
                                                              "_id": "6077c4efbc5f4d4df9ef1d93"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differentials",
                                                      "id": "5f68345471814158f68cc762",
                                                      "_id": "6077c4efbc5f4d4df9ef1d90",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcca",
                                                              "_id": "6077c4efbc5f4d4df9ef1d91"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions Of Several Variables",
                                                      "id": "5f68345471814158f68cc763",
                                                      "_id": "6077c4efbc5f4d4df9ef1d8e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccb",
                                                              "_id": "6077c4efbc5f4d4df9ef1d8f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f68345471814158f68cc761",
                                                      "_id": "6077c4efbc5f4d4df9ef1d8c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccc",
                                                              "_id": "6077c4efbc5f4d4df9ef1d8d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                      "id": "5f68345471814158f68cc764",
                                                      "_id": "6077c4efbc5f4d4df9ef1d8a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccd",
                                                              "_id": "6077c4efbc5f4d4df9ef1d8b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differential Of A",
                                                      "id": "5f68345471814158f68cc766",
                                                      "_id": "6077c4efbc5f4d4df9ef1d88",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcce",
                                                              "_id": "6077c4efbc5f4d4df9ef1d89"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9ce",
                                                      "_id": "6077c4efbc5f4d4df9ef1d94"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Theory Of Equations",
                                              "id": "5f6831c6f100a06808b0d4ed",
                                              "_id": "6077c4efbc5f4d4df9ef1d73",
                                              "concepts": [
                                                  {
                                                      "name": "Basics Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53b",
                                                      "_id": "6077c4efbc5f4d4df9ef1d84",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dccf",
                                                              "_id": "6077c4efbc5f4d4df9ef1d85"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Vieta’S Formulae And Formation Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53c",
                                                      "_id": "6077c4efbc5f4d4df9ef1d82",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd0",
                                                              "_id": "6077c4efbc5f4d4df9ef1d83"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Roots Of Higher Degree Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53f",
                                                      "_id": "6077c4efbc5f4d4df9ef1d80",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd1",
                                                              "_id": "6077c4efbc5f4d4df9ef1d81"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nature Of Roots And Nature Of Coefficients Of Polynomial Equations",
                                                      "id": "5f6832c3f100a06808b0d53d",
                                                      "_id": "6077c4efbc5f4d4df9ef1d7e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd2",
                                                              "_id": "6077c4efbc5f4d4df9ef1d7f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications To Geometrical Problems",
                                                      "id": "5f6832c3f100a06808b0d53e",
                                                      "_id": "6077c4efbc5f4d4df9ef1d7c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd3",
                                                              "_id": "6077c4efbc5f4d4df9ef1d7d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomial Equations With No Additional Information",
                                                      "id": "5f6832c3f100a06808b0d541",
                                                      "_id": "6077c4efbc5f4d4df9ef1d7a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd4",
                                                              "_id": "6077c4efbc5f4d4df9ef1d7b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Descartes Rule",
                                                      "id": "5f6832c3f100a06808b0d542",
                                                      "_id": "6077c4efbc5f4d4df9ef1d78",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd5",
                                                              "_id": "6077c4efbc5f4d4df9ef1d79"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomials With Additional Information",
                                                      "id": "5f6832c3f100a06808b0d540",
                                                      "_id": "6077c4efbc5f4d4df9ef1d76",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd6",
                                                              "_id": "6077c4efbc5f4d4df9ef1d77"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6832c3f100a06808b0d53a",
                                                      "_id": "6077c4efbc5f4d4df9ef1d74",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd7",
                                                              "_id": "6077c4efbc5f4d4df9ef1d75"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9cf",
                                                      "_id": "6077c4efbc5f4d4df9ef1d86"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Calculus - Differentiability And Methods Of Differentiation",
                                              "id": "5f68661f71814158f68ce591",
                                              "_id": "6077c4efbc5f4d4df9ef1d69",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159ff",
                                                      "_id": "6077c4efbc5f4d4df9ef1d70",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd8",
                                                              "_id": "6077c4efbc5f4d4df9ef1d71"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Concept Of Derivative",
                                                      "id": "5f686a41058075680d815a00",
                                                      "_id": "6077c4efbc5f4d4df9ef1d6e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcd9",
                                                              "_id": "6077c4efbc5f4d4df9ef1d6f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiability And Continuity",
                                                      "id": "5f686a41058075680d815a01",
                                                      "_id": "6077c4efbc5f4d4df9ef1d6c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcda",
                                                              "_id": "6077c4efbc5f4d4df9ef1d6d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differentiation Rules",
                                                      "id": "5f686a41058075680d815a02",
                                                      "_id": "6077c4efbc5f4d4df9ef1d6a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdb",
                                                              "_id": "6077c4efbc5f4d4df9ef1d6b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d0",
                                                      "_id": "6077c4efbc5f4d4df9ef1d72"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Vector Algebra",
                                              "id": "5f68661f71814158f68ce58f",
                                              "_id": "6077c4efbc5f4d4df9ef1d57",
                                              "concepts": [
                                                  {
                                                      "name": "Algebra Of Vectors",
                                                      "id": "5f686a41058075680d8159f7",
                                                      "_id": "6077c4efbc5f4d4df9ef1d66",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdc",
                                                              "_id": "6077c4efbc5f4d4df9ef1d67"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Resolution Of Vectors",
                                                      "id": "5f686a41058075680d8159f9",
                                                      "_id": "6077c4efbc5f4d4df9ef1d64",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdd",
                                                              "_id": "6077c4efbc5f4d4df9ef1d65"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Direction Cosines And Directon Ratios",
                                                      "id": "5f686a41058075680d8159fa",
                                                      "_id": "6077c4efbc5f4d4df9ef1d62",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcde",
                                                              "_id": "6077c4efbc5f4d4df9ef1d63"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Scalars And Vectors",
                                                      "id": "5f686a41058075680d8159f5",
                                                      "_id": "6077c4efbc5f4d4df9ef1d60",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcdf",
                                                              "_id": "6077c4efbc5f4d4df9ef1d61"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Position Vectors",
                                                      "id": "5f686a41058075680d8159f8",
                                                      "_id": "6077c4efbc5f4d4df9ef1d5e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce0",
                                                              "_id": "6077c4efbc5f4d4df9ef1d5f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Product Of Vectors",
                                                      "id": "5f686a41058075680d8159fb",
                                                      "_id": "6077c4efbc5f4d4df9ef1d5c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce1",
                                                              "_id": "6077c4efbc5f4d4df9ef1d5d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Representation Of A Vector And Types Of Vectors",
                                                      "id": "5f686a41058075680d8159f6",
                                                      "_id": "6077c4efbc5f4d4df9ef1d5a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce2",
                                                              "_id": "6077c4efbc5f4d4df9ef1d5b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159f4",
                                                      "_id": "6077c4efbc5f4d4df9ef1d58",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce3",
                                                              "_id": "6077c4efbc5f4d4df9ef1d59"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d1",
                                                      "_id": "6077c4efbc5f4d4df9ef1d68"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differential Calculus - Limits And Continuity",
                                              "id": "5f68661f71814158f68ce590",
                                              "_id": "6077c4efbc5f4d4df9ef1d4f",
                                              "concepts": [
                                                  {
                                                      "name": "Limits",
                                                      "id": "5f686a41058075680d8159fd",
                                                      "_id": "6077c4efbc5f4d4df9ef1d54",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce4",
                                                              "_id": "6077c4efbc5f4d4df9ef1d55"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuity",
                                                      "id": "5f686a41058075680d8159fe",
                                                      "_id": "6077c4efbc5f4d4df9ef1d52",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce5",
                                                              "_id": "6077c4efbc5f4d4df9ef1d53"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159fc",
                                                      "_id": "6077c4efbc5f4d4df9ef1d50",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce6",
                                                              "_id": "6077c4efbc5f4d4df9ef1d51"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d2",
                                                      "_id": "6077c4efbc5f4d4df9ef1d56"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Integral Calculus",
                                              "id": "5f68661f71814158f68ce592",
                                              "_id": "6077c4efbc5f4d4df9ef1d3f",
                                              "concepts": [
                                                  {
                                                      "name": "Integrals Of The Form F(Ax + B)",
                                                      "id": "5f686a41058075680d815a06",
                                                      "_id": "6077c4efbc5f4d4df9ef1d4c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce7",
                                                              "_id": "6077c4efbc5f4d4df9ef1d4d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Rules Of Integration",
                                                      "id": "5f686a41058075680d815a05",
                                                      "_id": "6077c4efbc5f4d4df9ef1d4a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce8",
                                                              "_id": "6077c4efbc5f4d4df9ef1d4b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Properties Of Integrals",
                                                      "id": "5f686a41058075680d815a07",
                                                      "_id": "6077c4efbc5f4d4df9ef1d48",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dce9",
                                                              "_id": "6077c4efbc5f4d4df9ef1d49"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Applications",
                                                      "id": "5f686a41058075680d815a08",
                                                      "_id": "6077c4efbc5f4d4df9ef1d46",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcea",
                                                              "_id": "6077c4efbc5f4d4df9ef1d47"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Methods Of Integration",
                                                      "id": "5f686a41058075680d815a09",
                                                      "_id": "6077c4efbc5f4d4df9ef1d44",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dceb",
                                                              "_id": "6077c4efbc5f4d4df9ef1d45"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d815a03",
                                                      "_id": "6077c4efbc5f4d4df9ef1d42",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcec",
                                                              "_id": "6077c4efbc5f4d4df9ef1d43"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Newton-Leibnitz Integral",
                                                      "id": "5f686a41058075680d815a04",
                                                      "_id": "6077c4efbc5f4d4df9ef1d40",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dced",
                                                              "_id": "6077c4efbc5f4d4df9ef1d41"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d3",
                                                      "_id": "6077c4efbc5f4d4df9ef1d4e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Introduction To Probability Theory",
                                              "id": "5f68661f71814158f68ce593",
                                              "_id": "6077c4efbc5f4d4df9ef1d2d",
                                              "concepts": [
                                                  {
                                                      "name": "Probability",
                                                      "id": "5f686a41058075680d815a0d",
                                                      "_id": "6077c4efbc5f4d4df9ef1d3c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcee",
                                                              "_id": "6077c4efbc5f4d4df9ef1d3d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Total Probability Of An Event",
                                                      "id": "5f686a41058075680d815a10",
                                                      "_id": "6077c4efbc5f4d4df9ef1d3a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcef",
                                                              "_id": "6077c4efbc5f4d4df9ef1d3b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Some Basic Theorems On Probability",
                                                      "id": "5f686a41058075680d815a0e",
                                                      "_id": "6077c4efbc5f4d4df9ef1d38",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf0",
                                                              "_id": "6077c4efbc5f4d4df9ef1d39"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d815a0a",
                                                      "_id": "6077c4efbc5f4d4df9ef1d36",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf1",
                                                              "_id": "6077c4efbc5f4d4df9ef1d37"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Finite Sample Space",
                                                      "id": "5f686a41058075680d815a0c",
                                                      "_id": "6077c4efbc5f4d4df9ef1d34",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf2",
                                                              "_id": "6077c4efbc5f4d4df9ef1d35"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Basic Definitions",
                                                      "id": "5f686a41058075680d815a0b",
                                                      "_id": "6077c4efbc5f4d4df9ef1d32",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf3",
                                                              "_id": "6077c4efbc5f4d4df9ef1d33"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Conditional Probability",
                                                      "id": "5f686a41058075680d815a0f",
                                                      "_id": "6077c4efbc5f4d4df9ef1d30",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf4",
                                                              "_id": "6077c4efbc5f4d4df9ef1d31"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bayes’ Theorem",
                                                      "id": "5f686a41058075680d815a11",
                                                      "_id": "6077c4efbc5f4d4df9ef1d2e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf5",
                                                              "_id": "6077c4efbc5f4d4df9ef1d2f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d4",
                                                      "_id": "6077c4efbc5f4d4df9ef1d3e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Matrices And Determinants",
                                              "id": "5f68661f71814158f68ce58e",
                                              "_id": "6077c4efbc5f4d4df9ef1d25",
                                              "concepts": [
                                                  {
                                                      "name": "Determinants",
                                                      "id": "5f686a41058075680d8159f3",
                                                      "_id": "6077c4efbc5f4d4df9ef1d2a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf6",
                                                              "_id": "6077c4efbc5f4d4df9ef1d2b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matrices",
                                                      "id": "5f686a41058075680d8159f2",
                                                      "_id": "6077c4efbc5f4d4df9ef1d28",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf7",
                                                              "_id": "6077c4efbc5f4d4df9ef1d29"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159f1",
                                                      "_id": "6077c4efbc5f4d4df9ef1d26",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf8",
                                                              "_id": "6077c4efbc5f4d4df9ef1d27"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d5",
                                                      "_id": "6077c4efbc5f4d4df9ef1d2c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Binomial Th Eorem, Sequences And Series",
                                              "id": "5f68661f71814158f68ce58c",
                                              "_id": "6077c4efbc5f4d4df9ef1d17",
                                              "concepts": [
                                                  {
                                                      "name": "Finite Series",
                                                      "id": "5f686a41058075680d8159ea",
                                                      "_id": "6077c4efbc5f4d4df9ef1d22",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcf9",
                                                              "_id": "6077c4efbc5f4d4df9ef1d23"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binomial Theorem",
                                                      "id": "5f686a41058075680d8159e7",
                                                      "_id": "6077c4efbc5f4d4df9ef1d20",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfa",
                                                              "_id": "6077c4efbc5f4d4df9ef1d21"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159e6",
                                                      "_id": "6077c4efbc5f4d4df9ef1d1e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfb",
                                                              "_id": "6077c4efbc5f4d4df9ef1d1f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Particular Cases Of Binomial Theorem",
                                                      "id": "5f686a41058075680d8159e8",
                                                      "_id": "6077c4efbc5f4d4df9ef1d1c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfc",
                                                              "_id": "6077c4efbc5f4d4df9ef1d1d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Finite Sequences",
                                                      "id": "5f686a41058075680d8159e9",
                                                      "_id": "6077c4efbc5f4d4df9ef1d1a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfd",
                                                              "_id": "6077c4efbc5f4d4df9ef1d1b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Infinite Sequences And Series",
                                                      "id": "5f686a41058075680d8159eb",
                                                      "_id": "6077c4efbc5f4d4df9ef1d18",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dcfe",
                                                              "_id": "6077c4efbc5f4d4df9ef1d19"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d6",
                                                      "_id": "6077c4efbc5f4d4df9ef1d24"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef1da9"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Electrostatics",
                                              "id": "5f6991e8058075680d81d37c",
                                              "_id": "6077c4efbc5f4d4df9ef1d02",
                                              "concepts": [
                                                  {
                                                      "name": "Electrostatics Of Conductors And Dielectrics",
                                                      "id": "5f69922571814158f68d60ef",
                                                      "_id": "6077c4efbc5f4d4df9ef1d13",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded6",
                                                              "_id": "6077c4efbc5f4d4df9ef1d14"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Distribution Of Charges In A Conductor And Action At Points",
                                                      "id": "5f69922571814158f68d60f1",
                                                      "_id": "6077c4efbc5f4d4df9ef1d11",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded7",
                                                              "_id": "6077c4efbc5f4d4df9ef1d12"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Dipole And Its Properties",
                                                      "id": "5f69922571814158f68d60ec",
                                                      "_id": "6077c4efbc5f4d4df9ef1d0f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded8",
                                                              "_id": "6077c4efbc5f4d4df9ef1d10"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Field And Electric Field Lines",
                                                      "id": "5f69922571814158f68d60eb",
                                                      "_id": "6077c4efbc5f4d4df9ef1d0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673ded9",
                                                              "_id": "6077c4efbc5f4d4df9ef1d0e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb’s Law",
                                                      "id": "5f69922571814158f68d60ea",
                                                      "_id": "6077c4efbc5f4d4df9ef1d0b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deda",
                                                              "_id": "6077c4efbc5f4d4df9ef1d0c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electrostatic Potential And Potential Energy",
                                                      "id": "5f69922571814158f68d60ed",
                                                      "_id": "6077c4efbc5f4d4df9ef1d09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedb",
                                                              "_id": "6077c4efbc5f4d4df9ef1d0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f69922571814158f68d60e9",
                                                      "_id": "6077c4efbc5f4d4df9ef1d07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedc",
                                                              "_id": "6077c4efbc5f4d4df9ef1d08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Capacitors And Capacitance",
                                                      "id": "5f69922571814158f68d60f0",
                                                      "_id": "6077c4efbc5f4d4df9ef1d05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedd",
                                                              "_id": "6077c4efbc5f4d4df9ef1d06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gauss Law And Its Applications",
                                                      "id": "5f69922571814158f68d60ee",
                                                      "_id": "6077c4efbc5f4d4df9ef1d03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dede",
                                                              "_id": "6077c4efbc5f4d4df9ef1d04"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd85",
                                                      "_id": "6077c4efbc5f4d4df9ef1d15"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Dual Nature Of Radiation And Matter",
                                              "id": "5f6991e8058075680d81d382",
                                              "_id": "6077c4efbc5f4d4df9ef1cf8",
                                              "concepts": [
                                                  {
                                                      "name": "Photo Electric Effect",
                                                      "id": "5f69948d71814158f68d6237",
                                                      "_id": "6077c4efbc5f4d4df9ef1cff",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dedf",
                                                              "_id": "6077c4efbc5f4d4df9ef1d00"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f69948d71814158f68d6236",
                                                      "_id": "6077c4efbc5f4d4df9ef1cfd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee0",
                                                              "_id": "6077c4efbc5f4d4df9ef1cfe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matter Waves",
                                                      "id": "5f69948d71814158f68d6238",
                                                      "_id": "6077c4efbc5f4d4df9ef1cfb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee1",
                                                              "_id": "6077c4efbc5f4d4df9ef1cfc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "X – Rays",
                                                      "id": "5f69948d71814158f68d6239",
                                                      "_id": "6077c4efbc5f4d4df9ef1cf9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee2",
                                                              "_id": "6077c4efbc5f4d4df9ef1cfa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd86",
                                                      "_id": "6077c4efbc5f4d4df9ef1d01"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Magnetism And Magnetic Effects Of Electric Current",
                                              "id": "5f6991e8058075680d81d37e",
                                              "_id": "6077c4efbc5f4d4df9ef1ce0",
                                              "concepts": [
                                                  {
                                                      "name": "Torque Acting On A Bar Magnet In Uniform Magnetic Field",
                                                      "id": "5f6993e8ca5ac358f170d8d8",
                                                      "_id": "6077c4efbc5f4d4df9ef1cf5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee3",
                                                              "_id": "6077c4efbc5f4d4df9ef1cf6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Properties",
                                                      "id": "5f6993e8ca5ac358f170d8d9",
                                                      "_id": "6077c4efbc5f4d4df9ef1cf3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee4",
                                                              "_id": "6077c4efbc5f4d4df9ef1cf4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction To Magnetism",
                                                      "id": "5f6993e8ca5ac358f170d8d6",
                                                      "_id": "6077c4efbc5f4d4df9ef1cf1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee5",
                                                              "_id": "6077c4efbc5f4d4df9ef1cf2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Hysteresis",
                                                      "id": "5f6993e8ca5ac358f170d8db",
                                                      "_id": "6077c4efbc5f4d4df9ef1cef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee6",
                                                              "_id": "6077c4efbc5f4d4df9ef1cf0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Magnetic Effects Of Current",
                                                      "id": "5f6993e8ca5ac358f170d8dc",
                                                      "_id": "6077c4efbc5f4d4df9ef1ced",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee7",
                                                              "_id": "6077c4efbc5f4d4df9ef1cee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Lorentz Force",
                                                      "id": "5f6993e8ca5ac358f170d8df",
                                                      "_id": "6077c4efbc5f4d4df9ef1ceb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee8",
                                                              "_id": "6077c4efbc5f4d4df9ef1cec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification Of Magnetic Materials",
                                                      "id": "5f6993e8ca5ac358f170d8da",
                                                      "_id": "6077c4efbc5f4d4df9ef1ce9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673dee9",
                                                              "_id": "6077c4efbc5f4d4df9ef1cea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Biot - Savart Law",
                                                      "id": "5f6993e8ca5ac358f170d8dd",
                                                      "_id": "6077c4efbc5f4d4df9ef1ce7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deea",
                                                              "_id": "6077c4efbc5f4d4df9ef1ce8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Ampère’s Circuital Law",
                                                      "id": "5f6993e8ca5ac358f170d8de",
                                                      "_id": "6077c4efbc5f4d4df9ef1ce5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deeb",
                                                              "_id": "6077c4efbc5f4d4df9ef1ce6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Coulomb’s Inverse Square Law Of Magnetism",
                                                      "id": "5f6993e8ca5ac358f170d8d7",
                                                      "_id": "6077c4efbc5f4d4df9ef1ce3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deec",
                                                              "_id": "6077c4efbc5f4d4df9ef1ce4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Torque On A Current Loop",
                                                      "id": "5f6993e8ca5ac358f170d8e0",
                                                      "_id": "6077c4efbc5f4d4df9ef1ce1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deed",
                                                              "_id": "6077c4efbc5f4d4df9ef1ce2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd87",
                                                      "_id": "6077c4efbc5f4d4df9ef1cf7"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Atomic And Nuclear Physics",
                                              "id": "5f6991e8058075680d81d383",
                                              "_id": "6077c4efbc5f4d4df9ef1cce",
                                              "concepts": [
                                                  {
                                                      "name": "Nuclei",
                                                      "id": "5f6994b7ca5ac358f170d965",
                                                      "_id": "6077c4efbc5f4d4df9ef1cdd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def5",
                                                              "_id": "6077c4efbc5f4d4df9ef1cde"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Discharge Through Gases",
                                                      "id": "5f6994b7ca5ac358f170d963",
                                                      "_id": "6077c4efbc5f4d4df9ef1cdb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def6",
                                                              "_id": "6077c4efbc5f4d4df9ef1cdc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fusion",
                                                      "id": "5f6994b7ca5ac358f170d969",
                                                      "_id": "6077c4efbc5f4d4df9ef1cd9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def7",
                                                              "_id": "6077c4efbc5f4d4df9ef1cda"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Force",
                                                      "id": "5f6994b7ca5ac358f170d966",
                                                      "_id": "6077c4efbc5f4d4df9ef1cd7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def8",
                                                              "_id": "6077c4efbc5f4d4df9ef1cd8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radioactivity",
                                                      "id": "5f6994b7ca5ac358f170d967",
                                                      "_id": "6077c4efbc5f4d4df9ef1cd5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673def9",
                                                              "_id": "6077c4efbc5f4d4df9ef1cd6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fission",
                                                      "id": "5f6994b7ca5ac358f170d968",
                                                      "_id": "6077c4efbc5f4d4df9ef1cd3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defa",
                                                              "_id": "6077c4efbc5f4d4df9ef1cd4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atom Models",
                                                      "id": "5f6994b7ca5ac358f170d964",
                                                      "_id": "6077c4efbc5f4d4df9ef1cd1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defb",
                                                              "_id": "6077c4efbc5f4d4df9ef1cd2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6994b7ca5ac358f170d962",
                                                      "_id": "6077c4efbc5f4d4df9ef1ccf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defc",
                                                              "_id": "6077c4efbc5f4d4df9ef1cd0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd89",
                                                      "_id": "6077c4efbc5f4d4df9ef1cdf"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4efbc5f4d4df9ef1d16"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Analogy",
                                              "id": "5ace20309fe7b01d5806bc1e",
                                              "_id": "6077c4efbc5f4d4df9ef1cc9",
                                              "concepts": [
                                                  {
                                                      "name": "Analogy",
                                                      "id": "5ace20389fe7b01d5806bf0c",
                                                      "_id": "6077c4efbc5f4d4df9ef1cca",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8445",
                                                              "_id": "6077c4efbc5f4d4df9ef1ccb"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825e",
                                                      "_id": "6077c4efbc5f4d4df9ef1ccc"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Arithmetical Reasoning",
                                              "id": "5ace20309fe7b01d5806bc1f",
                                              "_id": "6077c4efbc5f4d4df9ef1cc5",
                                              "concepts": [
                                                  {
                                                      "name": "Arithmetical Reasoning",
                                                      "id": "5ace20389fe7b01d5806bf0d",
                                                      "_id": "6077c4efbc5f4d4df9ef1cc6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8446",
                                                              "_id": "6077c4efbc5f4d4df9ef1cc7"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c825f",
                                                      "_id": "6077c4efbc5f4d4df9ef1cc8"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4efbc5f4d4df9ef1ccd"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "Outcomes of Democracy",
                                              "id": "5ace20329fe7b01d5806bce9",
                                              "_id": "6077c4efbc5f4d4df9ef1cc0",
                                              "concepts": [
                                                  {
                                                      "name": "Democracy as accountable, legimate and responsive government",
                                                      "id": "5ace20429fe7b01d5806c236",
                                                      "_id": "6077c4efbc5f4d4df9ef1cc1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849d",
                                                              "_id": "6077c4efbc5f4d4df9ef1cc2"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8291",
                                                      "_id": "6077c4efbc5f4d4df9ef1cc3"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Challenges to Democracy",
                                              "id": "5ace20329fe7b01d5806bce1",
                                              "_id": "6077c4efbc5f4d4df9ef1cbc",
                                              "concepts": [
                                                  {
                                                      "name": "Challenges to Democracy",
                                                      "id": "5ace20429fe7b01d5806c22b",
                                                      "_id": "6077c4efbc5f4d4df9ef1cbd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849e",
                                                              "_id": "6077c4efbc5f4d4df9ef1cbe"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8292",
                                                      "_id": "6077c4efbc5f4d4df9ef1cbf"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "The story of Village Palampur",
                                              "id": "5ace20329fe7b01d5806bcc3",
                                              "_id": "6077c4efbc5f4d4df9ef1cb6",
                                              "concepts": [
                                                  {
                                                      "name": "Factors of production",
                                                      "id": "5ace20419fe7b01d5806c1f2",
                                                      "_id": "6077c4efbc5f4d4df9ef1cb9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c849f",
                                                              "_id": "6077c4efbc5f4d4df9ef1cba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Green revolution",
                                                      "id": "5ace20419fe7b01d5806c1f3",
                                                      "_id": "6077c4efbc5f4d4df9ef1cb7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a0",
                                                              "_id": "6077c4efbc5f4d4df9ef1cb8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8293",
                                                      "_id": "6077c4efbc5f4d4df9ef1cbb"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4efbc5f4d4df9ef1cc4"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4efbc5f4d4df9ef1cb5"
                                          }
                                      ]
                                  }
                              ]
                          },
                          {
                              "weekNo": 12,
                              "startDate": "2021-07-15T00:00:00.000Z",
                              "endDate": "2021-07-21T00:00:00.000Z",
                              "_id": "6077c4eebc5f4d4df9ef1b46",
                              "content": [],
                              "subjects": [
                                  {
                                      "name": "Biology",
                                      "id": "5ace202e9fe7b01d5806bb89",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b2",
                                              "_id": "6077c4efbc5f4d4df9ef1cb3"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Chemistry",
                                      "id": "5ace202e9fe7b01d5806bb8a",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b3",
                                              "_id": "6077c4efbc5f4d4df9ef1cb2"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Mathematics",
                                      "id": "5ace202e9fe7b01d5806bb8e",
                                      "chapters": [
                                          {
                                              "name": "Combinatorics And Mathematical Induction",
                                              "id": "5f68661f71814158f68ce58b",
                                              "_id": "6077c4efbc5f4d4df9ef1ca3",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159e0",
                                                      "_id": "6077c4efbc5f4d4df9ef1cae",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd08",
                                                              "_id": "6077c4efbc5f4d4df9ef1caf"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Permutations",
                                                      "id": "5f686a41058075680d8159e3",
                                                      "_id": "6077c4efbc5f4d4df9ef1cac",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd09",
                                                              "_id": "6077c4efbc5f4d4df9ef1cad"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Combinations",
                                                      "id": "5f686a41058075680d8159e4",
                                                      "_id": "6077c4efbc5f4d4df9ef1caa",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0a",
                                                              "_id": "6077c4efbc5f4d4df9ef1cab"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Factorials",
                                                      "id": "5f686a41058075680d8159e2",
                                                      "_id": "6077c4efbc5f4d4df9ef1ca8",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0b",
                                                              "_id": "6077c4efbc5f4d4df9ef1ca9"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Induction",
                                                      "id": "5f686a41058075680d8159e5",
                                                      "_id": "6077c4efbc5f4d4df9ef1ca6",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0c",
                                                              "_id": "6077c4efbc5f4d4df9ef1ca7"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Principles Of Counting",
                                                      "id": "5f686a41058075680d8159e1",
                                                      "_id": "6077c4efbc5f4d4df9ef1ca4",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0d",
                                                              "_id": "6077c4efbc5f4d4df9ef1ca5"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d8",
                                                      "_id": "6077c4efbc5f4d4df9ef1cb0"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sets, Relations And Functions",
                                              "id": "5f68661f71814158f68ce588",
                                              "_id": "6077c4efbc5f4d4df9ef1c93",
                                              "concepts": [
                                                  {
                                                      "name": "Sets",
                                                      "id": "5f686a41058075680d8159c7",
                                                      "_id": "6077c4efbc5f4d4df9ef1ca0",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0e",
                                                              "_id": "6077c4efbc5f4d4df9ef1ca1"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Relations",
                                                      "id": "5f686a41058075680d8159ca",
                                                      "_id": "6077c4efbc5f4d4df9ef1c9e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd0f",
                                                              "_id": "6077c4efbc5f4d4df9ef1c9f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions",
                                                      "id": "5f686a41058075680d8159cb",
                                                      "_id": "6077c4efbc5f4d4df9ef1c9c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd10",
                                                              "_id": "6077c4efbc5f4d4df9ef1c9d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Graphing Functions Using Transformations",
                                                      "id": "5f686a41058075680d8159cc",
                                                      "_id": "6077c4efbc5f4d4df9ef1c9a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd11",
                                                              "_id": "6077c4efbc5f4d4df9ef1c9b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Cartesian Product",
                                                      "id": "5f686a41058075680d8159c8",
                                                      "_id": "6077c4efbc5f4d4df9ef1c98",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd12",
                                                              "_id": "6077c4efbc5f4d4df9ef1c99"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159c6",
                                                      "_id": "6077c4efbc5f4d4df9ef1c96",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd13",
                                                              "_id": "6077c4efbc5f4d4df9ef1c97"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Constants And Variables, Intervals And Neighbourhoods",
                                                      "id": "5f686a41058075680d8159c9",
                                                      "_id": "6077c4efbc5f4d4df9ef1c94",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd14",
                                                              "_id": "6077c4efbc5f4d4df9ef1c95"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9d9",
                                                      "_id": "6077c4efbc5f4d4df9ef1ca2"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Two Dimensional Analytical Geometry",
                                              "id": "5f68661f71814158f68ce58d",
                                              "_id": "6077c4efbc5f4d4df9ef1c87",
                                              "concepts": [
                                                  {
                                                      "name": "Straight Lines",
                                                      "id": "5f686a41058075680d8159ee",
                                                      "_id": "6077c4efbc5f4d4df9ef1c90",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd15",
                                                              "_id": "6077c4efbc5f4d4df9ef1c91"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159ec",
                                                      "_id": "6077c4efbc5f4d4df9ef1c8e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd16",
                                                              "_id": "6077c4efbc5f4d4df9ef1c8f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Pair Of Straight Lines",
                                                      "id": "5f686a41058075680d8159f0",
                                                      "_id": "6077c4efbc5f4d4df9ef1c8c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd17",
                                                              "_id": "6077c4efbc5f4d4df9ef1c8d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Locus Of A Point",
                                                      "id": "5f686a41058075680d8159ed",
                                                      "_id": "6077c4efbc5f4d4df9ef1c8a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd18",
                                                              "_id": "6077c4efbc5f4d4df9ef1c8b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Angle Between Two Straight Lines",
                                                      "id": "5f686a41058075680d8159ef",
                                                      "_id": "6077c4efbc5f4d4df9ef1c88",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd19",
                                                              "_id": "6077c4efbc5f4d4df9ef1c89"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9da",
                                                      "_id": "6077c4efbc5f4d4df9ef1c92"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Basic Algebra",
                                              "id": "5f68661f71814158f68ce589",
                                              "_id": "6077c4eebc5f4d4df9ef1c71",
                                              "concepts": [
                                                  {
                                                      "name": "Quadratic Functions",
                                                      "id": "5f686a41058075680d8159d1",
                                                      "_id": "6077c4efbc5f4d4df9ef1c84",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1a",
                                                              "_id": "6077c4efbc5f4d4df9ef1c85"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polynomial Functions",
                                                      "id": "5f686a41058075680d8159d2",
                                                      "_id": "6077c4efbc5f4d4df9ef1c82",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1b",
                                                              "_id": "6077c4efbc5f4d4df9ef1c83"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Rational Functions",
                                                      "id": "5f686a41058075680d8159d3",
                                                      "_id": "6077c4efbc5f4d4df9ef1c80",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1c",
                                                              "_id": "6077c4efbc5f4d4df9ef1c81"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Real Number System",
                                                      "id": "5f686a41058075680d8159ce",
                                                      "_id": "6077c4efbc5f4d4df9ef1c7e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1d",
                                                              "_id": "6077c4efbc5f4d4df9ef1c7f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f686a41058075680d8159cd",
                                                      "_id": "6077c4efbc5f4d4df9ef1c7c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1e",
                                                              "_id": "6077c4efbc5f4d4df9ef1c7d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Exponents And Radicals",
                                                      "id": "5f686a41058075680d8159d4",
                                                      "_id": "6077c4efbc5f4d4df9ef1c7a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd1f",
                                                              "_id": "6077c4efbc5f4d4df9ef1c7b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Algebra In Real Life",
                                                      "id": "5f686a41058075680d8159d6",
                                                      "_id": "6077c4efbc5f4d4df9ef1c78",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd20",
                                                              "_id": "6077c4efbc5f4d4df9ef1c79"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Logarithm",
                                                      "id": "5f686a41058075680d8159d5",
                                                      "_id": "6077c4efbc5f4d4df9ef1c76",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd21",
                                                              "_id": "6077c4efbc5f4d4df9ef1c77"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Absolute Value",
                                                      "id": "5f686a41058075680d8159cf",
                                                      "_id": "6077c4eebc5f4d4df9ef1c74",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd22",
                                                              "_id": "6077c4eebc5f4d4df9ef1c75"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Inequalities",
                                                      "id": "5f686a41058075680d8159d0",
                                                      "_id": "6077c4eebc5f4d4df9ef1c72",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd23",
                                                              "_id": "6077c4eebc5f4d4df9ef1c73"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9db",
                                                      "_id": "6077c4efbc5f4d4df9ef1c86"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Integration",
                                              "id": "5f71d512ce003c1296026cd3",
                                              "_id": "6077c4eebc5f4d4df9ef1c5d",
                                              "concepts": [
                                                  {
                                                      "name": "Evaluation Of Bounded Plane Area By Integration",
                                                      "id": "5f71d7c47ac53612907090e4",
                                                      "_id": "6077c4eebc5f4d4df9ef1c6e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd24",
                                                              "_id": "6077c4eebc5f4d4df9ef1c6f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                      "id": "5f71d7c47ac53612907090e5",
                                                      "_id": "6077c4eebc5f4d4df9ef1c6c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd25",
                                                              "_id": "6077c4eebc5f4d4df9ef1c6d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090dd",
                                                      "_id": "6077c4eebc5f4d4df9ef1c6a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd26",
                                                              "_id": "6077c4eebc5f4d4df9ef1c6b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Definite Integral As The Limit Of A Sum",
                                                      "id": "5f71d7c47ac53612907090de",
                                                      "_id": "6077c4eebc5f4d4df9ef1c68",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd27",
                                                              "_id": "6077c4eebc5f4d4df9ef1c69"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bernoulli’S Formula",
                                                      "id": "5f71d7c47ac53612907090e0",
                                                      "_id": "6077c4eebc5f4d4df9ef1c66",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd28",
                                                              "_id": "6077c4eebc5f4d4df9ef1c67"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Reduction Formulae",
                                                      "id": "5f71d7c47ac53612907090e2",
                                                      "_id": "6077c4eebc5f4d4df9ef1c64",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd29",
                                                              "_id": "6077c4eebc5f4d4df9ef1c65"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Gamma Integral",
                                                      "id": "5f71d7c47ac53612907090e3",
                                                      "_id": "6077c4eebc5f4d4df9ef1c62",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2a",
                                                              "_id": "6077c4eebc5f4d4df9ef1c63"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                      "id": "5f71d7c47ac53612907090df",
                                                      "_id": "6077c4eebc5f4d4df9ef1c60",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2b",
                                                              "_id": "6077c4eebc5f4d4df9ef1c61"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Improper Integrals",
                                                      "id": "5f71d7c47ac53612907090e1",
                                                      "_id": "6077c4eebc5f4d4df9ef1c5e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2c",
                                                              "_id": "6077c4eebc5f4d4df9ef1c5f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9dc",
                                                      "_id": "6077c4eebc5f4d4df9ef1c70"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Applications Of Differential Calculus",
                                              "id": "5f71d512ce003c1296026cd1",
                                              "_id": "6077c4eebc5f4d4df9ef1c47",
                                              "concepts": [
                                                  {
                                                      "name": "Applications In Optimization",
                                                      "id": "5f71d7c47ac53612907090d4",
                                                      "_id": "6077c4eebc5f4d4df9ef1c5a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2d",
                                                              "_id": "6077c4eebc5f4d4df9ef1c5b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090cd",
                                                      "_id": "6077c4eebc5f4d4df9ef1c58",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2e",
                                                              "_id": "6077c4eebc5f4d4df9ef1c59"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Symmetry And Asymptotes",
                                                      "id": "5f71d7c47ac53612907090d5",
                                                      "_id": "6077c4eebc5f4d4df9ef1c56",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd2f",
                                                              "_id": "6077c4eebc5f4d4df9ef1c57"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Meaning Of Derivatives",
                                                      "id": "5f71d7c47ac53612907090ce",
                                                      "_id": "6077c4eebc5f4d4df9ef1c54",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd30",
                                                              "_id": "6077c4eebc5f4d4df9ef1c55"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mean Value Theorem",
                                                      "id": "5f71d7c47ac53612907090cf",
                                                      "_id": "6077c4eebc5f4d4df9ef1c52",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd31",
                                                              "_id": "6077c4eebc5f4d4df9ef1c53"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Series Expansions",
                                                      "id": "5f71d7c47ac53612907090d0",
                                                      "_id": "6077c4eebc5f4d4df9ef1c50",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd32",
                                                              "_id": "6077c4eebc5f4d4df9ef1c51"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of Second Derivative",
                                                      "id": "5f71d7c47ac53612907090d3",
                                                      "_id": "6077c4eebc5f4d4df9ef1c4e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd33",
                                                              "_id": "6077c4eebc5f4d4df9ef1c4f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sketching Of Curves",
                                                      "id": "5f71d7c47ac53612907090d6",
                                                      "_id": "6077c4eebc5f4d4df9ef1c4c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd34",
                                                              "_id": "6077c4eebc5f4d4df9ef1c4d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Indeterminate Forms",
                                                      "id": "5f71d7c47ac53612907090d1",
                                                      "_id": "6077c4eebc5f4d4df9ef1c4a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd35",
                                                              "_id": "6077c4eebc5f4d4df9ef1c4b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Derivative",
                                                      "id": "5f71d7c47ac53612907090d2",
                                                      "_id": "6077c4eebc5f4d4df9ef1c48",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd36",
                                                              "_id": "6077c4eebc5f4d4df9ef1c49"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9dd",
                                                      "_id": "6077c4eebc5f4d4df9ef1c5c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Discrete Mathematics",
                                              "id": "5f71d512ce003c1296026cd6",
                                              "_id": "6077c4eebc5f4d4df9ef1c3f",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090f4",
                                                      "_id": "6077c4eebc5f4d4df9ef1c44",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd37",
                                                              "_id": "6077c4eebc5f4d4df9ef1c45"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Logic",
                                                      "id": "5f71d7c47ac53612907090f6",
                                                      "_id": "6077c4eebc5f4d4df9ef1c42",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd38",
                                                              "_id": "6077c4eebc5f4d4df9ef1c43"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Binary Operations",
                                                      "id": "5f71d7c47ac53612907090f5",
                                                      "_id": "6077c4eebc5f4d4df9ef1c40",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd39",
                                                              "_id": "6077c4eebc5f4d4df9ef1c41"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9de",
                                                      "_id": "6077c4eebc5f4d4df9ef1c46"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability Distributions",
                                              "id": "5f71d512ce003c1296026cd5",
                                              "_id": "6077c4eebc5f4d4df9ef1c31",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Random Variable",
                                                      "id": "5f71d7c47ac53612907090f0",
                                                      "_id": "6077c4eebc5f4d4df9ef1c3c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3a",
                                                              "_id": "6077c4eebc5f4d4df9ef1c3d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Random Variable",
                                                      "id": "5f71d7c47ac53612907090ef",
                                                      "_id": "6077c4eebc5f4d4df9ef1c3a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3b",
                                                              "_id": "6077c4eebc5f4d4df9ef1c3b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                      "id": "5f71d7c47ac53612907090f3",
                                                      "_id": "6077c4eebc5f4d4df9ef1c38",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3c",
                                                              "_id": "6077c4eebc5f4d4df9ef1c39"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090ee",
                                                      "_id": "6077c4eebc5f4d4df9ef1c36",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3d",
                                                              "_id": "6077c4eebc5f4d4df9ef1c37"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mathematical Expectation",
                                                      "id": "5f71d7c47ac53612907090f2",
                                                      "_id": "6077c4eebc5f4d4df9ef1c34",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3e",
                                                              "_id": "6077c4eebc5f4d4df9ef1c35"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Continuous Distributions",
                                                      "id": "5f71d7c47ac53612907090f1",
                                                      "_id": "6077c4eebc5f4d4df9ef1c32",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd3f",
                                                              "_id": "6077c4eebc5f4d4df9ef1c33"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9df",
                                                      "_id": "6077c4eebc5f4d4df9ef1c3e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Differentials And Partial Derivatives",
                                              "id": "5f71d512ce003c1296026cd2",
                                              "_id": "6077c4eebc5f4d4df9ef1c23",
                                              "concepts": [
                                                  {
                                                      "name": "Linear Approximation And Differential Of A",
                                                      "id": "5f71d7c47ac53612907090dc",
                                                      "_id": "6077c4eebc5f4d4df9ef1c2e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd40",
                                                              "_id": "6077c4eebc5f4d4df9ef1c2f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                      "id": "5f71d7c47ac53612907090da",
                                                      "_id": "6077c4eebc5f4d4df9ef1c2c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd41",
                                                              "_id": "6077c4eebc5f4d4df9ef1c2d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Partial Derivatives",
                                                      "id": "5f71d7c47ac53612907090db",
                                                      "_id": "6077c4eebc5f4d4df9ef1c2a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd42",
                                                              "_id": "6077c4eebc5f4d4df9ef1c2b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Functions Of Several Variables",
                                                      "id": "5f71d7c47ac53612907090d9",
                                                      "_id": "6077c4eebc5f4d4df9ef1c28",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd43",
                                                              "_id": "6077c4eebc5f4d4df9ef1c29"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Linear Approximation And Differentials",
                                                      "id": "5f71d7c47ac53612907090d8",
                                                      "_id": "6077c4eebc5f4d4df9ef1c26",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd44",
                                                              "_id": "6077c4eebc5f4d4df9ef1c27"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090d7",
                                                      "_id": "6077c4eebc5f4d4df9ef1c24",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd45",
                                                              "_id": "6077c4eebc5f4d4df9ef1c25"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9e0",
                                                      "_id": "6077c4eebc5f4d4df9ef1c30"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Ordinary Differential Equations",
                                              "id": "5f71d512ce003c1296026cd4",
                                              "_id": "6077c4eebc5f4d4df9ef1c11",
                                              "concepts": [
                                                  {
                                                      "name": "Classification Of Differential Equations",
                                                      "id": "5f71d7c47ac53612907090e8",
                                                      "_id": "6077c4eebc5f4d4df9ef1c20",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd46",
                                                              "_id": "6077c4eebc5f4d4df9ef1c21"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of First Order And First Degree Differential Equations",
                                                      "id": "5f71d7c47ac53612907090eb",
                                                      "_id": "6077c4eebc5f4d4df9ef1c1e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd47",
                                                              "_id": "6077c4eebc5f4d4df9ef1c1f"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Differential Equation, Order, And Degree",
                                                      "id": "5f71d7c47ac53612907090e7",
                                                      "_id": "6077c4eebc5f4d4df9ef1c1c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd48",
                                                              "_id": "6077c4eebc5f4d4df9ef1c1d"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71d7c47ac53612907090e6",
                                                      "_id": "6077c4eebc5f4d4df9ef1c1a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd49",
                                                              "_id": "6077c4eebc5f4d4df9ef1c1b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Formation Of Differential Equations",
                                                      "id": "5f71d7c47ac53612907090e9",
                                                      "_id": "6077c4eebc5f4d4df9ef1c18",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4a",
                                                              "_id": "6077c4eebc5f4d4df9ef1c19"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Applications Of First Order Ordinary Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ed",
                                                      "_id": "6077c4eebc5f4d4df9ef1c16",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4b",
                                                              "_id": "6077c4eebc5f4d4df9ef1c17"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Solution Of Ordinary Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ea",
                                                      "_id": "6077c4eebc5f4d4df9ef1c14",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4c",
                                                              "_id": "6077c4eebc5f4d4df9ef1c15"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "First Order Linear Differential Equations",
                                                      "id": "5f71d7c47ac53612907090ec",
                                                      "_id": "6077c4eebc5f4d4df9ef1c12",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5724b35a0a066673dd4d",
                                                              "_id": "6077c4eebc5f4d4df9ef1c13"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5723b35a0a066673d9e1",
                                                      "_id": "6077c4eebc5f4d4df9ef1c22"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b4",
                                              "_id": "6077c4efbc5f4d4df9ef1cb1"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Physics",
                                      "id": "5ace202e9fe7b01d5806bb8f",
                                      "chapters": [
                                          {
                                              "name": "Semiconductor Electronics",
                                              "id": "5f6991e8058075680d81d384",
                                              "_id": "6077c4eebc5f4d4df9ef1c00",
                                              "concepts": [
                                                  {
                                                      "name": "Types Of Semiconductrors",
                                                      "id": "5f6994deca5ac358f170d985",
                                                      "_id": "6077c4eebc5f4d4df9ef1c0d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defd",
                                                              "_id": "6077c4eebc5f4d4df9ef1c0e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diodes",
                                                      "id": "5f6994deca5ac358f170d986",
                                                      "_id": "6077c4eebc5f4d4df9ef1c0b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673defe",
                                                              "_id": "6077c4eebc5f4d4df9ef1c0c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Bipolar Junction Transistor [Bjt]",
                                                      "id": "5f6994deca5ac358f170d987",
                                                      "_id": "6077c4eebc5f4d4df9ef1c09",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673deff",
                                                              "_id": "6077c4eebc5f4d4df9ef1c0a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Digital Electronics",
                                                      "id": "5f6994deca5ac358f170d988",
                                                      "_id": "6077c4eebc5f4d4df9ef1c07",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df00",
                                                              "_id": "6077c4eebc5f4d4df9ef1c08"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’s Theorem",
                                                      "id": "5f6994deca5ac358f170d98a",
                                                      "_id": "6077c4eebc5f4d4df9ef1c05",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df01",
                                                              "_id": "6077c4eebc5f4d4df9ef1c06"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f6994deca5ac358f170d984",
                                                      "_id": "6077c4eebc5f4d4df9ef1c03",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df02",
                                                              "_id": "6077c4eebc5f4d4df9ef1c04"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Boolean Algebra",
                                                      "id": "5f6994deca5ac358f170d989",
                                                      "_id": "6077c4eebc5f4d4df9ef1c01",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df03",
                                                              "_id": "6077c4eebc5f4d4df9ef1c02"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8a",
                                                      "_id": "6077c4eebc5f4d4df9ef1c0f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Communication Systems",
                                              "id": "5f71cc80414f235e9782af05",
                                              "_id": "6077c4eebc5f4d4df9ef1be6",
                                              "concepts": [
                                                  {
                                                      "name": "Fibre Optic Communication",
                                                      "id": "5f71ce207ac5361290708c0c",
                                                      "_id": "6077c4eebc5f4d4df9ef1bfd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df04",
                                                              "_id": "6077c4eebc5f4d4df9ef1bfe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Global Positioning System",
                                                      "id": "5f71ce207ac5361290708c10",
                                                      "_id": "6077c4eebc5f4d4df9ef1bfb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df05",
                                                              "_id": "6077c4eebc5f4d4df9ef1bfc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Internet",
                                                      "id": "5f71ce207ac5361290708c0f",
                                                      "_id": "6077c4eebc5f4d4df9ef1bf9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df06",
                                                              "_id": "6077c4eebc5f4d4df9ef1bfa"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Antenna Size",
                                                      "id": "5f71ce207ac5361290708c09",
                                                      "_id": "6077c4eebc5f4d4df9ef1bf7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df07",
                                                              "_id": "6077c4eebc5f4d4df9ef1bf8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708c06",
                                                      "_id": "6077c4eebc5f4d4df9ef1bf5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df08",
                                                              "_id": "6077c4eebc5f4d4df9ef1bf6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                      "id": "5f71ce207ac5361290708c11",
                                                      "_id": "6077c4eebc5f4d4df9ef1bf3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df09",
                                                              "_id": "6077c4eebc5f4d4df9ef1bf4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Radar And Applications",
                                                      "id": "5f71ce207ac5361290708c0d",
                                                      "_id": "6077c4eebc5f4d4df9ef1bf1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0a",
                                                              "_id": "6077c4eebc5f4d4df9ef1bf2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Propagation Of Electromagnetic Waves",
                                                      "id": "5f71ce207ac5361290708c0a",
                                                      "_id": "6077c4eebc5f4d4df9ef1bef",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0b",
                                                              "_id": "6077c4eebc5f4d4df9ef1bf0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Elements Of An Electronic Communication System",
                                                      "id": "5f71ce207ac5361290708c08",
                                                      "_id": "6077c4eebc5f4d4df9ef1bed",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0c",
                                                              "_id": "6077c4eebc5f4d4df9ef1bee"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Satellite Communication",
                                                      "id": "5f71ce207ac5361290708c0b",
                                                      "_id": "6077c4eebc5f4d4df9ef1beb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0d",
                                                              "_id": "6077c4eebc5f4d4df9ef1bec"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Mobile Communication",
                                                      "id": "5f71ce207ac5361290708c0e",
                                                      "_id": "6077c4eebc5f4d4df9ef1be9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0e",
                                                              "_id": "6077c4eebc5f4d4df9ef1bea"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Modulation",
                                                      "id": "5f71ce207ac5361290708c07",
                                                      "_id": "6077c4eebc5f4d4df9ef1be7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df0f",
                                                              "_id": "6077c4eebc5f4d4df9ef1be8"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8b",
                                                      "_id": "6077c4eebc5f4d4df9ef1bff"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Recent Developments In Physics",
                                              "id": "5f71cc80414f235e9782af06",
                                              "_id": "6077c4eebc5f4d4df9ef1bde",
                                              "concepts": [
                                                  {
                                                      "name": "Nanoscience And Nanotechnology",
                                                      "id": "5f71ce207ac5361290708c13",
                                                      "_id": "6077c4eebc5f4d4df9ef1be3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df10",
                                                              "_id": "6077c4eebc5f4d4df9ef1be4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708c12",
                                                      "_id": "6077c4eebc5f4d4df9ef1be1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df11",
                                                              "_id": "6077c4eebc5f4d4df9ef1be2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Robotics",
                                                      "id": "5f71ce207ac5361290708c14",
                                                      "_id": "6077c4eebc5f4d4df9ef1bdf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df12",
                                                              "_id": "6077c4eebc5f4d4df9ef1be0"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8c",
                                                      "_id": "6077c4eebc5f4d4df9ef1be5"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Optics",
                                              "id": "5f71cc80414f235e9782af01",
                                              "_id": "6077c4eebc5f4d4df9ef1bc2",
                                              "concepts": [
                                                  {
                                                      "name": "Refraction",
                                                      "id": "5f71ce207ac5361290708be9",
                                                      "_id": "6077c4eebc5f4d4df9ef1bdb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df13",
                                                              "_id": "6077c4eebc5f4d4df9ef1bdc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Refraction At Single Spherical Surface",
                                                      "id": "5f71ce207ac5361290708bea",
                                                      "_id": "6077c4eebc5f4d4df9ef1bd9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df14",
                                                              "_id": "6077c4eebc5f4d4df9ef1bda"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Wave Nature Of Light",
                                                      "id": "5f71ce207ac5361290708bee",
                                                      "_id": "6077c4eebc5f4d4df9ef1bd7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df15",
                                                              "_id": "6077c4eebc5f4d4df9ef1bd8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708be6",
                                                      "_id": "6077c4eebc5f4d4df9ef1bd5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df16",
                                                              "_id": "6077c4eebc5f4d4df9ef1bd6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Theories On Light",
                                                      "id": "5f71ce207ac5361290708bed",
                                                      "_id": "6077c4eebc5f4d4df9ef1bd3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df17",
                                                              "_id": "6077c4eebc5f4d4df9ef1bd4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Polarisation",
                                                      "id": "5f71ce207ac5361290708bf1",
                                                      "_id": "6077c4eebc5f4d4df9ef1bd1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df18",
                                                              "_id": "6077c4eebc5f4d4df9ef1bd2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diffraction",
                                                      "id": "5f71ce207ac5361290708bf0",
                                                      "_id": "6077c4eebc5f4d4df9ef1bcf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df19",
                                                              "_id": "6077c4eebc5f4d4df9ef1bd0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Prism",
                                                      "id": "5f71ce207ac5361290708bec",
                                                      "_id": "6077c4eebc5f4d4df9ef1bcd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1a",
                                                              "_id": "6077c4eebc5f4d4df9ef1bce"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Simple Microscope",
                                                      "id": "5f71ce207ac5361290708bf2",
                                                      "_id": "6077c4eebc5f4d4df9ef1bcb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1b",
                                                              "_id": "6077c4eebc5f4d4df9ef1bcc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Speed Of Light",
                                                      "id": "5f71ce207ac5361290708be8",
                                                      "_id": "6077c4eebc5f4d4df9ef1bc9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1c",
                                                              "_id": "6077c4eebc5f4d4df9ef1bca"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Spherical Mirrors",
                                                      "id": "5f71ce207ac5361290708be7",
                                                      "_id": "6077c4eebc5f4d4df9ef1bc7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1d",
                                                              "_id": "6077c4eebc5f4d4df9ef1bc8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Thin Lens",
                                                      "id": "5f71ce207ac5361290708beb",
                                                      "_id": "6077c4eebc5f4d4df9ef1bc5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1e",
                                                              "_id": "6077c4eebc5f4d4df9ef1bc6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Interference",
                                                      "id": "5f71ce207ac5361290708bef",
                                                      "_id": "6077c4eebc5f4d4df9ef1bc3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df1f",
                                                              "_id": "6077c4eebc5f4d4df9ef1bc4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8d",
                                                      "_id": "6077c4eebc5f4d4df9ef1bdd"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Semiconductor Electronics",
                                              "id": "5f71cc80414f235e9782af04",
                                              "_id": "6077c4eebc5f4d4df9ef1bb2",
                                              "concepts": [
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bff",
                                                      "_id": "6077c4eebc5f4d4df9ef1bbf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df20",
                                                              "_id": "6077c4eebc5f4d4df9ef1bc0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "The Bipolar Junction Transistor [Bjt]",
                                                      "id": "5f71ce207ac5361290708c02",
                                                      "_id": "6077c4eebc5f4d4df9ef1bbd",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df21",
                                                              "_id": "6077c4eebc5f4d4df9ef1bbe"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Digital Electronics",
                                                      "id": "5f71ce207ac5361290708c03",
                                                      "_id": "6077c4eebc5f4d4df9ef1bbb",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df22",
                                                              "_id": "6077c4eebc5f4d4df9ef1bbc"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "De Morgan’S Theorem",
                                                      "id": "5f71ce207ac5361290708c05",
                                                      "_id": "6077c4eebc5f4d4df9ef1bb9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df23",
                                                              "_id": "6077c4eebc5f4d4df9ef1bba"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Diodes",
                                                      "id": "5f71ce207ac5361290708c01",
                                                      "_id": "6077c4eebc5f4d4df9ef1bb7",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df24",
                                                              "_id": "6077c4eebc5f4d4df9ef1bb8"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Types Of Semiconductrors",
                                                      "id": "5f71ce207ac5361290708c00",
                                                      "_id": "6077c4eebc5f4d4df9ef1bb5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df25",
                                                              "_id": "6077c4eebc5f4d4df9ef1bb6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Boolean Algebra",
                                                      "id": "5f71ce207ac5361290708c04",
                                                      "_id": "6077c4eebc5f4d4df9ef1bb3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df26",
                                                              "_id": "6077c4eebc5f4d4df9ef1bb4"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8e",
                                                      "_id": "6077c4eebc5f4d4df9ef1bc1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Dual Nature Of Radiation And Matter",
                                              "id": "5f71cc80414f235e9782af02",
                                              "_id": "6077c4eebc5f4d4df9ef1ba8",
                                              "concepts": [
                                                  {
                                                      "name": "X – Rays",
                                                      "id": "5f71ce207ac5361290708bf6",
                                                      "_id": "6077c4eebc5f4d4df9ef1baf",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df27",
                                                              "_id": "6077c4eebc5f4d4df9ef1bb0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Photo Electric Effect",
                                                      "id": "5f71ce207ac5361290708bf4",
                                                      "_id": "6077c4eebc5f4d4df9ef1bad",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df28",
                                                              "_id": "6077c4eebc5f4d4df9ef1bae"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bf3",
                                                      "_id": "6077c4eebc5f4d4df9ef1bab",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df29",
                                                              "_id": "6077c4eebc5f4d4df9ef1bac"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Matter Waves",
                                                      "id": "5f71ce207ac5361290708bf5",
                                                      "_id": "6077c4eebc5f4d4df9ef1ba9",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2a",
                                                              "_id": "6077c4eebc5f4d4df9ef1baa"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd8f",
                                                      "_id": "6077c4eebc5f4d4df9ef1bb1"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Atomic And Nuclear Physics",
                                              "id": "5f71cc80414f235e9782af03",
                                              "_id": "6077c4eebc5f4d4df9ef1b96",
                                              "concepts": [
                                                  {
                                                      "name": "Radioactivity",
                                                      "id": "5f71ce207ac5361290708bfc",
                                                      "_id": "6077c4eebc5f4d4df9ef1ba5",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2b",
                                                              "_id": "6077c4eebc5f4d4df9ef1ba6"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclei",
                                                      "id": "5f71ce207ac5361290708bfa",
                                                      "_id": "6077c4eebc5f4d4df9ef1ba3",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2c",
                                                              "_id": "6077c4eebc5f4d4df9ef1ba4"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Introduction",
                                                      "id": "5f71ce207ac5361290708bf7",
                                                      "_id": "6077c4eebc5f4d4df9ef1ba1",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2d",
                                                              "_id": "6077c4eebc5f4d4df9ef1ba2"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Electric Discharge Through Gases",
                                                      "id": "5f71ce207ac5361290708bf8",
                                                      "_id": "6077c4eebc5f4d4df9ef1b9f",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2e",
                                                              "_id": "6077c4eebc5f4d4df9ef1ba0"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fusion",
                                                      "id": "5f71ce207ac5361290708bfe",
                                                      "_id": "6077c4eebc5f4d4df9ef1b9d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df2f",
                                                              "_id": "6077c4eebc5f4d4df9ef1b9e"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Atom Models",
                                                      "id": "5f71ce207ac5361290708bf9",
                                                      "_id": "6077c4eebc5f4d4df9ef1b9b",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df30",
                                                              "_id": "6077c4eebc5f4d4df9ef1b9c"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Force",
                                                      "id": "5f71ce207ac5361290708bfb",
                                                      "_id": "6077c4eebc5f4d4df9ef1b99",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df31",
                                                              "_id": "6077c4eebc5f4d4df9ef1b9a"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Nuclear Fission",
                                                      "id": "5f71ce207ac5361290708bfd",
                                                      "_id": "6077c4eebc5f4d4df9ef1b97",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5fdc5707b35a0a066673d910",
                                                              "syllabusId": "5fdc5725b35a0a066673df32",
                                                              "_id": "6077c4eebc5f4d4df9ef1b98"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5fdc5707b35a0a066673d910",
                                                      "syllabusId": "5fdc5724b35a0a066673dd90",
                                                      "_id": "6077c4eebc5f4d4df9ef1ba7"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b5",
                                              "_id": "6077c4eebc5f4d4df9ef1c10"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "MAT",
                                      "id": "5ace202e9fe7b01d5806bb8d",
                                      "chapters": [
                                          {
                                              "name": "Speed,Time & Distance",
                                              "id": "5ace20319fe7b01d5806bc3d",
                                              "_id": "6077c4eebc5f4d4df9ef1b8f",
                                              "concepts": [
                                                  {
                                                      "name": "Train problems, Boats and streams",
                                                      "id": "5ace20399fe7b01d5806bf3a",
                                                      "_id": "6077c4eebc5f4d4df9ef1b92",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8447",
                                                              "_id": "6077c4eebc5f4d4df9ef1b93"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Problems on time and distance",
                                                      "id": "5ace20399fe7b01d5806bf39",
                                                      "_id": "6077c4eebc5f4d4df9ef1b90",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8448",
                                                              "_id": "6077c4eebc5f4d4df9ef1b91"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8260",
                                                      "_id": "6077c4eebc5f4d4df9ef1b94"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Simple Interest & Compound Interest",
                                              "id": "5ace20319fe7b01d5806bc3c",
                                              "_id": "6077c4eebc5f4d4df9ef1b8b",
                                              "concepts": [
                                                  {
                                                      "name": "Simple Interest & Compound Interest",
                                                      "id": "5ace20399fe7b01d5806bf38",
                                                      "_id": "6077c4eebc5f4d4df9ef1b8c",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8449",
                                                              "_id": "6077c4eebc5f4d4df9ef1b8d"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8261",
                                                      "_id": "6077c4eebc5f4d4df9ef1b8e"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Data Interpretation",
                                              "id": "5ace20309fe7b01d5806bc26",
                                              "_id": "6077c4eebc5f4d4df9ef1b85",
                                              "concepts": [
                                                  {
                                                      "name": "Pie Charts Tabulation",
                                                      "id": "5ace20389fe7b01d5806bf16",
                                                      "_id": "6077c4eebc5f4d4df9ef1b88",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844a",
                                                              "_id": "6077c4eebc5f4d4df9ef1b89"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Bar & Line graphs",
                                                      "id": "5ace20389fe7b01d5806bf15",
                                                      "_id": "6077c4eebc5f4d4df9ef1b86",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844b",
                                                              "_id": "6077c4eebc5f4d4df9ef1b87"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8262",
                                                      "_id": "6077c4eebc5f4d4df9ef1b8a"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statement Assumptions",
                                              "id": "5ace20319fe7b01d5806bc3e",
                                              "_id": "6077c4eebc5f4d4df9ef1b81",
                                              "concepts": [
                                                  {
                                                      "name": "Statement Assumptions",
                                                      "id": "5ace20399fe7b01d5806bf3b",
                                                      "_id": "6077c4eebc5f4d4df9ef1b82",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844c",
                                                              "_id": "6077c4eebc5f4d4df9ef1b83"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8263",
                                                      "_id": "6077c4eebc5f4d4df9ef1b84"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Statement Conclusions",
                                              "id": "5ace20319fe7b01d5806bc3f",
                                              "_id": "6077c4eebc5f4d4df9ef1b7d",
                                              "concepts": [
                                                  {
                                                      "name": "Statement Conclusions",
                                                      "id": "5ace20399fe7b01d5806bf3c",
                                                      "_id": "6077c4eebc5f4d4df9ef1b7e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844d",
                                                              "_id": "6077c4eebc5f4d4df9ef1b7f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8264",
                                                      "_id": "6077c4eebc5f4d4df9ef1b80"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Puzzle",
                                              "id": "5ace20319fe7b01d5806bc38",
                                              "_id": "6077c4eebc5f4d4df9ef1b71",
                                              "concepts": [
                                                  {
                                                      "name": "Family Based",
                                                      "id": "5ace20399fe7b01d5806bf2e",
                                                      "_id": "6077c4eebc5f4d4df9ef1b7a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844e",
                                                              "_id": "6077c4eebc5f4d4df9ef1b7b"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Sitting Arrangment",
                                                      "id": "5ace20399fe7b01d5806bf30",
                                                      "_id": "6077c4eebc5f4d4df9ef1b78",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c844f",
                                                              "_id": "6077c4eebc5f4d4df9ef1b79"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Classification Based",
                                                      "id": "5ace20399fe7b01d5806bf2c",
                                                      "_id": "6077c4eebc5f4d4df9ef1b76",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8450",
                                                              "_id": "6077c4eebc5f4d4df9ef1b77"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Comparison Based",
                                                      "id": "5ace20399fe7b01d5806bf2d",
                                                      "_id": "6077c4eebc5f4d4df9ef1b74",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8451",
                                                              "_id": "6077c4eebc5f4d4df9ef1b75"
                                                          }
                                                      ]
                                                  },
                                                  {
                                                      "name": "Logical Connectives",
                                                      "id": "5ace20399fe7b01d5806bf2f",
                                                      "_id": "6077c4eebc5f4d4df9ef1b72",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8452",
                                                              "_id": "6077c4eebc5f4d4df9ef1b73"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8265",
                                                      "_id": "6077c4eebc5f4d4df9ef1b7c"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Probability",
                                              "id": "5ace20319fe7b01d5806bc36",
                                              "_id": "6077c4eebc5f4d4df9ef1b6d",
                                              "concepts": [
                                                  {
                                                      "name": "Probability",
                                                      "id": "5ace20399fe7b01d5806bf28",
                                                      "_id": "6077c4eebc5f4d4df9ef1b6e",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8453",
                                                              "_id": "6077c4eebc5f4d4df9ef1b6f"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8266",
                                                      "_id": "6077c4eebc5f4d4df9ef1b70"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Inequality",
                                              "id": "5ace20319fe7b01d5806bc2e",
                                              "_id": "6077c4eebc5f4d4df9ef1b69",
                                              "concepts": [
                                                  {
                                                      "name": "Inequality",
                                                      "id": "5ace20389fe7b01d5806bf1e",
                                                      "_id": "6077c4eebc5f4d4df9ef1b6a",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c8454",
                                                              "_id": "6077c4eebc5f4d4df9ef1b6b"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8267",
                                                      "_id": "6077c4eebc5f4d4df9ef1b6c"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b6",
                                              "_id": "6077c4eebc5f4d4df9ef1b95"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "Social Science",
                                      "id": "5ace202e9fe7b01d5806bb90",
                                      "chapters": [
                                          {
                                              "name": "People As Resource",
                                              "id": "5ace20329fe7b01d5806bcc0",
                                              "_id": "6077c4eebc5f4d4df9ef1b64",
                                              "concepts": [
                                                  {
                                                      "name": "Role of education, health\nand training/skill development in \nmaking human capital",
                                                      "id": "5ace20419fe7b01d5806c1ef",
                                                      "_id": "6077c4eebc5f4d4df9ef1b65",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a1",
                                                              "_id": "6077c4eebc5f4d4df9ef1b66"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8294",
                                                      "_id": "6077c4eebc5f4d4df9ef1b67"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Poverty As a Challenge",
                                              "id": "5ace20329fe7b01d5806bcc1",
                                              "_id": "6077c4eebc5f4d4df9ef1b60",
                                              "concepts": [
                                                  {
                                                      "name": "Causes and impacts of poverty\ndifferent poverty elevation programmes",
                                                      "id": "5ace20419fe7b01d5806c1f0",
                                                      "_id": "6077c4eebc5f4d4df9ef1b61",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a2",
                                                              "_id": "6077c4eebc5f4d4df9ef1b62"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8295",
                                                      "_id": "6077c4eebc5f4d4df9ef1b63"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Food Security in India",
                                              "id": "5ace20329fe7b01d5806bcbd",
                                              "_id": "6077c4eebc5f4d4df9ef1b5c",
                                              "concepts": [
                                                  {
                                                      "name": "Dimensions of food security & Govt's role in food security",
                                                      "id": "5ace20419fe7b01d5806c1ec",
                                                      "_id": "6077c4eebc5f4d4df9ef1b5d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a3",
                                                              "_id": "6077c4eebc5f4d4df9ef1b5e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8296",
                                                      "_id": "6077c4eebc5f4d4df9ef1b5f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Development",
                                              "id": "5ace20329fe7b01d5806bcbc",
                                              "_id": "6077c4eebc5f4d4df9ef1b58",
                                              "concepts": [
                                                  {
                                                      "name": "Different approaches of development & estimation of GDP",
                                                      "id": "5ace20419fe7b01d5806c1eb",
                                                      "_id": "6077c4eebc5f4d4df9ef1b59",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a4",
                                                              "_id": "6077c4eebc5f4d4df9ef1b5a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8297",
                                                      "_id": "6077c4eebc5f4d4df9ef1b5b"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Sectors of the Indian Economy",
                                              "id": "5ace20329fe7b01d5806bcc2",
                                              "_id": "6077c4eebc5f4d4df9ef1b54",
                                              "concepts": [
                                                  {
                                                      "name": "Primary, secondary and tertiary sectors of economy & Unemployment in India",
                                                      "id": "5ace20419fe7b01d5806c1f1",
                                                      "_id": "6077c4eebc5f4d4df9ef1b55",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a5",
                                                              "_id": "6077c4eebc5f4d4df9ef1b56"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8298",
                                                      "_id": "6077c4eebc5f4d4df9ef1b57"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Money and Credit",
                                              "id": "5ace20329fe7b01d5806bcbf",
                                              "_id": "6077c4eebc5f4d4df9ef1b50",
                                              "concepts": [
                                                  {
                                                      "name": "Money & Credit",
                                                      "id": "5ace20419fe7b01d5806c1ee",
                                                      "_id": "6077c4eebc5f4d4df9ef1b51",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a6",
                                                              "_id": "6077c4eebc5f4d4df9ef1b52"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c8299",
                                                      "_id": "6077c4eebc5f4d4df9ef1b53"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Globalisation and the Indian Economy",
                                              "id": "5ace20329fe7b01d5806bcbe",
                                              "_id": "6077c4eebc5f4d4df9ef1b4c",
                                              "concepts": [
                                                  {
                                                      "name": "Economic factors, connecting the world",
                                                      "id": "5ace20419fe7b01d5806c1ed",
                                                      "_id": "6077c4eebc5f4d4df9ef1b4d",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a7",
                                                              "_id": "6077c4eebc5f4d4df9ef1b4e"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c829a",
                                                      "_id": "6077c4eebc5f4d4df9ef1b4f"
                                                  }
                                              ]
                                          },
                                          {
                                              "name": "Consumer Rights",
                                              "id": "5ace20329fe7b01d5806bcbb",
                                              "_id": "6077c4eebc5f4d4df9ef1b48",
                                              "concepts": [
                                                  {
                                                      "name": "Consumer court at different levels",
                                                      "id": "5ace20419fe7b01d5806c1ea",
                                                      "_id": "6077c4eebc5f4d4df9ef1b49",
                                                      "content": [],
                                                      "courseSyllabusIds": [
                                                          {
                                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                                              "syllabusId": "5f019d79e316d24ffb2c84a8",
                                                              "_id": "6077c4eebc5f4d4df9ef1b4a"
                                                          }
                                                      ]
                                                  }
                                              ],
                                              "content": [],
                                              "courseSyllabusIds": [
                                                  {
                                                      "courseId": "5f019d78e316d24ffb2c81fd",
                                                      "syllabusId": "5f019d78e316d24ffb2c829b",
                                                      "_id": "6077c4eebc5f4d4df9ef1b4b"
                                                  }
                                              ]
                                          }
                                      ],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5f019d78e316d24ffb2c81fd",
                                              "syllabusId": "5f019d79e316d24ffb2c84b7",
                                              "_id": "6077c4eebc5f4d4df9ef1b68"
                                          }
                                      ]
                                  },
                                  {
                                      "name": "LOGICAL REASONING",
                                      "id": "5ace202e9fe7b01d5806bb8c",
                                      "chapters": [],
                                      "courseSyllabusIds": [
                                          {
                                              "courseId": "5fdc5707b35a0a066673d910",
                                              "syllabusId": "5fdc5722b35a0a066673d921",
                                              "_id": "6077c4eebc5f4d4df9ef1b47"
                                          }
                                      ]
                                  }
                              ]
                          }
                      ],
                      "subjects": [
                          {
                              "name": "Biology",
                              "id": "5ace202e9fe7b01d5806bb89",
                              "chapterCount": 6
                          },
                          {
                              "name": "Chemistry",
                              "id": "5ace202e9fe7b01d5806bb8a",
                              "chapterCount": 4
                          },
                          {
                              "name": "Mathematics",
                              "id": "5ace202e9fe7b01d5806bb8e",
                              "chapterCount": 70
                          },
                          {
                              "name": "Physics",
                              "id": "5ace202e9fe7b01d5806bb8f",
                              "chapterCount": 31
                          },
                          {
                              "name": "MAT",
                              "id": "5ace202e9fe7b01d5806bb8d",
                              "chapterCount": 20
                          },
                          {
                              "name": "Social Science",
                              "id": "5ace202e9fe7b01d5806bb90",
                              "chapterCount": 26
                          },
                          {
                              "name": "LOGICAL REASONING",
                              "id": "5ace202e9fe7b01d5806bb8c",
                              "chapterCount": 5
                          }
                      ],
                      "isRevision": false,
                      "description": ""
                  }
              ],
              "subjects": [
                  {
                      "id": "5ace202e9fe7b01d5806bb89",
                      "name": "Biology",
                      "chapterCount": 11
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8a",
                      "name": "Chemistry",
                      "chapterCount": 9
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8e",
                      "name": "Mathematics",
                      "chapterCount": 159
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8f",
                      "name": "Physics",
                      "chapterCount": 62
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8d",
                      "name": "MAT",
                      "chapterCount": 37
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb90",
                      "name": "Social Science",
                      "chapterCount": 52
                  },
                  {
                      "id": "5ace202e9fe7b01d5806bb8c",
                      "name": "LOGICAL REASONING",
                      "chapterCount": 10
                  }
              ],
              "totalPhases": 2
          }
      }
  },
  
  ];
  
  export const mockPhase = [
    {
        statusCode: 200,
        responseMessage: 'Course plan details fetched',
        responseObject: {
          coursePlan: {
            _id: '60475e5c8d80f665fd2a0448',
            updatedAt: '2021-03-09T11:39:08.527Z',
            createdAt: '2021-03-09T11:39:08.527Z',
            packageId: '603f8936507486428bd3dffc',
            type: 'standard',
            startDate: '2021-05-12T07:23:14.700Z',
            endDate: '2022-05-12T07:23:14.700Z',
            aclMetaData: {
              _id: '60475e5c8d80f665fd2a0449',
              clientId: '5b5702e095cbc921944632a9',
              updatedBy: {
                email: 'rahul.khanna@edfora.com',
                id: '5afc2c9debd9c86ce48b806b',
              },
              createdBy: {
                email: 'rahul.khanna@edfora.com',
                id: '5afc2c9debd9c86ce48b806b',
              },
            },
            weekFormat: 'weekly',
            testSeries: [],
            phases: [
              {
                name: "Phase 1",
                startDate: "2021-05-12T05:30:00.000Z",
                endDate: "2022-05-12T05:30:00.000Z",
                _id: "60475e5c8d80f665fd2a044a",
                milestoneTests: [ {
                  "testId": "605469029c306d163039351d",
                  "scheduleID": "3747",
                  "name": "testing on create standard course phase 1",
                  "courseId": "5f5f402c863d076508897df5",
                  "syllabus": "Phase 1 syllabus",
                  "startDate": "2021-01-12T05:30:00.000Z",
                  "endDate": "2022-02-17T05:30:00.000Z",
                  "revisionTime": 0,
                  "type": "part",
                  "duration": 180,
                  "maxAttempts": 2
              }
    ],
                weeks: [
                  {
                    weekNo: 1,
                    startDate: '2021-05-12T05:30:00.000Z',
                    endDate: '2021-05-17T05:30:00.000Z',
                    _id: '60475e5c8d80f665fd2a044b',
                    content: [],
                    subjects: [
                      {
                        name: 'Chemistry',
                        id: '5ace202e9fe7b01d5806bb8a',
                        chapters: [
                          {
                            id: '5ace202f9fe7b01d5806bbdd',
                            name: 'Periodic Properties',
                            _id: '60475e5c8d80f665fd2a044c',
                            concepts: [
                              {
                                id: '5ace20359fe7b01d5806be13',
                                name: 'Modern Periodical Table',
                                _id: '60475e5c8d80f665fd2a044d',
                                content: ['abc', 'def', 'ghi'],
                                courseSyllabusIds: [
                                  {
                                    courseId: '5eb5893435bf9137d2c81a0b',
                                    syllabusId: '5eb58c2efb79f919d0f1312d',
                                    _id: '60475e5c8d80f665fd2a044e',
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: '5eb5893435bf9137d2c81a0b',
                                syllabusId: '5eb58c2efb79f919d0f1312c',
                                _id: '60475e5c8d80f665fd2a044f',
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: '5eb5893435bf9137d2c81a0b',
                            syllabusId: '5eb58c2dfb79f919d0f130f3',
                            _id: '60475e5c8d80f665fd2a0450',
                          },
                        ],
                      },
                      {
                        name: 'Physics',
                        id: '5ace202e9fe7b01d5806bb8b',
                        chapters: [
                          {
                            id: '5ace202f9fe7b01d5806bbdd',
                            name: 'Projectile',
                            _id: '60475e5c8d80f665fd2a044c',
                            concepts: [
                              {
                                id: '5ace20359fe7b01d5806be14',
                                name: 'Projectile motion',
                                _id: '60475e5c8d80f665fd2a044d',
                                content: [],
                                courseSyllabusIds: [
                                  {
                                    courseId: '5eb5893435bf9137d2c81a0b',
                                    syllabusId: '5eb58c2efb79f919d0f1312d',
                                    _id: '60475e5c8d80f665fd2a044e',
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: '5eb5893435bf9137d2c81a0b',
                                syllabusId: '5eb58c2efb79f919d0f1312c',
                                _id: '60475e5c8d80f665fd2a044f',
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: '5eb5893435bf9137d2c81a0b',
                            syllabusId: '5eb58c2dfb79f919d0f130f3',
                            _id: '60475e5c8d80f665fd2a0450',
                          },
                        ],
                      },
                    ],
                  },
                  {
                    weekNo: 1,
                    startDate: "2021-05-12T05:30:00.000Z",
                    endDate: "2021-05-17T05:30:00.000Z",
                    _id: "60475e5c8d80f665fd2a044b",
                    content: [],
                    subjects: [
                      {
                        name: "PhysicsAndChemistry",
                        id: "5ace202e9fe7b01d5806bb8a",
                        chapters: [
                          {
                            id: "5ace202f9fe7b01d5806bbdd",
                            name: "Periodic Properties",
                            _id: "60475e5c8d80f665fd2a044c",
                            concepts: [
                              {
                                id: "5ace20359fe7b01d5806be13",
                                name: "Modern Periodical Table",
                                _id: "60475e5c8d80f665fd2a044d",
                                content: ["abc", "def", "ghi"],
                                courseSyllabusIds: [
                                  {
                                    courseId: "5eb5893435bf9137d2c81a0b",
                                    syllabusId: "5eb58c2efb79f919d0f1312d",
                                    _id: "60475e5c8d80f665fd2a044e",
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: "5eb5893435bf9137d2c81a0b",
                                syllabusId: "5eb58c2efb79f919d0f1312c",
                                _id: "60475e5c8d80f665fd2a044f",
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: "5eb5893435bf9137d2c81a0b",
                            syllabusId: "5eb58c2dfb79f919d0f130f3",
                            _id: "60475e5c8d80f665fd2a0450",
                          },
                        ],
                      },
                      {
                        name: "Physics",
                        id: "5ace202e9fe7b01d5806bb8b",
                        chapters: [
                          {
                            id: "5ace202f9fe7b01d5806bbdd",
                            name: "Projectile",
                            _id: "60475e5c8d80f665fd2a044c",
                            concepts: [
                              {
                                id: "5ace20359fe7b01d5806be14",
                                name: "Projectile motion",
                                _id: "60475e5c8d80f665fd2a044d",
                                content: [],
                                courseSyllabusIds: [
                                  {
                                    courseId: "5eb5893435bf9137d2c81a0b",
                                    syllabusId: "5eb58c2efb79f919d0f1312d",
                                    _id: "60475e5c8d80f665fd2a044e",
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: "5eb5893435bf9137d2c81a0b",
                                syllabusId: "5eb58c2efb79f919d0f1312c",
                                _id: "60475e5c8d80f665fd2a044f",
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: "5eb5893435bf9137d2c81a0b",
                            syllabusId: "5eb58c2dfb79f919d0f130f3",
                            _id: "60475e5c8d80f665fd2a0450",
                          },
                        ],
                      },
                    ],
                  },
                ],
                subjects: [
                  {
                    name: 'Chemistry',
                    chapterCount: 38,
                  },
                  {
                    name: 'Physics',
                    chapterCount: 20,
                  },
                  {
                    name: 'Mathematics',
                    chapterCount: 36,
                  },
                ],
                isRevision: false,
                description: '',
              },
              {
                name: "Phase 2",
                startDate: "2021-05-12T05:30:00.000Z",
                endDate: "2022-05-12T05:30:00.000Z",
                _id: "60475e5c8d80f665fd2a044b",
                milestoneTests: [
                  {
                      "testId": "605469029c306d163039351d",
                      "scheduleID": "3747",
                      "name": "testing on combo course phase 2",
                      "courseId": "5f5f402c863d076508897df5",
                      "syllabus": "Phase 1 syllabus",
                      "startDate": "2021-22-12T05:30:00.000Z",
                      "endDate": "2022-21-17T05:30:00.000Z",
                      "revisionTime": 0,
                      "type": "part",
                      "duration": 180,
                      "maxAttempts": 2
                  }
              ],
                weeks: [
                  {
                    weekNo: 2,
                    startDate: '2021-05-12T05:30:00.000Z',
                    endDate: '2021-05-17T05:30:00.000Z',
                    _id: '60475e5c8d80f665fd2a044b',
                    content: [],
                    subjects: [
                      {
                        name: 'Mathametics',
                        id: '8ace202e9fe7b01d8806bb8a',
                        chapters: [
                          {
                            id: '8ace202f9fe7b01d8806bbdd',
                            name: 'Derivatives',
                            _id: '60478e8c8d80f668fd2a044c',
                            concepts: [
                              {
                                id: '8ace20389fe7b01d8806be13',
                                name: 'Maxima Minima',
                                _id: '60478e8c8d80f668fd2a044d',
                                content: ['abc', 'def', 'ghi'],
                                courseSyllabusIds: [
                                  {
                                    courseId: '8eb8893438bf9137d2c81a0b',
                                    syllabusId: '8eb88c2efb79f919d0f1312d',
                                    _id: '60478e8c8d80f668fd2a044e',
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: '5eb5893435bf9137d2c81a0b',
                                syllabusId: '5eb58c2efb79f919d0f1312c',
                                _id: '60475e5c8d80f665fd2a044f',
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: '5eb5893435bf9137d2c81a0b',
                            syllabusId: '5eb58c2dfb79f919d0f130f3',
                            _id: '60475e5c8d80f665fd2a0450',
                          },
                        ],
                      },
                      {
                        name: 'Chemistry',
                        id: '5ace202e9fe7b01d5806bb8a',
                        chapters: [
                          {
                            id: '5ace202f9fe7b01d5806bbdd',
                            name: 'Periodic Properties',
                            _id: '60475e5c8d80f665fd2a044c',
                            concepts: [
                              {
                                id: '5ace20359fe7b01d5806be13',
                                name: 'Modern Periodical Table',
                                _id: '60475e5c8d80f665fd2a044d',
                                content: [],
                                courseSyllabusIds: [
                                  {
                                    courseId: '5eb5893435bf9137d2c81a0b',
                                    syllabusId: '5eb58c2efb79f919d0f1312d',
                                    _id: '60475e5c8d80f665fd2a044e',
                                  },
                                ],
                              },
                            ],
                            content: [],
                            courseSyllabusIds: [
                              {
                                courseId: '5eb5893435bf9137d2c81a0b',
                                syllabusId: '5eb58c2efb79f919d0f1312c',
                                _id: '60475e5c8d80f665fd2a044f',
                              },
                            ],
                          },
                        ],
                        courseSyllabusIds: [
                          {
                            courseId: '5eb5893435bf9137d2c81a0b',
                            syllabusId: '5eb58c2dfb79f919d0f130f3',
                            _id: '60475e5c8d80f665fd2a0450',
                          },
                        ],
                      },
                    ],
                  },
                ],
                subjects: [
                  {
                    name: 'Chemistry',
                    chapterCount: 38,
                  },
                  {
                    name: 'Physics',
                    chapterCount: 20,
                  },
                  {
                    name: 'Mathematics',
                    chapterCount: 36,
                  },
                ],
                isRevision: false,
                description: '',
              },
            ],
            subjects: [
              {
                name: 'Chemistry',
                chapterCount: 38,
              },
              {
                name: 'Physics',
                chapterCount: 20,
              },
              {
                name: 'Mathematics',
                chapterCount: 36,
              },
            ],
    
            totalPhases: 1,
            __v: 0,
          },
        },
      },

      {
        "statusCode": 200,
        "responseMessage": "Course plan details fetched",
        "responseObject": {
            "coursePlan": {
                "_id": "6077c4eebc5f4d4df9ef1b43",
                "packageId": "607551a83a5af95b0ff8b5a3",
                "type": "combo",
                "startDate": "2021-04-26T12:27:45.779Z",
                "endDate": "2021-07-26T12:27:45.779Z",
                "weekFormat": "weekly",
                "status": "draft",
                "totalTests": 0,
                "testSeries": [],
                "phases": [
                    {
                        "name": "Phase 1",
                        "startDate": "2021-04-26T00:00:00.000Z",
                        "endDate": "2021-05-31T00:00:00.000Z",
                        "_id": "6077c4efbc5f4d4df9ef234c",
                        "milestoneTests": [],
                        "weeks": [
                            {
                                "weekNo": 1,
                                "startDate": "2021-04-26T00:00:00.000Z",
                                "endDate": "2021-05-02T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef291d",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "The fundamental unit of life",
                                                "id": "5ace202f9fe7b01d5806bbc3",
                                                "_id": "6077c4efbc5f4d4df9ef2aa4",
                                                "concepts": [
                                                    {
                                                        "name": "Discovery & Microscopy",
                                                        "id": "5ace20339fe7b01d5806bd5a",
                                                        "_id": "6077c4efbc5f4d4df9ef2ab9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c829d",
                                                                "_id": "6077c4efbc5f4d4df9ef2aba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Totipotency, Size,Number and shape of cell",
                                                        "id": "5ace20339fe7b01d5806bd5d",
                                                        "_id": "6077c4efbc5f4d4df9ef2ab7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c829e",
                                                                "_id": "6077c4efbc5f4d4df9ef2ab8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Characteristics of Prokaryotic cell",
                                                        "id": "5ace20339fe7b01d5806bd57",
                                                        "_id": "6077c4efbc5f4d4df9ef2ab5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c829f",
                                                                "_id": "6077c4efbc5f4d4df9ef2ab6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Characteristics of Eukaryotic cell",
                                                        "id": "5ace20339fe7b01d5806bd56",
                                                        "_id": "6077c4efbc5f4d4df9ef2ab3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a0",
                                                                "_id": "6077c4efbc5f4d4df9ef2ab4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Difference between Prokaryotic and Eukaryotic cell",
                                                        "id": "5ace20339fe7b01d5806bd59",
                                                        "_id": "6077c4efbc5f4d4df9ef2ab1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a1",
                                                                "_id": "6077c4efbc5f4d4df9ef2ab2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Difference between plant cell and animal cell",
                                                        "id": "5ace20339fe7b01d5806bd58",
                                                        "_id": "6077c4efbc5f4d4df9ef2aaf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a2",
                                                                "_id": "6077c4efbc5f4d4df9ef2ab0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cell wall",
                                                        "id": "5ace20339fe7b01d5806bd55",
                                                        "_id": "6077c4efbc5f4d4df9ef2aad",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a3",
                                                                "_id": "6077c4efbc5f4d4df9ef2aae"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cell Membrane",
                                                        "id": "5ace20339fe7b01d5806bd54",
                                                        "_id": "6077c4efbc5f4d4df9ef2aab",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a4",
                                                                "_id": "6077c4efbc5f4d4df9ef2aac"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nucleus",
                                                        "id": "5ace20339fe7b01d5806bd5c",
                                                        "_id": "6077c4efbc5f4d4df9ef2aa9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a5",
                                                                "_id": "6077c4efbc5f4d4df9ef2aaa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Non-membranous organelles, single & double membraned organelles",
                                                        "id": "5ace20339fe7b01d5806bd5b",
                                                        "_id": "6077c4efbc5f4d4df9ef2aa7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a6",
                                                                "_id": "6077c4efbc5f4d4df9ef2aa8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cell cycle",
                                                        "id": "5ace20339fe7b01d5806bd53",
                                                        "_id": "6077c4efbc5f4d4df9ef2aa5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a7",
                                                                "_id": "6077c4efbc5f4d4df9ef2aa6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8207",
                                                        "_id": "6077c4efbc5f4d4df9ef2abb"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef2abc"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Matter in our Surroundings",
                                                "id": "5ace202f9fe7b01d5806bbcc",
                                                "_id": "6077c4efbc5f4d4df9ef2a97",
                                                "concepts": [
                                                    {
                                                        "name": "Particulate Nature Of Matter(Physical states of matter)",
                                                        "id": "5ace20349fe7b01d5806bda3",
                                                        "_id": "6077c4efbc5f4d4df9ef2aa0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831b",
                                                                "_id": "6077c4efbc5f4d4df9ef2aa1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diffusion,Brownian movement",
                                                        "id": "5ace20349fe7b01d5806bda0",
                                                        "_id": "6077c4efbc5f4d4df9ef2a9e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831c",
                                                                "_id": "6077c4efbc5f4d4df9ef2a9f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Change of state of matter",
                                                        "id": "5ace20349fe7b01d5806bd9f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a9c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831d",
                                                                "_id": "6077c4efbc5f4d4df9ef2a9d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Latent heat and specific heat",
                                                        "id": "5ace20349fe7b01d5806bda2",
                                                        "_id": "6077c4efbc5f4d4df9ef2a9a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831e",
                                                                "_id": "6077c4efbc5f4d4df9ef2a9b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Evaporation And Factors affecting evapouration",
                                                        "id": "5ace20349fe7b01d5806bda1",
                                                        "_id": "6077c4efbc5f4d4df9ef2a98",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831f",
                                                                "_id": "6077c4efbc5f4d4df9ef2a99"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8212",
                                                        "_id": "6077c4efbc5f4d4df9ef2aa2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef2aa3"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "NISL",
                                                "id": "5ace20319fe7b01d5806bc75",
                                                "_id": "6077c4efbc5f4d4df9ef2a86",
                                                "concepts": [
                                                    {
                                                        "name": "Review of Numbers, Conversion of Decimal Numbers to Rational numbers, Irrational numbers",
                                                        "id": "5ace203b9fe7b01d5806c016",
                                                        "_id": "6077c4efbc5f4d4df9ef2a93",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8362",
                                                                "_id": "6077c4efbc5f4d4df9ef2a94"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "surds",
                                                        "id": "5ace203b9fe7b01d5806c017",
                                                        "_id": "6077c4efbc5f4d4df9ef2a91",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8363",
                                                                "_id": "6077c4efbc5f4d4df9ef2a92"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conjugate of an Irrational Number",
                                                        "id": "5ace203b9fe7b01d5806c011",
                                                        "_id": "6077c4efbc5f4d4df9ef2a8f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8364",
                                                                "_id": "6077c4efbc5f4d4df9ef2a90"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rationalisation of the Denominator",
                                                        "id": "5ace203b9fe7b01d5806c015",
                                                        "_id": "6077c4efbc5f4d4df9ef2a8d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8365",
                                                                "_id": "6077c4efbc5f4d4df9ef2a8e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Logarithms- Definition and Properties",
                                                        "id": "5ace203b9fe7b01d5806c013",
                                                        "_id": "6077c4efbc5f4d4df9ef2a8b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8366",
                                                                "_id": "6077c4efbc5f4d4df9ef2a8c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "No. of divisions of a composite number, Sum of divisions of a composite number, Decimal Representation of Rational Numbers, Results on Irrational numbers, Representation of Irrational number on number line, Representation of Real Numbers using Successive Magnification",
                                                        "id": "5ace203b9fe7b01d5806c014",
                                                        "_id": "6077c4efbc5f4d4df9ef2a89",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8367",
                                                                "_id": "6077c4efbc5f4d4df9ef2a8a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Indices",
                                                        "id": "5ace203b9fe7b01d5806c012",
                                                        "_id": "6077c4efbc5f4d4df9ef2a87",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8368",
                                                                "_id": "6077c4efbc5f4d4df9ef2a88"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a95"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Binomial Theorem",
                                                "id": "5ace20319fe7b01d5806bc43",
                                                "_id": "6077c4efbc5f4d4df9ef2a7a",
                                                "concepts": [
                                                    {
                                                        "name": "Binomial Co-efficient of a specific type of term",
                                                        "id": "5ace20399fe7b01d5806bf41",
                                                        "_id": "6077c4efbc5f4d4df9ef2a83",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e2",
                                                                "_id": "6077c4efbc5f4d4df9ef2a84"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Binomial series with k.Binomial coefficient",
                                                        "id": "5ace20399fe7b01d5806bf42",
                                                        "_id": "6077c4efbc5f4d4df9ef2a81",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e3",
                                                                "_id": "6077c4efbc5f4d4df9ef2a82"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Definition, coefficient of any term",
                                                        "id": "5ace20399fe7b01d5806bf43",
                                                        "_id": "6077c4efbc5f4d4df9ef2a7f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e4",
                                                                "_id": "6077c4efbc5f4d4df9ef2a80"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Greatest co-efficient, greatest term,",
                                                        "id": "5ace20399fe7b01d5806bf44",
                                                        "_id": "6077c4efbc5f4d4df9ef2a7d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e5",
                                                                "_id": "6077c4efbc5f4d4df9ef2a7e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sum of co-efficient and Relationship between the Co-efficient of the expansion like (a + bx + cx2)",
                                                        "id": "5ace20399fe7b01d5806bf45",
                                                        "_id": "6077c4efbc5f4d4df9ef2a7b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e6",
                                                                "_id": "6077c4efbc5f4d4df9ef2a7c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d939",
                                                        "_id": "6077c4efbc5f4d4df9ef2a85"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Polynomials-1",
                                                "id": "5ace20319fe7b01d5806bc76",
                                                "_id": "6077c4efbc5f4d4df9ef2a70",
                                                "concepts": [
                                                    {
                                                        "name": "Definition and Different Types of Polynomial, Algebraic Identities",
                                                        "id": "5ace203b9fe7b01d5806c018",
                                                        "_id": "6077c4efbc5f4d4df9ef2a77",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8369",
                                                                "_id": "6077c4efbc5f4d4df9ef2a78"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Degree of Polynomial, Zeroes of a Polynomial",
                                                        "id": "5ace203b9fe7b01d5806c019",
                                                        "_id": "6077c4efbc5f4d4df9ef2a75",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836a",
                                                                "_id": "6077c4efbc5f4d4df9ef2a76"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Factor Theorem , Remainder Theorem",
                                                        "id": "5ace203b9fe7b01d5806c01a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a73",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836b",
                                                                "_id": "6077c4efbc5f4d4df9ef2a74"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Factorization of Polynomials, Axioms and Postulates, Definitions- Line,Point,Plane etc, Collinear points ,Concurrent Lines, Parallel Lines and Intersecting Lines, Line Segments",
                                                        "id": "5ace203b9fe7b01d5806c01b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a71",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836c",
                                                                "_id": "6077c4efbc5f4d4df9ef2a72"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821c",
                                                        "_id": "6077c4efbc5f4d4df9ef2a79"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Complex Number",
                                                "id": "5ace20319fe7b01d5806bc44",
                                                "_id": "6077c4efbc5f4d4df9ef2a5a",
                                                "concepts": [
                                                    {
                                                        "name": "Argument, properties of argument",
                                                        "id": "5ace20399fe7b01d5806bf46",
                                                        "_id": "6077c4efbc5f4d4df9ef2a6d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e7",
                                                                "_id": "6077c4efbc5f4d4df9ef2a6e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Concept of rotation",
                                                        "id": "5ace20399fe7b01d5806bf47",
                                                        "_id": "6077c4efbc5f4d4df9ef2a6b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e8",
                                                                "_id": "6077c4efbc5f4d4df9ef2a6c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conjugate, properties of conjugate",
                                                        "id": "5ace20399fe7b01d5806bf48",
                                                        "_id": "6077c4efbc5f4d4df9ef2a69",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9e9",
                                                                "_id": "6077c4efbc5f4d4df9ef2a6a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Definition based problems",
                                                        "id": "5ace20399fe7b01d5806bf49",
                                                        "_id": "6077c4efbc5f4d4df9ef2a67",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ea",
                                                                "_id": "6077c4efbc5f4d4df9ef2a68"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De-Moiver's theorem, cube roots of unity, nth root of unity",
                                                        "id": "5ace20399fe7b01d5806bf4a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a65",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9eb",
                                                                "_id": "6077c4efbc5f4d4df9ef2a66"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ellipse, Parabola, Hyperbola",
                                                        "id": "5ace20399fe7b01d5806bf4b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a63",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ec",
                                                                "_id": "6077c4efbc5f4d4df9ef2a64"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modulus, properties of modulus",
                                                        "id": "5ace20399fe7b01d5806bf4c",
                                                        "_id": "6077c4efbc5f4d4df9ef2a61",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ed",
                                                                "_id": "6077c4efbc5f4d4df9ef2a62"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems on geometrical application of complex number-Section Formula, Straight Line, Circle",
                                                        "id": "5ace20399fe7b01d5806bf4d",
                                                        "_id": "6077c4efbc5f4d4df9ef2a5f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ee",
                                                                "_id": "6077c4efbc5f4d4df9ef2a60"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems on Locus",
                                                        "id": "5ace20399fe7b01d5806bf4e",
                                                        "_id": "6077c4efbc5f4d4df9ef2a5d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ef",
                                                                "_id": "6077c4efbc5f4d4df9ef2a5e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Roots of complex equations",
                                                        "id": "5ace20399fe7b01d5806bf4f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a5b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f0",
                                                                "_id": "6077c4efbc5f4d4df9ef2a5c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a6f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Lines and Angles",
                                                "id": "5ace20319fe7b01d5806bc74",
                                                "_id": "6077c4efbc5f4d4df9ef2a50",
                                                "concepts": [
                                                    {
                                                        "name": "Angles, Interior angles, Exterior angle of a Triangle",
                                                        "id": "5ace203b9fe7b01d5806c00e",
                                                        "_id": "6077c4efbc5f4d4df9ef2a57",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836d",
                                                                "_id": "6077c4efbc5f4d4df9ef2a58"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types of Angles",
                                                        "id": "5ace203b9fe7b01d5806c010",
                                                        "_id": "6077c4efbc5f4d4df9ef2a55",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836e",
                                                                "_id": "6077c4efbc5f4d4df9ef2a56"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Angle Bisector, Vertically Opposite Angles",
                                                        "id": "5ace203b9fe7b01d5806c00d",
                                                        "_id": "6077c4efbc5f4d4df9ef2a53",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c836f",
                                                                "_id": "6077c4efbc5f4d4df9ef2a54"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transversal & Corresponding Angle Axioms. Parallel lines and Properties",
                                                        "id": "5ace203b9fe7b01d5806c00f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a51",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8370",
                                                                "_id": "6077c4efbc5f4d4df9ef2a52"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821d",
                                                        "_id": "6077c4efbc5f4d4df9ef2a59"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Logarithm",
                                                "id": "5ace20319fe7b01d5806bc45",
                                                "_id": "6077c4efbc5f4d4df9ef2a4a",
                                                "concepts": [
                                                    {
                                                        "name": "Definition and properties of log",
                                                        "id": "5ace20399fe7b01d5806bf50",
                                                        "_id": "6077c4efbc5f4d4df9ef2a4d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f1",
                                                                "_id": "6077c4efbc5f4d4df9ef2a4e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Log inequalities, graphs",
                                                        "id": "5ace20399fe7b01d5806bf51",
                                                        "_id": "6077c4efbc5f4d4df9ef2a4b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f2",
                                                                "_id": "6077c4efbc5f4d4df9ef2a4c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a4f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Linear Equation In Two Variables-1",
                                                "id": "5ace20319fe7b01d5806bc72",
                                                "_id": "6077c4efbc5f4d4df9ef2a46",
                                                "concepts": [
                                                    {
                                                        "name": "Linear equations in two variables, solution of Linear Equation in Two Variables, Graph of Linear Equation in Two Variables",
                                                        "id": "5ace203b9fe7b01d5806c00a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a47",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8371",
                                                                "_id": "6077c4efbc5f4d4df9ef2a48"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821e",
                                                        "_id": "6077c4efbc5f4d4df9ef2a49"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Progression & Series",
                                                "id": "5ace20319fe7b01d5806bc46",
                                                "_id": "6077c4efbc5f4d4df9ef2a38",
                                                "concepts": [
                                                    {
                                                        "name": "AP, and its mean and number of means inserted between two numbers",
                                                        "id": "5ace20399fe7b01d5806bf52",
                                                        "_id": "6077c4efbc5f4d4df9ef2a43",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f3",
                                                                "_id": "6077c4efbc5f4d4df9ef2a44"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "GP and its mean and number of means inserted between two numbers",
                                                        "id": "5ace20399fe7b01d5806bf53",
                                                        "_id": "6077c4efbc5f4d4df9ef2a41",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f4",
                                                                "_id": "6077c4efbc5f4d4df9ef2a42"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "HP and its mean and number of means inserted between two numbers",
                                                        "id": "5ace20399fe7b01d5806bf54",
                                                        "_id": "6077c4efbc5f4d4df9ef2a3f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f5",
                                                                "_id": "6077c4efbc5f4d4df9ef2a40"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Method of differences, Vn Method",
                                                        "id": "5ace20399fe7b01d5806bf55",
                                                        "_id": "6077c4efbc5f4d4df9ef2a3d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f6",
                                                                "_id": "6077c4efbc5f4d4df9ef2a3e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on sum of first n natural numbers, their squares and their cubes, Arithmetico Geometric Progression",
                                                        "id": "5ace20399fe7b01d5806bf56",
                                                        "_id": "6077c4efbc5f4d4df9ef2a3b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f7",
                                                                "_id": "6077c4efbc5f4d4df9ef2a3c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Inequalities of AM, GM, HM, weighted AM, weighted GM, weighted HM and AM of mth power",
                                                        "id": "5ace20399fe7b01d5806bf57",
                                                        "_id": "6077c4efbc5f4d4df9ef2a39",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f8",
                                                                "_id": "6077c4efbc5f4d4df9ef2a3a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93c",
                                                        "_id": "6077c4efbc5f4d4df9ef2a45"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Triangles",
                                                "id": "5ace20319fe7b01d5806bc83",
                                                "_id": "6077c4efbc5f4d4df9ef2a30",
                                                "concepts": [
                                                    {
                                                        "name": "Types of Triangles, Angle Sum Property of Triangle, Exterior Angle Theorem",
                                                        "id": "5ace203c9fe7b01d5806c051",
                                                        "_id": "6077c4efbc5f4d4df9ef2a35",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8372",
                                                                "_id": "6077c4efbc5f4d4df9ef2a36"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Congruence of a triangles, Criterion for the Congruence of two triangles",
                                                        "id": "5ace203c9fe7b01d5806c04f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a33",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8373",
                                                                "_id": "6077c4efbc5f4d4df9ef2a34"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Inequality relations in a triangle, Important lines of a triangle (median, perpendicular bisector, angle bisector, altitude",
                                                        "id": "5ace203c9fe7b01d5806c050",
                                                        "_id": "6077c4efbc5f4d4df9ef2a31",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8374",
                                                                "_id": "6077c4efbc5f4d4df9ef2a32"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a37"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Quadratic Equation and Expression",
                                                "id": "5ace20319fe7b01d5806bc47",
                                                "_id": "6077c4efbc5f4d4df9ef2a20",
                                                "concepts": [
                                                    {
                                                        "name": "Condition for a common root of two quadratic equation and condition for both the roots common of two quadratic equation",
                                                        "id": "5ace20399fe7b01d5806bf58",
                                                        "_id": "6077c4efbc5f4d4df9ef2a2d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9f9",
                                                                "_id": "6077c4efbc5f4d4df9ef2a2e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Formation of Quadratic Equation, sign of Quadratic Expression",
                                                        "id": "5ace20399fe7b01d5806bf59",
                                                        "_id": "6077c4efbc5f4d4df9ef2a2b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9fa",
                                                                "_id": "6077c4efbc5f4d4df9ef2a2c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Formula for roots, discriminant",
                                                        "id": "5ace20399fe7b01d5806bf5a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a29",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9fb",
                                                                "_id": "6077c4efbc5f4d4df9ef2a2a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Location of roots",
                                                        "id": "5ace20399fe7b01d5806bf5b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a27",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9fc",
                                                                "_id": "6077c4efbc5f4d4df9ef2a28"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "n-th degree polynomial equation and its property",
                                                        "id": "5ace20399fe7b01d5806bf5c",
                                                        "_id": "6077c4efbc5f4d4df9ef2a25",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9fd",
                                                                "_id": "6077c4efbc5f4d4df9ef2a26"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Quadratic expression",
                                                        "id": "5ace20399fe7b01d5806bf5d",
                                                        "_id": "6077c4efbc5f4d4df9ef2a23",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9fe",
                                                                "_id": "6077c4efbc5f4d4df9ef2a24"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Remainder theorem",
                                                        "id": "5ace20399fe7b01d5806bf5e",
                                                        "_id": "6077c4efbc5f4d4df9ef2a21",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673d9ff",
                                                                "_id": "6077c4efbc5f4d4df9ef2a22"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93d",
                                                        "_id": "6077c4efbc5f4d4df9ef2a2f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Quadrilateral",
                                                "id": "5ace20319fe7b01d5806bc7b",
                                                "_id": "6077c4efbc5f4d4df9ef2a16",
                                                "concepts": [
                                                    {
                                                        "name": "Angle sum property of quadrilateral, Various types of quadrilateral",
                                                        "id": "5ace203c9fe7b01d5806c028",
                                                        "_id": "6077c4efbc5f4d4df9ef2a1d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8375",
                                                                "_id": "6077c4efbc5f4d4df9ef2a1e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of a parallelogram, Sufficient condition for quadrilateral to be a Parallelogram",
                                                        "id": "5ace203c9fe7b01d5806c02b",
                                                        "_id": "6077c4efbc5f4d4df9ef2a1b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8376",
                                                                "_id": "6077c4efbc5f4d4df9ef2a1c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Prop. of Rectangle, Rhombus and Square",
                                                        "id": "5ace203c9fe7b01d5806c02a",
                                                        "_id": "6077c4efbc5f4d4df9ef2a19",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8377",
                                                                "_id": "6077c4efbc5f4d4df9ef2a1a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mid - Point Theorem & it's Converse",
                                                        "id": "5ace203c9fe7b01d5806c029",
                                                        "_id": "6077c4efbc5f4d4df9ef2a17",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8378",
                                                                "_id": "6077c4efbc5f4d4df9ef2a18"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8220",
                                                        "_id": "6077c4efbc5f4d4df9ef2a1f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Application of Derivatives",
                                                "id": "5ace20319fe7b01d5806bc48",
                                                "_id": "6077c4efbc5f4d4df9ef2a14",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93e",
                                                        "_id": "6077c4efbc5f4d4df9ef2a15"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Areas of Parallelogram and Triangles",
                                                "id": "5ace20319fe7b01d5806bc6a",
                                                "_id": "6077c4efbc5f4d4df9ef2a0e",
                                                "concepts": [
                                                    {
                                                        "name": "Theorems related to Parallelograms, Area, Triangles on the same base and between the same parallel lines",
                                                        "id": "5ace203b9fe7b01d5806bff9",
                                                        "_id": "6077c4efbc5f4d4df9ef2a11",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8379",
                                                                "_id": "6077c4efbc5f4d4df9ef2a12"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different triangles and there areas, Area of parallelogram on same base between same parallel lines are equal",
                                                        "id": "5ace203b9fe7b01d5806bff8",
                                                        "_id": "6077c4efbc5f4d4df9ef2a0f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837a",
                                                                "_id": "6077c4efbc5f4d4df9ef2a10"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8221",
                                                        "_id": "6077c4efbc5f4d4df9ef2a13"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Application of Derivatives",
                                                "id": "5ace20319fe7b01d5806bc49",
                                                "_id": "6077c4efbc5f4d4df9ef29f8",
                                                "concepts": [
                                                    {
                                                        "name": "angle between two curves",
                                                        "id": "5ace20399fe7b01d5806bf5f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a0b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da00",
                                                                "_id": "6077c4efbc5f4d4df9ef2a0c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "monotonocity based problems - inequality based",
                                                        "id": "5ace20399fe7b01d5806bf60",
                                                        "_id": "6077c4efbc5f4d4df9ef2a09",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da01",
                                                                "_id": "6077c4efbc5f4d4df9ef2a0a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "monotonocity based problems - inequality based - using first derivative",
                                                        "id": "5ace20399fe7b01d5806bf61",
                                                        "_id": "6077c4efbc5f4d4df9ef2a07",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da02",
                                                                "_id": "6077c4efbc5f4d4df9ef2a08"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "monotonocity based problems - inequality based - using second derivative",
                                                        "id": "5ace20399fe7b01d5806bf62",
                                                        "_id": "6077c4efbc5f4d4df9ef2a05",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da03",
                                                                "_id": "6077c4efbc5f4d4df9ef2a06"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on local/global maxima/minima using first, second and higher order derivative for a differentiable function and using graph for discontinuous function",
                                                        "id": "5ace20399fe7b01d5806bf63",
                                                        "_id": "6077c4efbc5f4d4df9ef2a03",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da04",
                                                                "_id": "6077c4efbc5f4d4df9ef2a04"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Mean Value theorem",
                                                        "id": "5ace20399fe7b01d5806bf64",
                                                        "_id": "6077c4efbc5f4d4df9ef2a01",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da05",
                                                                "_id": "6077c4efbc5f4d4df9ef2a02"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on monotonocity - interval of increase and decrease using first derivative and second derivative",
                                                        "id": "5ace20399fe7b01d5806bf65",
                                                        "_id": "6077c4efbc5f4d4df9ef29ff",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da06",
                                                                "_id": "6077c4efbc5f4d4df9ef2a00"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on monotonocity and maxima/minima for functional equation",
                                                        "id": "5ace20399fe7b01d5806bf66",
                                                        "_id": "6077c4efbc5f4d4df9ef29fd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da07",
                                                                "_id": "6077c4efbc5f4d4df9ef29fe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on normal",
                                                        "id": "5ace20399fe7b01d5806bf67",
                                                        "_id": "6077c4efbc5f4d4df9ef29fb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da08",
                                                                "_id": "6077c4efbc5f4d4df9ef29fc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Tangents",
                                                        "id": "5ace20399fe7b01d5806bf68",
                                                        "_id": "6077c4efbc5f4d4df9ef29f9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da09",
                                                                "_id": "6077c4efbc5f4d4df9ef29fa"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d93f",
                                                        "_id": "6077c4efbc5f4d4df9ef2a0d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Circles",
                                                "id": "5ace20319fe7b01d5806bc6c",
                                                "_id": "6077c4efbc5f4d4df9ef29f0",
                                                "concepts": [
                                                    {
                                                        "name": "Definition of Circle, Major Arcs and Minor arcs, congruence of circles and arcs, some results on congurent arcs and chords, some results on equal chords",
                                                        "id": "5ace203b9fe7b01d5806bffe",
                                                        "_id": "6077c4efbc5f4d4df9ef29f5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837b",
                                                                "_id": "6077c4efbc5f4d4df9ef29f6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Arcs and Angle subtended by them, Cyclic Quadrilateral, Cyclic Quadrilaterals Opposite Angle",
                                                        "id": "5ace203b9fe7b01d5806bffd",
                                                        "_id": "6077c4efbc5f4d4df9ef29f3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837c",
                                                                "_id": "6077c4efbc5f4d4df9ef29f4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "No. of Common Tangents, Arc of Circle, Angle in Semi-Circle",
                                                        "id": "5ace203b9fe7b01d5806bfff",
                                                        "_id": "6077c4efbc5f4d4df9ef29f1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837d",
                                                                "_id": "6077c4efbc5f4d4df9ef29f2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8222",
                                                        "_id": "6077c4efbc5f4d4df9ef29f7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Area Enclosed by Curves",
                                                "id": "5ace20319fe7b01d5806bc4a",
                                                "_id": "6077c4efbc5f4d4df9ef29ea",
                                                "concepts": [
                                                    {
                                                        "name": "Area bounded by f(x) and x-axis, f(y) and y-axis",
                                                        "id": "5ace20399fe7b01d5806bf69",
                                                        "_id": "6077c4efbc5f4d4df9ef29ed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0a",
                                                                "_id": "6077c4efbc5f4d4df9ef29ee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area bounded by f(x), g(x), x=a and x=b, curve and its asymptotes",
                                                        "id": "5ace20399fe7b01d5806bf6a",
                                                        "_id": "6077c4efbc5f4d4df9ef29eb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0b",
                                                                "_id": "6077c4efbc5f4d4df9ef29ec"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d940",
                                                        "_id": "6077c4efbc5f4d4df9ef29ef"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Constructions-1",
                                                "id": "5ace20319fe7b01d5806bc6e",
                                                "_id": "6077c4efbc5f4d4df9ef29e6",
                                                "concepts": [
                                                    {
                                                        "name": "Construction of Bisector of a line segment, Construction of bisector of a given angle, Construction of some Standard angles, Construction of a triangle when its base, sum of other two sides and one base angle are given",
                                                        "id": "5ace203b9fe7b01d5806c001",
                                                        "_id": "6077c4efbc5f4d4df9ef29e7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837e",
                                                                "_id": "6077c4efbc5f4d4df9ef29e8"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8223",
                                                        "_id": "6077c4efbc5f4d4df9ef29e9"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef2a96"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Motion",
                                                "id": "5ace20329fe7b01d5806bcb2",
                                                "_id": "6077c4efbc5f4d4df9ef29d3",
                                                "concepts": [
                                                    {
                                                        "name": "Distance & Displacement",
                                                        "id": "5ace20409fe7b01d5806c1bb",
                                                        "_id": "6077c4efbc5f4d4df9ef29e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d6",
                                                                "_id": "6077c4efbc5f4d4df9ef29e3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Avg Speed, Avg Velocity & Constant Acceleration",
                                                        "id": "5ace20409fe7b01d5806c1ba",
                                                        "_id": "6077c4efbc5f4d4df9ef29e0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d7",
                                                                "_id": "6077c4efbc5f4d4df9ef29e1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equations of motion",
                                                        "id": "5ace20409fe7b01d5806c1bd",
                                                        "_id": "6077c4efbc5f4d4df9ef29de",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d8",
                                                                "_id": "6077c4efbc5f4d4df9ef29df"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Free Fall under gravity",
                                                        "id": "5ace20409fe7b01d5806c1be",
                                                        "_id": "6077c4efbc5f4d4df9ef29dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d9",
                                                                "_id": "6077c4efbc5f4d4df9ef29dd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance time & Displacement time graph",
                                                        "id": "5ace20409fe7b01d5806c1bc",
                                                        "_id": "6077c4efbc5f4d4df9ef29da",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83da",
                                                                "_id": "6077c4efbc5f4d4df9ef29db"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Speed Time & Velocity time graph",
                                                        "id": "5ace20409fe7b01d5806c1c0",
                                                        "_id": "6077c4efbc5f4d4df9ef29d8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83db",
                                                                "_id": "6077c4efbc5f4d4df9ef29d9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Uniform Circular Motion",
                                                        "id": "5ace20409fe7b01d5806c1c1",
                                                        "_id": "6077c4efbc5f4d4df9ef29d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83dc",
                                                                "_id": "6077c4efbc5f4d4df9ef29d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Projectile motion",
                                                        "id": "5ace20409fe7b01d5806c1bf",
                                                        "_id": "6077c4efbc5f4d4df9ef29d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83dd",
                                                                "_id": "6077c4efbc5f4d4df9ef29d5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8238",
                                                        "_id": "6077c4efbc5f4d4df9ef29e4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Electric Charges and Fields",
                                                "id": "5ace20329fe7b01d5806bc9c",
                                                "_id": "6077c4efbc5f4d4df9ef29b9",
                                                "concepts": [
                                                    {
                                                        "name": "Coulomb's law & properties of charge",
                                                        "id": "5ace203e9fe7b01d5806c0ff",
                                                        "_id": "6077c4efbc5f4d4df9ef29d0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df17f",
                                                                "_id": "6077c4efbc5f4d4df9ef29d1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dielectrics and forces on dielectrics",
                                                        "id": "5ace203e9fe7b01d5806c100",
                                                        "_id": "6077c4efbc5f4d4df9ef29ce",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df180",
                                                                "_id": "6077c4efbc5f4d4df9ef29cf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "effect of electric field on a dipole",
                                                        "id": "5ace203e9fe7b01d5806c101",
                                                        "_id": "6077c4efbc5f4d4df9ef29cc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df181",
                                                                "_id": "6077c4efbc5f4d4df9ef29cd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric field lines and its representation",
                                                        "id": "5ace203e9fe7b01d5806c103",
                                                        "_id": "6077c4efbc5f4d4df9ef29ca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df182",
                                                                "_id": "6077c4efbc5f4d4df9ef29cb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric flux",
                                                        "id": "5ace203e9fe7b01d5806c104",
                                                        "_id": "6077c4efbc5f4d4df9ef29c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df183",
                                                                "_id": "6077c4efbc5f4d4df9ef29c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gauss' Law and its application",
                                                        "id": "5ace203e9fe7b01d5806c108",
                                                        "_id": "6077c4efbc5f4d4df9ef29c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df184",
                                                                "_id": "6077c4efbc5f4d4df9ef29c7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "properties of conductor, earthing of conductor",
                                                        "id": "5ace203e9fe7b01d5806c109",
                                                        "_id": "6077c4efbc5f4d4df9ef29c4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df185",
                                                                "_id": "6077c4efbc5f4d4df9ef29c5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Charges and Charging by induction",
                                                        "id": "5eeb62320a45db222dd12d09",
                                                        "_id": "6077c4efbc5f4d4df9ef29c2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df186",
                                                                "_id": "6077c4efbc5f4d4df9ef29c3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric field and Electric flux",
                                                        "id": "5eeb62320a45db222dd12d0b",
                                                        "_id": "6077c4efbc5f4d4df9ef29c0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df187",
                                                                "_id": "6077c4efbc5f4d4df9ef29c1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gauss Law and Its Applications",
                                                        "id": "5eeb62320a45db222dd12d0d",
                                                        "_id": "6077c4efbc5f4d4df9ef29be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df188",
                                                                "_id": "6077c4efbc5f4d4df9ef29bf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric dipole",
                                                        "id": "5eeb62320a45db222dd12d0c",
                                                        "_id": "6077c4efbc5f4d4df9ef29bc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df189",
                                                                "_id": "6077c4efbc5f4d4df9ef29bd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coulomb's law",
                                                        "id": "5eeb62320a45db222dd12d0a",
                                                        "_id": "6077c4efbc5f4d4df9ef29ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b1bf414a7d53ce5df18a",
                                                                "_id": "6077c4efbc5f4d4df9ef29bb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76b0f0f29da5758fc4bdbc",
                                                        "_id": "6077c4efbc5f4d4df9ef29d2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Current Electricity",
                                                "id": "5ace20329fe7b01d5806bc9b",
                                                "_id": "6077c4efbc5f4d4df9ef29a5",
                                                "concepts": [
                                                    {
                                                        "name": "cell and cell combination",
                                                        "id": "5ace203e9fe7b01d5806c0f3",
                                                        "_id": "6077c4efbc5f4d4df9ef29b6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd91",
                                                                "_id": "6077c4efbc5f4d4df9ef29b7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Current and voltage measuring instruments",
                                                        "id": "5ace203e9fe7b01d5806c0f4",
                                                        "_id": "6077c4efbc5f4d4df9ef29b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd92",
                                                                "_id": "6077c4efbc5f4d4df9ef29b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "drift velocity, electric current in conductors and current density",
                                                        "id": "5ace203e9fe7b01d5806c0f5",
                                                        "_id": "6077c4efbc5f4d4df9ef29b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd93",
                                                                "_id": "6077c4efbc5f4d4df9ef29b3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Effective resistances in networks",
                                                        "id": "5ace203e9fe7b01d5806c0f6",
                                                        "_id": "6077c4efbc5f4d4df9ef29b0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd94",
                                                                "_id": "6077c4efbc5f4d4df9ef29b1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heating effect of current, maximum power transfer theorem",
                                                        "id": "5ace203e9fe7b01d5806c0f7",
                                                        "_id": "6077c4efbc5f4d4df9ef29ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd95",
                                                                "_id": "6077c4efbc5f4d4df9ef29af"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kirchoff's laws and circuit problems (without capacitor)",
                                                        "id": "5ace203e9fe7b01d5806c0f8",
                                                        "_id": "6077c4efbc5f4d4df9ef29ac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd96",
                                                                "_id": "6077c4efbc5f4d4df9ef29ad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ohm's Law, Resistance and its properties",
                                                        "id": "5ace203e9fe7b01d5806c0f9",
                                                        "_id": "6077c4efbc5f4d4df9ef29aa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd97",
                                                                "_id": "6077c4efbc5f4d4df9ef29ab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "R-C circuits",
                                                        "id": "5ace203e9fe7b01d5806c0fa",
                                                        "_id": "6077c4efbc5f4d4df9ef29a8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd98",
                                                                "_id": "6077c4efbc5f4d4df9ef29a9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Wheatstone bridge and its applications",
                                                        "id": "5ace203e9fe7b01d5806c0fb",
                                                        "_id": "6077c4efbc5f4d4df9ef29a6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd99",
                                                                "_id": "6077c4efbc5f4d4df9ef29a7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd5b",
                                                        "_id": "6077c4efbc5f4d4df9ef29b8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Electrostatic Potential and Capacitance",
                                                "id": "5ace20329fe7b01d5806bc9c",
                                                "_id": "6077c4efbc5f4d4df9ef2983",
                                                "concepts": [
                                                    {
                                                        "name": "Capacitor circuit",
                                                        "id": "5ace203e9fe7b01d5806c0fc",
                                                        "_id": "6077c4efbc5f4d4df9ef29a2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae62",
                                                                "_id": "6077c4efbc5f4d4df9ef29a3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Capacitors and conductors",
                                                        "id": "5ace203e9fe7b01d5806c0fd",
                                                        "_id": "6077c4efbc5f4d4df9ef29a0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae63",
                                                                "_id": "6077c4efbc5f4d4df9ef29a1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Charge distribution and energy conservation in capacitance circuits",
                                                        "id": "5ace203e9fe7b01d5806c0fe",
                                                        "_id": "6077c4efbc5f4d4df9ef299e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae64",
                                                                "_id": "6077c4efbc5f4d4df9ef299f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Effective capacitances in various networks (Series,Parallel..etc)",
                                                        "id": "5ace203e9fe7b01d5806c102",
                                                        "_id": "6077c4efbc5f4d4df9ef299c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae65",
                                                                "_id": "6077c4efbc5f4d4df9ef299d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic field & potential energy, eqipotential surface",
                                                        "id": "5ace203e9fe7b01d5806c105",
                                                        "_id": "6077c4efbc5f4d4df9ef299a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae66",
                                                                "_id": "6077c4efbc5f4d4df9ef299b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic potential energy & self energy",
                                                        "id": "5ace203e9fe7b01d5806c106",
                                                        "_id": "6077c4efbc5f4d4df9ef2998",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae67",
                                                                "_id": "6077c4efbc5f4d4df9ef2999"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "field and potential due to a dipole",
                                                        "id": "5ace203e9fe7b01d5806c107",
                                                        "_id": "6077c4efbc5f4d4df9ef2996",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae68",
                                                                "_id": "6077c4efbc5f4d4df9ef2997"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "work energy theorem in a capacitor circuit",
                                                        "id": "5ace203e9fe7b01d5806c10a",
                                                        "_id": "6077c4efbc5f4d4df9ef2994",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae69",
                                                                "_id": "6077c4efbc5f4d4df9ef2995"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Combination of capacitors",
                                                        "id": "5eeb62320a45db222dd12d14",
                                                        "_id": "6077c4efbc5f4d4df9ef2992",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6a",
                                                                "_id": "6077c4efbc5f4d4df9ef2993"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatics of Conductors, Dielectrics and Polarisation",
                                                        "id": "5eeb62320a45db222dd12d12",
                                                        "_id": "6077c4efbc5f4d4df9ef2990",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6b",
                                                                "_id": "6077c4efbc5f4d4df9ef2991"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Capacitors and Capacitance",
                                                        "id": "5eeb62320a45db222dd12d13",
                                                        "_id": "6077c4efbc5f4d4df9ef298e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6c",
                                                                "_id": "6077c4efbc5f4d4df9ef298f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Potential due to an electric dipole and a system of charges",
                                                        "id": "5eeb62320a45db222dd12d0f",
                                                        "_id": "6077c4efbc5f4d4df9ef298c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6d",
                                                                "_id": "6077c4efbc5f4d4df9ef298d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equipotential surfaces and Potential Energy due to a system of charges",
                                                        "id": "5eeb62320a45db222dd12d10",
                                                        "_id": "6077c4efbc5f4d4df9ef298a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6e",
                                                                "_id": "6077c4efbc5f4d4df9ef298b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Energy stored in a Capacitor and Van de Graff generator",
                                                        "id": "5eeb62320a45db222dd12d15",
                                                        "_id": "6077c4efbc5f4d4df9ef2988",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae6f",
                                                                "_id": "6077c4efbc5f4d4df9ef2989"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic potential",
                                                        "id": "5eeb62320a45db222dd12d0e",
                                                        "_id": "6077c4efbc5f4d4df9ef2986",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae70",
                                                                "_id": "6077c4efbc5f4d4df9ef2987"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Potential energy in an external field",
                                                        "id": "5eeb62320a45db222dd12d11",
                                                        "_id": "6077c4efbc5f4d4df9ef2984",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f76b2b0a44fda53d315ae71",
                                                                "_id": "6077c4efbc5f4d4df9ef2985"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76b1e1f29da5758fc4bde0",
                                                        "_id": "6077c4efbc5f4d4df9ef29a4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Laws of Motion",
                                                "id": "5ace20329fe7b01d5806bcaf",
                                                "_id": "6077c4efbc5f4d4df9ef2971",
                                                "concepts": [
                                                    {
                                                        "name": "Force and its types and Inertia",
                                                        "id": "5ace20409fe7b01d5806c1a2",
                                                        "_id": "6077c4efbc5f4d4df9ef2980",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83de",
                                                                "_id": "6077c4efbc5f4d4df9ef2981"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Newton's First Law of Motion",
                                                        "id": "5ace20409fe7b01d5806c1a6",
                                                        "_id": "6077c4efbc5f4d4df9ef297e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83df",
                                                                "_id": "6077c4efbc5f4d4df9ef297f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Momentum & Newton's Second Law of Motion",
                                                        "id": "5ace20409fe7b01d5806c1a5",
                                                        "_id": "6077c4efbc5f4d4df9ef297c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e0",
                                                                "_id": "6077c4efbc5f4d4df9ef297d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Newton's Third Law of Motion",
                                                        "id": "5ace20409fe7b01d5806c1a7",
                                                        "_id": "6077c4efbc5f4d4df9ef297a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e1",
                                                                "_id": "6077c4efbc5f4d4df9ef297b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Impulse",
                                                        "id": "5ace20409fe7b01d5806c1a4",
                                                        "_id": "6077c4efbc5f4d4df9ef2978",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e2",
                                                                "_id": "6077c4efbc5f4d4df9ef2979"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conservation of Momentum",
                                                        "id": "5ace20409fe7b01d5806c1a1",
                                                        "_id": "6077c4efbc5f4d4df9ef2976",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e3",
                                                                "_id": "6077c4efbc5f4d4df9ef2977"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Friction (Basic idea)",
                                                        "id": "5ace20409fe7b01d5806c1a3",
                                                        "_id": "6077c4efbc5f4d4df9ef2974",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e4",
                                                                "_id": "6077c4efbc5f4d4df9ef2975"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Centripetal force (Basic idea)",
                                                        "id": "5ace20409fe7b01d5806c1a0",
                                                        "_id": "6077c4efbc5f4d4df9ef2972",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e5",
                                                                "_id": "6077c4efbc5f4d4df9ef2973"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8239",
                                                        "_id": "6077c4efbc5f4d4df9ef2982"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Electrostatistics",
                                                "id": "5ace20329fe7b01d5806bc9c",
                                                "_id": "6077c4efbc5f4d4df9ef2951",
                                                "concepts": [
                                                    {
                                                        "name": "Capacitor circuit",
                                                        "id": "5ace203e9fe7b01d5806c0fc",
                                                        "_id": "6077c4efbc5f4d4df9ef296e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9a",
                                                                "_id": "6077c4efbc5f4d4df9ef296f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Capacitors and conductors",
                                                        "id": "5ace203e9fe7b01d5806c0fd",
                                                        "_id": "6077c4efbc5f4d4df9ef296c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9b",
                                                                "_id": "6077c4efbc5f4d4df9ef296d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Charge distribution and energy conservation in capacitance circuits",
                                                        "id": "5ace203e9fe7b01d5806c0fe",
                                                        "_id": "6077c4efbc5f4d4df9ef296a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9c",
                                                                "_id": "6077c4efbc5f4d4df9ef296b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coulomb's law & properties of charge",
                                                        "id": "5ace203e9fe7b01d5806c0ff",
                                                        "_id": "6077c4efbc5f4d4df9ef2968",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9d",
                                                                "_id": "6077c4efbc5f4d4df9ef2969"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dielectrics and forces on dielectrics",
                                                        "id": "5ace203e9fe7b01d5806c100",
                                                        "_id": "6077c4efbc5f4d4df9ef2966",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9e",
                                                                "_id": "6077c4efbc5f4d4df9ef2967"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "effect of electric field on a dipole",
                                                        "id": "5ace203e9fe7b01d5806c101",
                                                        "_id": "6077c4efbc5f4d4df9ef2964",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd9f",
                                                                "_id": "6077c4efbc5f4d4df9ef2965"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Effective capacitances in various networks (Series,Parallel..etc)",
                                                        "id": "5ace203e9fe7b01d5806c102",
                                                        "_id": "6077c4efbc5f4d4df9ef2962",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda0",
                                                                "_id": "6077c4efbc5f4d4df9ef2963"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric field lines and its representation",
                                                        "id": "5ace203e9fe7b01d5806c103",
                                                        "_id": "6077c4efbc5f4d4df9ef2960",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda1",
                                                                "_id": "6077c4efbc5f4d4df9ef2961"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric flux",
                                                        "id": "5ace203e9fe7b01d5806c104",
                                                        "_id": "6077c4efbc5f4d4df9ef295e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda2",
                                                                "_id": "6077c4efbc5f4d4df9ef295f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic field & potential energy, eqipotential surface",
                                                        "id": "5ace203e9fe7b01d5806c105",
                                                        "_id": "6077c4efbc5f4d4df9ef295c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda3",
                                                                "_id": "6077c4efbc5f4d4df9ef295d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic potential energy & self energy",
                                                        "id": "5ace203e9fe7b01d5806c106",
                                                        "_id": "6077c4efbc5f4d4df9ef295a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda4",
                                                                "_id": "6077c4efbc5f4d4df9ef295b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "field and potential due to a dipole",
                                                        "id": "5ace203e9fe7b01d5806c107",
                                                        "_id": "6077c4efbc5f4d4df9ef2958",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda5",
                                                                "_id": "6077c4efbc5f4d4df9ef2959"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gauss' Law and its application",
                                                        "id": "5ace203e9fe7b01d5806c108",
                                                        "_id": "6077c4efbc5f4d4df9ef2956",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda6",
                                                                "_id": "6077c4efbc5f4d4df9ef2957"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "properties of conductor, earthing of conductor",
                                                        "id": "5ace203e9fe7b01d5806c109",
                                                        "_id": "6077c4efbc5f4d4df9ef2954",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda7",
                                                                "_id": "6077c4efbc5f4d4df9ef2955"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "work energy theorem in a capacitor circuit",
                                                        "id": "5ace203e9fe7b01d5806c10a",
                                                        "_id": "6077c4efbc5f4d4df9ef2952",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda8",
                                                                "_id": "6077c4efbc5f4d4df9ef2953"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd5c",
                                                        "_id": "6077c4efbc5f4d4df9ef2970"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef29e5"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Series Completion",
                                                "id": "5ace20319fe7b01d5806bc3b",
                                                "_id": "6077c4efbc5f4d4df9ef294a",
                                                "concepts": [
                                                    {
                                                        "name": "Number Series",
                                                        "id": "5ace20399fe7b01d5806bf37",
                                                        "_id": "6077c4efbc5f4d4df9ef294d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8420",
                                                                "_id": "6077c4efbc5f4d4df9ef294e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Alphabet Series",
                                                        "id": "5ace20399fe7b01d5806bf36",
                                                        "_id": "6077c4efbc5f4d4df9ef294b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8421",
                                                                "_id": "6077c4efbc5f4d4df9ef294c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8243",
                                                        "_id": "6077c4efbc5f4d4df9ef294f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Inserting Missing Character",
                                                "id": "5ace20319fe7b01d5806bc2f",
                                                "_id": "6077c4efbc5f4d4df9ef2946",
                                                "concepts": [
                                                    {
                                                        "name": "Inserting missing character",
                                                        "id": "5ace20389fe7b01d5806bf1f",
                                                        "_id": "6077c4efbc5f4d4df9ef2947",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8422",
                                                                "_id": "6077c4efbc5f4d4df9ef2948"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8244",
                                                        "_id": "6077c4efbc5f4d4df9ef2949"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Blood Relations",
                                                "id": "5ace20309fe7b01d5806bc21",
                                                "_id": "6077c4efbc5f4d4df9ef2942",
                                                "concepts": [
                                                    {
                                                        "name": "Blood Relations",
                                                        "id": "5ace20389fe7b01d5806bf0f",
                                                        "_id": "6077c4efbc5f4d4df9ef2943",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8423",
                                                                "_id": "6077c4efbc5f4d4df9ef2944"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8245",
                                                        "_id": "6077c4efbc5f4d4df9ef2945"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef2950"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "India - Size and Location",
                                                "id": "5ace20329fe7b01d5806bcc8",
                                                "_id": "6077c4efbc5f4d4df9ef293d",
                                                "concepts": [
                                                    {
                                                        "name": "India - Size and Location",
                                                        "id": "5ace20419fe7b01d5806c1fc",
                                                        "_id": "6077c4efbc5f4d4df9ef293e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8455",
                                                                "_id": "6077c4efbc5f4d4df9ef293f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8268",
                                                        "_id": "6077c4efbc5f4d4df9ef2940"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Drainage",
                                                "id": "5ace20329fe7b01d5806bcc6",
                                                "_id": "6077c4efbc5f4d4df9ef2937",
                                                "concepts": [
                                                    {
                                                        "name": "Perennial & Seasonal Rivers.",
                                                        "id": "5ace20419fe7b01d5806c1f9",
                                                        "_id": "6077c4efbc5f4d4df9ef293a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8456",
                                                                "_id": "6077c4efbc5f4d4df9ef293b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different river systems.",
                                                        "id": "5ace20419fe7b01d5806c1f8",
                                                        "_id": "6077c4efbc5f4d4df9ef2938",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8457",
                                                                "_id": "6077c4efbc5f4d4df9ef2939"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8269",
                                                        "_id": "6077c4efbc5f4d4df9ef293c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Physical Features of India",
                                                "id": "5ace20329fe7b01d5806bccd",
                                                "_id": "6077c4efbc5f4d4df9ef2931",
                                                "concepts": [
                                                    {
                                                        "name": "Plate Tectonic movements & the formation of Himalaya",
                                                        "id": "5ace20419fe7b01d5806c203",
                                                        "_id": "6077c4efbc5f4d4df9ef2934",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8458",
                                                                "_id": "6077c4efbc5f4d4df9ef2935"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different landforms",
                                                        "id": "5ace20419fe7b01d5806c202",
                                                        "_id": "6077c4efbc5f4d4df9ef2932",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8459",
                                                                "_id": "6077c4efbc5f4d4df9ef2933"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826a",
                                                        "_id": "6077c4efbc5f4d4df9ef2936"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Climate",
                                                "id": "5ace20329fe7b01d5806bcc5",
                                                "_id": "6077c4efbc5f4d4df9ef292b",
                                                "concepts": [
                                                    {
                                                        "name": "Components of weather & climate",
                                                        "id": "5ace20419fe7b01d5806c1f6",
                                                        "_id": "6077c4efbc5f4d4df9ef292e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845a",
                                                                "_id": "6077c4efbc5f4d4df9ef292f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Factors, affecting climate i.e., India",
                                                        "id": "5ace20419fe7b01d5806c1f7",
                                                        "_id": "6077c4efbc5f4d4df9ef292c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845b",
                                                                "_id": "6077c4efbc5f4d4df9ef292d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826b",
                                                        "_id": "6077c4efbc5f4d4df9ef2930"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Natural Vegetation and Wildlife",
                                                "id": "5ace20329fe7b01d5806bccc",
                                                "_id": "6077c4efbc5f4d4df9ef2927",
                                                "concepts": [
                                                    {
                                                        "name": "Natural Vegetation & Wildlife",
                                                        "id": "5ace20419fe7b01d5806c201",
                                                        "_id": "6077c4efbc5f4d4df9ef2928",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845c",
                                                                "_id": "6077c4efbc5f4d4df9ef2929"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826c",
                                                        "_id": "6077c4efbc5f4d4df9ef292a"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef2941"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Analogy",
                                                "id": "5ace20309fe7b01d5806bc13",
                                                "_id": "6077c4efbc5f4d4df9ef291e",
                                                "concepts": [
                                                    {
                                                        "name": "Letter Analogy",
                                                        "id": "5ace20389fe7b01d5806bef9",
                                                        "_id": "6077c4efbc5f4d4df9ef2923",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df3e",
                                                                "_id": "6077c4efbc5f4d4df9ef2924"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Number Analogy",
                                                        "id": "5ace20389fe7b01d5806befa",
                                                        "_id": "6077c4efbc5f4d4df9ef2921",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df3f",
                                                                "_id": "6077c4efbc5f4d4df9ef2922"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Word Analogy",
                                                        "id": "5ace20389fe7b01d5806befb",
                                                        "_id": "6077c4efbc5f4d4df9ef291f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df40",
                                                                "_id": "6077c4efbc5f4d4df9ef2920"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df34",
                                                        "_id": "6077c4efbc5f4d4df9ef2925"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef2926"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 2,
                                "startDate": "2021-05-03T00:00:00.000Z",
                                "endDate": "2021-05-09T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef27a1",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Tissues",
                                                "id": "5ace202f9fe7b01d5806bbc4",
                                                "_id": "6077c4efbc5f4d4df9ef290c",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction Classification of plant tissues",
                                                        "id": "5ace20339fe7b01d5806bd61",
                                                        "_id": "6077c4efbc5f4d4df9ef2919",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a8",
                                                                "_id": "6077c4efbc5f4d4df9ef291a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple & Complex permanent tissues",
                                                        "id": "5ace20339fe7b01d5806bd64",
                                                        "_id": "6077c4efbc5f4d4df9ef2917",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82a9",
                                                                "_id": "6077c4efbc5f4d4df9ef2918"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Meristematic tissues & Protective tissue",
                                                        "id": "5ace20339fe7b01d5806bd62",
                                                        "_id": "6077c4efbc5f4d4df9ef2915",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82aa",
                                                                "_id": "6077c4efbc5f4d4df9ef2916"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classification of animal tissues",
                                                        "id": "5ace20339fe7b01d5806bd5e",
                                                        "_id": "6077c4efbc5f4d4df9ef2913",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ab",
                                                                "_id": "6077c4efbc5f4d4df9ef2914"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Epithelial tissues",
                                                        "id": "5ace20339fe7b01d5806bd60",
                                                        "_id": "6077c4efbc5f4d4df9ef2911",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ac",
                                                                "_id": "6077c4efbc5f4d4df9ef2912"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Connective tissues",
                                                        "id": "5ace20339fe7b01d5806bd5f",
                                                        "_id": "6077c4efbc5f4d4df9ef290f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ad",
                                                                "_id": "6077c4efbc5f4d4df9ef2910"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Muscular & Nervous tissues",
                                                        "id": "5ace20339fe7b01d5806bd63",
                                                        "_id": "6077c4efbc5f4d4df9ef290d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ae",
                                                                "_id": "6077c4efbc5f4d4df9ef290e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8208",
                                                        "_id": "6077c4efbc5f4d4df9ef291b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef291c"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Is matter around as pure?",
                                                "id": "5ace202f9fe7b01d5806bbcb",
                                                "_id": "6077c4efbc5f4d4df9ef28fb",
                                                "concepts": [
                                                    {
                                                        "name": "Elements(metals,non-metals and metalloids)",
                                                        "id": "5ace20349fe7b01d5806bd9a",
                                                        "_id": "6077c4efbc5f4d4df9ef2908",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8320",
                                                                "_id": "6077c4efbc5f4d4df9ef2909"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Compounds",
                                                        "id": "5ace20349fe7b01d5806bd98",
                                                        "_id": "6077c4efbc5f4d4df9ef2906",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8321",
                                                                "_id": "6077c4efbc5f4d4df9ef2907"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Homogenous mixtures",
                                                        "id": "5ace20349fe7b01d5806bd9c",
                                                        "_id": "6077c4efbc5f4d4df9ef2904",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8322",
                                                                "_id": "6077c4efbc5f4d4df9ef2905"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heterogenous mixtures(Colloids and Suspensions)",
                                                        "id": "5ace20349fe7b01d5806bd9b",
                                                        "_id": "6077c4efbc5f4d4df9ef2902",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8323",
                                                                "_id": "6077c4efbc5f4d4df9ef2903"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Concentration terms",
                                                        "id": "5ace20349fe7b01d5806bd99",
                                                        "_id": "6077c4efbc5f4d4df9ef2900",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8324",
                                                                "_id": "6077c4efbc5f4d4df9ef2901"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Separation of mixtures",
                                                        "id": "5ace20349fe7b01d5806bd9e",
                                                        "_id": "6077c4efbc5f4d4df9ef28fe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8325",
                                                                "_id": "6077c4efbc5f4d4df9ef28ff"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Physical and Chemical changes",
                                                        "id": "5ace20349fe7b01d5806bd9d",
                                                        "_id": "6077c4efbc5f4d4df9ef28fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8326",
                                                                "_id": "6077c4efbc5f4d4df9ef28fd"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8213",
                                                        "_id": "6077c4efbc5f4d4df9ef290a"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef290b"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Continuity & Differentiabilty",
                                                "id": "5ace20319fe7b01d5806bc4b",
                                                "_id": "6077c4efbc5f4d4df9ef28f8",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d941",
                                                        "_id": "6077c4efbc5f4d4df9ef28f9"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Heron's Formula",
                                                "id": "5ace20319fe7b01d5806bc71",
                                                "_id": "6077c4efbc5f4d4df9ef28f4",
                                                "concepts": [
                                                    {
                                                        "name": "Heron's Formula and problems",
                                                        "id": "5ace203b9fe7b01d5806c009",
                                                        "_id": "6077c4efbc5f4d4df9ef28f5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c837f",
                                                                "_id": "6077c4efbc5f4d4df9ef28f6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8224",
                                                        "_id": "6077c4efbc5f4d4df9ef28f7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Continuity & Differentiabilty",
                                                "id": "5ace20319fe7b01d5806bc4c",
                                                "_id": "6077c4efbc5f4d4df9ef28e0",
                                                "concepts": [
                                                    {
                                                        "name": "Continuity of composite function, finding unknown parameters from continuity",
                                                        "id": "5ace20399fe7b01d5806bf6b",
                                                        "_id": "6077c4efbc5f4d4df9ef28f1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0c",
                                                                "_id": "6077c4efbc5f4d4df9ef28f2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiability based on finding unknown parameters",
                                                        "id": "5ace20399fe7b01d5806bf6c",
                                                        "_id": "6077c4efbc5f4d4df9ef28ef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0d",
                                                                "_id": "6077c4efbc5f4d4df9ef28f0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiability based on first principle, Using continuity & differentiability to determine number of real roots of a function",
                                                        "id": "5ace20399fe7b01d5806bf6d",
                                                        "_id": "6077c4efbc5f4d4df9ef28ed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0e",
                                                                "_id": "6077c4efbc5f4d4df9ef28ee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Intermediate Value Theorem",
                                                        "id": "5ace20399fe7b01d5806bf6e",
                                                        "_id": "6077c4efbc5f4d4df9ef28eb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da0f",
                                                                "_id": "6077c4efbc5f4d4df9ef28ec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Investigating functions using functional equation",
                                                        "id": "5ace20399fe7b01d5806bf6f",
                                                        "_id": "6077c4efbc5f4d4df9ef28e9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da10",
                                                                "_id": "6077c4efbc5f4d4df9ef28ea"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on continuity and differentiability using graph",
                                                        "id": "5ace20399fe7b01d5806bf70",
                                                        "_id": "6077c4efbc5f4d4df9ef28e7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da11",
                                                                "_id": "6077c4efbc5f4d4df9ef28e8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "To check continuity of a function",
                                                        "id": "5ace20399fe7b01d5806bf71",
                                                        "_id": "6077c4efbc5f4d4df9ef28e5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da12",
                                                                "_id": "6077c4efbc5f4d4df9ef28e6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "To check differentiability of a function, LHD & RHD of a function, existence of derivative Problems based on piece wise defined function",
                                                        "id": "5ace20399fe7b01d5806bf72",
                                                        "_id": "6077c4efbc5f4d4df9ef28e3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da13",
                                                                "_id": "6077c4efbc5f4d4df9ef28e4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Type of discontinuity, to find points of discontinuity, no of points of discontinuity",
                                                        "id": "5ace20399fe7b01d5806bf73",
                                                        "_id": "6077c4efbc5f4d4df9ef28e1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da14",
                                                                "_id": "6077c4efbc5f4d4df9ef28e2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d942",
                                                        "_id": "6077c4efbc5f4d4df9ef28f3"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Surface Area and Volume - 1",
                                                "id": "5ace20319fe7b01d5806bc80",
                                                "_id": "6077c4efbc5f4d4df9ef28d2",
                                                "concepts": [
                                                    {
                                                        "name": "Lateral Surface Area and Total Surface Area of Cuboid and Cube, Volume of a Cuboid and Cube",
                                                        "id": "5ace203c9fe7b01d5806c03f",
                                                        "_id": "6077c4efbc5f4d4df9ef28dd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8380",
                                                                "_id": "6077c4efbc5f4d4df9ef28de"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of a Cuboid and Cube",
                                                        "id": "5ace203c9fe7b01d5806c040",
                                                        "_id": "6077c4efbc5f4d4df9ef28db",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8381",
                                                                "_id": "6077c4efbc5f4d4df9ef28dc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Curved Surface Area and Total Surface Area of Right Circular Cylinder,Cone,Sphere and Hemisphere",
                                                        "id": "5ace203c9fe7b01d5806c03e",
                                                        "_id": "6077c4efbc5f4d4df9ef28d9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8382",
                                                                "_id": "6077c4efbc5f4d4df9ef28da"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Curved Surface Area and Total Surface Area of Hollow Cylinder,Hollow Sphere and Hollow Hemisphere",
                                                        "id": "5ace203c9fe7b01d5806c03d",
                                                        "_id": "6077c4efbc5f4d4df9ef28d7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8383",
                                                                "_id": "6077c4efbc5f4d4df9ef28d8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of a Cylinder,Cone,Sphere and Hemisphere",
                                                        "id": "5ace203c9fe7b01d5806c041",
                                                        "_id": "6077c4efbc5f4d4df9ef28d5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8384",
                                                                "_id": "6077c4efbc5f4d4df9ef28d6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of a Hollow cylinder,Hollow sphere and Hollow hemisphere",
                                                        "id": "5ace203c9fe7b01d5806c042",
                                                        "_id": "6077c4efbc5f4d4df9ef28d3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8385",
                                                                "_id": "6077c4efbc5f4d4df9ef28d4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8225",
                                                        "_id": "6077c4efbc5f4d4df9ef28df"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Definite Integration",
                                                "id": "5ace20319fe7b01d5806bc4d",
                                                "_id": "6077c4efbc5f4d4df9ef28c0",
                                                "concepts": [
                                                    {
                                                        "name": "Inequalities, Solving definite integration using graphs, piece wise continuous functions",
                                                        "id": "5ace20399fe7b01d5806bf74",
                                                        "_id": "6077c4efbc5f4d4df9ef28cf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da15",
                                                                "_id": "6077c4efbc5f4d4df9ef28d0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Integral of inverse of a function",
                                                        "id": "5ace20399fe7b01d5806bf75",
                                                        "_id": "6077c4efbc5f4d4df9ef28cd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da16",
                                                                "_id": "6077c4efbc5f4d4df9ef28ce"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Integral of periodic function",
                                                        "id": "5ace20399fe7b01d5806bf76",
                                                        "_id": "6077c4efbc5f4d4df9ef28cb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da17",
                                                                "_id": "6077c4efbc5f4d4df9ef28cc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limit as a sum",
                                                        "id": "5ace20399fe7b01d5806bf77",
                                                        "_id": "6077c4efbc5f4d4df9ef28c9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da18",
                                                                "_id": "6077c4efbc5f4d4df9ef28ca"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Newton-Leibnitz rule",
                                                        "id": "5ace20399fe7b01d5806bf78",
                                                        "_id": "6077c4efbc5f4d4df9ef28c7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da19",
                                                                "_id": "6077c4efbc5f4d4df9ef28c8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on reduction formula",
                                                        "id": "5ace20399fe7b01d5806bf79",
                                                        "_id": "6077c4efbc5f4d4df9ef28c5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1a",
                                                                "_id": "6077c4efbc5f4d4df9ef28c6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on partial derivatives",
                                                        "id": "5ace203a9fe7b01d5806bf7a",
                                                        "_id": "6077c4efbc5f4d4df9ef28c3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1b",
                                                                "_id": "6077c4efbc5f4d4df9ef28c4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on properties",
                                                        "id": "5ace203a9fe7b01d5806bf7b",
                                                        "_id": "6077c4efbc5f4d4df9ef28c1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1c",
                                                                "_id": "6077c4efbc5f4d4df9ef28c2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d943",
                                                        "_id": "6077c4efbc5f4d4df9ef28d1"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics-1",
                                                "id": "5ace20319fe7b01d5806bc7e",
                                                "_id": "6077c4efbc5f4d4df9ef28ac",
                                                "concepts": [
                                                    {
                                                        "name": "Statistical Data ( Primary, Secondary )",
                                                        "id": "5ace203c9fe7b01d5806c039",
                                                        "_id": "6077c4efbc5f4d4df9ef28bd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8386",
                                                                "_id": "6077c4efbc5f4d4df9ef28be"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Frequency Distributions ( Discrete and Continous )",
                                                        "id": "5ace203c9fe7b01d5806c035",
                                                        "_id": "6077c4efbc5f4d4df9ef28bb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8387",
                                                                "_id": "6077c4efbc5f4d4df9ef28bc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Exclusive, Inclusive method",
                                                        "id": "5ace203c9fe7b01d5806c034",
                                                        "_id": "6077c4efbc5f4d4df9ef28b9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8388",
                                                                "_id": "6077c4efbc5f4d4df9ef28ba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Construction of Discrete , Grouped Frequency Distributions",
                                                        "id": "5ace203c9fe7b01d5806c032",
                                                        "_id": "6077c4efbc5f4d4df9ef28b7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8389",
                                                                "_id": "6077c4efbc5f4d4df9ef28b8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cumulative Frequency Distributions",
                                                        "id": "5ace203c9fe7b01d5806c033",
                                                        "_id": "6077c4efbc5f4d4df9ef28b5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838a",
                                                                "_id": "6077c4efbc5f4d4df9ef28b6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graphical Represantion of Statistical Data ( Bar graph, Histogram )",
                                                        "id": "5ace203c9fe7b01d5806c037",
                                                        "_id": "6077c4efbc5f4d4df9ef28b3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838b",
                                                                "_id": "6077c4efbc5f4d4df9ef28b4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Construction of different kind of Histograms",
                                                        "id": "5ace203c9fe7b01d5806c031",
                                                        "_id": "6077c4efbc5f4d4df9ef28b1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838c",
                                                                "_id": "6077c4efbc5f4d4df9ef28b2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Frequency Polygon",
                                                        "id": "5ace203c9fe7b01d5806c036",
                                                        "_id": "6077c4efbc5f4d4df9ef28af",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838d",
                                                                "_id": "6077c4efbc5f4d4df9ef28b0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Measure of Central Tendency",
                                                        "id": "5ace203c9fe7b01d5806c038",
                                                        "_id": "6077c4efbc5f4d4df9ef28ad",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838e",
                                                                "_id": "6077c4efbc5f4d4df9ef28ae"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8226",
                                                        "_id": "6077c4efbc5f4d4df9ef28bf"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differential Equation",
                                                "id": "5ace20319fe7b01d5806bc4e",
                                                "_id": "6077c4efbc5f4d4df9ef28aa",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d944",
                                                        "_id": "6077c4efbc5f4d4df9ef28ab"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Co-ordinate Geometry-1",
                                                "id": "5ace20319fe7b01d5806bc70",
                                                "_id": "6077c4efbc5f4d4df9ef28a0",
                                                "concepts": [
                                                    {
                                                        "name": "Distance between Two Points",
                                                        "id": "5ace203b9fe7b01d5806c006",
                                                        "_id": "6077c4efbc5f4d4df9ef28a7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c838f",
                                                                "_id": "6077c4efbc5f4d4df9ef28a8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Internal and External Division using Section Formula,",
                                                        "id": "5ace203b9fe7b01d5806c007",
                                                        "_id": "6077c4efbc5f4d4df9ef28a5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8390",
                                                                "_id": "6077c4efbc5f4d4df9ef28a6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mid point theorem, centroid of triangle",
                                                        "id": "5ace203b9fe7b01d5806c008",
                                                        "_id": "6077c4efbc5f4d4df9ef28a3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8391",
                                                                "_id": "6077c4efbc5f4d4df9ef28a4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area of triangle, collinearity of points",
                                                        "id": "5ace203b9fe7b01d5806c005",
                                                        "_id": "6077c4efbc5f4d4df9ef28a1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8392",
                                                                "_id": "6077c4efbc5f4d4df9ef28a2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8227",
                                                        "_id": "6077c4efbc5f4d4df9ef28a9"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differential Equation",
                                                "id": "5ace20319fe7b01d5806bc4f",
                                                "_id": "6077c4efbc5f4d4df9ef288c",
                                                "concepts": [
                                                    {
                                                        "name": "Apllications of differential equation- orthogonal trajectories, tangent and normal, sub-tangent and sub-normal",
                                                        "id": "5ace203a9fe7b01d5806bf7c",
                                                        "_id": "6077c4efbc5f4d4df9ef289d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1d",
                                                                "_id": "6077c4efbc5f4d4df9ef289e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application of differential equation-rate of change problem",
                                                        "id": "5ace203a9fe7b01d5806bf7d",
                                                        "_id": "6077c4efbc5f4d4df9ef289b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1e",
                                                                "_id": "6077c4efbc5f4d4df9ef289c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Formation of differential equation",
                                                        "id": "5ace203a9fe7b01d5806bf7e",
                                                        "_id": "6077c4efbc5f4d4df9ef2899",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da1f",
                                                                "_id": "6077c4efbc5f4d4df9ef289a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "geometrical apllication",
                                                        "id": "5ace203a9fe7b01d5806bf7f",
                                                        "_id": "6077c4efbc5f4d4df9ef2897",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da20",
                                                                "_id": "6077c4efbc5f4d4df9ef2898"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "order and degree of differential equation",
                                                        "id": "5ace203a9fe7b01d5806bf80",
                                                        "_id": "6077c4efbc5f4d4df9ef2895",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da21",
                                                                "_id": "6077c4efbc5f4d4df9ef2896"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reducible to variable seperable method, solution of differential equation of the homogeneous and reducible to the homogeneous form",
                                                        "id": "5ace203a9fe7b01d5806bf81",
                                                        "_id": "6077c4efbc5f4d4df9ef2893",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da22",
                                                                "_id": "6077c4efbc5f4d4df9ef2894"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of differential equation by variable seperable method",
                                                        "id": "5ace203a9fe7b01d5806bf82",
                                                        "_id": "6077c4efbc5f4d4df9ef2891",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da23",
                                                                "_id": "6077c4efbc5f4d4df9ef2892"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "solution of general form of variable seperation",
                                                        "id": "5ace203a9fe7b01d5806bf83",
                                                        "_id": "6077c4efbc5f4d4df9ef288f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da24",
                                                                "_id": "6077c4efbc5f4d4df9ef2890"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Linear differential equation, solution of bernoulis eqn, Solution of differential equation reducible to Bernoulii form",
                                                        "id": "5ace203a9fe7b01d5806bf84",
                                                        "_id": "6077c4efbc5f4d4df9ef288d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da25",
                                                                "_id": "6077c4efbc5f4d4df9ef288e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d945",
                                                        "_id": "6077c4efbc5f4d4df9ef289f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability-1",
                                                "id": "5ace20319fe7b01d5806bc78",
                                                "_id": "6077c4efbc5f4d4df9ef2884",
                                                "concepts": [
                                                    {
                                                        "name": "Definition of Probability",
                                                        "id": "5ace203b9fe7b01d5806c01e",
                                                        "_id": "6077c4efbc5f4d4df9ef2889",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8393",
                                                                "_id": "6077c4efbc5f4d4df9ef288a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems on coins",
                                                        "id": "5ace203b9fe7b01d5806c01f",
                                                        "_id": "6077c4efbc5f4d4df9ef2887",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8394",
                                                                "_id": "6077c4efbc5f4d4df9ef2888"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems on dice",
                                                        "id": "5ace203b9fe7b01d5806c020",
                                                        "_id": "6077c4efbc5f4d4df9ef2885",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8395",
                                                                "_id": "6077c4efbc5f4d4df9ef2886"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8228",
                                                        "_id": "6077c4efbc5f4d4df9ef288b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differentiation",
                                                "id": "5ace20319fe7b01d5806bc50",
                                                "_id": "6077c4efbc5f4d4df9ef2882",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d946",
                                                        "_id": "6077c4efbc5f4d4df9ef2883"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Co-ordinate Geometry - 2",
                                                "id": "5ace20319fe7b01d5806bc6f",
                                                "_id": "6077c4efbc5f4d4df9ef287a",
                                                "concepts": [
                                                    {
                                                        "name": "Cartesian system, Distance between two points, Internal and External division",
                                                        "id": "5ace203b9fe7b01d5806c002",
                                                        "_id": "6077c4efbc5f4d4df9ef287f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8396",
                                                                "_id": "6077c4efbc5f4d4df9ef2880"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Centroid ,Area of a Triangle, Straight line (Locus, Slope)",
                                                        "id": "5ace203b9fe7b01d5806c003",
                                                        "_id": "6077c4efbc5f4d4df9ef287d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8397",
                                                                "_id": "6077c4efbc5f4d4df9ef287e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Forms of Straight Line- Point slope, Slope intercept, Two point, Normal form, Length of perpendicular, Angle between Two Lines",
                                                        "id": "5ace203b9fe7b01d5806c004",
                                                        "_id": "6077c4efbc5f4d4df9ef287b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8398",
                                                                "_id": "6077c4efbc5f4d4df9ef287c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8229",
                                                        "_id": "6077c4efbc5f4d4df9ef2881"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differentiation",
                                                "id": "5ace20319fe7b01d5806bc51",
                                                "_id": "6077c4efbc5f4d4df9ef286e",
                                                "concepts": [
                                                    {
                                                        "name": "chain rule",
                                                        "id": "5ace203a9fe7b01d5806bf85",
                                                        "_id": "6077c4efbc5f4d4df9ef2877",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da26",
                                                                "_id": "6077c4efbc5f4d4df9ef2878"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Derivative of implicit function, derivative of parametric function, derivative of one function w.r.t another function, derivative of function to power function form, derivative of infinite series type problems",
                                                        "id": "5ace203a9fe7b01d5806bf86",
                                                        "_id": "6077c4efbc5f4d4df9ef2875",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da27",
                                                                "_id": "6077c4efbc5f4d4df9ef2876"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiation of various functions and the rules of differentiation",
                                                        "id": "5ace203a9fe7b01d5806bf87",
                                                        "_id": "6077c4efbc5f4d4df9ef2873",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da28",
                                                                "_id": "6077c4efbc5f4d4df9ef2874"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "first principle",
                                                        "id": "5ace203a9fe7b01d5806bf88",
                                                        "_id": "6077c4efbc5f4d4df9ef2871",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da29",
                                                                "_id": "6077c4efbc5f4d4df9ef2872"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "higher order derivative",
                                                        "id": "5ace203a9fe7b01d5806bf89",
                                                        "_id": "6077c4efbc5f4d4df9ef286f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2a",
                                                                "_id": "6077c4efbc5f4d4df9ef2870"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d947",
                                                        "_id": "6077c4efbc5f4d4df9ef2879"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability-2",
                                                "id": "5ace20319fe7b01d5806bc79",
                                                "_id": "6077c4efbc5f4d4df9ef2866",
                                                "concepts": [
                                                    {
                                                        "name": "Experimental or emperical approch to probability, Definitions of trial, Event, Compound event, Occurrence of an event, Emperical Probability Definition and problems related to it",
                                                        "id": "5ace203b9fe7b01d5806c021",
                                                        "_id": "6077c4efbc5f4d4df9ef286b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8399",
                                                                "_id": "6077c4efbc5f4d4df9ef286c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental Principles of Addition and Multiplication",
                                                        "id": "5ace203b9fe7b01d5806c022",
                                                        "_id": "6077c4efbc5f4d4df9ef2869",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839a",
                                                                "_id": "6077c4efbc5f4d4df9ef286a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sure event, Impossible event, Complement of an event",
                                                        "id": "5ace203b9fe7b01d5806c023",
                                                        "_id": "6077c4efbc5f4d4df9ef2867",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839b",
                                                                "_id": "6077c4efbc5f4d4df9ef2868"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822a",
                                                        "_id": "6077c4efbc5f4d4df9ef286d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Indefinite Integration",
                                                "id": "5ace20319fe7b01d5806bc52",
                                                "_id": "6077c4efbc5f4d4df9ef2864",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d948",
                                                        "_id": "6077c4efbc5f4d4df9ef2865"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Linear Equation In Two Variables-2",
                                                "id": "5ace20319fe7b01d5806bc73",
                                                "_id": "6077c4efbc5f4d4df9ef285e",
                                                "concepts": [
                                                    {
                                                        "name": "Linear equation in two variables, Graphs of linear equation, Simultaneous equation in two variables",
                                                        "id": "5ace203b9fe7b01d5806c00c",
                                                        "_id": "6077c4efbc5f4d4df9ef2861",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839c",
                                                                "_id": "6077c4efbc5f4d4df9ef2862"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "graphical solution of simultaneous equations in two variables, method of elimination by substitution, method of elimination by equationg coefficients\nsolution of equations of form, method of elimination by comparison, method of cross multiplication",
                                                        "id": "5ace203b9fe7b01d5806c00b",
                                                        "_id": "6077c4efbc5f4d4df9ef285f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839d",
                                                                "_id": "6077c4efbc5f4d4df9ef2860"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822b",
                                                        "_id": "6077c4efbc5f4d4df9ef2863"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Indefinite Integration",
                                                "id": "5ace20319fe7b01d5806bc53",
                                                "_id": "6077c4efbc5f4d4df9ef284c",
                                                "concepts": [
                                                    {
                                                        "name": "conversion of unknown form to known form",
                                                        "id": "5ace203a9fe7b01d5806bf8a",
                                                        "_id": "6077c4efbc5f4d4df9ef285b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2b",
                                                                "_id": "6077c4efbc5f4d4df9ef285c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on partial fraction",
                                                        "id": "5ace203a9fe7b01d5806bf8b",
                                                        "_id": "6077c4efbc5f4d4df9ef2859",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2c",
                                                                "_id": "6077c4efbc5f4d4df9ef285a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Algebraic twin form, algebraic substitution, integration using complex number",
                                                        "id": "5ace203a9fe7b01d5806bf8c",
                                                        "_id": "6077c4efbc5f4d4df9ef2857",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2d",
                                                                "_id": "6077c4efbc5f4d4df9ef2858"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on by parts, e to the power x (f(x) + f`(x)) dx type",
                                                        "id": "5ace203a9fe7b01d5806bf8d",
                                                        "_id": "6077c4efbc5f4d4df9ef2855",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2e",
                                                                "_id": "6077c4efbc5f4d4df9ef2856"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on integration of irrational function",
                                                        "id": "5ace203a9fe7b01d5806bf8e",
                                                        "_id": "6077c4efbc5f4d4df9ef2853",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da2f",
                                                                "_id": "6077c4efbc5f4d4df9ef2854"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on integration of rational function",
                                                        "id": "5ace203a9fe7b01d5806bf8f",
                                                        "_id": "6077c4efbc5f4d4df9ef2851",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da30",
                                                                "_id": "6077c4efbc5f4d4df9ef2852"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on method of substitution",
                                                        "id": "5ace203a9fe7b01d5806bf90",
                                                        "_id": "6077c4efbc5f4d4df9ef284f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da31",
                                                                "_id": "6077c4efbc5f4d4df9ef2850"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Quadratic divided by quadratic, linear divided by quadratic and trigonometric substitution",
                                                        "id": "5ace203a9fe7b01d5806bf91",
                                                        "_id": "6077c4efbc5f4d4df9ef284d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da32",
                                                                "_id": "6077c4efbc5f4d4df9ef284e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d949",
                                                        "_id": "6077c4efbc5f4d4df9ef285d"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef28fa"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Moving Charges and Magnetism",
                                                "id": "5ace20329fe7b01d5806bc9e",
                                                "_id": "6077c4efbc5f4d4df9ef282d",
                                                "concepts": [
                                                    {
                                                        "name": "Ampere's circuital law and applications",
                                                        "id": "5ace203e9fe7b01d5806c11a",
                                                        "_id": "6077c4efbc5f4d4df9ef2848",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e24c",
                                                                "_id": "6077c4efbc5f4d4df9ef2849"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biot-Savart law & application",
                                                        "id": "5ace203e9fe7b01d5806c11b",
                                                        "_id": "6077c4efbc5f4d4df9ef2846",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e24d",
                                                                "_id": "6077c4efbc5f4d4df9ef2847"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Galvanometers",
                                                        "id": "5ace203e9fe7b01d5806c11d",
                                                        "_id": "6077c4efbc5f4d4df9ef2844",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e24e",
                                                                "_id": "6077c4efbc5f4d4df9ef2845"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic force on charge particle",
                                                        "id": "5ace203e9fe7b01d5806c11f",
                                                        "_id": "6077c4efbc5f4d4df9ef2842",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e24f",
                                                                "_id": "6077c4efbc5f4d4df9ef2843"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "magnetic force on current carrying wire",
                                                        "id": "5ace203e9fe7b01d5806c120",
                                                        "_id": "6077c4efbc5f4d4df9ef2840",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e250",
                                                                "_id": "6077c4efbc5f4d4df9ef2841"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motion of charged particles in combined field",
                                                        "id": "5ace203e9fe7b01d5806c122",
                                                        "_id": "6077c4efbc5f4d4df9ef283e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e251",
                                                                "_id": "6077c4efbc5f4d4df9ef283f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "potential energy of current carrying loop",
                                                        "id": "5ace203e9fe7b01d5806c123",
                                                        "_id": "6077c4efbc5f4d4df9ef283c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e252",
                                                                "_id": "6077c4efbc5f4d4df9ef283d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "torque on a current carrying loop",
                                                        "id": "5ace203e9fe7b01d5806c124",
                                                        "_id": "6077c4efbc5f4d4df9ef283a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e253",
                                                                "_id": "6077c4efbc5f4d4df9ef283b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic Force ",
                                                        "id": "5eeb62320a45db222dd12d1d",
                                                        "_id": "6077c4efbc5f4d4df9ef2838",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e254",
                                                                "_id": "6077c4efbc5f4d4df9ef2839"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Moving coil galvanometer",
                                                        "id": "5eeb62320a45db222dd12d22",
                                                        "_id": "6077c4efbc5f4d4df9ef2836",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e255",
                                                                "_id": "6077c4efbc5f4d4df9ef2837"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ampere's Circuital Law and Force between two parallel currents",
                                                        "id": "5eeb62320a45db222dd12d20",
                                                        "_id": "6077c4efbc5f4d4df9ef2834",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e256",
                                                                "_id": "6077c4efbc5f4d4df9ef2835"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Torque on Current Loop and Magnetic Dipole",
                                                        "id": "5eeb62320a45db222dd12d21",
                                                        "_id": "6077c4efbc5f4d4df9ef2832",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e257",
                                                                "_id": "6077c4efbc5f4d4df9ef2833"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motion in a magnetic field and in combined electrical and magnetic fields",
                                                        "id": "5eeb62320a45db222dd12d1e",
                                                        "_id": "6077c4efbc5f4d4df9ef2830",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e258",
                                                                "_id": "6077c4efbc5f4d4df9ef2831"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biot-Savart Law",
                                                        "id": "5eeb62320a45db222dd12d1f",
                                                        "_id": "6077c4efbc5f4d4df9ef282e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f5f402c863d076508897df5",
                                                                "syllabusId": "5f7c38eba44fda53d316e259",
                                                                "_id": "6077c4efbc5f4d4df9ef282f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f7c3321f29da5758fc5ff96",
                                                        "_id": "6077c4efbc5f4d4df9ef284a"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Gravitation",
                                                "id": "5ace20329fe7b01d5806bcad",
                                                "_id": "6077c4efbc5f4d4df9ef2821",
                                                "concepts": [
                                                    {
                                                        "name": "Universal Law of Gravitation",
                                                        "id": "5ace20409fe7b01d5806c19a",
                                                        "_id": "6077c4efbc5f4d4df9ef282a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e6",
                                                                "_id": "6077c4efbc5f4d4df9ef282b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Planetary motion, Motion of Planets & Kepler’s laws",
                                                        "id": "5ace20409fe7b01d5806c199",
                                                        "_id": "6077c4efbc5f4d4df9ef2828",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e7",
                                                                "_id": "6077c4efbc5f4d4df9ef2829"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Orbital velocity, Time period of a Satellite",
                                                        "id": "5ace20409fe7b01d5806c198",
                                                        "_id": "6077c4efbc5f4d4df9ef2826",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e8",
                                                                "_id": "6077c4efbc5f4d4df9ef2827"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Escape Velocity",
                                                        "id": "5ace20409fe7b01d5806c197",
                                                        "_id": "6077c4efbc5f4d4df9ef2824",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83e9",
                                                                "_id": "6077c4efbc5f4d4df9ef2825"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Acceleration due to gravity (g) & Variation of g and Types of Variation",
                                                        "id": "5ace20409fe7b01d5806c196",
                                                        "_id": "6077c4efbc5f4d4df9ef2822",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ea",
                                                                "_id": "6077c4efbc5f4d4df9ef2823"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823a",
                                                        "_id": "6077c4efbc5f4d4df9ef282c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "EMI & AC",
                                                "id": "5ace20329fe7b01d5806bc9d",
                                                "_id": "6077c4efbc5f4d4df9ef2801",
                                                "concepts": [
                                                    {
                                                        "name": "Alternating current and its properties",
                                                        "id": "5ace203e9fe7b01d5806c10b",
                                                        "_id": "6077c4efbc5f4d4df9ef281e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dda9",
                                                                "_id": "6077c4efbc5f4d4df9ef281f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Faraday's law & Lenz's Law",
                                                        "id": "5ace203e9fe7b01d5806c10c",
                                                        "_id": "6077c4efbc5f4d4df9ef281c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddaa",
                                                                "_id": "6077c4efbc5f4d4df9ef281d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Induced electric field",
                                                        "id": "5ace203e9fe7b01d5806c10d",
                                                        "_id": "6077c4efbc5f4d4df9ef281a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddab",
                                                                "_id": "6077c4efbc5f4d4df9ef281b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Inductance - self and mutual",
                                                        "id": "5ace203e9fe7b01d5806c10e",
                                                        "_id": "6077c4efbc5f4d4df9ef2818",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddac",
                                                                "_id": "6077c4efbc5f4d4df9ef2819"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "inductor based circuit",
                                                        "id": "5ace203e9fe7b01d5806c10f",
                                                        "_id": "6077c4efbc5f4d4df9ef2816",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddad",
                                                                "_id": "6077c4efbc5f4d4df9ef2817"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "LCR based circuits",
                                                        "id": "5ace203e9fe7b01d5806c110",
                                                        "_id": "6077c4efbc5f4d4df9ef2814",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddae",
                                                                "_id": "6077c4efbc5f4d4df9ef2815"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "LR based circuits",
                                                        "id": "5ace203e9fe7b01d5806c111",
                                                        "_id": "6077c4efbc5f4d4df9ef2812",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddaf",
                                                                "_id": "6077c4efbc5f4d4df9ef2813"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "magnetic flux",
                                                        "id": "5ace203e9fe7b01d5806c112",
                                                        "_id": "6077c4efbc5f4d4df9ef2810",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb0",
                                                                "_id": "6077c4efbc5f4d4df9ef2811"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motional emf",
                                                        "id": "5ace203e9fe7b01d5806c113",
                                                        "_id": "6077c4efbc5f4d4df9ef280e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb1",
                                                                "_id": "6077c4efbc5f4d4df9ef280f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parallel circuits and Wheatstone Bridge",
                                                        "id": "5ace203e9fe7b01d5806c114",
                                                        "_id": "6077c4efbc5f4d4df9ef280c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb2",
                                                                "_id": "6077c4efbc5f4d4df9ef280d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Power & Resonance in AC",
                                                        "id": "5ace203e9fe7b01d5806c115",
                                                        "_id": "6077c4efbc5f4d4df9ef280a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb3",
                                                                "_id": "6077c4efbc5f4d4df9ef280b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Study of motion of conductors in a magnetic field when currents are induced",
                                                        "id": "5ace203e9fe7b01d5806c116",
                                                        "_id": "6077c4efbc5f4d4df9ef2808",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb4",
                                                                "_id": "6077c4efbc5f4d4df9ef2809"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Time varying magnetic field",
                                                        "id": "5ace203e9fe7b01d5806c117",
                                                        "_id": "6077c4efbc5f4d4df9ef2806",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb5",
                                                                "_id": "6077c4efbc5f4d4df9ef2807"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Torque experienced by the particle kept in magnetic field",
                                                        "id": "5ace203e9fe7b01d5806c118",
                                                        "_id": "6077c4efbc5f4d4df9ef2804",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb6",
                                                                "_id": "6077c4efbc5f4d4df9ef2805"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transformer and choke coil",
                                                        "id": "5ace203e9fe7b01d5806c119",
                                                        "_id": "6077c4efbc5f4d4df9ef2802",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb7",
                                                                "_id": "6077c4efbc5f4d4df9ef2803"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd5d",
                                                        "_id": "6077c4efbc5f4d4df9ef2820"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Fluid",
                                                "id": "5ace20329fe7b01d5806bcac",
                                                "_id": "6077c4efbc5f4d4df9ef27f7",
                                                "concepts": [
                                                    {
                                                        "name": "Pressure, Atmospheric Pressure & Relative density",
                                                        "id": "5ace20409fe7b01d5806c193",
                                                        "_id": "6077c4efbc5f4d4df9ef27fe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83eb",
                                                                "_id": "6077c4efbc5f4d4df9ef27ff"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Variation of pressure with depth & Pascal Law",
                                                        "id": "5ace20409fe7b01d5806c195",
                                                        "_id": "6077c4efbc5f4d4df9ef27fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ec",
                                                                "_id": "6077c4efbc5f4d4df9ef27fd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Upthrust/buyont force & Laws of floatation",
                                                        "id": "5ace20409fe7b01d5806c194",
                                                        "_id": "6077c4efbc5f4d4df9ef27fa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ed",
                                                                "_id": "6077c4efbc5f4d4df9ef27fb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Archimedes Principle",
                                                        "id": "5ace20409fe7b01d5806c192",
                                                        "_id": "6077c4efbc5f4d4df9ef27f8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ee",
                                                                "_id": "6077c4efbc5f4d4df9ef27f9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823b",
                                                        "_id": "6077c4efbc5f4d4df9ef2800"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Magnetics",
                                                "id": "5ace20329fe7b01d5806bc9e",
                                                "_id": "6077c4efbc5f4d4df9ef27df",
                                                "concepts": [
                                                    {
                                                        "name": "Ampere's circuital law and applications",
                                                        "id": "5ace203e9fe7b01d5806c11a",
                                                        "_id": "6077c4efbc5f4d4df9ef27f4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb8",
                                                                "_id": "6077c4efbc5f4d4df9ef27f5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biot-Savart law & application",
                                                        "id": "5ace203e9fe7b01d5806c11b",
                                                        "_id": "6077c4efbc5f4d4df9ef27f2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddb9",
                                                                "_id": "6077c4efbc5f4d4df9ef27f3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Earth magnetism",
                                                        "id": "5ace203e9fe7b01d5806c11c",
                                                        "_id": "6077c4efbc5f4d4df9ef27f0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddba",
                                                                "_id": "6077c4efbc5f4d4df9ef27f1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Galvanometers",
                                                        "id": "5ace203e9fe7b01d5806c11d",
                                                        "_id": "6077c4efbc5f4d4df9ef27ee",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddbb",
                                                                "_id": "6077c4efbc5f4d4df9ef27ef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnet and its properties",
                                                        "id": "5ace203e9fe7b01d5806c11e",
                                                        "_id": "6077c4efbc5f4d4df9ef27ec",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddbc",
                                                                "_id": "6077c4efbc5f4d4df9ef27ed"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic force on charge particle",
                                                        "id": "5ace203e9fe7b01d5806c11f",
                                                        "_id": "6077c4efbc5f4d4df9ef27ea",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddbd",
                                                                "_id": "6077c4efbc5f4d4df9ef27eb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "magnetic force on current carrying wire",
                                                        "id": "5ace203e9fe7b01d5806c120",
                                                        "_id": "6077c4efbc5f4d4df9ef27e8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddbe",
                                                                "_id": "6077c4efbc5f4d4df9ef27e9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic properties of material",
                                                        "id": "5ace203e9fe7b01d5806c121",
                                                        "_id": "6077c4efbc5f4d4df9ef27e6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddbf",
                                                                "_id": "6077c4efbc5f4d4df9ef27e7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motion of charged particles in combined field",
                                                        "id": "5ace203e9fe7b01d5806c122",
                                                        "_id": "6077c4efbc5f4d4df9ef27e4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc0",
                                                                "_id": "6077c4efbc5f4d4df9ef27e5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "potential energy of current carrying loop",
                                                        "id": "5ace203e9fe7b01d5806c123",
                                                        "_id": "6077c4efbc5f4d4df9ef27e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc1",
                                                                "_id": "6077c4efbc5f4d4df9ef27e3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "torque on a current carrying loop",
                                                        "id": "5ace203e9fe7b01d5806c124",
                                                        "_id": "6077c4efbc5f4d4df9ef27e0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc2",
                                                                "_id": "6077c4efbc5f4d4df9ef27e1"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd5e",
                                                        "_id": "6077c4efbc5f4d4df9ef27f6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Work, Energy & Power",
                                                "id": "5ace20329fe7b01d5806bcb5",
                                                "_id": "6077c4efbc5f4d4df9ef27d1",
                                                "concepts": [
                                                    {
                                                        "name": "Work done",
                                                        "id": "5ace20419fe7b01d5806c1d0",
                                                        "_id": "6077c4efbc5f4d4df9ef27dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ef",
                                                                "_id": "6077c4efbc5f4d4df9ef27dd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Energy & Different forms of energy",
                                                        "id": "5ace20419fe7b01d5806c1cd",
                                                        "_id": "6077c4efbc5f4d4df9ef27da",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f0",
                                                                "_id": "6077c4efbc5f4d4df9ef27db"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Potential energy & Kinetic energy",
                                                        "id": "5ace20419fe7b01d5806c1cf",
                                                        "_id": "6077c4efbc5f4d4df9ef27d8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f1",
                                                                "_id": "6077c4efbc5f4d4df9ef27d9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kinetic energy and Momentum",
                                                        "id": "5ace20419fe7b01d5806c1ce",
                                                        "_id": "6077c4efbc5f4d4df9ef27d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f2",
                                                                "_id": "6077c4efbc5f4d4df9ef27d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Work energy theorem",
                                                        "id": "5ace20419fe7b01d5806c1d1",
                                                        "_id": "6077c4efbc5f4d4df9ef27d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f3",
                                                                "_id": "6077c4efbc5f4d4df9ef27d5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conservation of energy",
                                                        "id": "5ace20419fe7b01d5806c1cc",
                                                        "_id": "6077c4efbc5f4d4df9ef27d2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f4",
                                                                "_id": "6077c4efbc5f4d4df9ef27d3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823c",
                                                        "_id": "6077c4efbc5f4d4df9ef27de"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef284b"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Coding Decoding",
                                                "id": "5ace20309fe7b01d5806bc24",
                                                "_id": "6077c4efbc5f4d4df9ef27cc",
                                                "concepts": [
                                                    {
                                                        "name": "Coding Decoding",
                                                        "id": "5ace20389fe7b01d5806bf12",
                                                        "_id": "6077c4efbc5f4d4df9ef27cd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8424",
                                                                "_id": "6077c4efbc5f4d4df9ef27ce"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8246",
                                                        "_id": "6077c4efbc5f4d4df9ef27cf"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Alphabet Test",
                                                "id": "5ace20309fe7b01d5806bc1d",
                                                "_id": "6077c4efbc5f4d4df9ef27c8",
                                                "concepts": [
                                                    {
                                                        "name": "Alphabet Test",
                                                        "id": "5ace20389fe7b01d5806bf0b",
                                                        "_id": "6077c4efbc5f4d4df9ef27c9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8425",
                                                                "_id": "6077c4efbc5f4d4df9ef27ca"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8247",
                                                        "_id": "6077c4efbc5f4d4df9ef27cb"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Direction Sense Test",
                                                "id": "5ace20309fe7b01d5806bc28",
                                                "_id": "6077c4efbc5f4d4df9ef27c4",
                                                "concepts": [
                                                    {
                                                        "name": "Direction Sense Test",
                                                        "id": "5ace20389fe7b01d5806bf18",
                                                        "_id": "6077c4efbc5f4d4df9ef27c5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8426",
                                                                "_id": "6077c4efbc5f4d4df9ef27c6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8248",
                                                        "_id": "6077c4efbc5f4d4df9ef27c7"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef27d0"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Population",
                                                "id": "5ace20329fe7b01d5806bcce",
                                                "_id": "6077c4efbc5f4d4df9ef27bd",
                                                "concepts": [
                                                    {
                                                        "name": "Factors of populatin growth.",
                                                        "id": "5ace20419fe7b01d5806c205",
                                                        "_id": "6077c4efbc5f4d4df9ef27c0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845d",
                                                                "_id": "6077c4efbc5f4d4df9ef27c1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different categories of population.",
                                                        "id": "5ace20419fe7b01d5806c204",
                                                        "_id": "6077c4efbc5f4d4df9ef27be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845e",
                                                                "_id": "6077c4efbc5f4d4df9ef27bf"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826d",
                                                        "_id": "6077c4efbc5f4d4df9ef27c2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Resources and Development",
                                                "id": "5ace20329fe7b01d5806bccf",
                                                "_id": "6077c4efbc5f4d4df9ef27b7",
                                                "concepts": [
                                                    {
                                                        "name": "Different types of resources.",
                                                        "id": "5ace20419fe7b01d5806c206",
                                                        "_id": "6077c4efbc5f4d4df9ef27ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c845f",
                                                                "_id": "6077c4efbc5f4d4df9ef27bb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Steps of resource conservation.",
                                                        "id": "5ace20419fe7b01d5806c207",
                                                        "_id": "6077c4efbc5f4d4df9ef27b8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8460",
                                                                "_id": "6077c4efbc5f4d4df9ef27b9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826e",
                                                        "_id": "6077c4efbc5f4d4df9ef27bc"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Forest and Wildlife Resources",
                                                "id": "5ace20329fe7b01d5806bcc7",
                                                "_id": "6077c4efbc5f4d4df9ef27b1",
                                                "concepts": [
                                                    {
                                                        "name": "Contribution of forests.",
                                                        "id": "5ace20419fe7b01d5806c1fb",
                                                        "_id": "6077c4efbc5f4d4df9ef27b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8461",
                                                                "_id": "6077c4efbc5f4d4df9ef27b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Causes of deforestation & the steps of the forests conservation",
                                                        "id": "5ace20419fe7b01d5806c1fa",
                                                        "_id": "6077c4efbc5f4d4df9ef27b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8462",
                                                                "_id": "6077c4efbc5f4d4df9ef27b3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c826f",
                                                        "_id": "6077c4efbc5f4d4df9ef27b6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Water Resources",
                                                "id": "5ace20329fe7b01d5806bcd0",
                                                "_id": "6077c4efbc5f4d4df9ef27ad",
                                                "concepts": [
                                                    {
                                                        "name": "Water, scarecity & conservation",
                                                        "id": "5ace20419fe7b01d5806c208",
                                                        "_id": "6077c4efbc5f4d4df9ef27ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8463",
                                                                "_id": "6077c4efbc5f4d4df9ef27af"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8270",
                                                        "_id": "6077c4efbc5f4d4df9ef27b0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Agriculture",
                                                "id": "5ace20329fe7b01d5806bcc4",
                                                "_id": "6077c4efbc5f4d4df9ef27a7",
                                                "concepts": [
                                                    {
                                                        "name": "Types of agriculture.",
                                                        "id": "5ace20419fe7b01d5806c1f5",
                                                        "_id": "6077c4efbc5f4d4df9ef27aa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8464",
                                                                "_id": "6077c4efbc5f4d4df9ef27ab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different types of crops.",
                                                        "id": "5ace20419fe7b01d5806c1f4",
                                                        "_id": "6077c4efbc5f4d4df9ef27a8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8465",
                                                                "_id": "6077c4efbc5f4d4df9ef27a9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8271",
                                                        "_id": "6077c4efbc5f4d4df9ef27ac"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef27c3"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Chart Logic",
                                                "id": "5ace20309fe7b01d5806bc14",
                                                "_id": "6077c4efbc5f4d4df9ef27a2",
                                                "concepts": [
                                                    {
                                                        "name": "Inserting missing character",
                                                        "id": "5ace20389fe7b01d5806befc",
                                                        "_id": "6077c4efbc5f4d4df9ef27a3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df41",
                                                                "_id": "6077c4efbc5f4d4df9ef27a4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df35",
                                                        "_id": "6077c4efbc5f4d4df9ef27a5"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef27a6"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 3,
                                "startDate": "2021-05-10T00:00:00.000Z",
                                "endDate": "2021-05-16T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef2603",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Diversity in living organism",
                                                "id": "5ace202f9fe7b01d5806bbbc",
                                                "_id": "6077c4efbc5f4d4df9ef2764",
                                                "concepts": [
                                                    {
                                                        "name": "Taxonomy",
                                                        "id": "5ace20339fe7b01d5806bd17",
                                                        "_id": "6077c4efbc5f4d4df9ef279d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82af",
                                                                "_id": "6077c4efbc5f4d4df9ef279e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Binomial nomenclature",
                                                        "id": "5ace20339fe7b01d5806bd03",
                                                        "_id": "6077c4efbc5f4d4df9ef279b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b0",
                                                                "_id": "6077c4efbc5f4d4df9ef279c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types of classification",
                                                        "id": "5ace20339fe7b01d5806bd19",
                                                        "_id": "6077c4efbc5f4d4df9ef2799",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b1",
                                                                "_id": "6077c4efbc5f4d4df9ef279a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kingdom Monera",
                                                        "id": "5ace20339fe7b01d5806bd0c",
                                                        "_id": "6077c4efbc5f4d4df9ef2797",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b2",
                                                                "_id": "6077c4efbc5f4d4df9ef2798"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kingdom Protista",
                                                        "id": "5ace20339fe7b01d5806bd0e",
                                                        "_id": "6077c4efbc5f4d4df9ef2795",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b3",
                                                                "_id": "6077c4efbc5f4d4df9ef2796"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kingdom Fungi",
                                                        "id": "5ace20339fe7b01d5806bd0b",
                                                        "_id": "6077c4efbc5f4d4df9ef2793",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b4",
                                                                "_id": "6077c4efbc5f4d4df9ef2794"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kingdom Plantae",
                                                        "id": "5ace20339fe7b01d5806bd0d",
                                                        "_id": "6077c4efbc5f4d4df9ef2791",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b5",
                                                                "_id": "6077c4efbc5f4d4df9ef2792"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Thallophyta",
                                                        "id": "5ace20339fe7b01d5806bd18",
                                                        "_id": "6077c4efbc5f4d4df9ef278f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b6",
                                                                "_id": "6077c4efbc5f4d4df9ef2790"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bryophyta",
                                                        "id": "5ace20339fe7b01d5806bd04",
                                                        "_id": "6077c4efbc5f4d4df9ef278d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b7",
                                                                "_id": "6077c4efbc5f4d4df9ef278e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pteridophyta",
                                                        "id": "5ace20339fe7b01d5806bd15",
                                                        "_id": "6077c4efbc5f4d4df9ef278b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b8",
                                                                "_id": "6077c4efbc5f4d4df9ef278c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gymnosperm",
                                                        "id": "5ace20339fe7b01d5806bd08",
                                                        "_id": "6077c4efbc5f4d4df9ef2789",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82b9",
                                                                "_id": "6077c4efbc5f4d4df9ef278a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Angiosperm",
                                                        "id": "5ace20329fe7b01d5806bcfe",
                                                        "_id": "6077c4efbc5f4d4df9ef2787",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ba",
                                                                "_id": "6077c4efbc5f4d4df9ef2788"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kingdom Animalia",
                                                        "id": "5ace20339fe7b01d5806bd0a",
                                                        "_id": "6077c4efbc5f4d4df9ef2785",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82bb",
                                                                "_id": "6077c4efbc5f4d4df9ef2786"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Porifera",
                                                        "id": "5ace20339fe7b01d5806bd13",
                                                        "_id": "6077c4efbc5f4d4df9ef2783",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82bc",
                                                                "_id": "6077c4efbc5f4d4df9ef2784"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coelenterata or Cnidaria",
                                                        "id": "5ace20339fe7b01d5806bd06",
                                                        "_id": "6077c4efbc5f4d4df9ef2781",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82bd",
                                                                "_id": "6077c4efbc5f4d4df9ef2782"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Platyhelminthes",
                                                        "id": "5ace20339fe7b01d5806bd12",
                                                        "_id": "6077c4efbc5f4d4df9ef277f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82be",
                                                                "_id": "6077c4efbc5f4d4df9ef2780"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Aschelminthes",
                                                        "id": "5ace20339fe7b01d5806bd01",
                                                        "_id": "6077c4efbc5f4d4df9ef277d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82bf",
                                                                "_id": "6077c4efbc5f4d4df9ef277e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Annelida",
                                                        "id": "5ace20329fe7b01d5806bcff",
                                                        "_id": "6077c4efbc5f4d4df9ef277b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c0",
                                                                "_id": "6077c4efbc5f4d4df9ef277c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Arthropoda",
                                                        "id": "5ace20329fe7b01d5806bd00",
                                                        "_id": "6077c4efbc5f4d4df9ef2779",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c1",
                                                                "_id": "6077c4efbc5f4d4df9ef277a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mollusca",
                                                        "id": "5ace20339fe7b01d5806bd10",
                                                        "_id": "6077c4efbc5f4d4df9ef2777",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c2",
                                                                "_id": "6077c4efbc5f4d4df9ef2778"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Echinodermata",
                                                        "id": "5ace20339fe7b01d5806bd07",
                                                        "_id": "6077c4efbc5f4d4df9ef2775",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c3",
                                                                "_id": "6077c4efbc5f4d4df9ef2776"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Hemichordata",
                                                        "id": "5ace20339fe7b01d5806bd09",
                                                        "_id": "6077c4efbc5f4d4df9ef2773",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c4",
                                                                "_id": "6077c4efbc5f4d4df9ef2774"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Protochordata",
                                                        "id": "5ace20339fe7b01d5806bd14",
                                                        "_id": "6077c4efbc5f4d4df9ef2771",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c5",
                                                                "_id": "6077c4efbc5f4d4df9ef2772"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chordata",
                                                        "id": "5ace20339fe7b01d5806bd05",
                                                        "_id": "6077c4efbc5f4d4df9ef276f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c6",
                                                                "_id": "6077c4efbc5f4d4df9ef2770"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pisces",
                                                        "id": "5ace20339fe7b01d5806bd11",
                                                        "_id": "6077c4efbc5f4d4df9ef276d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c7",
                                                                "_id": "6077c4efbc5f4d4df9ef276e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Amphibians",
                                                        "id": "5ace20329fe7b01d5806bcfd",
                                                        "_id": "6077c4efbc5f4d4df9ef276b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c8",
                                                                "_id": "6077c4efbc5f4d4df9ef276c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Aves",
                                                        "id": "5ace20339fe7b01d5806bd02",
                                                        "_id": "6077c4efbc5f4d4df9ef2769",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82c9",
                                                                "_id": "6077c4efbc5f4d4df9ef276a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reptilia",
                                                        "id": "5ace20339fe7b01d5806bd16",
                                                        "_id": "6077c4efbc5f4d4df9ef2767",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ca",
                                                                "_id": "6077c4efbc5f4d4df9ef2768"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mammalia",
                                                        "id": "5ace20339fe7b01d5806bd0f",
                                                        "_id": "6077c4efbc5f4d4df9ef2765",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82cb",
                                                                "_id": "6077c4efbc5f4d4df9ef2766"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8209",
                                                        "_id": "6077c4efbc5f4d4df9ef279f"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef27a0"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Atoms,Molecules & Mole Concept",
                                                "id": "5ace202f9fe7b01d5806bbc8",
                                                "_id": "6077c4efbc5f4d4df9ef274b",
                                                "concepts": [
                                                    {
                                                        "name": "Laws of Chemical Combination",
                                                        "id": "5ace20349fe7b01d5806bd83",
                                                        "_id": "6077c4efbc5f4d4df9ef2760",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8327",
                                                                "_id": "6077c4efbc5f4d4df9ef2761"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Important Terminology",
                                                        "id": "5ace20349fe7b01d5806bd81",
                                                        "_id": "6077c4efbc5f4d4df9ef275e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8328",
                                                                "_id": "6077c4efbc5f4d4df9ef275f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chemical Formula and Valency",
                                                        "id": "5ace20349fe7b01d5806bd7f",
                                                        "_id": "6077c4efbc5f4d4df9ef275c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8329",
                                                                "_id": "6077c4efbc5f4d4df9ef275d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mole Concept",
                                                        "id": "5ace20349fe7b01d5806bd86",
                                                        "_id": "6077c4efbc5f4d4df9ef275a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832a",
                                                                "_id": "6077c4efbc5f4d4df9ef275b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Percentage Composition",
                                                        "id": "5ace20349fe7b01d5806bd88",
                                                        "_id": "6077c4efbc5f4d4df9ef2758",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832b",
                                                                "_id": "6077c4efbc5f4d4df9ef2759"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Empirical and Molecular Formula",
                                                        "id": "5ace20349fe7b01d5806bd80",
                                                        "_id": "6077c4efbc5f4d4df9ef2756",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832c",
                                                                "_id": "6077c4efbc5f4d4df9ef2757"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Molarity",
                                                        "id": "5ace20349fe7b01d5806bd85",
                                                        "_id": "6077c4efbc5f4d4df9ef2754",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832d",
                                                                "_id": "6077c4efbc5f4d4df9ef2755"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Molality",
                                                        "id": "5ace20349fe7b01d5806bd84",
                                                        "_id": "6077c4efbc5f4d4df9ef2752",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832e",
                                                                "_id": "6077c4efbc5f4d4df9ef2753"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mole Fraction",
                                                        "id": "5ace20349fe7b01d5806bd87",
                                                        "_id": "6077c4efbc5f4d4df9ef2750",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c832f",
                                                                "_id": "6077c4efbc5f4d4df9ef2751"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Avogadro Hypothesis",
                                                        "id": "5ace20349fe7b01d5806bd7e",
                                                        "_id": "6077c4efbc5f4d4df9ef274e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8330",
                                                                "_id": "6077c4efbc5f4d4df9ef274f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Isotopes,Isotones and Isobars",
                                                        "id": "5ace20349fe7b01d5806bd82",
                                                        "_id": "6077c4efbc5f4d4df9ef274c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8331",
                                                                "_id": "6077c4efbc5f4d4df9ef274d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8214",
                                                        "_id": "6077c4efbc5f4d4df9ef2762"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef2763"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Quadratic Equations",
                                                "id": "5ace20319fe7b01d5806bc7a",
                                                "_id": "6077c4efbc5f4d4df9ef2740",
                                                "concepts": [
                                                    {
                                                        "name": "Quadratic polynomials, Solution of Quadratic equations by method of factorisation, solution of quadratic equations by method of completion of squares",
                                                        "id": "5ace203c9fe7b01d5806c026",
                                                        "_id": "6077c4efbc5f4d4df9ef2747",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839e",
                                                                "_id": "6077c4efbc5f4d4df9ef2748"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relation between roots and coeffficients of Quadratic",
                                                        "id": "5ace203c9fe7b01d5806c027",
                                                        "_id": "6077c4efbc5f4d4df9ef2745",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c839f",
                                                                "_id": "6077c4efbc5f4d4df9ef2746"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Discriminant based questions",
                                                        "id": "5ace203c9fe7b01d5806c024",
                                                        "_id": "6077c4efbc5f4d4df9ef2743",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a0",
                                                                "_id": "6077c4efbc5f4d4df9ef2744"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nature of roots",
                                                        "id": "5ace203c9fe7b01d5806c025",
                                                        "_id": "6077c4efbc5f4d4df9ef2741",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a1",
                                                                "_id": "6077c4efbc5f4d4df9ef2742"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822c",
                                                        "_id": "6077c4efbc5f4d4df9ef2749"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Limit of the function",
                                                "id": "5ace20319fe7b01d5806bc54",
                                                "_id": "6077c4efbc5f4d4df9ef273e",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94a",
                                                        "_id": "6077c4efbc5f4d4df9ef273f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Arithmetic Progressions",
                                                "id": "5ace20319fe7b01d5806bc6b",
                                                "_id": "6077c4efbc5f4d4df9ef2736",
                                                "concepts": [
                                                    {
                                                        "name": "Definition, nth term from start, nth term from end",
                                                        "id": "5ace203b9fe7b01d5806bffa",
                                                        "_id": "6077c4efbc5f4d4df9ef273b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a2",
                                                                "_id": "6077c4efbc5f4d4df9ef273c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Selection of terms in an AP, sum of first n terms of an AP",
                                                        "id": "5ace203b9fe7b01d5806bffb",
                                                        "_id": "6077c4efbc5f4d4df9ef2739",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a3",
                                                                "_id": "6077c4efbc5f4d4df9ef273a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Word problems",
                                                        "id": "5ace203b9fe7b01d5806bffc",
                                                        "_id": "6077c4efbc5f4d4df9ef2737",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a4",
                                                                "_id": "6077c4efbc5f4d4df9ef2738"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822d",
                                                        "_id": "6077c4efbc5f4d4df9ef273d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Limit of the function",
                                                "id": "5ace20319fe7b01d5806bc55",
                                                "_id": "6077c4efbc5f4d4df9ef2718",
                                                "concepts": [
                                                    {
                                                        "name": "Application of series to find the limits of a function",
                                                        "id": "5ace203a9fe7b01d5806bf92",
                                                        "_id": "6077c4efbc5f4d4df9ef2733",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da33",
                                                                "_id": "6077c4efbc5f4d4df9ef2734"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limits of Exponential functions",
                                                        "id": "5ace203a9fe7b01d5806bf93",
                                                        "_id": "6077c4efbc5f4d4df9ef2731",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da34",
                                                                "_id": "6077c4efbc5f4d4df9ef2732"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limits of Logarithmic functions",
                                                        "id": "5ace203a9fe7b01d5806bf94",
                                                        "_id": "6077c4efbc5f4d4df9ef272f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da35",
                                                                "_id": "6077c4efbc5f4d4df9ef2730"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limits of Trigonometrical function",
                                                        "id": "5ace203a9fe7b01d5806bf95",
                                                        "_id": "6077c4efbc5f4d4df9ef272d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da36",
                                                                "_id": "6077c4efbc5f4d4df9ef272e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Max. value and MIn. value of a function using limit",
                                                        "id": "5ace203a9fe7b01d5806bf96",
                                                        "_id": "6077c4efbc5f4d4df9ef272b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da37",
                                                                "_id": "6077c4efbc5f4d4df9ef272c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Method of Direct substitution to find the limit",
                                                        "id": "5ace203a9fe7b01d5806bf97",
                                                        "_id": "6077c4efbc5f4d4df9ef2729",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da38",
                                                                "_id": "6077c4efbc5f4d4df9ef272a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Method of Rationalization to find the limit",
                                                        "id": "5ace203a9fe7b01d5806bf98",
                                                        "_id": "6077c4efbc5f4d4df9ef2727",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da39",
                                                                "_id": "6077c4efbc5f4d4df9ef2728"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on 1 to power infinity form, function power function form",
                                                        "id": "5ace203a9fe7b01d5806bf99",
                                                        "_id": "6077c4efbc5f4d4df9ef2725",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3a",
                                                                "_id": "6077c4efbc5f4d4df9ef2726"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on existance of limits, LHL and RHL",
                                                        "id": "5ace203a9fe7b01d5806bf9a",
                                                        "_id": "6077c4efbc5f4d4df9ef2723",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3b",
                                                                "_id": "6077c4efbc5f4d4df9ef2724"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on L hospital rule",
                                                        "id": "5ace203a9fe7b01d5806bf9b",
                                                        "_id": "6077c4efbc5f4d4df9ef2721",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3c",
                                                                "_id": "6077c4efbc5f4d4df9ef2722"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Limit of composite functions and sandwitz theorem",
                                                        "id": "5ace203a9fe7b01d5806bf9c",
                                                        "_id": "6077c4efbc5f4d4df9ef271f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3d",
                                                                "_id": "6077c4efbc5f4d4df9ef2720"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on limits of the form x approaches infinity",
                                                        "id": "5ace203a9fe7b01d5806bf9d",
                                                        "_id": "6077c4efbc5f4d4df9ef271d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3e",
                                                                "_id": "6077c4efbc5f4d4df9ef271e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on Newton Lebnitz rule",
                                                        "id": "5ace203a9fe7b01d5806bf9e",
                                                        "_id": "6077c4efbc5f4d4df9ef271b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da3f",
                                                                "_id": "6077c4efbc5f4d4df9ef271c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on standard results",
                                                        "id": "5ace203a9fe7b01d5806bf9f",
                                                        "_id": "6077c4efbc5f4d4df9ef2719",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da40",
                                                                "_id": "6077c4efbc5f4d4df9ef271a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94b",
                                                        "_id": "6077c4efbc5f4d4df9ef2735"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Similar Triangles",
                                                "id": "5ace20319fe7b01d5806bc7d",
                                                "_id": "6077c4efbc5f4d4df9ef2710",
                                                "concepts": [
                                                    {
                                                        "name": "Basic proportionality theorem and converse, AAA similarity criterion, Sss similarity criterion, SAS similarity criterion, Area of two similar triangles",
                                                        "id": "5ace203c9fe7b01d5806c02e",
                                                        "_id": "6077c4efbc5f4d4df9ef2715",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a5",
                                                                "_id": "6077c4efbc5f4d4df9ef2716"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pythagoras theorem, Vertical angle base for theorem",
                                                        "id": "5ace203c9fe7b01d5806c030",
                                                        "_id": "6077c4efbc5f4d4df9ef2713",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a6",
                                                                "_id": "6077c4efbc5f4d4df9ef2714"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of two similar triangles, Converse of Pythagoras theorem",
                                                        "id": "5ace203c9fe7b01d5806c02f",
                                                        "_id": "6077c4efbc5f4d4df9ef2711",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a7",
                                                                "_id": "6077c4efbc5f4d4df9ef2712"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822e",
                                                        "_id": "6077c4efbc5f4d4df9ef2717"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Basic Calculus",
                                                "id": "5bab788738234f74bfb65ff5",
                                                "_id": "6077c4efbc5f4d4df9ef2708",
                                                "concepts": [
                                                    {
                                                        "name": "Integration",
                                                        "id": "5bab79b238234f74bfb6600f",
                                                        "_id": "6077c4efbc5f4d4df9ef270d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da41",
                                                                "_id": "6077c4efbc5f4d4df9ef270e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiation",
                                                        "id": "5bab79c138234f74bfb66010",
                                                        "_id": "6077c4efbc5f4d4df9ef270b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da42",
                                                                "_id": "6077c4efbc5f4d4df9ef270c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Definite Integration",
                                                        "id": "5bab79d038234f74bfb66012",
                                                        "_id": "6077c4efbc5f4d4df9ef2709",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da43",
                                                                "_id": "6077c4efbc5f4d4df9ef270a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94c",
                                                        "_id": "6077c4efbc5f4d4df9ef270f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Tangents to a Circle",
                                                "id": "5ace20319fe7b01d5806bc82",
                                                "_id": "6077c4efbc5f4d4df9ef2700",
                                                "concepts": [
                                                    {
                                                        "name": "Tangents to a circle from a point, Properties of tangents",
                                                        "id": "5ace203c9fe7b01d5806c04e",
                                                        "_id": "6077c4efbc5f4d4df9ef2705",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a8",
                                                                "_id": "6077c4efbc5f4d4df9ef2706"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Intersection of chords, Alternate segment, Two circles in a plane, Common tangent",
                                                        "id": "5ace203c9fe7b01d5806c04d",
                                                        "_id": "6077c4efbc5f4d4df9ef2703",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83a9",
                                                                "_id": "6077c4efbc5f4d4df9ef2704"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Central angle and arcs, Congruence of circles and arcs, Angles subtended by arcs and chords at points on the circle",
                                                        "id": "5ace203c9fe7b01d5806c04c",
                                                        "_id": "6077c4efbc5f4d4df9ef2701",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83aa",
                                                                "_id": "6077c4efbc5f4d4df9ef2702"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c822f",
                                                        "_id": "6077c4efbc5f4d4df9ef2707"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Complex Number",
                                                "id": "5ace20319fe7b01d5806bc56",
                                                "_id": "6077c4efbc5f4d4df9ef26fc",
                                                "concepts": [
                                                    {
                                                        "name": "Intersection of a straight line and circle on Argand plane",
                                                        "id": "5ace203a9fe7b01d5806bfa0",
                                                        "_id": "6077c4efbc5f4d4df9ef26fd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da44",
                                                                "_id": "6077c4efbc5f4d4df9ef26fe"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94d",
                                                        "_id": "6077c4efbc5f4d4df9ef26ff"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Constructions - 2",
                                                "id": "5ace20319fe7b01d5806bc6d",
                                                "_id": "6077c4efbc5f4d4df9ef26f8",
                                                "concepts": [
                                                    {
                                                        "name": "Circle construction, Circle line intersection constructions, Division of a line segment in a given ratio, Construction of tangents to a circle from a point when centre of circle is known, Construction of common tangents to two given circles, Construction of Circumcircle and incircle of a triangle",
                                                        "id": "5ace203b9fe7b01d5806c000",
                                                        "_id": "6077c4efbc5f4d4df9ef26f9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ab",
                                                                "_id": "6077c4efbc5f4d4df9ef26fa"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8230",
                                                        "_id": "6077c4efbc5f4d4df9ef26fb"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Circle",
                                                "id": "5ace20319fe7b01d5806bc57",
                                                "_id": "6077c4efbc5f4d4df9ef26f6",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94e",
                                                        "_id": "6077c4efbc5f4d4df9ef26f7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Surface Area and Volume - 2",
                                                "id": "5ace20319fe7b01d5806bc81",
                                                "_id": "6077c4efbc5f4d4df9ef26e2",
                                                "concepts": [
                                                    {
                                                        "name": "Cuboid",
                                                        "id": "5ace203c9fe7b01d5806c046",
                                                        "_id": "6077c4efbc5f4d4df9ef26f3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ac",
                                                                "_id": "6077c4efbc5f4d4df9ef26f4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cube",
                                                        "id": "5ace203c9fe7b01d5806c045",
                                                        "_id": "6077c4efbc5f4d4df9ef26f1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ad",
                                                                "_id": "6077c4efbc5f4d4df9ef26f2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Right Prism & Right Prism",
                                                        "id": "5ace203c9fe7b01d5806c04a",
                                                        "_id": "6077c4efbc5f4d4df9ef26ef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ae",
                                                                "_id": "6077c4efbc5f4d4df9ef26f0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Right Circular Cylinder",
                                                        "id": "5ace203c9fe7b01d5806c049",
                                                        "_id": "6077c4efbc5f4d4df9ef26ed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83af",
                                                                "_id": "6077c4efbc5f4d4df9ef26ee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Right Circular Cone",
                                                        "id": "5ace203c9fe7b01d5806c048",
                                                        "_id": "6077c4efbc5f4d4df9ef26eb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b0",
                                                                "_id": "6077c4efbc5f4d4df9ef26ec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sphere, Hemisphere",
                                                        "id": "5ace203c9fe7b01d5806c04b",
                                                        "_id": "6077c4efbc5f4d4df9ef26e9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b1",
                                                                "_id": "6077c4efbc5f4d4df9ef26ea"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conversion of a solid into another",
                                                        "id": "5ace203c9fe7b01d5806c044",
                                                        "_id": "6077c4efbc5f4d4df9ef26e7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b2",
                                                                "_id": "6077c4efbc5f4d4df9ef26e8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Combination of Solids",
                                                        "id": "5ace203c9fe7b01d5806c043",
                                                        "_id": "6077c4efbc5f4d4df9ef26e5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b3",
                                                                "_id": "6077c4efbc5f4d4df9ef26e6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Frustum of a Right Circular Cone",
                                                        "id": "5ace203c9fe7b01d5806c047",
                                                        "_id": "6077c4efbc5f4d4df9ef26e3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b4",
                                                                "_id": "6077c4efbc5f4d4df9ef26e4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8231",
                                                        "_id": "6077c4efbc5f4d4df9ef26f5"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Circle",
                                                "id": "5ace20319fe7b01d5806bc58",
                                                "_id": "6077c4efbc5f4d4df9ef26ca",
                                                "concepts": [
                                                    {
                                                        "name": "Angle between two circles and condition for orthogonal intersection",
                                                        "id": "5ace203a9fe7b01d5806bfa1",
                                                        "_id": "6077c4efbc5f4d4df9ef26df",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da45",
                                                                "_id": "6077c4efbc5f4d4df9ef26e0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chord of contact, equation of chord in mid-point form",
                                                        "id": "5ace203a9fe7b01d5806bfa2",
                                                        "_id": "6077c4efbc5f4d4df9ef26dd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da46",
                                                                "_id": "6077c4efbc5f4d4df9ef26de"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of common tangent and their length, equation of common chord",
                                                        "id": "5ace203a9fe7b01d5806bfa3",
                                                        "_id": "6077c4efbc5f4d4df9ef26db",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da47",
                                                                "_id": "6077c4efbc5f4d4df9ef26dc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of tangent in various form",
                                                        "id": "5ace203a9fe7b01d5806bfa4",
                                                        "_id": "6077c4efbc5f4d4df9ef26d9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da48",
                                                                "_id": "6077c4efbc5f4d4df9ef26da"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Family of circles in various conditions",
                                                        "id": "5ace203a9fe7b01d5806bfa5",
                                                        "_id": "6077c4efbc5f4d4df9ef26d7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da49",
                                                                "_id": "6077c4efbc5f4d4df9ef26d8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "length of tangent",
                                                        "id": "5ace203a9fe7b01d5806bfa6",
                                                        "_id": "6077c4efbc5f4d4df9ef26d5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4a",
                                                                "_id": "6077c4efbc5f4d4df9ef26d6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Normal of the circle",
                                                        "id": "5ace203a9fe7b01d5806bfa7",
                                                        "_id": "6077c4efbc5f4d4df9ef26d3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4b",
                                                                "_id": "6077c4efbc5f4d4df9ef26d4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pair of tangents and angle between pair of tangent and director circle",
                                                        "id": "5ace203a9fe7b01d5806bfa8",
                                                        "_id": "6077c4efbc5f4d4df9ef26d1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4c",
                                                                "_id": "6077c4efbc5f4d4df9ef26d2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Position of point w.r.t. to circle and position of line w.r.t. circle, length of intercept made by circle on line",
                                                        "id": "5ace203a9fe7b01d5806bfa9",
                                                        "_id": "6077c4efbc5f4d4df9ef26cf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4d",
                                                                "_id": "6077c4efbc5f4d4df9ef26d0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Radical axis and its property, position of two circles w.r.t. each other",
                                                        "id": "5ace203a9fe7b01d5806bfaa",
                                                        "_id": "6077c4efbc5f4d4df9ef26cd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4e",
                                                                "_id": "6077c4efbc5f4d4df9ef26ce"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Various forms of circle, condition for second degree equation to represents a circle",
                                                        "id": "5ace203a9fe7b01d5806bfab",
                                                        "_id": "6077c4efbc5f4d4df9ef26cb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da4f",
                                                                "_id": "6077c4efbc5f4d4df9ef26cc"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d94f",
                                                        "_id": "6077c4efbc5f4d4df9ef26e1"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Trigonometry",
                                                "id": "5ace20319fe7b01d5806bc84",
                                                "_id": "6077c4efbc5f4d4df9ef269c",
                                                "concepts": [
                                                    {
                                                        "name": "Trigonometric Identities",
                                                        "id": "5ace203c9fe7b01d5806c063",
                                                        "_id": "6077c4efbc5f4d4df9ef26c7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b5",
                                                                "_id": "6077c4efbc5f4d4df9ef26c8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of Complementary Angles",
                                                        "id": "5ace203c9fe7b01d5806c065",
                                                        "_id": "6077c4efbc5f4d4df9ef26c5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b6",
                                                                "_id": "6077c4efbc5f4d4df9ef26c6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relation between different systems of Measurement of Angles",
                                                        "id": "5ace203c9fe7b01d5806c05a",
                                                        "_id": "6077c4efbc5f4d4df9ef26c3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b7",
                                                                "_id": "6077c4efbc5f4d4df9ef26c4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental identities, Sign of Trigonometric ratios",
                                                        "id": "5ace203c9fe7b01d5806c054",
                                                        "_id": "6077c4efbc5f4d4df9ef26c1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b8",
                                                                "_id": "6077c4efbc5f4d4df9ef26c2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Domain & range of Trigonometric ratios",
                                                        "id": "5ace203c9fe7b01d5806c053",
                                                        "_id": "6077c4efbc5f4d4df9ef26bf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83b9",
                                                                "_id": "6077c4efbc5f4d4df9ef26c0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                        "id": "5ace203c9fe7b01d5806c064",
                                                        "_id": "6077c4efbc5f4d4df9ef26bd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ba",
                                                                "_id": "6077c4efbc5f4d4df9ef26be"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of Sum & Difference of two angles",
                                                        "id": "5ace203c9fe7b01d5806c067",
                                                        "_id": "6077c4efbc5f4d4df9ef26bb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83bb",
                                                                "_id": "6077c4efbc5f4d4df9ef26bc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transformation Formula - Product into Sum or Difference",
                                                        "id": "5ace203c9fe7b01d5806c05e",
                                                        "_id": "6077c4efbc5f4d4df9ef26b9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83bc",
                                                                "_id": "6077c4efbc5f4d4df9ef26ba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transformation Formula - Sum and Difference into Poduct",
                                                        "id": "5ace203c9fe7b01d5806c05f",
                                                        "_id": "6077c4efbc5f4d4df9ef26b7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83bd",
                                                                "_id": "6077c4efbc5f4d4df9ef26b8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of multiple angles, Trigonometric Ratios of sub-multiple angles",
                                                        "id": "5ace203c9fe7b01d5806c066",
                                                        "_id": "6077c4efbc5f4d4df9ef26b5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83be",
                                                                "_id": "6077c4efbc5f4d4df9ef26b6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Greatest & Least values of Trigonometric Expressions",
                                                        "id": "5ace203c9fe7b01d5806c056",
                                                        "_id": "6077c4efbc5f4d4df9ef26b3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83bf",
                                                                "_id": "6077c4efbc5f4d4df9ef26b4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Compound angles",
                                                        "id": "5ace203c9fe7b01d5806c052",
                                                        "_id": "6077c4efbc5f4d4df9ef26b1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c0",
                                                                "_id": "6077c4efbc5f4d4df9ef26b2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Multiple angles",
                                                        "id": "5ace203c9fe7b01d5806c058",
                                                        "_id": "6077c4efbc5f4d4df9ef26af",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c1",
                                                                "_id": "6077c4efbc5f4d4df9ef26b0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sub-multiple angles",
                                                        "id": "5ace203c9fe7b01d5806c05b",
                                                        "_id": "6077c4efbc5f4d4df9ef26ad",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c2",
                                                                "_id": "6077c4efbc5f4d4df9ef26ae"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transformation",
                                                        "id": "5ace203c9fe7b01d5806c05d",
                                                        "_id": "6077c4efbc5f4d4df9ef26ab",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c3",
                                                                "_id": "6077c4efbc5f4d4df9ef26ac"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graph of trignomety(periodicity) ratio",
                                                        "id": "5ace203c9fe7b01d5806c055",
                                                        "_id": "6077c4efbc5f4d4df9ef26a9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c4",
                                                                "_id": "6077c4efbc5f4d4df9ef26aa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trignometric equations",
                                                        "id": "5ace203c9fe7b01d5806c060",
                                                        "_id": "6077c4efbc5f4d4df9ef26a7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c5",
                                                                "_id": "6077c4efbc5f4d4df9ef26a8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trignometric inequations",
                                                        "id": "5ace203c9fe7b01d5806c061",
                                                        "_id": "6077c4efbc5f4d4df9ef26a5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c6",
                                                                "_id": "6077c4efbc5f4d4df9ef26a6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of triangle",
                                                        "id": "5ace203c9fe7b01d5806c059",
                                                        "_id": "6077c4efbc5f4d4df9ef26a3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c7",
                                                                "_id": "6077c4efbc5f4d4df9ef26a4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trignometric ratios",
                                                        "id": "5ace203d9fe7b01d5806c0c0",
                                                        "_id": "6077c4efbc5f4d4df9ef26a1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c8",
                                                                "_id": "6077c4efbc5f4d4df9ef26a2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heights and distances",
                                                        "id": "5ace203d9fe7b01d5806c0b7",
                                                        "_id": "6077c4efbc5f4d4df9ef269f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83c9",
                                                                "_id": "6077c4efbc5f4d4df9ef26a0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sum and product formulae",
                                                        "id": "5ace203c9fe7b01d5806c05c",
                                                        "_id": "6077c4efbc5f4d4df9ef269d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ca",
                                                                "_id": "6077c4efbc5f4d4df9ef269e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8232",
                                                        "_id": "6077c4efbc5f4d4df9ef26c9"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ellipse",
                                                "id": "5ace20319fe7b01d5806bc59",
                                                "_id": "6077c4efbc5f4d4df9ef269a",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d950",
                                                        "_id": "6077c4efbc5f4d4df9ef269b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Application of Trigonometry",
                                                "id": "5ace20319fe7b01d5806bc68",
                                                "_id": "6077c4efbc5f4d4df9ef2696",
                                                "concepts": [
                                                    {
                                                        "name": "Angle of Elevation, Angle of Depression",
                                                        "id": "5ace203b9fe7b01d5806bff4",
                                                        "_id": "6077c4efbc5f4d4df9ef2697",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83cb",
                                                                "_id": "6077c4efbc5f4d4df9ef2698"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8233",
                                                        "_id": "6077c4efbc5f4d4df9ef2699"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ellipse",
                                                "id": "5ace20319fe7b01d5806bc5a",
                                                "_id": "6077c4efbc5f4d4df9ef2678",
                                                "concepts": [
                                                    {
                                                        "name": "Angle between the tangents",
                                                        "id": "5ace203a9fe7b01d5806bfac",
                                                        "_id": "6077c4efbc5f4d4df9ef2693",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da50",
                                                                "_id": "6077c4efbc5f4d4df9ef2694"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "auxiliary circle",
                                                        "id": "5ace203a9fe7b01d5806bfad",
                                                        "_id": "6077c4efbc5f4d4df9ef2691",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da51",
                                                                "_id": "6077c4efbc5f4d4df9ef2692"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basing on director circle of ellipse",
                                                        "id": "5ace203a9fe7b01d5806bfae",
                                                        "_id": "6077c4efbc5f4d4df9ef268f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da52",
                                                                "_id": "6077c4efbc5f4d4df9ef2690"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "chord of contact, equation of pair of tangents, director circle",
                                                        "id": "5ace203a9fe7b01d5806bfaf",
                                                        "_id": "6077c4efbc5f4d4df9ef268d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da53",
                                                                "_id": "6077c4efbc5f4d4df9ef268e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chord, focal chord, focal length and equation of chord-mid point form,",
                                                        "id": "5ace203a9fe7b01d5806bfb0",
                                                        "_id": "6077c4efbc5f4d4df9ef268b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da54",
                                                                "_id": "6077c4efbc5f4d4df9ef268c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord",
                                                        "id": "5ace203a9fe7b01d5806bfb1",
                                                        "_id": "6077c4efbc5f4d4df9ef2689",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da55",
                                                                "_id": "6077c4efbc5f4d4df9ef268a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for second degree to represent ellipse, standard form and general form of ellipse and to find focus, directrix, axes, latus rectum, tangent at vertex of ellipse, parametric form, focal length, auxiliary circle",
                                                        "id": "5ace203a9fe7b01d5806bfb2",
                                                        "_id": "6077c4efbc5f4d4df9ef2687",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da56",
                                                                "_id": "6077c4efbc5f4d4df9ef2688"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                        "id": "5ace203a9fe7b01d5806bfb3",
                                                        "_id": "6077c4efbc5f4d4df9ef2685",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da57",
                                                                "_id": "6077c4efbc5f4d4df9ef2686"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Co-normal points, condition of four normals passing through a point",
                                                        "id": "5ace203a9fe7b01d5806bfb4",
                                                        "_id": "6077c4efbc5f4d4df9ef2683",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da58",
                                                                "_id": "6077c4efbc5f4d4df9ef2684"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of chord joining two points having eccentric angle",
                                                        "id": "5ace203a9fe7b01d5806bfb5",
                                                        "_id": "6077c4efbc5f4d4df9ef2681",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da59",
                                                                "_id": "6077c4efbc5f4d4df9ef2682"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Intersection of ellipse and a circle",
                                                        "id": "5ace203a9fe7b01d5806bfb6",
                                                        "_id": "6077c4efbc5f4d4df9ef267f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5a",
                                                                "_id": "6077c4efbc5f4d4df9ef2680"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "parametric co-ordinates",
                                                        "id": "5ace203a9fe7b01d5806bfb7",
                                                        "_id": "6077c4efbc5f4d4df9ef267d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5b",
                                                                "_id": "6077c4efbc5f4d4df9ef267e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "position of a pt w.r.t. ellipse",
                                                        "id": "5ace203a9fe7b01d5806bfb8",
                                                        "_id": "6077c4efbc5f4d4df9ef267b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5c",
                                                                "_id": "6077c4efbc5f4d4df9ef267c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties in ellipse-reflection, tangent, normal",
                                                        "id": "5ace203a9fe7b01d5806bfb9",
                                                        "_id": "6077c4efbc5f4d4df9ef2679",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5d",
                                                                "_id": "6077c4efbc5f4d4df9ef267a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d951",
                                                        "_id": "6077c4efbc5f4d4df9ef2695"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics-2",
                                                "id": "5ace20319fe7b01d5806bc7f",
                                                "_id": "6077c4efbc5f4d4df9ef2670",
                                                "concepts": [
                                                    {
                                                        "name": "Frequency Distribution",
                                                        "id": "5ace203c9fe7b01d5806c03b",
                                                        "_id": "6077c4efbc5f4d4df9ef2675",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83cc",
                                                                "_id": "6077c4efbc5f4d4df9ef2676"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean, Median, Mode",
                                                        "id": "5ace203c9fe7b01d5806c03c",
                                                        "_id": "6077c4efbc5f4d4df9ef2673",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83cd",
                                                                "_id": "6077c4efbc5f4d4df9ef2674"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Empherical formula, Ogive curve, Emperical relation between mean, median, mode",
                                                        "id": "5ace203c9fe7b01d5806c03a",
                                                        "_id": "6077c4efbc5f4d4df9ef2671",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ce",
                                                                "_id": "6077c4efbc5f4d4df9ef2672"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8234",
                                                        "_id": "6077c4efbc5f4d4df9ef2677"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef274a"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Fluids",
                                                "id": "5ace20329fe7b01d5806bc9f",
                                                "_id": "6077c4efbc5f4d4df9ef2655",
                                                "concepts": [
                                                    {
                                                        "name": "Barometer, manometer, U-tube",
                                                        "id": "5ace203e9fe7b01d5806c125",
                                                        "_id": "6077c4efbc5f4d4df9ef266c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc3",
                                                                "_id": "6077c4efbc5f4d4df9ef266d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Capillary action",
                                                        "id": "5ace203e9fe7b01d5806c126",
                                                        "_id": "6077c4efbc5f4d4df9ef266a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc4",
                                                                "_id": "6077c4efbc5f4d4df9ef266b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Excess pressure",
                                                        "id": "5ace203e9fe7b01d5806c127",
                                                        "_id": "6077c4efbc5f4d4df9ef2668",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc5",
                                                                "_id": "6077c4efbc5f4d4df9ef2669"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Floatation",
                                                        "id": "5ace203f9fe7b01d5806c128",
                                                        "_id": "6077c4efbc5f4d4df9ef2666",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc6",
                                                                "_id": "6077c4efbc5f4d4df9ef2667"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fluid dynamics, Bernoulli's equation",
                                                        "id": "5ace203f9fe7b01d5806c129",
                                                        "_id": "6077c4efbc5f4d4df9ef2664",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc7",
                                                                "_id": "6077c4efbc5f4d4df9ef2665"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pressure and Force applied by fluid",
                                                        "id": "5ace203f9fe7b01d5806c12a",
                                                        "_id": "6077c4efbc5f4d4df9ef2662",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc8",
                                                                "_id": "6077c4efbc5f4d4df9ef2663"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Siphonic action, venturimeter, pitot tube",
                                                        "id": "5ace203f9fe7b01d5806c12b",
                                                        "_id": "6077c4efbc5f4d4df9ef2660",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddc9",
                                                                "_id": "6077c4efbc5f4d4df9ef2661"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Stoke's Law",
                                                        "id": "5ace203f9fe7b01d5806c12c",
                                                        "_id": "6077c4efbc5f4d4df9ef265e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddca",
                                                                "_id": "6077c4efbc5f4d4df9ef265f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface tension force",
                                                        "id": "5ace203f9fe7b01d5806c12d",
                                                        "_id": "6077c4efbc5f4d4df9ef265c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddcb",
                                                                "_id": "6077c4efbc5f4d4df9ef265d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Time to drain out liquid from a container",
                                                        "id": "5ace203f9fe7b01d5806c12e",
                                                        "_id": "6077c4efbc5f4d4df9ef265a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddcc",
                                                                "_id": "6077c4efbc5f4d4df9ef265b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Velocity of efflux and thrust force",
                                                        "id": "5ace203f9fe7b01d5806c12f",
                                                        "_id": "6077c4efbc5f4d4df9ef2658",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddcd",
                                                                "_id": "6077c4efbc5f4d4df9ef2659"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Viscosity",
                                                        "id": "5ace203f9fe7b01d5806c130",
                                                        "_id": "6077c4efbc5f4d4df9ef2656",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddce",
                                                                "_id": "6077c4efbc5f4d4df9ef2657"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd5f",
                                                        "_id": "6077c4efbc5f4d4df9ef266e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ray Optics and Optical Instruments",
                                                "id": "5eeb5f6cbb67ca2232c1e0b0",
                                                "_id": "6077c4efbc5f4d4df9ef2653",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae64",
                                                        "_id": "6077c4efbc5f4d4df9ef2654"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Sound",
                                                "id": "5ace20329fe7b01d5806bcb3",
                                                "_id": "6077c4efbc5f4d4df9ef2645",
                                                "concepts": [
                                                    {
                                                        "name": "Types of waves , Amplitude , Time Period & Frequency",
                                                        "id": "5ace20409fe7b01d5806c1c6",
                                                        "_id": "6077c4efbc5f4d4df9ef2650",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f5",
                                                                "_id": "6077c4efbc5f4d4df9ef2651"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reflection of sound & ECHO",
                                                        "id": "5ace20409fe7b01d5806c1c3",
                                                        "_id": "6077c4efbc5f4d4df9ef264e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f6",
                                                                "_id": "6077c4efbc5f4d4df9ef264f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relation between frequency, velocity and wave length",
                                                        "id": "5ace20409fe7b01d5806c1c4",
                                                        "_id": "6077c4efbc5f4d4df9ef264c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f7",
                                                                "_id": "6077c4efbc5f4d4df9ef264d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pitch, Loudness of sound, Timber & Intensity of sound",
                                                        "id": "5ace20409fe7b01d5806c1c2",
                                                        "_id": "6077c4efbc5f4d4df9ef264a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f8",
                                                                "_id": "6077c4efbc5f4d4df9ef264b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ultrasonic waves and its application",
                                                        "id": "5ace20409fe7b01d5806c1c7",
                                                        "_id": "6077c4efbc5f4d4df9ef2648",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83f9",
                                                                "_id": "6077c4efbc5f4d4df9ef2649"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Time period of simple pendulum",
                                                        "id": "5ace20409fe7b01d5806c1c5",
                                                        "_id": "6077c4efbc5f4d4df9ef2646",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83fa",
                                                                "_id": "6077c4efbc5f4d4df9ef2647"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823d",
                                                        "_id": "6077c4efbc5f4d4df9ef2652"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Semiconductor Electronics: Materials, Devices, and Simple Circuits",
                                                "id": "5eeb5f6cbb67ca2232c1e0b5",
                                                "_id": "6077c4efbc5f4d4df9ef2643",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae65",
                                                        "_id": "6077c4efbc5f4d4df9ef2644"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "General Physics",
                                                "id": "5ace20329fe7b01d5806bca0",
                                                "_id": "6077c4efbc5f4d4df9ef2639",
                                                "concepts": [
                                                    {
                                                        "name": "dimensional analysis",
                                                        "id": "5ace203f9fe7b01d5806c131",
                                                        "_id": "6077c4efbc5f4d4df9ef2640",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddcf",
                                                                "_id": "6077c4efbc5f4d4df9ef2641"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Error analysis",
                                                        "id": "5ace203f9fe7b01d5806c132",
                                                        "_id": "6077c4efbc5f4d4df9ef263e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd0",
                                                                "_id": "6077c4efbc5f4d4df9ef263f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Experiments",
                                                        "id": "5ace203f9fe7b01d5806c133",
                                                        "_id": "6077c4efbc5f4d4df9ef263c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd1",
                                                                "_id": "6077c4efbc5f4d4df9ef263d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Significant figure",
                                                        "id": "5ace203f9fe7b01d5806c134",
                                                        "_id": "6077c4efbc5f4d4df9ef263a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd2",
                                                                "_id": "6077c4efbc5f4d4df9ef263b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd60",
                                                        "_id": "6077c4efbc5f4d4df9ef2642"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Electromagnetic Induction",
                                                "id": "5eeb5f6cbb67ca2232c1e0ad",
                                                "_id": "6077c4efbc5f4d4df9ef2637",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae67",
                                                        "_id": "6077c4efbc5f4d4df9ef2638"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef266f"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Number System",
                                                "id": "5ace20319fe7b01d5806bc33",
                                                "_id": "6077c4efbc5f4d4df9ef2630",
                                                "concepts": [
                                                    {
                                                        "name": "Remainder theorem",
                                                        "id": "5ace20399fe7b01d5806bf25",
                                                        "_id": "6077c4efbc5f4d4df9ef2633",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8427",
                                                                "_id": "6077c4efbc5f4d4df9ef2634"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basics of number system",
                                                        "id": "5ace20399fe7b01d5806bf24",
                                                        "_id": "6077c4efbc5f4d4df9ef2631",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8428",
                                                                "_id": "6077c4efbc5f4d4df9ef2632"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8249",
                                                        "_id": "6077c4efbc5f4d4df9ef2635"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Machine Input",
                                                "id": "5ace20319fe7b01d5806bc31",
                                                "_id": "6077c4efbc5f4d4df9ef262c",
                                                "concepts": [
                                                    {
                                                        "name": "Sequential output tracing",
                                                        "id": "5ace20389fe7b01d5806bf21",
                                                        "_id": "6077c4efbc5f4d4df9ef262d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8429",
                                                                "_id": "6077c4efbc5f4d4df9ef262e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824a",
                                                        "_id": "6077c4efbc5f4d4df9ef262f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Logical Venn Diagram",
                                                "id": "5ace20319fe7b01d5806bc30",
                                                "_id": "6077c4efbc5f4d4df9ef2628",
                                                "concepts": [
                                                    {
                                                        "name": "Venn Diagrams",
                                                        "id": "5ace20389fe7b01d5806bf20",
                                                        "_id": "6077c4efbc5f4d4df9ef2629",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842a",
                                                                "_id": "6077c4efbc5f4d4df9ef262a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824b",
                                                        "_id": "6077c4efbc5f4d4df9ef262b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef2636"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Minerals and Energy Resources",
                                                "id": "5ace20329fe7b01d5806bccb",
                                                "_id": "6077c4efbc5f4d4df9ef2621",
                                                "concepts": [
                                                    {
                                                        "name": "Occurrence of minerals.",
                                                        "id": "5ace20419fe7b01d5806c1ff",
                                                        "_id": "6077c4efbc5f4d4df9ef2624",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8466",
                                                                "_id": "6077c4efbc5f4d4df9ef2625"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Uses and conservation of mineral & energy resources",
                                                        "id": "5ace20419fe7b01d5806c200",
                                                        "_id": "6077c4efbc5f4d4df9ef2622",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8467",
                                                                "_id": "6077c4efbc5f4d4df9ef2623"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8272",
                                                        "_id": "6077c4efbc5f4d4df9ef2626"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Manufacturing Industries",
                                                "id": "5ace20329fe7b01d5806bcca",
                                                "_id": "6077c4efbc5f4d4df9ef261d",
                                                "concepts": [
                                                    {
                                                        "name": "Industries, location and their importance",
                                                        "id": "5ace20419fe7b01d5806c1fe",
                                                        "_id": "6077c4efbc5f4d4df9ef261e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8468",
                                                                "_id": "6077c4efbc5f4d4df9ef261f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8273",
                                                        "_id": "6077c4efbc5f4d4df9ef2620"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Life Lines of National Economy",
                                                "id": "5ace20329fe7b01d5806bcc9",
                                                "_id": "6077c4efbc5f4d4df9ef2619",
                                                "concepts": [
                                                    {
                                                        "name": "Importance of the transportation and communication in economy",
                                                        "id": "5ace20419fe7b01d5806c1fd",
                                                        "_id": "6077c4efbc5f4d4df9ef261a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8469",
                                                                "_id": "6077c4efbc5f4d4df9ef261b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8274",
                                                        "_id": "6077c4efbc5f4d4df9ef261c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "The French Revolution",
                                                "id": "5ace20329fe7b01d5806bcdc",
                                                "_id": "6077c4efbc5f4d4df9ef2613",
                                                "concepts": [
                                                    {
                                                        "name": "Causes of the French Revolution",
                                                        "id": "5ace20429fe7b01d5806c221",
                                                        "_id": "6077c4efbc5f4d4df9ef2616",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846a",
                                                                "_id": "6077c4efbc5f4d4df9ef2617"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Contribution of different sections in the FR",
                                                        "id": "5ace20429fe7b01d5806c222",
                                                        "_id": "6077c4efbc5f4d4df9ef2614",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846b",
                                                                "_id": "6077c4efbc5f4d4df9ef2615"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8275",
                                                        "_id": "6077c4efbc5f4d4df9ef2618"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Socialism in Europe and the Russian Revolution",
                                                "id": "5ace20329fe7b01d5806bcda",
                                                "_id": "6077c4efbc5f4d4df9ef260d",
                                                "concepts": [
                                                    {
                                                        "name": "Rise of socialism",
                                                        "id": "5ace20429fe7b01d5806c21e",
                                                        "_id": "6077c4efbc5f4d4df9ef2610",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846c",
                                                                "_id": "6077c4efbc5f4d4df9ef2611"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Causes of the RR and its impact",
                                                        "id": "5ace20429fe7b01d5806c21d",
                                                        "_id": "6077c4efbc5f4d4df9ef260e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846d",
                                                                "_id": "6077c4efbc5f4d4df9ef260f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8276",
                                                        "_id": "6077c4efbc5f4d4df9ef2612"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef2627"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Classification",
                                                "id": "5ace20309fe7b01d5806bc15",
                                                "_id": "6077c4efbc5f4d4df9ef2604",
                                                "concepts": [
                                                    {
                                                        "name": "Letter Classification",
                                                        "id": "5ace20389fe7b01d5806befd",
                                                        "_id": "6077c4efbc5f4d4df9ef2609",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df42",
                                                                "_id": "6077c4efbc5f4d4df9ef260a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Number Classification",
                                                        "id": "5ace20389fe7b01d5806befe",
                                                        "_id": "6077c4efbc5f4d4df9ef2607",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df43",
                                                                "_id": "6077c4efbc5f4d4df9ef2608"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Word Classification",
                                                        "id": "5ace20389fe7b01d5806beff",
                                                        "_id": "6077c4efbc5f4d4df9ef2605",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df44",
                                                                "_id": "6077c4efbc5f4d4df9ef2606"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df36",
                                                        "_id": "6077c4efbc5f4d4df9ef260b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef260c"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 4,
                                "startDate": "2021-05-17T00:00:00.000Z",
                                "endDate": "2021-05-23T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef24b7",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Why do we fall ill",
                                                "id": "5ace202f9fe7b01d5806bbc5",
                                                "_id": "6077c4efbc5f4d4df9ef25f0",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction to disease, types, cause",
                                                        "id": "5ace20339fe7b01d5806bd67",
                                                        "_id": "6077c4efbc5f4d4df9ef25ff",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82cc",
                                                                "_id": "6077c4efbc5f4d4df9ef2600"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Immunization",
                                                        "id": "5ace20339fe7b01d5806bd66",
                                                        "_id": "6077c4efbc5f4d4df9ef25fd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82cd",
                                                                "_id": "6077c4efbc5f4d4df9ef25fe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bacterial diseases",
                                                        "id": "5ace20339fe7b01d5806bd65",
                                                        "_id": "6077c4efbc5f4d4df9ef25fb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ce",
                                                                "_id": "6077c4efbc5f4d4df9ef25fc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Viral diseases",
                                                        "id": "5ace20339fe7b01d5806bd6b",
                                                        "_id": "6077c4efbc5f4d4df9ef25f9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82cf",
                                                                "_id": "6077c4efbc5f4d4df9ef25fa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Protozoan disease",
                                                        "id": "5ace20339fe7b01d5806bd6a",
                                                        "_id": "6077c4efbc5f4d4df9ef25f7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d0",
                                                                "_id": "6077c4efbc5f4d4df9ef25f8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mineral deficiency disorder",
                                                        "id": "5ace20339fe7b01d5806bd68",
                                                        "_id": "6077c4efbc5f4d4df9ef25f5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d1",
                                                                "_id": "6077c4efbc5f4d4df9ef25f6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Protein deficiency disorder",
                                                        "id": "5ace20339fe7b01d5806bd69",
                                                        "_id": "6077c4efbc5f4d4df9ef25f3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d2",
                                                                "_id": "6077c4efbc5f4d4df9ef25f4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vitamin deficiency disorder",
                                                        "id": "5ace20339fe7b01d5806bd6c",
                                                        "_id": "6077c4efbc5f4d4df9ef25f1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d3",
                                                                "_id": "6077c4efbc5f4d4df9ef25f2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820a",
                                                        "_id": "6077c4efbc5f4d4df9ef2601"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef2602"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Atomic structure",
                                                "id": "5ace202f9fe7b01d5806bbc7",
                                                "_id": "6077c4efbc5f4d4df9ef25db",
                                                "concepts": [
                                                    {
                                                        "name": "Discovery of Fundamental Particles",
                                                        "id": "5ace20349fe7b01d5806bd77",
                                                        "_id": "6077c4efbc5f4d4df9ef25ec",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8332",
                                                                "_id": "6077c4efbc5f4d4df9ef25ed"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Atomic Models (Thomson & Rutherford Atomic Models)",
                                                        "id": "5ace20349fe7b01d5806bd75",
                                                        "_id": "6077c4efbc5f4d4df9ef25ea",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8333",
                                                                "_id": "6077c4efbc5f4d4df9ef25eb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bohrs Theory",
                                                        "id": "5ace20349fe7b01d5806bd76",
                                                        "_id": "6077c4efbc5f4d4df9ef25e8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8334",
                                                                "_id": "6077c4efbc5f4d4df9ef25e9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electronic distribution in terms of shells and subshells",
                                                        "id": "5ace20349fe7b01d5806bd79",
                                                        "_id": "6077c4efbc5f4d4df9ef25e6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8335",
                                                                "_id": "6077c4efbc5f4d4df9ef25e7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Isotopes, Isotones and Isobars",
                                                        "id": "5ace20349fe7b01d5806bd7b",
                                                        "_id": "6077c4efbc5f4d4df9ef25e4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8336",
                                                                "_id": "6077c4efbc5f4d4df9ef25e5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Iso-electronic species",
                                                        "id": "5ace20349fe7b01d5806bd7a",
                                                        "_id": "6077c4efbc5f4d4df9ef25e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8337",
                                                                "_id": "6077c4efbc5f4d4df9ef25e3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electromagnetic Radiation",
                                                        "id": "5ace20349fe7b01d5806bd78",
                                                        "_id": "6077c4efbc5f4d4df9ef25e0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8338",
                                                                "_id": "6077c4efbc5f4d4df9ef25e1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Radioactivity",
                                                        "id": "5ace20349fe7b01d5806bd7d",
                                                        "_id": "6077c4efbc5f4d4df9ef25de",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8339",
                                                                "_id": "6077c4efbc5f4d4df9ef25df"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plancks Quantum Theory and Quantum Numbers",
                                                        "id": "5ace20349fe7b01d5806bd7c",
                                                        "_id": "6077c4efbc5f4d4df9ef25dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833a",
                                                                "_id": "6077c4efbc5f4d4df9ef25dd"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8215",
                                                        "_id": "6077c4efbc5f4d4df9ef25ee"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef25ef"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Hyperbola",
                                                "id": "5ace20319fe7b01d5806bc5b",
                                                "_id": "6077c4efbc5f4d4df9ef25d8",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d952",
                                                        "_id": "6077c4efbc5f4d4df9ef25d9"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Area related to Circle",
                                                "id": "5ace20319fe7b01d5806bc69",
                                                "_id": "6077c4efbc5f4d4df9ef25d0",
                                                "concepts": [
                                                    {
                                                        "name": "Area of circle",
                                                        "id": "5ace203b9fe7b01d5806bff6",
                                                        "_id": "6077c4efbc5f4d4df9ef25d5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83cf",
                                                                "_id": "6077c4efbc5f4d4df9ef25d6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area of sector, Semi-circle area",
                                                        "id": "5ace203b9fe7b01d5806bff7",
                                                        "_id": "6077c4efbc5f4d4df9ef25d3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d0",
                                                                "_id": "6077c4efbc5f4d4df9ef25d4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area enclosed by two concentric circles, Area of segment",
                                                        "id": "5ace203b9fe7b01d5806bff5",
                                                        "_id": "6077c4efbc5f4d4df9ef25d1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d1",
                                                                "_id": "6077c4efbc5f4d4df9ef25d2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8235",
                                                        "_id": "6077c4efbc5f4d4df9ef25d7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Hyperbola",
                                                "id": "5ace20319fe7b01d5806bc5c",
                                                "_id": "6077c4efbc5f4d4df9ef25b4",
                                                "concepts": [
                                                    {
                                                        "name": "Asymptotes of hyperbola and its properties",
                                                        "id": "5ace203a9fe7b01d5806bfba",
                                                        "_id": "6077c4efbc5f4d4df9ef25cd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5e",
                                                                "_id": "6077c4efbc5f4d4df9ef25ce"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic properties of conjugate hyperbola of a hyperbola",
                                                        "id": "5ace203a9fe7b01d5806bfbb",
                                                        "_id": "6077c4efbc5f4d4df9ef25cb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da5f",
                                                                "_id": "6077c4efbc5f4d4df9ef25cc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chord of contact, equation of pair of tangents, director circle",
                                                        "id": "5ace203a9fe7b01d5806bfbc",
                                                        "_id": "6077c4efbc5f4d4df9ef25c9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da60",
                                                                "_id": "6077c4efbc5f4d4df9ef25ca"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                        "id": "5ace203a9fe7b01d5806bfbd",
                                                        "_id": "6077c4efbc5f4d4df9ef25c7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da61",
                                                                "_id": "6077c4efbc5f4d4df9ef25c8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Common tangent between hyperbola and circle",
                                                        "id": "5ace203a9fe7b01d5806bfbe",
                                                        "_id": "6077c4efbc5f4d4df9ef25c5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da62",
                                                                "_id": "6077c4efbc5f4d4df9ef25c6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                        "id": "5ace203a9fe7b01d5806bfbf",
                                                        "_id": "6077c4efbc5f4d4df9ef25c3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da63",
                                                                "_id": "6077c4efbc5f4d4df9ef25c4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for second degree to represents hyperbola, standard form and general form of hyperbola, conjugate hyperbola and to find focus, directrix, axes, latus rectum, tangent at vertex of hyperbola, parametric form, focal length, auxiliary circle",
                                                        "id": "5ace203a9fe7b01d5806bfc0",
                                                        "_id": "6077c4efbc5f4d4df9ef25c1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da64",
                                                                "_id": "6077c4efbc5f4d4df9ef25c2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents",
                                                        "id": "5ace203a9fe7b01d5806bfc1",
                                                        "_id": "6077c4efbc5f4d4df9ef25bf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da65",
                                                                "_id": "6077c4efbc5f4d4df9ef25c0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Co-normal points, condition of four normals passing through a point",
                                                        "id": "5ace203a9fe7b01d5806bfc2",
                                                        "_id": "6077c4efbc5f4d4df9ef25bd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da66",
                                                                "_id": "6077c4efbc5f4d4df9ef25be"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Intersection of a rectangular hyperbola with a circle",
                                                        "id": "5ace203a9fe7b01d5806bfc3",
                                                        "_id": "6077c4efbc5f4d4df9ef25bb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da67",
                                                                "_id": "6077c4efbc5f4d4df9ef25bc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "position of a pt w.r.t. hyperbola",
                                                        "id": "5ace203a9fe7b01d5806bfc4",
                                                        "_id": "6077c4efbc5f4d4df9ef25b9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da68",
                                                                "_id": "6077c4efbc5f4d4df9ef25ba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties in hyperbola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                        "id": "5ace203a9fe7b01d5806bfc5",
                                                        "_id": "6077c4efbc5f4d4df9ef25b7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da69",
                                                                "_id": "6077c4efbc5f4d4df9ef25b8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rectangular hyperbola and its properties",
                                                        "id": "5ace203a9fe7b01d5806bfc6",
                                                        "_id": "6077c4efbc5f4d4df9ef25b5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6a",
                                                                "_id": "6077c4efbc5f4d4df9ef25b6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d953",
                                                        "_id": "6077c4efbc5f4d4df9ef25cf"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Real Numbers",
                                                "id": "5ace20319fe7b01d5806bc7c",
                                                "_id": "6077c4efbc5f4d4df9ef25ae",
                                                "concepts": [
                                                    {
                                                        "name": "Euclid's Division Method, Fundamental Theorm of Arithmetic",
                                                        "id": "5ace203c9fe7b01d5806c02c",
                                                        "_id": "6077c4efbc5f4d4df9ef25b1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d2",
                                                                "_id": "6077c4efbc5f4d4df9ef25b2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Results-Irrationality of sqrt of 2, 3, 5, Decimal Expansions of Rational Numbers in Terms of Terminating / Non-Terminating",
                                                        "id": "5ace203c9fe7b01d5806c02d",
                                                        "_id": "6077c4efbc5f4d4df9ef25af",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d3",
                                                                "_id": "6077c4efbc5f4d4df9ef25b0"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8236",
                                                        "_id": "6077c4efbc5f4d4df9ef25b3"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Parabola",
                                                "id": "5ace20319fe7b01d5806bc5d",
                                                "_id": "6077c4efbc5f4d4df9ef25ac",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d954",
                                                        "_id": "6077c4efbc5f4d4df9ef25ad"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Polynomials-2",
                                                "id": "5ace20319fe7b01d5806bc77",
                                                "_id": "6077c4efbc5f4d4df9ef25a6",
                                                "concepts": [
                                                    {
                                                        "name": "Nature of Zeros of a Polynomial",
                                                        "id": "5ace203b9fe7b01d5806c01d",
                                                        "_id": "6077c4efbc5f4d4df9ef25a9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d4",
                                                                "_id": "6077c4efbc5f4d4df9ef25aa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometrical Meaning of the Zeroes of a Polynomials",
                                                        "id": "5ace203b9fe7b01d5806c01c",
                                                        "_id": "6077c4efbc5f4d4df9ef25a7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83d5",
                                                                "_id": "6077c4efbc5f4d4df9ef25a8"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8237",
                                                        "_id": "6077c4efbc5f4d4df9ef25ab"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Parabola",
                                                "id": "5ace20319fe7b01d5806bc5e",
                                                "_id": "6077c4efbc5f4d4df9ef258e",
                                                "concepts": [
                                                    {
                                                        "name": "Chord, focal chord, focal length and equation of chord-mid point form",
                                                        "id": "5ace203a9fe7b01d5806bfc7",
                                                        "_id": "6077c4efbc5f4d4df9ef25a3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6b",
                                                                "_id": "6077c4efbc5f4d4df9ef25a4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for line to be normal, equation of normal in different forms, point of intersection of normal, length of normal chord,",
                                                        "id": "5ace203a9fe7b01d5806bfc8",
                                                        "_id": "6077c4efbc5f4d4df9ef25a1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6c",
                                                                "_id": "6077c4efbc5f4d4df9ef25a2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for second degree to represents conic, standard form and general form of parabola, focus, directrix, axes, latus rectum, tangent at vertex of parabola, parametric form",
                                                        "id": "5ace203a9fe7b01d5806bfc9",
                                                        "_id": "6077c4efbc5f4d4df9ef259f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6d",
                                                                "_id": "6077c4efbc5f4d4df9ef25a0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for z normals",
                                                        "id": "5ace203a9fe7b01d5806bfca",
                                                        "_id": "6077c4efbc5f4d4df9ef259d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6e",
                                                                "_id": "6077c4efbc5f4d4df9ef259e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition of tangency, equation of tangent in various forms, point of intersection of tangents, chord of contact",
                                                        "id": "5ace203a9fe7b01d5806bfcb",
                                                        "_id": "6077c4efbc5f4d4df9ef259b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da6f",
                                                                "_id": "6077c4efbc5f4d4df9ef259c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Co-normal points, condition of three normals passing through a point",
                                                        "id": "5ace203a9fe7b01d5806bfcc",
                                                        "_id": "6077c4efbc5f4d4df9ef2599",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da70",
                                                                "_id": "6077c4efbc5f4d4df9ef259a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "eqn of normal",
                                                        "id": "5ace203a9fe7b01d5806bfcd",
                                                        "_id": "6077c4efbc5f4d4df9ef2597",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da71",
                                                                "_id": "6077c4efbc5f4d4df9ef2598"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of pair of tangents",
                                                        "id": "5ace203a9fe7b01d5806bfce",
                                                        "_id": "6077c4efbc5f4d4df9ef2595",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da72",
                                                                "_id": "6077c4efbc5f4d4df9ef2596"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "geometrical properties of a parabola",
                                                        "id": "5ace203a9fe7b01d5806bfcf",
                                                        "_id": "6077c4efbc5f4d4df9ef2593",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da73",
                                                                "_id": "6077c4efbc5f4d4df9ef2594"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties in parabola-reflection, tangent, normal, sub-normal and sub-tangent",
                                                        "id": "5ace203a9fe7b01d5806bfd0",
                                                        "_id": "6077c4efbc5f4d4df9ef2591",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da74",
                                                                "_id": "6077c4efbc5f4d4df9ef2592"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Roots of cubic equations",
                                                        "id": "5ace203a9fe7b01d5806bfd1",
                                                        "_id": "6077c4efbc5f4d4df9ef258f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da75",
                                                                "_id": "6077c4efbc5f4d4df9ef2590"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d955",
                                                        "_id": "6077c4efbc5f4d4df9ef25a5"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Straight Line",
                                                "id": "5ace20319fe7b01d5806bc5f",
                                                "_id": "6077c4efbc5f4d4df9ef258c",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d956",
                                                        "_id": "6077c4efbc5f4d4df9ef258d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Straight Line",
                                                "id": "5ace20319fe7b01d5806bc60",
                                                "_id": "6077c4efbc5f4d4df9ef2572",
                                                "concepts": [
                                                    {
                                                        "name": "Angle bisectors",
                                                        "id": "5ace203a9fe7b01d5806bfd2",
                                                        "_id": "6077c4efbc5f4d4df9ef2589",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da76",
                                                                "_id": "6077c4efbc5f4d4df9ef258a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area of triangle, collinearity and locus",
                                                        "id": "5ace203a9fe7b01d5806bfd3",
                                                        "_id": "6077c4efbc5f4d4df9ef2587",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da77",
                                                                "_id": "6077c4efbc5f4d4df9ef2588"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Concept of homogenization",
                                                        "id": "5ace203a9fe7b01d5806bfd4",
                                                        "_id": "6077c4efbc5f4d4df9ef2585",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da78",
                                                                "_id": "6077c4efbc5f4d4df9ef2586"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition for eqn of second degree to represent two lines, angle between two pair of straight lines",
                                                        "id": "5ace203a9fe7b01d5806bfd5",
                                                        "_id": "6077c4efbc5f4d4df9ef2583",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da79",
                                                                "_id": "6077c4efbc5f4d4df9ef2584"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance formula, Section formula, centres related to triangle",
                                                        "id": "5ace203a9fe7b01d5806bfd6",
                                                        "_id": "6077c4efbc5f4d4df9ef2581",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7a",
                                                                "_id": "6077c4efbc5f4d4df9ef2582"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "eqn of pair of line joing pts of intersection of a line and a conic",
                                                        "id": "5ace203a9fe7b01d5806bfd7",
                                                        "_id": "6077c4efbc5f4d4df9ef257f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7b",
                                                                "_id": "6077c4efbc5f4d4df9ef2580"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of angle bisectors of pair of straight lines",
                                                        "id": "5ace203a9fe7b01d5806bfd8",
                                                        "_id": "6077c4efbc5f4d4df9ef257d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7c",
                                                                "_id": "6077c4efbc5f4d4df9ef257e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Family of straight lines/concurrency of straight lines",
                                                        "id": "5ace203a9fe7b01d5806bfd9",
                                                        "_id": "6077c4efbc5f4d4df9ef257b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7d",
                                                                "_id": "6077c4efbc5f4d4df9ef257c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parametric form of line and its application",
                                                        "id": "5ace203b9fe7b01d5806bfda",
                                                        "_id": "6077c4efbc5f4d4df9ef2579",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7e",
                                                                "_id": "6077c4efbc5f4d4df9ef257a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Position of points w.r.t. to line, distance of a point from a line, distance between two parallel lines angle between two lines, condition of parallel/perpendicular/identical lines",
                                                        "id": "5ace203b9fe7b01d5806bfdb",
                                                        "_id": "6077c4efbc5f4d4df9ef2577",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da7f",
                                                                "_id": "6077c4efbc5f4d4df9ef2578"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rotation and translation of axes",
                                                        "id": "5ace203b9fe7b01d5806bfdc",
                                                        "_id": "6077c4efbc5f4d4df9ef2575",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da80",
                                                                "_id": "6077c4efbc5f4d4df9ef2576"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Slope of a line, various forms of equation of straight line",
                                                        "id": "5ace203b9fe7b01d5806bfdd",
                                                        "_id": "6077c4efbc5f4d4df9ef2573",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da81",
                                                                "_id": "6077c4efbc5f4d4df9ef2574"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d957",
                                                        "_id": "6077c4efbc5f4d4df9ef258b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Functions",
                                                "id": "5ace20319fe7b01d5806bc61",
                                                "_id": "6077c4efbc5f4d4df9ef2570",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d958",
                                                        "_id": "6077c4efbc5f4d4df9ef2571"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Functions",
                                                "id": "5ace20319fe7b01d5806bc62",
                                                "_id": "6077c4efbc5f4d4df9ef254c",
                                                "concepts": [
                                                    {
                                                        "name": "Algebra of a function",
                                                        "id": "5ace203b9fe7b01d5806bfde",
                                                        "_id": "6077c4efbc5f4d4df9ef256d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da82",
                                                                "_id": "6077c4efbc5f4d4df9ef256e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bijective functions, inverse of a function",
                                                        "id": "5ace203b9fe7b01d5806bfdf",
                                                        "_id": "6077c4efbc5f4d4df9ef256b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da83",
                                                                "_id": "6077c4efbc5f4d4df9ef256c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "binary operation",
                                                        "id": "5ace203b9fe7b01d5806bfe0",
                                                        "_id": "6077c4efbc5f4d4df9ef2569",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da84",
                                                                "_id": "6077c4efbc5f4d4df9ef256a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Composite function",
                                                        "id": "5ace203b9fe7b01d5806bfe1",
                                                        "_id": "6077c4efbc5f4d4df9ef2567",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da85",
                                                                "_id": "6077c4efbc5f4d4df9ef2568"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Domain of a function",
                                                        "id": "5ace203b9fe7b01d5806bfe2",
                                                        "_id": "6077c4efbc5f4d4df9ef2565",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da86",
                                                                "_id": "6077c4efbc5f4d4df9ef2566"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "even fn",
                                                        "id": "5ace203b9fe7b01d5806bfe3",
                                                        "_id": "6077c4efbc5f4d4df9ef2563",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da87",
                                                                "_id": "6077c4efbc5f4d4df9ef2564"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Even/odd functions",
                                                        "id": "5ace203b9fe7b01d5806bfe4",
                                                        "_id": "6077c4efbc5f4d4df9ef2561",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da88",
                                                                "_id": "6077c4efbc5f4d4df9ef2562"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functional equation",
                                                        "id": "5ace203b9fe7b01d5806bfe5",
                                                        "_id": "6077c4efbc5f4d4df9ef255f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da89",
                                                                "_id": "6077c4efbc5f4d4df9ef2560"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "GIF (Greatest integer function)",
                                                        "id": "5ace203b9fe7b01d5806bfe6",
                                                        "_id": "6077c4efbc5f4d4df9ef255d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8a",
                                                                "_id": "6077c4efbc5f4d4df9ef255e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modulus function",
                                                        "id": "5ace203b9fe7b01d5806bfe7",
                                                        "_id": "6077c4efbc5f4d4df9ef255b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8b",
                                                                "_id": "6077c4efbc5f4d4df9ef255c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Number of elements in sets, operation on sets, venn diagram based problems, cartesian products of two sets",
                                                        "id": "5ace203b9fe7b01d5806bfe8",
                                                        "_id": "6077c4efbc5f4d4df9ef2559",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8c",
                                                                "_id": "6077c4efbc5f4d4df9ef255a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Number of solution type problems, Graphical solution of function",
                                                        "id": "5ace203b9fe7b01d5806bfe9",
                                                        "_id": "6077c4efbc5f4d4df9ef2557",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8d",
                                                                "_id": "6077c4efbc5f4d4df9ef2558"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "odd fn",
                                                        "id": "5ace203b9fe7b01d5806bfea",
                                                        "_id": "6077c4efbc5f4d4df9ef2555",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8e",
                                                                "_id": "6077c4efbc5f4d4df9ef2556"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Period of a function",
                                                        "id": "5ace203b9fe7b01d5806bfeb",
                                                        "_id": "6077c4efbc5f4d4df9ef2553",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da8f",
                                                                "_id": "6077c4efbc5f4d4df9ef2554"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Range of a function",
                                                        "id": "5ace203b9fe7b01d5806bfec",
                                                        "_id": "6077c4efbc5f4d4df9ef2551",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da90",
                                                                "_id": "6077c4efbc5f4d4df9ef2552"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relation and types of relations",
                                                        "id": "5ace203b9fe7b01d5806bfed",
                                                        "_id": "6077c4efbc5f4d4df9ef254f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da91",
                                                                "_id": "6077c4efbc5f4d4df9ef2550"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types and number of functions: one-one/many-one, into/ onto",
                                                        "id": "5ace203b9fe7b01d5806bfee",
                                                        "_id": "6077c4efbc5f4d4df9ef254d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da92",
                                                                "_id": "6077c4efbc5f4d4df9ef254e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d959",
                                                        "_id": "6077c4efbc5f4d4df9ef256f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Linear Inequations",
                                                "id": "5ace20319fe7b01d5806bc63",
                                                "_id": "6077c4efbc5f4d4df9ef2548",
                                                "concepts": [
                                                    {
                                                        "name": "Linear Inequations",
                                                        "id": "5ace203b9fe7b01d5806bfef",
                                                        "_id": "6077c4efbc5f4d4df9ef2549",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da93",
                                                                "_id": "6077c4efbc5f4d4df9ef254a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d95a",
                                                        "_id": "6077c4efbc5f4d4df9ef254b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Linear Programming",
                                                "id": "5ace20319fe7b01d5806bc64",
                                                "_id": "6077c4efbc5f4d4df9ef2544",
                                                "concepts": [
                                                    {
                                                        "name": "Problems based on optimization under constraints",
                                                        "id": "5ace203b9fe7b01d5806bff0",
                                                        "_id": "6077c4efbc5f4d4df9ef2545",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da94",
                                                                "_id": "6077c4efbc5f4d4df9ef2546"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d95b",
                                                        "_id": "6077c4efbc5f4d4df9ef2547"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Logarithmic and Exponential Series",
                                                "id": "5ace20319fe7b01d5806bc65",
                                                "_id": "6077c4efbc5f4d4df9ef2540",
                                                "concepts": [
                                                    {
                                                        "name": "Problems related to Series and Equation",
                                                        "id": "5ace203b9fe7b01d5806bff1",
                                                        "_id": "6077c4efbc5f4d4df9ef2541",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da95",
                                                                "_id": "6077c4efbc5f4d4df9ef2542"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d95c",
                                                        "_id": "6077c4efbc5f4d4df9ef2543"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Mathematical Induction",
                                                "id": "5ace20319fe7b01d5806bc66",
                                                "_id": "6077c4efbc5f4d4df9ef253c",
                                                "concepts": [
                                                    {
                                                        "name": "Principle of Mathematical Induction",
                                                        "id": "5ace203b9fe7b01d5806bff2",
                                                        "_id": "6077c4efbc5f4d4df9ef253d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da96",
                                                                "_id": "6077c4efbc5f4d4df9ef253e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d95d",
                                                        "_id": "6077c4efbc5f4d4df9ef253f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Mathematical Reasoning",
                                                "id": "5ace20319fe7b01d5806bc67",
                                                "_id": "6077c4efbc5f4d4df9ef2538",
                                                "concepts": [
                                                    {
                                                        "name": "Types of statements, Mathematical operators-And, or, NOT, If then, If and only If, Quantifiers, Tautology, Falacy",
                                                        "id": "5ace203b9fe7b01d5806bff3",
                                                        "_id": "6077c4efbc5f4d4df9ef2539",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673da97",
                                                                "_id": "6077c4efbc5f4d4df9ef253a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5722b35a0a066673d95e",
                                                        "_id": "6077c4efbc5f4d4df9ef253b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Linear Equations in Two Variables",
                                                "id": "5ec644a012a5e80679ddd546",
                                                "_id": "6077c4efbc5f4d4df9ef252c",
                                                "concepts": [
                                                    {
                                                        "name": "Linear Equations",
                                                        "id": "5ec64785941e1306742b8428",
                                                        "_id": "6077c4efbc5f4d4df9ef2535",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673db20",
                                                                "_id": "6077c4efbc5f4d4df9ef2536"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equations of Lines Parallel to the X-axis and Y-axis",
                                                        "id": "5ec64785941e1306742b842c",
                                                        "_id": "6077c4efbc5f4d4df9ef2533",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673db21",
                                                                "_id": "6077c4efbc5f4d4df9ef2534"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graph of Linear Equation in Two Variables",
                                                        "id": "5ec64785941e1306742b842a",
                                                        "_id": "6077c4efbc5f4d4df9ef2531",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673db22",
                                                                "_id": "6077c4efbc5f4d4df9ef2532"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Real Life Applications ",
                                                        "id": "5ec64785941e1306742b842b",
                                                        "_id": "6077c4efbc5f4d4df9ef252f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673db23",
                                                                "_id": "6077c4efbc5f4d4df9ef2530"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of a Linear Equation",
                                                        "id": "5ec64785941e1306742b8429",
                                                        "_id": "6077c4efbc5f4d4df9ef252d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5723b35a0a066673db24",
                                                                "_id": "6077c4efbc5f4d4df9ef252e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d97c",
                                                        "_id": "6077c4efbc5f4d4df9ef2537"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef25da"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Electricity",
                                                "id": "5ace20329fe7b01d5806bcab",
                                                "_id": "6077c4efbc5f4d4df9ef2515",
                                                "concepts": [
                                                    {
                                                        "name": "Potential & Potential Difference",
                                                        "id": "5ace20409fe7b01d5806c18d",
                                                        "_id": "6077c4efbc5f4d4df9ef2528",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83fb",
                                                                "_id": "6077c4efbc5f4d4df9ef2529"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of Charge & Electric Current",
                                                        "id": "5ace20409fe7b01d5806c18e",
                                                        "_id": "6077c4efbc5f4d4df9ef2526",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83fc",
                                                                "_id": "6077c4efbc5f4d4df9ef2527"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ohm's Law",
                                                        "id": "5ace20409fe7b01d5806c18c",
                                                        "_id": "6077c4efbc5f4d4df9ef2524",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83fd",
                                                                "_id": "6077c4efbc5f4d4df9ef2525"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conductor, Insulator and Ammeter and Voltmeter",
                                                        "id": "5ace20409fe7b01d5806c189",
                                                        "_id": "6077c4efbc5f4d4df9ef2522",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83fe",
                                                                "_id": "6077c4efbc5f4d4df9ef2523"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Resistance and Resistivity",
                                                        "id": "5ace20409fe7b01d5806c18f",
                                                        "_id": "6077c4efbc5f4d4df9ef2520",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c83ff",
                                                                "_id": "6077c4efbc5f4d4df9ef2521"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Series and Parralel Combination of Resistances",
                                                        "id": "5ace20409fe7b01d5806c190",
                                                        "_id": "6077c4efbc5f4d4df9ef251e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8400",
                                                                "_id": "6077c4efbc5f4d4df9ef251f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heating Effect of Current",
                                                        "id": "5ace20409fe7b01d5806c18b",
                                                        "_id": "6077c4efbc5f4d4df9ef251c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8401",
                                                                "_id": "6077c4efbc5f4d4df9ef251d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Power",
                                                        "id": "5ace20409fe7b01d5806c18a",
                                                        "_id": "6077c4efbc5f4d4df9ef251a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8402",
                                                                "_id": "6077c4efbc5f4d4df9ef251b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Columb's Inverse Square Law",
                                                        "id": "5ace20409fe7b01d5806c188",
                                                        "_id": "6077c4efbc5f4d4df9ef2518",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8403",
                                                                "_id": "6077c4efbc5f4d4df9ef2519"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Wheatstone Bridge",
                                                        "id": "5ace20409fe7b01d5806c191",
                                                        "_id": "6077c4efbc5f4d4df9ef2516",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8404",
                                                                "_id": "6077c4efbc5f4d4df9ef2517"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823e",
                                                        "_id": "6077c4efbc5f4d4df9ef252a"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Wave Optics",
                                                "id": "5eeb5f6cbb67ca2232c1e0b1",
                                                "_id": "6077c4efbc5f4d4df9ef2513",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae69",
                                                        "_id": "6077c4efbc5f4d4df9ef2514"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Vectors",
                                                "id": "5ace20329fe7b01d5806bca1",
                                                "_id": "6077c4efbc5f4d4df9ef250b",
                                                "concepts": [
                                                    {
                                                        "name": "Dot Product, Cross product and applications",
                                                        "id": "5ace203f9fe7b01d5806c135",
                                                        "_id": "6077c4efbc5f4d4df9ef2510",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd3",
                                                                "_id": "6077c4efbc5f4d4df9ef2511"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Resolution of vectors",
                                                        "id": "5ace203f9fe7b01d5806c136",
                                                        "_id": "6077c4efbc5f4d4df9ef250e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd4",
                                                                "_id": "6077c4efbc5f4d4df9ef250f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vectors & parallelogram Law",
                                                        "id": "5ace203f9fe7b01d5806c137",
                                                        "_id": "6077c4efbc5f4d4df9ef250c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd5",
                                                                "_id": "6077c4efbc5f4d4df9ef250d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd61",
                                                        "_id": "6077c4efbc5f4d4df9ef2512"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Magnetism and Matter",
                                                "id": "5eeb5f6cbb67ca2232c1e0ac",
                                                "_id": "6077c4efbc5f4d4df9ef2509",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae6a",
                                                        "_id": "6077c4efbc5f4d4df9ef250a"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Magnetic Effect of Electric Current",
                                                "id": "5ace20329fe7b01d5806bcb1",
                                                "_id": "6077c4efbc5f4d4df9ef24f3",
                                                "concepts": [
                                                    {
                                                        "name": "Magnetic Field",
                                                        "id": "5ace20409fe7b01d5806c1b4",
                                                        "_id": "6077c4efbc5f4d4df9ef2506",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8405",
                                                                "_id": "6077c4efbc5f4d4df9ef2507"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic field due to Current in a straight conductor",
                                                        "id": "5ace20409fe7b01d5806c1b6",
                                                        "_id": "6077c4efbc5f4d4df9ef2504",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8406",
                                                                "_id": "6077c4efbc5f4d4df9ef2505"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic field due to Current in a loop",
                                                        "id": "5ace20409fe7b01d5806c1b5",
                                                        "_id": "6077c4efbc5f4d4df9ef2502",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8407",
                                                                "_id": "6077c4efbc5f4d4df9ef2503"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic Field due to Solenoid",
                                                        "id": "5ace20409fe7b01d5806c1b7",
                                                        "_id": "6077c4efbc5f4d4df9ef2500",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8408",
                                                                "_id": "6077c4efbc5f4d4df9ef2501"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Type of Magnet, Electro magnets and its uses",
                                                        "id": "5ace20409fe7b01d5806c1b9",
                                                        "_id": "6077c4efbc5f4d4df9ef24fe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8409",
                                                                "_id": "6077c4efbc5f4d4df9ef24ff"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fleming's Left/right hand rule & Maxwell's cork screw rule",
                                                        "id": "5ace20409fe7b01d5806c1b2",
                                                        "_id": "6077c4efbc5f4d4df9ef24fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840a",
                                                                "_id": "6077c4efbc5f4d4df9ef24fd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Force on a charge moving in Magnetic field",
                                                        "id": "5ace20409fe7b01d5806c1b3",
                                                        "_id": "6077c4efbc5f4d4df9ef24fa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840b",
                                                                "_id": "6077c4efbc5f4d4df9ef24fb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electromagnetic Induction & Lenz's law",
                                                        "id": "5ace20409fe7b01d5806c1b1",
                                                        "_id": "6077c4efbc5f4d4df9ef24f8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840c",
                                                                "_id": "6077c4efbc5f4d4df9ef24f9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motor and Generator",
                                                        "id": "5ace20409fe7b01d5806c1b8",
                                                        "_id": "6077c4efbc5f4d4df9ef24f6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840d",
                                                                "_id": "6077c4efbc5f4d4df9ef24f7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Domestic Electric circuits, Live,Neutral and Earth wires & Safety devices in domestic circuits",
                                                        "id": "5ace20409fe7b01d5806c1b0",
                                                        "_id": "6077c4efbc5f4d4df9ef24f4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840e",
                                                                "_id": "6077c4efbc5f4d4df9ef24f5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c823f",
                                                        "_id": "6077c4efbc5f4d4df9ef2508"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Dual Nature of Radiation and Matter",
                                                "id": "5eeb5f6cbb67ca2232c1e0b2",
                                                "_id": "6077c4efbc5f4d4df9ef24f1",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae6b",
                                                        "_id": "6077c4efbc5f4d4df9ef24f2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef252b"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Syllogism",
                                                "id": "5ace20319fe7b01d5806bc40",
                                                "_id": "6077c4efbc5f4d4df9ef24ec",
                                                "concepts": [
                                                    {
                                                        "name": "Syllogism",
                                                        "id": "5ace20399fe7b01d5806bf3d",
                                                        "_id": "6077c4efbc5f4d4df9ef24ed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842b",
                                                                "_id": "6077c4efbc5f4d4df9ef24ee"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824c",
                                                        "_id": "6077c4efbc5f4d4df9ef24ef"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Arrangements",
                                                "id": "5ace20309fe7b01d5806bc20",
                                                "_id": "6077c4efbc5f4d4df9ef24e8",
                                                "concepts": [
                                                    {
                                                        "name": "Arrangements",
                                                        "id": "5ace20389fe7b01d5806bf0e",
                                                        "_id": "6077c4efbc5f4d4df9ef24e9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842c",
                                                                "_id": "6077c4efbc5f4d4df9ef24ea"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824d",
                                                        "_id": "6077c4efbc5f4d4df9ef24eb"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ranking Test & Time Sequence Test",
                                                "id": "5ace20319fe7b01d5806bc39",
                                                "_id": "6077c4efbc5f4d4df9ef24e0",
                                                "concepts": [
                                                    {
                                                        "name": "Ranking Test",
                                                        "id": "5ace20399fe7b01d5806bf32",
                                                        "_id": "6077c4efbc5f4d4df9ef24e5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842d",
                                                                "_id": "6077c4efbc5f4d4df9ef24e6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Time Sequence Test",
                                                        "id": "5ace20399fe7b01d5806bf33",
                                                        "_id": "6077c4efbc5f4d4df9ef24e3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842e",
                                                                "_id": "6077c4efbc5f4d4df9ef24e4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Calendar",
                                                        "id": "5ace20399fe7b01d5806bf31",
                                                        "_id": "6077c4efbc5f4d4df9ef24e1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c842f",
                                                                "_id": "6077c4efbc5f4d4df9ef24e2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824e",
                                                        "_id": "6077c4efbc5f4d4df9ef24e7"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef24f0"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Nazism and the Rise of Hitler",
                                                "id": "5ace20329fe7b01d5806bcd5",
                                                "_id": "6077c4efbc5f4d4df9ef24d9",
                                                "concepts": [
                                                    {
                                                        "name": "First World War and Weimar Republic.",
                                                        "id": "5ace20419fe7b01d5806c210",
                                                        "_id": "6077c4efbc5f4d4df9ef24dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846e",
                                                                "_id": "6077c4efbc5f4d4df9ef24dd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rise of Hitler & the idea of Nazism",
                                                        "id": "5ace20419fe7b01d5806c211",
                                                        "_id": "6077c4efbc5f4d4df9ef24da",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c846f",
                                                                "_id": "6077c4efbc5f4d4df9ef24db"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8277",
                                                        "_id": "6077c4efbc5f4d4df9ef24de"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Forest Society and Colonialism",
                                                "id": "5ace20329fe7b01d5806bcd2",
                                                "_id": "6077c4efbc5f4d4df9ef24d3",
                                                "concepts": [
                                                    {
                                                        "name": "Causes of deforestration.",
                                                        "id": "5ace20419fe7b01d5806c20b",
                                                        "_id": "6077c4efbc5f4d4df9ef24d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8470",
                                                                "_id": "6077c4efbc5f4d4df9ef24d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Forests rule under British government'",
                                                        "id": "5ace20419fe7b01d5806c20c",
                                                        "_id": "6077c4efbc5f4d4df9ef24d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8471",
                                                                "_id": "6077c4efbc5f4d4df9ef24d5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8278",
                                                        "_id": "6077c4efbc5f4d4df9ef24d8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Pastaralists in the Modern World",
                                                "id": "5ace20329fe7b01d5806bcd7",
                                                "_id": "6077c4efbc5f4d4df9ef24cb",
                                                "concepts": [
                                                    {
                                                        "name": "Pastoralists of India.",
                                                        "id": "5ace20429fe7b01d5806c216",
                                                        "_id": "6077c4efbc5f4d4df9ef24d0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8472",
                                                                "_id": "6077c4efbc5f4d4df9ef24d1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different rules, affecting pastoralists movement",
                                                        "id": "5ace20419fe7b01d5806c214",
                                                        "_id": "6077c4efbc5f4d4df9ef24ce",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8473",
                                                                "_id": "6077c4efbc5f4d4df9ef24cf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pastoralist in Africa",
                                                        "id": "5ace20429fe7b01d5806c215",
                                                        "_id": "6077c4efbc5f4d4df9ef24cc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8474",
                                                                "_id": "6077c4efbc5f4d4df9ef24cd"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8279",
                                                        "_id": "6077c4efbc5f4d4df9ef24d2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Peasants and Farmers",
                                                "id": "5ace20329fe7b01d5806bcd8",
                                                "_id": "6077c4efbc5f4d4df9ef24c3",
                                                "concepts": [
                                                    {
                                                        "name": "Life of the peasant in Britain after enclosurement",
                                                        "id": "5ace20429fe7b01d5806c218",
                                                        "_id": "6077c4efbc5f4d4df9ef24c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8475",
                                                                "_id": "6077c4efbc5f4d4df9ef24c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Whites settlers of USA & causes of Dust Bowl",
                                                        "id": "5ace20429fe7b01d5806c219",
                                                        "_id": "6077c4efbc5f4d4df9ef24c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8476",
                                                                "_id": "6077c4efbc5f4d4df9ef24c7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cultivation of opium in Bengal under British rule",
                                                        "id": "5ace20429fe7b01d5806c217",
                                                        "_id": "6077c4efbc5f4d4df9ef24c4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8477",
                                                                "_id": "6077c4efbc5f4d4df9ef24c5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827a",
                                                        "_id": "6077c4efbc5f4d4df9ef24ca"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "History and Sport: The Story of Cricket",
                                                "id": "5ace20329fe7b01d5806bcd3",
                                                "_id": "6077c4efbc5f4d4df9ef24bd",
                                                "concepts": [
                                                    {
                                                        "name": "Rise and growth of cricket.",
                                                        "id": "5ace20419fe7b01d5806c20e",
                                                        "_id": "6077c4efbc5f4d4df9ef24c0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8478",
                                                                "_id": "6077c4efbc5f4d4df9ef24c1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cricket as the symbol of nationalism",
                                                        "id": "5ace20419fe7b01d5806c20d",
                                                        "_id": "6077c4efbc5f4d4df9ef24be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8479",
                                                                "_id": "6077c4efbc5f4d4df9ef24bf"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827b",
                                                        "_id": "6077c4efbc5f4d4df9ef24c2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef24df"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Figure Formation and Analogy",
                                                "id": "5ace20309fe7b01d5806bc16",
                                                "_id": "6077c4efbc5f4d4df9ef24b8",
                                                "concepts": [
                                                    {
                                                        "name": "Figure Formation",
                                                        "id": "5ace20389fe7b01d5806bf00",
                                                        "_id": "6077c4efbc5f4d4df9ef24b9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df45",
                                                                "_id": "6077c4efbc5f4d4df9ef24ba"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df37",
                                                        "_id": "6077c4efbc5f4d4df9ef24bb"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef24bc"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 5,
                                "startDate": "2021-05-24T00:00:00.000Z",
                                "endDate": "2021-05-30T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef234d",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Natural Resources",
                                                "id": "5ace202f9fe7b01d5806bbc2",
                                                "_id": "6077c4efbc5f4d4df9ef24a4",
                                                "concepts": [
                                                    {
                                                        "name": "Types of resources, Energy & Newly formed Resources",
                                                        "id": "5ace20339fe7b01d5806bd51",
                                                        "_id": "6077c4efbc5f4d4df9ef24b3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d4",
                                                                "_id": "6077c4efbc5f4d4df9ef24b4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Air",
                                                        "id": "5ace20339fe7b01d5806bd4b",
                                                        "_id": "6077c4efbc5f4d4df9ef24b1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d5",
                                                                "_id": "6077c4efbc5f4d4df9ef24b2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Water & Forest",
                                                        "id": "5ace20339fe7b01d5806bd52",
                                                        "_id": "6077c4efbc5f4d4df9ef24af",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d6",
                                                                "_id": "6077c4efbc5f4d4df9ef24b0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Soil",
                                                        "id": "5ace20339fe7b01d5806bd50",
                                                        "_id": "6077c4efbc5f4d4df9ef24ad",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d7",
                                                                "_id": "6077c4efbc5f4d4df9ef24ae"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biomass energy & Coal, Petroleum, Fossil Fuels",
                                                        "id": "5ace20339fe7b01d5806bd4d",
                                                        "_id": "6077c4efbc5f4d4df9ef24ab",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d8",
                                                                "_id": "6077c4efbc5f4d4df9ef24ac"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pollution",
                                                        "id": "5ace20339fe7b01d5806bd4f",
                                                        "_id": "6077c4efbc5f4d4df9ef24a9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82d9",
                                                                "_id": "6077c4efbc5f4d4df9ef24aa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conservative measures",
                                                        "id": "5ace20339fe7b01d5806bd4e",
                                                        "_id": "6077c4efbc5f4d4df9ef24a7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82da",
                                                                "_id": "6077c4efbc5f4d4df9ef24a8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biogeochemical Cycles",
                                                        "id": "5ace20339fe7b01d5806bd4c",
                                                        "_id": "6077c4efbc5f4d4df9ef24a5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82db",
                                                                "_id": "6077c4efbc5f4d4df9ef24a6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820b",
                                                        "_id": "6077c4efbc5f4d4df9ef24b5"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef24b6"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Chemical Reactions",
                                                "id": "5ace202f9fe7b01d5806bbca",
                                                "_id": "6077c4efbc5f4d4df9ef2491",
                                                "concepts": [
                                                    {
                                                        "name": "Combination Reaction",
                                                        "id": "5ace20349fe7b01d5806bd91",
                                                        "_id": "6077c4efbc5f4d4df9ef24a0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833b",
                                                                "_id": "6077c4efbc5f4d4df9ef24a1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Decomposition Reaction",
                                                        "id": "5ace20349fe7b01d5806bd92",
                                                        "_id": "6077c4efbc5f4d4df9ef249e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833c",
                                                                "_id": "6077c4efbc5f4d4df9ef249f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Displacement Reaction- Single Displacement Reaction",
                                                        "id": "5ace20349fe7b01d5806bd94",
                                                        "_id": "6077c4efbc5f4d4df9ef249c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833d",
                                                                "_id": "6077c4efbc5f4d4df9ef249d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Displacement Reaction- Double Displacement Reaction",
                                                        "id": "5ace20349fe7b01d5806bd93",
                                                        "_id": "6077c4efbc5f4d4df9ef249a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833e",
                                                                "_id": "6077c4efbc5f4d4df9ef249b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reactivity Series",
                                                        "id": "5ace20349fe7b01d5806bd95",
                                                        "_id": "6077c4efbc5f4d4df9ef2498",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c833f",
                                                                "_id": "6077c4efbc5f4d4df9ef2499"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rusting of Iron and Rancidity",
                                                        "id": "5ace20349fe7b01d5806bd97",
                                                        "_id": "6077c4efbc5f4d4df9ef2496",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8340",
                                                                "_id": "6077c4efbc5f4d4df9ef2497"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Redox Reaction",
                                                        "id": "5ace20349fe7b01d5806bd96",
                                                        "_id": "6077c4efbc5f4d4df9ef2494",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8341",
                                                                "_id": "6077c4efbc5f4d4df9ef2495"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Balancing of Equations",
                                                        "id": "5ace20349fe7b01d5806bd90",
                                                        "_id": "6077c4efbc5f4d4df9ef2492",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8342",
                                                                "_id": "6077c4efbc5f4d4df9ef2493"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8216",
                                                        "_id": "6077c4efbc5f4d4df9ef24a2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef24a3"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Statistics",
                                                "id": "5ec644a012a5e80679ddd54b",
                                                "_id": "6077c4efbc5f4d4df9ef2480",
                                                "concepts": [
                                                    {
                                                        "name": "Median of Ungrouped Data",
                                                        "id": "5ec64785941e1306742b845a",
                                                        "_id": "6077c4efbc5f4d4df9ef248d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db25",
                                                                "_id": "6077c4efbc5f4d4df9ef248e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Representation of Data: Frequency Distribution Table",
                                                        "id": "5ec64785941e1306742b8455",
                                                        "_id": "6077c4efbc5f4d4df9ef248b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db26",
                                                                "_id": "6077c4efbc5f4d4df9ef248c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mode of Ungrouped Data",
                                                        "id": "5ec64785941e1306742b845b",
                                                        "_id": "6077c4efbc5f4d4df9ef2489",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db27",
                                                                "_id": "6077c4efbc5f4d4df9ef248a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Histograms",
                                                        "id": "5ec64785941e1306742b8457",
                                                        "_id": "6077c4efbc5f4d4df9ef2487",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db28",
                                                                "_id": "6077c4efbc5f4d4df9ef2488"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Frequency Polygons",
                                                        "id": "5ec64785941e1306742b8458",
                                                        "_id": "6077c4efbc5f4d4df9ef2485",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db29",
                                                                "_id": "6077c4efbc5f4d4df9ef2486"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean of Ungrouped Data",
                                                        "id": "5ec64785941e1306742b8459",
                                                        "_id": "6077c4efbc5f4d4df9ef2483",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2a",
                                                                "_id": "6077c4efbc5f4d4df9ef2484"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bar Graphs",
                                                        "id": "5ec64785941e1306742b8456",
                                                        "_id": "6077c4efbc5f4d4df9ef2481",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2b",
                                                                "_id": "6077c4efbc5f4d4df9ef2482"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d97d",
                                                        "_id": "6077c4efbc5f4d4df9ef248f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Number System",
                                                "id": "5ec644a012a5e80679ddd543",
                                                "_id": "6077c4efbc5f4d4df9ef2474",
                                                "concepts": [
                                                    {
                                                        "name": "Operations on Real Numbers",
                                                        "id": "5ec64785941e1306742b841e",
                                                        "_id": "6077c4efbc5f4d4df9ef247d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2c",
                                                                "_id": "6077c4efbc5f4d4df9ef247e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Decimal Expansion of Real Numbers",
                                                        "id": "5ec64785941e1306742b841d",
                                                        "_id": "6077c4efbc5f4d4df9ef247b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2d",
                                                                "_id": "6077c4efbc5f4d4df9ef247c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Laws of Exponents for Real Numbers",
                                                        "id": "5ec64785941e1306742b841f",
                                                        "_id": "6077c4efbc5f4d4df9ef2479",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2e",
                                                                "_id": "6077c4efbc5f4d4df9ef247a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rational Numbers",
                                                        "id": "5ec64785941e1306742b841b",
                                                        "_id": "6077c4efbc5f4d4df9ef2477",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db2f",
                                                                "_id": "6077c4efbc5f4d4df9ef2478"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Irrational Numbers",
                                                        "id": "5ec64785941e1306742b841c",
                                                        "_id": "6077c4efbc5f4d4df9ef2475",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db30",
                                                                "_id": "6077c4efbc5f4d4df9ef2476"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d97e",
                                                        "_id": "6077c4efbc5f4d4df9ef247f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Quadrilaterals",
                                                "id": "5ec644a012a5e80679ddd548",
                                                "_id": "6077c4efbc5f4d4df9ef246a",
                                                "concepts": [
                                                    {
                                                        "name": "Types of Quadrilaterals and Angle Sum Property",
                                                        "id": "5ec64785941e1306742b843c",
                                                        "_id": "6077c4efbc5f4d4df9ef2471",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db31",
                                                                "_id": "6077c4efbc5f4d4df9ef2472"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conditions for a Quadrilateral to be a Parallelogram",
                                                        "id": "5ec64785941e1306742b843e",
                                                        "_id": "6077c4efbc5f4d4df9ef246f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db32",
                                                                "_id": "6077c4efbc5f4d4df9ef2470"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mid-Point Theorem",
                                                        "id": "5ec64785941e1306742b843f",
                                                        "_id": "6077c4efbc5f4d4df9ef246d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db33",
                                                                "_id": "6077c4efbc5f4d4df9ef246e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of Parallelogram",
                                                        "id": "5ec64785941e1306742b843d",
                                                        "_id": "6077c4efbc5f4d4df9ef246b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db34",
                                                                "_id": "6077c4efbc5f4d4df9ef246c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d97f",
                                                        "_id": "6077c4efbc5f4d4df9ef2473"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Introduction To Euclid's Geometry",
                                                "id": "5ec644a012a5e80679ddd547",
                                                "_id": "6077c4efbc5f4d4df9ef2464",
                                                "concepts": [
                                                    {
                                                        "name": "Euclid's Definition and Axioms",
                                                        "id": "5ec64785941e1306742b842d",
                                                        "_id": "6077c4efbc5f4d4df9ef2467",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db35",
                                                                "_id": "6077c4efbc5f4d4df9ef2468"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Euclid's Postulates",
                                                        "id": "5ec64785941e1306742b842e",
                                                        "_id": "6077c4efbc5f4d4df9ef2465",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db36",
                                                                "_id": "6077c4efbc5f4d4df9ef2466"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d980",
                                                        "_id": "6077c4efbc5f4d4df9ef2469"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability",
                                                "id": "5ec644a012a5e80679ddd54c",
                                                "_id": "6077c4efbc5f4d4df9ef245e",
                                                "concepts": [
                                                    {
                                                        "name": "Probability-Experimental Approach",
                                                        "id": "5ec64785941e1306742b845c",
                                                        "_id": "6077c4efbc5f4d4df9ef2461",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db37",
                                                                "_id": "6077c4efbc5f4d4df9ef2462"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Probability of an Event",
                                                        "id": "5ec64785941e1306742b845d",
                                                        "_id": "6077c4efbc5f4d4df9ef245f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db38",
                                                                "_id": "6077c4efbc5f4d4df9ef2460"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d981",
                                                        "_id": "6077c4efbc5f4d4df9ef2463"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Polynomials",
                                                "id": "5ec644a012a5e80679ddd544",
                                                "_id": "6077c4efbc5f4d4df9ef2450",
                                                "concepts": [
                                                    {
                                                        "name": "Factorisation of Polynomials",
                                                        "id": "5ec64785941e1306742b8423",
                                                        "_id": "6077c4efbc5f4d4df9ef245b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db39",
                                                                "_id": "6077c4efbc5f4d4df9ef245c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Algebraic Identities - I",
                                                        "id": "5ec64785941e1306742b8424",
                                                        "_id": "6077c4efbc5f4d4df9ef2459",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3a",
                                                                "_id": "6077c4efbc5f4d4df9ef245a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polynomials in One Variable",
                                                        "id": "5ec64785941e1306742b8420",
                                                        "_id": "6077c4efbc5f4d4df9ef2457",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3b",
                                                                "_id": "6077c4efbc5f4d4df9ef2458"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Algebraic Identities - II",
                                                        "id": "5ec64785941e1306742b8425",
                                                        "_id": "6077c4efbc5f4d4df9ef2455",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3c",
                                                                "_id": "6077c4efbc5f4d4df9ef2456"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Remainder Theorem",
                                                        "id": "5ec64785941e1306742b8422",
                                                        "_id": "6077c4efbc5f4d4df9ef2453",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3d",
                                                                "_id": "6077c4efbc5f4d4df9ef2454"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Zeros of a Polynomial",
                                                        "id": "5ec64785941e1306742b8421",
                                                        "_id": "6077c4efbc5f4d4df9ef2451",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3e",
                                                                "_id": "6077c4efbc5f4d4df9ef2452"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d982",
                                                        "_id": "6077c4efbc5f4d4df9ef245d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Constructions",
                                                "id": "5ec644a012a5e80679ddd549",
                                                "_id": "6077c4efbc5f4d4df9ef2446",
                                                "concepts": [
                                                    {
                                                        "name": "Construction of a Triangle Given its Perimeter and Its Two Base Angles",
                                                        "id": "5ec64785941e1306742b844a",
                                                        "_id": "6077c4efbc5f4d4df9ef244d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db3f",
                                                                "_id": "6077c4efbc5f4d4df9ef244e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic Constructions",
                                                        "id": "5ec64785941e1306742b8447",
                                                        "_id": "6077c4efbc5f4d4df9ef244b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db40",
                                                                "_id": "6077c4efbc5f4d4df9ef244c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Construction of a Triangle Given Its Base, a Base Angle and Sum of Other Two Sides",
                                                        "id": "5ec64785941e1306742b8448",
                                                        "_id": "6077c4efbc5f4d4df9ef2449",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db41",
                                                                "_id": "6077c4efbc5f4d4df9ef244a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Construction of a Triangle Given Its Base, a Base Angle and Difference of Other Two Sides",
                                                        "id": "5ec64785941e1306742b8449",
                                                        "_id": "6077c4efbc5f4d4df9ef2447",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db42",
                                                                "_id": "6077c4efbc5f4d4df9ef2448"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d983",
                                                        "_id": "6077c4efbc5f4d4df9ef244f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Coordinate Geometry",
                                                "id": "5ec644a012a5e80679ddd545",
                                                "_id": "6077c4efbc5f4d4df9ef2440",
                                                "concepts": [
                                                    {
                                                        "name": "Plotting of Points in Cartesian Plane",
                                                        "id": "5ec64785941e1306742b8427",
                                                        "_id": "6077c4efbc5f4d4df9ef2443",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db43",
                                                                "_id": "6077c4efbc5f4d4df9ef2444"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cartesian Plane",
                                                        "id": "5ec64785941e1306742b8426",
                                                        "_id": "6077c4efbc5f4d4df9ef2441",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db44",
                                                                "_id": "6077c4efbc5f4d4df9ef2442"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d984",
                                                        "_id": "6077c4efbc5f4d4df9ef2445"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Surface Areas and Volumes",
                                                "id": "5ec644a012a5e80679ddd54a",
                                                "_id": "6077c4efbc5f4d4df9ef242e",
                                                "concepts": [
                                                    {
                                                        "name": "Surface Area of Sphere and Hemisphere",
                                                        "id": "5ec64785941e1306742b8450",
                                                        "_id": "6077c4efbc5f4d4df9ef243d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db45",
                                                                "_id": "6077c4efbc5f4d4df9ef243e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of Sphere and Hemisphere",
                                                        "id": "5ec64785941e1306742b8454",
                                                        "_id": "6077c4efbc5f4d4df9ef243b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db46",
                                                                "_id": "6077c4efbc5f4d4df9ef243c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface Area of Right Circular Cone",
                                                        "id": "5ec64785941e1306742b844f",
                                                        "_id": "6077c4efbc5f4d4df9ef2439",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db47",
                                                                "_id": "6077c4efbc5f4d4df9ef243a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of Cuboid and Cube",
                                                        "id": "5ec64785941e1306742b8451",
                                                        "_id": "6077c4efbc5f4d4df9ef2437",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db48",
                                                                "_id": "6077c4efbc5f4d4df9ef2438"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of Right Circular Cylinder",
                                                        "id": "5ec64785941e1306742b8452",
                                                        "_id": "6077c4efbc5f4d4df9ef2435",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db49",
                                                                "_id": "6077c4efbc5f4d4df9ef2436"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface Area of Right Circular Cylinder",
                                                        "id": "5ec64785941e1306742b844e",
                                                        "_id": "6077c4efbc5f4d4df9ef2433",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4a",
                                                                "_id": "6077c4efbc5f4d4df9ef2434"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface Area of Cuboid and Cube",
                                                        "id": "5ec64785941e1306742b844d",
                                                        "_id": "6077c4efbc5f4d4df9ef2431",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4b",
                                                                "_id": "6077c4efbc5f4d4df9ef2432"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of Right Circular Cone",
                                                        "id": "5ec64785941e1306742b8453",
                                                        "_id": "6077c4efbc5f4d4df9ef242f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4c",
                                                                "_id": "6077c4efbc5f4d4df9ef2430"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d985",
                                                        "_id": "6077c4efbc5f4d4df9ef243f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Numbers And Sequences",
                                                "id": "5f68726f058075680d815e26",
                                                "_id": "6077c4efbc5f4d4df9ef242c",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d986",
                                                        "_id": "6077c4efbc5f4d4df9ef242d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Coordinate Geometry",
                                                "id": "5f68726f058075680d815e29",
                                                "_id": "6077c4efbc5f4d4df9ef242a",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d987",
                                                        "_id": "6077c4efbc5f4d4df9ef242b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Mensuration",
                                                "id": "5f68726f058075680d815e2b",
                                                "_id": "6077c4efbc5f4d4df9ef2428",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d988",
                                                        "_id": "6077c4efbc5f4d4df9ef2429"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Algebra",
                                                "id": "5f68726f058075680d815e27",
                                                "_id": "6077c4efbc5f4d4df9ef2426",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d989",
                                                        "_id": "6077c4efbc5f4d4df9ef2427"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics And Probability",
                                                "id": "5f68726f058075680d815e2c",
                                                "_id": "6077c4efbc5f4d4df9ef2424",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d98a",
                                                        "_id": "6077c4efbc5f4d4df9ef2425"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Relations And Functions",
                                                "id": "5f68726f058075680d815e25",
                                                "_id": "6077c4efbc5f4d4df9ef2422",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d98b",
                                                        "_id": "6077c4efbc5f4d4df9ef2423"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Geometry",
                                                "id": "5f68726f058075680d815e28",
                                                "_id": "6077c4efbc5f4d4df9ef2420",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d98d",
                                                        "_id": "6077c4efbc5f4d4df9ef2421"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Determinants",
                                                "id": "5ace20319fe7b01d5806bc85",
                                                "_id": "6077c4efbc5f4d4df9ef2418",
                                                "concepts": [
                                                    {
                                                        "name": "Cramer's rule for simultaneous linear equation, Solution of homogeneous linear equation (trivial and non-trivial solutions)",
                                                        "id": "5ace203c9fe7b01d5806c068",
                                                        "_id": "6077c4efbc5f4d4df9ef241d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4d",
                                                                "_id": "6077c4efbc5f4d4df9ef241e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Determinants and its basic question, types of determinants, Properties of determinants and multiplication of determinants",
                                                        "id": "5ace203c9fe7b01d5806c069",
                                                        "_id": "6077c4efbc5f4d4df9ef241b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4e",
                                                                "_id": "6077c4efbc5f4d4df9ef241c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Summation, differentation of determinant, Integration of determinant",
                                                        "id": "5ace203c9fe7b01d5806c06a",
                                                        "_id": "6077c4efbc5f4d4df9ef2419",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db4f",
                                                                "_id": "6077c4efbc5f4d4df9ef241a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d98e",
                                                        "_id": "6077c4efbc5f4d4df9ef241f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Matrices",
                                                "id": "5ace20319fe7b01d5806bc86",
                                                "_id": "6077c4efbc5f4d4df9ef240a",
                                                "concepts": [
                                                    {
                                                        "name": "Adjoint of a matrices",
                                                        "id": "5ace203c9fe7b01d5806c06b",
                                                        "_id": "6077c4efbc5f4d4df9ef2415",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db50",
                                                                "_id": "6077c4efbc5f4d4df9ef2416"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Inverse, Inverse by row, column transformation",
                                                        "id": "5ace203c9fe7b01d5806c06c",
                                                        "_id": "6077c4efbc5f4d4df9ef2413",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db51",
                                                                "_id": "6077c4efbc5f4d4df9ef2414"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Othogonal matrices, idempotent, nilpotent, involutary, Hermittian, skew-Hermittian matrices",
                                                        "id": "5ace203c9fe7b01d5806c06d",
                                                        "_id": "6077c4efbc5f4d4df9ef2411",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db52",
                                                                "_id": "6077c4efbc5f4d4df9ef2412"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of system of linear equation",
                                                        "id": "5ace203c9fe7b01d5806c06e",
                                                        "_id": "6077c4efbc5f4d4df9ef240f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db53",
                                                                "_id": "6077c4efbc5f4d4df9ef2410"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transpose of a matrices, symmetric, skew-symmetric",
                                                        "id": "5ace203c9fe7b01d5806c06f",
                                                        "_id": "6077c4efbc5f4d4df9ef240d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db54",
                                                                "_id": "6077c4efbc5f4d4df9ef240e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types of matrices, addition, subtraction, multiplication Minors, co-factors",
                                                        "id": "5ace203c9fe7b01d5806c070",
                                                        "_id": "6077c4efbc5f4d4df9ef240b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db55",
                                                                "_id": "6077c4efbc5f4d4df9ef240c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d98f",
                                                        "_id": "6077c4efbc5f4d4df9ef2417"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Matrices",
                                                "id": "5ace20319fe7b01d5806bc87",
                                                "_id": "6077c4efbc5f4d4df9ef2402",
                                                "concepts": [
                                                    {
                                                        "name": "Conjugate of a matrix",
                                                        "id": "5ace203c9fe7b01d5806c071",
                                                        "_id": "6077c4efbc5f4d4df9ef2407",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db56",
                                                                "_id": "6077c4efbc5f4d4df9ef2408"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equality of two matrices",
                                                        "id": "5ace203c9fe7b01d5806c072",
                                                        "_id": "6077c4efbc5f4d4df9ef2405",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db57",
                                                                "_id": "6077c4efbc5f4d4df9ef2406"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Using of determinant to explain some properties of adjoint of matrix",
                                                        "id": "5ace203d9fe7b01d5806c073",
                                                        "_id": "6077c4efbc5f4d4df9ef2403",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db58",
                                                                "_id": "6077c4efbc5f4d4df9ef2404"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d990",
                                                        "_id": "6077c4efbc5f4d4df9ef2409"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Permuations & Combinations",
                                                "id": "5ace20319fe7b01d5806bc88",
                                                "_id": "6077c4efbc5f4d4df9ef2400",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d991",
                                                        "_id": "6077c4efbc5f4d4df9ef2401"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Permuations & Combinations",
                                                "id": "5ace20319fe7b01d5806bc89",
                                                "_id": "6077c4efbc5f4d4df9ef23e2",
                                                "concepts": [
                                                    {
                                                        "name": "Arrangement in groups",
                                                        "id": "5ace203d9fe7b01d5806c074",
                                                        "_id": "6077c4efbc5f4d4df9ef23fd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db59",
                                                                "_id": "6077c4efbc5f4d4df9ef23fe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "C (n, 1) + C (n, 2) + ……+C(n, n) =2^n - 1.",
                                                        "id": "5ace203d9fe7b01d5806c075",
                                                        "_id": "6077c4efbc5f4d4df9ef23fb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5a",
                                                                "_id": "6077c4efbc5f4d4df9ef23fc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Circular permutation",
                                                        "id": "5ace203d9fe7b01d5806c076",
                                                        "_id": "6077c4efbc5f4d4df9ef23f9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5b",
                                                                "_id": "6077c4efbc5f4d4df9ef23fa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Combination (with repetition, without repetition), restricted combination",
                                                        "id": "5ace203d9fe7b01d5806c077",
                                                        "_id": "6077c4efbc5f4d4df9ef23f7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5c",
                                                                "_id": "6077c4efbc5f4d4df9ef23f8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De-arrangement principle",
                                                        "id": "5ace203d9fe7b01d5806c078",
                                                        "_id": "6077c4efbc5f4d4df9ef23f5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5d",
                                                                "_id": "6077c4efbc5f4d4df9ef23f6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distribution of things into boxes",
                                                        "id": "5ace203d9fe7b01d5806c079",
                                                        "_id": "6077c4efbc5f4d4df9ef23f3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5e",
                                                                "_id": "6077c4efbc5f4d4df9ef23f4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Divison into groups and distribution among persons",
                                                        "id": "5ace203d9fe7b01d5806c07a",
                                                        "_id": "6077c4efbc5f4d4df9ef23f1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db5f",
                                                                "_id": "6077c4efbc5f4d4df9ef23f2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental principle of counting (multiplication, addition rule)",
                                                        "id": "5ace203d9fe7b01d5806c07b",
                                                        "_id": "6077c4efbc5f4d4df9ef23ef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db60",
                                                                "_id": "6077c4efbc5f4d4df9ef23f0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Inclusion Exclusion Principle",
                                                        "id": "5ace203d9fe7b01d5806c07c",
                                                        "_id": "6077c4efbc5f4d4df9ef23ed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db61",
                                                                "_id": "6077c4efbc5f4d4df9ef23ee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear permutation (with repetition, without repetition), restricted permutation",
                                                        "id": "5ace203d9fe7b01d5806c07d",
                                                        "_id": "6077c4efbc5f4d4df9ef23eb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db62",
                                                                "_id": "6077c4efbc5f4d4df9ef23ec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Multinomial theorem",
                                                        "id": "5ace203d9fe7b01d5806c07e",
                                                        "_id": "6077c4efbc5f4d4df9ef23e9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db63",
                                                                "_id": "6077c4efbc5f4d4df9ef23ea"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Selection of atleast one thing and problems related to divisors, exponent of prime 'p' in n!",
                                                        "id": "5ace203d9fe7b01d5806c07f",
                                                        "_id": "6077c4efbc5f4d4df9ef23e7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db64",
                                                                "_id": "6077c4efbc5f4d4df9ef23e8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sum of division of a composite number",
                                                        "id": "5ace203d9fe7b01d5806c080",
                                                        "_id": "6077c4efbc5f4d4df9ef23e5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db65",
                                                                "_id": "6077c4efbc5f4d4df9ef23e6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "total no of divisors of a number",
                                                        "id": "5ace203d9fe7b01d5806c081",
                                                        "_id": "6077c4efbc5f4d4df9ef23e3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db66",
                                                                "_id": "6077c4efbc5f4d4df9ef23e4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d992",
                                                        "_id": "6077c4efbc5f4d4df9ef23ff"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef2490"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Conservation Of Momentum",
                                                "id": "5ace20329fe7b01d5806bca2",
                                                "_id": "6077c4efbc5f4d4df9ef23d1",
                                                "concepts": [
                                                    {
                                                        "name": "centre of mass",
                                                        "id": "5ace203f9fe7b01d5806c138",
                                                        "_id": "6077c4efbc5f4d4df9ef23de",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd6",
                                                                "_id": "6077c4efbc5f4d4df9ef23df"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "coefficient of restitution",
                                                        "id": "5ace203f9fe7b01d5806c139",
                                                        "_id": "6077c4efbc5f4d4df9ef23dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd7",
                                                                "_id": "6077c4efbc5f4d4df9ef23dd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Head on collision",
                                                        "id": "5ace203f9fe7b01d5806c13a",
                                                        "_id": "6077c4efbc5f4d4df9ef23da",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd8",
                                                                "_id": "6077c4efbc5f4d4df9ef23db"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Impulse momentum theorem",
                                                        "id": "5ace203f9fe7b01d5806c13b",
                                                        "_id": "6077c4efbc5f4d4df9ef23d8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddd9",
                                                                "_id": "6077c4efbc5f4d4df9ef23d9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "motion of centre of mass",
                                                        "id": "5ace203f9fe7b01d5806c13c",
                                                        "_id": "6077c4efbc5f4d4df9ef23d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673ddda",
                                                                "_id": "6077c4efbc5f4d4df9ef23d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Oblique collision",
                                                        "id": "5ace203f9fe7b01d5806c13d",
                                                        "_id": "6077c4efbc5f4d4df9ef23d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dddb",
                                                                "_id": "6077c4efbc5f4d4df9ef23d5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "variable mass system",
                                                        "id": "5ace203f9fe7b01d5806c13e",
                                                        "_id": "6077c4efbc5f4d4df9ef23d2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dddc",
                                                                "_id": "6077c4efbc5f4d4df9ef23d3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd62",
                                                        "_id": "6077c4efbc5f4d4df9ef23e0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Alternating Current",
                                                "id": "5eeb5f6cbb67ca2232c1e0ae",
                                                "_id": "6077c4efbc5f4d4df9ef23cf",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae6c",
                                                        "_id": "6077c4efbc5f4d4df9ef23d0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Sources of Energy",
                                                "id": "5ace20329fe7b01d5806bcb4",
                                                "_id": "6077c4efbc5f4d4df9ef23c5",
                                                "concepts": [
                                                    {
                                                        "name": "Characteristics of sources of energy & Renewable and Non-Renewable Forms of Energy",
                                                        "id": "5ace20409fe7b01d5806c1c8",
                                                        "_id": "6077c4efbc5f4d4df9ef23cc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c840f",
                                                                "_id": "6077c4efbc5f4d4df9ef23cd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types of Energy ( Solar, Wind, Hydro, Geo Thermal and Ocean Thermal)",
                                                        "id": "5ace20409fe7b01d5806c1cb",
                                                        "_id": "6077c4efbc5f4d4df9ef23ca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8410",
                                                                "_id": "6077c4efbc5f4d4df9ef23cb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fuels and its types & Characteristics of Fuels",
                                                        "id": "5ace20409fe7b01d5806c1c9",
                                                        "_id": "6077c4efbc5f4d4df9ef23c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8411",
                                                                "_id": "6077c4efbc5f4d4df9ef23c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Fssion, Nuclear Fusion & Nuclear Reactor",
                                                        "id": "5ace20409fe7b01d5806c1ca",
                                                        "_id": "6077c4efbc5f4d4df9ef23c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8412",
                                                                "_id": "6077c4efbc5f4d4df9ef23c7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8240",
                                                        "_id": "6077c4efbc5f4d4df9ef23ce"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Atoms",
                                                "id": "5eeb5f6cbb67ca2232c1e0b3",
                                                "_id": "6077c4efbc5f4d4df9ef23c3",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae6d",
                                                        "_id": "6077c4efbc5f4d4df9ef23c4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "LIGHT",
                                                "id": "5ace20329fe7b01d5806bcb0",
                                                "_id": "6077c4efbc5f4d4df9ef23b1",
                                                "concepts": [
                                                    {
                                                        "name": "Properties of Light & Laws of Reflection",
                                                        "id": "5ace20409fe7b01d5806c1ac",
                                                        "_id": "6077c4efbc5f4d4df9ef23c0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8413",
                                                                "_id": "6077c4efbc5f4d4df9ef23c1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plane Mirror, Rotation of mirror & Displacing object by a distance x",
                                                        "id": "5ace20409fe7b01d5806c1ab",
                                                        "_id": "6077c4efbc5f4d4df9ef23be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8414",
                                                                "_id": "6077c4efbc5f4d4df9ef23bf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Concave Mirror & Convex Mirror",
                                                        "id": "5ace20409fe7b01d5806c1aa",
                                                        "_id": "6077c4efbc5f4d4df9ef23bc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8415",
                                                                "_id": "6077c4efbc5f4d4df9ef23bd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Refractive Index and velocity when medium changes & Snell's Law",
                                                        "id": "5ace20409fe7b01d5806c1ae",
                                                        "_id": "6077c4efbc5f4d4df9ef23ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8416",
                                                                "_id": "6077c4efbc5f4d4df9ef23bb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Concave lens & Convex Lens",
                                                        "id": "5ace20409fe7b01d5806c1a9",
                                                        "_id": "6077c4efbc5f4d4df9ef23b8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8417",
                                                                "_id": "6077c4efbc5f4d4df9ef23b9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Combination of lens & Power of Lens",
                                                        "id": "5ace20409fe7b01d5806c1a8",
                                                        "_id": "6077c4efbc5f4d4df9ef23b6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8418",
                                                                "_id": "6077c4efbc5f4d4df9ef23b7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Real and Apparent Depth",
                                                        "id": "5ace20409fe7b01d5806c1ad",
                                                        "_id": "6077c4efbc5f4d4df9ef23b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8419",
                                                                "_id": "6077c4efbc5f4d4df9ef23b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Total Internal Reflection",
                                                        "id": "5ace20409fe7b01d5806c1af",
                                                        "_id": "6077c4efbc5f4d4df9ef23b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841a",
                                                                "_id": "6077c4efbc5f4d4df9ef23b3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8241",
                                                        "_id": "6077c4efbc5f4d4df9ef23c2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Kinematics",
                                                "id": "5ace20329fe7b01d5806bca4",
                                                "_id": "6077c4efbc5f4d4df9ef2397",
                                                "concepts": [
                                                    {
                                                        "name": "1-D motion with constant acceleration",
                                                        "id": "5ace203f9fe7b01d5806c144",
                                                        "_id": "6077c4efbc5f4d4df9ef23ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde2",
                                                                "_id": "6077c4efbc5f4d4df9ef23af"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "1-D motion with variable acceleration",
                                                        "id": "5ace203f9fe7b01d5806c145",
                                                        "_id": "6077c4efbc5f4d4df9ef23ac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde3",
                                                                "_id": "6077c4efbc5f4d4df9ef23ad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Free body diagram",
                                                        "id": "5ace203f9fe7b01d5806c146",
                                                        "_id": "6077c4efbc5f4d4df9ef23aa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde4",
                                                                "_id": "6077c4efbc5f4d4df9ef23ab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graphs in kinematics",
                                                        "id": "5ace203f9fe7b01d5806c147",
                                                        "_id": "6077c4efbc5f4d4df9ef23a8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde5",
                                                                "_id": "6077c4efbc5f4d4df9ef23a9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "non uniform circular motion",
                                                        "id": "5ace203f9fe7b01d5806c148",
                                                        "_id": "6077c4efbc5f4d4df9ef23a6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde6",
                                                                "_id": "6077c4efbc5f4d4df9ef23a7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Projectile Motion on horizontal plane",
                                                        "id": "5ace203f9fe7b01d5806c149",
                                                        "_id": "6077c4efbc5f4d4df9ef23a4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde7",
                                                                "_id": "6077c4efbc5f4d4df9ef23a5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "projectile motion on inclined plane",
                                                        "id": "5ace203f9fe7b01d5806c14a",
                                                        "_id": "6077c4efbc5f4d4df9ef23a2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde8",
                                                                "_id": "6077c4efbc5f4d4df9ef23a3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "rain man problem",
                                                        "id": "5ace203f9fe7b01d5806c14b",
                                                        "_id": "6077c4efbc5f4d4df9ef23a0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dde9",
                                                                "_id": "6077c4efbc5f4d4df9ef23a1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relative Motion",
                                                        "id": "5ace203f9fe7b01d5806c14c",
                                                        "_id": "6077c4efbc5f4d4df9ef239e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddea",
                                                                "_id": "6077c4efbc5f4d4df9ef239f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "river boat problem",
                                                        "id": "5ace203f9fe7b01d5806c14d",
                                                        "_id": "6077c4efbc5f4d4df9ef239c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddeb",
                                                                "_id": "6077c4efbc5f4d4df9ef239d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Uniform circular motion",
                                                        "id": "5ace203f9fe7b01d5806c14e",
                                                        "_id": "6077c4efbc5f4d4df9ef239a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddec",
                                                                "_id": "6077c4efbc5f4d4df9ef239b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Velocity of approach and separation, minimum distance of approach",
                                                        "id": "5ace203f9fe7b01d5806c14f",
                                                        "_id": "6077c4efbc5f4d4df9ef2398",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dded",
                                                                "_id": "6077c4efbc5f4d4df9ef2399"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd64",
                                                        "_id": "6077c4efbc5f4d4df9ef23b0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Nuclei",
                                                "id": "5eeb5f6cbb67ca2232c1e0b4",
                                                "_id": "6077c4efbc5f4d4df9ef2395",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f5f402c863d076508897df5",
                                                        "syllabusId": "5f76a73af29da5758fc4ae70",
                                                        "_id": "6077c4efbc5f4d4df9ef2396"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef23e1"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Data Sufficiency",
                                                "id": "5ace20309fe7b01d5806bc27",
                                                "_id": "6077c4efbc5f4d4df9ef2390",
                                                "concepts": [
                                                    {
                                                        "name": "Data Sufficiency",
                                                        "id": "5ace20389fe7b01d5806bf17",
                                                        "_id": "6077c4efbc5f4d4df9ef2391",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8430",
                                                                "_id": "6077c4efbc5f4d4df9ef2392"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c824f",
                                                        "_id": "6077c4efbc5f4d4df9ef2393"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Word Problems",
                                                "id": "5ace20319fe7b01d5806bc42",
                                                "_id": "6077c4efbc5f4d4df9ef238c",
                                                "concepts": [
                                                    {
                                                        "name": "Logical Sequence of Words",
                                                        "id": "5ace20399fe7b01d5806bf40",
                                                        "_id": "6077c4efbc5f4d4df9ef238d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8431",
                                                                "_id": "6077c4efbc5f4d4df9ef238e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8250",
                                                        "_id": "6077c4efbc5f4d4df9ef238f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ratio & Proportion",
                                                "id": "5ace20319fe7b01d5806bc3a",
                                                "_id": "6077c4efbc5f4d4df9ef2386",
                                                "concepts": [
                                                    {
                                                        "name": "Ratio & Proportion, Variation",
                                                        "id": "5ace20399fe7b01d5806bf35",
                                                        "_id": "6077c4efbc5f4d4df9ef2389",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8432",
                                                                "_id": "6077c4efbc5f4d4df9ef238a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Partnership",
                                                        "id": "5ace20399fe7b01d5806bf34",
                                                        "_id": "6077c4efbc5f4d4df9ef2387",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8433",
                                                                "_id": "6077c4efbc5f4d4df9ef2388"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8251",
                                                        "_id": "6077c4efbc5f4d4df9ef238b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Percentage",
                                                "id": "5ace20319fe7b01d5806bc35",
                                                "_id": "6077c4efbc5f4d4df9ef2382",
                                                "concepts": [
                                                    {
                                                        "name": "Percentages",
                                                        "id": "5ace20399fe7b01d5806bf27",
                                                        "_id": "6077c4efbc5f4d4df9ef2383",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8434",
                                                                "_id": "6077c4efbc5f4d4df9ef2384"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8252",
                                                        "_id": "6077c4efbc5f4d4df9ef2385"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Profit, Loss & Discount",
                                                "id": "5ace20319fe7b01d5806bc37",
                                                "_id": "6077c4efbc5f4d4df9ef237a",
                                                "concepts": [
                                                    {
                                                        "name": "Profit",
                                                        "id": "5ace20399fe7b01d5806bf2b",
                                                        "_id": "6077c4efbc5f4d4df9ef237f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8435",
                                                                "_id": "6077c4efbc5f4d4df9ef2380"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Loss",
                                                        "id": "5ace20399fe7b01d5806bf2a",
                                                        "_id": "6077c4efbc5f4d4df9ef237d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8436",
                                                                "_id": "6077c4efbc5f4d4df9ef237e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Discount",
                                                        "id": "5ace20399fe7b01d5806bf29",
                                                        "_id": "6077c4efbc5f4d4df9ef237b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8437",
                                                                "_id": "6077c4efbc5f4d4df9ef237c"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8253",
                                                        "_id": "6077c4efbc5f4d4df9ef2381"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef2394"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Clothig - A Social History",
                                                "id": "5ace20329fe7b01d5806bcd1",
                                                "_id": "6077c4efbc5f4d4df9ef2373",
                                                "concepts": [
                                                    {
                                                        "name": "Clothing pattern of France, USA after sumptuary laws",
                                                        "id": "5ace20419fe7b01d5806c209",
                                                        "_id": "6077c4efbc5f4d4df9ef2376",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847a",
                                                                "_id": "6077c4efbc5f4d4df9ef2377"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dress styles in India",
                                                        "id": "5ace20419fe7b01d5806c20a",
                                                        "_id": "6077c4efbc5f4d4df9ef2374",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847b",
                                                                "_id": "6077c4efbc5f4d4df9ef2375"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827c",
                                                        "_id": "6077c4efbc5f4d4df9ef2378"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "The Age of Industrialisation",
                                                "id": "5ace20329fe7b01d5806bcdb",
                                                "_id": "6077c4efbc5f4d4df9ef236d",
                                                "concepts": [
                                                    {
                                                        "name": "Industrialisation in Britain",
                                                        "id": "5ace20429fe7b01d5806c21f",
                                                        "_id": "6077c4efbc5f4d4df9ef2370",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847c",
                                                                "_id": "6077c4efbc5f4d4df9ef2371"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Process of industralisation in India",
                                                        "id": "5ace20429fe7b01d5806c220",
                                                        "_id": "6077c4efbc5f4d4df9ef236e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847d",
                                                                "_id": "6077c4efbc5f4d4df9ef236f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827d",
                                                        "_id": "6077c4efbc5f4d4df9ef2372"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "The Making of Global World",
                                                "id": "5ace20329fe7b01d5806bcdd",
                                                "_id": "6077c4efbc5f4d4df9ef2367",
                                                "concepts": [
                                                    {
                                                        "name": "Factors of globalisation in ancient period",
                                                        "id": "5ace20429fe7b01d5806c223",
                                                        "_id": "6077c4efbc5f4d4df9ef236a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847e",
                                                                "_id": "6077c4efbc5f4d4df9ef236b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Making of the modern world a global one",
                                                        "id": "5ace20429fe7b01d5806c224",
                                                        "_id": "6077c4efbc5f4d4df9ef2368",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c847f",
                                                                "_id": "6077c4efbc5f4d4df9ef2369"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827e",
                                                        "_id": "6077c4efbc5f4d4df9ef236c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Print Culture and the Modern World",
                                                "id": "5ace20329fe7b01d5806bcd9",
                                                "_id": "6077c4efbc5f4d4df9ef235f",
                                                "concepts": [
                                                    {
                                                        "name": "beginning of print in Asia",
                                                        "id": "5ace20429fe7b01d5806c21a",
                                                        "_id": "6077c4efbc5f4d4df9ef2364",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8480",
                                                                "_id": "6077c4efbc5f4d4df9ef2365"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Spread of print culture in Europe",
                                                        "id": "5ace20429fe7b01d5806c21c",
                                                        "_id": "6077c4efbc5f4d4df9ef2362",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8481",
                                                                "_id": "6077c4efbc5f4d4df9ef2363"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Print revolution in India",
                                                        "id": "5ace20429fe7b01d5806c21b",
                                                        "_id": "6077c4efbc5f4d4df9ef2360",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8482",
                                                                "_id": "6077c4efbc5f4d4df9ef2361"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c827f",
                                                        "_id": "6077c4efbc5f4d4df9ef2366"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Novels, Society and History",
                                                "id": "5ace20329fe7b01d5806bcd6",
                                                "_id": "6077c4efbc5f4d4df9ef2359",
                                                "concepts": [
                                                    {
                                                        "name": "Beginning of Novels in Europe",
                                                        "id": "5ace20419fe7b01d5806c212",
                                                        "_id": "6077c4efbc5f4d4df9ef235c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8483",
                                                                "_id": "6077c4efbc5f4d4df9ef235d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "History of writing of novels in India",
                                                        "id": "5ace20419fe7b01d5806c213",
                                                        "_id": "6077c4efbc5f4d4df9ef235a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8484",
                                                                "_id": "6077c4efbc5f4d4df9ef235b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8280",
                                                        "_id": "6077c4efbc5f4d4df9ef235e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Work, Life and Leisure",
                                                "id": "5ace20329fe7b01d5806bce0",
                                                "_id": "6077c4efbc5f4d4df9ef2353",
                                                "concepts": [
                                                    {
                                                        "name": "Process of urbanisation and its impact in England",
                                                        "id": "5ace20429fe7b01d5806c229",
                                                        "_id": "6077c4efbc5f4d4df9ef2356",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8485",
                                                                "_id": "6077c4efbc5f4d4df9ef2357"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Urbanisation in Bombay and its impacts",
                                                        "id": "5ace20429fe7b01d5806c22a",
                                                        "_id": "6077c4efbc5f4d4df9ef2354",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8486",
                                                                "_id": "6077c4efbc5f4d4df9ef2355"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8281",
                                                        "_id": "6077c4efbc5f4d4df9ef2358"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef2379"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Figure Matrix",
                                                "id": "5ace20309fe7b01d5806bc17",
                                                "_id": "6077c4efbc5f4d4df9ef234e",
                                                "concepts": [
                                                    {
                                                        "name": "Figure Matrix",
                                                        "id": "5ace20389fe7b01d5806bf01",
                                                        "_id": "6077c4efbc5f4d4df9ef234f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df46",
                                                                "_id": "6077c4efbc5f4d4df9ef2350"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df38",
                                                        "_id": "6077c4efbc5f4d4df9ef2351"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef2352"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "subjects": [
                            {
                                "name": "Biology",
                                "id": "5ace202e9fe7b01d5806bb89",
                                "chapterCount": 5
                            },
                            {
                                "name": "Chemistry",
                                "id": "5ace202e9fe7b01d5806bb8a",
                                "chapterCount": 5
                            },
                            {
                                "name": "Mathematics",
                                "id": "5ace202e9fe7b01d5806bb8e",
                                "chapterCount": 89
                            },
                            {
                                "name": "Physics",
                                "id": "5ace202e9fe7b01d5806bb8f",
                                "chapterCount": 31
                            },
                            {
                                "name": "MAT",
                                "id": "5ace202e9fe7b01d5806bb8d",
                                "chapterCount": 17
                            },
                            {
                                "name": "Social Science",
                                "id": "5ace202e9fe7b01d5806bb90",
                                "chapterCount": 26
                            },
                            {
                                "name": "LOGICAL REASONING",
                                "id": "5ace202e9fe7b01d5806bb8c",
                                "chapterCount": 5
                            }
                        ],
                        "isRevision": false,
                        "description": ""
                    },
                    {
                        "name": "phase 2",
                        "startDate": "2021-06-03T00:00:00.000Z",
                        "endDate": "2021-07-21T00:00:00.000Z",
                        "_id": "6077c4eebc5f4d4df9ef1b45",
                        "milestoneTests": [],
                        "weeks": [
                            {
                                "weekNo": 6,
                                "startDate": "2021-06-03T00:00:00.000Z",
                                "endDate": "2021-06-09T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef2252",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Improvement in Food Resources",
                                                "id": "5ace202f9fe7b01d5806bbbf",
                                                "_id": "6077c4efbc5f4d4df9ef233b",
                                                "concepts": [
                                                    {
                                                        "name": "Crop variety improvement & hybrid vigour",
                                                        "id": "5ace20339fe7b01d5806bd2a",
                                                        "_id": "6077c4efbc5f4d4df9ef2348",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82dc",
                                                                "_id": "6077c4efbc5f4d4df9ef2349"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nutrients",
                                                        "id": "5ace20339fe7b01d5806bd2e",
                                                        "_id": "6077c4efbc5f4d4df9ef2346",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82dd",
                                                                "_id": "6077c4efbc5f4d4df9ef2347"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fertilizers & Manures",
                                                        "id": "5ace20339fe7b01d5806bd2c",
                                                        "_id": "6077c4efbc5f4d4df9ef2344",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82de",
                                                                "_id": "6077c4efbc5f4d4df9ef2345"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Irrigation methods",
                                                        "id": "5ace20339fe7b01d5806bd2d",
                                                        "_id": "6077c4efbc5f4d4df9ef2342",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82df",
                                                                "_id": "6077c4efbc5f4d4df9ef2343"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cropping pattern",
                                                        "id": "5ace20339fe7b01d5806bd2b",
                                                        "_id": "6077c4efbc5f4d4df9ef2340",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e0",
                                                                "_id": "6077c4efbc5f4d4df9ef2341"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Crop protection management",
                                                        "id": "5ace20339fe7b01d5806bd29",
                                                        "_id": "6077c4efbc5f4d4df9ef233e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e1",
                                                                "_id": "6077c4efbc5f4d4df9ef233f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Animal husbandry",
                                                        "id": "5ace20339fe7b01d5806bd28",
                                                        "_id": "6077c4efbc5f4d4df9ef233c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e2",
                                                                "_id": "6077c4efbc5f4d4df9ef233d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820c",
                                                        "_id": "6077c4efbc5f4d4df9ef234a"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef234b"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Acid Base And Salts",
                                                "id": "5ace202f9fe7b01d5806bbc6",
                                                "_id": "6077c4efbc5f4d4df9ef2328",
                                                "concepts": [
                                                    {
                                                        "name": "Definition of Acid And Base",
                                                        "id": "5ace20339fe7b01d5806bd6d",
                                                        "_id": "6077c4efbc5f4d4df9ef2337",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8343",
                                                                "_id": "6077c4efbc5f4d4df9ef2338"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reaction Of Acid With Metals, Oxygen, Water and Salts",
                                                        "id": "5ace20339fe7b01d5806bd70",
                                                        "_id": "6077c4efbc5f4d4df9ef2335",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8344",
                                                                "_id": "6077c4efbc5f4d4df9ef2336"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reactions Of Bases",
                                                        "id": "5ace20339fe7b01d5806bd71",
                                                        "_id": "6077c4efbc5f4d4df9ef2333",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8345",
                                                                "_id": "6077c4efbc5f4d4df9ef2334"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories of acids & bases - Arrhenius concept",
                                                        "id": "5ace20339fe7b01d5806bd72",
                                                        "_id": "6077c4efbc5f4d4df9ef2331",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8346",
                                                                "_id": "6077c4efbc5f4d4df9ef2332"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories of acids & bases - Bronsted Lowry concept",
                                                        "id": "5ace20339fe7b01d5806bd73",
                                                        "_id": "6077c4efbc5f4d4df9ef232f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8347",
                                                                "_id": "6077c4efbc5f4d4df9ef2330"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories of acids & bases - Lewis concept",
                                                        "id": "5ace20349fe7b01d5806bd74",
                                                        "_id": "6077c4efbc5f4d4df9ef232d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8348",
                                                                "_id": "6077c4efbc5f4d4df9ef232e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "pH Scale",
                                                        "id": "5ace20339fe7b01d5806bd6f",
                                                        "_id": "6077c4efbc5f4d4df9ef232b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8349",
                                                                "_id": "6077c4efbc5f4d4df9ef232c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different types of Salts",
                                                        "id": "5ace20339fe7b01d5806bd6e",
                                                        "_id": "6077c4efbc5f4d4df9ef2329",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834a",
                                                                "_id": "6077c4efbc5f4d4df9ef232a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8217",
                                                        "_id": "6077c4efbc5f4d4df9ef2339"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef233a"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Probability",
                                                "id": "5ace20319fe7b01d5806bc8a",
                                                "_id": "6077c4efbc5f4d4df9ef2325",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d993",
                                                        "_id": "6077c4efbc5f4d4df9ef2326"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability",
                                                "id": "5ace20319fe7b01d5806bc8b",
                                                "_id": "6077c4efbc5f4d4df9ef22ff",
                                                "concepts": [
                                                    {
                                                        "name": "Addition theorem of probability",
                                                        "id": "5ace203d9fe7b01d5806c082",
                                                        "_id": "6077c4efbc5f4d4df9ef2322",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db67",
                                                                "_id": "6077c4efbc5f4d4df9ef2323"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Addition theorem of probability",
                                                        "id": "5ace203d9fe7b01d5806c083",
                                                        "_id": "6077c4efbc5f4d4df9ef2320",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db68",
                                                                "_id": "6077c4efbc5f4d4df9ef2321"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Binomial theorem on probability, Binomial distribution",
                                                        "id": "5ace203d9fe7b01d5806c084",
                                                        "_id": "6077c4efbc5f4d4df9ef231e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db69",
                                                                "_id": "6077c4efbc5f4d4df9ef231f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classical definition of probability",
                                                        "id": "5ace203d9fe7b01d5806c085",
                                                        "_id": "6077c4efbc5f4d4df9ef231c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6a",
                                                                "_id": "6077c4efbc5f4d4df9ef231d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Exhaustive events",
                                                        "id": "5ace203d9fe7b01d5806c086",
                                                        "_id": "6077c4efbc5f4d4df9ef231a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6b",
                                                                "_id": "6077c4efbc5f4d4df9ef231b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Multinomial theorem on probablity",
                                                        "id": "5ace203d9fe7b01d5806c087",
                                                        "_id": "6077c4efbc5f4d4df9ef2318",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6c",
                                                                "_id": "6077c4efbc5f4d4df9ef2319"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mutually exclusive events",
                                                        "id": "5ace203d9fe7b01d5806c088",
                                                        "_id": "6077c4efbc5f4d4df9ef2316",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6d",
                                                                "_id": "6077c4efbc5f4d4df9ef2317"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Bay`s theorem",
                                                        "id": "5ace203d9fe7b01d5806c089",
                                                        "_id": "6077c4efbc5f4d4df9ef2314",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6e",
                                                                "_id": "6077c4efbc5f4d4df9ef2315"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Compound probablity",
                                                        "id": "5ace203d9fe7b01d5806c08a",
                                                        "_id": "6077c4efbc5f4d4df9ef2312",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db6f",
                                                                "_id": "6077c4efbc5f4d4df9ef2313"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Conditional probablity",
                                                        "id": "5ace203d9fe7b01d5806c08b",
                                                        "_id": "6077c4efbc5f4d4df9ef2310",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db70",
                                                                "_id": "6077c4efbc5f4d4df9ef2311"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on equally likely events,",
                                                        "id": "5ace203d9fe7b01d5806c08c",
                                                        "_id": "6077c4efbc5f4d4df9ef230e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db71",
                                                                "_id": "6077c4efbc5f4d4df9ef230f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on independent events,",
                                                        "id": "5ace203d9fe7b01d5806c08d",
                                                        "_id": "6077c4efbc5f4d4df9ef230c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db72",
                                                                "_id": "6077c4efbc5f4d4df9ef230d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on mixed events",
                                                        "id": "5ace203d9fe7b01d5806c08e",
                                                        "_id": "6077c4efbc5f4d4df9ef230a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db73",
                                                                "_id": "6077c4efbc5f4d4df9ef230b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on mutually exclusive events, exhaustive events,",
                                                        "id": "5ace203d9fe7b01d5806c08f",
                                                        "_id": "6077c4efbc5f4d4df9ef2308",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db74",
                                                                "_id": "6077c4efbc5f4d4df9ef2309"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on repeated trials",
                                                        "id": "5ace203d9fe7b01d5806c090",
                                                        "_id": "6077c4efbc5f4d4df9ef2306",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db75",
                                                                "_id": "6077c4efbc5f4d4df9ef2307"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Total probability theorem",
                                                        "id": "5ace203d9fe7b01d5806c091",
                                                        "_id": "6077c4efbc5f4d4df9ef2304",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db76",
                                                                "_id": "6077c4efbc5f4d4df9ef2305"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on sample space, classsical definition of probability, complementary events",
                                                        "id": "5ace203d9fe7b01d5806c092",
                                                        "_id": "6077c4efbc5f4d4df9ef2302",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db77",
                                                                "_id": "6077c4efbc5f4d4df9ef2303"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Random variable",
                                                        "id": "5ace203d9fe7b01d5806c093",
                                                        "_id": "6077c4efbc5f4d4df9ef2300",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db78",
                                                                "_id": "6077c4efbc5f4d4df9ef2301"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d994",
                                                        "_id": "6077c4efbc5f4d4df9ef2324"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics",
                                                "id": "5ace20319fe7b01d5806bc8c",
                                                "_id": "6077c4efbc5f4d4df9ef22f9",
                                                "concepts": [
                                                    {
                                                        "name": "Calculation of mean, median, mode of grouped and ungrouped data",
                                                        "id": "5ace203d9fe7b01d5806c094",
                                                        "_id": "6077c4efbc5f4d4df9ef22fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db79",
                                                                "_id": "6077c4efbc5f4d4df9ef22fd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Calculation of standard deviation, variance and mean deviation for grouped and ungrouped data",
                                                        "id": "5ace203d9fe7b01d5806c095",
                                                        "_id": "6077c4efbc5f4d4df9ef22fa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7a",
                                                                "_id": "6077c4efbc5f4d4df9ef22fb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d995",
                                                        "_id": "6077c4efbc5f4d4df9ef22fe"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Heights & Distances",
                                                "id": "5ace20319fe7b01d5806bc8d",
                                                "_id": "6077c4efbc5f4d4df9ef22f1",
                                                "concepts": [
                                                    {
                                                        "name": "Problems based on angle of elevation, angle of depression",
                                                        "id": "5ace203d9fe7b01d5806c096",
                                                        "_id": "6077c4efbc5f4d4df9ef22f6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7b",
                                                                "_id": "6077c4efbc5f4d4df9ef22f7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems related to 2-Dimensional",
                                                        "id": "5ace203d9fe7b01d5806c097",
                                                        "_id": "6077c4efbc5f4d4df9ef22f4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7c",
                                                                "_id": "6077c4efbc5f4d4df9ef22f5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems related to 3-Dimensional",
                                                        "id": "5ace203d9fe7b01d5806c098",
                                                        "_id": "6077c4efbc5f4d4df9ef22f2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7d",
                                                                "_id": "6077c4efbc5f4d4df9ef22f3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d996",
                                                        "_id": "6077c4efbc5f4d4df9ef22f8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Inverse Trigonometry",
                                                "id": "5ace20319fe7b01d5806bc8e",
                                                "_id": "6077c4efbc5f4d4df9ef22e9",
                                                "concepts": [
                                                    {
                                                        "name": "Inequalities, Maximum and minimum values",
                                                        "id": "5ace203d9fe7b01d5806c099",
                                                        "_id": "6077c4efbc5f4d4df9ef22ee",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7e",
                                                                "_id": "6077c4efbc5f4d4df9ef22ef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on -Definition of inverse functions, Domain and Range, Graphs of inverse functions, properties of inverse functions",
                                                        "id": "5ace203d9fe7b01d5806c09a",
                                                        "_id": "6077c4efbc5f4d4df9ef22ec",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db7f",
                                                                "_id": "6077c4efbc5f4d4df9ef22ed"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sum of series, Solution of Inverse trigonometric Equations",
                                                        "id": "5ace203d9fe7b01d5806c09b",
                                                        "_id": "6077c4efbc5f4d4df9ef22ea",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db80",
                                                                "_id": "6077c4efbc5f4d4df9ef22eb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d997",
                                                        "_id": "6077c4efbc5f4d4df9ef22f0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Inverse Trigonometry /Inverse Circular Function",
                                                "id": "5ace20319fe7b01d5806bc8f",
                                                "_id": "6077c4efbc5f4d4df9ef22dd",
                                                "concepts": [
                                                    {
                                                        "name": "Conversion of one ICF to other",
                                                        "id": "5ace203d9fe7b01d5806c09c",
                                                        "_id": "6077c4efbc5f4d4df9ef22e6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db81",
                                                                "_id": "6077c4efbc5f4d4df9ef22e7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Inverse circular Function - domain & range",
                                                        "id": "5ace203d9fe7b01d5806c09d",
                                                        "_id": "6077c4efbc5f4d4df9ef22e4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db82",
                                                                "_id": "6077c4efbc5f4d4df9ef22e5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "problems based on inverse trigonometric function of trigonometric functions",
                                                        "id": "5ace203d9fe7b01d5806c09e",
                                                        "_id": "6077c4efbc5f4d4df9ef22e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db83",
                                                                "_id": "6077c4efbc5f4d4df9ef22e3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "problems based on trigonometric functions of inverse trigonometric function",
                                                        "id": "5ace203d9fe7b01d5806c09f",
                                                        "_id": "6077c4efbc5f4d4df9ef22e0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db84",
                                                                "_id": "6077c4efbc5f4d4df9ef22e1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "sum & Difference of Two or more ICFs",
                                                        "id": "5ace203d9fe7b01d5806c0a0",
                                                        "_id": "6077c4efbc5f4d4df9ef22de",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db85",
                                                                "_id": "6077c4efbc5f4d4df9ef22df"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d998",
                                                        "_id": "6077c4efbc5f4d4df9ef22e8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Solution of Triangle",
                                                "id": "5ace20319fe7b01d5806bc90",
                                                "_id": "6077c4efbc5f4d4df9ef22db",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d999",
                                                        "_id": "6077c4efbc5f4d4df9ef22dc"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Solution of Triangle",
                                                "id": "5ace20319fe7b01d5806bc91",
                                                "_id": "6077c4efbc5f4d4df9ef22c1",
                                                "concepts": [
                                                    {
                                                        "name": "Circles circumscribing or inscribing a regular Polygon",
                                                        "id": "5ace203d9fe7b01d5806c0a1",
                                                        "_id": "6077c4efbc5f4d4df9ef22d8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db86",
                                                                "_id": "6077c4efbc5f4d4df9ef22d9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Circles Connected with a Triangle - Circumcircle, Incircle, Escribed Circles",
                                                        "id": "5ace203d9fe7b01d5806c0a2",
                                                        "_id": "6077c4efbc5f4d4df9ef22d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db87",
                                                                "_id": "6077c4efbc5f4d4df9ef22d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "cyclic quadrilaterals",
                                                        "id": "5ace203d9fe7b01d5806c0a3",
                                                        "_id": "6077c4efbc5f4d4df9ef22d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db88",
                                                                "_id": "6077c4efbc5f4d4df9ef22d5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance of Circumcentre, incentre, orthocentre, centroid and ex-centre from the sides and vertices of the triangle, Distance between circumcentre and orthocentre, circmucentre and incentre, circum centre and excentre, Apolloneus theorem, length of median",
                                                        "id": "5ace203d9fe7b01d5806c0a4",
                                                        "_id": "6077c4efbc5f4d4df9ef22d2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db89",
                                                                "_id": "6077c4efbc5f4d4df9ef22d3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Half angle formula",
                                                        "id": "5ace203d9fe7b01d5806c0a5",
                                                        "_id": "6077c4efbc5f4d4df9ef22d0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8a",
                                                                "_id": "6077c4efbc5f4d4df9ef22d1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on Heron's formula, Area of triangle",
                                                        "id": "5ace203d9fe7b01d5806c0a6",
                                                        "_id": "6077c4efbc5f4d4df9ef22ce",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8b",
                                                                "_id": "6077c4efbc5f4d4df9ef22cf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problem based on m-n theorem",
                                                        "id": "5ace203d9fe7b01d5806c0a7",
                                                        "_id": "6077c4efbc5f4d4df9ef22cc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8c",
                                                                "_id": "6077c4efbc5f4d4df9ef22cd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Projection formula, Napier's Analogy",
                                                        "id": "5ace203d9fe7b01d5806c0a8",
                                                        "_id": "6077c4efbc5f4d4df9ef22ca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8d",
                                                                "_id": "6077c4efbc5f4d4df9ef22cb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sine Rule, Cosine Rule",
                                                        "id": "5ace203d9fe7b01d5806c0a9",
                                                        "_id": "6077c4efbc5f4d4df9ef22c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8e",
                                                                "_id": "6077c4efbc5f4d4df9ef22c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "solution of Triangle - Two angles and included side are given",
                                                        "id": "5ace203d9fe7b01d5806c0aa",
                                                        "_id": "6077c4efbc5f4d4df9ef22c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db8f",
                                                                "_id": "6077c4efbc5f4d4df9ef22c7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "solution of Triangle - Two sides and included angle are given",
                                                        "id": "5ace203d9fe7b01d5806c0ab",
                                                        "_id": "6077c4efbc5f4d4df9ef22c4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db90",
                                                                "_id": "6077c4efbc5f4d4df9ef22c5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Triangle including ambiguous cases",
                                                        "id": "5ace203d9fe7b01d5806c0ac",
                                                        "_id": "6077c4efbc5f4d4df9ef22c2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db91",
                                                                "_id": "6077c4efbc5f4d4df9ef22c3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d99a",
                                                        "_id": "6077c4efbc5f4d4df9ef22da"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Trigonometric Equations",
                                                "id": "5ace20319fe7b01d5806bc92",
                                                "_id": "6077c4efbc5f4d4df9ef22bf",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d99b",
                                                        "_id": "6077c4efbc5f4d4df9ef22c0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Trigonometric Equations",
                                                "id": "5ace20329fe7b01d5806bc93",
                                                "_id": "6077c4efbc5f4d4df9ef22ad",
                                                "concepts": [
                                                    {
                                                        "name": "Inequalities, Problems based on extreme values",
                                                        "id": "5ace203d9fe7b01d5806c0ad",
                                                        "_id": "6077c4efbc5f4d4df9ef22bc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db92",
                                                                "_id": "6077c4efbc5f4d4df9ef22bd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Simultaneous trigonometric equation - in one variable",
                                                        "id": "5ace203d9fe7b01d5806c0ae",
                                                        "_id": "6077c4efbc5f4d4df9ef22ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db93",
                                                                "_id": "6077c4efbc5f4d4df9ef22bb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Simultaneous trigonometric equation - in two variable",
                                                        "id": "5ace203d9fe7b01d5806c0af",
                                                        "_id": "6077c4efbc5f4d4df9ef22b8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db94",
                                                                "_id": "6077c4efbc5f4d4df9ef22b9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Trigonometric Equations - based on extreme values of Trigonometric ratios",
                                                        "id": "5ace203d9fe7b01d5806c0b0",
                                                        "_id": "6077c4efbc5f4d4df9ef22b6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db95",
                                                                "_id": "6077c4efbc5f4d4df9ef22b7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Trigonometric Equations - General Solution",
                                                        "id": "5ace203d9fe7b01d5806c0b1",
                                                        "_id": "6077c4efbc5f4d4df9ef22b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db96",
                                                                "_id": "6077c4efbc5f4d4df9ef22b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Trigonometric Equations - in a given Interval",
                                                        "id": "5ace203d9fe7b01d5806c0b2",
                                                        "_id": "6077c4efbc5f4d4df9ef22b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db97",
                                                                "_id": "6077c4efbc5f4d4df9ef22b3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution of Trigonometric Equations - Priciple values",
                                                        "id": "5ace203d9fe7b01d5806c0b3",
                                                        "_id": "6077c4efbc5f4d4df9ef22b0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db98",
                                                                "_id": "6077c4efbc5f4d4df9ef22b1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Inequation",
                                                        "id": "5ace203d9fe7b01d5806c0b4",
                                                        "_id": "6077c4efbc5f4d4df9ef22ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db99",
                                                                "_id": "6077c4efbc5f4d4df9ef22af"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d99c",
                                                        "_id": "6077c4efbc5f4d4df9ef22be"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef2327"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "HUMAN EYE",
                                                "id": "5ace20329fe7b01d5806bcae",
                                                "_id": "6077c4efbc5f4d4df9ef22a0",
                                                "concepts": [
                                                    {
                                                        "name": "Human Eye & Defects of Vision",
                                                        "id": "5ace20409fe7b01d5806c19d",
                                                        "_id": "6077c4efbc5f4d4df9ef22a9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841b",
                                                                "_id": "6077c4efbc5f4d4df9ef22aa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dispersion & Prism",
                                                        "id": "5ace20409fe7b01d5806c19c",
                                                        "_id": "6077c4efbc5f4d4df9ef22a7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841c",
                                                                "_id": "6077c4efbc5f4d4df9ef22a8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Atmospheric Refraction & Scattering of Light",
                                                        "id": "5ace20409fe7b01d5806c19b",
                                                        "_id": "6077c4efbc5f4d4df9ef22a5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841d",
                                                                "_id": "6077c4efbc5f4d4df9ef22a6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mirror Formula & Lens Formula",
                                                        "id": "5ace20409fe7b01d5806c19e",
                                                        "_id": "6077c4efbc5f4d4df9ef22a3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841e",
                                                                "_id": "6077c4efbc5f4d4df9ef22a4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple Microscope",
                                                        "id": "5ace20409fe7b01d5806c19f",
                                                        "_id": "6077c4efbc5f4d4df9ef22a1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c841f",
                                                                "_id": "6077c4efbc5f4d4df9ef22a2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8242",
                                                        "_id": "6077c4efbc5f4d4df9ef22ab"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Rotational Motion",
                                                "id": "5ace20329fe7b01d5806bca6",
                                                "_id": "6077c4efbc5f4d4df9ef2286",
                                                "concepts": [
                                                    {
                                                        "name": "angular momentum and conservation of angular momentum",
                                                        "id": "5ace203f9fe7b01d5806c15a",
                                                        "_id": "6077c4efbc5f4d4df9ef229d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddf8",
                                                                "_id": "6077c4efbc5f4d4df9ef229e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Hinge reaction",
                                                        "id": "5ace203f9fe7b01d5806c15b",
                                                        "_id": "6077c4efbc5f4d4df9ef229b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddf9",
                                                                "_id": "6077c4efbc5f4d4df9ef229c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Instantaneous axis of rotation",
                                                        "id": "5ace203f9fe7b01d5806c15c",
                                                        "_id": "6077c4efbc5f4d4df9ef2299",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddfa",
                                                                "_id": "6077c4efbc5f4d4df9ef229a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "kinetic energy of a body performing combined motion",
                                                        "id": "5ace203f9fe7b01d5806c15d",
                                                        "_id": "6077c4efbc5f4d4df9ef2297",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddfb",
                                                                "_id": "6077c4efbc5f4d4df9ef2298"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Moment of inertia of discrete and distributed mass",
                                                        "id": "5ace203f9fe7b01d5806c15e",
                                                        "_id": "6077c4efbc5f4d4df9ef2295",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddfc",
                                                                "_id": "6077c4efbc5f4d4df9ef2296"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parallel and perpendicular axis theorem",
                                                        "id": "5ace203f9fe7b01d5806c15f",
                                                        "_id": "6077c4efbc5f4d4df9ef2293",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddfd",
                                                                "_id": "6077c4efbc5f4d4df9ef2294"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pure Rotation Motion",
                                                        "id": "5ace203f9fe7b01d5806c160",
                                                        "_id": "6077c4efbc5f4d4df9ef2291",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddfe",
                                                                "_id": "6077c4efbc5f4d4df9ef2292"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "rolling on horizontal surface",
                                                        "id": "5ace203f9fe7b01d5806c161",
                                                        "_id": "6077c4efbc5f4d4df9ef228f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ddff",
                                                                "_id": "6077c4efbc5f4d4df9ef2290"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "rolling on inclined plane and toppling",
                                                        "id": "5ace203f9fe7b01d5806c162",
                                                        "_id": "6077c4efbc5f4d4df9ef228d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de00",
                                                                "_id": "6077c4efbc5f4d4df9ef228e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "torque",
                                                        "id": "5ace203f9fe7b01d5806c163",
                                                        "_id": "6077c4efbc5f4d4df9ef228b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de01",
                                                                "_id": "6077c4efbc5f4d4df9ef228c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "velocity and acceleration of a body performing combined motion",
                                                        "id": "5ace203f9fe7b01d5806c164",
                                                        "_id": "6077c4efbc5f4d4df9ef2289",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de02",
                                                                "_id": "6077c4efbc5f4d4df9ef228a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "work energy theorem in rotation motion",
                                                        "id": "5ace203f9fe7b01d5806c165",
                                                        "_id": "6077c4efbc5f4d4df9ef2287",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de03",
                                                                "_id": "6077c4efbc5f4d4df9ef2288"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd66",
                                                        "_id": "6077c4efbc5f4d4df9ef229f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Work Power and Energy",
                                                "id": "5ace20329fe7b01d5806bca7",
                                                "_id": "6077c4efbc5f4d4df9ef2276",
                                                "concepts": [
                                                    {
                                                        "name": "Conservation of mechanical energy and Conservative forces",
                                                        "id": "5ace203f9fe7b01d5806c166",
                                                        "_id": "6077c4efbc5f4d4df9ef2283",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de04",
                                                                "_id": "6077c4efbc5f4d4df9ef2284"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Motion in vertical circle",
                                                        "id": "5ace203f9fe7b01d5806c167",
                                                        "_id": "6077c4efbc5f4d4df9ef2281",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de05",
                                                                "_id": "6077c4efbc5f4d4df9ef2282"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Potential Energy",
                                                        "id": "5ace203f9fe7b01d5806c168",
                                                        "_id": "6077c4efbc5f4d4df9ef227f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de06",
                                                                "_id": "6077c4efbc5f4d4df9ef2280"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Power",
                                                        "id": "5ace203f9fe7b01d5806c169",
                                                        "_id": "6077c4efbc5f4d4df9ef227d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de07",
                                                                "_id": "6077c4efbc5f4d4df9ef227e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Work",
                                                        "id": "5ace203f9fe7b01d5806c16a",
                                                        "_id": "6077c4efbc5f4d4df9ef227b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de08",
                                                                "_id": "6077c4efbc5f4d4df9ef227c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Work energy theorem for a single particle system",
                                                        "id": "5ace203f9fe7b01d5806c16b",
                                                        "_id": "6077c4efbc5f4d4df9ef2279",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de09",
                                                                "_id": "6077c4efbc5f4d4df9ef227a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "work energy theorem for multiple particle system",
                                                        "id": "5ace203f9fe7b01d5806c16c",
                                                        "_id": "6077c4efbc5f4d4df9ef2277",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0a",
                                                                "_id": "6077c4efbc5f4d4df9ef2278"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd67",
                                                        "_id": "6077c4efbc5f4d4df9ef2285"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Modern Physics",
                                                "id": "5ace20329fe7b01d5806bca8",
                                                "_id": "6077c4efbc5f4d4df9ef2274",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd68",
                                                        "_id": "6077c4efbc5f4d4df9ef2275"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef22ac"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Mixtures, Alligations & Averages",
                                                "id": "5ace20319fe7b01d5806bc32",
                                                "_id": "6077c4efbc5f4d4df9ef226d",
                                                "concepts": [
                                                    {
                                                        "name": "Alligations & Mixtures",
                                                        "id": "5ace20389fe7b01d5806bf22",
                                                        "_id": "6077c4efbc5f4d4df9ef2270",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8438",
                                                                "_id": "6077c4efbc5f4d4df9ef2271"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Averages",
                                                        "id": "5ace20399fe7b01d5806bf23",
                                                        "_id": "6077c4efbc5f4d4df9ef226e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8439",
                                                                "_id": "6077c4efbc5f4d4df9ef226f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8254",
                                                        "_id": "6077c4efbc5f4d4df9ef2272"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Clocks",
                                                "id": "5ace20309fe7b01d5806bc23",
                                                "_id": "6077c4efbc5f4d4df9ef2269",
                                                "concepts": [
                                                    {
                                                        "name": "Clocks",
                                                        "id": "5ace20389fe7b01d5806bf11",
                                                        "_id": "6077c4efbc5f4d4df9ef226a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843a",
                                                                "_id": "6077c4efbc5f4d4df9ef226b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8255",
                                                        "_id": "6077c4efbc5f4d4df9ef226c"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef2273"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "The Rise of Nationalism in Europe",
                                                "id": "5ace20329fe7b01d5806bcdf",
                                                "_id": "6077c4efbc5f4d4df9ef2262",
                                                "concepts": [
                                                    {
                                                        "name": "French Revolution and its impact",
                                                        "id": "5ace20429fe7b01d5806c227",
                                                        "_id": "6077c4efbc5f4d4df9ef2265",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8487",
                                                                "_id": "6077c4efbc5f4d4df9ef2266"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Unification of Germany, Italy and UK",
                                                        "id": "5ace20429fe7b01d5806c228",
                                                        "_id": "6077c4efbc5f4d4df9ef2263",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8488",
                                                                "_id": "6077c4efbc5f4d4df9ef2264"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8282",
                                                        "_id": "6077c4efbc5f4d4df9ef2267"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "The Naitonal Movement in Indo-China",
                                                "id": "5ace20329fe7b01d5806bcde",
                                                "_id": "6077c4efbc5f4d4df9ef225c",
                                                "concepts": [
                                                    {
                                                        "name": "Occupation of Vietnam by French",
                                                        "id": "5ace20429fe7b01d5806c225",
                                                        "_id": "6077c4efbc5f4d4df9ef225f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8489",
                                                                "_id": "6077c4efbc5f4d4df9ef2260"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vietnamese war with France and USA",
                                                        "id": "5ace20429fe7b01d5806c226",
                                                        "_id": "6077c4efbc5f4d4df9ef225d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848a",
                                                                "_id": "6077c4efbc5f4d4df9ef225e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8283",
                                                        "_id": "6077c4efbc5f4d4df9ef2261"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Nationalism in India",
                                                "id": "5ace20329fe7b01d5806bcd4",
                                                "_id": "6077c4efbc5f4d4df9ef2258",
                                                "concepts": [
                                                    {
                                                        "name": "Indian nationalism under congress before Gandhi\nIndian nationalism under congress with Gandhi",
                                                        "id": "5ace20419fe7b01d5806c20f",
                                                        "_id": "6077c4efbc5f4d4df9ef2259",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848b",
                                                                "_id": "6077c4efbc5f4d4df9ef225a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8284",
                                                        "_id": "6077c4efbc5f4d4df9ef225b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef2268"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Logical Deduction",
                                                "id": "5ace20309fe7b01d5806bc18",
                                                "_id": "6077c4efbc5f4d4df9ef2253",
                                                "concepts": [
                                                    {
                                                        "name": "Syllogism",
                                                        "id": "5ace20389fe7b01d5806bf02",
                                                        "_id": "6077c4efbc5f4d4df9ef2254",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df47",
                                                                "_id": "6077c4efbc5f4d4df9ef2255"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df39",
                                                        "_id": "6077c4efbc5f4d4df9ef2256"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef2257"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 7,
                                "startDate": "2021-06-10T00:00:00.000Z",
                                "endDate": "2021-06-16T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef2100",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Life Processes",
                                                "id": "5ace202f9fe7b01d5806bbc0",
                                                "_id": "6077c4efbc5f4d4df9ef2221",
                                                "concepts": [
                                                    {
                                                        "name": "Nutrition, Types of nutrition, Nutrients and balanced diet",
                                                        "id": "5ace20339fe7b01d5806bd3d",
                                                        "_id": "6077c4efbc5f4d4df9ef224e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e3",
                                                                "_id": "6077c4efbc5f4d4df9ef224f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plant nutrition",
                                                        "id": "5ace20339fe7b01d5806bd3e",
                                                        "_id": "6077c4efbc5f4d4df9ef224c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e4",
                                                                "_id": "6077c4efbc5f4d4df9ef224d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Lignt reaction & Dark reaction",
                                                        "id": "5ace20339fe7b01d5806bd3b",
                                                        "_id": "6077c4efbc5f4d4df9ef224a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e5",
                                                                "_id": "6077c4efbc5f4d4df9ef224b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Steps of holozoic nutrition, Digestion in Amoeba",
                                                        "id": "5ace20339fe7b01d5806bd41",
                                                        "_id": "6077c4efbc5f4d4df9ef2248",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e6",
                                                                "_id": "6077c4efbc5f4d4df9ef2249"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Digestion in Human",
                                                        "id": "5ace20339fe7b01d5806bd34",
                                                        "_id": "6077c4efbc5f4d4df9ef2246",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e7",
                                                                "_id": "6077c4efbc5f4d4df9ef2247"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diseases related to digestion",
                                                        "id": "5ace20339fe7b01d5806bd35",
                                                        "_id": "6077c4efbc5f4d4df9ef2244",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e8",
                                                                "_id": "6077c4efbc5f4d4df9ef2245"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Respiration in plants",
                                                        "id": "5ace20339fe7b01d5806bd40",
                                                        "_id": "6077c4efbc5f4d4df9ef2242",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82e9",
                                                                "_id": "6077c4efbc5f4d4df9ef2243"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Respiration in Amoeba",
                                                        "id": "5ace20339fe7b01d5806bd3f",
                                                        "_id": "6077c4efbc5f4d4df9ef2240",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ea",
                                                                "_id": "6077c4efbc5f4d4df9ef2241"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Structure of lungs & Breathing process",
                                                        "id": "5ace20339fe7b01d5806bd44",
                                                        "_id": "6077c4efbc5f4d4df9ef223e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82eb",
                                                                "_id": "6077c4efbc5f4d4df9ef223f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Aerobic respiration",
                                                        "id": "5ace20339fe7b01d5806bd2f",
                                                        "_id": "6077c4efbc5f4d4df9ef223c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ec",
                                                                "_id": "6077c4efbc5f4d4df9ef223d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Anaerobic respiration",
                                                        "id": "5ace20339fe7b01d5806bd30",
                                                        "_id": "6077c4efbc5f4d4df9ef223a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ed",
                                                                "_id": "6077c4efbc5f4d4df9ef223b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diseases related to respiration",
                                                        "id": "5ace20339fe7b01d5806bd38",
                                                        "_id": "6077c4efbc5f4d4df9ef2238",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ee",
                                                                "_id": "6077c4efbc5f4d4df9ef2239"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transportation in plants",
                                                        "id": "5ace20339fe7b01d5806bd45",
                                                        "_id": "6077c4efbc5f4d4df9ef2236",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82ef",
                                                                "_id": "6077c4efbc5f4d4df9ef2237"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Blood and its components & Blood vessels",
                                                        "id": "5ace20339fe7b01d5806bd31",
                                                        "_id": "6077c4efbc5f4d4df9ef2234",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f0",
                                                                "_id": "6077c4efbc5f4d4df9ef2235"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Structure of heart",
                                                        "id": "5ace20339fe7b01d5806bd42",
                                                        "_id": "6077c4efbc5f4d4df9ef2232",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f1",
                                                                "_id": "6077c4efbc5f4d4df9ef2233"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Circulation in Human",
                                                        "id": "5ace20339fe7b01d5806bd33",
                                                        "_id": "6077c4efbc5f4d4df9ef2230",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f2",
                                                                "_id": "6077c4efbc5f4d4df9ef2231"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Blood groups",
                                                        "id": "5ace20339fe7b01d5806bd32",
                                                        "_id": "6077c4efbc5f4d4df9ef222e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f3",
                                                                "_id": "6077c4efbc5f4d4df9ef222f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Lymphatic system",
                                                        "id": "5ace20339fe7b01d5806bd3c",
                                                        "_id": "6077c4efbc5f4d4df9ef222c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f4",
                                                                "_id": "6077c4efbc5f4d4df9ef222d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diseases related to heart and lymph",
                                                        "id": "5ace20339fe7b01d5806bd37",
                                                        "_id": "6077c4efbc5f4d4df9ef222a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f5",
                                                                "_id": "6077c4efbc5f4d4df9ef222b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Excretion and its products",
                                                        "id": "5ace20339fe7b01d5806bd39",
                                                        "_id": "6077c4efbc5f4d4df9ef2228",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f6",
                                                                "_id": "6077c4efbc5f4d4df9ef2229"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Structure of kidney & Nephron & Formation of urine",
                                                        "id": "5ace20339fe7b01d5806bd43",
                                                        "_id": "6077c4efbc5f4d4df9ef2226",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f7",
                                                                "_id": "6077c4efbc5f4d4df9ef2227"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Excretion in Plants",
                                                        "id": "5ace20339fe7b01d5806bd3a",
                                                        "_id": "6077c4efbc5f4d4df9ef2224",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f8",
                                                                "_id": "6077c4efbc5f4d4df9ef2225"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diseases related to Excretion",
                                                        "id": "5ace20339fe7b01d5806bd36",
                                                        "_id": "6077c4efbc5f4d4df9ef2222",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d78e316d24ffb2c82f9",
                                                                "_id": "6077c4efbc5f4d4df9ef2223"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820d",
                                                        "_id": "6077c4efbc5f4d4df9ef2250"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef2251"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Metals and Non Metals",
                                                "id": "5ace202f9fe7b01d5806bbcd",
                                                "_id": "6077c4efbc5f4d4df9ef2210",
                                                "concepts": [
                                                    {
                                                        "name": "Properties of Metals",
                                                        "id": "5ace20349fe7b01d5806bda8",
                                                        "_id": "6077c4efbc5f4d4df9ef221d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834b",
                                                                "_id": "6077c4efbc5f4d4df9ef221e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties of Non- Metals",
                                                        "id": "5ace20349fe7b01d5806bda9",
                                                        "_id": "6077c4efbc5f4d4df9ef221b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834c",
                                                                "_id": "6077c4efbc5f4d4df9ef221c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Compounds of Metals and Non-Metals",
                                                        "id": "5ace20349fe7b01d5806bda4",
                                                        "_id": "6077c4efbc5f4d4df9ef2219",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834d",
                                                                "_id": "6077c4efbc5f4d4df9ef221a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Metallurgy - An Introduction to Methods of Extraction",
                                                        "id": "5ace20349fe7b01d5806bda7",
                                                        "_id": "6077c4efbc5f4d4df9ef2217",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834e",
                                                                "_id": "6077c4efbc5f4d4df9ef2218"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Enrichment of Ores",
                                                        "id": "5ace20349fe7b01d5806bda6",
                                                        "_id": "6077c4efbc5f4d4df9ef2215",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c834f",
                                                                "_id": "6077c4efbc5f4d4df9ef2216"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reduction and Refining",
                                                        "id": "5ace20349fe7b01d5806bdaa",
                                                        "_id": "6077c4efbc5f4d4df9ef2213",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8350",
                                                                "_id": "6077c4efbc5f4d4df9ef2214"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Corrosion & Alloys",
                                                        "id": "5ace20349fe7b01d5806bda5",
                                                        "_id": "6077c4efbc5f4d4df9ef2211",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8351",
                                                                "_id": "6077c4efbc5f4d4df9ef2212"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8218",
                                                        "_id": "6077c4efbc5f4d4df9ef221f"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef2220"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Trigonometry Ratios & Identities",
                                                "id": "5ace20329fe7b01d5806bc95",
                                                "_id": "6077c4efbc5f4d4df9ef220d",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d99e",
                                                        "_id": "6077c4efbc5f4d4df9ef220e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Trigonometry Ratios & Identities",
                                                "id": "5ace20329fe7b01d5806bc96",
                                                "_id": "6077c4efbc5f4d4df9ef21f5",
                                                "concepts": [
                                                    {
                                                        "name": "Conditional identities, trigonometric inequalities, trigonometrical graphs",
                                                        "id": "5ace203d9fe7b01d5806c0c1",
                                                        "_id": "6077c4efbc5f4d4df9ef220a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db9c",
                                                                "_id": "6077c4efbc5f4d4df9ef220b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Domain & range of Trigonometric ratios",
                                                        "id": "5ace203d9fe7b01d5806c0c2",
                                                        "_id": "6077c4efbc5f4d4df9ef2208",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db9d",
                                                                "_id": "6077c4efbc5f4d4df9ef2209"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Identities, compound angles, multiple angles, sub-multiple angles and transformations",
                                                        "id": "5ace203d9fe7b01d5806c0c3",
                                                        "_id": "6077c4efbc5f4d4df9ef2206",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db9e",
                                                                "_id": "6077c4efbc5f4d4df9ef2207"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Maximum and minimum value of trigonometric function",
                                                        "id": "5ace203d9fe7b01d5806c0c4",
                                                        "_id": "6077c4efbc5f4d4df9ef2204",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673db9f",
                                                                "_id": "6077c4efbc5f4d4df9ef2205"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "polygons",
                                                        "id": "5ace203d9fe7b01d5806c0c5",
                                                        "_id": "6077c4efbc5f4d4df9ef2202",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba0",
                                                                "_id": "6077c4efbc5f4d4df9ef2203"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Principle, particular and general solution of trigonometrical equation, Conversion to lower degree, Conversion into quadratic form, change of variable",
                                                        "id": "5ace203d9fe7b01d5806c0c6",
                                                        "_id": "6077c4efbc5f4d4df9ef2200",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba1",
                                                                "_id": "6077c4efbc5f4d4df9ef2201"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Product of cosine, where angles are in G.P.",
                                                        "id": "5ace203d9fe7b01d5806c0c7",
                                                        "_id": "6077c4efbc5f4d4df9ef21fe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba2",
                                                                "_id": "6077c4efbc5f4d4df9ef21ff"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sign of Trigonometric ratios",
                                                        "id": "5ace203d9fe7b01d5806c0c8",
                                                        "_id": "6077c4efbc5f4d4df9ef21fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba3",
                                                                "_id": "6077c4efbc5f4d4df9ef21fd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Summation of sine/cosine series",
                                                        "id": "5ace203d9fe7b01d5806c0c9",
                                                        "_id": "6077c4efbc5f4d4df9ef21fa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba4",
                                                                "_id": "6077c4efbc5f4d4df9ef21fb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric ratios of Allied angles ( Sum or difference is multiple of 90)",
                                                        "id": "5ace203d9fe7b01d5806c0ca",
                                                        "_id": "6077c4efbc5f4d4df9ef21f8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba5",
                                                                "_id": "6077c4efbc5f4d4df9ef21f9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric ratios of sum & difference of two angles",
                                                        "id": "5ace203e9fe7b01d5806c0cb",
                                                        "_id": "6077c4efbc5f4d4df9ef21f6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba6",
                                                                "_id": "6077c4efbc5f4d4df9ef21f7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d99f",
                                                        "_id": "6077c4efbc5f4d4df9ef220c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "3-Dimensional Geometry",
                                                "id": "5ace20329fe7b01d5806bc97",
                                                "_id": "6077c4efbc5f4d4df9ef21f3",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a0",
                                                        "_id": "6077c4efbc5f4d4df9ef21f4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "3-Dimensional Geometry",
                                                "id": "5ace20329fe7b01d5806bc98",
                                                "_id": "6077c4efbc5f4d4df9ef21d3",
                                                "concepts": [
                                                    {
                                                        "name": "Angle between a line and a plane, Planes bisecting the angles between two planes, Bisector of acute / obtuse angle, Distance of a point from a plane, Distance between two parallel planes",
                                                        "id": "5ace203e9fe7b01d5806c0cc",
                                                        "_id": "6077c4efbc5f4d4df9ef21f0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba7",
                                                                "_id": "6077c4efbc5f4d4df9ef21f1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Angle between two vectors, Projection of the join of two points",
                                                        "id": "5ace203e9fe7b01d5806c0cd",
                                                        "_id": "6077c4efbc5f4d4df9ef21ee",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba8",
                                                                "_id": "6077c4efbc5f4d4df9ef21ef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition of tangency ( C. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0ce",
                                                        "_id": "6077c4efbc5f4d4df9ef21ec",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dba9",
                                                                "_id": "6077c4efbc5f4d4df9ef21ed"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Condition of tangency ( v. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0cf",
                                                        "_id": "6077c4efbc5f4d4df9ef21ea",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbaa",
                                                                "_id": "6077c4efbc5f4d4df9ef21eb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Direction cosines, Direction ratios",
                                                        "id": "5ace203e9fe7b01d5806c0d0",
                                                        "_id": "6077c4efbc5f4d4df9ef21e8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbab",
                                                                "_id": "6077c4efbc5f4d4df9ef21e9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance formula, Section formula, Centriod of a triangle, Centriod of a tetrahedron,",
                                                        "id": "5ace203e9fe7b01d5806c0d1",
                                                        "_id": "6077c4efbc5f4d4df9ef21e6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbac",
                                                                "_id": "6077c4efbc5f4d4df9ef21e7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of a sphere ( v. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0d2",
                                                        "_id": "6077c4efbc5f4d4df9ef21e4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbad",
                                                                "_id": "6077c4efbc5f4d4df9ef21e5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of a sphere (C. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0d3",
                                                        "_id": "6077c4efbc5f4d4df9ef21e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbae",
                                                                "_id": "6077c4efbc5f4d4df9ef21e3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of a sphere the extremities of diameter being",
                                                        "id": "5ace203e9fe7b01d5806c0d4",
                                                        "_id": "6077c4efbc5f4d4df9ef21e0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbaf",
                                                                "_id": "6077c4efbc5f4d4df9ef21e1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of a sphere the extremities of diameter being given ( c. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0d5",
                                                        "_id": "6077c4efbc5f4d4df9ef21de",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb0",
                                                                "_id": "6077c4efbc5f4d4df9ef21df"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of a sphere through four points ( v. F. )",
                                                        "id": "5ace203e9fe7b01d5806c0d6",
                                                        "_id": "6077c4efbc5f4d4df9ef21dc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb1",
                                                                "_id": "6077c4efbc5f4d4df9ef21dd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plane passing through three points, Plane passing through two points and parallel to a vector, Plane passing through two points and parallel to two vectors, Plane parallel to a given plane, Angle between two planes",
                                                        "id": "5ace203e9fe7b01d5806c0d7",
                                                        "_id": "6077c4efbc5f4d4df9ef21da",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb2",
                                                                "_id": "6077c4efbc5f4d4df9ef21db"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plane-General equation of plane, Plane in normal form, Transformation of general form of normal form, Plane passing through a point and perpendicular to a vector, Equation of a plane in intercept form",
                                                        "id": "5ace203e9fe7b01d5806c0d8",
                                                        "_id": "6077c4efbc5f4d4df9ef21d8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb3",
                                                                "_id": "6077c4efbc5f4d4df9ef21d9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Planes passing through the intersection of two planes, Two sides of a plane, Condition for a line to lie in a plane, Condition for two lines to be intersecting coplaner and the plane containing them, Area of Figures (Traingle etc.) in 3-Dimensional space",
                                                        "id": "5ace203e9fe7b01d5806c0d9",
                                                        "_id": "6077c4efbc5f4d4df9ef21d6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb4",
                                                                "_id": "6077c4efbc5f4d4df9ef21d7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Straight Line-through a point and parallel to a vector, Line passing through two points, Angle between two lines, Perpendicular from a point to a line, Shortest distance between two lines",
                                                        "id": "5ace203e9fe7b01d5806c0da",
                                                        "_id": "6077c4efbc5f4d4df9ef21d4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb5",
                                                                "_id": "6077c4efbc5f4d4df9ef21d5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a1",
                                                        "_id": "6077c4efbc5f4d4df9ef21f2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Vector",
                                                "id": "5ace20329fe7b01d5806bc99",
                                                "_id": "6077c4efbc5f4d4df9ef21d1",
                                                "concepts": [],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a2",
                                                        "_id": "6077c4efbc5f4d4df9ef21d2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Vector",
                                                "id": "5ace20329fe7b01d5806bc9a",
                                                "_id": "6077c4efbc5f4d4df9ef219f",
                                                "concepts": [
                                                    {
                                                        "name": "Component of a vector",
                                                        "id": "5ace203e9fe7b01d5806c0db",
                                                        "_id": "6077c4efbc5f4d4df9ef21ce",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb6",
                                                                "_id": "6077c4efbc5f4d4df9ef21cf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Component of a vector",
                                                        "id": "5ace203e9fe7b01d5806c0dc",
                                                        "_id": "6077c4efbc5f4d4df9ef21cc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb7",
                                                                "_id": "6077c4efbc5f4d4df9ef21cd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cross product of two vectors and its application",
                                                        "id": "5ace203e9fe7b01d5806c0dd",
                                                        "_id": "6077c4efbc5f4d4df9ef21ca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb8",
                                                                "_id": "6077c4efbc5f4d4df9ef21cb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dot product of two vectors and its application",
                                                        "id": "5ace203e9fe7b01d5806c0de",
                                                        "_id": "6077c4efbc5f4d4df9ef21c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbb9",
                                                                "_id": "6077c4efbc5f4d4df9ef21c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometrical application of vectors-plane, parallel planes, angle between planes, length of perpendicular from a point on the plane, point of intersection of a straight line and a plane, angle between two planes",
                                                        "id": "5ace203e9fe7b01d5806c0df",
                                                        "_id": "6077c4efbc5f4d4df9ef21c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbba",
                                                                "_id": "6077c4efbc5f4d4df9ef21c7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometrical application of vectors-straight line, angle between straight line, point of intersection of straight line, distance between two straight lines, distance of a point from a straight line, angle bisector",
                                                        "id": "5ace203e9fe7b01d5806c0e0",
                                                        "_id": "6077c4efbc5f4d4df9ef21c4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbbb",
                                                                "_id": "6077c4efbc5f4d4df9ef21c5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometrical interpretation",
                                                        "id": "5ace203e9fe7b01d5806c0e1",
                                                        "_id": "6077c4efbc5f4d4df9ef21c2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbbc",
                                                                "_id": "6077c4efbc5f4d4df9ef21c3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometrical interpretation of cross product",
                                                        "id": "5ace203e9fe7b01d5806c0e2",
                                                        "_id": "6077c4efbc5f4d4df9ef21c0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbbd",
                                                                "_id": "6077c4efbc5f4d4df9ef21c1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Image of a plane in a plane, image of a line in a plane, image of a point in a plane, image of a point in a line",
                                                        "id": "5ace203e9fe7b01d5806c0e3",
                                                        "_id": "6077c4efbc5f4d4df9ef21be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbbe",
                                                                "_id": "6077c4efbc5f4d4df9ef21bf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear combination",
                                                        "id": "5ace203e9fe7b01d5806c0e4",
                                                        "_id": "6077c4efbc5f4d4df9ef21bc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbbf",
                                                                "_id": "6077c4efbc5f4d4df9ef21bd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear combination, Linearly dependent or independent",
                                                        "id": "5ace203e9fe7b01d5806c0e5",
                                                        "_id": "6077c4efbc5f4d4df9ef21ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc0",
                                                                "_id": "6077c4efbc5f4d4df9ef21bb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear dependent or independent",
                                                        "id": "5ace203e9fe7b01d5806c0e6",
                                                        "_id": "6077c4efbc5f4d4df9ef21b8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc1",
                                                                "_id": "6077c4efbc5f4d4df9ef21b9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Moment of a force",
                                                        "id": "5ace203e9fe7b01d5806c0e7",
                                                        "_id": "6077c4efbc5f4d4df9ef21b6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc2",
                                                                "_id": "6077c4efbc5f4d4df9ef21b7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on collinearity of three points, two vectors, four points, three vectors",
                                                        "id": "5ace203e9fe7b01d5806c0e8",
                                                        "_id": "6077c4efbc5f4d4df9ef21b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc3",
                                                                "_id": "6077c4efbc5f4d4df9ef21b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems based on magnitude of vectors, Types of vectors, Addition and subtraction of vectors, Position vectors, Section formula (internal/external),",
                                                        "id": "5ace203e9fe7b01d5806c0e9",
                                                        "_id": "6077c4efbc5f4d4df9ef21b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc4",
                                                                "_id": "6077c4efbc5f4d4df9ef21b3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Product of four vector",
                                                        "id": "5ace203e9fe7b01d5806c0ea",
                                                        "_id": "6077c4efbc5f4d4df9ef21b0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc5",
                                                                "_id": "6077c4efbc5f4d4df9ef21b1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Product of two vectors",
                                                        "id": "5ace203e9fe7b01d5806c0eb",
                                                        "_id": "6077c4efbc5f4d4df9ef21ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc6",
                                                                "_id": "6077c4efbc5f4d4df9ef21af"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reciprocal system of vectors and solution of vector equation",
                                                        "id": "5ace203e9fe7b01d5806c0ec",
                                                        "_id": "6077c4efbc5f4d4df9ef21ac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc7",
                                                                "_id": "6077c4efbc5f4d4df9ef21ad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Scalar product",
                                                        "id": "5ace203e9fe7b01d5806c0ed",
                                                        "_id": "6077c4efbc5f4d4df9ef21aa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc8",
                                                                "_id": "6077c4efbc5f4d4df9ef21ab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Scalar triple product",
                                                        "id": "5ace203e9fe7b01d5806c0ee",
                                                        "_id": "6077c4efbc5f4d4df9ef21a8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbc9",
                                                                "_id": "6077c4efbc5f4d4df9ef21a9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Triple product",
                                                        "id": "5ace203e9fe7b01d5806c0ef",
                                                        "_id": "6077c4efbc5f4d4df9ef21a6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbca",
                                                                "_id": "6077c4efbc5f4d4df9ef21a7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vector product",
                                                        "id": "5ace203e9fe7b01d5806c0f0",
                                                        "_id": "6077c4efbc5f4d4df9ef21a4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbcb",
                                                                "_id": "6077c4efbc5f4d4df9ef21a5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vector triple product",
                                                        "id": "5ace203e9fe7b01d5806c0f1",
                                                        "_id": "6077c4efbc5f4d4df9ef21a2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbcc",
                                                                "_id": "6077c4efbc5f4d4df9ef21a3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Work done",
                                                        "id": "5ace203e9fe7b01d5806c0f2",
                                                        "_id": "6077c4efbc5f4d4df9ef21a0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbcd",
                                                                "_id": "6077c4efbc5f4d4df9ef21a1"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a3",
                                                        "_id": "6077c4efbc5f4d4df9ef21d0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Real Number",
                                                "id": "5ec36b98f05a6036ccbb380c",
                                                "_id": "6077c4efbc5f4d4df9ef2195",
                                                "concepts": [
                                                    {
                                                        "name": "Fundamental Theorem of Arithmetic",
                                                        "id": "5ec36bfce56f4536c61841ec",
                                                        "_id": "6077c4efbc5f4d4df9ef219c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbce",
                                                                "_id": "6077c4efbc5f4d4df9ef219d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Euclid's Division Lemma",
                                                        "id": "5ec36bfce56f4536c61841eb",
                                                        "_id": "6077c4efbc5f4d4df9ef219a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbcf",
                                                                "_id": "6077c4efbc5f4d4df9ef219b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Decimal Expansion of Rational Numbers",
                                                        "id": "5ec36bfce56f4536c61841ee",
                                                        "_id": "6077c4efbc5f4d4df9ef2198",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbd0",
                                                                "_id": "6077c4efbc5f4d4df9ef2199"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Review of Irrational Numbers",
                                                        "id": "5ec36bfce56f4536c61841ed",
                                                        "_id": "6077c4efbc5f4d4df9ef2196",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbd1",
                                                                "_id": "6077c4efbc5f4d4df9ef2197"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a4",
                                                        "_id": "6077c4efbc5f4d4df9ef219e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Constructions",
                                                "id": "5ec36b98f05a6036ccbb3816",
                                                "_id": "6077c4efbc5f4d4df9ef218d",
                                                "concepts": [
                                                    {
                                                        "name": "Construction of Tangents to a Circle",
                                                        "id": "5ec377853d2b7e3af65ff176",
                                                        "_id": "6077c4efbc5f4d4df9ef2192",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbd9",
                                                                "_id": "6077c4efbc5f4d4df9ef2193"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Division of a Line Segment",
                                                        "id": "5ec377853d2b7e3af65ff174",
                                                        "_id": "6077c4efbc5f4d4df9ef2190",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbda",
                                                                "_id": "6077c4efbc5f4d4df9ef2191"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Construction of a Triangle Similar to a Given Triangle as per Given Scale Factor",
                                                        "id": "5ec377853d2b7e3af65ff175",
                                                        "_id": "6077c4efbc5f4d4df9ef218e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbdb",
                                                                "_id": "6077c4efbc5f4d4df9ef218f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a6",
                                                        "_id": "6077c4efbc5f4d4df9ef2194"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Polynomials",
                                                "id": "5ec36b98f05a6036ccbb380d",
                                                "_id": "6077c4efbc5f4d4df9ef2183",
                                                "concepts": [
                                                    {
                                                        "name": "Division Algorithm of Polynomials",
                                                        "id": "5ec36c363d2b7e3af65fefb3",
                                                        "_id": "6077c4efbc5f4d4df9ef218a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbdc",
                                                                "_id": "6077c4efbc5f4d4df9ef218b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relationship between Zeroes and Coefficient of a Quadratic Polynomial",
                                                        "id": "5ec36c363d2b7e3af65fefb1",
                                                        "_id": "6077c4efbc5f4d4df9ef2188",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbdd",
                                                                "_id": "6077c4efbc5f4d4df9ef2189"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relationship between Zeroes and Coefficient of a Cubic Polynomial",
                                                        "id": "5ec36c363d2b7e3af65fefb2",
                                                        "_id": "6077c4efbc5f4d4df9ef2186",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbde",
                                                                "_id": "6077c4efbc5f4d4df9ef2187"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Zeros of a Polynomial",
                                                        "id": "5ec36c363d2b7e3af65fefb0",
                                                        "_id": "6077c4efbc5f4d4df9ef2184",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbdf",
                                                                "_id": "6077c4efbc5f4d4df9ef2185"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a7",
                                                        "_id": "6077c4efbc5f4d4df9ef218c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Coordinate Geometry",
                                                "id": "5ec36b98f05a6036ccbb3812",
                                                "_id": "6077c4efbc5f4d4df9ef217b",
                                                "concepts": [
                                                    {
                                                        "name": "Area of a Triangle",
                                                        "id": "5ec370763d2b7e3af65ff041",
                                                        "_id": "6077c4efbc5f4d4df9ef2180",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe0",
                                                                "_id": "6077c4efbc5f4d4df9ef2181"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance Formula",
                                                        "id": "5ec370763d2b7e3af65ff03f",
                                                        "_id": "6077c4efbc5f4d4df9ef217e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe1",
                                                                "_id": "6077c4efbc5f4d4df9ef217f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Section Formula",
                                                        "id": "5ec370763d2b7e3af65ff040",
                                                        "_id": "6077c4efbc5f4d4df9ef217c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe2",
                                                                "_id": "6077c4efbc5f4d4df9ef217d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a8",
                                                        "_id": "6077c4efbc5f4d4df9ef2182"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef220f"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Modern Physics",
                                                "id": "5ace20329fe7b01d5806bca9",
                                                "_id": "6077c4efbc5f4d4df9ef2162",
                                                "concepts": [
                                                    {
                                                        "name": "Bohrs model",
                                                        "id": "5ace203f9fe7b01d5806c16d",
                                                        "_id": "6077c4efbc5f4d4df9ef2177",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0b",
                                                                "_id": "6077c4efbc5f4d4df9ef2178"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conventional and non\n  conventional sources of energy",
                                                        "id": "5ace203f9fe7b01d5806c16e",
                                                        "_id": "6077c4efbc5f4d4df9ef2175",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0c",
                                                                "_id": "6077c4efbc5f4d4df9ef2176"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "dual nature of matter and de-broglie wavelength",
                                                        "id": "5ace203f9fe7b01d5806c16f",
                                                        "_id": "6077c4efbc5f4d4df9ef2173",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0d",
                                                                "_id": "6077c4efbc5f4d4df9ef2174"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Emission spectrun in Bohr's model",
                                                        "id": "5ace203f9fe7b01d5806c170",
                                                        "_id": "6077c4efbc5f4d4df9ef2171",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0e",
                                                                "_id": "6077c4efbc5f4d4df9ef2172"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "fustion and fission reaction, alpha, beta & gamma decay,",
                                                        "id": "5ace203f9fe7b01d5806c171",
                                                        "_id": "6077c4efbc5f4d4df9ef216f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de0f",
                                                                "_id": "6077c4efbc5f4d4df9ef2170"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "nuclear physics, binding energy, Q-value of reaction, threshold energy",
                                                        "id": "5ace203f9fe7b01d5806c172",
                                                        "_id": "6077c4efbc5f4d4df9ef216d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de10",
                                                                "_id": "6077c4efbc5f4d4df9ef216e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "photo-electric effect",
                                                        "id": "5ace203f9fe7b01d5806c173",
                                                        "_id": "6077c4efbc5f4d4df9ef216b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de11",
                                                                "_id": "6077c4efbc5f4d4df9ef216c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "properties of photon",
                                                        "id": "5ace203f9fe7b01d5806c174",
                                                        "_id": "6077c4efbc5f4d4df9ef2169",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de12",
                                                                "_id": "6077c4efbc5f4d4df9ef216a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "radioactivity, parallel and series decay, radioactive equilirbium",
                                                        "id": "5ace203f9fe7b01d5806c175",
                                                        "_id": "6077c4efbc5f4d4df9ef2167",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de13",
                                                                "_id": "6077c4efbc5f4d4df9ef2168"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Renewable & non renewable source of energy",
                                                        "id": "5ace203f9fe7b01d5806c176",
                                                        "_id": "6077c4efbc5f4d4df9ef2165",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de14",
                                                                "_id": "6077c4efbc5f4d4df9ef2166"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "X rays, characteristic and continuous wavelength, mosley's law",
                                                        "id": "5ace203f9fe7b01d5806c177",
                                                        "_id": "6077c4efbc5f4d4df9ef2163",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de15",
                                                                "_id": "6077c4efbc5f4d4df9ef2164"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd69",
                                                        "_id": "6077c4efbc5f4d4df9ef2179"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Optics",
                                                "id": "5ace20329fe7b01d5806bcaa",
                                                "_id": "6077c4efbc5f4d4df9ef2140",
                                                "concepts": [
                                                    {
                                                        "name": "basic properties of reflection and plane mirror, Object and image",
                                                        "id": "5ace203f9fe7b01d5806c178",
                                                        "_id": "6077c4efbc5f4d4df9ef215f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de16",
                                                                "_id": "6077c4efbc5f4d4df9ef2160"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "basic properties of refraction and image formation from plane surface, variable refractive index, motion of image from plane surface",
                                                        "id": "5ace203f9fe7b01d5806c179",
                                                        "_id": "6077c4efbc5f4d4df9ef215d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de17",
                                                                "_id": "6077c4efbc5f4d4df9ef215e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "basic property of prism, deviation and dispersion from prism, image formation from prism, minimum deviation from prism",
                                                        "id": "5ace203f9fe7b01d5806c17a",
                                                        "_id": "6077c4efbc5f4d4df9ef215b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de18",
                                                                "_id": "6077c4efbc5f4d4df9ef215c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "combination of lens, silvering of lens, splitting of lens",
                                                        "id": "5ace203f9fe7b01d5806c17b",
                                                        "_id": "6077c4efbc5f4d4df9ef2159",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de19",
                                                                "_id": "6077c4efbc5f4d4df9ef215a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "deviation from optical instruments",
                                                        "id": "5ace203f9fe7b01d5806c17c",
                                                        "_id": "6077c4efbc5f4d4df9ef2157",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1a",
                                                                "_id": "6077c4efbc5f4d4df9ef2158"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electromagnetic wave",
                                                        "id": "5ace203f9fe7b01d5806c17d",
                                                        "_id": "6077c4efbc5f4d4df9ef2155",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1b",
                                                                "_id": "6077c4efbc5f4d4df9ef2156"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "huygen theory of wave fronts, YDSE",
                                                        "id": "5ace203f9fe7b01d5806c17e",
                                                        "_id": "6077c4efbc5f4d4df9ef2153",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1c",
                                                                "_id": "6077c4efbc5f4d4df9ef2154"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "interference from thin film",
                                                        "id": "5ace203f9fe7b01d5806c17f",
                                                        "_id": "6077c4efbc5f4d4df9ef2151",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1d",
                                                                "_id": "6077c4efbc5f4d4df9ef2152"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "interference in system similar to YDSE",
                                                        "id": "5ace203f9fe7b01d5806c180",
                                                        "_id": "6077c4efbc5f4d4df9ef214f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1e",
                                                                "_id": "6077c4efbc5f4d4df9ef2150"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "microscope, telescope and eye",
                                                        "id": "5ace20409fe7b01d5806c181",
                                                        "_id": "6077c4efbc5f4d4df9ef214d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de1f",
                                                                "_id": "6077c4efbc5f4d4df9ef214e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polarization, resolving power, microscope, telescope, brewster's law, polaroids",
                                                        "id": "5ace20409fe7b01d5806c182",
                                                        "_id": "6077c4efbc5f4d4df9ef214b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de20",
                                                                "_id": "6077c4efbc5f4d4df9ef214c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "refraction from spherical surfaces, lens, lens formula, magnification, motion of image from lens",
                                                        "id": "5ace20409fe7b01d5806c183",
                                                        "_id": "6077c4efbc5f4d4df9ef2149",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de21",
                                                                "_id": "6077c4efbc5f4d4df9ef214a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "shifting of fringes due to introduction of film, concept of optical path",
                                                        "id": "5ace20409fe7b01d5806c184",
                                                        "_id": "6077c4efbc5f4d4df9ef2147",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de22",
                                                                "_id": "6077c4efbc5f4d4df9ef2148"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Single slit diffraction, width of centre maximum",
                                                        "id": "5ace20409fe7b01d5806c185",
                                                        "_id": "6077c4efbc5f4d4df9ef2145",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de23",
                                                                "_id": "6077c4efbc5f4d4df9ef2146"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "spherical mirror and mirror formula, relative motion of miror and object, magnification",
                                                        "id": "5ace20409fe7b01d5806c186",
                                                        "_id": "6077c4efbc5f4d4df9ef2143",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de24",
                                                                "_id": "6077c4efbc5f4d4df9ef2144"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "total internal reflection",
                                                        "id": "5ace20409fe7b01d5806c187",
                                                        "_id": "6077c4efbc5f4d4df9ef2141",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de25",
                                                                "_id": "6077c4efbc5f4d4df9ef2142"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd6a",
                                                        "_id": "6077c4efbc5f4d4df9ef2161"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Laws Of Motion",
                                                "id": "5f6860f5058075680d81545a",
                                                "_id": "6077c4efbc5f4d4df9ef2130",
                                                "concepts": [
                                                    {
                                                        "name": "Dynamics Of Circular Motion",
                                                        "id": "5f6862f9f100a06808b0f5ba",
                                                        "_id": "6077c4efbc5f4d4df9ef213d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de70",
                                                                "_id": "6077c4efbc5f4d4df9ef213e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Lami’S Theorem",
                                                        "id": "5f6862f9f100a06808b0f5b7",
                                                        "_id": "6077c4efbc5f4d4df9ef213b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de71",
                                                                "_id": "6077c4efbc5f4d4df9ef213c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6862f9f100a06808b0f5b4",
                                                        "_id": "6077c4efbc5f4d4df9ef2139",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de72",
                                                                "_id": "6077c4efbc5f4d4df9ef213a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Friction",
                                                        "id": "5f6862f9f100a06808b0f5b9",
                                                        "_id": "6077c4efbc5f4d4df9ef2137",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de73",
                                                                "_id": "6077c4efbc5f4d4df9ef2138"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Newton’S Laws",
                                                        "id": "5f6862f9f100a06808b0f5b5",
                                                        "_id": "6077c4efbc5f4d4df9ef2135",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de74",
                                                                "_id": "6077c4efbc5f4d4df9ef2136"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application Of Newton’S Laws",
                                                        "id": "5f6862f9f100a06808b0f5b6",
                                                        "_id": "6077c4efbc5f4d4df9ef2133",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de75",
                                                                "_id": "6077c4efbc5f4d4df9ef2134"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Law Of Conservation Of Total Linear Momentum",
                                                        "id": "5f6862f9f100a06808b0f5b8",
                                                        "_id": "6077c4efbc5f4d4df9ef2131",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de76",
                                                                "_id": "6077c4efbc5f4d4df9ef2132"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd76",
                                                        "_id": "6077c4efbc5f4d4df9ef213f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Motion Of System Of Particles And Rigid Bodies",
                                                "id": "5f6860f5058075680d81545c",
                                                "_id": "6077c4efbc5f4d4df9ef2120",
                                                "concepts": [
                                                    {
                                                        "name": "Equilibrium Of Rigid Bodies",
                                                        "id": "5f6862f9f100a06808b0f5c3",
                                                        "_id": "6077c4efbc5f4d4df9ef212d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de77",
                                                                "_id": "6077c4efbc5f4d4df9ef212e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Torque And Angular Momentum",
                                                        "id": "5f6862f9f100a06808b0f5c2",
                                                        "_id": "6077c4efbc5f4d4df9ef212b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de78",
                                                                "_id": "6077c4efbc5f4d4df9ef212c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Centre Of Mass",
                                                        "id": "5f6862f9f100a06808b0f5c1",
                                                        "_id": "6077c4efbc5f4d4df9ef2129",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de79",
                                                                "_id": "6077c4efbc5f4d4df9ef212a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6862f9f100a06808b0f5c0",
                                                        "_id": "6077c4efbc5f4d4df9ef2127",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7a",
                                                                "_id": "6077c4efbc5f4d4df9ef2128"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Moment Of Inertia",
                                                        "id": "5f6862f9f100a06808b0f5c4",
                                                        "_id": "6077c4efbc5f4d4df9ef2125",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7b",
                                                                "_id": "6077c4efbc5f4d4df9ef2126"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rolling Motion",
                                                        "id": "5f6862f9f100a06808b0f5c6",
                                                        "_id": "6077c4efbc5f4d4df9ef2123",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7c",
                                                                "_id": "6077c4efbc5f4d4df9ef2124"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rotational Dynamics",
                                                        "id": "5f6862f9f100a06808b0f5c5",
                                                        "_id": "6077c4efbc5f4d4df9ef2121",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7d",
                                                                "_id": "6077c4efbc5f4d4df9ef2122"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd77",
                                                        "_id": "6077c4efbc5f4d4df9ef212f"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef217a"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Cubes & Dice",
                                                "id": "5ace20309fe7b01d5806bc25",
                                                "_id": "6077c4efbc5f4d4df9ef2119",
                                                "concepts": [
                                                    {
                                                        "name": "Cubes",
                                                        "id": "5ace20389fe7b01d5806bf13",
                                                        "_id": "6077c4efbc5f4d4df9ef211c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843b",
                                                                "_id": "6077c4efbc5f4d4df9ef211d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dice",
                                                        "id": "5ace20389fe7b01d5806bf14",
                                                        "_id": "6077c4efbc5f4d4df9ef211a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843c",
                                                                "_id": "6077c4efbc5f4d4df9ef211b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8256",
                                                        "_id": "6077c4efbc5f4d4df9ef211e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Figure series",
                                                "id": "5ace20319fe7b01d5806bc2c",
                                                "_id": "6077c4efbc5f4d4df9ef2115",
                                                "concepts": [
                                                    {
                                                        "name": "Figure series",
                                                        "id": "5ace20389fe7b01d5806bf1c",
                                                        "_id": "6077c4efbc5f4d4df9ef2116",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843d",
                                                                "_id": "6077c4efbc5f4d4df9ef2117"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8257",
                                                        "_id": "6077c4efbc5f4d4df9ef2118"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef211f"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Democracy in the Contemporary World",
                                                "id": "5ace20329fe7b01d5806bce4",
                                                "_id": "6077c4efbc5f4d4df9ef2110",
                                                "concepts": [
                                                    {
                                                        "name": "Expansion of democracy in the world",
                                                        "id": "5ace20429fe7b01d5806c22f",
                                                        "_id": "6077c4efbc5f4d4df9ef2111",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848c",
                                                                "_id": "6077c4efbc5f4d4df9ef2112"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8285",
                                                        "_id": "6077c4efbc5f4d4df9ef2113"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "What is Democracy ? Why Democracy?",
                                                "id": "5ace20329fe7b01d5806bced",
                                                "_id": "6077c4efbc5f4d4df9ef210c",
                                                "concepts": [
                                                    {
                                                        "name": "Merits & demarits of democracy",
                                                        "id": "5ace20429fe7b01d5806c23c",
                                                        "_id": "6077c4efbc5f4d4df9ef210d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848d",
                                                                "_id": "6077c4efbc5f4d4df9ef210e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8286",
                                                        "_id": "6077c4efbc5f4d4df9ef210f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Constitutional Design",
                                                "id": "5ace20329fe7b01d5806bce2",
                                                "_id": "6077c4efbc5f4d4df9ef2108",
                                                "concepts": [
                                                    {
                                                        "name": "African nation congress and its role in the equality for Blacks.\nFormation of CA and constitution in India",
                                                        "id": "5ace20429fe7b01d5806c22c",
                                                        "_id": "6077c4efbc5f4d4df9ef2109",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848e",
                                                                "_id": "6077c4efbc5f4d4df9ef210a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8287",
                                                        "_id": "6077c4efbc5f4d4df9ef210b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef2114"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Paper Cutting",
                                                "id": "5ace20309fe7b01d5806bc19",
                                                "_id": "6077c4efbc5f4d4df9ef2101",
                                                "concepts": [
                                                    {
                                                        "name": "Folding and Unfolding",
                                                        "id": "5ace20389fe7b01d5806bf03",
                                                        "_id": "6077c4efbc5f4d4df9ef2104",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df48",
                                                                "_id": "6077c4efbc5f4d4df9ef2105"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Paper Cutting and Dot Situation",
                                                        "id": "5ace20389fe7b01d5806bf04",
                                                        "_id": "6077c4efbc5f4d4df9ef2102",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df49",
                                                                "_id": "6077c4efbc5f4d4df9ef2103"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df3a",
                                                        "_id": "6077c4efbc5f4d4df9ef2106"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef2107"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 8,
                                "startDate": "2021-06-17T00:00:00.000Z",
                                "endDate": "2021-06-23T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef200a",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Control & Co-ordination & Reproduction",
                                                "id": "5ace202f9fe7b01d5806bbbb",
                                                "_id": "6077c4efbc5f4d4df9ef20e1",
                                                "concepts": [
                                                    {
                                                        "name": "Plant movements",
                                                        "id": "5ace20329fe7b01d5806bcf8",
                                                        "_id": "6077c4efbc5f4d4df9ef20fc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82fa",
                                                                "_id": "6077c4efbc5f4d4df9ef20fd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Plant hormones",
                                                        "id": "5ace20329fe7b01d5806bcf7",
                                                        "_id": "6077c4efbc5f4d4df9ef20fa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82fb",
                                                                "_id": "6077c4efbc5f4d4df9ef20fb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Structure and function of Human brain",
                                                        "id": "5ace20329fe7b01d5806bcfa",
                                                        "_id": "6077c4efbc5f4d4df9ef20f8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82fc",
                                                                "_id": "6077c4efbc5f4d4df9ef20f9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Structure and function of Spinal cord",
                                                        "id": "5ace20329fe7b01d5806bcfb",
                                                        "_id": "6077c4efbc5f4d4df9ef20f6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82fd",
                                                                "_id": "6077c4efbc5f4d4df9ef20f7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Autonomic nervous system",
                                                        "id": "5ace20329fe7b01d5806bcef",
                                                        "_id": "6077c4efbc5f4d4df9ef20f4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82fe",
                                                                "_id": "6077c4efbc5f4d4df9ef20f5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "peripheral nervous system",
                                                        "id": "5ace20329fe7b01d5806bcf6",
                                                        "_id": "6077c4efbc5f4d4df9ef20f2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c82ff",
                                                                "_id": "6077c4efbc5f4d4df9ef20f3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Endocrine glands",
                                                        "id": "5ace20329fe7b01d5806bcf0",
                                                        "_id": "6077c4efbc5f4d4df9ef20f0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8300",
                                                                "_id": "6077c4efbc5f4d4df9ef20f1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vegetative reproduction, Budding, Fission, Spore formation",
                                                        "id": "5ace20329fe7b01d5806bcfc",
                                                        "_id": "6077c4efbc5f4d4df9ef20ee",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8301",
                                                                "_id": "6077c4efbc5f4d4df9ef20ef"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parts of a flower, Pollination",
                                                        "id": "5ace20329fe7b01d5806bcf5",
                                                        "_id": "6077c4efbc5f4d4df9ef20ec",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8302",
                                                                "_id": "6077c4efbc5f4d4df9ef20ed"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fertilization in angiospermic plants",
                                                        "id": "5ace20329fe7b01d5806bcf1",
                                                        "_id": "6077c4efbc5f4d4df9ef20ea",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8303",
                                                                "_id": "6077c4efbc5f4d4df9ef20eb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Human male reproductive system",
                                                        "id": "5ace20329fe7b01d5806bcf4",
                                                        "_id": "6077c4efbc5f4d4df9ef20e8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8304",
                                                                "_id": "6077c4efbc5f4d4df9ef20e9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Human female reproductive system",
                                                        "id": "5ace20329fe7b01d5806bcf3",
                                                        "_id": "6077c4efbc5f4d4df9ef20e6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8305",
                                                                "_id": "6077c4efbc5f4d4df9ef20e7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Puberty , Menstrual cycle",
                                                        "id": "5ace20329fe7b01d5806bcf9",
                                                        "_id": "6077c4efbc5f4d4df9ef20e4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8306",
                                                                "_id": "6077c4efbc5f4d4df9ef20e5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fertilization in human, Birth control measures",
                                                        "id": "5ace20329fe7b01d5806bcf2",
                                                        "_id": "6077c4efbc5f4d4df9ef20e2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8307",
                                                                "_id": "6077c4efbc5f4d4df9ef20e3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820e",
                                                        "_id": "6077c4efbc5f4d4df9ef20fe"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef20ff"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Periodic classification of elements",
                                                "id": "5ace202f9fe7b01d5806bbce",
                                                "_id": "6077c4efbc5f4d4df9ef20cc",
                                                "concepts": [
                                                    {
                                                        "name": "Classification of Elements",
                                                        "id": "5ace20349fe7b01d5806bdac",
                                                        "_id": "6077c4efbc5f4d4df9ef20dd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8352",
                                                                "_id": "6077c4efbc5f4d4df9ef20de"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dobereneirs triads and Newlands Law",
                                                        "id": "5ace20349fe7b01d5806bdad",
                                                        "_id": "6077c4efbc5f4d4df9ef20db",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8353",
                                                                "_id": "6077c4efbc5f4d4df9ef20dc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mendeleevs Periodic Table",
                                                        "id": "5ace20349fe7b01d5806bdb0",
                                                        "_id": "6077c4efbc5f4d4df9ef20d9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8354",
                                                                "_id": "6077c4efbc5f4d4df9ef20da"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Periodic Properties",
                                                        "id": "5ace20349fe7b01d5806bdb3",
                                                        "_id": "6077c4efbc5f4d4df9ef20d7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8355",
                                                                "_id": "6077c4efbc5f4d4df9ef20d8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Atomic Size",
                                                        "id": "5ace20349fe7b01d5806bdab",
                                                        "_id": "6077c4efbc5f4d4df9ef20d5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8356",
                                                                "_id": "6077c4efbc5f4d4df9ef20d6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ionisation Energy and Electron Affinity",
                                                        "id": "5ace20349fe7b01d5806bdaf",
                                                        "_id": "6077c4efbc5f4d4df9ef20d3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8357",
                                                                "_id": "6077c4efbc5f4d4df9ef20d4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electronegativity",
                                                        "id": "5ace20349fe7b01d5806bdae",
                                                        "_id": "6077c4efbc5f4d4df9ef20d1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8358",
                                                                "_id": "6077c4efbc5f4d4df9ef20d2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Metallic & Non Metallic character",
                                                        "id": "5ace20349fe7b01d5806bdb1",
                                                        "_id": "6077c4efbc5f4d4df9ef20cf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8359",
                                                                "_id": "6077c4efbc5f4d4df9ef20d0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Oxide Nature",
                                                        "id": "5ace20349fe7b01d5806bdb2",
                                                        "_id": "6077c4efbc5f4d4df9ef20cd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835a",
                                                                "_id": "6077c4efbc5f4d4df9ef20ce"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8219",
                                                        "_id": "6077c4efbc5f4d4df9ef20df"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef20e0"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Areas Related to Circles",
                                                "id": "5ec36b98f05a6036ccbb3817",
                                                "_id": "6077c4efbc5f4d4df9ef20c1",
                                                "concepts": [
                                                    {
                                                        "name": "Perimeter and Area of a Circle",
                                                        "id": "5ec377d2e56f4536c61843cd",
                                                        "_id": "6077c4efbc5f4d4df9ef20c8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe3",
                                                                "_id": "6077c4efbc5f4d4df9ef20c9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area of Segment of a Circle",
                                                        "id": "5ec377d2e56f4536c61843cf",
                                                        "_id": "6077c4efbc5f4d4df9ef20c6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe4",
                                                                "_id": "6077c4efbc5f4d4df9ef20c7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area of Sector of a Circle",
                                                        "id": "5ec377d2e56f4536c61843ce",
                                                        "_id": "6077c4efbc5f4d4df9ef20c4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe5",
                                                                "_id": "6077c4efbc5f4d4df9ef20c5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Areas of Combinations of Plane Figures",
                                                        "id": "5ec377d2e56f4536c61843d0",
                                                        "_id": "6077c4efbc5f4d4df9ef20c2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe6",
                                                                "_id": "6077c4efbc5f4d4df9ef20c3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9a9",
                                                        "_id": "6077c4efbc5f4d4df9ef20ca"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Pair of Linear Equations in Two Variables",
                                                "id": "5ec36b98f05a6036ccbb380e",
                                                "_id": "6077c4efbc5f4d4df9ef20b1",
                                                "concepts": [
                                                    {
                                                        "name": "Pair of Linear Equations in Two Variables",
                                                        "id": "5ec36c873d2b7e3af65fefba",
                                                        "_id": "6077c4efbc5f4d4df9ef20be",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe7",
                                                                "_id": "6077c4efbc5f4d4df9ef20bf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cross Multiplication Method of Solving a Pair of Linear Equations",
                                                        "id": "5ec36c873d2b7e3af65fefbe",
                                                        "_id": "6077c4efbc5f4d4df9ef20bc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe8",
                                                                "_id": "6077c4efbc5f4d4df9ef20bd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conditions for Solvability",
                                                        "id": "5ec36c873d2b7e3af65fefbf",
                                                        "_id": "6077c4efbc5f4d4df9ef20ba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbe9",
                                                                "_id": "6077c4efbc5f4d4df9ef20bb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Elimination Method of Solving a Pair of Linear Equations",
                                                        "id": "5ec36c873d2b7e3af65fefbd",
                                                        "_id": "6077c4efbc5f4d4df9ef20b8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbea",
                                                                "_id": "6077c4efbc5f4d4df9ef20b9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graphical Method of Solution of a Pair of Linear Equations",
                                                        "id": "5ec36c873d2b7e3af65fefbb",
                                                        "_id": "6077c4efbc5f4d4df9ef20b6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbeb",
                                                                "_id": "6077c4efbc5f4d4df9ef20b7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equations Reducible to a Pair of Linear Equations in Two Variables",
                                                        "id": "5ec36c873d2b7e3af65fefc0",
                                                        "_id": "6077c4efbc5f4d4df9ef20b4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbec",
                                                                "_id": "6077c4efbc5f4d4df9ef20b5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Substitution Method of Solving a Pair of Linear Equations",
                                                        "id": "5ec36c873d2b7e3af65fefbc",
                                                        "_id": "6077c4efbc5f4d4df9ef20b2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbed",
                                                                "_id": "6077c4efbc5f4d4df9ef20b3"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9aa",
                                                        "_id": "6077c4efbc5f4d4df9ef20c0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Introduction to Trigonometry",
                                                "id": "5ec36b98f05a6036ccbb3813",
                                                "_id": "6077c4efbc5f4d4df9ef20a7",
                                                "concepts": [
                                                    {
                                                        "name": "Trigonometric Identities",
                                                        "id": "5ec370e6e56f4536c618425a",
                                                        "_id": "6077c4efbc5f4d4df9ef20ae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbee",
                                                                "_id": "6077c4efbc5f4d4df9ef20af"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of Complementary Angles",
                                                        "id": "5ec370e6e56f4536c6184259",
                                                        "_id": "6077c4efbc5f4d4df9ef20ac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbef",
                                                                "_id": "6077c4efbc5f4d4df9ef20ad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios",
                                                        "id": "5ec370e6e56f4536c6184257",
                                                        "_id": "6077c4efbc5f4d4df9ef20aa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf0",
                                                                "_id": "6077c4efbc5f4d4df9ef20ab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Trigonometric Ratios of Some Specific Angles",
                                                        "id": "5ec370e6e56f4536c6184258",
                                                        "_id": "6077c4efbc5f4d4df9ef20a8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf1",
                                                                "_id": "6077c4efbc5f4d4df9ef20a9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ab",
                                                        "_id": "6077c4efbc5f4d4df9ef20b0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Surface Areas and Volumes",
                                                "id": "5ec36b98f05a6036ccbb3818",
                                                "_id": "6077c4efbc5f4d4df9ef209d",
                                                "concepts": [
                                                    {
                                                        "name": "Frustum of a Cone",
                                                        "id": "5ec3783d497e903afb98dc9f",
                                                        "_id": "6077c4efbc5f4d4df9ef20a4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf2",
                                                                "_id": "6077c4efbc5f4d4df9ef20a5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume of a Combination of Solids",
                                                        "id": "5ec3783d497e903afb98dc9d",
                                                        "_id": "6077c4efbc5f4d4df9ef20a2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf3",
                                                                "_id": "6077c4efbc5f4d4df9ef20a3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface Area of a Combination of Solids",
                                                        "id": "5ec3783d497e903afb98dc9c",
                                                        "_id": "6077c4efbc5f4d4df9ef20a0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf4",
                                                                "_id": "6077c4efbc5f4d4df9ef20a1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conversion of Solid from One Shape to Another",
                                                        "id": "5ec3783d497e903afb98dc9e",
                                                        "_id": "6077c4efbc5f4d4df9ef209e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbf5",
                                                                "_id": "6077c4efbc5f4d4df9ef209f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ac",
                                                        "_id": "6077c4efbc5f4d4df9ef20a6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Some Applications of Trigonometry",
                                                "id": "5ec36b98f05a6036ccbb3814",
                                                "_id": "6077c4efbc5f4d4df9ef2099",
                                                "concepts": [
                                                    {
                                                        "name": "Heights and Distances",
                                                        "id": "5ec376b9f05a6036ccbb38cf",
                                                        "_id": "6077c4efbc5f4d4df9ef209a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbfb",
                                                                "_id": "6077c4efbc5f4d4df9ef209b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ae",
                                                        "_id": "6077c4efbc5f4d4df9ef209c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics",
                                                "id": "5ec36b98f05a6036ccbb3819",
                                                "_id": "6077c4efbc5f4d4df9ef208b",
                                                "concepts": [
                                                    {
                                                        "name": "Mode of Grouped Data",
                                                        "id": "5ec37898e56f4536c6184408",
                                                        "_id": "6077c4efbc5f4d4df9ef2096",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbfc",
                                                                "_id": "6077c4efbc5f4d4df9ef2097"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean of Grouped Data Using Direct Method",
                                                        "id": "5ec37898e56f4536c6184405",
                                                        "_id": "6077c4efbc5f4d4df9ef2094",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbfd",
                                                                "_id": "6077c4efbc5f4d4df9ef2095"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean of Grouped Data Using Assumed Mean Method",
                                                        "id": "5ec37898e56f4536c6184406",
                                                        "_id": "6077c4efbc5f4d4df9ef2092",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbfe",
                                                                "_id": "6077c4efbc5f4d4df9ef2093"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean of Grouped Data Using Step Deviation Method",
                                                        "id": "5ec37898e56f4536c6184407",
                                                        "_id": "6077c4efbc5f4d4df9ef2090",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dbff",
                                                                "_id": "6077c4efbc5f4d4df9ef2091"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Median of Grouped Data",
                                                        "id": "5ec37898e56f4536c6184409",
                                                        "_id": "6077c4efbc5f4d4df9ef208e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc00",
                                                                "_id": "6077c4efbc5f4d4df9ef208f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graphical Representation of Cumulative Frequency Distribution",
                                                        "id": "5ec37898e56f4536c618440a",
                                                        "_id": "6077c4efbc5f4d4df9ef208c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc01",
                                                                "_id": "6077c4efbc5f4d4df9ef208d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9af",
                                                        "_id": "6077c4efbc5f4d4df9ef2098"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability",
                                                "id": "5ec36b98f05a6036ccbb381a",
                                                "_id": "6077c4efbc5f4d4df9ef2083",
                                                "concepts": [
                                                    {
                                                        "name": "Sure and Impossible Events",
                                                        "id": "5ec378d0e56f4536c618441d",
                                                        "_id": "6077c4efbc5f4d4df9ef2088",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc02",
                                                                "_id": "6077c4efbc5f4d4df9ef2089"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Probability of an Event",
                                                        "id": "5ec378d0e56f4536c618441b",
                                                        "_id": "6077c4efbc5f4d4df9ef2086",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc03",
                                                                "_id": "6077c4efbc5f4d4df9ef2087"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Probability of Complement of an Event",
                                                        "id": "5ec378d0e56f4536c618441c",
                                                        "_id": "6077c4efbc5f4d4df9ef2084",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc04",
                                                                "_id": "6077c4efbc5f4d4df9ef2085"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b0",
                                                        "_id": "6077c4efbc5f4d4df9ef208a"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Geometry",
                                                "id": "5f687f33058075680d816492",
                                                "_id": "6077c4efbc5f4d4df9ef2075",
                                                "concepts": [
                                                    {
                                                        "name": "Concurrency Theorems",
                                                        "id": "5f688427ca5ac358f1705c72",
                                                        "_id": "6077c4efbc5f4d4df9ef2080",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc0b",
                                                                "_id": "6077c4efbc5f4d4df9ef2081"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Thales Theorem And Angle Bisector Theorem",
                                                        "id": "5f688427ca5ac358f1705c6f",
                                                        "_id": "6077c4efbc5f4d4df9ef207e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc0c",
                                                                "_id": "6077c4efbc5f4d4df9ef207f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pythagoras Theorem",
                                                        "id": "5f688427ca5ac358f1705c70",
                                                        "_id": "6077c4efbc5f4d4df9ef207c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc0d",
                                                                "_id": "6077c4efbc5f4d4df9ef207d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c6d",
                                                        "_id": "6077c4efbc5f4d4df9ef207a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc0e",
                                                                "_id": "6077c4efbc5f4d4df9ef207b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Circles And Tangents",
                                                        "id": "5f688427ca5ac358f1705c71",
                                                        "_id": "6077c4efbc5f4d4df9ef2078",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc0f",
                                                                "_id": "6077c4efbc5f4d4df9ef2079"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Similarity",
                                                        "id": "5f688427ca5ac358f1705c6e",
                                                        "_id": "6077c4efbc5f4d4df9ef2076",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc10",
                                                                "_id": "6077c4efbc5f4d4df9ef2077"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b3",
                                                        "_id": "6077c4efbc5f4d4df9ef2082"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Coordinate Geometry",
                                                "id": "5f687f33058075680d816493",
                                                "_id": "6077c4efbc5f4d4df9ef2067",
                                                "concepts": [
                                                    {
                                                        "name": "Inclination Of A Line",
                                                        "id": "5f688427ca5ac358f1705c76",
                                                        "_id": "6077c4efbc5f4d4df9ef2072",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc11",
                                                                "_id": "6077c4efbc5f4d4df9ef2073"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area Of A Quadrilateral",
                                                        "id": "5f688427ca5ac358f1705c75",
                                                        "_id": "6077c4efbc5f4d4df9ef2070",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc12",
                                                                "_id": "6077c4efbc5f4d4df9ef2071"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c73",
                                                        "_id": "6077c4efbc5f4d4df9ef206e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc13",
                                                                "_id": "6077c4efbc5f4d4df9ef206f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "General Form Of A Straight Line",
                                                        "id": "5f688427ca5ac358f1705c78",
                                                        "_id": "6077c4efbc5f4d4df9ef206c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc14",
                                                                "_id": "6077c4efbc5f4d4df9ef206d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Area Of A Triangle",
                                                        "id": "5f688427ca5ac358f1705c74",
                                                        "_id": "6077c4efbc5f4d4df9ef206a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc15",
                                                                "_id": "6077c4efbc5f4d4df9ef206b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Straight Line",
                                                        "id": "5f688427ca5ac358f1705c77",
                                                        "_id": "6077c4efbc5f4d4df9ef2068",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc16",
                                                                "_id": "6077c4efbc5f4d4df9ef2069"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b4",
                                                        "_id": "6077c4efbc5f4d4df9ef2074"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Numbers And Sequences",
                                                "id": "5f687f33058075680d816490",
                                                "_id": "6077c4efbc5f4d4df9ef204f",
                                                "concepts": [
                                                    {
                                                        "name": "Special Series",
                                                        "id": "5f688427ca5ac358f1705c63",
                                                        "_id": "6077c4efbc5f4d4df9ef2064",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc17",
                                                                "_id": "6077c4efbc5f4d4df9ef2065"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sum To N Terms Of A Geometric Progression",
                                                        "id": "5f688427ca5ac358f1705c62",
                                                        "_id": "6077c4efbc5f4d4df9ef2062",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc18",
                                                                "_id": "6077c4efbc5f4d4df9ef2063"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Arithmetic Progression",
                                                        "id": "5f688427ca5ac358f1705c5f",
                                                        "_id": "6077c4efbc5f4d4df9ef2060",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc19",
                                                                "_id": "6077c4efbc5f4d4df9ef2061"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Euclid’s Division Algorithm",
                                                        "id": "5f688427ca5ac358f1705c5b",
                                                        "_id": "6077c4efbc5f4d4df9ef205e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1a",
                                                                "_id": "6077c4efbc5f4d4df9ef205f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental Theorem Of Arithmetic",
                                                        "id": "5f688427ca5ac358f1705c5c",
                                                        "_id": "6077c4efbc5f4d4df9ef205c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1b",
                                                                "_id": "6077c4efbc5f4d4df9ef205d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c59",
                                                        "_id": "6077c4efbc5f4d4df9ef205a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1c",
                                                                "_id": "6077c4efbc5f4d4df9ef205b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modular Arithmetic",
                                                        "id": "5f688427ca5ac358f1705c5d",
                                                        "_id": "6077c4efbc5f4d4df9ef2058",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1d",
                                                                "_id": "6077c4efbc5f4d4df9ef2059"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometric Progression",
                                                        "id": "5f688427ca5ac358f1705c61",
                                                        "_id": "6077c4efbc5f4d4df9ef2056",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1e",
                                                                "_id": "6077c4efbc5f4d4df9ef2057"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sequences",
                                                        "id": "5f688427ca5ac358f1705c5e",
                                                        "_id": "6077c4efbc5f4d4df9ef2054",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc1f",
                                                                "_id": "6077c4efbc5f4d4df9ef2055"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Euclid’s Division Lemma",
                                                        "id": "5f688427ca5ac358f1705c5a",
                                                        "_id": "6077c4efbc5f4d4df9ef2052",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc20",
                                                                "_id": "6077c4efbc5f4d4df9ef2053"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Series",
                                                        "id": "5f688427ca5ac358f1705c60",
                                                        "_id": "6077c4efbc5f4d4df9ef2050",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc21",
                                                                "_id": "6077c4efbc5f4d4df9ef2051"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b5",
                                                        "_id": "6077c4efbc5f4d4df9ef2066"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef20cb"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Nature Of Physical World And Measurement",
                                                "id": "5f6860f5058075680d815458",
                                                "_id": "6077c4efbc5f4d4df9ef203c",
                                                "concepts": [
                                                    {
                                                        "name": "Theory Of Errors",
                                                        "id": "5f6862f9f100a06808b0f5a6",
                                                        "_id": "6077c4efbc5f4d4df9ef204b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7e",
                                                                "_id": "6077c4efbc5f4d4df9ef204c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Physics - Introduction",
                                                        "id": "5f6862f9f100a06808b0f5a2",
                                                        "_id": "6077c4efbc5f4d4df9ef2049",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de7f",
                                                                "_id": "6077c4efbc5f4d4df9ef204a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Physics In Relation To Technology And Society",
                                                        "id": "5f6862f9f100a06808b0f5a3",
                                                        "_id": "6077c4efbc5f4d4df9ef2047",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de80",
                                                                "_id": "6077c4efbc5f4d4df9ef2048"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Dimensional Analysis",
                                                        "id": "5f6862f9f100a06808b0f5a8",
                                                        "_id": "6077c4efbc5f4d4df9ef2045",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de81",
                                                                "_id": "6077c4efbc5f4d4df9ef2046"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Significant Figures",
                                                        "id": "5f6862f9f100a06808b0f5a7",
                                                        "_id": "6077c4efbc5f4d4df9ef2043",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de82",
                                                                "_id": "6077c4efbc5f4d4df9ef2044"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Science—Introduction",
                                                        "id": "5f6862f9f100a06808b0f5a1",
                                                        "_id": "6077c4efbc5f4d4df9ef2041",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de83",
                                                                "_id": "6077c4efbc5f4d4df9ef2042"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Measurement Of Basic Quantities",
                                                        "id": "5f6862f9f100a06808b0f5a5",
                                                        "_id": "6077c4efbc5f4d4df9ef203f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de84",
                                                                "_id": "6077c4efbc5f4d4df9ef2040"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Measurement",
                                                        "id": "5f6862f9f100a06808b0f5a4",
                                                        "_id": "6077c4efbc5f4d4df9ef203d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de85",
                                                                "_id": "6077c4efbc5f4d4df9ef203e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd78",
                                                        "_id": "6077c4efbc5f4d4df9ef204d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Work, Energy And Power",
                                                "id": "5f6860f5058075680d81545b",
                                                "_id": "6077c4efbc5f4d4df9ef2030",
                                                "concepts": [
                                                    {
                                                        "name": "Energy",
                                                        "id": "5f6862f9f100a06808b0f5bd",
                                                        "_id": "6077c4efbc5f4d4df9ef2039",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de86",
                                                                "_id": "6077c4efbc5f4d4df9ef203a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6862f9f100a06808b0f5bb",
                                                        "_id": "6077c4efbc5f4d4df9ef2037",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de87",
                                                                "_id": "6077c4efbc5f4d4df9ef2038"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Work",
                                                        "id": "5f6862f9f100a06808b0f5bc",
                                                        "_id": "6077c4efbc5f4d4df9ef2035",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de88",
                                                                "_id": "6077c4efbc5f4d4df9ef2036"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Collisions",
                                                        "id": "5f6862f9f100a06808b0f5bf",
                                                        "_id": "6077c4efbc5f4d4df9ef2033",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de89",
                                                                "_id": "6077c4efbc5f4d4df9ef2034"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Power",
                                                        "id": "5f6862f9f100a06808b0f5be",
                                                        "_id": "6077c4efbc5f4d4df9ef2031",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de8a",
                                                                "_id": "6077c4efbc5f4d4df9ef2032"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd79",
                                                        "_id": "6077c4efbc5f4d4df9ef203b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Principle of communication",
                                                "id": "5ace20329fe7b01d5806bcb6",
                                                "_id": "6077c4efbc5f4d4df9ef202c",
                                                "concepts": [
                                                    {
                                                        "name": "Basic of electronic communication",
                                                        "id": "5ace20419fe7b01d5806c1d2",
                                                        "_id": "6077c4efbc5f4d4df9ef202d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de96",
                                                                "_id": "6077c4efbc5f4d4df9ef202e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd7b",
                                                        "_id": "6077c4efbc5f4d4df9ef202f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Semi conductors",
                                                "id": "5ace20329fe7b01d5806bcb7",
                                                "_id": "6077c4efbc5f4d4df9ef2026",
                                                "concepts": [
                                                    {
                                                        "name": "basic of semiconductors, semiconductors diode, junction transistor",
                                                        "id": "5ace20419fe7b01d5806c1d3",
                                                        "_id": "6077c4efbc5f4d4df9ef2029",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de97",
                                                                "_id": "6077c4efbc5f4d4df9ef202a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "digital electronics and logic gates",
                                                        "id": "5ace20419fe7b01d5806c1d4",
                                                        "_id": "6077c4efbc5f4d4df9ef2027",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de98",
                                                                "_id": "6077c4efbc5f4d4df9ef2028"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd7c",
                                                        "_id": "6077c4efbc5f4d4df9ef202b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef204e"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Figure analogy",
                                                "id": "5ace20309fe7b01d5806bc2a",
                                                "_id": "6077c4efbc5f4d4df9ef2021",
                                                "concepts": [
                                                    {
                                                        "name": "Figure analogy",
                                                        "id": "5ace20389fe7b01d5806bf1a",
                                                        "_id": "6077c4efbc5f4d4df9ef2022",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843e",
                                                                "_id": "6077c4efbc5f4d4df9ef2023"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8258",
                                                        "_id": "6077c4efbc5f4d4df9ef2024"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Figure classification & Figure counting",
                                                "id": "5ace20319fe7b01d5806bc2b",
                                                "_id": "6077c4efbc5f4d4df9ef201d",
                                                "concepts": [
                                                    {
                                                        "name": "Figure classification & Figure counting",
                                                        "id": "5ace20389fe7b01d5806bf1b",
                                                        "_id": "6077c4efbc5f4d4df9ef201e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c843f",
                                                                "_id": "6077c4efbc5f4d4df9ef201f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8259",
                                                        "_id": "6077c4efbc5f4d4df9ef2020"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef2025"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Electoral Politics",
                                                "id": "5ace20329fe7b01d5806bce6",
                                                "_id": "6077c4efbc5f4d4df9ef2018",
                                                "concepts": [
                                                    {
                                                        "name": "Needs of election & steps involved in it.",
                                                        "id": "5ace20429fe7b01d5806c231",
                                                        "_id": "6077c4efbc5f4d4df9ef2019",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c848f",
                                                                "_id": "6077c4efbc5f4d4df9ef201a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8288",
                                                        "_id": "6077c4efbc5f4d4df9ef201b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Working of Institutions",
                                                "id": "5ace20329fe7b01d5806bcee",
                                                "_id": "6077c4efbc5f4d4df9ef2014",
                                                "concepts": [
                                                    {
                                                        "name": "Functions of legislature, \nexecutive and judiciary",
                                                        "id": "5ace20429fe7b01d5806c23d",
                                                        "_id": "6077c4efbc5f4d4df9ef2015",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8490",
                                                                "_id": "6077c4efbc5f4d4df9ef2016"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8289",
                                                        "_id": "6077c4efbc5f4d4df9ef2017"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Democratic Rights",
                                                "id": "5ace20329fe7b01d5806bce5",
                                                "_id": "6077c4efbc5f4d4df9ef2010",
                                                "concepts": [
                                                    {
                                                        "name": "The fundamental rights & the writs.",
                                                        "id": "5ace20429fe7b01d5806c230",
                                                        "_id": "6077c4efbc5f4d4df9ef2011",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8491",
                                                                "_id": "6077c4efbc5f4d4df9ef2012"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828a",
                                                        "_id": "6077c4efbc5f4d4df9ef2013"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef201c"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Pattern Perception",
                                                "id": "5ace20309fe7b01d5806bc1a",
                                                "_id": "6077c4efbc5f4d4df9ef200b",
                                                "concepts": [
                                                    {
                                                        "name": "Figure Completion",
                                                        "id": "5ace20389fe7b01d5806bf05",
                                                        "_id": "6077c4efbc5f4d4df9ef200c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4a",
                                                                "_id": "6077c4efbc5f4d4df9ef200d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df3b",
                                                        "_id": "6077c4efbc5f4d4df9ef200e"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef200f"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 9,
                                "startDate": "2021-06-24T00:00:00.000Z",
                                "endDate": "2021-06-30T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef1ee2",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Heredity & Evolution",
                                                "id": "5ace202f9fe7b01d5806bbbe",
                                                "_id": "6077c4efbc5f4d4df9ef1ffb",
                                                "concepts": [
                                                    {
                                                        "name": "Mendel's laws of genetics, Mendelian ratios",
                                                        "id": "5ace20339fe7b01d5806bd24",
                                                        "_id": "6077c4efbc5f4d4df9ef2006",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8308",
                                                                "_id": "6077c4efbc5f4d4df9ef2007"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Experiments to show DNA as genetic material, Structure of DNA, Types of chromosomes",
                                                        "id": "5ace20339fe7b01d5806bd23",
                                                        "_id": "6077c4efbc5f4d4df9ef2004",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8309",
                                                                "_id": "6077c4efbc5f4d4df9ef2005"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sex determination in Human and Genetic Disorders",
                                                        "id": "5ace20339fe7b01d5806bd25",
                                                        "_id": "6077c4efbc5f4d4df9ef2002",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830a",
                                                                "_id": "6077c4efbc5f4d4df9ef2003"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories of Origin of Life",
                                                        "id": "5ace20339fe7b01d5806bd27",
                                                        "_id": "6077c4efbc5f4d4df9ef2000",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830b",
                                                                "_id": "6077c4efbc5f4d4df9ef2001"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories of Evolution",
                                                        "id": "5ace20339fe7b01d5806bd26",
                                                        "_id": "6077c4efbc5f4d4df9ef1ffe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830c",
                                                                "_id": "6077c4efbc5f4d4df9ef1fff"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Evidences of Evolution",
                                                        "id": "5ace20339fe7b01d5806bd22",
                                                        "_id": "6077c4efbc5f4d4df9ef1ffc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830d",
                                                                "_id": "6077c4efbc5f4d4df9ef1ffd"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c820f",
                                                        "_id": "6077c4efbc5f4d4df9ef2008"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef2009"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [
                                            {
                                                "name": "Carbon Compounds",
                                                "id": "5ace202f9fe7b01d5806bbc9",
                                                "_id": "6077c4efbc5f4d4df9ef1fea",
                                                "concepts": [
                                                    {
                                                        "name": "IUPAC Nomenclature",
                                                        "id": "5ace20349fe7b01d5806bd8b",
                                                        "_id": "6077c4efbc5f4d4df9ef1ff7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835b",
                                                                "_id": "6077c4efbc5f4d4df9ef1ff8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Versatile Nature Of Carbon, Some Compounds Of Carbon",
                                                        "id": "5ace20349fe7b01d5806bd8f",
                                                        "_id": "6077c4efbc5f4d4df9ef1ff5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835c",
                                                                "_id": "6077c4efbc5f4d4df9ef1ff6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Isomerism",
                                                        "id": "5ace20349fe7b01d5806bd8a",
                                                        "_id": "6077c4efbc5f4d4df9ef1ff3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835d",
                                                                "_id": "6077c4efbc5f4d4df9ef1ff4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types of Organic Reactions",
                                                        "id": "5ace20349fe7b01d5806bd8e",
                                                        "_id": "6077c4efbc5f4d4df9ef1ff1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835e",
                                                                "_id": "6077c4efbc5f4d4df9ef1ff2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polymers",
                                                        "id": "5ace20349fe7b01d5806bd8c",
                                                        "_id": "6077c4efbc5f4d4df9ef1fef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c835f",
                                                                "_id": "6077c4efbc5f4d4df9ef1ff0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Soaps & Detergents",
                                                        "id": "5ace20349fe7b01d5806bd8d",
                                                        "_id": "6077c4efbc5f4d4df9ef1fed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8360",
                                                                "_id": "6077c4efbc5f4d4df9ef1fee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Allotropes of Carbon",
                                                        "id": "5ace20349fe7b01d5806bd89",
                                                        "_id": "6077c4efbc5f4d4df9ef1feb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8361",
                                                                "_id": "6077c4efbc5f4d4df9ef1fec"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c821a",
                                                        "_id": "6077c4efbc5f4d4df9ef1ff9"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef1ffa"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Mensuration",
                                                "id": "5f687f33058075680d816495",
                                                "_id": "6077c4efbc5f4d4df9ef1fdd",
                                                "concepts": [
                                                    {
                                                        "name": "Volume And Surface Area Of Combined Solids",
                                                        "id": "5f688427ca5ac358f1705c7f",
                                                        "_id": "6077c4efbc5f4d4df9ef1fe6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc22",
                                                                "_id": "6077c4efbc5f4d4df9ef1fe7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Surface Area",
                                                        "id": "5f688427ca5ac358f1705c7d",
                                                        "_id": "6077c4efbc5f4d4df9ef1fe4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc23",
                                                                "_id": "6077c4efbc5f4d4df9ef1fe5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conversion Of Solids From One Shape To Another With No Change In Volume",
                                                        "id": "5f688427ca5ac358f1705c80",
                                                        "_id": "6077c4efbc5f4d4df9ef1fe2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc24",
                                                                "_id": "6077c4efbc5f4d4df9ef1fe3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume",
                                                        "id": "5f688427ca5ac358f1705c7e",
                                                        "_id": "6077c4efbc5f4d4df9ef1fe0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc25",
                                                                "_id": "6077c4efbc5f4d4df9ef1fe1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c7c",
                                                        "_id": "6077c4efbc5f4d4df9ef1fde",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc26",
                                                                "_id": "6077c4efbc5f4d4df9ef1fdf"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b6",
                                                        "_id": "6077c4efbc5f4d4df9ef1fe8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Algebra",
                                                "id": "5f687f33058075680d816491",
                                                "_id": "6077c4efbc5f4d4df9ef1fc9",
                                                "concepts": [
                                                    {
                                                        "name": "Simultaneous Linear Equations In Three Variables",
                                                        "id": "5f688427ca5ac358f1705c65",
                                                        "_id": "6077c4efbc5f4d4df9ef1fda",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc27",
                                                                "_id": "6077c4efbc5f4d4df9ef1fdb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Square Root Of Polynomials",
                                                        "id": "5f688427ca5ac358f1705c68",
                                                        "_id": "6077c4efbc5f4d4df9ef1fd8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc28",
                                                                "_id": "6077c4efbc5f4d4df9ef1fd9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c64",
                                                        "_id": "6077c4efbc5f4d4df9ef1fd6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc29",
                                                                "_id": "6077c4efbc5f4d4df9ef1fd7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Matrices",
                                                        "id": "5f688427ca5ac358f1705c6c",
                                                        "_id": "6077c4efbc5f4d4df9ef1fd4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2a",
                                                                "_id": "6077c4efbc5f4d4df9ef1fd5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Quadratic Graphs",
                                                        "id": "5f688427ca5ac358f1705c6b",
                                                        "_id": "6077c4efbc5f4d4df9ef1fd2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2b",
                                                                "_id": "6077c4efbc5f4d4df9ef1fd3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graph Of Variations",
                                                        "id": "5f688427ca5ac358f1705c6a",
                                                        "_id": "6077c4efbc5f4d4df9ef1fd0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2c",
                                                                "_id": "6077c4efbc5f4d4df9ef1fd1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Quadratic Equations",
                                                        "id": "5f688427ca5ac358f1705c69",
                                                        "_id": "6077c4efbc5f4d4df9ef1fce",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2d",
                                                                "_id": "6077c4efbc5f4d4df9ef1fcf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rational Expressions",
                                                        "id": "5f688427ca5ac358f1705c67",
                                                        "_id": "6077c4efbc5f4d4df9ef1fcc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2e",
                                                                "_id": "6077c4efbc5f4d4df9ef1fcd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "GCD And LCM Of Polynomials",
                                                        "id": "5f688427ca5ac358f1705c66",
                                                        "_id": "6077c4efbc5f4d4df9ef1fca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc2f",
                                                                "_id": "6077c4efbc5f4d4df9ef1fcb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b7",
                                                        "_id": "6077c4efbc5f4d4df9ef1fdc"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics And Probability",
                                                "id": "5f687f33058075680d816496",
                                                "_id": "6077c4efbc5f4d4df9ef1fbb",
                                                "concepts": [
                                                    {
                                                        "name": "Measures Of Dispersion",
                                                        "id": "5f688427ca5ac358f1705c82",
                                                        "_id": "6077c4efbc5f4d4df9ef1fc6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc30",
                                                                "_id": "6077c4efbc5f4d4df9ef1fc7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Probability",
                                                        "id": "5f688427ca5ac358f1705c84",
                                                        "_id": "6077c4efbc5f4d4df9ef1fc4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc31",
                                                                "_id": "6077c4efbc5f4d4df9ef1fc5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Algebra Of Events",
                                                        "id": "5f688427ca5ac358f1705c85",
                                                        "_id": "6077c4efbc5f4d4df9ef1fc2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc32",
                                                                "_id": "6077c4efbc5f4d4df9ef1fc3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coefficient Of Variation",
                                                        "id": "5f688427ca5ac358f1705c83",
                                                        "_id": "6077c4efbc5f4d4df9ef1fc0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc33",
                                                                "_id": "6077c4efbc5f4d4df9ef1fc1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c81",
                                                        "_id": "6077c4efbc5f4d4df9ef1fbe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc34",
                                                                "_id": "6077c4efbc5f4d4df9ef1fbf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Addition Theorem Of Probability",
                                                        "id": "5f688427ca5ac358f1705c86",
                                                        "_id": "6077c4efbc5f4d4df9ef1fbc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc35",
                                                                "_id": "6077c4efbc5f4d4df9ef1fbd"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9b8",
                                                        "_id": "6077c4efbc5f4d4df9ef1fc8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Relations And Functions",
                                                "id": "5f687f33058075680d81648f",
                                                "_id": "6077c4efbc5f4d4df9ef1fa5",
                                                "concepts": [
                                                    {
                                                        "name": "Cartesian Product",
                                                        "id": "5f688427ca5ac358f1705c51",
                                                        "_id": "6077c4efbc5f4d4df9ef1fb8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc39",
                                                                "_id": "6077c4efbc5f4d4df9ef1fb9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Functions",
                                                        "id": "5f688427ca5ac358f1705c55",
                                                        "_id": "6077c4efbc5f4d4df9ef1fb6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3a",
                                                                "_id": "6077c4efbc5f4d4df9ef1fb7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Representation Of Functions",
                                                        "id": "5f688427ca5ac358f1705c54",
                                                        "_id": "6077c4efbc5f4d4df9ef1fb4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3b",
                                                                "_id": "6077c4efbc5f4d4df9ef1fb5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relations",
                                                        "id": "5f688427ca5ac358f1705c52",
                                                        "_id": "6077c4efbc5f4d4df9ef1fb2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3c",
                                                                "_id": "6077c4efbc5f4d4df9ef1fb3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Special Cases Of Functions",
                                                        "id": "5f688427ca5ac358f1705c56",
                                                        "_id": "6077c4efbc5f4d4df9ef1fb0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3d",
                                                                "_id": "6077c4efbc5f4d4df9ef1fb1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f688427ca5ac358f1705c4f",
                                                        "_id": "6077c4efbc5f4d4df9ef1fae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3e",
                                                                "_id": "6077c4efbc5f4d4df9ef1faf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ordered Pair",
                                                        "id": "5f688427ca5ac358f1705c50",
                                                        "_id": "6077c4efbc5f4d4df9ef1fac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc3f",
                                                                "_id": "6077c4efbc5f4d4df9ef1fad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Identifying The Graphs Of Linear, Quadratic, Cubic And Reciprocal Functions",
                                                        "id": "5f688427ca5ac358f1705c58",
                                                        "_id": "6077c4efbc5f4d4df9ef1faa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc40",
                                                                "_id": "6077c4efbc5f4d4df9ef1fab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Composition Of Functions",
                                                        "id": "5f688427ca5ac358f1705c57",
                                                        "_id": "6077c4efbc5f4d4df9ef1fa8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc41",
                                                                "_id": "6077c4efbc5f4d4df9ef1fa9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functions",
                                                        "id": "5f688427ca5ac358f1705c53",
                                                        "_id": "6077c4efbc5f4d4df9ef1fa6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc42",
                                                                "_id": "6077c4efbc5f4d4df9ef1fa7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ba",
                                                        "_id": "6077c4efbc5f4d4df9ef1fba"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Set Language",
                                                "id": "5f64aec082532750fe359c1c",
                                                "_id": "6077c4efbc5f4d4df9ef1f93",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f657fbf03e86d7fe78b3e5e",
                                                        "_id": "6077c4efbc5f4d4df9ef1fa2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc47",
                                                                "_id": "6077c4efbc5f4d4df9ef1fa3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application On Cardinality Of Sets:",
                                                        "id": "5f657fbf03e86d7fe78b3e65",
                                                        "_id": "6077c4efbc5f4d4df9ef1fa0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc48",
                                                                "_id": "6077c4efbc5f4d4df9ef1fa1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Representation Of A Set",
                                                        "id": "5f657fbf03e86d7fe78b3e60",
                                                        "_id": "6077c4efbc5f4d4df9ef1f9e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc49",
                                                                "_id": "6077c4efbc5f4d4df9ef1f9f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties Of Set Operations",
                                                        "id": "5f657fbf03e86d7fe78b3e63",
                                                        "_id": "6077c4efbc5f4d4df9ef1f9c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4a",
                                                                "_id": "6077c4efbc5f4d4df9ef1f9d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Sets",
                                                        "id": "5f657fbf03e86d7fe78b3e61",
                                                        "_id": "6077c4efbc5f4d4df9ef1f9a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4b",
                                                                "_id": "6077c4efbc5f4d4df9ef1f9b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Set",
                                                        "id": "5f657fbf03e86d7fe78b3e5f",
                                                        "_id": "6077c4efbc5f4d4df9ef1f98",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4c",
                                                                "_id": "6077c4efbc5f4d4df9ef1f99"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De Morgan’s Laws",
                                                        "id": "5f657fbf03e86d7fe78b3e64",
                                                        "_id": "6077c4efbc5f4d4df9ef1f96",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4d",
                                                                "_id": "6077c4efbc5f4d4df9ef1f97"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Set Operations",
                                                        "id": "5f657fbf03e86d7fe78b3e62",
                                                        "_id": "6077c4efbc5f4d4df9ef1f94",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4e",
                                                                "_id": "6077c4efbc5f4d4df9ef1f95"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9bc",
                                                        "_id": "6077c4efbc5f4d4df9ef1fa4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Algebra",
                                                "id": "5f64aec082532750fe359c1e",
                                                "_id": "6077c4efbc5f4d4df9ef1f81",
                                                "concepts": [
                                                    {
                                                        "name": "Division of Polynomials",
                                                        "id": "5f65877582532750fe35cff4",
                                                        "_id": "6077c4efbc5f4d4df9ef1f90",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc4f",
                                                                "_id": "6077c4efbc5f4d4df9ef1f91"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polynomials",
                                                        "id": "5f65877582532750fe35cff0",
                                                        "_id": "6077c4efbc5f4d4df9ef1f8e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc50",
                                                                "_id": "6077c4efbc5f4d4df9ef1f8f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f65877582532750fe35cfef",
                                                        "_id": "6077c4efbc5f4d4df9ef1f8c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc51",
                                                                "_id": "6077c4efbc5f4d4df9ef1f8d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Factorisation",
                                                        "id": "5f65877582532750fe35cff3",
                                                        "_id": "6077c4efbc5f4d4df9ef1f8a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc52",
                                                                "_id": "6077c4efbc5f4d4df9ef1f8b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear Equation In Two Variables",
                                                        "id": "5f65877582532750fe35cff6",
                                                        "_id": "6077c4efbc5f4d4df9ef1f88",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc53",
                                                                "_id": "6077c4efbc5f4d4df9ef1f89"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Greatest Common Divisor (Gcd)",
                                                        "id": "5f65877582532750fe35cff5",
                                                        "_id": "6077c4efbc5f4d4df9ef1f86",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc54",
                                                                "_id": "6077c4efbc5f4d4df9ef1f87"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Algebraic Identities",
                                                        "id": "5f65877582532750fe35cff2",
                                                        "_id": "6077c4efbc5f4d4df9ef1f84",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc55",
                                                                "_id": "6077c4efbc5f4d4df9ef1f85"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Remainder Theorem",
                                                        "id": "5f65877582532750fe35cff1",
                                                        "_id": "6077c4efbc5f4d4df9ef1f82",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc56",
                                                                "_id": "6077c4efbc5f4d4df9ef1f83"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9bd",
                                                        "_id": "6077c4efbc5f4d4df9ef1f92"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statistics",
                                                "id": "5f64aec082532750fe359c23",
                                                "_id": "6077c4efbc5f4d4df9ef1f73",
                                                "concepts": [
                                                    {
                                                        "name": "Median",
                                                        "id": "5f65877582532750fe35d012",
                                                        "_id": "6077c4efbc5f4d4df9ef1f7e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc57",
                                                                "_id": "6077c4efbc5f4d4df9ef1f7f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f65877582532750fe35d00e",
                                                        "_id": "6077c4efbc5f4d4df9ef1f7c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc58",
                                                                "_id": "6077c4efbc5f4d4df9ef1f7d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Collection Of Data",
                                                        "id": "5f65877582532750fe35d00f",
                                                        "_id": "6077c4efbc5f4d4df9ef1f7a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc59",
                                                                "_id": "6077c4efbc5f4d4df9ef1f7b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mode",
                                                        "id": "5f65877582532750fe35d013",
                                                        "_id": "6077c4efbc5f4d4df9ef1f78",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5a",
                                                                "_id": "6077c4efbc5f4d4df9ef1f79"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Measures Of Central Tendency",
                                                        "id": "5f65877582532750fe35d010",
                                                        "_id": "6077c4efbc5f4d4df9ef1f76",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5b",
                                                                "_id": "6077c4efbc5f4d4df9ef1f77"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Arithmetic Mean",
                                                        "id": "5f65877582532750fe35d011",
                                                        "_id": "6077c4efbc5f4d4df9ef1f74",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5c",
                                                                "_id": "6077c4efbc5f4d4df9ef1f75"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9be",
                                                        "_id": "6077c4efbc5f4d4df9ef1f80"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability",
                                                "id": "5f64aec082532750fe359c24",
                                                "_id": "6077c4efbc5f4d4df9ef1f67",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f65877582532750fe35d014",
                                                        "_id": "6077c4efbc5f4d4df9ef1f70",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5d",
                                                                "_id": "6077c4efbc5f4d4df9ef1f71"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic Ideas",
                                                        "id": "5f65877582532750fe35d015",
                                                        "_id": "6077c4efbc5f4d4df9ef1f6e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5e",
                                                                "_id": "6077c4efbc5f4d4df9ef1f6f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classical Approach",
                                                        "id": "5f65877582532750fe35d016",
                                                        "_id": "6077c4efbc5f4d4df9ef1f6c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc5f",
                                                                "_id": "6077c4efbc5f4d4df9ef1f6d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Empirical Approach",
                                                        "id": "5f65877582532750fe35d017",
                                                        "_id": "6077c4efbc5f4d4df9ef1f6a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc60",
                                                                "_id": "6077c4efbc5f4d4df9ef1f6b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Events",
                                                        "id": "5f65877582532750fe35d018",
                                                        "_id": "6077c4efbc5f4d4df9ef1f68",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc61",
                                                                "_id": "6077c4efbc5f4d4df9ef1f69"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9bf",
                                                        "_id": "6077c4efbc5f4d4df9ef1f72"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Geometry",
                                                "id": "5f64aec082532750fe359c1f",
                                                "_id": "6077c4efbc5f4d4df9ef1f57",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f65877582532750fe35cff7",
                                                        "_id": "6077c4efbc5f4d4df9ef1f64",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc62",
                                                                "_id": "6077c4efbc5f4d4df9ef1f65"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cyclic Quadrilaterals",
                                                        "id": "5f65877582532750fe35cffc",
                                                        "_id": "6077c4efbc5f4d4df9ef1f62",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc63",
                                                                "_id": "6077c4efbc5f4d4df9ef1f63"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parts Of A Circle",
                                                        "id": "5f65877582532750fe35cffa",
                                                        "_id": "6077c4efbc5f4d4df9ef1f60",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc64",
                                                                "_id": "6077c4efbc5f4d4df9ef1f61"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties Of Chords Of A Circle",
                                                        "id": "5f65877582532750fe35cffb",
                                                        "_id": "6077c4efbc5f4d4df9ef1f5e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc65",
                                                                "_id": "6077c4efbc5f4d4df9ef1f5f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Quadrilaterals",
                                                        "id": "5f65877582532750fe35cff9",
                                                        "_id": "6077c4efbc5f4d4df9ef1f5c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc66",
                                                                "_id": "6077c4efbc5f4d4df9ef1f5d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Angles",
                                                        "id": "5f65877582532750fe35cff8",
                                                        "_id": "6077c4efbc5f4d4df9ef1f5a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc67",
                                                                "_id": "6077c4efbc5f4d4df9ef1f5b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Practical Geometry",
                                                        "id": "5f65877582532750fe35cffd",
                                                        "_id": "6077c4efbc5f4d4df9ef1f58",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc68",
                                                                "_id": "6077c4efbc5f4d4df9ef1f59"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c0",
                                                        "_id": "6077c4efbc5f4d4df9ef1f66"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Coordinate Geometry",
                                                "id": "5f64aec082532750fe359c20",
                                                "_id": "6077c4efbc5f4d4df9ef1f47",
                                                "concepts": [
                                                    {
                                                        "name": "The Coordinates Of The Centroid",
                                                        "id": "5f65877582532750fe35d004",
                                                        "_id": "6077c4efbc5f4d4df9ef1f54",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc69",
                                                                "_id": "6077c4efbc5f4d4df9ef1f55"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distance Between Any Two Points",
                                                        "id": "5f65877582532750fe35d000",
                                                        "_id": "6077c4efbc5f4d4df9ef1f52",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6a",
                                                                "_id": "6077c4efbc5f4d4df9ef1f53"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Section Formula",
                                                        "id": "5f65877582532750fe35d003",
                                                        "_id": "6077c4efbc5f4d4df9ef1f50",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6b",
                                                                "_id": "6077c4efbc5f4d4df9ef1f51"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Devising A Coordinate System",
                                                        "id": "5f65877582532750fe35cfff",
                                                        "_id": "6077c4efbc5f4d4df9ef1f4e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6c",
                                                                "_id": "6077c4efbc5f4d4df9ef1f4f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Points Of Trisection Of A Line Segment",
                                                        "id": "5f65877582532750fe35d002",
                                                        "_id": "6077c4efbc5f4d4df9ef1f4c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6d",
                                                                "_id": "6077c4efbc5f4d4df9ef1f4d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Mid-Point Of A Line Segment",
                                                        "id": "5f65877582532750fe35d001",
                                                        "_id": "6077c4efbc5f4d4df9ef1f4a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6e",
                                                                "_id": "6077c4efbc5f4d4df9ef1f4b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mapping The Plane",
                                                        "id": "5f65877582532750fe35cffe",
                                                        "_id": "6077c4efbc5f4d4df9ef1f48",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc6f",
                                                                "_id": "6077c4efbc5f4d4df9ef1f49"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c1",
                                                        "_id": "6077c4efbc5f4d4df9ef1f56"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef1fe9"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Heat and Thermodynamics",
                                                "id": "5ace20329fe7b01d5806bcb8",
                                                "_id": "6077c4efbc5f4d4df9ef1f34",
                                                "concepts": [
                                                    {
                                                        "name": "calorimetary",
                                                        "id": "5ace20419fe7b01d5806c1d5",
                                                        "_id": "6077c4efbc5f4d4df9ef1f43",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de99",
                                                                "_id": "6077c4efbc5f4d4df9ef1f44"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "First law of Thermodynamics & process",
                                                        "id": "5ace20419fe7b01d5806c1d6",
                                                        "_id": "6077c4efbc5f4d4df9ef1f41",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9a",
                                                                "_id": "6077c4efbc5f4d4df9ef1f42"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "graphs, efficiency and engines",
                                                        "id": "5ace20419fe7b01d5806c1d7",
                                                        "_id": "6077c4efbc5f4d4df9ef1f3f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9b",
                                                                "_id": "6077c4efbc5f4d4df9ef1f40"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heat transfer conduction",
                                                        "id": "5ace20419fe7b01d5806c1d8",
                                                        "_id": "6077c4efbc5f4d4df9ef1f3d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9c",
                                                                "_id": "6077c4efbc5f4d4df9ef1f3e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heat transfer radiation and convection",
                                                        "id": "5ace20419fe7b01d5806c1d9",
                                                        "_id": "6077c4efbc5f4d4df9ef1f3b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9d",
                                                                "_id": "6077c4efbc5f4d4df9ef1f3c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ideal gas equation, Average,RMS, Most probable velocities, Molar specific heat capacities",
                                                        "id": "5ace20419fe7b01d5806c1da",
                                                        "_id": "6077c4efbc5f4d4df9ef1f39",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9e",
                                                                "_id": "6077c4efbc5f4d4df9ef1f3a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Kinetic theory of gases and degree of freedom",
                                                        "id": "5ace20419fe7b01d5806c1db",
                                                        "_id": "6077c4efbc5f4d4df9ef1f37",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673de9f",
                                                                "_id": "6077c4efbc5f4d4df9ef1f38"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Thermometry, thermal expansion of solid, liquid",
                                                        "id": "5ace20419fe7b01d5806c1dc",
                                                        "_id": "6077c4efbc5f4d4df9ef1f35",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea0",
                                                                "_id": "6077c4efbc5f4d4df9ef1f36"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd7d",
                                                        "_id": "6077c4efbc5f4d4df9ef1f45"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Simple Harmonic Motion",
                                                "id": "5ace20329fe7b01d5806bcb9",
                                                "_id": "6077c4efbc5f4d4df9ef1f26",
                                                "concepts": [
                                                    {
                                                        "name": "Damped harmonic motion, forced oscillation, superposition principle, reduced mass concept",
                                                        "id": "5ace20419fe7b01d5806c1dd",
                                                        "_id": "6077c4efbc5f4d4df9ef1f31",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea1",
                                                                "_id": "6077c4efbc5f4d4df9ef1f32"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Energy in SHM",
                                                        "id": "5ace20419fe7b01d5806c1de",
                                                        "_id": "6077c4efbc5f4d4df9ef1f2f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea2",
                                                                "_id": "6077c4efbc5f4d4df9ef1f30"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Equation of SHM, Relation between SHM and uniform circular motion, Phase constant, phase",
                                                        "id": "5ace20419fe7b01d5806c1df",
                                                        "_id": "6077c4efbc5f4d4df9ef1f2d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea3",
                                                                "_id": "6077c4efbc5f4d4df9ef1f2e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Frequency of a system performing SHM",
                                                        "id": "5ace20419fe7b01d5806c1e0",
                                                        "_id": "6077c4efbc5f4d4df9ef1f2b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea4",
                                                                "_id": "6077c4efbc5f4d4df9ef1f2c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modulii of elasticity, Elastic potential energy, graph between stress & strain",
                                                        "id": "5ace20419fe7b01d5806c1e1",
                                                        "_id": "6077c4efbc5f4d4df9ef1f29",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea5",
                                                                "_id": "6077c4efbc5f4d4df9ef1f2a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple and rigid pendulum",
                                                        "id": "5ace20419fe7b01d5806c1e2",
                                                        "_id": "6077c4efbc5f4d4df9ef1f27",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea6",
                                                                "_id": "6077c4efbc5f4d4df9ef1f28"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd7e",
                                                        "_id": "6077c4efbc5f4d4df9ef1f33"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Waves and Sound",
                                                "id": "5ace20329fe7b01d5806bcba",
                                                "_id": "6077c4efbc5f4d4df9ef1f16",
                                                "concepts": [
                                                    {
                                                        "name": "Beats and doppler effect, transmission and reflection of wave",
                                                        "id": "5ace20419fe7b01d5806c1e3",
                                                        "_id": "6077c4efbc5f4d4df9ef1f23",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea7",
                                                                "_id": "6077c4efbc5f4d4df9ef1f24"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Energy transfer in waves & intensity",
                                                        "id": "5ace20419fe7b01d5806c1e4",
                                                        "_id": "6077c4efbc5f4d4df9ef1f21",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea8",
                                                                "_id": "6077c4efbc5f4d4df9ef1f22"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "standing wave in organ pipe and in rod",
                                                        "id": "5ace20419fe7b01d5806c1e5",
                                                        "_id": "6077c4efbc5f4d4df9ef1f1f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dea9",
                                                                "_id": "6077c4efbc5f4d4df9ef1f20"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Superposition of waves - Interference, standing wave in string, energy in standing wave",
                                                        "id": "5ace20419fe7b01d5806c1e6",
                                                        "_id": "6077c4efbc5f4d4df9ef1f1d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deaa",
                                                                "_id": "6077c4efbc5f4d4df9ef1f1e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transverse and longitudinal waves, Equation of waves",
                                                        "id": "5ace20419fe7b01d5806c1e7",
                                                        "_id": "6077c4efbc5f4d4df9ef1f1b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deab",
                                                                "_id": "6077c4efbc5f4d4df9ef1f1c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Velcoity & Acceleration of particles of medium during wave propagation",
                                                        "id": "5ace20419fe7b01d5806c1e8",
                                                        "_id": "6077c4efbc5f4d4df9ef1f19",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deac",
                                                                "_id": "6077c4efbc5f4d4df9ef1f1a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "velocity of longitudinal and transverse waves",
                                                        "id": "5ace20419fe7b01d5806c1e9",
                                                        "_id": "6077c4efbc5f4d4df9ef1f17",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dead",
                                                                "_id": "6077c4efbc5f4d4df9ef1f18"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd7f",
                                                        "_id": "6077c4efbc5f4d4df9ef1f25"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Electromagnetic Induction And Alternating Current",
                                                "id": "5f6991e8058075680d81d37f",
                                                "_id": "6077c4efbc5f4d4df9ef1f02",
                                                "concepts": [
                                                    {
                                                        "name": "Methods Of Producing Induced Emf",
                                                        "id": "5f69941cca5ac358f170d8ee",
                                                        "_id": "6077c4efbc5f4d4df9ef1f13",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deae",
                                                                "_id": "6077c4efbc5f4d4df9ef1f14"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Alternating Current",
                                                        "id": "5f69941cca5ac358f170d8f1",
                                                        "_id": "6077c4efbc5f4d4df9ef1f11",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deaf",
                                                                "_id": "6077c4efbc5f4d4df9ef1f12"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electromagnetic Induction",
                                                        "id": "5f69941cca5ac358f170d8eb",
                                                        "_id": "6077c4efbc5f4d4df9ef1f0f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb0",
                                                                "_id": "6077c4efbc5f4d4df9ef1f10"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Power In Ac Circuits",
                                                        "id": "5f69941cca5ac358f170d8f2",
                                                        "_id": "6077c4efbc5f4d4df9ef1f0d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb1",
                                                                "_id": "6077c4efbc5f4d4df9ef1f0e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Oscillation In Lc Circuits",
                                                        "id": "5f69941cca5ac358f170d8f3",
                                                        "_id": "6077c4efbc5f4d4df9ef1f0b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb2",
                                                                "_id": "6077c4efbc5f4d4df9ef1f0c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Analogies Between Lc Oscillations And Simple Harmonic Oscillations",
                                                        "id": "5f69941cca5ac358f170d8ec",
                                                        "_id": "6077c4efbc5f4d4df9ef1f09",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb3",
                                                                "_id": "6077c4efbc5f4d4df9ef1f0a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Self–Induction",
                                                        "id": "5f69941cca5ac358f170d8ed",
                                                        "_id": "6077c4efbc5f4d4df9ef1f07",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb4",
                                                                "_id": "6077c4efbc5f4d4df9ef1f08"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ac Generator",
                                                        "id": "5f69941cca5ac358f170d8ef",
                                                        "_id": "6077c4efbc5f4d4df9ef1f05",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb5",
                                                                "_id": "6077c4efbc5f4d4df9ef1f06"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Transformer",
                                                        "id": "5f69941cca5ac358f170d8f0",
                                                        "_id": "6077c4efbc5f4d4df9ef1f03",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb6",
                                                                "_id": "6077c4efbc5f4d4df9ef1f04"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd80",
                                                        "_id": "6077c4efbc5f4d4df9ef1f15"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef1f46"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Embedded figures, Completion of incomplete pattern",
                                                "id": "5ace20309fe7b01d5806bc29",
                                                "_id": "6077c4efbc5f4d4df9ef1efd",
                                                "concepts": [
                                                    {
                                                        "name": "Embedded figures, Completion of incomplete pattern",
                                                        "id": "5ace20389fe7b01d5806bf19",
                                                        "_id": "6077c4efbc5f4d4df9ef1efe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8440",
                                                                "_id": "6077c4efbc5f4d4df9ef1eff"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825a",
                                                        "_id": "6077c4efbc5f4d4df9ef1f00"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Images",
                                                "id": "5ace20319fe7b01d5806bc2d",
                                                "_id": "6077c4efbc5f4d4df9ef1ef9",
                                                "concepts": [
                                                    {
                                                        "name": "Images",
                                                        "id": "5ace20389fe7b01d5806bf1d",
                                                        "_id": "6077c4efbc5f4d4df9ef1efa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8441",
                                                                "_id": "6077c4efbc5f4d4df9ef1efb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825b",
                                                        "_id": "6077c4efbc5f4d4df9ef1efc"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef1f01"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Power Sharing",
                                                "id": "5ace20329fe7b01d5806bcec",
                                                "_id": "6077c4efbc5f4d4df9ef1ef4",
                                                "concepts": [
                                                    {
                                                        "name": "Needs of power sharing and its different forms",
                                                        "id": "5ace20429fe7b01d5806c23b",
                                                        "_id": "6077c4efbc5f4d4df9ef1ef5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8492",
                                                                "_id": "6077c4efbc5f4d4df9ef1ef6"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828b",
                                                        "_id": "6077c4efbc5f4d4df9ef1ef7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Federalism",
                                                "id": "5ace20329fe7b01d5806bce7",
                                                "_id": "6077c4efbc5f4d4df9ef1eee",
                                                "concepts": [
                                                    {
                                                        "name": "Division of power between centre & state",
                                                        "id": "5ace20429fe7b01d5806c232",
                                                        "_id": "6077c4efbc5f4d4df9ef1ef1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8493",
                                                                "_id": "6077c4efbc5f4d4df9ef1ef2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Featrus of federalism",
                                                        "id": "5ace20429fe7b01d5806c233",
                                                        "_id": "6077c4efbc5f4d4df9ef1eef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8494",
                                                                "_id": "6077c4efbc5f4d4df9ef1ef0"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828c",
                                                        "_id": "6077c4efbc5f4d4df9ef1ef3"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Democracy and Diversity",
                                                "id": "5ace20329fe7b01d5806bce3",
                                                "_id": "6077c4efbc5f4d4df9ef1ee8",
                                                "concepts": [
                                                    {
                                                        "name": "Features of democracy.",
                                                        "id": "5ace20429fe7b01d5806c22d",
                                                        "_id": "6077c4efbc5f4d4df9ef1eeb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8495",
                                                                "_id": "6077c4efbc5f4d4df9ef1eec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The way democracy accomodates differences",
                                                        "id": "5ace20429fe7b01d5806c22e",
                                                        "_id": "6077c4efbc5f4d4df9ef1ee9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8496",
                                                                "_id": "6077c4efbc5f4d4df9ef1eea"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828d",
                                                        "_id": "6077c4efbc5f4d4df9ef1eed"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef1ef8"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Rule Direction",
                                                "id": "5ace20309fe7b01d5806bc1b",
                                                "_id": "6077c4efbc5f4d4df9ef1ee3",
                                                "concepts": [
                                                    {
                                                        "name": "Figure Series",
                                                        "id": "5ace20389fe7b01d5806bf06",
                                                        "_id": "6077c4efbc5f4d4df9ef1ee4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4b",
                                                                "_id": "6077c4efbc5f4d4df9ef1ee5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df3c",
                                                        "_id": "6077c4efbc5f4d4df9ef1ee6"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef1ee7"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 10,
                                "startDate": "2021-07-01T00:00:00.000Z",
                                "endDate": "2021-07-07T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef1dbe",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Management of natural resources",
                                                "id": "5ace202f9fe7b01d5806bbc1",
                                                "_id": "6077c4efbc5f4d4df9ef1ed5",
                                                "concepts": [
                                                    {
                                                        "name": "Types of resources",
                                                        "id": "5ace20339fe7b01d5806bd4a",
                                                        "_id": "6077c4efbc5f4d4df9ef1ede",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830e",
                                                                "_id": "6077c4efbc5f4d4df9ef1edf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Narmada Bachao Andolan, Ganga Action Plan, Water harvesting system",
                                                        "id": "5ace20339fe7b01d5806bd49",
                                                        "_id": "6077c4efbc5f4d4df9ef1edc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c830f",
                                                                "_id": "6077c4efbc5f4d4df9ef1edd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Chipko movement, Stake holders of forest, Problems through dam constructions",
                                                        "id": "5ace20339fe7b01d5806bd46",
                                                        "_id": "6077c4efbc5f4d4df9ef1eda",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8310",
                                                                "_id": "6077c4efbc5f4d4df9ef1edb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fossil Fuels",
                                                        "id": "5ace20339fe7b01d5806bd48",
                                                        "_id": "6077c4efbc5f4d4df9ef1ed8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8311",
                                                                "_id": "6077c4efbc5f4d4df9ef1ed9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conservation Methods",
                                                        "id": "5ace20339fe7b01d5806bd47",
                                                        "_id": "6077c4efbc5f4d4df9ef1ed6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8312",
                                                                "_id": "6077c4efbc5f4d4df9ef1ed7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8210",
                                                        "_id": "6077c4efbc5f4d4df9ef1ee0"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef1ee1"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef1ed4"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Mensuration",
                                                "id": "5f64aec082532750fe359c22",
                                                "_id": "6077c4efbc5f4d4df9ef1ec7",
                                                "concepts": [
                                                    {
                                                        "name": "Surface Area Of Cuboid And Cube",
                                                        "id": "5f65877582532750fe35d00c",
                                                        "_id": "6077c4efbc5f4d4df9ef1ed0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc70",
                                                                "_id": "6077c4efbc5f4d4df9ef1ed1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f65877582532750fe35d009",
                                                        "_id": "6077c4efbc5f4d4df9ef1ece",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc71",
                                                                "_id": "6077c4efbc5f4d4df9ef1ecf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume Of Cuboid And Cube",
                                                        "id": "5f65877582532750fe35d00d",
                                                        "_id": "6077c4efbc5f4d4df9ef1ecc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc72",
                                                                "_id": "6077c4efbc5f4d4df9ef1ecd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Heron’s Formula",
                                                        "id": "5f65877582532750fe35d00a",
                                                        "_id": "6077c4efbc5f4d4df9ef1eca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc73",
                                                                "_id": "6077c4efbc5f4d4df9ef1ecb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application Of Heron’s Formula In Finding Areas Of Quadrilaterals",
                                                        "id": "5f65877582532750fe35d00b",
                                                        "_id": "6077c4efbc5f4d4df9ef1ec8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc74",
                                                                "_id": "6077c4efbc5f4d4df9ef1ec9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c2",
                                                        "_id": "6077c4efbc5f4d4df9ef1ed2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Two Dimensional Analytical Geometry-Ii",
                                                "id": "5f6831c6f100a06808b0d4ef",
                                                "_id": "6077c4efbc5f4d4df9ef1eb7",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f68335c058075680d813619",
                                                        "_id": "6077c4efbc5f4d4df9ef1ec4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc7d",
                                                                "_id": "6077c4efbc5f4d4df9ef1ec5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Tangents And Normals To Conics",
                                                        "id": "5f68335c058075680d81361e",
                                                        "_id": "6077c4efbc5f4d4df9ef1ec2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc7e",
                                                                "_id": "6077c4efbc5f4d4df9ef1ec3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Circle",
                                                        "id": "5f68335c058075680d81361a",
                                                        "_id": "6077c4efbc5f4d4df9ef1ec0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc7f",
                                                                "_id": "6077c4efbc5f4d4df9ef1ec1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conic Sections",
                                                        "id": "5f68335c058075680d81361c",
                                                        "_id": "6077c4efbc5f4d4df9ef1ebe",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc80",
                                                                "_id": "6077c4efbc5f4d4df9ef1ebf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Real Life Applications Of Conics",
                                                        "id": "5f68335c058075680d81361f",
                                                        "_id": "6077c4efbc5f4d4df9ef1ebc",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc81",
                                                                "_id": "6077c4efbc5f4d4df9ef1ebd"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conics",
                                                        "id": "5f68335c058075680d81361b",
                                                        "_id": "6077c4efbc5f4d4df9ef1eba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc82",
                                                                "_id": "6077c4efbc5f4d4df9ef1ebb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Parametric Form Of Conics",
                                                        "id": "5f68335c058075680d81361d",
                                                        "_id": "6077c4efbc5f4d4df9ef1eb8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc83",
                                                                "_id": "6077c4efbc5f4d4df9ef1eb9"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c4",
                                                        "_id": "6077c4efbc5f4d4df9ef1ec6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ordinary Differential Equations",
                                                "id": "5f6831c6f100a06808b0d4f4",
                                                "_id": "6077c4efbc5f4d4df9ef1ea5",
                                                "concepts": [
                                                    {
                                                        "name": "Solution Of First Order And First Degree Differential Equations",
                                                        "id": "5f6834dc058075680d81371c",
                                                        "_id": "6077c4efbc5f4d4df9ef1eb4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc84",
                                                                "_id": "6077c4efbc5f4d4df9ef1eb5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6834dc058075680d813717",
                                                        "_id": "6077c4efbc5f4d4df9ef1eb2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc85",
                                                                "_id": "6077c4efbc5f4d4df9ef1eb3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differential Equation, Order, And Degree",
                                                        "id": "5f6834dc058075680d813718",
                                                        "_id": "6077c4efbc5f4d4df9ef1eb0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc86",
                                                                "_id": "6077c4efbc5f4d4df9ef1eb1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Formation Of Differential Equations",
                                                        "id": "5f6834dc058075680d81371a",
                                                        "_id": "6077c4efbc5f4d4df9ef1eae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc87",
                                                                "_id": "6077c4efbc5f4d4df9ef1eaf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution Of Ordinary Differential Equations",
                                                        "id": "5f6834dc058075680d81371b",
                                                        "_id": "6077c4efbc5f4d4df9ef1eac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc88",
                                                                "_id": "6077c4efbc5f4d4df9ef1ead"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of First Order Ordinary Differential Equations",
                                                        "id": "5f6834dc058075680d81371e",
                                                        "_id": "6077c4efbc5f4d4df9ef1eaa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc89",
                                                                "_id": "6077c4efbc5f4d4df9ef1eab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "First Order Linear Differential Equations",
                                                        "id": "5f6834dc058075680d81371d",
                                                        "_id": "6077c4efbc5f4d4df9ef1ea8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8a",
                                                                "_id": "6077c4efbc5f4d4df9ef1ea9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classification Of Differential Equations",
                                                        "id": "5f6834dc058075680d813719",
                                                        "_id": "6077c4efbc5f4d4df9ef1ea6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8b",
                                                                "_id": "6077c4efbc5f4d4df9ef1ea7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c5",
                                                        "_id": "6077c4efbc5f4d4df9ef1eb6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Complex Numbers",
                                                "id": "5f6831c6f100a06808b0d4ec",
                                                "_id": "6077c4efbc5f4d4df9ef1e93",
                                                "concepts": [
                                                    {
                                                        "name": "Geometry And Locus Of Complex Numbers",
                                                        "id": "5f683275ca5ac358f17027f1",
                                                        "_id": "6077c4efbc5f4d4df9ef1ea2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8c",
                                                                "_id": "6077c4efbc5f4d4df9ef1ea3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conjugate Of A Complex Number",
                                                        "id": "5f683275ca5ac358f17027ef",
                                                        "_id": "6077c4efbc5f4d4df9ef1ea0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8d",
                                                                "_id": "6077c4efbc5f4d4df9ef1ea1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic Algebraic Properties Of Complex Numbers",
                                                        "id": "5f683275ca5ac358f17027ee",
                                                        "_id": "6077c4efbc5f4d4df9ef1e9e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8e",
                                                                "_id": "6077c4efbc5f4d4df9ef1e9f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Complex Numbers",
                                                        "id": "5f683275ca5ac358f17027ed",
                                                        "_id": "6077c4efbc5f4d4df9ef1e9c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc8f",
                                                                "_id": "6077c4efbc5f4d4df9ef1e9d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction To Complex Numbers",
                                                        "id": "5f683275ca5ac358f17027ec",
                                                        "_id": "6077c4efbc5f4d4df9ef1e9a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc90",
                                                                "_id": "6077c4efbc5f4d4df9ef1e9b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De Moivre’S Theorem And Its Applications",
                                                        "id": "5f683275ca5ac358f17027f3",
                                                        "_id": "6077c4efbc5f4d4df9ef1e98",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc91",
                                                                "_id": "6077c4efbc5f4d4df9ef1e99"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modulus Of A Complex Number",
                                                        "id": "5f683275ca5ac358f17027f0",
                                                        "_id": "6077c4efbc5f4d4df9ef1e96",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc92",
                                                                "_id": "6077c4efbc5f4d4df9ef1e97"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polar And Euler Form Of A Complex Number",
                                                        "id": "5f683275ca5ac358f17027f2",
                                                        "_id": "6077c4efbc5f4d4df9ef1e94",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc93",
                                                                "_id": "6077c4efbc5f4d4df9ef1e95"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c6",
                                                        "_id": "6077c4efbc5f4d4df9ef1ea4"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Applications Of Differential Calculus",
                                                "id": "5f6831c6f100a06808b0d4f1",
                                                "_id": "6077c4efbc5f4d4df9ef1e7d",
                                                "concepts": [
                                                    {
                                                        "name": "Indeterminate Forms",
                                                        "id": "5f683405ca5ac358f17028c0",
                                                        "_id": "6077c4efbc5f4d4df9ef1e90",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc94",
                                                                "_id": "6077c4efbc5f4d4df9ef1e91"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of Second Derivative",
                                                        "id": "5f683405ca5ac358f17028c2",
                                                        "_id": "6077c4efbc5f4d4df9ef1e8e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc95",
                                                                "_id": "6077c4efbc5f4d4df9ef1e8f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of First Derivative",
                                                        "id": "5f683405ca5ac358f17028c1",
                                                        "_id": "6077c4efbc5f4d4df9ef1e8c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc96",
                                                                "_id": "6077c4efbc5f4d4df9ef1e8d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sketching Of Curves",
                                                        "id": "5f683405ca5ac358f17028c5",
                                                        "_id": "6077c4efbc5f4d4df9ef1e8a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc97",
                                                                "_id": "6077c4efbc5f4d4df9ef1e8b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f683405ca5ac358f17028bc",
                                                        "_id": "6077c4efbc5f4d4df9ef1e88",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc98",
                                                                "_id": "6077c4efbc5f4d4df9ef1e89"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Meaning Of Derivatives",
                                                        "id": "5f683405ca5ac358f17028bd",
                                                        "_id": "6077c4efbc5f4d4df9ef1e86",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc99",
                                                                "_id": "6077c4efbc5f4d4df9ef1e87"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean Value Theorem",
                                                        "id": "5f683405ca5ac358f17028be",
                                                        "_id": "6077c4efbc5f4d4df9ef1e84",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9a",
                                                                "_id": "6077c4efbc5f4d4df9ef1e85"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Symmetry And Asymptotes",
                                                        "id": "5f683405ca5ac358f17028c4",
                                                        "_id": "6077c4efbc5f4d4df9ef1e82",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9b",
                                                                "_id": "6077c4efbc5f4d4df9ef1e83"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Series Expansions",
                                                        "id": "5f683405ca5ac358f17028bf",
                                                        "_id": "6077c4efbc5f4d4df9ef1e80",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9c",
                                                                "_id": "6077c4efbc5f4d4df9ef1e81"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications In Optimization",
                                                        "id": "5f683405ca5ac358f17028c3",
                                                        "_id": "6077c4efbc5f4d4df9ef1e7e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9d",
                                                                "_id": "6077c4efbc5f4d4df9ef1e7f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c7",
                                                        "_id": "6077c4efbc5f4d4df9ef1e92"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Discrete Mathematics",
                                                "id": "5f6831c6f100a06808b0d4f6",
                                                "_id": "6077c4efbc5f4d4df9ef1e75",
                                                "concepts": [
                                                    {
                                                        "name": "Binary Operations",
                                                        "id": "5f68352571814158f68cc7e1",
                                                        "_id": "6077c4efbc5f4d4df9ef1e7a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9e",
                                                                "_id": "6077c4efbc5f4d4df9ef1e7b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f68352571814158f68cc7e0",
                                                        "_id": "6077c4efbc5f4d4df9ef1e78",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dc9f",
                                                                "_id": "6077c4efbc5f4d4df9ef1e79"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mathematical Logic",
                                                        "id": "5f68352571814158f68cc7e2",
                                                        "_id": "6077c4efbc5f4d4df9ef1e76",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca0",
                                                                "_id": "6077c4efbc5f4d4df9ef1e77"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c8",
                                                        "_id": "6077c4efbc5f4d4df9ef1e7c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Applications Of Vector Algebra",
                                                "id": "5f6831c6f100a06808b0d4f0",
                                                "_id": "6077c4efbc5f4d4df9ef1e5f",
                                                "concepts": [
                                                    {
                                                        "name": "Jacobi’S Identity And Lagrange’S Identity",
                                                        "id": "5f6833c2058075680d81364f",
                                                        "_id": "6077c4efbc5f4d4df9ef1e72",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca1",
                                                                "_id": "6077c4efbc5f4d4df9ef1e73"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Meeting Point Of A Line And A Plane",
                                                        "id": "5f6833c2058075680d813653",
                                                        "_id": "6077c4efbc5f4d4df9ef1e70",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca2",
                                                                "_id": "6077c4efbc5f4d4df9ef1e71"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Scalar Product And Vector Product",
                                                        "id": "5f6833c2058075680d81364c",
                                                        "_id": "6077c4efbc5f4d4df9ef1e6e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca3",
                                                                "_id": "6077c4efbc5f4d4df9ef1e6f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Geometric Introduction To Vectors",
                                                        "id": "5f6833c2058075680d81364b",
                                                        "_id": "6077c4efbc5f4d4df9ef1e6c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca4",
                                                                "_id": "6077c4efbc5f4d4df9ef1e6d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Image Of A Point In A Plane",
                                                        "id": "5f6833c2058075680d813652",
                                                        "_id": "6077c4efbc5f4d4df9ef1e6a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca5",
                                                                "_id": "6077c4efbc5f4d4df9ef1e6b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Scalar Triple Product",
                                                        "id": "5f6833c2058075680d81364d",
                                                        "_id": "6077c4efbc5f4d4df9ef1e68",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca6",
                                                                "_id": "6077c4efbc5f4d4df9ef1e69"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different Forms Of Equation Of A Plane",
                                                        "id": "5f6833c2058075680d813651",
                                                        "_id": "6077c4efbc5f4d4df9ef1e66",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca7",
                                                                "_id": "6077c4efbc5f4d4df9ef1e67"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vector Triple Product",
                                                        "id": "5f6833c2058075680d81364e",
                                                        "_id": "6077c4efbc5f4d4df9ef1e64",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca8",
                                                                "_id": "6077c4efbc5f4d4df9ef1e65"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6833c2058075680d81364a",
                                                        "_id": "6077c4efbc5f4d4df9ef1e62",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dca9",
                                                                "_id": "6077c4efbc5f4d4df9ef1e63"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Different Forms Of Equation Of A Straight Line",
                                                        "id": "5f6833c2058075680d813650",
                                                        "_id": "6077c4efbc5f4d4df9ef1e60",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcaa",
                                                                "_id": "6077c4efbc5f4d4df9ef1e61"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9c9",
                                                        "_id": "6077c4efbc5f4d4df9ef1e74"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Applications Of Matrices And Determinants",
                                                "id": "5f6831c6f100a06808b0d4eb",
                                                "_id": "6077c4efbc5f4d4df9ef1e53",
                                                "concepts": [
                                                    {
                                                        "name": "Inverse Of A Non-Singular Square Matrix",
                                                        "id": "5f683235f100a06808b0d503",
                                                        "_id": "6077c4efbc5f4d4df9ef1e5c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcab",
                                                                "_id": "6077c4efbc5f4d4df9ef1e5d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Elementary Transformations Of A Matrix",
                                                        "id": "5f683235f100a06808b0d504",
                                                        "_id": "6077c4efbc5f4d4df9ef1e5a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcac",
                                                                "_id": "6077c4efbc5f4d4df9ef1e5b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of Matrices: Consistency Of System Of Linear Equations By Rank Method",
                                                        "id": "5f683235f100a06808b0d506",
                                                        "_id": "6077c4efbc5f4d4df9ef1e58",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcad",
                                                                "_id": "6077c4efbc5f4d4df9ef1e59"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f683235f100a06808b0d502",
                                                        "_id": "6077c4efbc5f4d4df9ef1e56",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcae",
                                                                "_id": "6077c4efbc5f4d4df9ef1e57"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of Matrices: Solving System Of Linear Equations",
                                                        "id": "5f683235f100a06808b0d505",
                                                        "_id": "6077c4efbc5f4d4df9ef1e54",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcaf",
                                                                "_id": "6077c4efbc5f4d4df9ef1e55"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ca",
                                                        "_id": "6077c4efbc5f4d4df9ef1e5e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability Distributions",
                                                "id": "5f6831c6f100a06808b0d4f5",
                                                "_id": "6077c4efbc5f4d4df9ef1e45",
                                                "concepts": [
                                                    {
                                                        "name": "Continuous Distributions",
                                                        "id": "5f683505058075680d813749",
                                                        "_id": "6077c4efbc5f4d4df9ef1e50",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb0",
                                                                "_id": "6077c4efbc5f4d4df9ef1e51"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mathematical Expectation",
                                                        "id": "5f683505058075680d81374a",
                                                        "_id": "6077c4efbc5f4d4df9ef1e4e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb1",
                                                                "_id": "6077c4efbc5f4d4df9ef1e4f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Random Variable",
                                                        "id": "5f683505058075680d813748",
                                                        "_id": "6077c4efbc5f4d4df9ef1e4c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb2",
                                                                "_id": "6077c4efbc5f4d4df9ef1e4d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f683505058075680d813746",
                                                        "_id": "6077c4efbc5f4d4df9ef1e4a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb3",
                                                                "_id": "6077c4efbc5f4d4df9ef1e4b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Random Variable",
                                                        "id": "5f683505058075680d813747",
                                                        "_id": "6077c4efbc5f4d4df9ef1e48",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb4",
                                                                "_id": "6077c4efbc5f4d4df9ef1e49"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                        "id": "5f683505058075680d81374b",
                                                        "_id": "6077c4efbc5f4d4df9ef1e46",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb5",
                                                                "_id": "6077c4efbc5f4d4df9ef1e47"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9cb",
                                                        "_id": "6077c4efbc5f4d4df9ef1e52"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Inverse Trigonometric Functions",
                                                "id": "5f6831c6f100a06808b0d4ee",
                                                "_id": "6077c4efbc5f4d4df9ef1e2f",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f68332aca5ac358f170285a",
                                                        "_id": "6077c4efbc5f4d4df9ef1e42",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb6",
                                                                "_id": "6077c4efbc5f4d4df9ef1e43"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties Of Inverse Trigonometric Functions",
                                                        "id": "5f68332aca5ac358f1702863",
                                                        "_id": "6077c4efbc5f4d4df9ef1e40",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb7",
                                                                "_id": "6077c4efbc5f4d4df9ef1e41"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sine Function And Inverse Sine Function",
                                                        "id": "5f68332aca5ac358f170285c",
                                                        "_id": "6077c4efbc5f4d4df9ef1e3e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb8",
                                                                "_id": "6077c4efbc5f4d4df9ef1e3f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Tangent Function And The Inverse Tangent Function",
                                                        "id": "5f68332aca5ac358f170285e",
                                                        "_id": "6077c4efbc5f4d4df9ef1e3c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcb9",
                                                                "_id": "6077c4efbc5f4d4df9ef1e3d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Cosecant Function And The Inverse Cosecant Function",
                                                        "id": "5f68332aca5ac358f170285f",
                                                        "_id": "6077c4efbc5f4d4df9ef1e3a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcba",
                                                                "_id": "6077c4efbc5f4d4df9ef1e3b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Principal Value Of Inverse Trigonometric Functions",
                                                        "id": "5f68332aca5ac358f1702862",
                                                        "_id": "6077c4efbc5f4d4df9ef1e38",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcbb",
                                                                "_id": "6077c4efbc5f4d4df9ef1e39"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Cotangent Function And The Inverse Cotangent Function",
                                                        "id": "5f68332aca5ac358f1702861",
                                                        "_id": "6077c4efbc5f4d4df9ef1e36",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcbc",
                                                                "_id": "6077c4efbc5f4d4df9ef1e37"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Secant Function And Inverse Secant Function",
                                                        "id": "5f68332aca5ac358f1702860",
                                                        "_id": "6077c4efbc5f4d4df9ef1e34",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcbd",
                                                                "_id": "6077c4efbc5f4d4df9ef1e35"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Cosine Function And Inverse Cosine Function",
                                                        "id": "5f68332aca5ac358f170285d",
                                                        "_id": "6077c4efbc5f4d4df9ef1e32",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcbe",
                                                                "_id": "6077c4efbc5f4d4df9ef1e33"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Some Fundamental Concepts",
                                                        "id": "5f68332aca5ac358f170285b",
                                                        "_id": "6077c4efbc5f4d4df9ef1e30",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcbf",
                                                                "_id": "6077c4efbc5f4d4df9ef1e31"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9cc",
                                                        "_id": "6077c4efbc5f4d4df9ef1e44"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef1ed3"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Electromagnetic Waves",
                                                "id": "5f6991e8058075680d81d380",
                                                "_id": "6077c4efbc5f4d4df9ef1e26",
                                                "concepts": [
                                                    {
                                                        "name": "Types Of Spectrumemission And Absorption Spectrumfraunhofer Lines",
                                                        "id": "5f699431058075680d81d4bd",
                                                        "_id": "6077c4efbc5f4d4df9ef1e2b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb7",
                                                                "_id": "6077c4efbc5f4d4df9ef1e2c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electromagnetic Waves",
                                                        "id": "5f699431058075680d81d4bc",
                                                        "_id": "6077c4efbc5f4d4df9ef1e29",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb8",
                                                                "_id": "6077c4efbc5f4d4df9ef1e2a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f699431058075680d81d4bb",
                                                        "_id": "6077c4efbc5f4d4df9ef1e27",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deb9",
                                                                "_id": "6077c4efbc5f4d4df9ef1e28"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd81",
                                                        "_id": "6077c4efbc5f4d4df9ef1e2d"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Communication Systems",
                                                "id": "5f6991e8058075680d81d385",
                                                "_id": "6077c4efbc5f4d4df9ef1e0c",
                                                "concepts": [
                                                    {
                                                        "name": "Modulation",
                                                        "id": "5f699522058075680d81d51a",
                                                        "_id": "6077c4efbc5f4d4df9ef1e23",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deba",
                                                                "_id": "6077c4efbc5f4d4df9ef1e24"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Satellite Communication",
                                                        "id": "5f699522058075680d81d51e",
                                                        "_id": "6077c4efbc5f4d4df9ef1e21",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673debb",
                                                                "_id": "6077c4efbc5f4d4df9ef1e22"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Propagation Of Electromagnetic Waves",
                                                        "id": "5f699522058075680d81d51d",
                                                        "_id": "6077c4efbc5f4d4df9ef1e1f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673debc",
                                                                "_id": "6077c4efbc5f4d4df9ef1e20"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Radar And Applications",
                                                        "id": "5f699522058075680d81d520",
                                                        "_id": "6077c4efbc5f4d4df9ef1e1d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673debd",
                                                                "_id": "6077c4efbc5f4d4df9ef1e1e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Elements Of An Electronic Communication System",
                                                        "id": "5f699522058075680d81d51b",
                                                        "_id": "6077c4efbc5f4d4df9ef1e1b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673debe",
                                                                "_id": "6077c4efbc5f4d4df9ef1e1c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Internet",
                                                        "id": "5f699522058075680d81d522",
                                                        "_id": "6077c4efbc5f4d4df9ef1e19",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673debf",
                                                                "_id": "6077c4efbc5f4d4df9ef1e1a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f699522058075680d81d519",
                                                        "_id": "6077c4efbc5f4d4df9ef1e17",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec0",
                                                                "_id": "6077c4efbc5f4d4df9ef1e18"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Antenna Size",
                                                        "id": "5f699522058075680d81d51c",
                                                        "_id": "6077c4efbc5f4d4df9ef1e15",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec1",
                                                                "_id": "6077c4efbc5f4d4df9ef1e16"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Global Positioning System",
                                                        "id": "5f699522058075680d81d523",
                                                        "_id": "6077c4efbc5f4d4df9ef1e13",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec2",
                                                                "_id": "6077c4efbc5f4d4df9ef1e14"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fibre Optic Communication",
                                                        "id": "5f699522058075680d81d51f",
                                                        "_id": "6077c4efbc5f4d4df9ef1e11",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec3",
                                                                "_id": "6077c4efbc5f4d4df9ef1e12"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mobile Communication",
                                                        "id": "5f699522058075680d81d521",
                                                        "_id": "6077c4efbc5f4d4df9ef1e0f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec4",
                                                                "_id": "6077c4efbc5f4d4df9ef1e10"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                        "id": "5f699522058075680d81d524",
                                                        "_id": "6077c4efbc5f4d4df9ef1e0d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec5",
                                                                "_id": "6077c4efbc5f4d4df9ef1e0e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd82",
                                                        "_id": "6077c4efbc5f4d4df9ef1e25"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Recent Developments In Physics",
                                                "id": "5f6991e8058075680d81d386",
                                                "_id": "6077c4efbc5f4d4df9ef1e04",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f699536f100a06808b181df",
                                                        "_id": "6077c4efbc5f4d4df9ef1e09",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec6",
                                                                "_id": "6077c4efbc5f4d4df9ef1e0a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nanoscience And Nanotechnology",
                                                        "id": "5f699536f100a06808b181e0",
                                                        "_id": "6077c4efbc5f4d4df9ef1e07",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec7",
                                                                "_id": "6077c4efbc5f4d4df9ef1e08"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Robotics",
                                                        "id": "5f699536f100a06808b181e1",
                                                        "_id": "6077c4efbc5f4d4df9ef1e05",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec8",
                                                                "_id": "6077c4efbc5f4d4df9ef1e06"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd83",
                                                        "_id": "6077c4efbc5f4d4df9ef1e0b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Optics",
                                                "id": "5f6991e8058075680d81d381",
                                                "_id": "6077c4efbc5f4d4df9ef1de8",
                                                "concepts": [
                                                    {
                                                        "name": "Refraction",
                                                        "id": "5f699472ca5ac358f170d92d",
                                                        "_id": "6077c4efbc5f4d4df9ef1e01",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dec9",
                                                                "_id": "6077c4efbc5f4d4df9ef1e02"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Thin Lens",
                                                        "id": "5f699472ca5ac358f170d92f",
                                                        "_id": "6077c4efbc5f4d4df9ef1dff",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deca",
                                                                "_id": "6077c4efbc5f4d4df9ef1e00"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Refraction At Single Spherical Surface",
                                                        "id": "5f699472ca5ac358f170d92e",
                                                        "_id": "6077c4efbc5f4d4df9ef1dfd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673decb",
                                                                "_id": "6077c4efbc5f4d4df9ef1dfe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diffraction",
                                                        "id": "5f699472ca5ac358f170d934",
                                                        "_id": "6077c4efbc5f4d4df9ef1dfb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673decc",
                                                                "_id": "6077c4efbc5f4d4df9ef1dfc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Wave Nature Of Light",
                                                        "id": "5f699472ca5ac358f170d932",
                                                        "_id": "6077c4efbc5f4d4df9ef1df9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673decd",
                                                                "_id": "6077c4efbc5f4d4df9ef1dfa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Interference",
                                                        "id": "5f699472ca5ac358f170d933",
                                                        "_id": "6077c4efbc5f4d4df9ef1df7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dece",
                                                                "_id": "6077c4efbc5f4d4df9ef1df8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories On Light",
                                                        "id": "5f699472ca5ac358f170d931",
                                                        "_id": "6077c4efbc5f4d4df9ef1df5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673decf",
                                                                "_id": "6077c4efbc5f4d4df9ef1df6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Spherical Mirrors",
                                                        "id": "5f699472ca5ac358f170d92b",
                                                        "_id": "6077c4efbc5f4d4df9ef1df3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded0",
                                                                "_id": "6077c4efbc5f4d4df9ef1df4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple Microscope",
                                                        "id": "5f699472ca5ac358f170d936",
                                                        "_id": "6077c4efbc5f4d4df9ef1df1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded1",
                                                                "_id": "6077c4efbc5f4d4df9ef1df2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Prism",
                                                        "id": "5f699472ca5ac358f170d930",
                                                        "_id": "6077c4efbc5f4d4df9ef1def",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded2",
                                                                "_id": "6077c4efbc5f4d4df9ef1df0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f699472ca5ac358f170d92a",
                                                        "_id": "6077c4efbc5f4d4df9ef1ded",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded3",
                                                                "_id": "6077c4efbc5f4d4df9ef1dee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Speed Of Light",
                                                        "id": "5f699472ca5ac358f170d92c",
                                                        "_id": "6077c4efbc5f4d4df9ef1deb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded4",
                                                                "_id": "6077c4efbc5f4d4df9ef1dec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polarisation",
                                                        "id": "5f699472ca5ac358f170d935",
                                                        "_id": "6077c4efbc5f4d4df9ef1de9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded5",
                                                                "_id": "6077c4efbc5f4d4df9ef1dea"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd84",
                                                        "_id": "6077c4efbc5f4d4df9ef1e03"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef1e2e"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Paper cutting folding & unfolding, Dot situation",
                                                "id": "5ace20319fe7b01d5806bc34",
                                                "_id": "6077c4efbc5f4d4df9ef1de3",
                                                "concepts": [
                                                    {
                                                        "name": "Paper cutting folding & unfolding, Dot situation",
                                                        "id": "5ace20399fe7b01d5806bf26",
                                                        "_id": "6077c4efbc5f4d4df9ef1de4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8442",
                                                                "_id": "6077c4efbc5f4d4df9ef1de5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825c",
                                                        "_id": "6077c4efbc5f4d4df9ef1de6"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Time & Work",
                                                "id": "5ace20319fe7b01d5806bc41",
                                                "_id": "6077c4efbc5f4d4df9ef1ddd",
                                                "concepts": [
                                                    {
                                                        "name": "Chain Rule, Pipes & cisterns",
                                                        "id": "5ace20399fe7b01d5806bf3e",
                                                        "_id": "6077c4efbc5f4d4df9ef1de0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8443",
                                                                "_id": "6077c4efbc5f4d4df9ef1de1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Time & Work problems",
                                                        "id": "5ace20399fe7b01d5806bf3f",
                                                        "_id": "6077c4efbc5f4d4df9ef1dde",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8444",
                                                                "_id": "6077c4efbc5f4d4df9ef1ddf"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825d",
                                                        "_id": "6077c4efbc5f4d4df9ef1de2"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef1de7"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Gender, Religion and Caste",
                                                "id": "5ace20329fe7b01d5806bce8",
                                                "_id": "6077c4efbc5f4d4df9ef1dd6",
                                                "concepts": [
                                                    {
                                                        "name": "Diversity of gender & castecism in India",
                                                        "id": "5ace20429fe7b01d5806c234",
                                                        "_id": "6077c4efbc5f4d4df9ef1dd9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8497",
                                                                "_id": "6077c4efbc5f4d4df9ef1dda"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "India, a secular country",
                                                        "id": "5ace20429fe7b01d5806c235",
                                                        "_id": "6077c4efbc5f4d4df9ef1dd7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8498",
                                                                "_id": "6077c4efbc5f4d4df9ef1dd8"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828e",
                                                        "_id": "6077c4efbc5f4d4df9ef1ddb"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Popular Struggles and Movements",
                                                "id": "5ace20329fe7b01d5806bceb",
                                                "_id": "6077c4efbc5f4d4df9ef1dd0",
                                                "concepts": [
                                                    {
                                                        "name": "Successful struggle and mass participation.",
                                                        "id": "5ace20429fe7b01d5806c23a",
                                                        "_id": "6077c4efbc5f4d4df9ef1dd3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8499",
                                                                "_id": "6077c4efbc5f4d4df9ef1dd4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Role of pressure groups.",
                                                        "id": "5ace20429fe7b01d5806c239",
                                                        "_id": "6077c4efbc5f4d4df9ef1dd1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849a",
                                                                "_id": "6077c4efbc5f4d4df9ef1dd2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c828f",
                                                        "_id": "6077c4efbc5f4d4df9ef1dd5"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Political Parties",
                                                "id": "5ace20329fe7b01d5806bcea",
                                                "_id": "6077c4efbc5f4d4df9ef1dca",
                                                "concepts": [
                                                    {
                                                        "name": "Political parties and their needs",
                                                        "id": "5ace20429fe7b01d5806c238",
                                                        "_id": "6077c4efbc5f4d4df9ef1dcd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849b",
                                                                "_id": "6077c4efbc5f4d4df9ef1dce"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functions and challenges of the political parties",
                                                        "id": "5ace20429fe7b01d5806c237",
                                                        "_id": "6077c4efbc5f4d4df9ef1dcb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849c",
                                                                "_id": "6077c4efbc5f4d4df9ef1dcc"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8290",
                                                        "_id": "6077c4efbc5f4d4df9ef1dcf"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef1ddc"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [
                                            {
                                                "name": "Series Completion",
                                                "id": "5ace20309fe7b01d5806bc1c",
                                                "_id": "6077c4efbc5f4d4df9ef1dbf",
                                                "concepts": [
                                                    {
                                                        "name": "Alphabet Series",
                                                        "id": "5ace20389fe7b01d5806bf07",
                                                        "_id": "6077c4efbc5f4d4df9ef1dc6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4c",
                                                                "_id": "6077c4efbc5f4d4df9ef1dc7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Alphanumeric Series",
                                                        "id": "5ace20389fe7b01d5806bf08",
                                                        "_id": "6077c4efbc5f4d4df9ef1dc4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4d",
                                                                "_id": "6077c4efbc5f4d4df9ef1dc5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Continuous Pattern Series",
                                                        "id": "5ace20389fe7b01d5806bf09",
                                                        "_id": "6077c4efbc5f4d4df9ef1dc2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4e",
                                                                "_id": "6077c4efbc5f4d4df9ef1dc3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "NUMBER SERIES",
                                                        "id": "5ace20389fe7b01d5806bf0a",
                                                        "_id": "6077c4efbc5f4d4df9ef1dc0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df4f",
                                                                "_id": "6077c4efbc5f4d4df9ef1dc1"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5725b35a0a066673df3d",
                                                        "_id": "6077c4efbc5f4d4df9ef1dc8"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef1dc9"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 11,
                                "startDate": "2021-07-08T00:00:00.000Z",
                                "endDate": "2021-07-14T00:00:00.000Z",
                                "_id": "6077c4efbc5f4d4df9ef1cb4",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [
                                            {
                                                "name": "Environmental Problem",
                                                "id": "5ace202f9fe7b01d5806bbbd",
                                                "_id": "6077c4efbc5f4d4df9ef1dab",
                                                "concepts": [
                                                    {
                                                        "name": "Definition/Introduction, Food chain/Food web",
                                                        "id": "5ace20339fe7b01d5806bd1b",
                                                        "_id": "6077c4efbc5f4d4df9ef1dba",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8313",
                                                                "_id": "6077c4efbc5f4d4df9ef1dbb"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ecological Pyramids",
                                                        "id": "5ace20339fe7b01d5806bd1d",
                                                        "_id": "6077c4efbc5f4d4df9ef1db8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8314",
                                                                "_id": "6077c4efbc5f4d4df9ef1db9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Energy Flow",
                                                        "id": "5ace20339fe7b01d5806bd1e",
                                                        "_id": "6077c4efbc5f4d4df9ef1db6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8315",
                                                                "_id": "6077c4efbc5f4d4df9ef1db7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ecological Balance",
                                                        "id": "5ace20339fe7b01d5806bd1c",
                                                        "_id": "6077c4efbc5f4d4df9ef1db4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8316",
                                                                "_id": "6077c4efbc5f4d4df9ef1db5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Water Pollution",
                                                        "id": "5ace20339fe7b01d5806bd21",
                                                        "_id": "6077c4efbc5f4d4df9ef1db2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8317",
                                                                "_id": "6077c4efbc5f4d4df9ef1db3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Air Pollution",
                                                        "id": "5ace20339fe7b01d5806bd1a",
                                                        "_id": "6077c4efbc5f4d4df9ef1db0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8318",
                                                                "_id": "6077c4efbc5f4d4df9ef1db1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Land Pollution",
                                                        "id": "5ace20339fe7b01d5806bd1f",
                                                        "_id": "6077c4efbc5f4d4df9ef1dae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8319",
                                                                "_id": "6077c4efbc5f4d4df9ef1daf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Preventive Measures",
                                                        "id": "5ace20339fe7b01d5806bd20",
                                                        "_id": "6077c4efbc5f4d4df9ef1dac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c831a",
                                                                "_id": "6077c4efbc5f4d4df9ef1dad"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8211",
                                                        "_id": "6077c4efbc5f4d4df9ef1dbc"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef1dbd"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef1daa"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Applications Of Integration",
                                                "id": "5f6831c6f100a06808b0d4f3",
                                                "_id": "6077c4efbc5f4d4df9ef1d95",
                                                "concepts": [
                                                    {
                                                        "name": "Gamma Integral",
                                                        "id": "5f683497ca5ac358f170293f",
                                                        "_id": "6077c4efbc5f4d4df9ef1da6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc0",
                                                                "_id": "6077c4efbc5f4d4df9ef1da7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                        "id": "5f683497ca5ac358f170293b",
                                                        "_id": "6077c4efbc5f4d4df9ef1da4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc1",
                                                                "_id": "6077c4efbc5f4d4df9ef1da5"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f683497ca5ac358f1702939",
                                                        "_id": "6077c4efbc5f4d4df9ef1da2",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc2",
                                                                "_id": "6077c4efbc5f4d4df9ef1da3"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Evaluation Of Bounded Plane Area By Integration",
                                                        "id": "5f683497ca5ac358f1702940",
                                                        "_id": "6077c4efbc5f4d4df9ef1da0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc3",
                                                                "_id": "6077c4efbc5f4d4df9ef1da1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reduction Formulae",
                                                        "id": "5f683497ca5ac358f170293e",
                                                        "_id": "6077c4efbc5f4d4df9ef1d9e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc4",
                                                                "_id": "6077c4efbc5f4d4df9ef1d9f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                        "id": "5f683497ca5ac358f1702941",
                                                        "_id": "6077c4efbc5f4d4df9ef1d9c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc5",
                                                                "_id": "6077c4efbc5f4d4df9ef1d9d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Improper Integrals",
                                                        "id": "5f683497ca5ac358f170293d",
                                                        "_id": "6077c4efbc5f4d4df9ef1d9a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc6",
                                                                "_id": "6077c4efbc5f4d4df9ef1d9b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bernoulli’S Formula",
                                                        "id": "5f683497ca5ac358f170293c",
                                                        "_id": "6077c4efbc5f4d4df9ef1d98",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc7",
                                                                "_id": "6077c4efbc5f4d4df9ef1d99"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Definite Integral As The Limit Of A Sum",
                                                        "id": "5f683497ca5ac358f170293a",
                                                        "_id": "6077c4efbc5f4d4df9ef1d96",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc8",
                                                                "_id": "6077c4efbc5f4d4df9ef1d97"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9cd",
                                                        "_id": "6077c4efbc5f4d4df9ef1da8"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differentials And Partial Derivatives",
                                                "id": "5f6831c6f100a06808b0d4f2",
                                                "_id": "6077c4efbc5f4d4df9ef1d87",
                                                "concepts": [
                                                    {
                                                        "name": "Partial Derivatives",
                                                        "id": "5f68345471814158f68cc765",
                                                        "_id": "6077c4efbc5f4d4df9ef1d92",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcc9",
                                                                "_id": "6077c4efbc5f4d4df9ef1d93"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear Approximation And Differentials",
                                                        "id": "5f68345471814158f68cc762",
                                                        "_id": "6077c4efbc5f4d4df9ef1d90",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcca",
                                                                "_id": "6077c4efbc5f4d4df9ef1d91"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functions Of Several Variables",
                                                        "id": "5f68345471814158f68cc763",
                                                        "_id": "6077c4efbc5f4d4df9ef1d8e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dccb",
                                                                "_id": "6077c4efbc5f4d4df9ef1d8f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f68345471814158f68cc761",
                                                        "_id": "6077c4efbc5f4d4df9ef1d8c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dccc",
                                                                "_id": "6077c4efbc5f4d4df9ef1d8d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                        "id": "5f68345471814158f68cc764",
                                                        "_id": "6077c4efbc5f4d4df9ef1d8a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dccd",
                                                                "_id": "6077c4efbc5f4d4df9ef1d8b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear Approximation And Differential Of A",
                                                        "id": "5f68345471814158f68cc766",
                                                        "_id": "6077c4efbc5f4d4df9ef1d88",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcce",
                                                                "_id": "6077c4efbc5f4d4df9ef1d89"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9ce",
                                                        "_id": "6077c4efbc5f4d4df9ef1d94"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Theory Of Equations",
                                                "id": "5f6831c6f100a06808b0d4ed",
                                                "_id": "6077c4efbc5f4d4df9ef1d73",
                                                "concepts": [
                                                    {
                                                        "name": "Basics Of Polynomial Equations",
                                                        "id": "5f6832c3f100a06808b0d53b",
                                                        "_id": "6077c4efbc5f4d4df9ef1d84",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dccf",
                                                                "_id": "6077c4efbc5f4d4df9ef1d85"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Vieta’S Formulae And Formation Of Polynomial Equations",
                                                        "id": "5f6832c3f100a06808b0d53c",
                                                        "_id": "6077c4efbc5f4d4df9ef1d82",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd0",
                                                                "_id": "6077c4efbc5f4d4df9ef1d83"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Roots Of Higher Degree Polynomial Equations",
                                                        "id": "5f6832c3f100a06808b0d53f",
                                                        "_id": "6077c4efbc5f4d4df9ef1d80",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd1",
                                                                "_id": "6077c4efbc5f4d4df9ef1d81"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nature Of Roots And Nature Of Coefficients Of Polynomial Equations",
                                                        "id": "5f6832c3f100a06808b0d53d",
                                                        "_id": "6077c4efbc5f4d4df9ef1d7e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd2",
                                                                "_id": "6077c4efbc5f4d4df9ef1d7f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications To Geometrical Problems",
                                                        "id": "5f6832c3f100a06808b0d53e",
                                                        "_id": "6077c4efbc5f4d4df9ef1d7c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd3",
                                                                "_id": "6077c4efbc5f4d4df9ef1d7d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polynomial Equations With No Additional Information",
                                                        "id": "5f6832c3f100a06808b0d541",
                                                        "_id": "6077c4efbc5f4d4df9ef1d7a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd4",
                                                                "_id": "6077c4efbc5f4d4df9ef1d7b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Descartes Rule",
                                                        "id": "5f6832c3f100a06808b0d542",
                                                        "_id": "6077c4efbc5f4d4df9ef1d78",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd5",
                                                                "_id": "6077c4efbc5f4d4df9ef1d79"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polynomials With Additional Information",
                                                        "id": "5f6832c3f100a06808b0d540",
                                                        "_id": "6077c4efbc5f4d4df9ef1d76",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd6",
                                                                "_id": "6077c4efbc5f4d4df9ef1d77"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6832c3f100a06808b0d53a",
                                                        "_id": "6077c4efbc5f4d4df9ef1d74",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd7",
                                                                "_id": "6077c4efbc5f4d4df9ef1d75"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9cf",
                                                        "_id": "6077c4efbc5f4d4df9ef1d86"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differential Calculus - Differentiability And Methods Of Differentiation",
                                                "id": "5f68661f71814158f68ce591",
                                                "_id": "6077c4efbc5f4d4df9ef1d69",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159ff",
                                                        "_id": "6077c4efbc5f4d4df9ef1d70",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd8",
                                                                "_id": "6077c4efbc5f4d4df9ef1d71"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Concept Of Derivative",
                                                        "id": "5f686a41058075680d815a00",
                                                        "_id": "6077c4efbc5f4d4df9ef1d6e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcd9",
                                                                "_id": "6077c4efbc5f4d4df9ef1d6f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiability And Continuity",
                                                        "id": "5f686a41058075680d815a01",
                                                        "_id": "6077c4efbc5f4d4df9ef1d6c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcda",
                                                                "_id": "6077c4efbc5f4d4df9ef1d6d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differentiation Rules",
                                                        "id": "5f686a41058075680d815a02",
                                                        "_id": "6077c4efbc5f4d4df9ef1d6a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcdb",
                                                                "_id": "6077c4efbc5f4d4df9ef1d6b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d0",
                                                        "_id": "6077c4efbc5f4d4df9ef1d72"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Vector Algebra",
                                                "id": "5f68661f71814158f68ce58f",
                                                "_id": "6077c4efbc5f4d4df9ef1d57",
                                                "concepts": [
                                                    {
                                                        "name": "Algebra Of Vectors",
                                                        "id": "5f686a41058075680d8159f7",
                                                        "_id": "6077c4efbc5f4d4df9ef1d66",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcdc",
                                                                "_id": "6077c4efbc5f4d4df9ef1d67"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Resolution Of Vectors",
                                                        "id": "5f686a41058075680d8159f9",
                                                        "_id": "6077c4efbc5f4d4df9ef1d64",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcdd",
                                                                "_id": "6077c4efbc5f4d4df9ef1d65"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Direction Cosines And Directon Ratios",
                                                        "id": "5f686a41058075680d8159fa",
                                                        "_id": "6077c4efbc5f4d4df9ef1d62",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcde",
                                                                "_id": "6077c4efbc5f4d4df9ef1d63"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Scalars And Vectors",
                                                        "id": "5f686a41058075680d8159f5",
                                                        "_id": "6077c4efbc5f4d4df9ef1d60",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcdf",
                                                                "_id": "6077c4efbc5f4d4df9ef1d61"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Position Vectors",
                                                        "id": "5f686a41058075680d8159f8",
                                                        "_id": "6077c4efbc5f4d4df9ef1d5e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce0",
                                                                "_id": "6077c4efbc5f4d4df9ef1d5f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Product Of Vectors",
                                                        "id": "5f686a41058075680d8159fb",
                                                        "_id": "6077c4efbc5f4d4df9ef1d5c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce1",
                                                                "_id": "6077c4efbc5f4d4df9ef1d5d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Representation Of A Vector And Types Of Vectors",
                                                        "id": "5f686a41058075680d8159f6",
                                                        "_id": "6077c4efbc5f4d4df9ef1d5a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce2",
                                                                "_id": "6077c4efbc5f4d4df9ef1d5b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159f4",
                                                        "_id": "6077c4efbc5f4d4df9ef1d58",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce3",
                                                                "_id": "6077c4efbc5f4d4df9ef1d59"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d1",
                                                        "_id": "6077c4efbc5f4d4df9ef1d68"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differential Calculus - Limits And Continuity",
                                                "id": "5f68661f71814158f68ce590",
                                                "_id": "6077c4efbc5f4d4df9ef1d4f",
                                                "concepts": [
                                                    {
                                                        "name": "Limits",
                                                        "id": "5f686a41058075680d8159fd",
                                                        "_id": "6077c4efbc5f4d4df9ef1d54",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce4",
                                                                "_id": "6077c4efbc5f4d4df9ef1d55"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Continuity",
                                                        "id": "5f686a41058075680d8159fe",
                                                        "_id": "6077c4efbc5f4d4df9ef1d52",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce5",
                                                                "_id": "6077c4efbc5f4d4df9ef1d53"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159fc",
                                                        "_id": "6077c4efbc5f4d4df9ef1d50",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce6",
                                                                "_id": "6077c4efbc5f4d4df9ef1d51"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d2",
                                                        "_id": "6077c4efbc5f4d4df9ef1d56"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Integral Calculus",
                                                "id": "5f68661f71814158f68ce592",
                                                "_id": "6077c4efbc5f4d4df9ef1d3f",
                                                "concepts": [
                                                    {
                                                        "name": "Integrals Of The Form F(Ax + B)",
                                                        "id": "5f686a41058075680d815a06",
                                                        "_id": "6077c4efbc5f4d4df9ef1d4c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce7",
                                                                "_id": "6077c4efbc5f4d4df9ef1d4d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic Rules Of Integration",
                                                        "id": "5f686a41058075680d815a05",
                                                        "_id": "6077c4efbc5f4d4df9ef1d4a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce8",
                                                                "_id": "6077c4efbc5f4d4df9ef1d4b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Properties Of Integrals",
                                                        "id": "5f686a41058075680d815a07",
                                                        "_id": "6077c4efbc5f4d4df9ef1d48",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dce9",
                                                                "_id": "6077c4efbc5f4d4df9ef1d49"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple Applications",
                                                        "id": "5f686a41058075680d815a08",
                                                        "_id": "6077c4efbc5f4d4df9ef1d46",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcea",
                                                                "_id": "6077c4efbc5f4d4df9ef1d47"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Methods Of Integration",
                                                        "id": "5f686a41058075680d815a09",
                                                        "_id": "6077c4efbc5f4d4df9ef1d44",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dceb",
                                                                "_id": "6077c4efbc5f4d4df9ef1d45"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d815a03",
                                                        "_id": "6077c4efbc5f4d4df9ef1d42",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcec",
                                                                "_id": "6077c4efbc5f4d4df9ef1d43"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Newton-Leibnitz Integral",
                                                        "id": "5f686a41058075680d815a04",
                                                        "_id": "6077c4efbc5f4d4df9ef1d40",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dced",
                                                                "_id": "6077c4efbc5f4d4df9ef1d41"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d3",
                                                        "_id": "6077c4efbc5f4d4df9ef1d4e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Introduction To Probability Theory",
                                                "id": "5f68661f71814158f68ce593",
                                                "_id": "6077c4efbc5f4d4df9ef1d2d",
                                                "concepts": [
                                                    {
                                                        "name": "Probability",
                                                        "id": "5f686a41058075680d815a0d",
                                                        "_id": "6077c4efbc5f4d4df9ef1d3c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcee",
                                                                "_id": "6077c4efbc5f4d4df9ef1d3d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Total Probability Of An Event",
                                                        "id": "5f686a41058075680d815a10",
                                                        "_id": "6077c4efbc5f4d4df9ef1d3a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcef",
                                                                "_id": "6077c4efbc5f4d4df9ef1d3b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Some Basic Theorems On Probability",
                                                        "id": "5f686a41058075680d815a0e",
                                                        "_id": "6077c4efbc5f4d4df9ef1d38",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf0",
                                                                "_id": "6077c4efbc5f4d4df9ef1d39"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d815a0a",
                                                        "_id": "6077c4efbc5f4d4df9ef1d36",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf1",
                                                                "_id": "6077c4efbc5f4d4df9ef1d37"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Finite Sample Space",
                                                        "id": "5f686a41058075680d815a0c",
                                                        "_id": "6077c4efbc5f4d4df9ef1d34",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf2",
                                                                "_id": "6077c4efbc5f4d4df9ef1d35"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Basic Definitions",
                                                        "id": "5f686a41058075680d815a0b",
                                                        "_id": "6077c4efbc5f4d4df9ef1d32",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf3",
                                                                "_id": "6077c4efbc5f4d4df9ef1d33"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Conditional Probability",
                                                        "id": "5f686a41058075680d815a0f",
                                                        "_id": "6077c4efbc5f4d4df9ef1d30",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf4",
                                                                "_id": "6077c4efbc5f4d4df9ef1d31"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bayes’ Theorem",
                                                        "id": "5f686a41058075680d815a11",
                                                        "_id": "6077c4efbc5f4d4df9ef1d2e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf5",
                                                                "_id": "6077c4efbc5f4d4df9ef1d2f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d4",
                                                        "_id": "6077c4efbc5f4d4df9ef1d3e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Matrices And Determinants",
                                                "id": "5f68661f71814158f68ce58e",
                                                "_id": "6077c4efbc5f4d4df9ef1d25",
                                                "concepts": [
                                                    {
                                                        "name": "Determinants",
                                                        "id": "5f686a41058075680d8159f3",
                                                        "_id": "6077c4efbc5f4d4df9ef1d2a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf6",
                                                                "_id": "6077c4efbc5f4d4df9ef1d2b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Matrices",
                                                        "id": "5f686a41058075680d8159f2",
                                                        "_id": "6077c4efbc5f4d4df9ef1d28",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf7",
                                                                "_id": "6077c4efbc5f4d4df9ef1d29"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159f1",
                                                        "_id": "6077c4efbc5f4d4df9ef1d26",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf8",
                                                                "_id": "6077c4efbc5f4d4df9ef1d27"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d5",
                                                        "_id": "6077c4efbc5f4d4df9ef1d2c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Binomial Th Eorem, Sequences And Series",
                                                "id": "5f68661f71814158f68ce58c",
                                                "_id": "6077c4efbc5f4d4df9ef1d17",
                                                "concepts": [
                                                    {
                                                        "name": "Finite Series",
                                                        "id": "5f686a41058075680d8159ea",
                                                        "_id": "6077c4efbc5f4d4df9ef1d22",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcf9",
                                                                "_id": "6077c4efbc5f4d4df9ef1d23"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Binomial Theorem",
                                                        "id": "5f686a41058075680d8159e7",
                                                        "_id": "6077c4efbc5f4d4df9ef1d20",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcfa",
                                                                "_id": "6077c4efbc5f4d4df9ef1d21"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159e6",
                                                        "_id": "6077c4efbc5f4d4df9ef1d1e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcfb",
                                                                "_id": "6077c4efbc5f4d4df9ef1d1f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Particular Cases Of Binomial Theorem",
                                                        "id": "5f686a41058075680d8159e8",
                                                        "_id": "6077c4efbc5f4d4df9ef1d1c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcfc",
                                                                "_id": "6077c4efbc5f4d4df9ef1d1d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Finite Sequences",
                                                        "id": "5f686a41058075680d8159e9",
                                                        "_id": "6077c4efbc5f4d4df9ef1d1a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcfd",
                                                                "_id": "6077c4efbc5f4d4df9ef1d1b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Infinite Sequences And Series",
                                                        "id": "5f686a41058075680d8159eb",
                                                        "_id": "6077c4efbc5f4d4df9ef1d18",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dcfe",
                                                                "_id": "6077c4efbc5f4d4df9ef1d19"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d6",
                                                        "_id": "6077c4efbc5f4d4df9ef1d24"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef1da9"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Electrostatics",
                                                "id": "5f6991e8058075680d81d37c",
                                                "_id": "6077c4efbc5f4d4df9ef1d02",
                                                "concepts": [
                                                    {
                                                        "name": "Electrostatics Of Conductors And Dielectrics",
                                                        "id": "5f69922571814158f68d60ef",
                                                        "_id": "6077c4efbc5f4d4df9ef1d13",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded6",
                                                                "_id": "6077c4efbc5f4d4df9ef1d14"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Distribution Of Charges In A Conductor And Action At Points",
                                                        "id": "5f69922571814158f68d60f1",
                                                        "_id": "6077c4efbc5f4d4df9ef1d11",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded7",
                                                                "_id": "6077c4efbc5f4d4df9ef1d12"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Dipole And Its Properties",
                                                        "id": "5f69922571814158f68d60ec",
                                                        "_id": "6077c4efbc5f4d4df9ef1d0f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded8",
                                                                "_id": "6077c4efbc5f4d4df9ef1d10"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Field And Electric Field Lines",
                                                        "id": "5f69922571814158f68d60eb",
                                                        "_id": "6077c4efbc5f4d4df9ef1d0d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673ded9",
                                                                "_id": "6077c4efbc5f4d4df9ef1d0e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coulomb’s Law",
                                                        "id": "5f69922571814158f68d60ea",
                                                        "_id": "6077c4efbc5f4d4df9ef1d0b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deda",
                                                                "_id": "6077c4efbc5f4d4df9ef1d0c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electrostatic Potential And Potential Energy",
                                                        "id": "5f69922571814158f68d60ed",
                                                        "_id": "6077c4efbc5f4d4df9ef1d09",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dedb",
                                                                "_id": "6077c4efbc5f4d4df9ef1d0a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f69922571814158f68d60e9",
                                                        "_id": "6077c4efbc5f4d4df9ef1d07",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dedc",
                                                                "_id": "6077c4efbc5f4d4df9ef1d08"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Capacitors And Capacitance",
                                                        "id": "5f69922571814158f68d60f0",
                                                        "_id": "6077c4efbc5f4d4df9ef1d05",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dedd",
                                                                "_id": "6077c4efbc5f4d4df9ef1d06"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gauss Law And Its Applications",
                                                        "id": "5f69922571814158f68d60ee",
                                                        "_id": "6077c4efbc5f4d4df9ef1d03",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dede",
                                                                "_id": "6077c4efbc5f4d4df9ef1d04"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd85",
                                                        "_id": "6077c4efbc5f4d4df9ef1d15"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Dual Nature Of Radiation And Matter",
                                                "id": "5f6991e8058075680d81d382",
                                                "_id": "6077c4efbc5f4d4df9ef1cf8",
                                                "concepts": [
                                                    {
                                                        "name": "Photo Electric Effect",
                                                        "id": "5f69948d71814158f68d6237",
                                                        "_id": "6077c4efbc5f4d4df9ef1cff",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dedf",
                                                                "_id": "6077c4efbc5f4d4df9ef1d00"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f69948d71814158f68d6236",
                                                        "_id": "6077c4efbc5f4d4df9ef1cfd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee0",
                                                                "_id": "6077c4efbc5f4d4df9ef1cfe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Matter Waves",
                                                        "id": "5f69948d71814158f68d6238",
                                                        "_id": "6077c4efbc5f4d4df9ef1cfb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee1",
                                                                "_id": "6077c4efbc5f4d4df9ef1cfc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "X – Rays",
                                                        "id": "5f69948d71814158f68d6239",
                                                        "_id": "6077c4efbc5f4d4df9ef1cf9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee2",
                                                                "_id": "6077c4efbc5f4d4df9ef1cfa"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd86",
                                                        "_id": "6077c4efbc5f4d4df9ef1d01"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Magnetism And Magnetic Effects Of Electric Current",
                                                "id": "5f6991e8058075680d81d37e",
                                                "_id": "6077c4efbc5f4d4df9ef1ce0",
                                                "concepts": [
                                                    {
                                                        "name": "Torque Acting On A Bar Magnet In Uniform Magnetic Field",
                                                        "id": "5f6993e8ca5ac358f170d8d8",
                                                        "_id": "6077c4efbc5f4d4df9ef1cf5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee3",
                                                                "_id": "6077c4efbc5f4d4df9ef1cf6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic Properties",
                                                        "id": "5f6993e8ca5ac358f170d8d9",
                                                        "_id": "6077c4efbc5f4d4df9ef1cf3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee4",
                                                                "_id": "6077c4efbc5f4d4df9ef1cf4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction To Magnetism",
                                                        "id": "5f6993e8ca5ac358f170d8d6",
                                                        "_id": "6077c4efbc5f4d4df9ef1cf1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee5",
                                                                "_id": "6077c4efbc5f4d4df9ef1cf2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Hysteresis",
                                                        "id": "5f6993e8ca5ac358f170d8db",
                                                        "_id": "6077c4efbc5f4d4df9ef1cef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee6",
                                                                "_id": "6077c4efbc5f4d4df9ef1cf0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Magnetic Effects Of Current",
                                                        "id": "5f6993e8ca5ac358f170d8dc",
                                                        "_id": "6077c4efbc5f4d4df9ef1ced",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee7",
                                                                "_id": "6077c4efbc5f4d4df9ef1cee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Lorentz Force",
                                                        "id": "5f6993e8ca5ac358f170d8df",
                                                        "_id": "6077c4efbc5f4d4df9ef1ceb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee8",
                                                                "_id": "6077c4efbc5f4d4df9ef1cec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classification Of Magnetic Materials",
                                                        "id": "5f6993e8ca5ac358f170d8da",
                                                        "_id": "6077c4efbc5f4d4df9ef1ce9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673dee9",
                                                                "_id": "6077c4efbc5f4d4df9ef1cea"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Biot - Savart Law",
                                                        "id": "5f6993e8ca5ac358f170d8dd",
                                                        "_id": "6077c4efbc5f4d4df9ef1ce7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deea",
                                                                "_id": "6077c4efbc5f4d4df9ef1ce8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Ampère’s Circuital Law",
                                                        "id": "5f6993e8ca5ac358f170d8de",
                                                        "_id": "6077c4efbc5f4d4df9ef1ce5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deeb",
                                                                "_id": "6077c4efbc5f4d4df9ef1ce6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Coulomb’s Inverse Square Law Of Magnetism",
                                                        "id": "5f6993e8ca5ac358f170d8d7",
                                                        "_id": "6077c4efbc5f4d4df9ef1ce3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deec",
                                                                "_id": "6077c4efbc5f4d4df9ef1ce4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Torque On A Current Loop",
                                                        "id": "5f6993e8ca5ac358f170d8e0",
                                                        "_id": "6077c4efbc5f4d4df9ef1ce1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deed",
                                                                "_id": "6077c4efbc5f4d4df9ef1ce2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd87",
                                                        "_id": "6077c4efbc5f4d4df9ef1cf7"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Atomic And Nuclear Physics",
                                                "id": "5f6991e8058075680d81d383",
                                                "_id": "6077c4efbc5f4d4df9ef1cce",
                                                "concepts": [
                                                    {
                                                        "name": "Nuclei",
                                                        "id": "5f6994b7ca5ac358f170d965",
                                                        "_id": "6077c4efbc5f4d4df9ef1cdd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673def5",
                                                                "_id": "6077c4efbc5f4d4df9ef1cde"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Discharge Through Gases",
                                                        "id": "5f6994b7ca5ac358f170d963",
                                                        "_id": "6077c4efbc5f4d4df9ef1cdb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673def6",
                                                                "_id": "6077c4efbc5f4d4df9ef1cdc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Fusion",
                                                        "id": "5f6994b7ca5ac358f170d969",
                                                        "_id": "6077c4efbc5f4d4df9ef1cd9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673def7",
                                                                "_id": "6077c4efbc5f4d4df9ef1cda"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Force",
                                                        "id": "5f6994b7ca5ac358f170d966",
                                                        "_id": "6077c4efbc5f4d4df9ef1cd7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673def8",
                                                                "_id": "6077c4efbc5f4d4df9ef1cd8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Radioactivity",
                                                        "id": "5f6994b7ca5ac358f170d967",
                                                        "_id": "6077c4efbc5f4d4df9ef1cd5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673def9",
                                                                "_id": "6077c4efbc5f4d4df9ef1cd6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Fission",
                                                        "id": "5f6994b7ca5ac358f170d968",
                                                        "_id": "6077c4efbc5f4d4df9ef1cd3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673defa",
                                                                "_id": "6077c4efbc5f4d4df9ef1cd4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Atom Models",
                                                        "id": "5f6994b7ca5ac358f170d964",
                                                        "_id": "6077c4efbc5f4d4df9ef1cd1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673defb",
                                                                "_id": "6077c4efbc5f4d4df9ef1cd2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6994b7ca5ac358f170d962",
                                                        "_id": "6077c4efbc5f4d4df9ef1ccf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673defc",
                                                                "_id": "6077c4efbc5f4d4df9ef1cd0"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd89",
                                                        "_id": "6077c4efbc5f4d4df9ef1cdf"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4efbc5f4d4df9ef1d16"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Analogy",
                                                "id": "5ace20309fe7b01d5806bc1e",
                                                "_id": "6077c4efbc5f4d4df9ef1cc9",
                                                "concepts": [
                                                    {
                                                        "name": "Analogy",
                                                        "id": "5ace20389fe7b01d5806bf0c",
                                                        "_id": "6077c4efbc5f4d4df9ef1cca",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8445",
                                                                "_id": "6077c4efbc5f4d4df9ef1ccb"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825e",
                                                        "_id": "6077c4efbc5f4d4df9ef1ccc"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Arithmetical Reasoning",
                                                "id": "5ace20309fe7b01d5806bc1f",
                                                "_id": "6077c4efbc5f4d4df9ef1cc5",
                                                "concepts": [
                                                    {
                                                        "name": "Arithmetical Reasoning",
                                                        "id": "5ace20389fe7b01d5806bf0d",
                                                        "_id": "6077c4efbc5f4d4df9ef1cc6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8446",
                                                                "_id": "6077c4efbc5f4d4df9ef1cc7"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c825f",
                                                        "_id": "6077c4efbc5f4d4df9ef1cc8"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4efbc5f4d4df9ef1ccd"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "Outcomes of Democracy",
                                                "id": "5ace20329fe7b01d5806bce9",
                                                "_id": "6077c4efbc5f4d4df9ef1cc0",
                                                "concepts": [
                                                    {
                                                        "name": "Democracy as accountable, legimate and responsive government",
                                                        "id": "5ace20429fe7b01d5806c236",
                                                        "_id": "6077c4efbc5f4d4df9ef1cc1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849d",
                                                                "_id": "6077c4efbc5f4d4df9ef1cc2"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8291",
                                                        "_id": "6077c4efbc5f4d4df9ef1cc3"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Challenges to Democracy",
                                                "id": "5ace20329fe7b01d5806bce1",
                                                "_id": "6077c4efbc5f4d4df9ef1cbc",
                                                "concepts": [
                                                    {
                                                        "name": "Challenges to Democracy",
                                                        "id": "5ace20429fe7b01d5806c22b",
                                                        "_id": "6077c4efbc5f4d4df9ef1cbd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849e",
                                                                "_id": "6077c4efbc5f4d4df9ef1cbe"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8292",
                                                        "_id": "6077c4efbc5f4d4df9ef1cbf"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "The story of Village Palampur",
                                                "id": "5ace20329fe7b01d5806bcc3",
                                                "_id": "6077c4efbc5f4d4df9ef1cb6",
                                                "concepts": [
                                                    {
                                                        "name": "Factors of production",
                                                        "id": "5ace20419fe7b01d5806c1f2",
                                                        "_id": "6077c4efbc5f4d4df9ef1cb9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c849f",
                                                                "_id": "6077c4efbc5f4d4df9ef1cba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Green revolution",
                                                        "id": "5ace20419fe7b01d5806c1f3",
                                                        "_id": "6077c4efbc5f4d4df9ef1cb7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a0",
                                                                "_id": "6077c4efbc5f4d4df9ef1cb8"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8293",
                                                        "_id": "6077c4efbc5f4d4df9ef1cbb"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4efbc5f4d4df9ef1cc4"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4efbc5f4d4df9ef1cb5"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "weekNo": 12,
                                "startDate": "2021-07-15T00:00:00.000Z",
                                "endDate": "2021-07-21T00:00:00.000Z",
                                "_id": "6077c4eebc5f4d4df9ef1b46",
                                "content": [],
                                "subjects": [
                                    {
                                        "name": "Biology",
                                        "id": "5ace202e9fe7b01d5806bb89",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b2",
                                                "_id": "6077c4efbc5f4d4df9ef1cb3"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Chemistry",
                                        "id": "5ace202e9fe7b01d5806bb8a",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b3",
                                                "_id": "6077c4efbc5f4d4df9ef1cb2"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Mathematics",
                                        "id": "5ace202e9fe7b01d5806bb8e",
                                        "chapters": [
                                            {
                                                "name": "Combinatorics And Mathematical Induction",
                                                "id": "5f68661f71814158f68ce58b",
                                                "_id": "6077c4efbc5f4d4df9ef1ca3",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159e0",
                                                        "_id": "6077c4efbc5f4d4df9ef1cae",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd08",
                                                                "_id": "6077c4efbc5f4d4df9ef1caf"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Permutations",
                                                        "id": "5f686a41058075680d8159e3",
                                                        "_id": "6077c4efbc5f4d4df9ef1cac",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd09",
                                                                "_id": "6077c4efbc5f4d4df9ef1cad"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Combinations",
                                                        "id": "5f686a41058075680d8159e4",
                                                        "_id": "6077c4efbc5f4d4df9ef1caa",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0a",
                                                                "_id": "6077c4efbc5f4d4df9ef1cab"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Factorials",
                                                        "id": "5f686a41058075680d8159e2",
                                                        "_id": "6077c4efbc5f4d4df9ef1ca8",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0b",
                                                                "_id": "6077c4efbc5f4d4df9ef1ca9"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mathematical Induction",
                                                        "id": "5f686a41058075680d8159e5",
                                                        "_id": "6077c4efbc5f4d4df9ef1ca6",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0c",
                                                                "_id": "6077c4efbc5f4d4df9ef1ca7"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental Principles Of Counting",
                                                        "id": "5f686a41058075680d8159e1",
                                                        "_id": "6077c4efbc5f4d4df9ef1ca4",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0d",
                                                                "_id": "6077c4efbc5f4d4df9ef1ca5"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d8",
                                                        "_id": "6077c4efbc5f4d4df9ef1cb0"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Sets, Relations And Functions",
                                                "id": "5f68661f71814158f68ce588",
                                                "_id": "6077c4efbc5f4d4df9ef1c93",
                                                "concepts": [
                                                    {
                                                        "name": "Sets",
                                                        "id": "5f686a41058075680d8159c7",
                                                        "_id": "6077c4efbc5f4d4df9ef1ca0",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0e",
                                                                "_id": "6077c4efbc5f4d4df9ef1ca1"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Relations",
                                                        "id": "5f686a41058075680d8159ca",
                                                        "_id": "6077c4efbc5f4d4df9ef1c9e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd0f",
                                                                "_id": "6077c4efbc5f4d4df9ef1c9f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functions",
                                                        "id": "5f686a41058075680d8159cb",
                                                        "_id": "6077c4efbc5f4d4df9ef1c9c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd10",
                                                                "_id": "6077c4efbc5f4d4df9ef1c9d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Graphing Functions Using Transformations",
                                                        "id": "5f686a41058075680d8159cc",
                                                        "_id": "6077c4efbc5f4d4df9ef1c9a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd11",
                                                                "_id": "6077c4efbc5f4d4df9ef1c9b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Cartesian Product",
                                                        "id": "5f686a41058075680d8159c8",
                                                        "_id": "6077c4efbc5f4d4df9ef1c98",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd12",
                                                                "_id": "6077c4efbc5f4d4df9ef1c99"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159c6",
                                                        "_id": "6077c4efbc5f4d4df9ef1c96",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd13",
                                                                "_id": "6077c4efbc5f4d4df9ef1c97"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Constants And Variables, Intervals And Neighbourhoods",
                                                        "id": "5f686a41058075680d8159c9",
                                                        "_id": "6077c4efbc5f4d4df9ef1c94",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd14",
                                                                "_id": "6077c4efbc5f4d4df9ef1c95"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9d9",
                                                        "_id": "6077c4efbc5f4d4df9ef1ca2"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Two Dimensional Analytical Geometry",
                                                "id": "5f68661f71814158f68ce58d",
                                                "_id": "6077c4efbc5f4d4df9ef1c87",
                                                "concepts": [
                                                    {
                                                        "name": "Straight Lines",
                                                        "id": "5f686a41058075680d8159ee",
                                                        "_id": "6077c4efbc5f4d4df9ef1c90",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd15",
                                                                "_id": "6077c4efbc5f4d4df9ef1c91"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159ec",
                                                        "_id": "6077c4efbc5f4d4df9ef1c8e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd16",
                                                                "_id": "6077c4efbc5f4d4df9ef1c8f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Pair Of Straight Lines",
                                                        "id": "5f686a41058075680d8159f0",
                                                        "_id": "6077c4efbc5f4d4df9ef1c8c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd17",
                                                                "_id": "6077c4efbc5f4d4df9ef1c8d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Locus Of A Point",
                                                        "id": "5f686a41058075680d8159ed",
                                                        "_id": "6077c4efbc5f4d4df9ef1c8a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd18",
                                                                "_id": "6077c4efbc5f4d4df9ef1c8b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Angle Between Two Straight Lines",
                                                        "id": "5f686a41058075680d8159ef",
                                                        "_id": "6077c4efbc5f4d4df9ef1c88",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd19",
                                                                "_id": "6077c4efbc5f4d4df9ef1c89"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9da",
                                                        "_id": "6077c4efbc5f4d4df9ef1c92"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Basic Algebra",
                                                "id": "5f68661f71814158f68ce589",
                                                "_id": "6077c4eebc5f4d4df9ef1c71",
                                                "concepts": [
                                                    {
                                                        "name": "Quadratic Functions",
                                                        "id": "5f686a41058075680d8159d1",
                                                        "_id": "6077c4efbc5f4d4df9ef1c84",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1a",
                                                                "_id": "6077c4efbc5f4d4df9ef1c85"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polynomial Functions",
                                                        "id": "5f686a41058075680d8159d2",
                                                        "_id": "6077c4efbc5f4d4df9ef1c82",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1b",
                                                                "_id": "6077c4efbc5f4d4df9ef1c83"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Rational Functions",
                                                        "id": "5f686a41058075680d8159d3",
                                                        "_id": "6077c4efbc5f4d4df9ef1c80",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1c",
                                                                "_id": "6077c4efbc5f4d4df9ef1c81"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Real Number System",
                                                        "id": "5f686a41058075680d8159ce",
                                                        "_id": "6077c4efbc5f4d4df9ef1c7e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1d",
                                                                "_id": "6077c4efbc5f4d4df9ef1c7f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f686a41058075680d8159cd",
                                                        "_id": "6077c4efbc5f4d4df9ef1c7c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1e",
                                                                "_id": "6077c4efbc5f4d4df9ef1c7d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Exponents And Radicals",
                                                        "id": "5f686a41058075680d8159d4",
                                                        "_id": "6077c4efbc5f4d4df9ef1c7a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd1f",
                                                                "_id": "6077c4efbc5f4d4df9ef1c7b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application Of Algebra In Real Life",
                                                        "id": "5f686a41058075680d8159d6",
                                                        "_id": "6077c4efbc5f4d4df9ef1c78",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd20",
                                                                "_id": "6077c4efbc5f4d4df9ef1c79"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Logarithm",
                                                        "id": "5f686a41058075680d8159d5",
                                                        "_id": "6077c4efbc5f4d4df9ef1c76",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd21",
                                                                "_id": "6077c4efbc5f4d4df9ef1c77"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Absolute Value",
                                                        "id": "5f686a41058075680d8159cf",
                                                        "_id": "6077c4eebc5f4d4df9ef1c74",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd22",
                                                                "_id": "6077c4eebc5f4d4df9ef1c75"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear Inequalities",
                                                        "id": "5f686a41058075680d8159d0",
                                                        "_id": "6077c4eebc5f4d4df9ef1c72",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd23",
                                                                "_id": "6077c4eebc5f4d4df9ef1c73"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9db",
                                                        "_id": "6077c4efbc5f4d4df9ef1c86"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Applications Of Integration",
                                                "id": "5f71d512ce003c1296026cd3",
                                                "_id": "6077c4eebc5f4d4df9ef1c5d",
                                                "concepts": [
                                                    {
                                                        "name": "Evaluation Of Bounded Plane Area By Integration",
                                                        "id": "5f71d7c47ac53612907090e4",
                                                        "_id": "6077c4eebc5f4d4df9ef1c6e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd24",
                                                                "_id": "6077c4eebc5f4d4df9ef1c6f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Volume Of A Solid Obtained By Revolving Area About An Axis",
                                                        "id": "5f71d7c47ac53612907090e5",
                                                        "_id": "6077c4eebc5f4d4df9ef1c6c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd25",
                                                                "_id": "6077c4eebc5f4d4df9ef1c6d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090dd",
                                                        "_id": "6077c4eebc5f4d4df9ef1c6a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd26",
                                                                "_id": "6077c4eebc5f4d4df9ef1c6b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Definite Integral As The Limit Of A Sum",
                                                        "id": "5f71d7c47ac53612907090de",
                                                        "_id": "6077c4eebc5f4d4df9ef1c68",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd27",
                                                                "_id": "6077c4eebc5f4d4df9ef1c69"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bernoulli’S Formula",
                                                        "id": "5f71d7c47ac53612907090e0",
                                                        "_id": "6077c4eebc5f4d4df9ef1c66",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd28",
                                                                "_id": "6077c4eebc5f4d4df9ef1c67"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Reduction Formulae",
                                                        "id": "5f71d7c47ac53612907090e2",
                                                        "_id": "6077c4eebc5f4d4df9ef1c64",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd29",
                                                                "_id": "6077c4eebc5f4d4df9ef1c65"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Gamma Integral",
                                                        "id": "5f71d7c47ac53612907090e3",
                                                        "_id": "6077c4eebc5f4d4df9ef1c62",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2a",
                                                                "_id": "6077c4eebc5f4d4df9ef1c63"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Fundamental Theorems Of Integral Calculus And Their Applications",
                                                        "id": "5f71d7c47ac53612907090df",
                                                        "_id": "6077c4eebc5f4d4df9ef1c60",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2b",
                                                                "_id": "6077c4eebc5f4d4df9ef1c61"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Improper Integrals",
                                                        "id": "5f71d7c47ac53612907090e1",
                                                        "_id": "6077c4eebc5f4d4df9ef1c5e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2c",
                                                                "_id": "6077c4eebc5f4d4df9ef1c5f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9dc",
                                                        "_id": "6077c4eebc5f4d4df9ef1c70"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Applications Of Differential Calculus",
                                                "id": "5f71d512ce003c1296026cd1",
                                                "_id": "6077c4eebc5f4d4df9ef1c47",
                                                "concepts": [
                                                    {
                                                        "name": "Applications In Optimization",
                                                        "id": "5f71d7c47ac53612907090d4",
                                                        "_id": "6077c4eebc5f4d4df9ef1c5a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2d",
                                                                "_id": "6077c4eebc5f4d4df9ef1c5b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090cd",
                                                        "_id": "6077c4eebc5f4d4df9ef1c58",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2e",
                                                                "_id": "6077c4eebc5f4d4df9ef1c59"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Symmetry And Asymptotes",
                                                        "id": "5f71d7c47ac53612907090d5",
                                                        "_id": "6077c4eebc5f4d4df9ef1c56",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd2f",
                                                                "_id": "6077c4eebc5f4d4df9ef1c57"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Meaning Of Derivatives",
                                                        "id": "5f71d7c47ac53612907090ce",
                                                        "_id": "6077c4eebc5f4d4df9ef1c54",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd30",
                                                                "_id": "6077c4eebc5f4d4df9ef1c55"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mean Value Theorem",
                                                        "id": "5f71d7c47ac53612907090cf",
                                                        "_id": "6077c4eebc5f4d4df9ef1c52",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd31",
                                                                "_id": "6077c4eebc5f4d4df9ef1c53"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Series Expansions",
                                                        "id": "5f71d7c47ac53612907090d0",
                                                        "_id": "6077c4eebc5f4d4df9ef1c50",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd32",
                                                                "_id": "6077c4eebc5f4d4df9ef1c51"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of Second Derivative",
                                                        "id": "5f71d7c47ac53612907090d3",
                                                        "_id": "6077c4eebc5f4d4df9ef1c4e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd33",
                                                                "_id": "6077c4eebc5f4d4df9ef1c4f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sketching Of Curves",
                                                        "id": "5f71d7c47ac53612907090d6",
                                                        "_id": "6077c4eebc5f4d4df9ef1c4c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd34",
                                                                "_id": "6077c4eebc5f4d4df9ef1c4d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Indeterminate Forms",
                                                        "id": "5f71d7c47ac53612907090d1",
                                                        "_id": "6077c4eebc5f4d4df9ef1c4a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd35",
                                                                "_id": "6077c4eebc5f4d4df9ef1c4b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of First Derivative",
                                                        "id": "5f71d7c47ac53612907090d2",
                                                        "_id": "6077c4eebc5f4d4df9ef1c48",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd36",
                                                                "_id": "6077c4eebc5f4d4df9ef1c49"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9dd",
                                                        "_id": "6077c4eebc5f4d4df9ef1c5c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Discrete Mathematics",
                                                "id": "5f71d512ce003c1296026cd6",
                                                "_id": "6077c4eebc5f4d4df9ef1c3f",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090f4",
                                                        "_id": "6077c4eebc5f4d4df9ef1c44",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd37",
                                                                "_id": "6077c4eebc5f4d4df9ef1c45"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mathematical Logic",
                                                        "id": "5f71d7c47ac53612907090f6",
                                                        "_id": "6077c4eebc5f4d4df9ef1c42",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd38",
                                                                "_id": "6077c4eebc5f4d4df9ef1c43"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Binary Operations",
                                                        "id": "5f71d7c47ac53612907090f5",
                                                        "_id": "6077c4eebc5f4d4df9ef1c40",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd39",
                                                                "_id": "6077c4eebc5f4d4df9ef1c41"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9de",
                                                        "_id": "6077c4eebc5f4d4df9ef1c46"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability Distributions",
                                                "id": "5f71d512ce003c1296026cd5",
                                                "_id": "6077c4eebc5f4d4df9ef1c31",
                                                "concepts": [
                                                    {
                                                        "name": "Types Of Random Variable",
                                                        "id": "5f71d7c47ac53612907090f0",
                                                        "_id": "6077c4eebc5f4d4df9ef1c3c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3a",
                                                                "_id": "6077c4eebc5f4d4df9ef1c3d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Random Variable",
                                                        "id": "5f71d7c47ac53612907090ef",
                                                        "_id": "6077c4eebc5f4d4df9ef1c3a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3b",
                                                                "_id": "6077c4eebc5f4d4df9ef1c3b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theoretical Distributions: Some Special Discrete Distributions",
                                                        "id": "5f71d7c47ac53612907090f3",
                                                        "_id": "6077c4eebc5f4d4df9ef1c38",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3c",
                                                                "_id": "6077c4eebc5f4d4df9ef1c39"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090ee",
                                                        "_id": "6077c4eebc5f4d4df9ef1c36",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3d",
                                                                "_id": "6077c4eebc5f4d4df9ef1c37"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mathematical Expectation",
                                                        "id": "5f71d7c47ac53612907090f2",
                                                        "_id": "6077c4eebc5f4d4df9ef1c34",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3e",
                                                                "_id": "6077c4eebc5f4d4df9ef1c35"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Continuous Distributions",
                                                        "id": "5f71d7c47ac53612907090f1",
                                                        "_id": "6077c4eebc5f4d4df9ef1c32",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd3f",
                                                                "_id": "6077c4eebc5f4d4df9ef1c33"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9df",
                                                        "_id": "6077c4eebc5f4d4df9ef1c3e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Differentials And Partial Derivatives",
                                                "id": "5f71d512ce003c1296026cd2",
                                                "_id": "6077c4eebc5f4d4df9ef1c23",
                                                "concepts": [
                                                    {
                                                        "name": "Linear Approximation And Differential Of A",
                                                        "id": "5f71d7c47ac53612907090dc",
                                                        "_id": "6077c4eebc5f4d4df9ef1c2e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd40",
                                                                "_id": "6077c4eebc5f4d4df9ef1c2f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Limit And Continuity Of Functions Of Two Variables Function Of Several Variables",
                                                        "id": "5f71d7c47ac53612907090da",
                                                        "_id": "6077c4eebc5f4d4df9ef1c2c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd41",
                                                                "_id": "6077c4eebc5f4d4df9ef1c2d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Partial Derivatives",
                                                        "id": "5f71d7c47ac53612907090db",
                                                        "_id": "6077c4eebc5f4d4df9ef1c2a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd42",
                                                                "_id": "6077c4eebc5f4d4df9ef1c2b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Functions Of Several Variables",
                                                        "id": "5f71d7c47ac53612907090d9",
                                                        "_id": "6077c4eebc5f4d4df9ef1c28",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd43",
                                                                "_id": "6077c4eebc5f4d4df9ef1c29"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Linear Approximation And Differentials",
                                                        "id": "5f71d7c47ac53612907090d8",
                                                        "_id": "6077c4eebc5f4d4df9ef1c26",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd44",
                                                                "_id": "6077c4eebc5f4d4df9ef1c27"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090d7",
                                                        "_id": "6077c4eebc5f4d4df9ef1c24",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd45",
                                                                "_id": "6077c4eebc5f4d4df9ef1c25"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9e0",
                                                        "_id": "6077c4eebc5f4d4df9ef1c30"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Ordinary Differential Equations",
                                                "id": "5f71d512ce003c1296026cd4",
                                                "_id": "6077c4eebc5f4d4df9ef1c11",
                                                "concepts": [
                                                    {
                                                        "name": "Classification Of Differential Equations",
                                                        "id": "5f71d7c47ac53612907090e8",
                                                        "_id": "6077c4eebc5f4d4df9ef1c20",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd46",
                                                                "_id": "6077c4eebc5f4d4df9ef1c21"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution Of First Order And First Degree Differential Equations",
                                                        "id": "5f71d7c47ac53612907090eb",
                                                        "_id": "6077c4eebc5f4d4df9ef1c1e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd47",
                                                                "_id": "6077c4eebc5f4d4df9ef1c1f"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Differential Equation, Order, And Degree",
                                                        "id": "5f71d7c47ac53612907090e7",
                                                        "_id": "6077c4eebc5f4d4df9ef1c1c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd48",
                                                                "_id": "6077c4eebc5f4d4df9ef1c1d"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71d7c47ac53612907090e6",
                                                        "_id": "6077c4eebc5f4d4df9ef1c1a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd49",
                                                                "_id": "6077c4eebc5f4d4df9ef1c1b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Formation Of Differential Equations",
                                                        "id": "5f71d7c47ac53612907090e9",
                                                        "_id": "6077c4eebc5f4d4df9ef1c18",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd4a",
                                                                "_id": "6077c4eebc5f4d4df9ef1c19"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Applications Of First Order Ordinary Differential Equations",
                                                        "id": "5f71d7c47ac53612907090ed",
                                                        "_id": "6077c4eebc5f4d4df9ef1c16",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd4b",
                                                                "_id": "6077c4eebc5f4d4df9ef1c17"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Solution Of Ordinary Differential Equations",
                                                        "id": "5f71d7c47ac53612907090ea",
                                                        "_id": "6077c4eebc5f4d4df9ef1c14",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd4c",
                                                                "_id": "6077c4eebc5f4d4df9ef1c15"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "First Order Linear Differential Equations",
                                                        "id": "5f71d7c47ac53612907090ec",
                                                        "_id": "6077c4eebc5f4d4df9ef1c12",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5724b35a0a066673dd4d",
                                                                "_id": "6077c4eebc5f4d4df9ef1c13"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5723b35a0a066673d9e1",
                                                        "_id": "6077c4eebc5f4d4df9ef1c22"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b4",
                                                "_id": "6077c4efbc5f4d4df9ef1cb1"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Physics",
                                        "id": "5ace202e9fe7b01d5806bb8f",
                                        "chapters": [
                                            {
                                                "name": "Semiconductor Electronics",
                                                "id": "5f6991e8058075680d81d384",
                                                "_id": "6077c4eebc5f4d4df9ef1c00",
                                                "concepts": [
                                                    {
                                                        "name": "Types Of Semiconductrors",
                                                        "id": "5f6994deca5ac358f170d985",
                                                        "_id": "6077c4eebc5f4d4df9ef1c0d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673defd",
                                                                "_id": "6077c4eebc5f4d4df9ef1c0e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diodes",
                                                        "id": "5f6994deca5ac358f170d986",
                                                        "_id": "6077c4eebc5f4d4df9ef1c0b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673defe",
                                                                "_id": "6077c4eebc5f4d4df9ef1c0c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Bipolar Junction Transistor [Bjt]",
                                                        "id": "5f6994deca5ac358f170d987",
                                                        "_id": "6077c4eebc5f4d4df9ef1c09",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673deff",
                                                                "_id": "6077c4eebc5f4d4df9ef1c0a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Digital Electronics",
                                                        "id": "5f6994deca5ac358f170d988",
                                                        "_id": "6077c4eebc5f4d4df9ef1c07",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df00",
                                                                "_id": "6077c4eebc5f4d4df9ef1c08"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De Morgan’s Theorem",
                                                        "id": "5f6994deca5ac358f170d98a",
                                                        "_id": "6077c4eebc5f4d4df9ef1c05",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df01",
                                                                "_id": "6077c4eebc5f4d4df9ef1c06"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f6994deca5ac358f170d984",
                                                        "_id": "6077c4eebc5f4d4df9ef1c03",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df02",
                                                                "_id": "6077c4eebc5f4d4df9ef1c04"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Boolean Algebra",
                                                        "id": "5f6994deca5ac358f170d989",
                                                        "_id": "6077c4eebc5f4d4df9ef1c01",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df03",
                                                                "_id": "6077c4eebc5f4d4df9ef1c02"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8a",
                                                        "_id": "6077c4eebc5f4d4df9ef1c0f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Communication Systems",
                                                "id": "5f71cc80414f235e9782af05",
                                                "_id": "6077c4eebc5f4d4df9ef1be6",
                                                "concepts": [
                                                    {
                                                        "name": "Fibre Optic Communication",
                                                        "id": "5f71ce207ac5361290708c0c",
                                                        "_id": "6077c4eebc5f4d4df9ef1bfd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df04",
                                                                "_id": "6077c4eebc5f4d4df9ef1bfe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Global Positioning System",
                                                        "id": "5f71ce207ac5361290708c10",
                                                        "_id": "6077c4eebc5f4d4df9ef1bfb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df05",
                                                                "_id": "6077c4eebc5f4d4df9ef1bfc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Internet",
                                                        "id": "5f71ce207ac5361290708c0f",
                                                        "_id": "6077c4eebc5f4d4df9ef1bf9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df06",
                                                                "_id": "6077c4eebc5f4d4df9ef1bfa"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Antenna Size",
                                                        "id": "5f71ce207ac5361290708c09",
                                                        "_id": "6077c4eebc5f4d4df9ef1bf7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df07",
                                                                "_id": "6077c4eebc5f4d4df9ef1bf8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708c06",
                                                        "_id": "6077c4eebc5f4d4df9ef1bf5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df08",
                                                                "_id": "6077c4eebc5f4d4df9ef1bf6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Application Of Information And Communication Technology In Agriculture, Fisheries And Mining (I) Agriculture The Implementation",
                                                        "id": "5f71ce207ac5361290708c11",
                                                        "_id": "6077c4eebc5f4d4df9ef1bf3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df09",
                                                                "_id": "6077c4eebc5f4d4df9ef1bf4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Radar And Applications",
                                                        "id": "5f71ce207ac5361290708c0d",
                                                        "_id": "6077c4eebc5f4d4df9ef1bf1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0a",
                                                                "_id": "6077c4eebc5f4d4df9ef1bf2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Propagation Of Electromagnetic Waves",
                                                        "id": "5f71ce207ac5361290708c0a",
                                                        "_id": "6077c4eebc5f4d4df9ef1bef",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0b",
                                                                "_id": "6077c4eebc5f4d4df9ef1bf0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Elements Of An Electronic Communication System",
                                                        "id": "5f71ce207ac5361290708c08",
                                                        "_id": "6077c4eebc5f4d4df9ef1bed",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0c",
                                                                "_id": "6077c4eebc5f4d4df9ef1bee"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Satellite Communication",
                                                        "id": "5f71ce207ac5361290708c0b",
                                                        "_id": "6077c4eebc5f4d4df9ef1beb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0d",
                                                                "_id": "6077c4eebc5f4d4df9ef1bec"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Mobile Communication",
                                                        "id": "5f71ce207ac5361290708c0e",
                                                        "_id": "6077c4eebc5f4d4df9ef1be9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0e",
                                                                "_id": "6077c4eebc5f4d4df9ef1bea"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Modulation",
                                                        "id": "5f71ce207ac5361290708c07",
                                                        "_id": "6077c4eebc5f4d4df9ef1be7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df0f",
                                                                "_id": "6077c4eebc5f4d4df9ef1be8"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8b",
                                                        "_id": "6077c4eebc5f4d4df9ef1bff"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Recent Developments In Physics",
                                                "id": "5f71cc80414f235e9782af06",
                                                "_id": "6077c4eebc5f4d4df9ef1bde",
                                                "concepts": [
                                                    {
                                                        "name": "Nanoscience And Nanotechnology",
                                                        "id": "5f71ce207ac5361290708c13",
                                                        "_id": "6077c4eebc5f4d4df9ef1be3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df10",
                                                                "_id": "6077c4eebc5f4d4df9ef1be4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708c12",
                                                        "_id": "6077c4eebc5f4d4df9ef1be1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df11",
                                                                "_id": "6077c4eebc5f4d4df9ef1be2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Robotics",
                                                        "id": "5f71ce207ac5361290708c14",
                                                        "_id": "6077c4eebc5f4d4df9ef1bdf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df12",
                                                                "_id": "6077c4eebc5f4d4df9ef1be0"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8c",
                                                        "_id": "6077c4eebc5f4d4df9ef1be5"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Optics",
                                                "id": "5f71cc80414f235e9782af01",
                                                "_id": "6077c4eebc5f4d4df9ef1bc2",
                                                "concepts": [
                                                    {
                                                        "name": "Refraction",
                                                        "id": "5f71ce207ac5361290708be9",
                                                        "_id": "6077c4eebc5f4d4df9ef1bdb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df13",
                                                                "_id": "6077c4eebc5f4d4df9ef1bdc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Refraction At Single Spherical Surface",
                                                        "id": "5f71ce207ac5361290708bea",
                                                        "_id": "6077c4eebc5f4d4df9ef1bd9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df14",
                                                                "_id": "6077c4eebc5f4d4df9ef1bda"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Wave Nature Of Light",
                                                        "id": "5f71ce207ac5361290708bee",
                                                        "_id": "6077c4eebc5f4d4df9ef1bd7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df15",
                                                                "_id": "6077c4eebc5f4d4df9ef1bd8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708be6",
                                                        "_id": "6077c4eebc5f4d4df9ef1bd5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df16",
                                                                "_id": "6077c4eebc5f4d4df9ef1bd6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Theories On Light",
                                                        "id": "5f71ce207ac5361290708bed",
                                                        "_id": "6077c4eebc5f4d4df9ef1bd3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df17",
                                                                "_id": "6077c4eebc5f4d4df9ef1bd4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Polarisation",
                                                        "id": "5f71ce207ac5361290708bf1",
                                                        "_id": "6077c4eebc5f4d4df9ef1bd1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df18",
                                                                "_id": "6077c4eebc5f4d4df9ef1bd2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diffraction",
                                                        "id": "5f71ce207ac5361290708bf0",
                                                        "_id": "6077c4eebc5f4d4df9ef1bcf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df19",
                                                                "_id": "6077c4eebc5f4d4df9ef1bd0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Prism",
                                                        "id": "5f71ce207ac5361290708bec",
                                                        "_id": "6077c4eebc5f4d4df9ef1bcd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1a",
                                                                "_id": "6077c4eebc5f4d4df9ef1bce"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Simple Microscope",
                                                        "id": "5f71ce207ac5361290708bf2",
                                                        "_id": "6077c4eebc5f4d4df9ef1bcb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1b",
                                                                "_id": "6077c4eebc5f4d4df9ef1bcc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Speed Of Light",
                                                        "id": "5f71ce207ac5361290708be8",
                                                        "_id": "6077c4eebc5f4d4df9ef1bc9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1c",
                                                                "_id": "6077c4eebc5f4d4df9ef1bca"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Spherical Mirrors",
                                                        "id": "5f71ce207ac5361290708be7",
                                                        "_id": "6077c4eebc5f4d4df9ef1bc7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1d",
                                                                "_id": "6077c4eebc5f4d4df9ef1bc8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Thin Lens",
                                                        "id": "5f71ce207ac5361290708beb",
                                                        "_id": "6077c4eebc5f4d4df9ef1bc5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1e",
                                                                "_id": "6077c4eebc5f4d4df9ef1bc6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Interference",
                                                        "id": "5f71ce207ac5361290708bef",
                                                        "_id": "6077c4eebc5f4d4df9ef1bc3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df1f",
                                                                "_id": "6077c4eebc5f4d4df9ef1bc4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8d",
                                                        "_id": "6077c4eebc5f4d4df9ef1bdd"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Semiconductor Electronics",
                                                "id": "5f71cc80414f235e9782af04",
                                                "_id": "6077c4eebc5f4d4df9ef1bb2",
                                                "concepts": [
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708bff",
                                                        "_id": "6077c4eebc5f4d4df9ef1bbf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df20",
                                                                "_id": "6077c4eebc5f4d4df9ef1bc0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "The Bipolar Junction Transistor [Bjt]",
                                                        "id": "5f71ce207ac5361290708c02",
                                                        "_id": "6077c4eebc5f4d4df9ef1bbd",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df21",
                                                                "_id": "6077c4eebc5f4d4df9ef1bbe"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Digital Electronics",
                                                        "id": "5f71ce207ac5361290708c03",
                                                        "_id": "6077c4eebc5f4d4df9ef1bbb",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df22",
                                                                "_id": "6077c4eebc5f4d4df9ef1bbc"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "De Morgan’S Theorem",
                                                        "id": "5f71ce207ac5361290708c05",
                                                        "_id": "6077c4eebc5f4d4df9ef1bb9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df23",
                                                                "_id": "6077c4eebc5f4d4df9ef1bba"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Diodes",
                                                        "id": "5f71ce207ac5361290708c01",
                                                        "_id": "6077c4eebc5f4d4df9ef1bb7",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df24",
                                                                "_id": "6077c4eebc5f4d4df9ef1bb8"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Types Of Semiconductrors",
                                                        "id": "5f71ce207ac5361290708c00",
                                                        "_id": "6077c4eebc5f4d4df9ef1bb5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df25",
                                                                "_id": "6077c4eebc5f4d4df9ef1bb6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Boolean Algebra",
                                                        "id": "5f71ce207ac5361290708c04",
                                                        "_id": "6077c4eebc5f4d4df9ef1bb3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df26",
                                                                "_id": "6077c4eebc5f4d4df9ef1bb4"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8e",
                                                        "_id": "6077c4eebc5f4d4df9ef1bc1"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Dual Nature Of Radiation And Matter",
                                                "id": "5f71cc80414f235e9782af02",
                                                "_id": "6077c4eebc5f4d4df9ef1ba8",
                                                "concepts": [
                                                    {
                                                        "name": "X – Rays",
                                                        "id": "5f71ce207ac5361290708bf6",
                                                        "_id": "6077c4eebc5f4d4df9ef1baf",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df27",
                                                                "_id": "6077c4eebc5f4d4df9ef1bb0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Photo Electric Effect",
                                                        "id": "5f71ce207ac5361290708bf4",
                                                        "_id": "6077c4eebc5f4d4df9ef1bad",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df28",
                                                                "_id": "6077c4eebc5f4d4df9ef1bae"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708bf3",
                                                        "_id": "6077c4eebc5f4d4df9ef1bab",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df29",
                                                                "_id": "6077c4eebc5f4d4df9ef1bac"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Matter Waves",
                                                        "id": "5f71ce207ac5361290708bf5",
                                                        "_id": "6077c4eebc5f4d4df9ef1ba9",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2a",
                                                                "_id": "6077c4eebc5f4d4df9ef1baa"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd8f",
                                                        "_id": "6077c4eebc5f4d4df9ef1bb1"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Atomic And Nuclear Physics",
                                                "id": "5f71cc80414f235e9782af03",
                                                "_id": "6077c4eebc5f4d4df9ef1b96",
                                                "concepts": [
                                                    {
                                                        "name": "Radioactivity",
                                                        "id": "5f71ce207ac5361290708bfc",
                                                        "_id": "6077c4eebc5f4d4df9ef1ba5",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2b",
                                                                "_id": "6077c4eebc5f4d4df9ef1ba6"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclei",
                                                        "id": "5f71ce207ac5361290708bfa",
                                                        "_id": "6077c4eebc5f4d4df9ef1ba3",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2c",
                                                                "_id": "6077c4eebc5f4d4df9ef1ba4"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Introduction",
                                                        "id": "5f71ce207ac5361290708bf7",
                                                        "_id": "6077c4eebc5f4d4df9ef1ba1",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2d",
                                                                "_id": "6077c4eebc5f4d4df9ef1ba2"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Electric Discharge Through Gases",
                                                        "id": "5f71ce207ac5361290708bf8",
                                                        "_id": "6077c4eebc5f4d4df9ef1b9f",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2e",
                                                                "_id": "6077c4eebc5f4d4df9ef1ba0"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Fusion",
                                                        "id": "5f71ce207ac5361290708bfe",
                                                        "_id": "6077c4eebc5f4d4df9ef1b9d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df2f",
                                                                "_id": "6077c4eebc5f4d4df9ef1b9e"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Atom Models",
                                                        "id": "5f71ce207ac5361290708bf9",
                                                        "_id": "6077c4eebc5f4d4df9ef1b9b",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df30",
                                                                "_id": "6077c4eebc5f4d4df9ef1b9c"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Force",
                                                        "id": "5f71ce207ac5361290708bfb",
                                                        "_id": "6077c4eebc5f4d4df9ef1b99",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df31",
                                                                "_id": "6077c4eebc5f4d4df9ef1b9a"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Nuclear Fission",
                                                        "id": "5f71ce207ac5361290708bfd",
                                                        "_id": "6077c4eebc5f4d4df9ef1b97",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5fdc5707b35a0a066673d910",
                                                                "syllabusId": "5fdc5725b35a0a066673df32",
                                                                "_id": "6077c4eebc5f4d4df9ef1b98"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5fdc5707b35a0a066673d910",
                                                        "syllabusId": "5fdc5724b35a0a066673dd90",
                                                        "_id": "6077c4eebc5f4d4df9ef1ba7"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b5",
                                                "_id": "6077c4eebc5f4d4df9ef1c10"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "MAT",
                                        "id": "5ace202e9fe7b01d5806bb8d",
                                        "chapters": [
                                            {
                                                "name": "Speed,Time & Distance",
                                                "id": "5ace20319fe7b01d5806bc3d",
                                                "_id": "6077c4eebc5f4d4df9ef1b8f",
                                                "concepts": [
                                                    {
                                                        "name": "Train problems, Boats and streams",
                                                        "id": "5ace20399fe7b01d5806bf3a",
                                                        "_id": "6077c4eebc5f4d4df9ef1b92",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8447",
                                                                "_id": "6077c4eebc5f4d4df9ef1b93"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Problems on time and distance",
                                                        "id": "5ace20399fe7b01d5806bf39",
                                                        "_id": "6077c4eebc5f4d4df9ef1b90",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8448",
                                                                "_id": "6077c4eebc5f4d4df9ef1b91"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8260",
                                                        "_id": "6077c4eebc5f4d4df9ef1b94"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Simple Interest & Compound Interest",
                                                "id": "5ace20319fe7b01d5806bc3c",
                                                "_id": "6077c4eebc5f4d4df9ef1b8b",
                                                "concepts": [
                                                    {
                                                        "name": "Simple Interest & Compound Interest",
                                                        "id": "5ace20399fe7b01d5806bf38",
                                                        "_id": "6077c4eebc5f4d4df9ef1b8c",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8449",
                                                                "_id": "6077c4eebc5f4d4df9ef1b8d"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8261",
                                                        "_id": "6077c4eebc5f4d4df9ef1b8e"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Data Interpretation",
                                                "id": "5ace20309fe7b01d5806bc26",
                                                "_id": "6077c4eebc5f4d4df9ef1b85",
                                                "concepts": [
                                                    {
                                                        "name": "Pie Charts Tabulation",
                                                        "id": "5ace20389fe7b01d5806bf16",
                                                        "_id": "6077c4eebc5f4d4df9ef1b88",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844a",
                                                                "_id": "6077c4eebc5f4d4df9ef1b89"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Bar & Line graphs",
                                                        "id": "5ace20389fe7b01d5806bf15",
                                                        "_id": "6077c4eebc5f4d4df9ef1b86",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844b",
                                                                "_id": "6077c4eebc5f4d4df9ef1b87"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8262",
                                                        "_id": "6077c4eebc5f4d4df9ef1b8a"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statement Assumptions",
                                                "id": "5ace20319fe7b01d5806bc3e",
                                                "_id": "6077c4eebc5f4d4df9ef1b81",
                                                "concepts": [
                                                    {
                                                        "name": "Statement Assumptions",
                                                        "id": "5ace20399fe7b01d5806bf3b",
                                                        "_id": "6077c4eebc5f4d4df9ef1b82",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844c",
                                                                "_id": "6077c4eebc5f4d4df9ef1b83"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8263",
                                                        "_id": "6077c4eebc5f4d4df9ef1b84"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Statement Conclusions",
                                                "id": "5ace20319fe7b01d5806bc3f",
                                                "_id": "6077c4eebc5f4d4df9ef1b7d",
                                                "concepts": [
                                                    {
                                                        "name": "Statement Conclusions",
                                                        "id": "5ace20399fe7b01d5806bf3c",
                                                        "_id": "6077c4eebc5f4d4df9ef1b7e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844d",
                                                                "_id": "6077c4eebc5f4d4df9ef1b7f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8264",
                                                        "_id": "6077c4eebc5f4d4df9ef1b80"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Puzzle",
                                                "id": "5ace20319fe7b01d5806bc38",
                                                "_id": "6077c4eebc5f4d4df9ef1b71",
                                                "concepts": [
                                                    {
                                                        "name": "Family Based",
                                                        "id": "5ace20399fe7b01d5806bf2e",
                                                        "_id": "6077c4eebc5f4d4df9ef1b7a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844e",
                                                                "_id": "6077c4eebc5f4d4df9ef1b7b"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Sitting Arrangment",
                                                        "id": "5ace20399fe7b01d5806bf30",
                                                        "_id": "6077c4eebc5f4d4df9ef1b78",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c844f",
                                                                "_id": "6077c4eebc5f4d4df9ef1b79"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Classification Based",
                                                        "id": "5ace20399fe7b01d5806bf2c",
                                                        "_id": "6077c4eebc5f4d4df9ef1b76",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8450",
                                                                "_id": "6077c4eebc5f4d4df9ef1b77"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Comparison Based",
                                                        "id": "5ace20399fe7b01d5806bf2d",
                                                        "_id": "6077c4eebc5f4d4df9ef1b74",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8451",
                                                                "_id": "6077c4eebc5f4d4df9ef1b75"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "name": "Logical Connectives",
                                                        "id": "5ace20399fe7b01d5806bf2f",
                                                        "_id": "6077c4eebc5f4d4df9ef1b72",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8452",
                                                                "_id": "6077c4eebc5f4d4df9ef1b73"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8265",
                                                        "_id": "6077c4eebc5f4d4df9ef1b7c"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Probability",
                                                "id": "5ace20319fe7b01d5806bc36",
                                                "_id": "6077c4eebc5f4d4df9ef1b6d",
                                                "concepts": [
                                                    {
                                                        "name": "Probability",
                                                        "id": "5ace20399fe7b01d5806bf28",
                                                        "_id": "6077c4eebc5f4d4df9ef1b6e",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8453",
                                                                "_id": "6077c4eebc5f4d4df9ef1b6f"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8266",
                                                        "_id": "6077c4eebc5f4d4df9ef1b70"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Inequality",
                                                "id": "5ace20319fe7b01d5806bc2e",
                                                "_id": "6077c4eebc5f4d4df9ef1b69",
                                                "concepts": [
                                                    {
                                                        "name": "Inequality",
                                                        "id": "5ace20389fe7b01d5806bf1e",
                                                        "_id": "6077c4eebc5f4d4df9ef1b6a",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c8454",
                                                                "_id": "6077c4eebc5f4d4df9ef1b6b"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8267",
                                                        "_id": "6077c4eebc5f4d4df9ef1b6c"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b6",
                                                "_id": "6077c4eebc5f4d4df9ef1b95"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "Social Science",
                                        "id": "5ace202e9fe7b01d5806bb90",
                                        "chapters": [
                                            {
                                                "name": "People As Resource",
                                                "id": "5ace20329fe7b01d5806bcc0",
                                                "_id": "6077c4eebc5f4d4df9ef1b64",
                                                "concepts": [
                                                    {
                                                        "name": "Role of education, health\nand training/skill development in \nmaking human capital",
                                                        "id": "5ace20419fe7b01d5806c1ef",
                                                        "_id": "6077c4eebc5f4d4df9ef1b65",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a1",
                                                                "_id": "6077c4eebc5f4d4df9ef1b66"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8294",
                                                        "_id": "6077c4eebc5f4d4df9ef1b67"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Poverty As a Challenge",
                                                "id": "5ace20329fe7b01d5806bcc1",
                                                "_id": "6077c4eebc5f4d4df9ef1b60",
                                                "concepts": [
                                                    {
                                                        "name": "Causes and impacts of poverty\ndifferent poverty elevation programmes",
                                                        "id": "5ace20419fe7b01d5806c1f0",
                                                        "_id": "6077c4eebc5f4d4df9ef1b61",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a2",
                                                                "_id": "6077c4eebc5f4d4df9ef1b62"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8295",
                                                        "_id": "6077c4eebc5f4d4df9ef1b63"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Food Security in India",
                                                "id": "5ace20329fe7b01d5806bcbd",
                                                "_id": "6077c4eebc5f4d4df9ef1b5c",
                                                "concepts": [
                                                    {
                                                        "name": "Dimensions of food security & Govt's role in food security",
                                                        "id": "5ace20419fe7b01d5806c1ec",
                                                        "_id": "6077c4eebc5f4d4df9ef1b5d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a3",
                                                                "_id": "6077c4eebc5f4d4df9ef1b5e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8296",
                                                        "_id": "6077c4eebc5f4d4df9ef1b5f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Development",
                                                "id": "5ace20329fe7b01d5806bcbc",
                                                "_id": "6077c4eebc5f4d4df9ef1b58",
                                                "concepts": [
                                                    {
                                                        "name": "Different approaches of development & estimation of GDP",
                                                        "id": "5ace20419fe7b01d5806c1eb",
                                                        "_id": "6077c4eebc5f4d4df9ef1b59",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a4",
                                                                "_id": "6077c4eebc5f4d4df9ef1b5a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8297",
                                                        "_id": "6077c4eebc5f4d4df9ef1b5b"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Sectors of the Indian Economy",
                                                "id": "5ace20329fe7b01d5806bcc2",
                                                "_id": "6077c4eebc5f4d4df9ef1b54",
                                                "concepts": [
                                                    {
                                                        "name": "Primary, secondary and tertiary sectors of economy & Unemployment in India",
                                                        "id": "5ace20419fe7b01d5806c1f1",
                                                        "_id": "6077c4eebc5f4d4df9ef1b55",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a5",
                                                                "_id": "6077c4eebc5f4d4df9ef1b56"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8298",
                                                        "_id": "6077c4eebc5f4d4df9ef1b57"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Money and Credit",
                                                "id": "5ace20329fe7b01d5806bcbf",
                                                "_id": "6077c4eebc5f4d4df9ef1b50",
                                                "concepts": [
                                                    {
                                                        "name": "Money & Credit",
                                                        "id": "5ace20419fe7b01d5806c1ee",
                                                        "_id": "6077c4eebc5f4d4df9ef1b51",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a6",
                                                                "_id": "6077c4eebc5f4d4df9ef1b52"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c8299",
                                                        "_id": "6077c4eebc5f4d4df9ef1b53"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Globalisation and the Indian Economy",
                                                "id": "5ace20329fe7b01d5806bcbe",
                                                "_id": "6077c4eebc5f4d4df9ef1b4c",
                                                "concepts": [
                                                    {
                                                        "name": "Economic factors, connecting the world",
                                                        "id": "5ace20419fe7b01d5806c1ed",
                                                        "_id": "6077c4eebc5f4d4df9ef1b4d",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a7",
                                                                "_id": "6077c4eebc5f4d4df9ef1b4e"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c829a",
                                                        "_id": "6077c4eebc5f4d4df9ef1b4f"
                                                    }
                                                ]
                                            },
                                            {
                                                "name": "Consumer Rights",
                                                "id": "5ace20329fe7b01d5806bcbb",
                                                "_id": "6077c4eebc5f4d4df9ef1b48",
                                                "concepts": [
                                                    {
                                                        "name": "Consumer court at different levels",
                                                        "id": "5ace20419fe7b01d5806c1ea",
                                                        "_id": "6077c4eebc5f4d4df9ef1b49",
                                                        "content": [],
                                                        "courseSyllabusIds": [
                                                            {
                                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                                "syllabusId": "5f019d79e316d24ffb2c84a8",
                                                                "_id": "6077c4eebc5f4d4df9ef1b4a"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "content": [],
                                                "courseSyllabusIds": [
                                                    {
                                                        "courseId": "5f019d78e316d24ffb2c81fd",
                                                        "syllabusId": "5f019d78e316d24ffb2c829b",
                                                        "_id": "6077c4eebc5f4d4df9ef1b4b"
                                                    }
                                                ]
                                            }
                                        ],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5f019d78e316d24ffb2c81fd",
                                                "syllabusId": "5f019d79e316d24ffb2c84b7",
                                                "_id": "6077c4eebc5f4d4df9ef1b68"
                                            }
                                        ]
                                    },
                                    {
                                        "name": "LOGICAL REASONING",
                                        "id": "5ace202e9fe7b01d5806bb8c",
                                        "chapters": [],
                                        "courseSyllabusIds": [
                                            {
                                                "courseId": "5fdc5707b35a0a066673d910",
                                                "syllabusId": "5fdc5722b35a0a066673d921",
                                                "_id": "6077c4eebc5f4d4df9ef1b47"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "subjects": [
                            {
                                "name": "Biology",
                                "id": "5ace202e9fe7b01d5806bb89",
                                "chapterCount": 6
                            },
                            {
                                "name": "Chemistry",
                                "id": "5ace202e9fe7b01d5806bb8a",
                                "chapterCount": 4
                            },
                            {
                                "name": "Mathematics",
                                "id": "5ace202e9fe7b01d5806bb8e",
                                "chapterCount": 70
                            },
                            {
                                "name": "Physics",
                                "id": "5ace202e9fe7b01d5806bb8f",
                                "chapterCount": 31
                            },
                            {
                                "name": "MAT",
                                "id": "5ace202e9fe7b01d5806bb8d",
                                "chapterCount": 20
                            },
                            {
                                "name": "Social Science",
                                "id": "5ace202e9fe7b01d5806bb90",
                                "chapterCount": 26
                            },
                            {
                                "name": "LOGICAL REASONING",
                                "id": "5ace202e9fe7b01d5806bb8c",
                                "chapterCount": 5
                            }
                        ],
                        "isRevision": false,
                        "description": ""
                    }
                ],
                "subjects": [
                    {
                        "id": "5ace202e9fe7b01d5806bb89",
                        "name": "Biology",
                        "chapterCount": 11
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb8a",
                        "name": "Chemistry",
                        "chapterCount": 9
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb8e",
                        "name": "Mathematics",
                        "chapterCount": 159
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb8f",
                        "name": "Physics",
                        "chapterCount": 62
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb8d",
                        "name": "MAT",
                        "chapterCount": 37
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb90",
                        "name": "Social Science",
                        "chapterCount": 52
                    },
                    {
                        "id": "5ace202e9fe7b01d5806bb8c",
                        "name": "LOGICAL REASONING",
                        "chapterCount": 10
                    }
                ],
                "totalPhases": 2
            }
        }
    },

];